import { create_ssr_component, add_attribute, escape, add_styles, validate_component, each, merge_ssr_styles, subscribe } from "svelte/internal";
import { ah as getDefaultExportFromCjs, au as Plus, O as Eyedropper, av as BrushSize, q as Image$1, aw as Brush, ax as Erase, ay as Crop, az as Resize, a0 as Upload, aA as ImagePaste, a1 as Webcam, aB as ColorPickerSolid, a3 as Circle$1, aC as Layers, h as IconButton$1, aD as VisibilityOff, aE as Visibility, aF as ArrowUp, aG as ArrowDown, A as Clear, I as IconButtonWrapper, D as Download, aH as Pan, aI as ZoomOut, aJ as ZoomIn, _ as Undo, aK as Redo, aj as Check, an as Trash, B as BlockLabel, Y as prepare_files, aL as FileData, n as Block, S as Static } from "./client.js";
import { Webcam as Webcam$1 } from "./Index26.js";
import { onMount, tick, createEventDispatcher } from "svelte";
import { writable, get } from "svelte/store";
import { t as tinycolor } from "./tinycolor.js";
import { spring } from "svelte/motion";
import "./ModifyUpload.js";
import ImagePreview from "./ImagePreview.js";
class CommandNode {
  command;
  next;
  previous;
  constructor(command) {
    this.command = command || null;
    this.next = null;
    this.previous = null;
  }
  push(command) {
    const node = new CommandNode(command);
    node.previous = this;
    this.next = node;
  }
}
class CommandManager {
  history = new CommandNode();
  current_history = writable(this.history);
  undo() {
    if (this.history.previous) {
      this.history.command?.undo();
      this.history = this.history.previous;
      this.current_history.set(this.history);
    }
  }
  redo() {
    if (this.history.next) {
      this.history = this.history.next;
      this.history.command?.execute();
    }
    this.current_history.set(this.history);
  }
  execute(command) {
    command.execute();
    this.history.push(command);
    this.history = this.history.next;
    this.current_history.set(this.history);
  }
  replay(full_history) {
    setTimeout(() => {
      while (full_history.next) {
        this.execute(full_history.next.command);
        full_history = full_history.next;
      }
    }, 1e3);
  }
  contains(command_name) {
    let current = this.history;
    while (current) {
      if (current.command?.name === command_name)
        return true;
      current = current.next;
    }
    return false;
  }
  reset() {
    this.history = new CommandNode();
    this.current_history.set(this.history);
  }
}
const css$b = {
  code: "button.svelte-rrog8b{display:flex;justify-content:center;align-items:center;gap:1px;z-index:var(--layer-2);color:var(--block-label-text-color);border:1px solid transparent}.quite-round.svelte-rrog8b{border-radius:var(--radius-sm)}.very-round.svelte-rrog8b{border-radius:var(--radius-md)}button[disabled].svelte-rrog8b{opacity:0.5;box-shadow:none}button[disabled].svelte-rrog8b:hover{cursor:not-allowed}.padded.svelte-rrog8b{padding:2px;background:var(--bg-color);box-shadow:var(--shadow-drop);border:1px solid var(--button-secondary-border-color)}button.svelte-rrog8b:hover,button.highlight.svelte-rrog8b{cursor:pointer;color:var(--color-accent)}.padded.svelte-rrog8b:hover{border:2px solid var(--button-secondary-border-color-hover);padding:1px;color:var(--block-label-text-color)}span.svelte-rrog8b{padding:0px 1px;font-size:10px}div.svelte-rrog8b{padding:2px;display:flex;align-items:flex-end}.small.svelte-rrog8b{width:14px;height:14px}.medium.svelte-rrog8b{width:20px;height:20px}.large.svelte-rrog8b{width:22px;height:22px}.pending.svelte-rrog8b{animation:svelte-rrog8b-flash 0.5s infinite}@keyframes svelte-rrog8b-flash{0%{opacity:0.5}50%{opacity:1}100%{opacity:0.5}}.transparent.svelte-rrog8b{background:transparent;border:none;box-shadow:none}",
  map: '{"version":3,"file":"IconButton.svelte","sources":["IconButton.svelte"],"sourcesContent":["<script lang=\\"ts\\">import {} from \\"svelte\\";\\nexport let Icon;\\nexport let label = \\"\\";\\nexport let show_label = false;\\nexport let pending = false;\\nexport let size = \\"small\\";\\nexport let padded = true;\\nexport let highlight = false;\\nexport let disabled = false;\\nexport let hasPopup = false;\\nexport let color = \\"var(--block-label-text-color)\\";\\nexport let transparent = false;\\nexport let background = \\"var(--background-fill-primary)\\";\\nexport let offset = 0;\\nexport let label_position = \\"left\\";\\nexport let roundedness = \\"quite\\";\\n$: _color = highlight ? \\"var(--color-accent)\\" : color.toString();\\n<\/script>\\n\\n<button\\n\\t{disabled}\\n\\ton:click\\n\\taria-label={label}\\n\\taria-haspopup={hasPopup}\\n\\ttitle={label}\\n\\tclass:pending\\n\\tclass:padded\\n\\tclass:highlight\\n\\tclass:transparent\\n\\tstyle:color={!disabled && _color ? _color : \\"var(--block-label-text-color)\\"}\\n\\tstyle:--bg-color={!disabled ? background : \\"auto\\"}\\n\\tstyle:margin-left={offset + \\"px\\"}\\n\\tclass=\\"{roundedness}-round\\"\\n>\\n\\t{#if show_label && label_position === \\"left\\"}\\n\\t\\t<span style=\\"margin-left: 4px;\\">{label}</span>\\n\\t{/if}\\n\\t<div\\n\\t\\tclass:small={size === \\"small\\"}\\n\\t\\tclass:large={size === \\"large\\"}\\n\\t\\tclass:medium={size === \\"medium\\"}\\n\\t>\\n\\t\\t<Icon />\\n\\t</div>\\n\\t{#if show_label && label_position === \\"right\\"}\\n\\t\\t<span style=\\"margin-right: 4px;\\">{label}</span>\\n\\t{/if}\\n</button>\\n\\n<style>\\n\\tbutton {\\n\\t\\tdisplay: flex;\\n\\t\\tjustify-content: center;\\n\\t\\talign-items: center;\\n\\t\\tgap: 1px;\\n\\t\\tz-index: var(--layer-2);\\n\\t\\t/* background: var(--background-fill-primary); */\\n\\t\\t/* border-radius: var(--radius-sm); */\\n\\t\\tcolor: var(--block-label-text-color);\\n\\t\\tborder: 1px solid transparent;\\n\\t}\\n\\n\\t.quite-round {\\n\\t\\tborder-radius: var(--radius-sm);\\n\\t}\\n\\n\\t.very-round {\\n\\t\\tborder-radius: var(--radius-md);\\n\\t}\\n\\n\\tbutton[disabled] {\\n\\t\\topacity: 0.5;\\n\\t\\tbox-shadow: none;\\n\\t}\\n\\n\\tbutton[disabled]:hover {\\n\\t\\tcursor: not-allowed;\\n\\t\\t/* border: 1px solid var(--button-secondary-border-color); */\\n\\t\\t/* padding: 2px; */\\n\\t}\\n\\n\\t.padded {\\n\\t\\tpadding: 2px;\\n\\t\\tbackground: var(--bg-color);\\n\\t\\tbox-shadow: var(--shadow-drop);\\n\\t\\tborder: 1px solid var(--button-secondary-border-color);\\n\\t}\\n\\n\\tbutton:hover,\\n\\tbutton.highlight {\\n\\t\\tcursor: pointer;\\n\\t\\tcolor: var(--color-accent);\\n\\t}\\n\\n\\t.padded:hover {\\n\\t\\tborder: 2px solid var(--button-secondary-border-color-hover);\\n\\t\\tpadding: 1px;\\n\\t\\tcolor: var(--block-label-text-color);\\n\\t}\\n\\n\\tspan {\\n\\t\\tpadding: 0px 1px;\\n\\t\\tfont-size: 10px;\\n\\t}\\n\\n\\tdiv {\\n\\t\\tpadding: 2px;\\n\\t\\tdisplay: flex;\\n\\t\\talign-items: flex-end;\\n\\t}\\n\\n\\t.small {\\n\\t\\twidth: 14px;\\n\\t\\theight: 14px;\\n\\t}\\n\\n\\t.medium {\\n\\t\\twidth: 20px;\\n\\t\\theight: 20px;\\n\\t}\\n\\n\\t.large {\\n\\t\\twidth: 22px;\\n\\t\\theight: 22px;\\n\\t}\\n\\n\\t.pending {\\n\\t\\tanimation: flash 0.5s infinite;\\n\\t}\\n\\n\\t@keyframes flash {\\n\\t\\t0% {\\n\\t\\t\\topacity: 0.5;\\n\\t\\t}\\n\\t\\t50% {\\n\\t\\t\\topacity: 1;\\n\\t\\t}\\n\\t\\t100% {\\n\\t\\t\\topacity: 0.5;\\n\\t\\t}\\n\\t}\\n\\n\\t.transparent {\\n\\t\\tbackground: transparent;\\n\\t\\tborder: none;\\n\\t\\tbox-shadow: none;\\n\\t}</style>\\n"],"names":[],"mappings":"AAkDC,oBAAO,CACN,OAAO,CAAE,IAAI,CACb,eAAe,CAAE,MAAM,CACvB,WAAW,CAAE,MAAM,CACnB,GAAG,CAAE,GAAG,CACR,OAAO,CAAE,IAAI,SAAS,CAAC,CAGvB,KAAK,CAAE,IAAI,wBAAwB,CAAC,CACpC,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,WACnB,CAEA,0BAAa,CACZ,aAAa,CAAE,IAAI,WAAW,CAC/B,CAEA,yBAAY,CACX,aAAa,CAAE,IAAI,WAAW,CAC/B,CAEA,MAAM,CAAC,QAAQ,eAAE,CAChB,OAAO,CAAE,GAAG,CACZ,UAAU,CAAE,IACb,CAEA,MAAM,CAAC,QAAQ,eAAC,MAAO,CACtB,MAAM,CAAE,WAGT,CAEA,qBAAQ,CACP,OAAO,CAAE,GAAG,CACZ,UAAU,CAAE,IAAI,UAAU,CAAC,CAC3B,UAAU,CAAE,IAAI,aAAa,CAAC,CAC9B,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,+BAA+B,CACtD,CAEA,oBAAM,MAAM,CACZ,MAAM,wBAAW,CAChB,MAAM,CAAE,OAAO,CACf,KAAK,CAAE,IAAI,cAAc,CAC1B,CAEA,qBAAO,MAAO,CACb,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,qCAAqC,CAAC,CAC5D,OAAO,CAAE,GAAG,CACZ,KAAK,CAAE,IAAI,wBAAwB,CACpC,CAEA,kBAAK,CACJ,OAAO,CAAE,GAAG,CAAC,GAAG,CAChB,SAAS,CAAE,IACZ,CAEA,iBAAI,CACH,OAAO,CAAE,GAAG,CACZ,OAAO,CAAE,IAAI,CACb,WAAW,CAAE,QACd,CAEA,oBAAO,CACN,KAAK,CAAE,IAAI,CACX,MAAM,CAAE,IACT,CAEA,qBAAQ,CACP,KAAK,CAAE,IAAI,CACX,MAAM,CAAE,IACT,CAEA,oBAAO,CACN,KAAK,CAAE,IAAI,CACX,MAAM,CAAE,IACT,CAEA,sBAAS,CACR,SAAS,CAAE,mBAAK,CAAC,IAAI,CAAC,QACvB,CAEA,WAAW,mBAAM,CAChB,EAAG,CACF,OAAO,CAAE,GACV,CACA,GAAI,CACH,OAAO,CAAE,CACV,CACA,IAAK,CACJ,OAAO,CAAE,GACV,CACD,CAEA,0BAAa,CACZ,UAAU,CAAE,WAAW,CACvB,MAAM,CAAE,IAAI,CACZ,UAAU,CAAE,IACb"}'
};
const IconButton = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let _color;
  let { Icon } = $$props;
  let { label = "" } = $$props;
  let { show_label = false } = $$props;
  let { pending = false } = $$props;
  let { size = "small" } = $$props;
  let { padded = true } = $$props;
  let { highlight = false } = $$props;
  let { disabled = false } = $$props;
  let { hasPopup = false } = $$props;
  let { color = "var(--block-label-text-color)" } = $$props;
  let { transparent = false } = $$props;
  let { background = "var(--background-fill-primary)" } = $$props;
  let { offset = 0 } = $$props;
  let { label_position = "left" } = $$props;
  let { roundedness = "quite" } = $$props;
  if ($$props.Icon === void 0 && $$bindings.Icon && Icon !== void 0)
    $$bindings.Icon(Icon);
  if ($$props.label === void 0 && $$bindings.label && label !== void 0)
    $$bindings.label(label);
  if ($$props.show_label === void 0 && $$bindings.show_label && show_label !== void 0)
    $$bindings.show_label(show_label);
  if ($$props.pending === void 0 && $$bindings.pending && pending !== void 0)
    $$bindings.pending(pending);
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.padded === void 0 && $$bindings.padded && padded !== void 0)
    $$bindings.padded(padded);
  if ($$props.highlight === void 0 && $$bindings.highlight && highlight !== void 0)
    $$bindings.highlight(highlight);
  if ($$props.disabled === void 0 && $$bindings.disabled && disabled !== void 0)
    $$bindings.disabled(disabled);
  if ($$props.hasPopup === void 0 && $$bindings.hasPopup && hasPopup !== void 0)
    $$bindings.hasPopup(hasPopup);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.transparent === void 0 && $$bindings.transparent && transparent !== void 0)
    $$bindings.transparent(transparent);
  if ($$props.background === void 0 && $$bindings.background && background !== void 0)
    $$bindings.background(background);
  if ($$props.offset === void 0 && $$bindings.offset && offset !== void 0)
    $$bindings.offset(offset);
  if ($$props.label_position === void 0 && $$bindings.label_position && label_position !== void 0)
    $$bindings.label_position(label_position);
  if ($$props.roundedness === void 0 && $$bindings.roundedness && roundedness !== void 0)
    $$bindings.roundedness(roundedness);
  $$result.css.add(css$b);
  _color = highlight ? "var(--color-accent)" : color.toString();
  return `<button ${disabled ? "disabled" : ""}${add_attribute("aria-label", label, 0)}${add_attribute("aria-haspopup", hasPopup, 0)}${add_attribute("title", label, 0)} class="${[
    escape(roundedness, true) + "-round svelte-rrog8b",
    (pending ? "pending" : "") + " " + (padded ? "padded" : "") + " " + (highlight ? "highlight" : "") + " " + (transparent ? "transparent" : "")
  ].join(" ").trim()}"${add_styles({
    "color": !disabled && _color ? _color : "var(--block-label-text-color)",
    "--bg-color": !disabled ? background : "auto",
    "margin-left": offset + "px"
  })}>${show_label && label_position === "left" ? `<span style="margin-left: 4px;" class="svelte-rrog8b">${escape(label)}</span>` : ``} <div class="${[
    "svelte-rrog8b",
    (size === "small" ? "small" : "") + " " + (size === "large" ? "large" : "") + " " + (size === "medium" ? "medium" : "")
  ].join(" ").trim()}">${validate_component(Icon, "Icon").$$render($$result, {}, {}, {})}</div> ${show_label && label_position === "right" ? `<span style="margin-right: 4px;" class="svelte-rrog8b">${escape(label)}</span>` : ``} </button>`;
});
var ExtensionType = /* @__PURE__ */ ((ExtensionType2) => {
  ExtensionType2["Application"] = "application";
  ExtensionType2["WebGLPipes"] = "webgl-pipes";
  ExtensionType2["WebGLPipesAdaptor"] = "webgl-pipes-adaptor";
  ExtensionType2["WebGLSystem"] = "webgl-system";
  ExtensionType2["WebGPUPipes"] = "webgpu-pipes";
  ExtensionType2["WebGPUPipesAdaptor"] = "webgpu-pipes-adaptor";
  ExtensionType2["WebGPUSystem"] = "webgpu-system";
  ExtensionType2["CanvasSystem"] = "canvas-system";
  ExtensionType2["CanvasPipesAdaptor"] = "canvas-pipes-adaptor";
  ExtensionType2["CanvasPipes"] = "canvas-pipes";
  ExtensionType2["Asset"] = "asset";
  ExtensionType2["LoadParser"] = "load-parser";
  ExtensionType2["ResolveParser"] = "resolve-parser";
  ExtensionType2["CacheParser"] = "cache-parser";
  ExtensionType2["DetectionParser"] = "detection-parser";
  ExtensionType2["MaskEffect"] = "mask-effect";
  ExtensionType2["BlendMode"] = "blend-mode";
  ExtensionType2["TextureSource"] = "texture-source";
  ExtensionType2["Environment"] = "environment";
  ExtensionType2["ShapeBuilder"] = "shape-builder";
  ExtensionType2["Batcher"] = "batcher";
  return ExtensionType2;
})(ExtensionType || {});
const normalizeExtension = (ext) => {
  if (typeof ext === "function" || typeof ext === "object" && ext.extension) {
    if (!ext.extension) {
      throw new Error("Extension class must have an extension object");
    }
    const metadata = typeof ext.extension !== "object" ? { type: ext.extension } : ext.extension;
    ext = { ...metadata, ref: ext };
  }
  if (typeof ext === "object") {
    ext = { ...ext };
  } else {
    throw new Error("Invalid extension type");
  }
  if (typeof ext.type === "string") {
    ext.type = [ext.type];
  }
  return ext;
};
const normalizeExtensionPriority = (ext, defaultPriority) => normalizeExtension(ext).priority ?? defaultPriority;
const extensions = {
  /** @ignore */
  _addHandlers: {},
  /** @ignore */
  _removeHandlers: {},
  /** @ignore */
  _queue: {},
  /**
   * Remove extensions from PixiJS.
   * @param extensions - Extensions to be removed.
   * @returns {extensions} For chaining.
   */
  remove(...extensions2) {
    extensions2.map(normalizeExtension).forEach((ext) => {
      ext.type.forEach((type) => this._removeHandlers[type]?.(ext));
    });
    return this;
  },
  /**
   * Register new extensions with PixiJS.
   * @param extensions - The spread of extensions to add to PixiJS.
   * @returns {extensions} For chaining.
   */
  add(...extensions2) {
    extensions2.map(normalizeExtension).forEach((ext) => {
      ext.type.forEach((type) => {
        const handlers = this._addHandlers;
        const queue = this._queue;
        if (!handlers[type]) {
          queue[type] = queue[type] || [];
          queue[type]?.push(ext);
        } else {
          handlers[type]?.(ext);
        }
      });
    });
    return this;
  },
  /**
   * Internal method to handle extensions by name.
   * @param type - The extension type.
   * @param onAdd  - Function handler when extensions are added/registered {@link StrictExtensionFormat}.
   * @param onRemove  - Function handler when extensions are removed/unregistered {@link StrictExtensionFormat}.
   * @returns {extensions} For chaining.
   */
  handle(type, onAdd, onRemove) {
    const addHandlers = this._addHandlers;
    const removeHandlers = this._removeHandlers;
    if (addHandlers[type] || removeHandlers[type]) {
      throw new Error(`Extension type ${type} already has a handler`);
    }
    addHandlers[type] = onAdd;
    removeHandlers[type] = onRemove;
    const queue = this._queue;
    if (queue[type]) {
      queue[type]?.forEach((ext) => onAdd(ext));
      delete queue[type];
    }
    return this;
  },
  /**
   * Handle a type, but using a map by `name` property.
   * @param type - Type of extension to handle.
   * @param map - The object map of named extensions.
   * @returns {extensions} For chaining.
   */
  handleByMap(type, map) {
    return this.handle(
      type,
      (extension) => {
        if (extension.name) {
          map[extension.name] = extension.ref;
        }
      },
      (extension) => {
        if (extension.name) {
          delete map[extension.name];
        }
      }
    );
  },
  /**
   * Handle a type, but using a list of extensions with a `name` property.
   * @param type - Type of extension to handle.
   * @param map - The array of named extensions.
   * @param defaultPriority - Fallback priority if none is defined.
   * @returns {extensions} For chaining.
   */
  handleByNamedList(type, map, defaultPriority = -1) {
    return this.handle(
      type,
      (extension) => {
        const index = map.findIndex((item) => item.name === extension.name);
        if (index >= 0)
          return;
        map.push({ name: extension.name, value: extension.ref });
        map.sort((a2, b2) => normalizeExtensionPriority(b2.value, defaultPriority) - normalizeExtensionPriority(a2.value, defaultPriority));
      },
      (extension) => {
        const index = map.findIndex((item) => item.name === extension.name);
        if (index !== -1) {
          map.splice(index, 1);
        }
      }
    );
  },
  /**
   * Handle a type, but using a list of extensions.
   * @param type - Type of extension to handle.
   * @param list - The list of extensions.
   * @param defaultPriority - The default priority to use if none is specified.
   * @returns {extensions} For chaining.
   */
  handleByList(type, list, defaultPriority = -1) {
    return this.handle(
      type,
      (extension) => {
        if (list.includes(extension.ref)) {
          return;
        }
        list.push(extension.ref);
        list.sort((a2, b2) => normalizeExtensionPriority(b2, defaultPriority) - normalizeExtensionPriority(a2, defaultPriority));
      },
      (extension) => {
        const index = list.indexOf(extension.ref);
        if (index !== -1) {
          list.splice(index, 1);
        }
      }
    );
  }
};
const browserExt = {
  extension: {
    type: ExtensionType.Environment,
    name: "browser",
    priority: -1
  },
  test: () => true,
  load: async () => {
    await import("./browserAll.js");
  }
};
const webworkerExt = {
  extension: {
    type: ExtensionType.Environment,
    name: "webworker",
    priority: 0
  },
  test: () => typeof self !== "undefined" && self.WorkerGlobalScope !== void 0,
  load: async () => {
    await import("./webworkerAll.js");
  }
};
class ObservablePoint {
  /**
   * Creates a new `ObservablePoint`
   * @param observer - Observer to pass to listen for change events.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */
  constructor(observer, x2, y2) {
    this._x = x2 || 0;
    this._y = y2 || 0;
    this._observer = observer;
  }
  /**
   * Creates a clone of this point.
   * @param observer - Optional observer to pass to the new observable point.
   * @returns a copy of this observable point
   */
  clone(observer) {
    return new ObservablePoint(observer ?? this._observer, this._x, this._y);
  }
  /**
   * Sets the point to a new `x` and `y` position.
   * If `y` is omitted, both `x` and `y` will be set to `x`.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=x] - position of the point on the y axis
   * @returns The observable point instance itself
   */
  set(x2 = 0, y2 = x2) {
    if (this._x !== x2 || this._y !== y2) {
      this._x = x2;
      this._y = y2;
      this._observer._onUpdate(this);
    }
    return this;
  }
  /**
   * Copies x and y from the given point (`p`)
   * @param p - The point to copy from. Can be any of type that is or extends `PointData`
   * @returns The observable point instance itself
   */
  copyFrom(p2) {
    if (this._x !== p2.x || this._y !== p2.y) {
      this._x = p2.x;
      this._y = p2.y;
      this._observer._onUpdate(this);
    }
    return this;
  }
  /**
   * Copies this point's x and y into that of the given point (`p`)
   * @param p - The point to copy to. Can be any of type that is or extends `PointData`
   * @returns The point (`p`) with values updated
   */
  copyTo(p2) {
    p2.set(this._x, this._y);
    return p2;
  }
  /**
   * Accepts another point (`p`) and returns `true` if the given point is equal to this point
   * @param p - The point to check
   * @returns Returns `true` if both `x` and `y` are equal
   */
  equals(p2) {
    return p2.x === this._x && p2.y === this._y;
  }
  toString() {
    return `[pixi.js/math:ObservablePoint x=${0} y=${0} scope=${this._observer}]`;
  }
  /** Position of the observable point on the x axis. */
  get x() {
    return this._x;
  }
  set x(value) {
    if (this._x !== value) {
      this._x = value;
      this._observer._onUpdate(this);
    }
  }
  /** Position of the observable point on the y axis. */
  get y() {
    return this._y;
  }
  set y(value) {
    if (this._y !== value) {
      this._y = value;
      this._observer._onUpdate(this);
    }
  }
}
var eventemitter3 = { exports: {} };
(function(module) {
  var has = Object.prototype.hasOwnProperty, prefix = "~";
  function Events() {
  }
  if (Object.create) {
    Events.prototype = /* @__PURE__ */ Object.create(null);
    if (!new Events().__proto__)
      prefix = false;
  }
  function EE(fn, context2, once) {
    this.fn = fn;
    this.context = context2;
    this.once = once || false;
  }
  function addListener(emitter, event, fn, context2, once) {
    if (typeof fn !== "function") {
      throw new TypeError("The listener must be a function");
    }
    var listener = new EE(fn, context2 || emitter, once), evt = prefix ? prefix + event : event;
    if (!emitter._events[evt])
      emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn)
      emitter._events[evt].push(listener);
    else
      emitter._events[evt] = [emitter._events[evt], listener];
    return emitter;
  }
  function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0)
      emitter._events = new Events();
    else
      delete emitter._events[evt];
  }
  function EventEmitter2() {
    this._events = new Events();
    this._eventsCount = 0;
  }
  EventEmitter2.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0)
      return names;
    for (name in events = this._events) {
      if (has.call(events, name))
        names.push(prefix ? name.slice(1) : name);
    }
    if (Object.getOwnPropertySymbols) {
      return names.concat(Object.getOwnPropertySymbols(events));
    }
    return names;
  };
  EventEmitter2.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event, handlers = this._events[evt];
    if (!handlers)
      return [];
    if (handlers.fn)
      return [handlers.fn];
    for (var i2 = 0, l2 = handlers.length, ee = new Array(l2); i2 < l2; i2++) {
      ee[i2] = handlers[i2].fn;
    }
    return ee;
  };
  EventEmitter2.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event, listeners = this._events[evt];
    if (!listeners)
      return 0;
    if (listeners.fn)
      return 1;
    return listeners.length;
  };
  EventEmitter2.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt])
      return false;
    var listeners = this._events[evt], len = arguments.length, args, i2;
    if (listeners.fn) {
      if (listeners.once)
        this.removeListener(event, listeners.fn, void 0, true);
      switch (len) {
        case 1:
          return listeners.fn.call(listeners.context), true;
        case 2:
          return listeners.fn.call(listeners.context, a1), true;
        case 3:
          return listeners.fn.call(listeners.context, a1, a2), true;
        case 4:
          return listeners.fn.call(listeners.context, a1, a2, a3), true;
        case 5:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
        case 6:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
      }
      for (i2 = 1, args = new Array(len - 1); i2 < len; i2++) {
        args[i2 - 1] = arguments[i2];
      }
      listeners.fn.apply(listeners.context, args);
    } else {
      var length2 = listeners.length, j2;
      for (i2 = 0; i2 < length2; i2++) {
        if (listeners[i2].once)
          this.removeListener(event, listeners[i2].fn, void 0, true);
        switch (len) {
          case 1:
            listeners[i2].fn.call(listeners[i2].context);
            break;
          case 2:
            listeners[i2].fn.call(listeners[i2].context, a1);
            break;
          case 3:
            listeners[i2].fn.call(listeners[i2].context, a1, a2);
            break;
          case 4:
            listeners[i2].fn.call(listeners[i2].context, a1, a2, a3);
            break;
          default:
            if (!args)
              for (j2 = 1, args = new Array(len - 1); j2 < len; j2++) {
                args[j2 - 1] = arguments[j2];
              }
            listeners[i2].fn.apply(listeners[i2].context, args);
        }
      }
    }
    return true;
  };
  EventEmitter2.prototype.on = function on(event, fn, context2) {
    return addListener(this, event, fn, context2, false);
  };
  EventEmitter2.prototype.once = function once(event, fn, context2) {
    return addListener(this, event, fn, context2, true);
  };
  EventEmitter2.prototype.removeListener = function removeListener(event, fn, context2, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt])
      return this;
    if (!fn) {
      clearEvent(this, evt);
      return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
      if (listeners.fn === fn && (!once || listeners.once) && (!context2 || listeners.context === context2)) {
        clearEvent(this, evt);
      }
    } else {
      for (var i2 = 0, events = [], length2 = listeners.length; i2 < length2; i2++) {
        if (listeners[i2].fn !== fn || once && !listeners[i2].once || context2 && listeners[i2].context !== context2) {
          events.push(listeners[i2]);
        }
      }
      if (events.length)
        this._events[evt] = events.length === 1 ? events[0] : events;
      else
        clearEvent(this, evt);
    }
    return this;
  };
  EventEmitter2.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
      evt = prefix ? prefix + event : event;
      if (this._events[evt])
        clearEvent(this, evt);
    } else {
      this._events = new Events();
      this._eventsCount = 0;
    }
    return this;
  };
  EventEmitter2.prototype.off = EventEmitter2.prototype.removeListener;
  EventEmitter2.prototype.addListener = EventEmitter2.prototype.on;
  EventEmitter2.prefixed = prefix;
  EventEmitter2.EventEmitter = EventEmitter2;
  {
    module.exports = EventEmitter2;
  }
})(eventemitter3);
var eventemitter3Exports = eventemitter3.exports;
const EventEmitter = /* @__PURE__ */ getDefaultExportFromCjs(eventemitter3Exports);
const PI_2 = Math.PI * 2;
const RAD_TO_DEG = 180 / Math.PI;
const DEG_TO_RAD = Math.PI / 180;
class Point {
  /**
   * Creates a new `Point`
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */
  constructor(x2 = 0, y2 = 0) {
    this.x = 0;
    this.y = 0;
    this.x = x2;
    this.y = y2;
  }
  /**
   * Creates a clone of this point
   * @returns A clone of this point
   */
  clone() {
    return new Point(this.x, this.y);
  }
  /**
   * Copies `x` and `y` from the given point into this point
   * @param p - The point to copy from
   * @returns The point instance itself
   */
  copyFrom(p2) {
    this.set(p2.x, p2.y);
    return this;
  }
  /**
   * Copies this point's x and y into the given point (`p`).
   * @param p - The point to copy to. Can be any of type that is or extends `PointData`
   * @returns The point (`p`) with values updated
   */
  copyTo(p2) {
    p2.set(this.x, this.y);
    return p2;
  }
  /**
   * Accepts another point (`p`) and returns `true` if the given point is equal to this point
   * @param p - The point to check
   * @returns Returns `true` if both `x` and `y` are equal
   */
  equals(p2) {
    return p2.x === this.x && p2.y === this.y;
  }
  /**
   * Sets the point to a new `x` and `y` position.
   * If `y` is omitted, both `x` and `y` will be set to `x`.
   * @param {number} [x=0] - position of the point on the `x` axis
   * @param {number} [y=x] - position of the point on the `y` axis
   * @returns The point instance itself
   */
  set(x2 = 0, y2 = x2) {
    this.x = x2;
    this.y = y2;
    return this;
  }
  toString() {
    return `[pixi.js/math:Point x=${this.x} y=${this.y}]`;
  }
  /**
   * A static Point object with `x` and `y` values of `0`. Can be used to avoid creating new objects multiple times.
   * @readonly
   */
  static get shared() {
    tempPoint.x = 0;
    tempPoint.y = 0;
    return tempPoint;
  }
}
const tempPoint = new Point();
class Matrix {
  /**
   * @param a - x scale
   * @param b - y skew
   * @param c - x skew
   * @param d - y scale
   * @param tx - x translation
   * @param ty - y translation
   */
  constructor(a2 = 1, b2 = 0, c2 = 0, d2 = 1, tx = 0, ty = 0) {
    this.array = null;
    this.a = a2;
    this.b = b2;
    this.c = c2;
    this.d = d2;
    this.tx = tx;
    this.ty = ty;
  }
  /**
   * Creates a Matrix object based on the given array. The Element to Matrix mapping order is as follows:
   *
   * a = array[0]
   * b = array[1]
   * c = array[3]
   * d = array[4]
   * tx = array[2]
   * ty = array[5]
   * @param array - The array that the matrix will be populated from.
   */
  fromArray(array) {
    this.a = array[0];
    this.b = array[1];
    this.c = array[3];
    this.d = array[4];
    this.tx = array[2];
    this.ty = array[5];
  }
  /**
   * Sets the matrix properties.
   * @param a - Matrix component
   * @param b - Matrix component
   * @param c - Matrix component
   * @param d - Matrix component
   * @param tx - Matrix component
   * @param ty - Matrix component
   * @returns This matrix. Good for chaining method calls.
   */
  set(a2, b2, c2, d2, tx, ty) {
    this.a = a2;
    this.b = b2;
    this.c = c2;
    this.d = d2;
    this.tx = tx;
    this.ty = ty;
    return this;
  }
  /**
   * Creates an array from the current Matrix object.
   * @param transpose - Whether we need to transpose the matrix or not
   * @param [out=new Float32Array(9)] - If provided the array will be assigned to out
   * @returns The newly created array which contains the matrix
   */
  toArray(transpose, out2) {
    if (!this.array) {
      this.array = new Float32Array(9);
    }
    const array = out2 || this.array;
    if (transpose) {
      array[0] = this.a;
      array[1] = this.b;
      array[2] = 0;
      array[3] = this.c;
      array[4] = this.d;
      array[5] = 0;
      array[6] = this.tx;
      array[7] = this.ty;
      array[8] = 1;
    } else {
      array[0] = this.a;
      array[1] = this.c;
      array[2] = this.tx;
      array[3] = this.b;
      array[4] = this.d;
      array[5] = this.ty;
      array[6] = 0;
      array[7] = 0;
      array[8] = 1;
    }
    return array;
  }
  /**
   * Get a new position with the current transformation applied.
   * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
   * @param pos - The origin
   * @param {Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
   * @returns {Point} The new point, transformed through this matrix
   */
  apply(pos, newPos) {
    newPos = newPos || new Point();
    const x2 = pos.x;
    const y2 = pos.y;
    newPos.x = this.a * x2 + this.c * y2 + this.tx;
    newPos.y = this.b * x2 + this.d * y2 + this.ty;
    return newPos;
  }
  /**
   * Get a new position with the inverse of the current transformation applied.
   * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
   * @param pos - The origin
   * @param {Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
   * @returns {Point} The new point, inverse-transformed through this matrix
   */
  applyInverse(pos, newPos) {
    newPos = newPos || new Point();
    const a2 = this.a;
    const b2 = this.b;
    const c2 = this.c;
    const d2 = this.d;
    const tx = this.tx;
    const ty = this.ty;
    const id = 1 / (a2 * d2 + c2 * -b2);
    const x2 = pos.x;
    const y2 = pos.y;
    newPos.x = d2 * id * x2 + -c2 * id * y2 + (ty * c2 - tx * d2) * id;
    newPos.y = a2 * id * y2 + -b2 * id * x2 + (-ty * a2 + tx * b2) * id;
    return newPos;
  }
  /**
   * Translates the matrix on the x and y.
   * @param x - How much to translate x by
   * @param y - How much to translate y by
   * @returns This matrix. Good for chaining method calls.
   */
  translate(x2, y2) {
    this.tx += x2;
    this.ty += y2;
    return this;
  }
  /**
   * Applies a scale transformation to the matrix.
   * @param x - The amount to scale horizontally
   * @param y - The amount to scale vertically
   * @returns This matrix. Good for chaining method calls.
   */
  scale(x2, y2) {
    this.a *= x2;
    this.d *= y2;
    this.c *= x2;
    this.b *= y2;
    this.tx *= x2;
    this.ty *= y2;
    return this;
  }
  /**
   * Applies a rotation transformation to the matrix.
   * @param angle - The angle in radians.
   * @returns This matrix. Good for chaining method calls.
   */
  rotate(angle) {
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    const a1 = this.a;
    const c1 = this.c;
    const tx1 = this.tx;
    this.a = a1 * cos - this.b * sin;
    this.b = a1 * sin + this.b * cos;
    this.c = c1 * cos - this.d * sin;
    this.d = c1 * sin + this.d * cos;
    this.tx = tx1 * cos - this.ty * sin;
    this.ty = tx1 * sin + this.ty * cos;
    return this;
  }
  /**
   * Appends the given Matrix to this Matrix.
   * @param matrix - The matrix to append.
   * @returns This matrix. Good for chaining method calls.
   */
  append(matrix) {
    const a1 = this.a;
    const b1 = this.b;
    const c1 = this.c;
    const d1 = this.d;
    this.a = matrix.a * a1 + matrix.b * c1;
    this.b = matrix.a * b1 + matrix.b * d1;
    this.c = matrix.c * a1 + matrix.d * c1;
    this.d = matrix.c * b1 + matrix.d * d1;
    this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
    this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;
    return this;
  }
  /**
   * Appends two matrix's and sets the result to this matrix. AB = A * B
   * @param a - The matrix to append.
   * @param b - The matrix to append.
   * @returns This matrix. Good for chaining method calls.
   */
  appendFrom(a2, b2) {
    const a1 = a2.a;
    const b1 = a2.b;
    const c1 = a2.c;
    const d1 = a2.d;
    const tx = a2.tx;
    const ty = a2.ty;
    const a22 = b2.a;
    const b22 = b2.b;
    const c2 = b2.c;
    const d2 = b2.d;
    this.a = a1 * a22 + b1 * c2;
    this.b = a1 * b22 + b1 * d2;
    this.c = c1 * a22 + d1 * c2;
    this.d = c1 * b22 + d1 * d2;
    this.tx = tx * a22 + ty * c2 + b2.tx;
    this.ty = tx * b22 + ty * d2 + b2.ty;
    return this;
  }
  /**
   * Sets the matrix based on all the available properties
   * @param x - Position on the x axis
   * @param y - Position on the y axis
   * @param pivotX - Pivot on the x axis
   * @param pivotY - Pivot on the y axis
   * @param scaleX - Scale on the x axis
   * @param scaleY - Scale on the y axis
   * @param rotation - Rotation in radians
   * @param skewX - Skew on the x axis
   * @param skewY - Skew on the y axis
   * @returns This matrix. Good for chaining method calls.
   */
  setTransform(x2, y2, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
    this.a = Math.cos(rotation + skewY) * scaleX;
    this.b = Math.sin(rotation + skewY) * scaleX;
    this.c = -Math.sin(rotation - skewX) * scaleY;
    this.d = Math.cos(rotation - skewX) * scaleY;
    this.tx = x2 - (pivotX * this.a + pivotY * this.c);
    this.ty = y2 - (pivotX * this.b + pivotY * this.d);
    return this;
  }
  /**
   * Prepends the given Matrix to this Matrix.
   * @param matrix - The matrix to prepend
   * @returns This matrix. Good for chaining method calls.
   */
  prepend(matrix) {
    const tx1 = this.tx;
    if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
      const a1 = this.a;
      const c1 = this.c;
      this.a = a1 * matrix.a + this.b * matrix.c;
      this.b = a1 * matrix.b + this.b * matrix.d;
      this.c = c1 * matrix.a + this.d * matrix.c;
      this.d = c1 * matrix.b + this.d * matrix.d;
    }
    this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx;
    this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty;
    return this;
  }
  /**
   * Decomposes the matrix (x, y, scaleX, scaleY, and rotation) and sets the properties on to a transform.
   * @param transform - The transform to apply the properties to.
   * @returns The transform with the newly applied properties
   */
  decompose(transform) {
    const a2 = this.a;
    const b2 = this.b;
    const c2 = this.c;
    const d2 = this.d;
    const pivot = transform.pivot;
    const skewX = -Math.atan2(-c2, d2);
    const skewY = Math.atan2(b2, a2);
    const delta = Math.abs(skewX + skewY);
    if (delta < 1e-5 || Math.abs(PI_2 - delta) < 1e-5) {
      transform.rotation = skewY;
      transform.skew.x = transform.skew.y = 0;
    } else {
      transform.rotation = 0;
      transform.skew.x = skewX;
      transform.skew.y = skewY;
    }
    transform.scale.x = Math.sqrt(a2 * a2 + b2 * b2);
    transform.scale.y = Math.sqrt(c2 * c2 + d2 * d2);
    transform.position.x = this.tx + (pivot.x * a2 + pivot.y * c2);
    transform.position.y = this.ty + (pivot.x * b2 + pivot.y * d2);
    return transform;
  }
  /**
   * Inverts this matrix
   * @returns This matrix. Good for chaining method calls.
   */
  invert() {
    const a1 = this.a;
    const b1 = this.b;
    const c1 = this.c;
    const d1 = this.d;
    const tx1 = this.tx;
    const n2 = a1 * d1 - b1 * c1;
    this.a = d1 / n2;
    this.b = -b1 / n2;
    this.c = -c1 / n2;
    this.d = a1 / n2;
    this.tx = (c1 * this.ty - d1 * tx1) / n2;
    this.ty = -(a1 * this.ty - b1 * tx1) / n2;
    return this;
  }
  /** Checks if this matrix is an identity matrix */
  isIdentity() {
    return this.a === 1 && this.b === 0 && this.c === 0 && this.d === 1 && this.tx === 0 && this.ty === 0;
  }
  /**
   * Resets this Matrix to an identity (default) matrix.
   * @returns This matrix. Good for chaining method calls.
   */
  identity() {
    this.a = 1;
    this.b = 0;
    this.c = 0;
    this.d = 1;
    this.tx = 0;
    this.ty = 0;
    return this;
  }
  /**
   * Creates a new Matrix object with the same values as this one.
   * @returns A copy of this matrix. Good for chaining method calls.
   */
  clone() {
    const matrix = new Matrix();
    matrix.a = this.a;
    matrix.b = this.b;
    matrix.c = this.c;
    matrix.d = this.d;
    matrix.tx = this.tx;
    matrix.ty = this.ty;
    return matrix;
  }
  /**
   * Changes the values of the given matrix to be the same as the ones in this matrix
   * @param matrix - The matrix to copy to.
   * @returns The matrix given in parameter with its values updated.
   */
  copyTo(matrix) {
    matrix.a = this.a;
    matrix.b = this.b;
    matrix.c = this.c;
    matrix.d = this.d;
    matrix.tx = this.tx;
    matrix.ty = this.ty;
    return matrix;
  }
  /**
   * Changes the values of the matrix to be the same as the ones in given matrix
   * @param matrix - The matrix to copy from.
   * @returns this
   */
  copyFrom(matrix) {
    this.a = matrix.a;
    this.b = matrix.b;
    this.c = matrix.c;
    this.d = matrix.d;
    this.tx = matrix.tx;
    this.ty = matrix.ty;
    return this;
  }
  /**
   * check to see if two matrices are the same
   * @param matrix - The matrix to compare to.
   */
  equals(matrix) {
    return matrix.a === this.a && matrix.b === this.b && matrix.c === this.c && matrix.d === this.d && matrix.tx === this.tx && matrix.ty === this.ty;
  }
  toString() {
    return `[pixi.js:Matrix a=${this.a} b=${this.b} c=${this.c} d=${this.d} tx=${this.tx} ty=${this.ty}]`;
  }
  /**
   * A default (identity) matrix.
   *
   * This is a shared object, if you want to modify it consider creating a new `Matrix`
   * @readonly
   */
  static get IDENTITY() {
    return identityMatrix$1.identity();
  }
  /**
   * A static Matrix that can be used to avoid creating new objects.
   * Will always ensure the matrix is reset to identity when requested.
   * Use this object for fast but temporary calculations, as it may be mutated later on.
   * This is a different object to the `IDENTITY` object and so can be modified without changing `IDENTITY`.
   * @readonly
   */
  static get shared() {
    return tempMatrix$3.identity();
  }
}
const tempMatrix$3 = new Matrix();
const identityMatrix$1 = new Matrix();
const ux = [1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1, 0, 1];
const uy = [0, 1, 1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1];
const vx = [0, -1, -1, -1, 0, 1, 1, 1, 0, 1, 1, 1, 0, -1, -1, -1];
const vy = [1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, 1, 1, 1, 0, -1];
const rotationCayley = [];
const rotationMatrices = [];
const signum = Math.sign;
function init() {
  for (let i2 = 0; i2 < 16; i2++) {
    const row = [];
    rotationCayley.push(row);
    for (let j2 = 0; j2 < 16; j2++) {
      const _ux = signum(ux[i2] * ux[j2] + vx[i2] * uy[j2]);
      const _uy = signum(uy[i2] * ux[j2] + vy[i2] * uy[j2]);
      const _vx = signum(ux[i2] * vx[j2] + vx[i2] * vy[j2]);
      const _vy = signum(uy[i2] * vx[j2] + vy[i2] * vy[j2]);
      for (let k2 = 0; k2 < 16; k2++) {
        if (ux[k2] === _ux && uy[k2] === _uy && vx[k2] === _vx && vy[k2] === _vy) {
          row.push(k2);
          break;
        }
      }
    }
  }
  for (let i2 = 0; i2 < 16; i2++) {
    const mat = new Matrix();
    mat.set(ux[i2], uy[i2], vx[i2], vy[i2], 0, 0);
    rotationMatrices.push(mat);
  }
}
init();
const groupD8 = {
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 0°       | East      |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  E: 0,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 45°↻     | Southeast |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  SE: 1,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 90°↻     | South     |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  S: 2,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 135°↻    | Southwest |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  SW: 3,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 180°     | West      |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  W: 4,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -135°/225°↻ | Northwest    |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  NW: 5,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -90°/270°↻  | North        |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  N: 6,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -45°/315°↻  | Northeast    |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  NE: 7,
  /**
   * Reflection about Y-axis.
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  MIRROR_VERTICAL: 8,
  /**
   * Reflection about the main diagonal.
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  MAIN_DIAGONAL: 10,
  /**
   * Reflection about X-axis.
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  MIRROR_HORIZONTAL: 12,
  /**
   * Reflection about reverse diagonal.
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  REVERSE_DIAGONAL: 14,
  /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the U-axis
   *    after rotating the axes.
   */
  uX: (ind) => ux[ind],
  /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the U-axis
   *    after rotating the axes.
   */
  uY: (ind) => uy[ind],
  /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the V-axis
   *    after rotating the axes.
   */
  vX: (ind) => vx[ind],
  /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the V-axis
   *    after rotating the axes.
   */
  vY: (ind) => vy[ind],
  /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} rotation - symmetry whose opposite
   *   is needed. Only rotations have opposite symmetries while
   *   reflections don't.
   * @returns {GD8Symmetry} The opposite symmetry of `rotation`
   */
  inv: (rotation) => {
    if (rotation & 8) {
      return rotation & 15;
    }
    return -rotation & 7;
  },
  /**
   * Composes the two D8 operations.
   *
   * Taking `^` as reflection:
   *
   * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
   * |-------|-----|-----|-----|-----|------|-------|-------|-------|
   * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
   * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
   * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
   * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
   * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
   * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
   * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
   * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
   *
   * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
   * @memberof maths.groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation, which
   *   is the row in the above cayley table.
   * @param {GD8Symmetry} rotationFirst - First operation, which
   *   is the column in the above cayley table.
   * @returns {GD8Symmetry} Composed operation
   */
  add: (rotationSecond, rotationFirst) => rotationCayley[rotationSecond][rotationFirst],
  /**
   * Reverse of `add`.
   * @memberof maths.groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation
   * @param {GD8Symmetry} rotationFirst - First operation
   * @returns {GD8Symmetry} Result
   */
  sub: (rotationSecond, rotationFirst) => rotationCayley[rotationSecond][groupD8.inv(rotationFirst)],
  /**
   * Adds 180 degrees to rotation, which is a commutative
   * operation.
   * @memberof maths.groupD8
   * @param {number} rotation - The number to rotate.
   * @returns {number} Rotated number
   */
  rotate180: (rotation) => rotation ^ 4,
  /**
   * Checks if the rotation angle is vertical, i.e. south
   * or north. It doesn't work for reflections.
   * @memberof maths.groupD8
   * @param {GD8Symmetry} rotation - The number to check.
   * @returns {boolean} Whether or not the direction is vertical
   */
  isVertical: (rotation) => (rotation & 3) === 2,
  // rotation % 4 === 2
  /**
   * Approximates the vector `V(dx,dy)` into one of the
   * eight directions provided by `groupD8`.
   * @memberof maths.groupD8
   * @param {number} dx - X-component of the vector
   * @param {number} dy - Y-component of the vector
   * @returns {GD8Symmetry} Approximation of the vector into
   *  one of the eight symmetries.
   */
  byDirection: (dx, dy) => {
    if (Math.abs(dx) * 2 <= Math.abs(dy)) {
      if (dy >= 0) {
        return groupD8.S;
      }
      return groupD8.N;
    } else if (Math.abs(dy) * 2 <= Math.abs(dx)) {
      if (dx > 0) {
        return groupD8.E;
      }
      return groupD8.W;
    } else if (dy > 0) {
      if (dx > 0) {
        return groupD8.SE;
      }
      return groupD8.SW;
    } else if (dx > 0) {
      return groupD8.NE;
    }
    return groupD8.NW;
  },
  /**
   * Helps sprite to compensate texture packer rotation.
   * @memberof maths.groupD8
   * @param {Matrix} matrix - sprite world matrix
   * @param {GD8Symmetry} rotation - The rotation factor to use.
   * @param {number} tx - sprite anchoring
   * @param {number} ty - sprite anchoring
   */
  matrixAppendRotationInv: (matrix, rotation, tx = 0, ty = 0) => {
    const mat = rotationMatrices[groupD8.inv(rotation)];
    mat.tx = tx;
    mat.ty = ty;
    matrix.append(mat);
  }
};
const tempPoints = [new Point(), new Point(), new Point(), new Point()];
class Rectangle {
  /**
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   */
  constructor(x2 = 0, y2 = 0, width = 0, height = 0) {
    this.type = "rectangle";
    this.x = Number(x2);
    this.y = Number(y2);
    this.width = Number(width);
    this.height = Number(height);
  }
  /** Returns the left edge of the rectangle. */
  get left() {
    return this.x;
  }
  /** Returns the right edge of the rectangle. */
  get right() {
    return this.x + this.width;
  }
  /** Returns the top edge of the rectangle. */
  get top() {
    return this.y;
  }
  /** Returns the bottom edge of the rectangle. */
  get bottom() {
    return this.y + this.height;
  }
  /** Determines whether the Rectangle is empty. */
  isEmpty() {
    return this.left === this.right || this.top === this.bottom;
  }
  /** A constant empty rectangle. This is a new object every time the property is accessed */
  static get EMPTY() {
    return new Rectangle(0, 0, 0, 0);
  }
  /**
   * Creates a clone of this Rectangle
   * @returns a copy of the rectangle
   */
  clone() {
    return new Rectangle(this.x, this.y, this.width, this.height);
  }
  /**
   * Converts a Bounds object to a Rectangle object.
   * @param bounds - The bounds to copy and convert to a rectangle.
   * @returns Returns itself.
   */
  copyFromBounds(bounds) {
    this.x = bounds.minX;
    this.y = bounds.minY;
    this.width = bounds.maxX - bounds.minX;
    this.height = bounds.maxY - bounds.minY;
    return this;
  }
  /**
   * Copies another rectangle to this one.
   * @param rectangle - The rectangle to copy from.
   * @returns Returns itself.
   */
  copyFrom(rectangle) {
    this.x = rectangle.x;
    this.y = rectangle.y;
    this.width = rectangle.width;
    this.height = rectangle.height;
    return this;
  }
  /**
   * Copies this rectangle to another one.
   * @param rectangle - The rectangle to copy to.
   * @returns Returns given parameter.
   */
  copyTo(rectangle) {
    rectangle.copyFrom(this);
    return rectangle;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rectangle
   */
  contains(x2, y2) {
    if (this.width <= 0 || this.height <= 0) {
      return false;
    }
    if (x2 >= this.x && x2 < this.x + this.width) {
      if (y2 >= this.y && y2 < this.y + this.height) {
        return true;
      }
    }
    return false;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke, 0.5 by default
   * @returns Whether the x/y coordinates are within this rectangle
   */
  strokeContains(x2, y2, strokeWidth, alignment = 0.5) {
    const { width, height } = this;
    if (width <= 0 || height <= 0)
      return false;
    const _x = this.x;
    const _y = this.y;
    const strokeWidthOuter = strokeWidth * (1 - alignment);
    const strokeWidthInner = strokeWidth - strokeWidthOuter;
    const outerLeft = _x - strokeWidthOuter;
    const outerRight = _x + width + strokeWidthOuter;
    const outerTop = _y - strokeWidthOuter;
    const outerBottom = _y + height + strokeWidthOuter;
    const innerLeft = _x + strokeWidthInner;
    const innerRight = _x + width - strokeWidthInner;
    const innerTop = _y + strokeWidthInner;
    const innerBottom = _y + height - strokeWidthInner;
    return x2 >= outerLeft && x2 <= outerRight && y2 >= outerTop && y2 <= outerBottom && !(x2 > innerLeft && x2 < innerRight && y2 > innerTop && y2 < innerBottom);
  }
  /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   * Returns true only if the area of the intersection is >0, this means that Rectangles
   * sharing a side are not overlapping. Another side effect is that an arealess rectangle
   * (width or height equal to zero) can't intersect any other rectangle.
   * @param {Rectangle} other - The Rectangle to intersect with `this`.
   * @param {Matrix} transform - The transformation matrix of `other`.
   * @returns {boolean} A value of `true` if the transformed `other` Rectangle intersects with `this`; otherwise `false`.
   */
  intersects(other, transform) {
    if (!transform) {
      const x02 = this.x < other.x ? other.x : this.x;
      const x12 = this.right > other.right ? other.right : this.right;
      if (x12 <= x02) {
        return false;
      }
      const y02 = this.y < other.y ? other.y : this.y;
      const y12 = this.bottom > other.bottom ? other.bottom : this.bottom;
      return y12 > y02;
    }
    const x0 = this.left;
    const x1 = this.right;
    const y0 = this.top;
    const y1 = this.bottom;
    if (x1 <= x0 || y1 <= y0) {
      return false;
    }
    const lt = tempPoints[0].set(other.left, other.top);
    const lb = tempPoints[1].set(other.left, other.bottom);
    const rt = tempPoints[2].set(other.right, other.top);
    const rb = tempPoints[3].set(other.right, other.bottom);
    if (rt.x <= lt.x || lb.y <= lt.y) {
      return false;
    }
    const s2 = Math.sign(transform.a * transform.d - transform.b * transform.c);
    if (s2 === 0) {
      return false;
    }
    transform.apply(lt, lt);
    transform.apply(lb, lb);
    transform.apply(rt, rt);
    transform.apply(rb, rb);
    if (Math.max(lt.x, lb.x, rt.x, rb.x) <= x0 || Math.min(lt.x, lb.x, rt.x, rb.x) >= x1 || Math.max(lt.y, lb.y, rt.y, rb.y) <= y0 || Math.min(lt.y, lb.y, rt.y, rb.y) >= y1) {
      return false;
    }
    const nx = s2 * (lb.y - lt.y);
    const ny = s2 * (lt.x - lb.x);
    const n00 = nx * x0 + ny * y0;
    const n10 = nx * x1 + ny * y0;
    const n01 = nx * x0 + ny * y1;
    const n11 = nx * x1 + ny * y1;
    if (Math.max(n00, n10, n01, n11) <= nx * lt.x + ny * lt.y || Math.min(n00, n10, n01, n11) >= nx * rb.x + ny * rb.y) {
      return false;
    }
    const mx = s2 * (lt.y - rt.y);
    const my = s2 * (rt.x - lt.x);
    const m00 = mx * x0 + my * y0;
    const m10 = mx * x1 + my * y0;
    const m01 = mx * x0 + my * y1;
    const m11 = mx * x1 + my * y1;
    if (Math.max(m00, m10, m01, m11) <= mx * lt.x + my * lt.y || Math.min(m00, m10, m01, m11) >= mx * rb.x + my * rb.y) {
      return false;
    }
    return true;
  }
  /**
   * Pads the rectangle making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @param paddingX - The horizontal padding amount.
   * @param paddingY - The vertical padding amount.
   * @returns Returns itself.
   */
  pad(paddingX = 0, paddingY = paddingX) {
    this.x -= paddingX;
    this.y -= paddingY;
    this.width += paddingX * 2;
    this.height += paddingY * 2;
    return this;
  }
  /**
   * Fits this rectangle around the passed one.
   * @param rectangle - The rectangle to fit.
   * @returns Returns itself.
   */
  fit(rectangle) {
    const x1 = Math.max(this.x, rectangle.x);
    const x2 = Math.min(this.x + this.width, rectangle.x + rectangle.width);
    const y1 = Math.max(this.y, rectangle.y);
    const y2 = Math.min(this.y + this.height, rectangle.y + rectangle.height);
    this.x = x1;
    this.width = Math.max(x2 - x1, 0);
    this.y = y1;
    this.height = Math.max(y2 - y1, 0);
    return this;
  }
  /**
   * Enlarges rectangle that way its corners lie on grid
   * @param resolution - resolution
   * @param eps - precision
   * @returns Returns itself.
   */
  ceil(resolution = 1, eps = 1e-3) {
    const x2 = Math.ceil((this.x + this.width - eps) * resolution) / resolution;
    const y2 = Math.ceil((this.y + this.height - eps) * resolution) / resolution;
    this.x = Math.floor((this.x + eps) * resolution) / resolution;
    this.y = Math.floor((this.y + eps) * resolution) / resolution;
    this.width = x2 - this.x;
    this.height = y2 - this.y;
    return this;
  }
  /**
   * Enlarges this rectangle to include the passed rectangle.
   * @param rectangle - The rectangle to include.
   * @returns Returns itself.
   */
  enlarge(rectangle) {
    const x1 = Math.min(this.x, rectangle.x);
    const x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width);
    const y1 = Math.min(this.y, rectangle.y);
    const y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);
    this.x = x1;
    this.width = x2 - x1;
    this.y = y1;
    this.height = y2 - y1;
    return this;
  }
  /**
   * Returns the framing rectangle of the rectangle as a Rectangle object
   * @param out - optional rectangle to store the result
   * @returns The framing rectangle
   */
  getBounds(out2) {
    out2 || (out2 = new Rectangle());
    out2.copyFrom(this);
    return out2;
  }
  toString() {
    return `[pixi.js/math:Rectangle x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
  }
}
const uidCache = {
  default: -1
};
function uid(name = "default") {
  if (uidCache[name] === void 0) {
    uidCache[name] = -1;
  }
  return ++uidCache[name];
}
const warnings = {};
const v8_0_0 = "8.0.0";
const v8_3_4 = "8.3.4";
function deprecation(version, message, ignoreDepth = 3) {
  if (warnings[message]) {
    return;
  }
  let stack = new Error().stack;
  if (typeof stack === "undefined") {
    console.warn("PixiJS Deprecation Warning: ", `${message}
Deprecated since v${version}`);
  } else {
    stack = stack.split("\n").splice(ignoreDepth).join("\n");
    if (console.groupCollapsed) {
      console.groupCollapsed(
        "%cPixiJS Deprecation Warning: %c%s",
        "color:#614108;background:#fffbe6",
        "font-weight:normal;color:#614108;background:#fffbe6",
        `${message}
Deprecated since v${version}`
      );
      console.warn(stack);
      console.groupEnd();
    } else {
      console.warn("PixiJS Deprecation Warning: ", `${message}
Deprecated since v${version}`);
      console.warn(stack);
    }
  }
  warnings[message] = true;
}
const NOOP = () => {
};
function nextPow2(v2) {
  v2 += v2 === 0 ? 1 : 0;
  --v2;
  v2 |= v2 >>> 1;
  v2 |= v2 >>> 2;
  v2 |= v2 >>> 4;
  v2 |= v2 >>> 8;
  v2 |= v2 >>> 16;
  return v2 + 1;
}
function isPow2(v2) {
  return !(v2 & v2 - 1) && !!v2;
}
function definedProps(obj) {
  const result = {};
  for (const key in obj) {
    if (obj[key] !== void 0) {
      result[key] = obj[key];
    }
  }
  return result;
}
const idHash$1 = /* @__PURE__ */ Object.create(null);
function createResourceIdFromString(value) {
  const id = idHash$1[value];
  if (id === void 0) {
    idHash$1[value] = uid("resource");
  }
  return id;
}
const _TextureStyle = class _TextureStyle2 extends EventEmitter {
  /**
   * @param options - options for the style
   */
  constructor(options = {}) {
    super();
    this._resourceType = "textureSampler";
    this._touched = 0;
    this._maxAnisotropy = 1;
    this.destroyed = false;
    options = { ..._TextureStyle2.defaultOptions, ...options };
    this.addressMode = options.addressMode;
    this.addressModeU = options.addressModeU ?? this.addressModeU;
    this.addressModeV = options.addressModeV ?? this.addressModeV;
    this.addressModeW = options.addressModeW ?? this.addressModeW;
    this.scaleMode = options.scaleMode;
    this.magFilter = options.magFilter ?? this.magFilter;
    this.minFilter = options.minFilter ?? this.minFilter;
    this.mipmapFilter = options.mipmapFilter ?? this.mipmapFilter;
    this.lodMinClamp = options.lodMinClamp;
    this.lodMaxClamp = options.lodMaxClamp;
    this.compare = options.compare;
    this.maxAnisotropy = options.maxAnisotropy ?? 1;
  }
  set addressMode(value) {
    this.addressModeU = value;
    this.addressModeV = value;
    this.addressModeW = value;
  }
  /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */
  get addressMode() {
    return this.addressModeU;
  }
  set wrapMode(value) {
    deprecation(v8_0_0, "TextureStyle.wrapMode is now TextureStyle.addressMode");
    this.addressMode = value;
  }
  get wrapMode() {
    return this.addressMode;
  }
  set scaleMode(value) {
    this.magFilter = value;
    this.minFilter = value;
    this.mipmapFilter = value;
  }
  /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */
  get scaleMode() {
    return this.magFilter;
  }
  /** Specifies the maximum anisotropy value clamp used by the sampler. */
  set maxAnisotropy(value) {
    this._maxAnisotropy = Math.min(value, 16);
    if (this._maxAnisotropy > 1) {
      this.scaleMode = "linear";
    }
  }
  get maxAnisotropy() {
    return this._maxAnisotropy;
  }
  // TODO - move this to WebGL?
  get _resourceId() {
    return this._sharedResourceId || this._generateResourceId();
  }
  update() {
    this.emit("change", this);
    this._sharedResourceId = null;
  }
  _generateResourceId() {
    const bigKey = `${this.addressModeU}-${this.addressModeV}-${this.addressModeW}-${this.magFilter}-${this.minFilter}-${this.mipmapFilter}-${this.lodMinClamp}-${this.lodMaxClamp}-${this.compare}-${this._maxAnisotropy}`;
    this._sharedResourceId = createResourceIdFromString(bigKey);
    return this._resourceId;
  }
  /** Destroys the style */
  destroy() {
    this.destroyed = true;
    this.emit("destroy", this);
    this.emit("change", this);
    this.removeAllListeners();
  }
};
_TextureStyle.defaultOptions = {
  addressMode: "clamp-to-edge",
  scaleMode: "linear"
};
let TextureStyle = _TextureStyle;
const _TextureSource = class _TextureSource2 extends EventEmitter {
  /**
   * @param options - options for creating a new TextureSource
   */
  constructor(options = {}) {
    super();
    this.options = options;
    this.uid = uid("textureSource");
    this._resourceType = "textureSource";
    this._resourceId = uid("resource");
    this.uploadMethodId = "unknown";
    this._resolution = 1;
    this.pixelWidth = 1;
    this.pixelHeight = 1;
    this.width = 1;
    this.height = 1;
    this.sampleCount = 1;
    this.mipLevelCount = 1;
    this.autoGenerateMipmaps = false;
    this.format = "rgba8unorm";
    this.dimension = "2d";
    this.antialias = false;
    this._touched = 0;
    this._batchTick = -1;
    this._textureBindLocation = -1;
    options = { ..._TextureSource2.defaultOptions, ...options };
    this.label = options.label ?? "";
    this.resource = options.resource;
    this.autoGarbageCollect = options.autoGarbageCollect;
    this._resolution = options.resolution;
    if (options.width) {
      this.pixelWidth = options.width * this._resolution;
    } else {
      this.pixelWidth = this.resource ? this.resourceWidth ?? 1 : 1;
    }
    if (options.height) {
      this.pixelHeight = options.height * this._resolution;
    } else {
      this.pixelHeight = this.resource ? this.resourceHeight ?? 1 : 1;
    }
    this.width = this.pixelWidth / this._resolution;
    this.height = this.pixelHeight / this._resolution;
    this.format = options.format;
    this.dimension = options.dimensions;
    this.mipLevelCount = options.mipLevelCount;
    this.autoGenerateMipmaps = options.autoGenerateMipmaps;
    this.sampleCount = options.sampleCount;
    this.antialias = options.antialias;
    this.alphaMode = options.alphaMode;
    this.style = new TextureStyle(definedProps(options));
    this.destroyed = false;
    this._refreshPOT();
  }
  /** returns itself */
  get source() {
    return this;
  }
  /** the style of the texture */
  get style() {
    return this._style;
  }
  set style(value) {
    if (this.style === value)
      return;
    this._style?.off("change", this._onStyleChange, this);
    this._style = value;
    this._style?.on("change", this._onStyleChange, this);
    this._onStyleChange();
  }
  /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */
  get addressMode() {
    return this._style.addressMode;
  }
  set addressMode(value) {
    this._style.addressMode = value;
  }
  /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */
  get repeatMode() {
    return this._style.addressMode;
  }
  set repeatMode(value) {
    this._style.addressMode = value;
  }
  /** Specifies the sampling behavior when the sample footprint is smaller than or equal to one texel. */
  get magFilter() {
    return this._style.magFilter;
  }
  set magFilter(value) {
    this._style.magFilter = value;
  }
  /** Specifies the sampling behavior when the sample footprint is larger than one texel. */
  get minFilter() {
    return this._style.minFilter;
  }
  set minFilter(value) {
    this._style.minFilter = value;
  }
  /** Specifies behavior for sampling between mipmap levels. */
  get mipmapFilter() {
    return this._style.mipmapFilter;
  }
  set mipmapFilter(value) {
    this._style.mipmapFilter = value;
  }
  /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */
  get lodMinClamp() {
    return this._style.lodMinClamp;
  }
  set lodMinClamp(value) {
    this._style.lodMinClamp = value;
  }
  /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */
  get lodMaxClamp() {
    return this._style.lodMaxClamp;
  }
  set lodMaxClamp(value) {
    this._style.lodMaxClamp = value;
  }
  _onStyleChange() {
    this.emit("styleChange", this);
  }
  /** call this if you have modified the texture outside of the constructor */
  update() {
    if (this.resource) {
      const resolution = this._resolution;
      const didResize = this.resize(this.resourceWidth / resolution, this.resourceHeight / resolution);
      if (didResize)
        return;
    }
    this.emit("update", this);
  }
  /** Destroys this texture source */
  destroy() {
    this.destroyed = true;
    this.emit("destroy", this);
    this.emit("change", this);
    if (this._style) {
      this._style.destroy();
      this._style = null;
    }
    this.uploadMethodId = null;
    this.resource = null;
    this.removeAllListeners();
  }
  /**
   * This will unload the Texture source from the GPU. This will free up the GPU memory
   * As soon as it is required fore rendering, it will be re-uploaded.
   */
  unload() {
    this._resourceId = uid("resource");
    this.emit("change", this);
    this.emit("unload", this);
  }
  /** the width of the resource. This is the REAL pure number, not accounting resolution   */
  get resourceWidth() {
    const { resource } = this;
    return resource.naturalWidth || resource.videoWidth || resource.displayWidth || resource.width;
  }
  /** the height of the resource. This is the REAL pure number, not accounting resolution */
  get resourceHeight() {
    const { resource } = this;
    return resource.naturalHeight || resource.videoHeight || resource.displayHeight || resource.height;
  }
  /**
   * the resolution of the texture. Changing this number, will not change the number of pixels in the actual texture
   * but will the size of the texture when rendered.
   *
   * changing the resolution of this texture to 2 for example will make it appear twice as small when rendered (as pixel
   * density will have increased)
   */
  get resolution() {
    return this._resolution;
  }
  set resolution(resolution) {
    if (this._resolution === resolution)
      return;
    this._resolution = resolution;
    this.width = this.pixelWidth / resolution;
    this.height = this.pixelHeight / resolution;
  }
  /**
   * Resize the texture, this is handy if you want to use the texture as a render texture
   * @param width - the new width of the texture
   * @param height - the new height of the texture
   * @param resolution - the new resolution of the texture
   * @returns - if the texture was resized
   */
  resize(width, height, resolution) {
    resolution || (resolution = this._resolution);
    width || (width = this.width);
    height || (height = this.height);
    const newPixelWidth = Math.round(width * resolution);
    const newPixelHeight = Math.round(height * resolution);
    this.width = newPixelWidth / resolution;
    this.height = newPixelHeight / resolution;
    this._resolution = resolution;
    if (this.pixelWidth === newPixelWidth && this.pixelHeight === newPixelHeight) {
      return false;
    }
    this._refreshPOT();
    this.pixelWidth = newPixelWidth;
    this.pixelHeight = newPixelHeight;
    this.emit("resize", this);
    this._resourceId = uid("resource");
    this.emit("change", this);
    return true;
  }
  /**
   * Lets the renderer know that this texture has been updated and its mipmaps should be re-generated.
   * This is only important for RenderTexture instances, as standard Texture instances will have their
   * mipmaps generated on upload. You should call this method after you make any change to the texture
   *
   * The reason for this is is can be quite expensive to update mipmaps for a texture. So by default,
   * We want you, the developer to specify when this action should happen.
   *
   * Generally you don't want to have mipmaps generated on Render targets that are changed every frame,
   */
  updateMipmaps() {
    if (this.autoGenerateMipmaps && this.mipLevelCount > 1) {
      this.emit("updateMipmaps", this);
    }
  }
  set wrapMode(value) {
    this._style.wrapMode = value;
  }
  get wrapMode() {
    return this._style.wrapMode;
  }
  set scaleMode(value) {
    this._style.scaleMode = value;
  }
  /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */
  get scaleMode() {
    return this._style.scaleMode;
  }
  /**
   * Refresh check for isPowerOfTwo texture based on size
   * @private
   */
  _refreshPOT() {
    this.isPowerOfTwo = isPow2(this.pixelWidth) && isPow2(this.pixelHeight);
  }
  static test(_resource) {
    throw new Error("Unimplemented");
  }
};
_TextureSource.defaultOptions = {
  resolution: 1,
  format: "bgra8unorm",
  alphaMode: "premultiply-alpha-on-upload",
  dimensions: "2d",
  mipLevelCount: 1,
  autoGenerateMipmaps: false,
  sampleCount: 1,
  antialias: false,
  autoGarbageCollect: false
};
let TextureSource = _TextureSource;
class BufferImageSource extends TextureSource {
  constructor(options) {
    const buffer = options.resource || new Float32Array(options.width * options.height * 4);
    let format = options.format;
    if (!format) {
      if (buffer instanceof Float32Array) {
        format = "rgba32float";
      } else if (buffer instanceof Int32Array) {
        format = "rgba32uint";
      } else if (buffer instanceof Uint32Array) {
        format = "rgba32uint";
      } else if (buffer instanceof Int16Array) {
        format = "rgba16uint";
      } else if (buffer instanceof Uint16Array) {
        format = "rgba16uint";
      } else if (buffer instanceof Int8Array) {
        format = "bgra8unorm";
      } else {
        format = "bgra8unorm";
      }
    }
    super({
      ...options,
      resource: buffer,
      format
    });
    this.uploadMethodId = "buffer";
  }
  static test(resource) {
    return resource instanceof Int8Array || resource instanceof Uint8Array || resource instanceof Uint8ClampedArray || resource instanceof Int16Array || resource instanceof Uint16Array || resource instanceof Int32Array || resource instanceof Uint32Array || resource instanceof Float32Array;
  }
}
BufferImageSource.extension = ExtensionType.TextureSource;
const tempMat = new Matrix();
class TextureMatrix {
  /**
   * @param texture - observed texture
   * @param clampMargin - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
   */
  constructor(texture, clampMargin) {
    this.mapCoord = new Matrix();
    this.uClampFrame = new Float32Array(4);
    this.uClampOffset = new Float32Array(2);
    this._textureID = -1;
    this._updateID = 0;
    this.clampOffset = 0;
    if (typeof clampMargin === "undefined") {
      this.clampMargin = texture.width < 10 ? 0 : 0.5;
    } else {
      this.clampMargin = clampMargin;
    }
    this.isSimple = false;
    this.texture = texture;
  }
  /** Texture property. */
  get texture() {
    return this._texture;
  }
  set texture(value) {
    if (this.texture === value)
      return;
    this._texture?.removeListener("update", this.update, this);
    this._texture = value;
    this._texture.addListener("update", this.update, this);
    this.update();
  }
  /**
   * Multiplies uvs array to transform
   * @param uvs - mesh uvs
   * @param [out=uvs] - output
   * @returns - output
   */
  multiplyUvs(uvs, out2) {
    if (out2 === void 0) {
      out2 = uvs;
    }
    const mat = this.mapCoord;
    for (let i2 = 0; i2 < uvs.length; i2 += 2) {
      const x2 = uvs[i2];
      const y2 = uvs[i2 + 1];
      out2[i2] = x2 * mat.a + y2 * mat.c + mat.tx;
      out2[i2 + 1] = x2 * mat.b + y2 * mat.d + mat.ty;
    }
    return out2;
  }
  /**
   * Updates matrices if texture was changed
   * @returns - whether or not it was updated
   */
  update() {
    const tex = this._texture;
    this._updateID++;
    const uvs = tex.uvs;
    this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);
    const orig = tex.orig;
    const trim = tex.trim;
    if (trim) {
      tempMat.set(
        orig.width / trim.width,
        0,
        0,
        orig.height / trim.height,
        -trim.x / trim.width,
        -trim.y / trim.height
      );
      this.mapCoord.append(tempMat);
    }
    const texBase = tex.source;
    const frame = this.uClampFrame;
    const margin = this.clampMargin / texBase._resolution;
    const offset = this.clampOffset / texBase._resolution;
    frame[0] = (tex.frame.x + margin + offset) / texBase.width;
    frame[1] = (tex.frame.y + margin + offset) / texBase.height;
    frame[2] = (tex.frame.x + tex.frame.width - margin + offset) / texBase.width;
    frame[3] = (tex.frame.y + tex.frame.height - margin + offset) / texBase.height;
    this.uClampOffset[0] = this.clampOffset / texBase.pixelWidth;
    this.uClampOffset[1] = this.clampOffset / texBase.pixelHeight;
    this.isSimple = tex.frame.width === texBase.width && tex.frame.height === texBase.height && tex.rotate === 0;
    return true;
  }
}
class Texture extends EventEmitter {
  /**
   * @param {rendering.TextureOptions} options - Options for the texture
   */
  constructor({
    source: source2,
    label,
    frame,
    orig,
    trim,
    defaultAnchor,
    defaultBorders,
    rotate,
    dynamic
  } = {}) {
    super();
    this.uid = uid("texture");
    this.uvs = { x0: 0, y0: 0, x1: 0, y1: 0, x2: 0, y2: 0, x3: 0, y3: 0 };
    this.frame = new Rectangle();
    this.noFrame = false;
    this.dynamic = false;
    this.isTexture = true;
    this.label = label;
    this.source = source2?.source ?? new TextureSource();
    this.noFrame = !frame;
    if (frame) {
      this.frame.copyFrom(frame);
    } else {
      const { width, height } = this._source;
      this.frame.width = width;
      this.frame.height = height;
    }
    this.orig = orig || this.frame;
    this.trim = trim;
    this.rotate = rotate ?? 0;
    this.defaultAnchor = defaultAnchor;
    this.defaultBorders = defaultBorders;
    this.destroyed = false;
    this.dynamic = dynamic || false;
    this.updateUvs();
  }
  set source(value) {
    if (this._source) {
      this._source.off("resize", this.update, this);
    }
    this._source = value;
    value.on("resize", this.update, this);
    this.emit("update", this);
  }
  /** the underlying source of the texture (equivalent of baseTexture in v7) */
  get source() {
    return this._source;
  }
  /** returns a TextureMatrix instance for this texture. By default, that object is not created because its heavy. */
  get textureMatrix() {
    if (!this._textureMatrix) {
      this._textureMatrix = new TextureMatrix(this);
    }
    return this._textureMatrix;
  }
  /** The width of the Texture in pixels. */
  get width() {
    return this.orig.width;
  }
  /** The height of the Texture in pixels. */
  get height() {
    return this.orig.height;
  }
  /** Call this function when you have modified the frame of this texture. */
  updateUvs() {
    const { uvs, frame } = this;
    const { width, height } = this._source;
    const nX = frame.x / width;
    const nY = frame.y / height;
    const nW = frame.width / width;
    const nH = frame.height / height;
    let rotate = this.rotate;
    if (rotate) {
      const w2 = nW / 2;
      const h2 = nH / 2;
      const cX = nX + w2;
      const cY = nY + h2;
      rotate = groupD8.add(rotate, groupD8.NW);
      uvs.x0 = cX + w2 * groupD8.uX(rotate);
      uvs.y0 = cY + h2 * groupD8.uY(rotate);
      rotate = groupD8.add(rotate, 2);
      uvs.x1 = cX + w2 * groupD8.uX(rotate);
      uvs.y1 = cY + h2 * groupD8.uY(rotate);
      rotate = groupD8.add(rotate, 2);
      uvs.x2 = cX + w2 * groupD8.uX(rotate);
      uvs.y2 = cY + h2 * groupD8.uY(rotate);
      rotate = groupD8.add(rotate, 2);
      uvs.x3 = cX + w2 * groupD8.uX(rotate);
      uvs.y3 = cY + h2 * groupD8.uY(rotate);
    } else {
      uvs.x0 = nX;
      uvs.y0 = nY;
      uvs.x1 = nX + nW;
      uvs.y1 = nY;
      uvs.x2 = nX + nW;
      uvs.y2 = nY + nH;
      uvs.x3 = nX;
      uvs.y3 = nY + nH;
    }
  }
  /**
   * Destroys this texture
   * @param destroySource - Destroy the source when the texture is destroyed.
   */
  destroy(destroySource = false) {
    if (this._source) {
      if (destroySource) {
        this._source.destroy();
        this._source = null;
      }
    }
    this._textureMatrix = null;
    this.destroyed = true;
    this.emit("destroy", this);
    this.removeAllListeners();
  }
  /**
   * Call this if you have modified the `texture outside` of the constructor.
   *
   * If you have modified this texture's source, you must separately call `texture.source.update()` to see those changes.
   */
  update() {
    if (this.noFrame) {
      this.frame.width = this._source.width;
      this.frame.height = this._source.height;
    }
    this.updateUvs();
    this.emit("update", this);
  }
  /** @deprecated since 8.0.0 */
  get baseTexture() {
    deprecation(v8_0_0, "Texture.baseTexture is now Texture.source");
    return this._source;
  }
}
Texture.EMPTY = new Texture({
  label: "EMPTY",
  source: new TextureSource({
    label: "EMPTY"
  })
});
Texture.EMPTY.destroy = NOOP;
Texture.WHITE = new Texture({
  source: new BufferImageSource({
    resource: new Uint8Array([255, 255, 255, 255]),
    width: 1,
    height: 1,
    alphaMode: "premultiply-alpha-on-upload",
    label: "WHITE"
  }),
  label: "WHITE"
});
Texture.WHITE.destroy = NOOP;
function updateQuadBounds(bounds, anchor, texture) {
  const { width, height } = texture.orig;
  const trim = texture.trim;
  if (trim) {
    const sourceWidth = trim.width;
    const sourceHeight = trim.height;
    bounds.minX = trim.x - anchor._x * width;
    bounds.maxX = bounds.minX + sourceWidth;
    bounds.minY = trim.y - anchor._y * height;
    bounds.maxY = bounds.minY + sourceHeight;
  } else {
    bounds.minX = -anchor._x * width;
    bounds.maxX = bounds.minX + width;
    bounds.minY = -anchor._y * height;
    bounds.maxY = bounds.minY + height;
  }
}
const defaultMatrix = new Matrix();
class Bounds {
  constructor(minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity) {
    this.minX = Infinity;
    this.minY = Infinity;
    this.maxX = -Infinity;
    this.maxY = -Infinity;
    this.matrix = defaultMatrix;
    this.minX = minX;
    this.minY = minY;
    this.maxX = maxX;
    this.maxY = maxY;
  }
  /**
   * Checks if bounds are empty.
   * @returns - True if empty.
   */
  isEmpty() {
    return this.minX > this.maxX || this.minY > this.maxY;
  }
  /** The bounding rectangle of the bounds. */
  get rectangle() {
    if (!this._rectangle) {
      this._rectangle = new Rectangle();
    }
    const rectangle = this._rectangle;
    if (this.minX > this.maxX || this.minY > this.maxY) {
      rectangle.x = 0;
      rectangle.y = 0;
      rectangle.width = 0;
      rectangle.height = 0;
    } else {
      rectangle.copyFromBounds(this);
    }
    return rectangle;
  }
  /** Clears the bounds and resets. */
  clear() {
    this.minX = Infinity;
    this.minY = Infinity;
    this.maxX = -Infinity;
    this.maxY = -Infinity;
    this.matrix = defaultMatrix;
    return this;
  }
  /**
   * Sets the bounds.
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   */
  set(x0, y0, x1, y1) {
    this.minX = x0;
    this.minY = y0;
    this.maxX = x1;
    this.maxY = y1;
  }
  /**
   * Adds sprite frame
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   * @param matrix
   */
  addFrame(x0, y0, x1, y1, matrix) {
    matrix || (matrix = this.matrix);
    const a2 = matrix.a;
    const b2 = matrix.b;
    const c2 = matrix.c;
    const d2 = matrix.d;
    const tx = matrix.tx;
    const ty = matrix.ty;
    let minX = this.minX;
    let minY = this.minY;
    let maxX = this.maxX;
    let maxY = this.maxY;
    let x2 = a2 * x0 + c2 * y0 + tx;
    let y2 = b2 * x0 + d2 * y0 + ty;
    if (x2 < minX)
      minX = x2;
    if (y2 < minY)
      minY = y2;
    if (x2 > maxX)
      maxX = x2;
    if (y2 > maxY)
      maxY = y2;
    x2 = a2 * x1 + c2 * y0 + tx;
    y2 = b2 * x1 + d2 * y0 + ty;
    if (x2 < minX)
      minX = x2;
    if (y2 < minY)
      minY = y2;
    if (x2 > maxX)
      maxX = x2;
    if (y2 > maxY)
      maxY = y2;
    x2 = a2 * x0 + c2 * y1 + tx;
    y2 = b2 * x0 + d2 * y1 + ty;
    if (x2 < minX)
      minX = x2;
    if (y2 < minY)
      minY = y2;
    if (x2 > maxX)
      maxX = x2;
    if (y2 > maxY)
      maxY = y2;
    x2 = a2 * x1 + c2 * y1 + tx;
    y2 = b2 * x1 + d2 * y1 + ty;
    if (x2 < minX)
      minX = x2;
    if (y2 < minY)
      minY = y2;
    if (x2 > maxX)
      maxX = x2;
    if (y2 > maxY)
      maxY = y2;
    this.minX = minX;
    this.minY = minY;
    this.maxX = maxX;
    this.maxY = maxY;
  }
  /**
   * Adds a rectangle to the bounds.
   * @param rect - The rectangle to be added.
   * @param matrix - The matrix to apply to the bounds.
   */
  addRect(rect, matrix) {
    this.addFrame(rect.x, rect.y, rect.x + rect.width, rect.y + rect.height, matrix);
  }
  /**
   * Adds other {@link Bounds}.
   * @param bounds - The Bounds to be added
   * @param matrix
   */
  addBounds(bounds, matrix) {
    this.addFrame(bounds.minX, bounds.minY, bounds.maxX, bounds.maxY, matrix);
  }
  /**
   * Adds other Bounds, masked with Bounds.
   * @param mask - The Bounds to be added.
   */
  addBoundsMask(mask) {
    this.minX = this.minX > mask.minX ? this.minX : mask.minX;
    this.minY = this.minY > mask.minY ? this.minY : mask.minY;
    this.maxX = this.maxX < mask.maxX ? this.maxX : mask.maxX;
    this.maxY = this.maxY < mask.maxY ? this.maxY : mask.maxY;
  }
  /**
   * Adds other Bounds, multiplied with matrix.
   * @param matrix - The matrix to apply to the bounds.
   */
  applyMatrix(matrix) {
    const minX = this.minX;
    const minY = this.minY;
    const maxX = this.maxX;
    const maxY = this.maxY;
    const { a: a2, b: b2, c: c2, d: d2, tx, ty } = matrix;
    let x2 = a2 * minX + c2 * minY + tx;
    let y2 = b2 * minX + d2 * minY + ty;
    this.minX = x2;
    this.minY = y2;
    this.maxX = x2;
    this.maxY = y2;
    x2 = a2 * maxX + c2 * minY + tx;
    y2 = b2 * maxX + d2 * minY + ty;
    this.minX = x2 < this.minX ? x2 : this.minX;
    this.minY = y2 < this.minY ? y2 : this.minY;
    this.maxX = x2 > this.maxX ? x2 : this.maxX;
    this.maxY = y2 > this.maxY ? y2 : this.maxY;
    x2 = a2 * minX + c2 * maxY + tx;
    y2 = b2 * minX + d2 * maxY + ty;
    this.minX = x2 < this.minX ? x2 : this.minX;
    this.minY = y2 < this.minY ? y2 : this.minY;
    this.maxX = x2 > this.maxX ? x2 : this.maxX;
    this.maxY = y2 > this.maxY ? y2 : this.maxY;
    x2 = a2 * maxX + c2 * maxY + tx;
    y2 = b2 * maxX + d2 * maxY + ty;
    this.minX = x2 < this.minX ? x2 : this.minX;
    this.minY = y2 < this.minY ? y2 : this.minY;
    this.maxX = x2 > this.maxX ? x2 : this.maxX;
    this.maxY = y2 > this.maxY ? y2 : this.maxY;
  }
  /**
   * Resizes the bounds object to include the given rectangle.
   * @param rect - The rectangle to be included.
   */
  fit(rect) {
    if (this.minX < rect.left)
      this.minX = rect.left;
    if (this.maxX > rect.right)
      this.maxX = rect.right;
    if (this.minY < rect.top)
      this.minY = rect.top;
    if (this.maxY > rect.bottom)
      this.maxY = rect.bottom;
    return this;
  }
  /**
   * Resizes the bounds object to include the given bounds.
   * @param left - The left value of the bounds.
   * @param right - The right value of the bounds.
   * @param top - The top value of the bounds.
   * @param bottom - The bottom value of the bounds.
   */
  fitBounds(left, right, top, bottom) {
    if (this.minX < left)
      this.minX = left;
    if (this.maxX > right)
      this.maxX = right;
    if (this.minY < top)
      this.minY = top;
    if (this.maxY > bottom)
      this.maxY = bottom;
    return this;
  }
  /**
   * Pads bounds object, making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @param paddingX - The horizontal padding amount.
   * @param paddingY - The vertical padding amount.
   */
  pad(paddingX, paddingY = paddingX) {
    this.minX -= paddingX;
    this.maxX += paddingX;
    this.minY -= paddingY;
    this.maxY += paddingY;
    return this;
  }
  /** Ceils the bounds. */
  ceil() {
    this.minX = Math.floor(this.minX);
    this.minY = Math.floor(this.minY);
    this.maxX = Math.ceil(this.maxX);
    this.maxY = Math.ceil(this.maxY);
    return this;
  }
  /** Clones the bounds. */
  clone() {
    return new Bounds(this.minX, this.minY, this.maxX, this.maxY);
  }
  /**
   * Scales the bounds by the given values
   * @param x - The X value to scale by.
   * @param y - The Y value to scale by.
   */
  scale(x2, y2 = x2) {
    this.minX *= x2;
    this.minY *= y2;
    this.maxX *= x2;
    this.maxY *= y2;
    return this;
  }
  /** the x value of the bounds. */
  get x() {
    return this.minX;
  }
  set x(value) {
    const width = this.maxX - this.minX;
    this.minX = value;
    this.maxX = value + width;
  }
  /** the y value of the bounds. */
  get y() {
    return this.minY;
  }
  set y(value) {
    const height = this.maxY - this.minY;
    this.minY = value;
    this.maxY = value + height;
  }
  /** the width value of the bounds. */
  get width() {
    return this.maxX - this.minX;
  }
  set width(value) {
    this.maxX = this.minX + value;
  }
  /** the height value of the bounds. */
  get height() {
    return this.maxY - this.minY;
  }
  set height(value) {
    this.maxY = this.minY + value;
  }
  /** the left value of the bounds. */
  get left() {
    return this.minX;
  }
  /** the right value of the bounds. */
  get right() {
    return this.maxX;
  }
  /** the top value of the bounds. */
  get top() {
    return this.minY;
  }
  /** the bottom value of the bounds. */
  get bottom() {
    return this.maxY;
  }
  /** Is the bounds positive. */
  get isPositive() {
    return this.maxX - this.minX > 0 && this.maxY - this.minY > 0;
  }
  get isValid() {
    return this.minX + this.minY !== Infinity;
  }
  /**
   * Adds screen vertices from array
   * @param vertexData - calculated vertices
   * @param beginOffset - begin offset
   * @param endOffset - end offset, excluded
   * @param matrix
   */
  addVertexData(vertexData, beginOffset, endOffset, matrix) {
    let minX = this.minX;
    let minY = this.minY;
    let maxX = this.maxX;
    let maxY = this.maxY;
    matrix || (matrix = this.matrix);
    const a2 = matrix.a;
    const b2 = matrix.b;
    const c2 = matrix.c;
    const d2 = matrix.d;
    const tx = matrix.tx;
    const ty = matrix.ty;
    for (let i2 = beginOffset; i2 < endOffset; i2 += 2) {
      const localX = vertexData[i2];
      const localY = vertexData[i2 + 1];
      const x2 = a2 * localX + c2 * localY + tx;
      const y2 = b2 * localX + d2 * localY + ty;
      minX = x2 < minX ? x2 : minX;
      minY = y2 < minY ? y2 : minY;
      maxX = x2 > maxX ? x2 : maxX;
      maxY = y2 > maxY ? y2 : maxY;
    }
    this.minX = minX;
    this.minY = minY;
    this.maxX = maxX;
    this.maxY = maxY;
  }
  /**
   * Checks if the point is contained within the bounds.
   * @param x - x coordinate
   * @param y - y coordinate
   */
  containsPoint(x2, y2) {
    if (this.minX <= x2 && this.minY <= y2 && this.maxX >= x2 && this.maxY >= y2) {
      return true;
    }
    return false;
  }
  toString() {
    return `[pixi.js:Bounds minX=${this.minX} minY=${this.minY} maxX=${this.maxX} maxY=${this.maxY} width=${this.width} height=${this.height}]`;
  }
  /**
   * Copies the bounds from another bounds object.
   * @param bounds - The bounds to copy from.
   * @returns - This bounds object.
   */
  copyFrom(bounds) {
    this.minX = bounds.minX;
    this.minY = bounds.minY;
    this.maxX = bounds.maxX;
    this.maxY = bounds.maxY;
    return this;
  }
}
var r = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, t = function(r2) {
  return "string" == typeof r2 ? r2.length > 0 : "number" == typeof r2;
}, n = function(r2, t2, n2) {
  return void 0 === t2 && (t2 = 0), void 0 === n2 && (n2 = Math.pow(10, t2)), Math.round(n2 * r2) / n2 + 0;
}, e = function(r2, t2, n2) {
  return void 0 === t2 && (t2 = 0), void 0 === n2 && (n2 = 1), r2 > n2 ? n2 : r2 > t2 ? r2 : t2;
}, u = function(r2) {
  return (r2 = isFinite(r2) ? r2 % 360 : 0) > 0 ? r2 : r2 + 360;
}, a = function(r2) {
  return { r: e(r2.r, 0, 255), g: e(r2.g, 0, 255), b: e(r2.b, 0, 255), a: e(r2.a) };
}, o = function(r2) {
  return { r: n(r2.r), g: n(r2.g), b: n(r2.b), a: n(r2.a, 3) };
}, i = /^#([0-9a-f]{3,8})$/i, s = function(r2) {
  var t2 = r2.toString(16);
  return t2.length < 2 ? "0" + t2 : t2;
}, h = function(r2) {
  var t2 = r2.r, n2 = r2.g, e2 = r2.b, u2 = r2.a, a2 = Math.max(t2, n2, e2), o2 = a2 - Math.min(t2, n2, e2), i2 = o2 ? a2 === t2 ? (n2 - e2) / o2 : a2 === n2 ? 2 + (e2 - t2) / o2 : 4 + (t2 - n2) / o2 : 0;
  return { h: 60 * (i2 < 0 ? i2 + 6 : i2), s: a2 ? o2 / a2 * 100 : 0, v: a2 / 255 * 100, a: u2 };
}, b = function(r2) {
  var t2 = r2.h, n2 = r2.s, e2 = r2.v, u2 = r2.a;
  t2 = t2 / 360 * 6, n2 /= 100, e2 /= 100;
  var a2 = Math.floor(t2), o2 = e2 * (1 - n2), i2 = e2 * (1 - (t2 - a2) * n2), s2 = e2 * (1 - (1 - t2 + a2) * n2), h2 = a2 % 6;
  return { r: 255 * [e2, i2, o2, o2, s2, e2][h2], g: 255 * [s2, e2, e2, i2, o2, o2][h2], b: 255 * [o2, o2, s2, e2, e2, i2][h2], a: u2 };
}, g = function(r2) {
  return { h: u(r2.h), s: e(r2.s, 0, 100), l: e(r2.l, 0, 100), a: e(r2.a) };
}, d = function(r2) {
  return { h: n(r2.h), s: n(r2.s), l: n(r2.l), a: n(r2.a, 3) };
}, f = function(r2) {
  return b((n2 = (t2 = r2).s, { h: t2.h, s: (n2 *= ((e2 = t2.l) < 50 ? e2 : 100 - e2) / 100) > 0 ? 2 * n2 / (e2 + n2) * 100 : 0, v: e2 + n2, a: t2.a }));
  var t2, n2, e2;
}, c = function(r2) {
  return { h: (t2 = h(r2)).h, s: (u2 = (200 - (n2 = t2.s)) * (e2 = t2.v) / 100) > 0 && u2 < 200 ? n2 * e2 / 100 / (u2 <= 100 ? u2 : 200 - u2) * 100 : 0, l: u2 / 2, a: t2.a };
  var t2, n2, e2, u2;
}, l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, p = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, v = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, m = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, y = { string: [[function(r2) {
  var t2 = i.exec(r2);
  return t2 ? (r2 = t2[1]).length <= 4 ? { r: parseInt(r2[0] + r2[0], 16), g: parseInt(r2[1] + r2[1], 16), b: parseInt(r2[2] + r2[2], 16), a: 4 === r2.length ? n(parseInt(r2[3] + r2[3], 16) / 255, 2) : 1 } : 6 === r2.length || 8 === r2.length ? { r: parseInt(r2.substr(0, 2), 16), g: parseInt(r2.substr(2, 2), 16), b: parseInt(r2.substr(4, 2), 16), a: 8 === r2.length ? n(parseInt(r2.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(r2) {
  var t2 = v.exec(r2) || m.exec(r2);
  return t2 ? t2[2] !== t2[4] || t2[4] !== t2[6] ? null : a({ r: Number(t2[1]) / (t2[2] ? 100 / 255 : 1), g: Number(t2[3]) / (t2[4] ? 100 / 255 : 1), b: Number(t2[5]) / (t2[6] ? 100 / 255 : 1), a: void 0 === t2[7] ? 1 : Number(t2[7]) / (t2[8] ? 100 : 1) }) : null;
}, "rgb"], [function(t2) {
  var n2 = l.exec(t2) || p.exec(t2);
  if (!n2)
    return null;
  var e2, u2, a2 = g({ h: (e2 = n2[1], u2 = n2[2], void 0 === u2 && (u2 = "deg"), Number(e2) * (r[u2] || 1)), s: Number(n2[3]), l: Number(n2[4]), a: void 0 === n2[5] ? 1 : Number(n2[5]) / (n2[6] ? 100 : 1) });
  return f(a2);
}, "hsl"]], object: [[function(r2) {
  var n2 = r2.r, e2 = r2.g, u2 = r2.b, o2 = r2.a, i2 = void 0 === o2 ? 1 : o2;
  return t(n2) && t(e2) && t(u2) ? a({ r: Number(n2), g: Number(e2), b: Number(u2), a: Number(i2) }) : null;
}, "rgb"], [function(r2) {
  var n2 = r2.h, e2 = r2.s, u2 = r2.l, a2 = r2.a, o2 = void 0 === a2 ? 1 : a2;
  if (!t(n2) || !t(e2) || !t(u2))
    return null;
  var i2 = g({ h: Number(n2), s: Number(e2), l: Number(u2), a: Number(o2) });
  return f(i2);
}, "hsl"], [function(r2) {
  var n2 = r2.h, a2 = r2.s, o2 = r2.v, i2 = r2.a, s2 = void 0 === i2 ? 1 : i2;
  if (!t(n2) || !t(a2) || !t(o2))
    return null;
  var h2 = function(r3) {
    return { h: u(r3.h), s: e(r3.s, 0, 100), v: e(r3.v, 0, 100), a: e(r3.a) };
  }({ h: Number(n2), s: Number(a2), v: Number(o2), a: Number(s2) });
  return b(h2);
}, "hsv"]] }, N = function(r2, t2) {
  for (var n2 = 0; n2 < t2.length; n2++) {
    var e2 = t2[n2][0](r2);
    if (e2)
      return [e2, t2[n2][1]];
  }
  return [null, void 0];
}, x = function(r2) {
  return "string" == typeof r2 ? N(r2.trim(), y.string) : "object" == typeof r2 && null !== r2 ? N(r2, y.object) : [null, void 0];
}, M = function(r2, t2) {
  var n2 = c(r2);
  return { h: n2.h, s: e(n2.s + 100 * t2, 0, 100), l: n2.l, a: n2.a };
}, H = function(r2) {
  return (299 * r2.r + 587 * r2.g + 114 * r2.b) / 1e3 / 255;
}, $ = function(r2, t2) {
  var n2 = c(r2);
  return { h: n2.h, s: n2.s, l: e(n2.l + 100 * t2, 0, 100), a: n2.a };
}, j = function() {
  function r2(r3) {
    this.parsed = x(r3)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return r2.prototype.isValid = function() {
    return null !== this.parsed;
  }, r2.prototype.brightness = function() {
    return n(H(this.rgba), 2);
  }, r2.prototype.isDark = function() {
    return H(this.rgba) < 0.5;
  }, r2.prototype.isLight = function() {
    return H(this.rgba) >= 0.5;
  }, r2.prototype.toHex = function() {
    return r3 = o(this.rgba), t2 = r3.r, e2 = r3.g, u2 = r3.b, i2 = (a2 = r3.a) < 1 ? s(n(255 * a2)) : "", "#" + s(t2) + s(e2) + s(u2) + i2;
    var r3, t2, e2, u2, a2, i2;
  }, r2.prototype.toRgb = function() {
    return o(this.rgba);
  }, r2.prototype.toRgbString = function() {
    return r3 = o(this.rgba), t2 = r3.r, n2 = r3.g, e2 = r3.b, (u2 = r3.a) < 1 ? "rgba(" + t2 + ", " + n2 + ", " + e2 + ", " + u2 + ")" : "rgb(" + t2 + ", " + n2 + ", " + e2 + ")";
    var r3, t2, n2, e2, u2;
  }, r2.prototype.toHsl = function() {
    return d(c(this.rgba));
  }, r2.prototype.toHslString = function() {
    return r3 = d(c(this.rgba)), t2 = r3.h, n2 = r3.s, e2 = r3.l, (u2 = r3.a) < 1 ? "hsla(" + t2 + ", " + n2 + "%, " + e2 + "%, " + u2 + ")" : "hsl(" + t2 + ", " + n2 + "%, " + e2 + "%)";
    var r3, t2, n2, e2, u2;
  }, r2.prototype.toHsv = function() {
    return r3 = h(this.rgba), { h: n(r3.h), s: n(r3.s), v: n(r3.v), a: n(r3.a, 3) };
    var r3;
  }, r2.prototype.invert = function() {
    return w({ r: 255 - (r3 = this.rgba).r, g: 255 - r3.g, b: 255 - r3.b, a: r3.a });
    var r3;
  }, r2.prototype.saturate = function(r3) {
    return void 0 === r3 && (r3 = 0.1), w(M(this.rgba, r3));
  }, r2.prototype.desaturate = function(r3) {
    return void 0 === r3 && (r3 = 0.1), w(M(this.rgba, -r3));
  }, r2.prototype.grayscale = function() {
    return w(M(this.rgba, -1));
  }, r2.prototype.lighten = function(r3) {
    return void 0 === r3 && (r3 = 0.1), w($(this.rgba, r3));
  }, r2.prototype.darken = function(r3) {
    return void 0 === r3 && (r3 = 0.1), w($(this.rgba, -r3));
  }, r2.prototype.rotate = function(r3) {
    return void 0 === r3 && (r3 = 15), this.hue(this.hue() + r3);
  }, r2.prototype.alpha = function(r3) {
    return "number" == typeof r3 ? w({ r: (t2 = this.rgba).r, g: t2.g, b: t2.b, a: r3 }) : n(this.rgba.a, 3);
    var t2;
  }, r2.prototype.hue = function(r3) {
    var t2 = c(this.rgba);
    return "number" == typeof r3 ? w({ h: r3, s: t2.s, l: t2.l, a: t2.a }) : n(t2.h);
  }, r2.prototype.isEqual = function(r3) {
    return this.toHex() === w(r3).toHex();
  }, r2;
}(), w = function(r2) {
  return r2 instanceof j ? r2 : new j(r2);
}, S = [], k = function(r2) {
  r2.forEach(function(r3) {
    S.indexOf(r3) < 0 && (r3(j, y), S.push(r3));
  });
};
function namesPlugin(e2, f2) {
  var a2 = { white: "#ffffff", bisque: "#ffe4c4", blue: "#0000ff", cadetblue: "#5f9ea0", chartreuse: "#7fff00", chocolate: "#d2691e", coral: "#ff7f50", antiquewhite: "#faebd7", aqua: "#00ffff", azure: "#f0ffff", whitesmoke: "#f5f5f5", papayawhip: "#ffefd5", plum: "#dda0dd", blanchedalmond: "#ffebcd", black: "#000000", gold: "#ffd700", goldenrod: "#daa520", gainsboro: "#dcdcdc", cornsilk: "#fff8dc", cornflowerblue: "#6495ed", burlywood: "#deb887", aquamarine: "#7fffd4", beige: "#f5f5dc", crimson: "#dc143c", cyan: "#00ffff", darkblue: "#00008b", darkcyan: "#008b8b", darkgoldenrod: "#b8860b", darkkhaki: "#bdb76b", darkgray: "#a9a9a9", darkgreen: "#006400", darkgrey: "#a9a9a9", peachpuff: "#ffdab9", darkmagenta: "#8b008b", darkred: "#8b0000", darkorchid: "#9932cc", darkorange: "#ff8c00", darkslateblue: "#483d8b", gray: "#808080", darkslategray: "#2f4f4f", darkslategrey: "#2f4f4f", deeppink: "#ff1493", deepskyblue: "#00bfff", wheat: "#f5deb3", firebrick: "#b22222", floralwhite: "#fffaf0", ghostwhite: "#f8f8ff", darkviolet: "#9400d3", magenta: "#ff00ff", green: "#008000", dodgerblue: "#1e90ff", grey: "#808080", honeydew: "#f0fff0", hotpink: "#ff69b4", blueviolet: "#8a2be2", forestgreen: "#228b22", lawngreen: "#7cfc00", indianred: "#cd5c5c", indigo: "#4b0082", fuchsia: "#ff00ff", brown: "#a52a2a", maroon: "#800000", mediumblue: "#0000cd", lightcoral: "#f08080", darkturquoise: "#00ced1", lightcyan: "#e0ffff", ivory: "#fffff0", lightyellow: "#ffffe0", lightsalmon: "#ffa07a", lightseagreen: "#20b2aa", linen: "#faf0e6", mediumaquamarine: "#66cdaa", lemonchiffon: "#fffacd", lime: "#00ff00", khaki: "#f0e68c", mediumseagreen: "#3cb371", limegreen: "#32cd32", mediumspringgreen: "#00fa9a", lightskyblue: "#87cefa", lightblue: "#add8e6", midnightblue: "#191970", lightpink: "#ffb6c1", mistyrose: "#ffe4e1", moccasin: "#ffe4b5", mintcream: "#f5fffa", lightslategray: "#778899", lightslategrey: "#778899", navajowhite: "#ffdead", navy: "#000080", mediumvioletred: "#c71585", powderblue: "#b0e0e6", palegoldenrod: "#eee8aa", oldlace: "#fdf5e6", paleturquoise: "#afeeee", mediumturquoise: "#48d1cc", mediumorchid: "#ba55d3", rebeccapurple: "#663399", lightsteelblue: "#b0c4de", mediumslateblue: "#7b68ee", thistle: "#d8bfd8", tan: "#d2b48c", orchid: "#da70d6", mediumpurple: "#9370db", purple: "#800080", pink: "#ffc0cb", skyblue: "#87ceeb", springgreen: "#00ff7f", palegreen: "#98fb98", red: "#ff0000", yellow: "#ffff00", slateblue: "#6a5acd", lavenderblush: "#fff0f5", peru: "#cd853f", palevioletred: "#db7093", violet: "#ee82ee", teal: "#008080", slategray: "#708090", slategrey: "#708090", aliceblue: "#f0f8ff", darkseagreen: "#8fbc8f", darkolivegreen: "#556b2f", greenyellow: "#adff2f", seagreen: "#2e8b57", seashell: "#fff5ee", tomato: "#ff6347", silver: "#c0c0c0", sienna: "#a0522d", lavender: "#e6e6fa", lightgreen: "#90ee90", orange: "#ffa500", orangered: "#ff4500", steelblue: "#4682b4", royalblue: "#4169e1", turquoise: "#40e0d0", yellowgreen: "#9acd32", salmon: "#fa8072", saddlebrown: "#8b4513", sandybrown: "#f4a460", rosybrown: "#bc8f8f", darksalmon: "#e9967a", lightgoldenrodyellow: "#fafad2", snow: "#fffafa", lightgrey: "#d3d3d3", lightgray: "#d3d3d3", dimgray: "#696969", dimgrey: "#696969", olivedrab: "#6b8e23", olive: "#808000" }, r2 = {};
  for (var d2 in a2)
    r2[a2[d2]] = d2;
  var l2 = {};
  e2.prototype.toName = function(f3) {
    if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b))
      return "transparent";
    var d3, i2, n2 = r2[this.toHex()];
    if (n2)
      return n2;
    if (null == f3 ? void 0 : f3.closest) {
      var o2 = this.toRgb(), t2 = 1 / 0, b2 = "black";
      if (!l2.length)
        for (var c2 in a2)
          l2[c2] = new e2(a2[c2]).toRgb();
      for (var g2 in a2) {
        var u2 = (d3 = o2, i2 = l2[g2], Math.pow(d3.r - i2.r, 2) + Math.pow(d3.g - i2.g, 2) + Math.pow(d3.b - i2.b, 2));
        u2 < t2 && (t2 = u2, b2 = g2);
      }
      return b2;
    }
  };
  f2.string.push([function(f3) {
    var r3 = f3.toLowerCase(), d3 = "transparent" === r3 ? "#0000" : a2[r3];
    return d3 ? new e2(d3).toRgb() : null;
  }, "name"]);
}
k([namesPlugin]);
const _Color = class _Color2 {
  /**
   * @param {ColorSource} value - Optional value to use, if not provided, white is used.
   */
  constructor(value = 16777215) {
    this._value = null;
    this._components = new Float32Array(4);
    this._components.fill(1);
    this._int = 16777215;
    this.value = value;
  }
  /** Get red component (0 - 1) */
  get red() {
    return this._components[0];
  }
  /** Get green component (0 - 1) */
  get green() {
    return this._components[1];
  }
  /** Get blue component (0 - 1) */
  get blue() {
    return this._components[2];
  }
  /** Get alpha component (0 - 1) */
  get alpha() {
    return this._components[3];
  }
  /**
   * Set the value, suitable for chaining
   * @param value
   * @see Color.value
   */
  setValue(value) {
    this.value = value;
    return this;
  }
  /**
   * The current color source.
   *
   * When setting:
   * - Setting to an instance of `Color` will copy its color source and components.
   * - Otherwise, `Color` will try to normalize the color source and set the components.
   *   If the color source is invalid, an `Error` will be thrown and the `Color` will left unchanged.
   *
   * Note: The `null` in the setter's parameter type is added to match the TypeScript rule: return type of getter
   * must be assignable to its setter's parameter type. Setting `value` to `null` will throw an `Error`.
   *
   * When getting:
   * - A return value of `null` means the previous value was overridden (e.g., {@link Color.multiply multiply},
   *   {@link Color.premultiply premultiply} or {@link Color.round round}).
   * - Otherwise, the color source used when setting is returned.
   */
  set value(value) {
    if (value instanceof _Color2) {
      this._value = this._cloneSource(value._value);
      this._int = value._int;
      this._components.set(value._components);
    } else if (value === null) {
      throw new Error("Cannot set Color#value to null");
    } else if (this._value === null || !this._isSourceEqual(this._value, value)) {
      this._value = this._cloneSource(value);
      this._normalize(this._value);
    }
  }
  get value() {
    return this._value;
  }
  /**
   * Copy a color source internally.
   * @param value - Color source
   */
  _cloneSource(value) {
    if (typeof value === "string" || typeof value === "number" || value instanceof Number || value === null) {
      return value;
    } else if (Array.isArray(value) || ArrayBuffer.isView(value)) {
      return value.slice(0);
    } else if (typeof value === "object" && value !== null) {
      return { ...value };
    }
    return value;
  }
  /**
   * Equality check for color sources.
   * @param value1 - First color source
   * @param value2 - Second color source
   * @returns `true` if the color sources are equal, `false` otherwise.
   */
  _isSourceEqual(value1, value2) {
    const type1 = typeof value1;
    const type2 = typeof value2;
    if (type1 !== type2) {
      return false;
    } else if (type1 === "number" || type1 === "string" || value1 instanceof Number) {
      return value1 === value2;
    } else if (Array.isArray(value1) && Array.isArray(value2) || ArrayBuffer.isView(value1) && ArrayBuffer.isView(value2)) {
      if (value1.length !== value2.length) {
        return false;
      }
      return value1.every((v2, i2) => v2 === value2[i2]);
    } else if (value1 !== null && value2 !== null) {
      const keys1 = Object.keys(value1);
      const keys2 = Object.keys(value2);
      if (keys1.length !== keys2.length) {
        return false;
      }
      return keys1.every((key) => value1[key] === value2[key]);
    }
    return value1 === value2;
  }
  /**
   * Convert to a RGBA color object.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toRgb(); // returns { r: 1, g: 1, b: 1, a: 1 }
   */
  toRgba() {
    const [r2, g2, b2, a2] = this._components;
    return { r: r2, g: g2, b: b2, a: a2 };
  }
  /**
   * Convert to a RGB color object.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toRgb(); // returns { r: 1, g: 1, b: 1 }
   */
  toRgb() {
    const [r2, g2, b2] = this._components;
    return { r: r2, g: g2, b: b2 };
  }
  /** Convert to a CSS-style rgba string: `rgba(255,255,255,1.0)`. */
  toRgbaString() {
    const [r2, g2, b2] = this.toUint8RgbArray();
    return `rgba(${r2},${g2},${b2},${this.alpha})`;
  }
  toUint8RgbArray(out2) {
    const [r2, g2, b2] = this._components;
    if (!this._arrayRgb) {
      this._arrayRgb = [];
    }
    out2 || (out2 = this._arrayRgb);
    out2[0] = Math.round(r2 * 255);
    out2[1] = Math.round(g2 * 255);
    out2[2] = Math.round(b2 * 255);
    return out2;
  }
  toArray(out2) {
    if (!this._arrayRgba) {
      this._arrayRgba = [];
    }
    out2 || (out2 = this._arrayRgba);
    const [r2, g2, b2, a2] = this._components;
    out2[0] = r2;
    out2[1] = g2;
    out2[2] = b2;
    out2[3] = a2;
    return out2;
  }
  toRgbArray(out2) {
    if (!this._arrayRgb) {
      this._arrayRgb = [];
    }
    out2 || (out2 = this._arrayRgb);
    const [r2, g2, b2] = this._components;
    out2[0] = r2;
    out2[1] = g2;
    out2[2] = b2;
    return out2;
  }
  /**
   * Convert to a hexadecimal number.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toNumber(); // returns 16777215
   */
  toNumber() {
    return this._int;
  }
  /**
   * Convert to a BGR number
   * @example
   * import { Color } from 'pixi.js';
   * new Color(0xffcc99).toBgrNumber(); // returns 0x99ccff
   */
  toBgrNumber() {
    const [r2, g2, b2] = this.toUint8RgbArray();
    return (b2 << 16) + (g2 << 8) + r2;
  }
  /**
   * Convert to a hexadecimal number in little endian format (e.g., BBGGRR).
   * @example
   * import { Color } from 'pixi.js';
   * new Color(0xffcc99).toLittleEndianNumber(); // returns 0x99ccff
   * @returns {number} - The color as a number in little endian format.
   */
  toLittleEndianNumber() {
    const value = this._int;
    return (value >> 16) + (value & 65280) + ((value & 255) << 16);
  }
  /**
   * Multiply with another color. This action is destructive, and will
   * override the previous `value` property to be `null`.
   * @param {ColorSource} value - The color to multiply by.
   */
  multiply(value) {
    const [r2, g2, b2, a2] = _Color2._temp.setValue(value)._components;
    this._components[0] *= r2;
    this._components[1] *= g2;
    this._components[2] *= b2;
    this._components[3] *= a2;
    this._refreshInt();
    this._value = null;
    return this;
  }
  /**
   * Converts color to a premultiplied alpha format. This action is destructive, and will
   * override the previous `value` property to be `null`.
   * @param alpha - The alpha to multiply by.
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels.
   * @returns {Color} - Itself.
   */
  premultiply(alpha, applyToRGB = true) {
    if (applyToRGB) {
      this._components[0] *= alpha;
      this._components[1] *= alpha;
      this._components[2] *= alpha;
    }
    this._components[3] = alpha;
    this._refreshInt();
    this._value = null;
    return this;
  }
  /**
   * Premultiplies alpha with current color.
   * @param {number} alpha - The alpha to multiply by.
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels.
   * @returns {number} tint multiplied by alpha
   */
  toPremultiplied(alpha, applyToRGB = true) {
    if (alpha === 1) {
      return (255 << 24) + this._int;
    }
    if (alpha === 0) {
      return applyToRGB ? 0 : this._int;
    }
    let r2 = this._int >> 16 & 255;
    let g2 = this._int >> 8 & 255;
    let b2 = this._int & 255;
    if (applyToRGB) {
      r2 = r2 * alpha + 0.5 | 0;
      g2 = g2 * alpha + 0.5 | 0;
      b2 = b2 * alpha + 0.5 | 0;
    }
    return (alpha * 255 << 24) + (r2 << 16) + (g2 << 8) + b2;
  }
  /**
   * Convert to a hexadecimal string.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toHex(); // returns "#ffffff"
   */
  toHex() {
    const hexString = this._int.toString(16);
    return `#${"000000".substring(0, 6 - hexString.length) + hexString}`;
  }
  /**
   * Convert to a hexadecimal string with alpha.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toHexa(); // returns "#ffffffff"
   */
  toHexa() {
    const alphaValue = Math.round(this._components[3] * 255);
    const alphaString = alphaValue.toString(16);
    return this.toHex() + "00".substring(0, 2 - alphaString.length) + alphaString;
  }
  /**
   * Set alpha, suitable for chaining.
   * @param alpha
   */
  setAlpha(alpha) {
    this._components[3] = this._clamp(alpha);
    return this;
  }
  /**
   * Normalize the input value into rgba
   * @param value - Input value
   */
  _normalize(value) {
    let r2;
    let g2;
    let b2;
    let a2;
    if ((typeof value === "number" || value instanceof Number) && value >= 0 && value <= 16777215) {
      const int = value;
      r2 = (int >> 16 & 255) / 255;
      g2 = (int >> 8 & 255) / 255;
      b2 = (int & 255) / 255;
      a2 = 1;
    } else if ((Array.isArray(value) || value instanceof Float32Array) && value.length >= 3 && value.length <= 4) {
      value = this._clamp(value);
      [r2, g2, b2, a2 = 1] = value;
    } else if ((value instanceof Uint8Array || value instanceof Uint8ClampedArray) && value.length >= 3 && value.length <= 4) {
      value = this._clamp(value, 0, 255);
      [r2, g2, b2, a2 = 255] = value;
      r2 /= 255;
      g2 /= 255;
      b2 /= 255;
      a2 /= 255;
    } else if (typeof value === "string" || typeof value === "object") {
      if (typeof value === "string") {
        const match = _Color2.HEX_PATTERN.exec(value);
        if (match) {
          value = `#${match[2]}`;
        }
      }
      const color = w(value);
      if (color.isValid()) {
        ({ r: r2, g: g2, b: b2, a: a2 } = color.rgba);
        r2 /= 255;
        g2 /= 255;
        b2 /= 255;
      }
    }
    if (r2 !== void 0) {
      this._components[0] = r2;
      this._components[1] = g2;
      this._components[2] = b2;
      this._components[3] = a2;
      this._refreshInt();
    } else {
      throw new Error(`Unable to convert color ${value}`);
    }
  }
  /** Refresh the internal color rgb number */
  _refreshInt() {
    this._clamp(this._components);
    const [r2, g2, b2] = this._components;
    this._int = (r2 * 255 << 16) + (g2 * 255 << 8) + (b2 * 255 | 0);
  }
  /**
   * Clamps values to a range. Will override original values
   * @param value - Value(s) to clamp
   * @param min - Minimum value
   * @param max - Maximum value
   */
  _clamp(value, min = 0, max = 1) {
    if (typeof value === "number") {
      return Math.min(Math.max(value, min), max);
    }
    value.forEach((v2, i2) => {
      value[i2] = Math.min(Math.max(v2, min), max);
    });
    return value;
  }
  /**
   * Check if the value is a color-like object
   * @param value - Value to check
   * @returns True if the value is a color-like object
   * @static
   * @example
   * import { Color } from 'pixi.js';
   * Color.isColorLike('white'); // returns true
   * Color.isColorLike(0xffffff); // returns true
   * Color.isColorLike([1, 1, 1]); // returns true
   */
  static isColorLike(value) {
    return typeof value === "number" || typeof value === "string" || value instanceof Number || value instanceof _Color2 || Array.isArray(value) || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Float32Array || value.r !== void 0 && value.g !== void 0 && value.b !== void 0 || value.r !== void 0 && value.g !== void 0 && value.b !== void 0 && value.a !== void 0 || value.h !== void 0 && value.s !== void 0 && value.l !== void 0 || value.h !== void 0 && value.s !== void 0 && value.l !== void 0 && value.a !== void 0 || value.h !== void 0 && value.s !== void 0 && value.v !== void 0 || value.h !== void 0 && value.s !== void 0 && value.v !== void 0 && value.a !== void 0;
  }
};
_Color.shared = new _Color();
_Color._temp = new _Color();
_Color.HEX_PATTERN = /^(#|0x)?(([a-f0-9]{3}){1,2}([a-f0-9]{2})?)$/i;
let Color = _Color;
const cullingMixin = {
  cullArea: null,
  cullable: false,
  cullableChildren: true
};
class Pool {
  /**
   * Constructs a new Pool.
   * @param ClassType - The constructor of the items in the pool.
   * @param {number} [initialSize] - The initial size of the pool.
   */
  constructor(ClassType, initialSize) {
    this._pool = [];
    this._count = 0;
    this._index = 0;
    this._classType = ClassType;
    if (initialSize) {
      this.prepopulate(initialSize);
    }
  }
  /**
   * Prepopulates the pool with a given number of items.
   * @param total - The number of items to add to the pool.
   */
  prepopulate(total) {
    for (let i2 = 0; i2 < total; i2++) {
      this._pool[this._index++] = new this._classType();
    }
    this._count += total;
  }
  /**
   * Gets an item from the pool. Calls the item's `init` method if it exists.
   * If there are no items left in the pool, a new one will be created.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */
  get(data) {
    let item;
    if (this._index > 0) {
      item = this._pool[--this._index];
    } else {
      item = new this._classType();
    }
    item.init?.(data);
    return item;
  }
  /**
   * Returns an item to the pool. Calls the item's `reset` method if it exists.
   * @param {T} item - The item to return to the pool.
   */
  return(item) {
    item.reset?.();
    this._pool[this._index++] = item;
  }
  /**
   * Gets the number of items in the pool.
   * @readonly
   * @member {number}
   */
  get totalSize() {
    return this._count;
  }
  /**
   * Gets the number of items in the pool that are free to use without needing to create more.
   * @readonly
   * @member {number}
   */
  get totalFree() {
    return this._index;
  }
  /**
   * Gets the number of items in the pool that are currently in use.
   * @readonly
   * @member {number}
   */
  get totalUsed() {
    return this._count - this._index;
  }
  /** clears the pool - mainly used for debugging! */
  clear() {
    this._pool.length = 0;
    this._index = 0;
  }
}
class PoolGroupClass {
  constructor() {
    this._poolsByClass = /* @__PURE__ */ new Map();
  }
  /**
   * Prepopulates a specific pool with a given number of items.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {number} total - The number of items to add to the pool.
   */
  prepopulate(Class, total) {
    const classPool = this.getPool(Class);
    classPool.prepopulate(total);
  }
  /**
   * Gets an item from a specific pool.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */
  get(Class, data) {
    const pool = this.getPool(Class);
    return pool.get(data);
  }
  /**
   * Returns an item to its respective pool.
   * @param {PoolItem} item - The item to return to the pool.
   */
  return(item) {
    const pool = this.getPool(item.constructor);
    pool.return(item);
  }
  /**
   * Gets a specific pool based on the class type.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} ClassType - The constructor of the items in the pool.
   * @returns {Pool<T>} The pool of the given class type.
   */
  getPool(ClassType) {
    if (!this._poolsByClass.has(ClassType)) {
      this._poolsByClass.set(ClassType, new Pool(ClassType));
    }
    return this._poolsByClass.get(ClassType);
  }
  /** gets the usage stats of each pool in the system */
  stats() {
    const stats = {};
    this._poolsByClass.forEach((pool) => {
      const name = stats[pool._classType.name] ? pool._classType.name + pool._classType.ID : pool._classType.name;
      stats[name] = {
        free: pool.totalFree,
        used: pool.totalUsed,
        size: pool.totalSize
      };
    });
    return stats;
  }
}
const BigPool = new PoolGroupClass();
const cacheAsTextureMixin = {
  /**
   * Is this container cached as a texture?
   * @readonly
   * @type {boolean}
   * @memberof scene.Container#
   */
  get isCachedAsTexture() {
    return !!this.renderGroup?.isCachedAsTexture;
  },
  cacheAsTexture(val) {
    if (typeof val === "boolean" && val === false) {
      this.disableRenderGroup();
    } else {
      this.enableRenderGroup();
      this.renderGroup.enableCacheAsTexture(val === true ? {} : val);
    }
  },
  /**
   * Updates the cached texture. Will flag that this container's cached texture needs to be redrawn.
   * This will happen on the next render.
   * @memberof scene.Container#
   */
  updateCacheTexture() {
    this.renderGroup?.updateCacheTexture();
  },
  /**
   * Allows backwards compatibility with pixi.js below version v8. Use `cacheAsTexture` instead.
   * @deprecated
   */
  get cacheAsBitmap() {
    return this.isCachedAsTexture;
  },
  /**
   * @deprecated
   */
  set cacheAsBitmap(val) {
    deprecation("v8.6.0", "cacheAsBitmap is deprecated, use cacheAsTexture instead.");
    this.cacheAsTexture(val);
  }
};
function removeItems(arr, startIdx, removeCount) {
  const length2 = arr.length;
  let i2;
  if (startIdx >= length2 || removeCount === 0) {
    return;
  }
  removeCount = startIdx + removeCount > length2 ? length2 - startIdx : removeCount;
  const len = length2 - removeCount;
  for (i2 = startIdx; i2 < len; ++i2) {
    arr[i2] = arr[i2 + removeCount];
  }
  arr.length = len;
}
const childrenHelperMixin = {
  allowChildren: true,
  /**
   * Removes all children from this container that are within the begin and end indexes.
   * @param beginIndex - The beginning position.
   * @param endIndex - The ending position. Default value is size of the container.
   * @returns - List of removed children
   * @memberof scene.Container#
   */
  removeChildren(beginIndex = 0, endIndex) {
    const end = endIndex ?? this.children.length;
    const range = end - beginIndex;
    const removed = [];
    if (range > 0 && range <= end) {
      for (let i2 = end - 1; i2 >= beginIndex; i2--) {
        const child = this.children[i2];
        if (!child)
          continue;
        removed.push(child);
        child.parent = null;
      }
      removeItems(this.children, beginIndex, end);
      const renderGroup = this.renderGroup || this.parentRenderGroup;
      if (renderGroup) {
        renderGroup.removeChildren(removed);
      }
      for (let i2 = 0; i2 < removed.length; ++i2) {
        this.emit("childRemoved", removed[i2], this, i2);
        removed[i2].emit("removed", this);
      }
      return removed;
    } else if (range === 0 && this.children.length === 0) {
      return removed;
    }
    throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
  },
  /**
   * Removes a child from the specified index position.
   * @param index - The index to get the child from
   * @returns The child that was removed.
   * @memberof scene.Container#
   */
  removeChildAt(index) {
    const child = this.getChildAt(index);
    return this.removeChild(child);
  },
  /**
   * Returns the child at the specified index
   * @param index - The index to get the child at
   * @returns - The child at the given index, if any.
   * @memberof scene.Container#
   */
  getChildAt(index) {
    if (index < 0 || index >= this.children.length) {
      throw new Error(`getChildAt: Index (${index}) does not exist.`);
    }
    return this.children[index];
  },
  /**
   * Changes the position of an existing child in the container
   * @param child - The child Container instance for which you want to change the index number
   * @param index - The resulting index number for the child container
   * @memberof scene.Container#
   */
  setChildIndex(child, index) {
    if (index < 0 || index >= this.children.length) {
      throw new Error(`The index ${index} supplied is out of bounds ${this.children.length}`);
    }
    this.getChildIndex(child);
    this.addChildAt(child, index);
  },
  /**
   * Returns the index position of a child Container instance
   * @param child - The Container instance to identify
   * @returns - The index position of the child container to identify
   * @memberof scene.Container#
   */
  getChildIndex(child) {
    const index = this.children.indexOf(child);
    if (index === -1) {
      throw new Error("The supplied Container must be a child of the caller");
    }
    return index;
  },
  /**
   * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown.
   * If the child is already in this container, it will be moved to the specified index.
   * @param {Container} child - The child to add.
   * @param {number} index - The absolute index where the child will be positioned at the end of the operation.
   * @returns {Container} The child that was added.
   * @memberof scene.Container#
   */
  addChildAt(child, index) {
    if (!this.allowChildren) {
      deprecation(v8_0_0, "addChildAt: Only Containers will be allowed to add children in v8.0.0");
    }
    const { children } = this;
    if (index < 0 || index > children.length) {
      throw new Error(`${child}addChildAt: The index ${index} supplied is out of bounds ${children.length}`);
    }
    if (child.parent) {
      const currentIndex = child.parent.children.indexOf(child);
      if (child.parent === this && currentIndex === index) {
        return child;
      }
      if (currentIndex !== -1) {
        child.parent.children.splice(currentIndex, 1);
      }
    }
    if (index === children.length) {
      children.push(child);
    } else {
      children.splice(index, 0, child);
    }
    child.parent = this;
    child.didChange = true;
    child._updateFlags = 15;
    const renderGroup = this.renderGroup || this.parentRenderGroup;
    if (renderGroup) {
      renderGroup.addChild(child);
    }
    if (this.sortableChildren)
      this.sortDirty = true;
    this.emit("childAdded", child, this, index);
    child.emit("added", this);
    return child;
  },
  /**
   * Swaps the position of 2 Containers within this container.
   * @param child - First container to swap
   * @param child2 - Second container to swap
   * @memberof scene.Container#
   */
  swapChildren(child, child2) {
    if (child === child2) {
      return;
    }
    const index1 = this.getChildIndex(child);
    const index2 = this.getChildIndex(child2);
    this.children[index1] = child2;
    this.children[index2] = child;
    const renderGroup = this.renderGroup || this.parentRenderGroup;
    if (renderGroup) {
      renderGroup.structureDidChange = true;
    }
    this._didContainerChangeTick++;
  },
  /**
   * Remove the Container from its parent Container. If the Container has no parent, do nothing.
   * @memberof scene.Container#
   */
  removeFromParent() {
    this.parent?.removeChild(this);
  },
  /**
   * Reparent the child to this container, keeping the same worldTransform.
   * @param child - The child to reparent
   * @returns The first child that was reparented.
   * @memberof scene.Container#
   */
  reparentChild(...child) {
    if (child.length === 1) {
      return this.reparentChildAt(child[0], this.children.length);
    }
    child.forEach((c2) => this.reparentChildAt(c2, this.children.length));
    return child[0];
  },
  /**
   * Reparent the child to this container at the specified index, keeping the same worldTransform.
   * @param child - The child to reparent
   * @param index - The index to reparent the child to
   * @memberof scene.Container#
   */
  reparentChildAt(child, index) {
    if (child.parent === this) {
      this.setChildIndex(child, index);
      return child;
    }
    const childMat = child.worldTransform.clone();
    child.removeFromParent();
    this.addChildAt(child, index);
    const newMatrix = this.worldTransform.clone();
    newMatrix.invert();
    childMat.prepend(newMatrix);
    child.setFromMatrix(childMat);
    return child;
  }
};
const collectRenderablesMixin = {
  /**
   * Main method to collect renderables from the container and its children.
   * It checks the container's properties to decide whether to use a simple or advanced collection method.
   * @param {InstructionSet} instructionSet - The set of instructions to which the renderables will be added.
   * @param {Renderer} renderer - The renderer responsible for rendering the scene.
   * @param {IRenderLayer} currentLayer - The current render layer being processed.
   * @memberof scene.Container#
   */
  collectRenderables(instructionSet, renderer, currentLayer) {
    if (this.parentRenderLayer && this.parentRenderLayer !== currentLayer || this.globalDisplayStatus < 7 || !this.includeInBuild)
      return;
    if (this.sortableChildren) {
      this.sortChildren();
    }
    if (this.isSimple) {
      this.collectRenderablesSimple(instructionSet, renderer, currentLayer);
    } else if (this.renderGroup) {
      renderer.renderPipes.renderGroup.addRenderGroup(this.renderGroup, instructionSet);
    } else {
      this.collectRenderablesWithEffects(instructionSet, renderer, currentLayer);
    }
  },
  /**
   * Simple method for collecting renderables from the container's children.
   * This method is efficient and used when the container is marked as simple.
   * @param {InstructionSet} instructionSet - The set of instructions to which the renderables will be added.
   * @param {Renderer} renderer - The renderer responsible for rendering the scene.
   * @param {IRenderLayer} currentLayer - The current render layer being processed.
   * @memberof scene.Container#
   */
  collectRenderablesSimple(instructionSet, renderer, currentLayer) {
    const children = this.children;
    const length2 = children.length;
    for (let i2 = 0; i2 < length2; i2++) {
      children[i2].collectRenderables(instructionSet, renderer, currentLayer);
    }
  },
  /**
   * Advanced method for collecting renderables, which handles additional effects.
   * This method is used when the container has complex processing needs.
   * @param {InstructionSet} instructionSet - The set of instructions to which the renderables will be added.
   * @param {Renderer} renderer - The renderer responsible for rendering the scene.
   * @param {IRenderLayer} currentLayer - The current render layer being processed.
   * @memberof scene.Container#
   */
  collectRenderablesWithEffects(instructionSet, renderer, currentLayer) {
    const { renderPipes } = renderer;
    for (let i2 = 0; i2 < this.effects.length; i2++) {
      const effect = this.effects[i2];
      const pipe = renderPipes[effect.pipe];
      pipe.push(effect, this, instructionSet);
    }
    this.collectRenderablesSimple(instructionSet, renderer, currentLayer);
    for (let i2 = this.effects.length - 1; i2 >= 0; i2--) {
      const effect = this.effects[i2];
      const pipe = renderPipes[effect.pipe];
      pipe.pop(effect, this, instructionSet);
    }
  }
};
class FilterEffect {
  constructor() {
    this.pipe = "filter";
    this.priority = 1;
  }
  destroy() {
    for (let i2 = 0; i2 < this.filters.length; i2++) {
      this.filters[i2].destroy();
    }
    this.filters = null;
    this.filterArea = null;
  }
}
class MaskEffectManagerClass {
  constructor() {
    this._effectClasses = [];
    this._tests = [];
    this._initialized = false;
  }
  init() {
    if (this._initialized)
      return;
    this._initialized = true;
    this._effectClasses.forEach((test) => {
      this.add({
        test: test.test,
        maskClass: test
      });
    });
  }
  add(test) {
    this._tests.push(test);
  }
  getMaskEffect(item) {
    if (!this._initialized)
      this.init();
    for (let i2 = 0; i2 < this._tests.length; i2++) {
      const test = this._tests[i2];
      if (test.test(item)) {
        return BigPool.get(test.maskClass, item);
      }
    }
    return item;
  }
  returnMaskEffect(effect) {
    BigPool.return(effect);
  }
}
const MaskEffectManager = new MaskEffectManagerClass();
extensions.handleByList(ExtensionType.MaskEffect, MaskEffectManager._effectClasses);
const effectsMixin = {
  _maskEffect: null,
  _maskOptions: {
    inverse: false
  },
  _filterEffect: null,
  /**
   * @todo Needs docs.
   * @memberof scene.Container#
   * @type {Array<Effect>}
   */
  effects: [],
  _markStructureAsChanged() {
    const renderGroup = this.renderGroup || this.parentRenderGroup;
    if (renderGroup) {
      renderGroup.structureDidChange = true;
    }
  },
  /**
   * @todo Needs docs.
   * @param effect - The effect to add.
   * @memberof scene.Container#
   * @ignore
   */
  addEffect(effect) {
    const index = this.effects.indexOf(effect);
    if (index !== -1)
      return;
    this.effects.push(effect);
    this.effects.sort((a2, b2) => a2.priority - b2.priority);
    this._markStructureAsChanged();
    this._updateIsSimple();
  },
  /**
   * @todo Needs docs.
   * @param effect - The effect to remove.
   * @memberof scene.Container#
   * @ignore
   */
  removeEffect(effect) {
    const index = this.effects.indexOf(effect);
    if (index === -1)
      return;
    this.effects.splice(index, 1);
    this._markStructureAsChanged();
    this._updateIsSimple();
  },
  set mask(value) {
    const effect = this._maskEffect;
    if (effect?.mask === value)
      return;
    if (effect) {
      this.removeEffect(effect);
      MaskEffectManager.returnMaskEffect(effect);
      this._maskEffect = null;
    }
    if (value === null || value === void 0)
      return;
    this._maskEffect = MaskEffectManager.getMaskEffect(value);
    this.addEffect(this._maskEffect);
  },
  /**
   * Used to set mask and control mask options.
   * @param options
   * @example
   * import { Graphics, Sprite } from 'pixi.js';
   *
   * const graphics = new Graphics();
   * graphics.beginFill(0xFF3300);
   * graphics.drawRect(50, 250, 100, 100);
   * graphics.endFill();
   *
   * const sprite = new Sprite(texture);
   * sprite.setMask({
   *     mask: graphics,
   *     inverse: true,
   * });
   * @memberof scene.Container#
   */
  setMask(options) {
    this._maskOptions = {
      ...this._maskOptions,
      ...options
    };
    if (options.mask) {
      this.mask = options.mask;
    }
    this._markStructureAsChanged();
  },
  /**
   * Sets a mask for the displayObject. A mask is an object that limits the visibility of an
   * object to the shape of the mask applied to it. In PixiJS a regular mask must be a
   * {@link Graphics} or a {@link Sprite} object. This allows for much faster masking in canvas as it
   * utilities shape clipping. Furthermore, a mask of an object must be in the subtree of its parent.
   * Otherwise, `getLocalBounds` may calculate incorrect bounds, which makes the container's width and height wrong.
   * To remove a mask, set this property to `null`.
   *
   * For sprite mask both alpha and red channel are used. Black mask is the same as transparent mask.
   * @example
   * import { Graphics, Sprite } from 'pixi.js';
   *
   * const graphics = new Graphics();
   * graphics.beginFill(0xFF3300);
   * graphics.drawRect(50, 250, 100, 100);
   * graphics.endFill();
   *
   * const sprite = new Sprite(texture);
   * sprite.mask = graphics;
   * @memberof scene.Container#
   */
  get mask() {
    return this._maskEffect?.mask;
  },
  set filters(value) {
    if (!Array.isArray(value) && value)
      value = [value];
    const effect = this._filterEffect || (this._filterEffect = new FilterEffect());
    value = value;
    const hasFilters = value?.length > 0;
    const hadFilters = effect.filters?.length > 0;
    const didChange = hasFilters !== hadFilters;
    value = Array.isArray(value) ? value.slice(0) : value;
    effect.filters = Object.freeze(value);
    if (didChange) {
      if (hasFilters) {
        this.addEffect(effect);
      } else {
        this.removeEffect(effect);
        effect.filters = value ?? null;
      }
    }
  },
  /**
   * Sets the filters for the displayObject.
   * IMPORTANT: This is a WebGL only feature and will be ignored by the canvas renderer.
   * To remove filters simply set this property to `'null'`.
   * @memberof scene.Container#
   */
  get filters() {
    return this._filterEffect?.filters;
  },
  set filterArea(value) {
    this._filterEffect || (this._filterEffect = new FilterEffect());
    this._filterEffect.filterArea = value;
  },
  /**
   * The area the filter is applied to. This is used as more of an optimization
   * rather than figuring out the dimensions of the displayObject each frame you can set this rectangle.
   *
   * Also works as an interaction mask.
   * @memberof scene.Container#
   */
  get filterArea() {
    return this._filterEffect?.filterArea;
  }
};
const findMixin = {
  /**
   * The instance label of the object.
   * @memberof scene.Container#
   * @member {string} label
   */
  label: null,
  /**
   * The instance name of the object.
   * @deprecated since 8.0.0
   * @see scene.Container#label
   * @member {string} name
   * @memberof scene.Container#
   */
  get name() {
    deprecation(v8_0_0, "Container.name property has been removed, use Container.label instead");
    return this.label;
  },
  set name(value) {
    deprecation(v8_0_0, "Container.name property has been removed, use Container.label instead");
    this.label = value;
  },
  /**
   * @method getChildByName
   * @deprecated since 8.0.0
   * @param {string} name - Instance name.
   * @param {boolean}[deep=false] - Whether to search recursively
   * @returns {Container} The child with the specified name.
   * @see scene.Container#getChildByLabel
   * @memberof scene.Container#
   */
  getChildByName(name, deep = false) {
    return this.getChildByLabel(name, deep);
  },
  /**
   * Returns the first child in the container with the specified label.
   *
   * Recursive searches are done in a pre-order traversal.
   * @memberof scene.Container#
   * @param {string|RegExp} label - Instance label.
   * @param {boolean}[deep=false] - Whether to search recursively
   * @returns {Container} The child with the specified label.
   */
  getChildByLabel(label, deep = false) {
    const children = this.children;
    for (let i2 = 0; i2 < children.length; i2++) {
      const child = children[i2];
      if (child.label === label || label instanceof RegExp && label.test(child.label))
        return child;
    }
    if (deep) {
      for (let i2 = 0; i2 < children.length; i2++) {
        const child = children[i2];
        const found = child.getChildByLabel(label, true);
        if (found) {
          return found;
        }
      }
    }
    return null;
  },
  /**
   * Returns all children in the container with the specified label.
   * @memberof scene.Container#
   * @param {string|RegExp} label - Instance label.
   * @param {boolean}[deep=false] - Whether to search recursively
   * @param {Container[]} [out=[]] - The array to store matching children in.
   * @returns {Container[]} An array of children with the specified label.
   */
  getChildrenByLabel(label, deep = false, out2 = []) {
    const children = this.children;
    for (let i2 = 0; i2 < children.length; i2++) {
      const child = children[i2];
      if (child.label === label || label instanceof RegExp && label.test(child.label)) {
        out2.push(child);
      }
    }
    if (deep) {
      for (let i2 = 0; i2 < children.length; i2++) {
        children[i2].getChildrenByLabel(label, true, out2);
      }
    }
    return out2;
  }
};
const matrixPool = new Pool(Matrix);
const boundsPool = new Pool(Bounds);
const tempMatrix$2 = new Matrix();
const getFastGlobalBoundsMixin = {
  /**
   * Computes the global bounds for the container, considering its children and optionally
   * factoring in render layers. It starts by clearing the provided bounds object, then
   * recursively calculates the bounds, and finally applies the world transformation.
   * @param {boolean} [factorRenderLayers] - Whether to consider render layers in the calculation.
   * @param {Bounds} [bounds] - The bounds object to store the result. If not provided, a new one is created.
   * @returns {Bounds} The computed bounds.
   * @memberof scene.Container#
   */
  getFastGlobalBounds(factorRenderLayers, bounds) {
    bounds || (bounds = new Bounds());
    bounds.clear();
    this._getGlobalBoundsRecursive(!!factorRenderLayers, bounds, this.parentRenderLayer);
    if (!bounds.isValid) {
      bounds.set(0, 0, 0, 0);
    }
    const renderGroup = this.renderGroup || this.parentRenderGroup;
    bounds.applyMatrix(renderGroup.worldTransform);
    return bounds;
  },
  /**
   * Recursively calculates the global bounds for the container and its children.
   * It considers visibility, measurability, and effects, and applies transformations
   * as necessary to compute the bounds accurately.
   * @param {boolean} factorRenderLayers - Whether to consider render layers in the calculation.
   * @param {Bounds} bounds - The bounds object to update with the calculated values.
   * @param {IRenderLayer} currentLayer - The current render layer being processed.
   * @memberof scene.Container#
   */
  _getGlobalBoundsRecursive(factorRenderLayers, bounds, currentLayer) {
    let localBounds = bounds;
    if (factorRenderLayers && this.parentRenderLayer !== currentLayer)
      return;
    if (this.localDisplayStatus !== 7 || !this.measurable) {
      return;
    }
    const manageEffects = !!this.effects.length;
    if (this.renderGroup || manageEffects) {
      localBounds = boundsPool.get().clear();
    }
    if (this.boundsArea) {
      bounds.addRect(this.boundsArea, this.worldTransform);
    } else {
      if (this.renderPipeId) {
        const viewBounds = this.bounds;
        localBounds.addFrame(
          viewBounds.minX,
          viewBounds.minY,
          viewBounds.maxX,
          viewBounds.maxY,
          this.groupTransform
        );
      }
      const children = this.children;
      for (let i2 = 0; i2 < children.length; i2++) {
        children[i2]._getGlobalBoundsRecursive(factorRenderLayers, localBounds, currentLayer);
      }
    }
    if (manageEffects) {
      let advanced = false;
      const renderGroup = this.renderGroup || this.parentRenderGroup;
      for (let i2 = 0; i2 < this.effects.length; i2++) {
        if (this.effects[i2].addBounds) {
          if (!advanced) {
            advanced = true;
            localBounds.applyMatrix(renderGroup.worldTransform);
          }
          this.effects[i2].addBounds(localBounds, true);
        }
      }
      if (advanced) {
        localBounds.applyMatrix(renderGroup.worldTransform.copyTo(tempMatrix$2).invert());
        bounds.addBounds(localBounds, this.relativeGroupTransform);
      }
      bounds.addBounds(localBounds);
      boundsPool.return(localBounds);
    } else if (this.renderGroup) {
      bounds.addBounds(localBounds, this.relativeGroupTransform);
      boundsPool.return(localBounds);
    }
  }
};
function getGlobalBounds(target, skipUpdateTransform, bounds) {
  bounds.clear();
  let parentTransform;
  let pooledMatrix;
  if (target.parent) {
    if (!skipUpdateTransform) {
      pooledMatrix = matrixPool.get().identity();
      parentTransform = updateTransformBackwards(target, pooledMatrix);
    } else {
      parentTransform = target.parent.worldTransform;
    }
  } else {
    parentTransform = Matrix.IDENTITY;
  }
  _getGlobalBounds(target, bounds, parentTransform, skipUpdateTransform);
  if (pooledMatrix) {
    matrixPool.return(pooledMatrix);
  }
  if (!bounds.isValid) {
    bounds.set(0, 0, 0, 0);
  }
  return bounds;
}
function _getGlobalBounds(target, bounds, parentTransform, skipUpdateTransform) {
  if (!target.visible || !target.measurable)
    return;
  let worldTransform;
  if (!skipUpdateTransform) {
    target.updateLocalTransform();
    worldTransform = matrixPool.get();
    worldTransform.appendFrom(target.localTransform, parentTransform);
  } else {
    worldTransform = target.worldTransform;
  }
  const parentBounds = bounds;
  const preserveBounds = !!target.effects.length;
  if (preserveBounds) {
    bounds = boundsPool.get().clear();
  }
  if (target.boundsArea) {
    bounds.addRect(target.boundsArea, worldTransform);
  } else {
    if (target.bounds) {
      bounds.matrix = worldTransform;
      bounds.addBounds(target.bounds);
    }
    for (let i2 = 0; i2 < target.children.length; i2++) {
      _getGlobalBounds(target.children[i2], bounds, worldTransform, skipUpdateTransform);
    }
  }
  if (preserveBounds) {
    for (let i2 = 0; i2 < target.effects.length; i2++) {
      target.effects[i2].addBounds?.(bounds);
    }
    parentBounds.addBounds(bounds, Matrix.IDENTITY);
    boundsPool.return(bounds);
  }
  if (!skipUpdateTransform) {
    matrixPool.return(worldTransform);
  }
}
function updateTransformBackwards(target, parentTransform) {
  const parent = target.parent;
  if (parent) {
    updateTransformBackwards(parent, parentTransform);
    parent.updateLocalTransform();
    parentTransform.append(parent.localTransform);
  }
  return parentTransform;
}
function multiplyHexColors(color1, color2) {
  if (color1 === 16777215 || !color2)
    return color2;
  if (color2 === 16777215 || !color1)
    return color1;
  const r1 = color1 >> 16 & 255;
  const g1 = color1 >> 8 & 255;
  const b1 = color1 & 255;
  const r2 = color2 >> 16 & 255;
  const g2 = color2 >> 8 & 255;
  const b2 = color2 & 255;
  const r3 = r1 * r2 / 255 | 0;
  const g3 = g1 * g2 / 255 | 0;
  const b3 = b1 * b2 / 255 | 0;
  return (r3 << 16) + (g3 << 8) + b3;
}
const WHITE_BGR = 16777215;
function multiplyColors(localBGRColor, parentBGRColor) {
  if (localBGRColor === WHITE_BGR) {
    return parentBGRColor;
  }
  if (parentBGRColor === WHITE_BGR) {
    return localBGRColor;
  }
  return multiplyHexColors(localBGRColor, parentBGRColor);
}
function bgr2rgb(color) {
  return ((color & 255) << 16) + (color & 65280) + (color >> 16 & 255);
}
const getGlobalMixin = {
  /**
   * Returns the global (compound) alpha of the container within the scene.
   * @param skipUpdate - Performance optimization flag:
   *   - If false (default): Recalculates the entire alpha chain through parents for accuracy
   *   - If true: Uses cached worldAlpha from the last render pass for better performance
   * @returns The resulting alpha value (between 0 and 1)
   * @example
   * // Accurate but slower - recalculates entire alpha chain
   * const preciseAlpha = container.getGlobalAlpha();
   *
   * // Faster but may be outdated - uses cached alpha
   * const cachedAlpha = container.getGlobalAlpha(true);
   */
  getGlobalAlpha(skipUpdate) {
    if (skipUpdate) {
      if (this.renderGroup) {
        return this.renderGroup.worldAlpha;
      }
      if (this.parentRenderGroup) {
        return this.parentRenderGroup.worldAlpha * this.alpha;
      }
      return this.alpha;
    }
    let alpha = this.alpha;
    let current = this.parent;
    while (current) {
      alpha *= current.alpha;
      current = current.parent;
    }
    return alpha;
  },
  /**
   * Returns the global transform matrix of the container within the scene.
   * @param matrix - Optional matrix to store the result. If not provided, a new Matrix will be created.
   * @param skipUpdate - Performance optimization flag:
   *   - If false (default): Recalculates the entire transform chain for accuracy
   *   - If true: Uses cached worldTransform from the last render pass for better performance
   * @returns The resulting transformation matrix (either the input matrix or a new one)
   * @example
   * // Accurate but slower - recalculates entire transform chain
   * const preciseTransform = container.getGlobalTransform();
   *
   * // Faster but may be outdated - uses cached transform
   * const cachedTransform = container.getGlobalTransform(undefined, true);
   *
   * // Reuse existing matrix
   * const existingMatrix = new Matrix();
   * container.getGlobalTransform(existingMatrix);
   */
  getGlobalTransform(matrix, skipUpdate) {
    if (skipUpdate) {
      return matrix.copyFrom(this.worldTransform);
    }
    this.updateLocalTransform();
    const parentTransform = updateTransformBackwards(this, matrixPool.get().identity());
    matrix.appendFrom(this.localTransform, parentTransform);
    matrixPool.return(parentTransform);
    return matrix;
  },
  /**
   * Returns the global (compound) tint color of the container within the scene.
   * @param skipUpdate - Performance optimization flag:
   *   - If false (default): Recalculates the entire tint chain through parents for accuracy
   *   - If true: Uses cached worldColor from the last render pass for better performance
   * @returns The resulting tint color as a 24-bit RGB number (0xRRGGBB)
   * @example
   * // Accurate but slower - recalculates entire tint chain
   * const preciseTint = container.getGlobalTint();
   *
   * // Faster but may be outdated - uses cached tint
   * const cachedTint = container.getGlobalTint(true);
   */
  getGlobalTint(skipUpdate) {
    if (skipUpdate) {
      if (this.renderGroup) {
        return bgr2rgb(this.renderGroup.worldColor);
      }
      if (this.parentRenderGroup) {
        return bgr2rgb(
          multiplyColors(this.localColor, this.parentRenderGroup.worldColor)
        );
      }
      return this.tint;
    }
    let color = this.localColor;
    let parent = this.parent;
    while (parent) {
      color = multiplyColors(color, parent.localColor);
      parent = parent.parent;
    }
    return bgr2rgb(color);
  }
};
let warnCount = 0;
const maxWarnings = 500;
function warn(...args) {
  if (warnCount === maxWarnings)
    return;
  warnCount++;
  if (warnCount === maxWarnings) {
    console.warn("PixiJS Warning: too many warnings, no more warnings will be reported to the console by PixiJS.");
  } else {
    console.warn("PixiJS Warning: ", ...args);
  }
}
function getLocalBounds(target, bounds, relativeMatrix) {
  bounds.clear();
  relativeMatrix || (relativeMatrix = Matrix.IDENTITY);
  _getLocalBounds(target, bounds, relativeMatrix, target, true);
  if (!bounds.isValid) {
    bounds.set(0, 0, 0, 0);
  }
  return bounds;
}
function _getLocalBounds(target, bounds, parentTransform, rootContainer, isRoot) {
  let relativeTransform;
  if (!isRoot) {
    if (!target.visible || !target.measurable)
      return;
    target.updateLocalTransform();
    const localTransform = target.localTransform;
    relativeTransform = matrixPool.get();
    relativeTransform.appendFrom(localTransform, parentTransform);
  } else {
    relativeTransform = matrixPool.get();
    relativeTransform = parentTransform.copyTo(relativeTransform);
  }
  const parentBounds = bounds;
  const preserveBounds = !!target.effects.length;
  if (preserveBounds) {
    bounds = boundsPool.get().clear();
  }
  if (target.boundsArea) {
    bounds.addRect(target.boundsArea, relativeTransform);
  } else {
    if (target.renderPipeId) {
      bounds.matrix = relativeTransform;
      bounds.addBounds(target.bounds);
    }
    const children = target.children;
    for (let i2 = 0; i2 < children.length; i2++) {
      _getLocalBounds(children[i2], bounds, relativeTransform, rootContainer, false);
    }
  }
  if (preserveBounds) {
    for (let i2 = 0; i2 < target.effects.length; i2++) {
      target.effects[i2].addLocalBounds?.(bounds, rootContainer);
    }
    parentBounds.addBounds(bounds, Matrix.IDENTITY);
    boundsPool.return(bounds);
  }
  matrixPool.return(relativeTransform);
}
function checkChildrenDidChange(container, previousData) {
  const children = container.children;
  for (let i2 = 0; i2 < children.length; i2++) {
    const child = children[i2];
    const uid2 = child.uid;
    const didChange = (child._didViewChangeTick & 65535) << 16 | child._didContainerChangeTick & 65535;
    const index = previousData.index;
    if (previousData.data[index] !== uid2 || previousData.data[index + 1] !== didChange) {
      previousData.data[previousData.index] = uid2;
      previousData.data[previousData.index + 1] = didChange;
      previousData.didChange = true;
    }
    previousData.index = index + 2;
    if (child.children.length) {
      checkChildrenDidChange(child, previousData);
    }
  }
  return previousData.didChange;
}
const tempMatrix$1 = new Matrix();
const measureMixin = {
  _localBoundsCacheId: -1,
  _localBoundsCacheData: null,
  _setWidth(value, localWidth) {
    const sign2 = Math.sign(this.scale.x) || 1;
    if (localWidth !== 0) {
      this.scale.x = value / localWidth * sign2;
    } else {
      this.scale.x = sign2;
    }
  },
  _setHeight(value, localHeight) {
    const sign2 = Math.sign(this.scale.y) || 1;
    if (localHeight !== 0) {
      this.scale.y = value / localHeight * sign2;
    } else {
      this.scale.y = sign2;
    }
  },
  /**
   * Retrieves the local bounds of the container as a Bounds object.
   * @returns - The bounding area.
   * @memberof scene.Container#
   */
  getLocalBounds() {
    if (!this._localBoundsCacheData) {
      this._localBoundsCacheData = {
        data: [],
        index: 1,
        didChange: false,
        localBounds: new Bounds()
      };
    }
    const localBoundsCacheData = this._localBoundsCacheData;
    localBoundsCacheData.index = 1;
    localBoundsCacheData.didChange = false;
    if (localBoundsCacheData.data[0] !== this._didViewChangeTick) {
      localBoundsCacheData.didChange = true;
      localBoundsCacheData.data[0] = this._didViewChangeTick;
    }
    checkChildrenDidChange(this, localBoundsCacheData);
    if (localBoundsCacheData.didChange) {
      getLocalBounds(this, localBoundsCacheData.localBounds, tempMatrix$1);
    }
    return localBoundsCacheData.localBounds;
  },
  /**
   * Calculates and returns the (world) bounds of the display object as a [Rectangle]{@link Rectangle}.
   * @param skipUpdate - Setting to `true` will stop the transforms of the scene graph from
   *  being updated. This means the calculation returned MAY be out of date BUT will give you a
   *  nice performance boost.
   * @param bounds - Optional bounds to store the result of the bounds calculation.
   * @returns - The minimum axis-aligned rectangle in world space that fits around this object.
   * @memberof scene.Container#
   */
  getBounds(skipUpdate, bounds) {
    return getGlobalBounds(this, skipUpdate, bounds || new Bounds());
  }
};
const onRenderMixin = {
  _onRender: null,
  set onRender(func) {
    const renderGroup = this.renderGroup || this.parentRenderGroup;
    if (!func) {
      if (this._onRender) {
        renderGroup?.removeOnRender(this);
      }
      this._onRender = null;
      return;
    }
    if (!this._onRender) {
      renderGroup?.addOnRender(this);
    }
    this._onRender = func;
  },
  /**
   * This callback is used when the container is rendered. This is where you should add your custom
   * logic that is needed to be run every frame.
   *
   * In v7 many users used `updateTransform` for this, however the way v8 renders objects is different
   * and "updateTransform" is no longer called every frame
   * @example
   * const container = new Container();
   * container.onRender = () => {
   *    container.rotation += 0.01;
   * };
   * @memberof scene.Container#
   */
  get onRender() {
    return this._onRender;
  }
};
const sortMixin = {
  _zIndex: 0,
  /**
   * Should children be sorted by zIndex at the next render call.
   *
   * Will get automatically set to true if a new child is added, or if a child's zIndex changes.
   * @type {boolean}
   * @memberof scene.Container#
   */
  sortDirty: false,
  /**
   * If set to true, the container will sort its children by `zIndex` value
   * when the next render is called, or manually if `sortChildren()` is called.
   *
   * This actually changes the order of elements in the array, so should be treated
   * as a basic solution that is not performant compared to other solutions,
   * such as {@link https://github.com/pixijs/layers PixiJS Layers}
   *
   * Also be aware of that this may not work nicely with the `addChildAt()` function,
   * as the `zIndex` sorting may cause the child to automatically sorted to another position.
   * @type {boolean}
   * @memberof scene.Container#
   */
  sortableChildren: false,
  /**
   * The zIndex of the container.
   *
   * Setting this value, will automatically set the parent to be sortable. Children will be automatically
   * sorted by zIndex value; a higher value will mean it will be moved towards the end of the array,
   * and thus rendered on top of other display objects within the same container.
   * @see scene.Container#sortableChildren
   * @memberof scene.Container#
   */
  get zIndex() {
    return this._zIndex;
  },
  set zIndex(value) {
    if (this._zIndex === value)
      return;
    this._zIndex = value;
    this.depthOfChildModified();
  },
  depthOfChildModified() {
    if (this.parent) {
      this.parent.sortableChildren = true;
      this.parent.sortDirty = true;
    }
    if (this.parentRenderGroup) {
      this.parentRenderGroup.structureDidChange = true;
    }
  },
  /**
   * Sorts children by zIndex.
   * @memberof scene.Container#
   */
  sortChildren() {
    if (!this.sortDirty)
      return;
    this.sortDirty = false;
    this.children.sort(sortChildren);
  }
};
function sortChildren(a2, b2) {
  return a2._zIndex - b2._zIndex;
}
const toLocalGlobalMixin = {
  /**
   * Returns the global position of the container.
   * @param point - The optional point to write the global value to.
   * @param skipUpdate - Should we skip the update transform.
   * @returns - The updated point.
   * @memberof scene.Container#
   */
  getGlobalPosition(point = new Point(), skipUpdate = false) {
    if (this.parent) {
      this.parent.toGlobal(this._position, point, skipUpdate);
    } else {
      point.x = this._position.x;
      point.y = this._position.y;
    }
    return point;
  },
  /**
   * Calculates the global position of the container.
   * @param position - The world origin to calculate from.
   * @param point - A Point object in which to store the value, optional
   *  (otherwise will create a new Point).
   * @param skipUpdate - Should we skip the update transform.
   * @returns - A point object representing the position of this object.
   * @memberof scene.Container#
   */
  toGlobal(position, point, skipUpdate = false) {
    const globalMatrix = this.getGlobalTransform(matrixPool.get(), skipUpdate);
    point = globalMatrix.apply(position, point);
    matrixPool.return(globalMatrix);
    return point;
  },
  /**
   * Calculates the local position of the container relative to another point.
   * @param position - The world origin to calculate from.
   * @param from - The Container to calculate the global position from.
   * @param point - A Point object in which to store the value, optional
   *  (otherwise will create a new Point).
   * @param skipUpdate - Should we skip the update transform
   * @returns - A point object representing the position of this object
   * @memberof scene.Container#
   */
  toLocal(position, from, point, skipUpdate) {
    if (from) {
      position = from.toGlobal(position, point, skipUpdate);
    }
    const globalMatrix = this.getGlobalTransform(matrixPool.get(), skipUpdate);
    point = globalMatrix.applyInverse(position, point);
    matrixPool.return(globalMatrix);
    return point;
  }
};
class InstructionSet {
  constructor() {
    this.uid = uid("instructionSet");
    this.instructions = [];
    this.instructionSize = 0;
    this.renderables = [];
    this.gcTick = 0;
  }
  /** reset the instruction set so it can be reused set size back to 0 */
  reset() {
    this.instructionSize = 0;
  }
  /**
   * Add an instruction to the set
   * @param instruction - add an instruction to the set
   */
  add(instruction) {
    this.instructions[this.instructionSize++] = instruction;
  }
  /**
   * Log the instructions to the console (for debugging)
   * @internal
   * @ignore
   */
  log() {
    this.instructions.length = this.instructionSize;
    console.table(this.instructions, ["type", "action"]);
  }
}
let count = 0;
class TexturePoolClass {
  /**
   * @param textureOptions - options that will be passed to BaseRenderTexture constructor
   * @param {SCALE_MODE} [textureOptions.scaleMode] - See {@link SCALE_MODE} for possible values.
   */
  constructor(textureOptions) {
    this._poolKeyHash = /* @__PURE__ */ Object.create(null);
    this._texturePool = {};
    this.textureOptions = textureOptions || {};
    this.enableFullScreen = false;
  }
  /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   * @param antialias
   */
  createTexture(pixelWidth, pixelHeight, antialias) {
    const textureSource = new TextureSource({
      ...this.textureOptions,
      width: pixelWidth,
      height: pixelHeight,
      resolution: 1,
      antialias,
      autoGarbageCollect: false
    });
    return new Texture({
      source: textureSource,
      label: `texturePool_${count++}`
    });
  }
  /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param frameWidth - The minimum width of the render texture.
   * @param frameHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @param antialias
   * @returns The new render texture.
   */
  getOptimalTexture(frameWidth, frameHeight, resolution = 1, antialias) {
    let po2Width = Math.ceil(frameWidth * resolution - 1e-6);
    let po2Height = Math.ceil(frameHeight * resolution - 1e-6);
    po2Width = nextPow2(po2Width);
    po2Height = nextPow2(po2Height);
    const key = (po2Width << 17) + (po2Height << 1) + (antialias ? 1 : 0);
    if (!this._texturePool[key]) {
      this._texturePool[key] = [];
    }
    let texture = this._texturePool[key].pop();
    if (!texture) {
      texture = this.createTexture(po2Width, po2Height, antialias);
    }
    texture.source._resolution = resolution;
    texture.source.width = po2Width / resolution;
    texture.source.height = po2Height / resolution;
    texture.source.pixelWidth = po2Width;
    texture.source.pixelHeight = po2Height;
    texture.frame.x = 0;
    texture.frame.y = 0;
    texture.frame.width = frameWidth;
    texture.frame.height = frameHeight;
    texture.updateUvs();
    this._poolKeyHash[texture.uid] = key;
    return texture;
  }
  /**
   * Gets extra texture of the same size as input renderTexture
   * @param texture - The texture to check what size it is.
   * @param antialias - Whether to use antialias.
   * @returns A texture that is a power of two
   */
  getSameSizeTexture(texture, antialias = false) {
    const source2 = texture.source;
    return this.getOptimalTexture(texture.width, texture.height, source2._resolution, antialias);
  }
  /**
   * Place a render texture back into the pool.
   * @param renderTexture - The renderTexture to free
   */
  returnTexture(renderTexture) {
    const key = this._poolKeyHash[renderTexture.uid];
    this._texturePool[key].push(renderTexture);
  }
  /**
   * Clears the pool.
   * @param destroyTextures - Destroy all stored textures.
   */
  clear(destroyTextures) {
    destroyTextures = destroyTextures !== false;
    if (destroyTextures) {
      for (const i2 in this._texturePool) {
        const textures = this._texturePool[i2];
        if (textures) {
          for (let j2 = 0; j2 < textures.length; j2++) {
            textures[j2].destroy(true);
          }
        }
      }
    }
    this._texturePool = {};
  }
}
const TexturePool = new TexturePoolClass();
class RenderGroup {
  constructor() {
    this.renderPipeId = "renderGroup";
    this.root = null;
    this.canBundle = false;
    this.renderGroupParent = null;
    this.renderGroupChildren = [];
    this.worldTransform = new Matrix();
    this.worldColorAlpha = 4294967295;
    this.worldColor = 16777215;
    this.worldAlpha = 1;
    this.childrenToUpdate = /* @__PURE__ */ Object.create(null);
    this.updateTick = 0;
    this.gcTick = 0;
    this.childrenRenderablesToUpdate = { list: [], index: 0 };
    this.structureDidChange = true;
    this.instructionSet = new InstructionSet();
    this._onRenderContainers = [];
    this.textureNeedsUpdate = true;
    this.isCachedAsTexture = false;
    this._matrixDirty = 7;
  }
  init(root) {
    this.root = root;
    if (root._onRender)
      this.addOnRender(root);
    root.didChange = true;
    const children = root.children;
    for (let i2 = 0; i2 < children.length; i2++) {
      const child = children[i2];
      child._updateFlags = 15;
      this.addChild(child);
    }
  }
  enableCacheAsTexture(options = {}) {
    this.textureOptions = options;
    this.isCachedAsTexture = true;
    this.textureNeedsUpdate = true;
  }
  disableCacheAsTexture() {
    this.isCachedAsTexture = false;
    if (this.texture) {
      TexturePool.returnTexture(this.texture);
      this.texture = null;
    }
  }
  updateCacheTexture() {
    this.textureNeedsUpdate = true;
  }
  reset() {
    this.renderGroupChildren.length = 0;
    for (const i2 in this.childrenToUpdate) {
      const childrenAtDepth = this.childrenToUpdate[i2];
      childrenAtDepth.list.fill(null);
      childrenAtDepth.index = 0;
    }
    this.childrenRenderablesToUpdate.index = 0;
    this.childrenRenderablesToUpdate.list.fill(null);
    this.root = null;
    this.updateTick = 0;
    this.structureDidChange = true;
    this._onRenderContainers.length = 0;
    this.renderGroupParent = null;
    this.disableCacheAsTexture();
  }
  get localTransform() {
    return this.root.localTransform;
  }
  addRenderGroupChild(renderGroupChild) {
    if (renderGroupChild.renderGroupParent) {
      renderGroupChild.renderGroupParent._removeRenderGroupChild(renderGroupChild);
    }
    renderGroupChild.renderGroupParent = this;
    this.renderGroupChildren.push(renderGroupChild);
  }
  _removeRenderGroupChild(renderGroupChild) {
    const index = this.renderGroupChildren.indexOf(renderGroupChild);
    if (index > -1) {
      this.renderGroupChildren.splice(index, 1);
    }
    renderGroupChild.renderGroupParent = null;
  }
  addChild(child) {
    this.structureDidChange = true;
    child.parentRenderGroup = this;
    child.updateTick = -1;
    if (child.parent === this.root) {
      child.relativeRenderGroupDepth = 1;
    } else {
      child.relativeRenderGroupDepth = child.parent.relativeRenderGroupDepth + 1;
    }
    child.didChange = true;
    this.onChildUpdate(child);
    if (child.renderGroup) {
      this.addRenderGroupChild(child.renderGroup);
      return;
    }
    if (child._onRender)
      this.addOnRender(child);
    const children = child.children;
    for (let i2 = 0; i2 < children.length; i2++) {
      this.addChild(children[i2]);
    }
  }
  removeChild(child) {
    this.structureDidChange = true;
    if (child._onRender) {
      if (!child.renderGroup) {
        this.removeOnRender(child);
      }
    }
    child.parentRenderGroup = null;
    if (child.renderGroup) {
      this._removeRenderGroupChild(child.renderGroup);
      return;
    }
    const children = child.children;
    for (let i2 = 0; i2 < children.length; i2++) {
      this.removeChild(children[i2]);
    }
  }
  removeChildren(children) {
    for (let i2 = 0; i2 < children.length; i2++) {
      this.removeChild(children[i2]);
    }
  }
  onChildUpdate(child) {
    let childrenToUpdate = this.childrenToUpdate[child.relativeRenderGroupDepth];
    if (!childrenToUpdate) {
      childrenToUpdate = this.childrenToUpdate[child.relativeRenderGroupDepth] = {
        index: 0,
        list: []
      };
    }
    childrenToUpdate.list[childrenToUpdate.index++] = child;
  }
  updateRenderable(renderable) {
    if (renderable.globalDisplayStatus < 7)
      return;
    this.instructionSet.renderPipes[renderable.renderPipeId].updateRenderable(renderable);
    renderable.didViewUpdate = false;
  }
  onChildViewUpdate(child) {
    this.childrenRenderablesToUpdate.list[this.childrenRenderablesToUpdate.index++] = child;
  }
  get isRenderable() {
    return this.root.localDisplayStatus === 7 && this.worldAlpha > 0;
  }
  /**
   * adding a container to the onRender list will make sure the user function
   * passed in to the user defined 'onRender` callBack
   * @param container - the container to add to the onRender list
   */
  addOnRender(container) {
    this._onRenderContainers.push(container);
  }
  removeOnRender(container) {
    this._onRenderContainers.splice(this._onRenderContainers.indexOf(container), 1);
  }
  runOnRender(renderer) {
    for (let i2 = 0; i2 < this._onRenderContainers.length; i2++) {
      this._onRenderContainers[i2]._onRender(renderer);
    }
  }
  destroy() {
    this.disableCacheAsTexture();
    this.renderGroupParent = null;
    this.root = null;
    this.childrenRenderablesToUpdate = null;
    this.childrenToUpdate = null;
    this.renderGroupChildren = null;
    this._onRenderContainers = null;
    this.instructionSet = null;
  }
  getChildren(out2 = []) {
    const children = this.root.children;
    for (let i2 = 0; i2 < children.length; i2++) {
      this._getChildren(children[i2], out2);
    }
    return out2;
  }
  _getChildren(container, out2 = []) {
    out2.push(container);
    if (container.renderGroup)
      return out2;
    const children = container.children;
    for (let i2 = 0; i2 < children.length; i2++) {
      this._getChildren(children[i2], out2);
    }
    return out2;
  }
  invalidateMatrices() {
    this._matrixDirty = 7;
  }
  /**
   * Returns the inverse of the world transform matrix.
   * @returns {Matrix} The inverse of the world transform matrix.
   */
  get inverseWorldTransform() {
    if ((this._matrixDirty & 1) === 0)
      return this._inverseWorldTransform;
    this._matrixDirty &= ~1;
    this._inverseWorldTransform || (this._inverseWorldTransform = new Matrix());
    return this._inverseWorldTransform.copyFrom(this.worldTransform).invert();
  }
  /**
   * Returns the inverse of the texture offset transform matrix.
   * @returns {Matrix} The inverse of the texture offset transform matrix.
   */
  get textureOffsetInverseTransform() {
    if ((this._matrixDirty & 2) === 0)
      return this._textureOffsetInverseTransform;
    this._matrixDirty &= ~2;
    this._textureOffsetInverseTransform || (this._textureOffsetInverseTransform = new Matrix());
    return this._textureOffsetInverseTransform.copyFrom(this.inverseWorldTransform).translate(
      -this._textureBounds.x,
      -this._textureBounds.y
    );
  }
  /**
   * Returns the inverse of the parent texture transform matrix.
   * This is used to properly transform coordinates when rendering into cached textures.
   * @returns {Matrix} The inverse of the parent texture transform matrix.
   */
  get inverseParentTextureTransform() {
    if ((this._matrixDirty & 4) === 0)
      return this._inverseParentTextureTransform;
    this._matrixDirty &= ~4;
    const parentCacheAsTexture = this._parentCacheAsTextureRenderGroup;
    if (parentCacheAsTexture) {
      this._inverseParentTextureTransform || (this._inverseParentTextureTransform = new Matrix());
      return this._inverseParentTextureTransform.copyFrom(this.worldTransform).prepend(parentCacheAsTexture.inverseWorldTransform).translate(
        -parentCacheAsTexture._textureBounds.x,
        -parentCacheAsTexture._textureBounds.y
      );
    }
    return this.worldTransform;
  }
  /**
   * Returns a matrix that transforms coordinates to the correct coordinate space of the texture being rendered to.
   * This is the texture offset inverse transform of the closest parent RenderGroup that is cached as a texture.
   * @returns {Matrix | null} The transform matrix for the cached texture coordinate space,
   * or null if no parent is cached as texture.
   */
  get cacheToLocalTransform() {
    if (!this._parentCacheAsTextureRenderGroup)
      return null;
    return this._parentCacheAsTextureRenderGroup.textureOffsetInverseTransform;
  }
}
function assignWithIgnore(target, options, ignore = {}) {
  for (const key in options) {
    if (!ignore[key] && options[key] !== void 0) {
      target[key] = options[key];
    }
  }
}
const defaultSkew = new ObservablePoint(null);
const defaultPivot = new ObservablePoint(null);
const defaultScale = new ObservablePoint(null, 1, 1);
const UPDATE_COLOR = 1;
const UPDATE_BLEND = 2;
const UPDATE_VISIBLE = 4;
class Container extends EventEmitter {
  constructor(options = {}) {
    super();
    this.uid = uid("renderable");
    this._updateFlags = 15;
    this.renderGroup = null;
    this.parentRenderGroup = null;
    this.parentRenderGroupIndex = 0;
    this.didChange = false;
    this.didViewUpdate = false;
    this.relativeRenderGroupDepth = 0;
    this.children = [];
    this.parent = null;
    this.includeInBuild = true;
    this.measurable = true;
    this.isSimple = true;
    this.updateTick = -1;
    this.localTransform = new Matrix();
    this.relativeGroupTransform = new Matrix();
    this.groupTransform = this.relativeGroupTransform;
    this.destroyed = false;
    this._position = new ObservablePoint(this, 0, 0);
    this._scale = defaultScale;
    this._pivot = defaultPivot;
    this._skew = defaultSkew;
    this._cx = 1;
    this._sx = 0;
    this._cy = 0;
    this._sy = 1;
    this._rotation = 0;
    this.localColor = 16777215;
    this.localAlpha = 1;
    this.groupAlpha = 1;
    this.groupColor = 16777215;
    this.groupColorAlpha = 4294967295;
    this.localBlendMode = "inherit";
    this.groupBlendMode = "normal";
    this.localDisplayStatus = 7;
    this.globalDisplayStatus = 7;
    this._didContainerChangeTick = 0;
    this._didViewChangeTick = 0;
    this._didLocalTransformChangeId = -1;
    this.effects = [];
    assignWithIgnore(this, options, {
      children: true,
      parent: true,
      effects: true
    });
    options.children?.forEach((child) => this.addChild(child));
    options.parent?.addChild(this);
  }
  /**
   * Mixes all enumerable properties and methods from a source object to Container.
   * @param source - The source of properties and methods to mix in.
   */
  static mixin(source2) {
    Object.defineProperties(Container.prototype, Object.getOwnPropertyDescriptors(source2));
  }
  // = 'default';
  /**
   * We now use the _didContainerChangeTick and _didViewChangeTick to track changes
   * @deprecated since 8.2.6
   * @ignore
   */
  set _didChangeId(value) {
    this._didViewChangeTick = value >> 12 & 4095;
    this._didContainerChangeTick = value & 4095;
  }
  get _didChangeId() {
    return this._didContainerChangeTick & 4095 | (this._didViewChangeTick & 4095) << 12;
  }
  /**
   * Adds one or more children to the container.
   *
   * Multiple items can be added like so: `myContainer.addChild(thingOne, thingTwo, thingThree)`
   * @param {...Container} children - The Container(s) to add to the container
   * @returns {Container} - The first child that was added.
   */
  addChild(...children) {
    if (!this.allowChildren) {
      deprecation(v8_0_0, "addChild: Only Containers will be allowed to add children in v8.0.0");
    }
    if (children.length > 1) {
      for (let i2 = 0; i2 < children.length; i2++) {
        this.addChild(children[i2]);
      }
      return children[0];
    }
    const child = children[0];
    const renderGroup = this.renderGroup || this.parentRenderGroup;
    if (child.parent === this) {
      this.children.splice(this.children.indexOf(child), 1);
      this.children.push(child);
      if (renderGroup) {
        renderGroup.structureDidChange = true;
      }
      return child;
    }
    if (child.parent) {
      child.parent.removeChild(child);
    }
    this.children.push(child);
    if (this.sortableChildren)
      this.sortDirty = true;
    child.parent = this;
    child.didChange = true;
    child._updateFlags = 15;
    if (renderGroup) {
      renderGroup.addChild(child);
    }
    this.emit("childAdded", child, this, this.children.length - 1);
    child.emit("added", this);
    this._didViewChangeTick++;
    if (child._zIndex !== 0) {
      child.depthOfChildModified();
    }
    return child;
  }
  /**
   * Removes one or more children from the container.
   * @param {...Container} children - The Container(s) to remove
   * @returns {Container} The first child that was removed.
   */
  removeChild(...children) {
    if (children.length > 1) {
      for (let i2 = 0; i2 < children.length; i2++) {
        this.removeChild(children[i2]);
      }
      return children[0];
    }
    const child = children[0];
    const index = this.children.indexOf(child);
    if (index > -1) {
      this._didViewChangeTick++;
      this.children.splice(index, 1);
      if (this.renderGroup) {
        this.renderGroup.removeChild(child);
      } else if (this.parentRenderGroup) {
        this.parentRenderGroup.removeChild(child);
      }
      if (child.parentRenderLayer) {
        child.parentRenderLayer.detach(child);
      }
      child.parent = null;
      this.emit("childRemoved", child, this, index);
      child.emit("removed", this);
    }
    return child;
  }
  /** @ignore */
  _onUpdate(point) {
    if (point) {
      if (point === this._skew) {
        this._updateSkew();
      }
    }
    this._didContainerChangeTick++;
    if (this.didChange)
      return;
    this.didChange = true;
    if (this.parentRenderGroup) {
      this.parentRenderGroup.onChildUpdate(this);
    }
  }
  set isRenderGroup(value) {
    if (!!this.renderGroup === value)
      return;
    if (value) {
      this.enableRenderGroup();
    } else {
      this.disableRenderGroup();
    }
  }
  /**
   * Returns true if this container is a render group.
   * This means that it will be rendered as a separate pass, with its own set of instructions
   */
  get isRenderGroup() {
    return !!this.renderGroup;
  }
  /**
   * Calling this enables a render group for this container.
   * This means it will be rendered as a separate set of instructions.
   * The transform of the container will also be handled on the GPU rather than the CPU.
   */
  enableRenderGroup() {
    if (this.renderGroup)
      return;
    const parentRenderGroup = this.parentRenderGroup;
    parentRenderGroup?.removeChild(this);
    this.renderGroup = BigPool.get(RenderGroup, this);
    this.groupTransform = Matrix.IDENTITY;
    parentRenderGroup?.addChild(this);
    this._updateIsSimple();
  }
  /** This will disable the render group for this container. */
  disableRenderGroup() {
    if (!this.renderGroup)
      return;
    const parentRenderGroup = this.parentRenderGroup;
    parentRenderGroup?.removeChild(this);
    BigPool.return(this.renderGroup);
    this.renderGroup = null;
    this.groupTransform = this.relativeGroupTransform;
    parentRenderGroup?.addChild(this);
    this._updateIsSimple();
  }
  /** @ignore */
  _updateIsSimple() {
    this.isSimple = !this.renderGroup && this.effects.length === 0;
  }
  /**
   * Current transform of the object based on world (parent) factors.
   * @readonly
   */
  get worldTransform() {
    this._worldTransform || (this._worldTransform = new Matrix());
    if (this.renderGroup) {
      this._worldTransform.copyFrom(this.renderGroup.worldTransform);
    } else if (this.parentRenderGroup) {
      this._worldTransform.appendFrom(this.relativeGroupTransform, this.parentRenderGroup.worldTransform);
    }
    return this._worldTransform;
  }
  /**
   * The position of the container on the x axis relative to the local coordinates of the parent.
   * An alias to position.x
   */
  get x() {
    return this._position.x;
  }
  set x(value) {
    this._position.x = value;
  }
  /**
   * The position of the container on the y axis relative to the local coordinates of the parent.
   * An alias to position.y
   */
  get y() {
    return this._position.y;
  }
  set y(value) {
    this._position.y = value;
  }
  /**
   * The coordinate of the object relative to the local coordinates of the parent.
   * @since 4.0.0
   */
  get position() {
    return this._position;
  }
  set position(value) {
    this._position.copyFrom(value);
  }
  /**
   * The rotation of the object in radians.
   * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
   */
  get rotation() {
    return this._rotation;
  }
  set rotation(value) {
    if (this._rotation !== value) {
      this._rotation = value;
      this._onUpdate(this._skew);
    }
  }
  /**
   * The angle of the object in degrees.
   * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
   */
  get angle() {
    return this.rotation * RAD_TO_DEG;
  }
  set angle(value) {
    this.rotation = value * DEG_TO_RAD;
  }
  /**
   * The center of rotation, scaling, and skewing for this display object in its local space. The `position`
   * is the projection of `pivot` in the parent's local space.
   *
   * By default, the pivot is the origin (0, 0).
   * @since 4.0.0
   */
  get pivot() {
    if (this._pivot === defaultPivot) {
      this._pivot = new ObservablePoint(this, 0, 0);
    }
    return this._pivot;
  }
  set pivot(value) {
    if (this._pivot === defaultPivot) {
      this._pivot = new ObservablePoint(this, 0, 0);
    }
    typeof value === "number" ? this._pivot.set(value) : this._pivot.copyFrom(value);
  }
  /**
   * The skew factor for the object in radians.
   * @since 4.0.0
   */
  get skew() {
    if (this._skew === defaultSkew) {
      this._skew = new ObservablePoint(this, 0, 0);
    }
    return this._skew;
  }
  set skew(value) {
    if (this._skew === defaultSkew) {
      this._skew = new ObservablePoint(this, 0, 0);
    }
    this._skew.copyFrom(value);
  }
  /**
   * The scale factors of this object along the local coordinate axes.
   *
   * The default scale is (1, 1).
   * @since 4.0.0
   */
  get scale() {
    if (this._scale === defaultScale) {
      this._scale = new ObservablePoint(this, 1, 1);
    }
    return this._scale;
  }
  set scale(value) {
    if (this._scale === defaultScale) {
      this._scale = new ObservablePoint(this, 0, 0);
    }
    typeof value === "number" ? this._scale.set(value) : this._scale.copyFrom(value);
  }
  /**
   * The width of the Container, setting this will actually modify the scale to achieve the value set.
   * @memberof scene.Container#
   */
  get width() {
    return Math.abs(this.scale.x * this.getLocalBounds().width);
  }
  set width(value) {
    const localWidth = this.getLocalBounds().width;
    this._setWidth(value, localWidth);
  }
  /**
   * The height of the Container, setting this will actually modify the scale to achieve the value set.
   * @memberof scene.Container#
   */
  get height() {
    return Math.abs(this.scale.y * this.getLocalBounds().height);
  }
  set height(value) {
    const localHeight = this.getLocalBounds().height;
    this._setHeight(value, localHeight);
  }
  /**
   * Retrieves the size of the container as a [Size]{@link Size} object.
   * This is faster than get the width and height separately.
   * @param out - Optional object to store the size in.
   * @returns - The size of the container.
   * @memberof scene.Container#
   */
  getSize(out2) {
    if (!out2) {
      out2 = {};
    }
    const bounds = this.getLocalBounds();
    out2.width = Math.abs(this.scale.x * bounds.width);
    out2.height = Math.abs(this.scale.y * bounds.height);
    return out2;
  }
  /**
   * Sets the size of the container to the specified width and height.
   * This is faster than setting the width and height separately.
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   * @memberof scene.Container#
   */
  setSize(value, height) {
    const size = this.getLocalBounds();
    if (typeof value === "object") {
      height = value.height ?? value.width;
      value = value.width;
    } else {
      height ?? (height = value);
    }
    value !== void 0 && this._setWidth(value, size.width);
    height !== void 0 && this._setHeight(height, size.height);
  }
  /** Called when the skew or the rotation changes. */
  _updateSkew() {
    const rotation = this._rotation;
    const skew = this._skew;
    this._cx = Math.cos(rotation + skew._y);
    this._sx = Math.sin(rotation + skew._y);
    this._cy = -Math.sin(rotation - skew._x);
    this._sy = Math.cos(rotation - skew._x);
  }
  /**
   * Updates the transform properties of the container (accepts partial values).
   * @param {object} opts - The options for updating the transform.
   * @param {number} opts.x - The x position of the container.
   * @param {number} opts.y - The y position of the container.
   * @param {number} opts.scaleX - The scale factor on the x-axis.
   * @param {number} opts.scaleY - The scale factor on the y-axis.
   * @param {number} opts.rotation - The rotation of the container, in radians.
   * @param {number} opts.skewX - The skew factor on the x-axis.
   * @param {number} opts.skewY - The skew factor on the y-axis.
   * @param {number} opts.pivotX - The x coordinate of the pivot point.
   * @param {number} opts.pivotY - The y coordinate of the pivot point.
   */
  updateTransform(opts) {
    this.position.set(
      typeof opts.x === "number" ? opts.x : this.position.x,
      typeof opts.y === "number" ? opts.y : this.position.y
    );
    this.scale.set(
      typeof opts.scaleX === "number" ? opts.scaleX || 1 : this.scale.x,
      typeof opts.scaleY === "number" ? opts.scaleY || 1 : this.scale.y
    );
    this.rotation = typeof opts.rotation === "number" ? opts.rotation : this.rotation;
    this.skew.set(
      typeof opts.skewX === "number" ? opts.skewX : this.skew.x,
      typeof opts.skewY === "number" ? opts.skewY : this.skew.y
    );
    this.pivot.set(
      typeof opts.pivotX === "number" ? opts.pivotX : this.pivot.x,
      typeof opts.pivotY === "number" ? opts.pivotY : this.pivot.y
    );
    return this;
  }
  /**
   * Updates the local transform using the given matrix.
   * @param matrix - The matrix to use for updating the transform.
   */
  setFromMatrix(matrix) {
    matrix.decompose(this);
  }
  /** Updates the local transform. */
  updateLocalTransform() {
    const localTransformChangeId = this._didContainerChangeTick;
    if (this._didLocalTransformChangeId === localTransformChangeId)
      return;
    this._didLocalTransformChangeId = localTransformChangeId;
    const lt = this.localTransform;
    const scale = this._scale;
    const pivot = this._pivot;
    const position = this._position;
    const sx = scale._x;
    const sy = scale._y;
    const px = pivot._x;
    const py = pivot._y;
    lt.a = this._cx * sx;
    lt.b = this._sx * sx;
    lt.c = this._cy * sy;
    lt.d = this._sy * sy;
    lt.tx = position._x - (px * lt.a + py * lt.c);
    lt.ty = position._y - (px * lt.b + py * lt.d);
  }
  // / ///// color related stuff
  set alpha(value) {
    if (value === this.localAlpha)
      return;
    this.localAlpha = value;
    this._updateFlags |= UPDATE_COLOR;
    this._onUpdate();
  }
  /** The opacity of the object. */
  get alpha() {
    return this.localAlpha;
  }
  set tint(value) {
    const tempColor = Color.shared.setValue(value ?? 16777215);
    const bgr = tempColor.toBgrNumber();
    if (bgr === this.localColor)
      return;
    this.localColor = bgr;
    this._updateFlags |= UPDATE_COLOR;
    this._onUpdate();
  }
  /**
   * The tint applied to the sprite. This is a hex value.
   *
   * A value of 0xFFFFFF will remove any tint effect.
   * @default 0xFFFFFF
   */
  get tint() {
    return bgr2rgb(this.localColor);
  }
  // / //////////////// blend related stuff
  set blendMode(value) {
    if (this.localBlendMode === value)
      return;
    if (this.parentRenderGroup) {
      this.parentRenderGroup.structureDidChange = true;
    }
    this._updateFlags |= UPDATE_BLEND;
    this.localBlendMode = value;
    this._onUpdate();
  }
  /**
   * The blend mode to be applied to the sprite. Apply a value of `'normal'` to reset the blend mode.
   * @default 'normal'
   */
  get blendMode() {
    return this.localBlendMode;
  }
  // / ///////// VISIBILITY / RENDERABLE /////////////////
  /** The visibility of the object. If false the object will not be drawn, and the transform will not be updated. */
  get visible() {
    return !!(this.localDisplayStatus & 2);
  }
  set visible(value) {
    const valueNumber = value ? 2 : 0;
    if ((this.localDisplayStatus & 2) === valueNumber)
      return;
    if (this.parentRenderGroup) {
      this.parentRenderGroup.structureDidChange = true;
    }
    this._updateFlags |= UPDATE_VISIBLE;
    this.localDisplayStatus ^= 2;
    this._onUpdate();
  }
  /** @ignore */
  get culled() {
    return !(this.localDisplayStatus & 4);
  }
  /** @ignore */
  set culled(value) {
    const valueNumber = value ? 0 : 4;
    if ((this.localDisplayStatus & 4) === valueNumber)
      return;
    if (this.parentRenderGroup) {
      this.parentRenderGroup.structureDidChange = true;
    }
    this._updateFlags |= UPDATE_VISIBLE;
    this.localDisplayStatus ^= 4;
    this._onUpdate();
  }
  /** Can this object be rendered, if false the object will not be drawn but the transform will still be updated. */
  get renderable() {
    return !!(this.localDisplayStatus & 1);
  }
  set renderable(value) {
    const valueNumber = value ? 1 : 0;
    if ((this.localDisplayStatus & 1) === valueNumber)
      return;
    this._updateFlags |= UPDATE_VISIBLE;
    this.localDisplayStatus ^= 1;
    if (this.parentRenderGroup) {
      this.parentRenderGroup.structureDidChange = true;
    }
    this._onUpdate();
  }
  /** Whether or not the object should be rendered. */
  get isRenderable() {
    return this.localDisplayStatus === 7 && this.groupAlpha > 0;
  }
  /**
   * Removes all internal references and listeners as well as removes children from the display list.
   * Do not use a Container after calling `destroy`.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
   *  method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for children with textures e.g. Sprites. If options.children
   * is set to true it should destroy the texture of the child sprite
   * @param {boolean} [options.textureSource=false] - Only used for children with textures e.g. Sprites.
   * If options.children is set to true it should destroy the texture source of the child sprite
   * @param {boolean} [options.context=false] - Only used for children with graphicsContexts e.g. Graphics.
   * If options.children is set to true it should destroy the context of the child graphics
   */
  destroy(options = false) {
    if (this.destroyed)
      return;
    this.destroyed = true;
    let oldChildren;
    if (this.children.length) {
      oldChildren = this.removeChildren(0, this.children.length);
    }
    this.removeFromParent();
    this.parent = null;
    this._maskEffect = null;
    this._filterEffect = null;
    this.effects = null;
    this._position = null;
    this._scale = null;
    this._pivot = null;
    this._skew = null;
    this.emit("destroyed", this);
    this.removeAllListeners();
    const destroyChildren = typeof options === "boolean" ? options : options?.children;
    if (destroyChildren && oldChildren) {
      for (let i2 = 0; i2 < oldChildren.length; ++i2) {
        oldChildren[i2].destroy(options);
      }
    }
    this.renderGroup?.destroy();
    this.renderGroup = null;
  }
}
Container.mixin(childrenHelperMixin);
Container.mixin(getFastGlobalBoundsMixin);
Container.mixin(toLocalGlobalMixin);
Container.mixin(onRenderMixin);
Container.mixin(measureMixin);
Container.mixin(effectsMixin);
Container.mixin(findMixin);
Container.mixin(sortMixin);
Container.mixin(cullingMixin);
Container.mixin(cacheAsTextureMixin);
Container.mixin(getGlobalMixin);
Container.mixin(collectRenderablesMixin);
class ViewContainer extends Container {
  constructor() {
    super(...arguments);
    this.canBundle = true;
    this.allowChildren = false;
    this._roundPixels = 0;
    this._lastUsed = -1;
    this._bounds = new Bounds(0, 1, 0, 0);
    this._boundsDirty = true;
  }
  /**
   * The local bounds of the view.
   * @type {rendering.Bounds}
   */
  get bounds() {
    if (!this._boundsDirty)
      return this._bounds;
    this.updateBounds();
    this._boundsDirty = false;
    return this._bounds;
  }
  /**
   * Whether or not to round the x/y position of the sprite.
   * @type {boolean}
   */
  get roundPixels() {
    return !!this._roundPixels;
  }
  set roundPixels(value) {
    this._roundPixels = value ? 1 : 0;
  }
  /**
   * Checks if the object contains the given point.
   * @param point - The point to check
   */
  containsPoint(point) {
    const bounds = this.bounds;
    const { x: x2, y: y2 } = point;
    return x2 >= bounds.minX && x2 <= bounds.maxX && y2 >= bounds.minY && y2 <= bounds.maxY;
  }
  /** @private */
  onViewUpdate() {
    this._didViewChangeTick++;
    this._boundsDirty = true;
    if (this.didViewUpdate)
      return;
    this.didViewUpdate = true;
    const renderGroup = this.renderGroup || this.parentRenderGroup;
    if (renderGroup) {
      renderGroup.onChildViewUpdate(this);
    }
  }
  destroy(options) {
    super.destroy(options);
    this._bounds = null;
  }
  collectRenderablesSimple(instructionSet, renderer, currentLayer) {
    const { renderPipes, renderableGC } = renderer;
    renderPipes.blendMode.setBlendMode(this, this.groupBlendMode, instructionSet);
    const rp = renderPipes;
    rp[this.renderPipeId].addRenderable(this, instructionSet);
    renderableGC.addRenderable(this);
    this.didViewUpdate = false;
    const children = this.children;
    const length2 = children.length;
    for (let i2 = 0; i2 < length2; i2++) {
      children[i2].collectRenderables(instructionSet, renderer, currentLayer);
    }
  }
}
class Sprite extends ViewContainer {
  /**
   * @param options - The options for creating the sprite.
   */
  constructor(options = Texture.EMPTY) {
    if (options instanceof Texture) {
      options = { texture: options };
    }
    const { texture = Texture.EMPTY, anchor, roundPixels, width, height, ...rest } = options;
    super({
      label: "Sprite",
      ...rest
    });
    this.renderPipeId = "sprite";
    this.batched = true;
    this._visualBounds = { minX: 0, maxX: 1, minY: 0, maxY: 0 };
    this._anchor = new ObservablePoint(
      {
        _onUpdate: () => {
          this.onViewUpdate();
        }
      }
    );
    if (anchor) {
      this.anchor = anchor;
    } else if (texture.defaultAnchor) {
      this.anchor = texture.defaultAnchor;
    }
    this.texture = texture;
    this.allowChildren = false;
    this.roundPixels = roundPixels ?? false;
    if (width !== void 0)
      this.width = width;
    if (height !== void 0)
      this.height = height;
  }
  /**
   * Helper function that creates a new sprite based on the source you provide.
   * The source can be - frame id, image, video, canvas element, video element, texture
   * @param source - Source to create texture from
   * @param [skipCache] - Whether to skip the cache or not
   * @returns The newly created sprite
   */
  static from(source2, skipCache = false) {
    if (source2 instanceof Texture) {
      return new Sprite(source2);
    }
    return new Sprite(Texture.from(source2, skipCache));
  }
  set texture(value) {
    value || (value = Texture.EMPTY);
    const currentTexture = this._texture;
    if (currentTexture === value)
      return;
    if (currentTexture && currentTexture.dynamic)
      currentTexture.off("update", this.onViewUpdate, this);
    if (value.dynamic)
      value.on("update", this.onViewUpdate, this);
    this._texture = value;
    if (this._width) {
      this._setWidth(this._width, this._texture.orig.width);
    }
    if (this._height) {
      this._setHeight(this._height, this._texture.orig.height);
    }
    this.onViewUpdate();
  }
  /** The texture that the sprite is using. */
  get texture() {
    return this._texture;
  }
  /**
   * The bounds of the sprite, taking the texture's trim into account.
   * @type {rendering.Bounds}
   */
  get visualBounds() {
    updateQuadBounds(this._visualBounds, this._anchor, this._texture);
    return this._visualBounds;
  }
  /**
   * @deprecated
   */
  get sourceBounds() {
    deprecation("8.6.1", "Sprite.sourceBounds is deprecated, use visualBounds instead.");
    return this.visualBounds;
  }
  /** @private */
  updateBounds() {
    const anchor = this._anchor;
    const texture = this._texture;
    const bounds = this._bounds;
    const { width, height } = texture.orig;
    bounds.minX = -anchor._x * width;
    bounds.maxX = bounds.minX + width;
    bounds.minY = -anchor._y * height;
    bounds.maxY = bounds.minY + height;
  }
  /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the renderable as well
   * @param {boolean} [options.textureSource=false] - Should it destroy the textureSource of the renderable as well
   */
  destroy(options = false) {
    super.destroy(options);
    const destroyTexture = typeof options === "boolean" ? options : options?.texture;
    if (destroyTexture) {
      const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
      this._texture.destroy(destroyTextureSource);
    }
    this._texture = null;
    this._visualBounds = null;
    this._bounds = null;
    this._anchor = null;
  }
  /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * The default is `(0,0)`, this means the sprite's origin is the top left.
   *
   * Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   *
   * Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * import { Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite({texture: Texture.WHITE});
   * sprite.anchor.set(0.5); // This will set the origin to center. (0.5) is same as (0.5, 0.5).
   */
  get anchor() {
    return this._anchor;
  }
  set anchor(value) {
    typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
  }
  /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */
  get width() {
    return Math.abs(this.scale.x) * this._texture.orig.width;
  }
  set width(value) {
    this._setWidth(value, this._texture.orig.width);
    this._width = value;
  }
  /** The height of the sprite, setting this will actually modify the scale to achieve the value set. */
  get height() {
    return Math.abs(this.scale.y) * this._texture.orig.height;
  }
  set height(value) {
    this._setHeight(value, this._texture.orig.height);
    this._height = value;
  }
  /**
   * Retrieves the size of the Sprite as a [Size]{@link Size} object.
   * This is faster than get the width and height separately.
   * @param out - Optional object to store the size in.
   * @returns - The size of the Sprite.
   */
  getSize(out2) {
    out2 || (out2 = {});
    out2.width = Math.abs(this.scale.x) * this._texture.orig.width;
    out2.height = Math.abs(this.scale.y) * this._texture.orig.height;
    return out2;
  }
  /**
   * Sets the size of the Sprite to the specified width and height.
   * This is faster than setting the width and height separately.
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   */
  setSize(value, height) {
    if (typeof value === "object") {
      height = value.height ?? value.width;
      value = value.width;
    } else {
      height ?? (height = value);
    }
    value !== void 0 && this._setWidth(value, this._texture.orig.width);
    height !== void 0 && this._setHeight(height, this._texture.orig.height);
  }
}
const tempBounds = new Bounds();
function addMaskBounds(mask, bounds, skipUpdateTransform) {
  const boundsToMask = tempBounds;
  mask.measurable = true;
  getGlobalBounds(mask, skipUpdateTransform, boundsToMask);
  bounds.addBoundsMask(boundsToMask);
  mask.measurable = false;
}
function addMaskLocalBounds(mask, bounds, localRoot) {
  const boundsToMask = boundsPool.get();
  mask.measurable = true;
  const tempMatrix2 = matrixPool.get().identity();
  const relativeMask = getMatrixRelativeToParent(mask, localRoot, tempMatrix2);
  getLocalBounds(mask, boundsToMask, relativeMask);
  mask.measurable = false;
  bounds.addBoundsMask(boundsToMask);
  matrixPool.return(tempMatrix2);
  boundsPool.return(boundsToMask);
}
function getMatrixRelativeToParent(target, root, matrix) {
  if (!target) {
    warn("Mask bounds, renderable is not inside the root container");
    return matrix;
  }
  if (target !== root) {
    getMatrixRelativeToParent(target.parent, root, matrix);
    target.updateLocalTransform();
    matrix.append(target.localTransform);
  }
  return matrix;
}
class AlphaMask {
  constructor(options) {
    this.priority = 0;
    this.inverse = false;
    this.pipe = "alphaMask";
    if (options?.mask) {
      this.init(options.mask);
    }
  }
  init(mask) {
    this.mask = mask;
    this.renderMaskToTexture = !(mask instanceof Sprite);
    this.mask.renderable = this.renderMaskToTexture;
    this.mask.includeInBuild = !this.renderMaskToTexture;
    this.mask.measurable = false;
  }
  reset() {
    this.mask.measurable = true;
    this.mask = null;
  }
  addBounds(bounds, skipUpdateTransform) {
    if (!this.inverse) {
      addMaskBounds(this.mask, bounds, skipUpdateTransform);
    }
  }
  addLocalBounds(bounds, localRoot) {
    addMaskLocalBounds(this.mask, bounds, localRoot);
  }
  containsPoint(point, hitTestFn) {
    const mask = this.mask;
    return hitTestFn(mask, point);
  }
  destroy() {
    this.reset();
  }
  static test(mask) {
    return mask instanceof Sprite;
  }
}
AlphaMask.extension = ExtensionType.MaskEffect;
class ColorMask {
  constructor(options) {
    this.priority = 0;
    this.pipe = "colorMask";
    if (options?.mask) {
      this.init(options.mask);
    }
  }
  init(mask) {
    this.mask = mask;
  }
  destroy() {
  }
  static test(mask) {
    return typeof mask === "number";
  }
}
ColorMask.extension = ExtensionType.MaskEffect;
class StencilMask {
  constructor(options) {
    this.priority = 0;
    this.pipe = "stencilMask";
    if (options?.mask) {
      this.init(options.mask);
    }
  }
  init(mask) {
    this.mask = mask;
    this.mask.includeInBuild = false;
    this.mask.measurable = false;
  }
  reset() {
    this.mask.measurable = true;
    this.mask.includeInBuild = true;
    this.mask = null;
  }
  addBounds(bounds, skipUpdateTransform) {
    addMaskBounds(this.mask, bounds, skipUpdateTransform);
  }
  addLocalBounds(bounds, localRoot) {
    addMaskLocalBounds(this.mask, bounds, localRoot);
  }
  containsPoint(point, hitTestFn) {
    const mask = this.mask;
    return hitTestFn(mask, point);
  }
  destroy() {
    this.reset();
  }
  static test(mask) {
    return mask instanceof Container;
  }
}
StencilMask.extension = ExtensionType.MaskEffect;
const BrowserAdapter = {
  createCanvas: (width, height) => {
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    return canvas;
  },
  getCanvasRenderingContext2D: () => CanvasRenderingContext2D,
  getWebGLRenderingContext: () => WebGLRenderingContext,
  getNavigator: () => navigator,
  getBaseUrl: () => document.baseURI ?? window.location.href,
  getFontFaceSet: () => document.fonts,
  fetch: (url, options) => fetch(url, options),
  parseXML: (xml) => {
    const parser = new DOMParser();
    return parser.parseFromString(xml, "text/xml");
  }
};
let currentAdapter = BrowserAdapter;
const DOMAdapter = {
  /**
   * Returns the current adapter.
   * @returns {environment.Adapter} The current adapter.
   */
  get() {
    return currentAdapter;
  },
  /**
   * Sets the current adapter.
   * @param adapter - The new adapter.
   */
  set(adapter) {
    currentAdapter = adapter;
  }
};
class CanvasSource extends TextureSource {
  constructor(options) {
    if (!options.resource) {
      options.resource = DOMAdapter.get().createCanvas();
    }
    if (!options.width) {
      options.width = options.resource.width;
      if (!options.autoDensity) {
        options.width /= options.resolution;
      }
    }
    if (!options.height) {
      options.height = options.resource.height;
      if (!options.autoDensity) {
        options.height /= options.resolution;
      }
    }
    super(options);
    this.uploadMethodId = "image";
    this.autoDensity = options.autoDensity;
    this.resizeCanvas();
    this.transparent = !!options.transparent;
  }
  resizeCanvas() {
    if (this.autoDensity) {
      this.resource.style.width = `${this.width}px`;
      this.resource.style.height = `${this.height}px`;
    }
    if (this.resource.width !== this.pixelWidth || this.resource.height !== this.pixelHeight) {
      this.resource.width = this.pixelWidth;
      this.resource.height = this.pixelHeight;
    }
  }
  resize(width = this.width, height = this.height, resolution = this._resolution) {
    const didResize = super.resize(width, height, resolution);
    if (didResize) {
      this.resizeCanvas();
    }
    return didResize;
  }
  static test(resource) {
    return globalThis.HTMLCanvasElement && resource instanceof HTMLCanvasElement || globalThis.OffscreenCanvas && resource instanceof OffscreenCanvas;
  }
  /**
   * Returns the 2D rendering context for the canvas.
   * Caches the context after creating it.
   * @returns The 2D rendering context of the canvas.
   */
  get context2D() {
    return this._context2D || (this._context2D = this.resource.getContext("2d"));
  }
}
CanvasSource.extension = ExtensionType.TextureSource;
class ImageSource extends TextureSource {
  constructor(options) {
    if (options.resource && (globalThis.HTMLImageElement && options.resource instanceof HTMLImageElement)) {
      const canvas = DOMAdapter.get().createCanvas(options.resource.width, options.resource.height);
      const context2 = canvas.getContext("2d");
      context2.drawImage(options.resource, 0, 0, options.resource.width, options.resource.height);
      options.resource = canvas;
      warn("ImageSource: Image element passed, converting to canvas. Use CanvasSource instead.");
    }
    super(options);
    this.uploadMethodId = "image";
    this.autoGarbageCollect = true;
  }
  static test(resource) {
    return globalThis.HTMLImageElement && resource instanceof HTMLImageElement || typeof ImageBitmap !== "undefined" && resource instanceof ImageBitmap || globalThis.VideoFrame && resource instanceof VideoFrame;
  }
}
ImageSource.extension = ExtensionType.TextureSource;
var UPDATE_PRIORITY = /* @__PURE__ */ ((UPDATE_PRIORITY2) => {
  UPDATE_PRIORITY2[UPDATE_PRIORITY2["INTERACTION"] = 50] = "INTERACTION";
  UPDATE_PRIORITY2[UPDATE_PRIORITY2["HIGH"] = 25] = "HIGH";
  UPDATE_PRIORITY2[UPDATE_PRIORITY2["NORMAL"] = 0] = "NORMAL";
  UPDATE_PRIORITY2[UPDATE_PRIORITY2["LOW"] = -25] = "LOW";
  UPDATE_PRIORITY2[UPDATE_PRIORITY2["UTILITY"] = -50] = "UTILITY";
  return UPDATE_PRIORITY2;
})(UPDATE_PRIORITY || {});
class TickerListener {
  /**
   * Constructor
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting
   * @param once - If the handler should fire once
   */
  constructor(fn, context2 = null, priority = 0, once = false) {
    this.next = null;
    this.previous = null;
    this._destroyed = false;
    this._fn = fn;
    this._context = context2;
    this.priority = priority;
    this._once = once;
  }
  /**
   * Simple compare function to figure out if a function and context match.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @returns `true` if the listener match the arguments
   */
  match(fn, context2 = null) {
    return this._fn === fn && this._context === context2;
  }
  /**
   * Emit by calling the current function.
   * @param ticker - The ticker emitting.
   * @returns Next ticker
   */
  emit(ticker) {
    if (this._fn) {
      if (this._context) {
        this._fn.call(this._context, ticker);
      } else {
        this._fn(ticker);
      }
    }
    const redirect = this.next;
    if (this._once) {
      this.destroy(true);
    }
    if (this._destroyed) {
      this.next = null;
    }
    return redirect;
  }
  /**
   * Connect to the list.
   * @param previous - Input node, previous listener
   */
  connect(previous) {
    this.previous = previous;
    if (previous.next) {
      previous.next.previous = this;
    }
    this.next = previous.next;
    previous.next = this;
  }
  /**
   * Destroy and don't use after this.
   * @param hard - `true` to remove the `next` reference, this
   *        is considered a hard destroy. Soft destroy maintains the next reference.
   * @returns The listener to redirect while emitting or removing.
   */
  destroy(hard = false) {
    this._destroyed = true;
    this._fn = null;
    this._context = null;
    if (this.previous) {
      this.previous.next = this.next;
    }
    if (this.next) {
      this.next.previous = this.previous;
    }
    const redirect = this.next;
    this.next = hard ? null : redirect;
    this.previous = null;
    return redirect;
  }
}
const _Ticker = class _Ticker2 {
  constructor() {
    this.autoStart = false;
    this.deltaTime = 1;
    this.lastTime = -1;
    this.speed = 1;
    this.started = false;
    this._requestId = null;
    this._maxElapsedMS = 100;
    this._minElapsedMS = 0;
    this._protected = false;
    this._lastFrame = -1;
    this._head = new TickerListener(null, null, Infinity);
    this.deltaMS = 1 / _Ticker2.targetFPMS;
    this.elapsedMS = 1 / _Ticker2.targetFPMS;
    this._tick = (time) => {
      this._requestId = null;
      if (this.started) {
        this.update(time);
        if (this.started && this._requestId === null && this._head.next) {
          this._requestId = requestAnimationFrame(this._tick);
        }
      }
    };
  }
  /**
   * Conditionally requests a new animation frame.
   * If a frame has not already been requested, and if the internal
   * emitter has listeners, a new frame is requested.
   * @private
   */
  _requestIfNeeded() {
    if (this._requestId === null && this._head.next) {
      this.lastTime = performance.now();
      this._lastFrame = this.lastTime;
      this._requestId = requestAnimationFrame(this._tick);
    }
  }
  /**
   * Conditionally cancels a pending animation frame.
   * @private
   */
  _cancelIfNeeded() {
    if (this._requestId !== null) {
      cancelAnimationFrame(this._requestId);
      this._requestId = null;
    }
  }
  /**
   * Conditionally requests a new animation frame.
   * If the ticker has been started it checks if a frame has not already
   * been requested, and if the internal emitter has listeners. If these
   * conditions are met, a new frame is requested. If the ticker has not
   * been started, but autoStart is `true`, then the ticker starts now,
   * and continues with the previous conditions to request a new frame.
   * @private
   */
  _startIfPossible() {
    if (this.started) {
      this._requestIfNeeded();
    } else if (this.autoStart) {
      this.start();
    }
  }
  /**
   * Register a handler for tick events. Calls continuously unless
   * it is removed or the ticker is stopped.
   * @param fn - The listener function to be added for updates
   * @param context - The listener context
   * @param {number} [priority=UPDATE_PRIORITY.NORMAL] - The priority for emitting
   * @returns This instance of a ticker
   */
  add(fn, context2, priority = UPDATE_PRIORITY.NORMAL) {
    return this._addListener(new TickerListener(fn, context2, priority));
  }
  /**
   * Add a handler for the tick event which is only execute once.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param {number} [priority=UPDATE_PRIORITY.NORMAL] - The priority for emitting
   * @returns This instance of a ticker
   */
  addOnce(fn, context2, priority = UPDATE_PRIORITY.NORMAL) {
    return this._addListener(new TickerListener(fn, context2, priority, true));
  }
  /**
   * Internally adds the event handler so that it can be sorted by priority.
   * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
   * before the rendering.
   * @private
   * @param listener - Current listener being added.
   * @returns This instance of a ticker
   */
  _addListener(listener) {
    let current = this._head.next;
    let previous = this._head;
    if (!current) {
      listener.connect(previous);
    } else {
      while (current) {
        if (listener.priority > current.priority) {
          listener.connect(previous);
          break;
        }
        previous = current;
        current = current.next;
      }
      if (!listener.previous) {
        listener.connect(previous);
      }
    }
    this._startIfPossible();
    return this;
  }
  /**
   * Removes any handlers matching the function and context parameters.
   * If no handlers are left after removing, then it cancels the animation frame.
   * @param fn - The listener function to be removed
   * @param context - The listener context to be removed
   * @returns This instance of a ticker
   */
  remove(fn, context2) {
    let listener = this._head.next;
    while (listener) {
      if (listener.match(fn, context2)) {
        listener = listener.destroy();
      } else {
        listener = listener.next;
      }
    }
    if (!this._head.next) {
      this._cancelIfNeeded();
    }
    return this;
  }
  /**
   * The number of listeners on this ticker, calculated by walking through linked list
   * @readonly
   * @member {number}
   */
  get count() {
    if (!this._head) {
      return 0;
    }
    let count2 = 0;
    let current = this._head;
    while (current = current.next) {
      count2++;
    }
    return count2;
  }
  /** Starts the ticker. If the ticker has listeners a new animation frame is requested at this point. */
  start() {
    if (!this.started) {
      this.started = true;
      this._requestIfNeeded();
    }
  }
  /** Stops the ticker. If the ticker has requested an animation frame it is canceled at this point. */
  stop() {
    if (this.started) {
      this.started = false;
      this._cancelIfNeeded();
    }
  }
  /** Destroy the ticker and don't use after this. Calling this method removes all references to internal events. */
  destroy() {
    if (!this._protected) {
      this.stop();
      let listener = this._head.next;
      while (listener) {
        listener = listener.destroy(true);
      }
      this._head.destroy();
      this._head = null;
    }
  }
  /**
   * Triggers an update. An update entails setting the
   * current {@link ticker.Ticker#elapsedMS|elapsedMS},
   * the current {@link ticker.Ticker#deltaTime|deltaTime},
   * invoking all listeners with current deltaTime,
   * and then finally setting {@link ticker.Ticker#lastTime|lastTime}
   * with the value of currentTime that was provided.
   * This method will be called automatically by animation
   * frame callbacks if the ticker instance has been started
   * and listeners are added.
   * @param {number} [currentTime=performance.now()] - the current time of execution
   */
  update(currentTime = performance.now()) {
    let elapsedMS;
    if (currentTime > this.lastTime) {
      elapsedMS = this.elapsedMS = currentTime - this.lastTime;
      if (elapsedMS > this._maxElapsedMS) {
        elapsedMS = this._maxElapsedMS;
      }
      elapsedMS *= this.speed;
      if (this._minElapsedMS) {
        const delta = currentTime - this._lastFrame | 0;
        if (delta < this._minElapsedMS) {
          return;
        }
        this._lastFrame = currentTime - delta % this._minElapsedMS;
      }
      this.deltaMS = elapsedMS;
      this.deltaTime = this.deltaMS * _Ticker2.targetFPMS;
      const head = this._head;
      let listener = head.next;
      while (listener) {
        listener = listener.emit(this);
      }
      if (!head.next) {
        this._cancelIfNeeded();
      }
    } else {
      this.deltaTime = this.deltaMS = this.elapsedMS = 0;
    }
    this.lastTime = currentTime;
  }
  /**
   * The frames per second at which this ticker is running.
   * The default is approximately 60 in most modern browsers.
   * **Note:** This does not factor in the value of
   * {@link ticker.Ticker#speed|speed}, which is specific
   * to scaling {@link ticker.Ticker#deltaTime|deltaTime}.
   * @member {number}
   * @readonly
   */
  get FPS() {
    return 1e3 / this.elapsedMS;
  }
  /**
   * Manages the maximum amount of milliseconds allowed to
   * elapse between invoking {@link ticker.Ticker#update|update}.
   * This value is used to cap {@link ticker.Ticker#deltaTime|deltaTime},
   * but does not effect the measured value of {@link ticker.Ticker#FPS|FPS}.
   * When setting this property it is clamped to a value between
   * `0` and `Ticker.targetFPMS * 1000`.
   * @member {number}
   * @default 10
   */
  get minFPS() {
    return 1e3 / this._maxElapsedMS;
  }
  set minFPS(fps) {
    const minFPS = Math.min(this.maxFPS, fps);
    const minFPMS = Math.min(Math.max(0, minFPS) / 1e3, _Ticker2.targetFPMS);
    this._maxElapsedMS = 1 / minFPMS;
  }
  /**
   * Manages the minimum amount of milliseconds required to
   * elapse between invoking {@link ticker.Ticker#update|update}.
   * This will effect the measured value of {@link ticker.Ticker#FPS|FPS}.
   * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
   * Otherwise it will be at least `minFPS`
   * @member {number}
   * @default 0
   */
  get maxFPS() {
    if (this._minElapsedMS) {
      return Math.round(1e3 / this._minElapsedMS);
    }
    return 0;
  }
  set maxFPS(fps) {
    if (fps === 0) {
      this._minElapsedMS = 0;
    } else {
      const maxFPS = Math.max(this.minFPS, fps);
      this._minElapsedMS = 1 / (maxFPS / 1e3);
    }
  }
  /**
   * The shared ticker instance used by {@link AnimatedSprite} and by
   * {@link VideoResource} to update animation frames / video textures.
   *
   * It may also be used by {@link Application} if created with the `sharedTicker` option property set to true.
   *
   * The property {@link ticker.Ticker#autoStart|autoStart} is set to `true` for this instance.
   * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
   * @example
   * import { Ticker } from 'pixi.js';
   *
   * const ticker = Ticker.shared;
   * // Set this to prevent starting this ticker when listeners are added.
   * // By default this is true only for the Ticker.shared instance.
   * ticker.autoStart = false;
   *
   * // FYI, call this to ensure the ticker is stopped. It should be stopped
   * // if you have not attempted to render anything yet.
   * ticker.stop();
   *
   * // Call this when you are ready for a running shared ticker.
   * ticker.start();
   * @example
   * import { autoDetectRenderer, Container } from 'pixi.js';
   *
   * // You may use the shared ticker to render...
   * const renderer = autoDetectRenderer();
   * const stage = new Container();
   * document.body.appendChild(renderer.view);
   * ticker.add((time) => renderer.render(stage));
   *
   * // Or you can just update it manually.
   * ticker.autoStart = false;
   * ticker.stop();
   * const animate = (time) => {
   *     ticker.update(time);
   *     renderer.render(stage);
   *     requestAnimationFrame(animate);
   * };
   * animate(performance.now());
   * @member {ticker.Ticker}
   * @readonly
   * @static
   */
  static get shared() {
    if (!_Ticker2._shared) {
      const shared = _Ticker2._shared = new _Ticker2();
      shared.autoStart = true;
      shared._protected = true;
    }
    return _Ticker2._shared;
  }
  /**
   * The system ticker instance used by {@link BasePrepare} for core timing
   * functionality that shouldn't usually need to be paused, unlike the `shared`
   * ticker which drives visual animations and rendering which may want to be paused.
   *
   * The property {@link ticker.Ticker#autoStart|autoStart} is set to `true` for this instance.
   * @member {ticker.Ticker}
   * @readonly
   * @static
   */
  static get system() {
    if (!_Ticker2._system) {
      const system = _Ticker2._system = new _Ticker2();
      system.autoStart = true;
      system._protected = true;
    }
    return _Ticker2._system;
  }
};
_Ticker.targetFPMS = 0.06;
let Ticker = _Ticker;
let promise;
async function detectVideoAlphaMode() {
  promise ?? (promise = (async () => {
    const canvas = document.createElement("canvas");
    const gl = canvas.getContext("webgl");
    if (!gl) {
      return "premultiply-alpha-on-upload";
    }
    const video = await new Promise((resolve) => {
      const video2 = document.createElement("video");
      video2.onloadeddata = () => resolve(video2);
      video2.onerror = () => resolve(null);
      video2.autoplay = false;
      video2.crossOrigin = "anonymous";
      video2.preload = "auto";
      video2.src = "data:video/webm;base64,GkXfo59ChoEBQveBAULygQRC84EIQoKEd2VibUKHgQJChYECGFOAZwEAAAAAAAHTEU2bdLpNu4tTq4QVSalmU6yBoU27i1OrhBZUrmtTrIHGTbuMU6uEElTDZ1OsggEXTbuMU6uEHFO7a1OsggG97AEAAAAAAABZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmoCrXsYMPQkBNgIRMYXZmV0GETGF2ZkSJiEBEAAAAAAAAFlSua8yuAQAAAAAAAEPXgQFzxYgAAAAAAAAAAZyBACK1nIN1bmSIgQCGhVZfVlA5g4EBI+ODhAJiWgDglLCBArqBApqBAlPAgQFVsIRVuYEBElTDZ9Vzc9JjwItjxYgAAAAAAAAAAWfInEWjh0VOQ09ERVJEh49MYXZjIGxpYnZweC12cDlnyKJFo4hEVVJBVElPTkSHlDAwOjAwOjAwLjA0MDAwMDAwMAAAH0O2dcfngQCgwqGggQAAAIJJg0IAABAAFgA4JBwYSgAAICAAEb///4r+AAB1oZ2mm+6BAaWWgkmDQgAAEAAWADgkHBhKAAAgIABIQBxTu2uRu4+zgQC3iveBAfGCAXHwgQM=";
      video2.load();
    });
    if (!video) {
      return "premultiply-alpha-on-upload";
    }
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    const framebuffer = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
    gl.framebufferTexture2D(
      gl.FRAMEBUFFER,
      gl.COLOR_ATTACHMENT0,
      gl.TEXTURE_2D,
      texture,
      0
    );
    gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
    gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, gl.NONE);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, video);
    const pixel = new Uint8Array(4);
    gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixel);
    gl.deleteFramebuffer(framebuffer);
    gl.deleteTexture(texture);
    gl.getExtension("WEBGL_lose_context")?.loseContext();
    return pixel[0] <= pixel[3] ? "premultiplied-alpha" : "premultiply-alpha-on-upload";
  })());
  return promise;
}
const _VideoSource = class _VideoSource2 extends TextureSource {
  constructor(options) {
    super(options);
    this.isReady = false;
    this.uploadMethodId = "video";
    options = {
      ..._VideoSource2.defaultOptions,
      ...options
    };
    this._autoUpdate = true;
    this._isConnectedToTicker = false;
    this._updateFPS = options.updateFPS || 0;
    this._msToNextUpdate = 0;
    this.autoPlay = options.autoPlay !== false;
    this.alphaMode = options.alphaMode ?? "premultiply-alpha-on-upload";
    this._videoFrameRequestCallback = this._videoFrameRequestCallback.bind(this);
    this._videoFrameRequestCallbackHandle = null;
    this._load = null;
    this._resolve = null;
    this._reject = null;
    this._onCanPlay = this._onCanPlay.bind(this);
    this._onCanPlayThrough = this._onCanPlayThrough.bind(this);
    this._onError = this._onError.bind(this);
    this._onPlayStart = this._onPlayStart.bind(this);
    this._onPlayStop = this._onPlayStop.bind(this);
    this._onSeeked = this._onSeeked.bind(this);
    if (options.autoLoad !== false) {
      void this.load();
    }
  }
  /** Update the video frame if the source is not destroyed and meets certain conditions. */
  updateFrame() {
    if (this.destroyed) {
      return;
    }
    if (this._updateFPS) {
      const elapsedMS = Ticker.shared.elapsedMS * this.resource.playbackRate;
      this._msToNextUpdate = Math.floor(this._msToNextUpdate - elapsedMS);
    }
    if (!this._updateFPS || this._msToNextUpdate <= 0) {
      this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0;
    }
    if (this.isValid) {
      this.update();
    }
  }
  /** Callback to update the video frame and potentially request the next frame update. */
  _videoFrameRequestCallback() {
    this.updateFrame();
    if (this.destroyed) {
      this._videoFrameRequestCallbackHandle = null;
    } else {
      this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(
        this._videoFrameRequestCallback
      );
    }
  }
  /**
   * Checks if the resource has valid dimensions.
   * @returns {boolean} True if width and height are set, otherwise false.
   */
  get isValid() {
    return !!this.resource.videoWidth && !!this.resource.videoHeight;
  }
  /**
   * Start preloading the video resource.
   * @returns {Promise<this>} Handle the validate event
   */
  async load() {
    if (this._load) {
      return this._load;
    }
    const source2 = this.resource;
    const options = this.options;
    if ((source2.readyState === source2.HAVE_ENOUGH_DATA || source2.readyState === source2.HAVE_FUTURE_DATA) && source2.width && source2.height) {
      source2.complete = true;
    }
    source2.addEventListener("play", this._onPlayStart);
    source2.addEventListener("pause", this._onPlayStop);
    source2.addEventListener("seeked", this._onSeeked);
    if (!this._isSourceReady()) {
      if (!options.preload) {
        source2.addEventListener("canplay", this._onCanPlay);
      }
      source2.addEventListener("canplaythrough", this._onCanPlayThrough);
      source2.addEventListener("error", this._onError, true);
    } else {
      this._mediaReady();
    }
    this.alphaMode = await detectVideoAlphaMode();
    this._load = new Promise((resolve, reject) => {
      if (this.isValid) {
        resolve(this);
      } else {
        this._resolve = resolve;
        this._reject = reject;
        if (options.preloadTimeoutMs !== void 0) {
          this._preloadTimeout = setTimeout(() => {
            this._onError(new ErrorEvent(`Preload exceeded timeout of ${options.preloadTimeoutMs}ms`));
          });
        }
        source2.load();
      }
    });
    return this._load;
  }
  /**
   * Handle video error events.
   * @param event - The error event
   */
  _onError(event) {
    this.resource.removeEventListener("error", this._onError, true);
    this.emit("error", event);
    if (this._reject) {
      this._reject(event);
      this._reject = null;
      this._resolve = null;
    }
  }
  /**
   * Checks if the underlying source is playing.
   * @returns True if playing.
   */
  _isSourcePlaying() {
    const source2 = this.resource;
    return !source2.paused && !source2.ended;
  }
  /**
   * Checks if the underlying source is ready for playing.
   * @returns True if ready.
   */
  _isSourceReady() {
    const source2 = this.resource;
    return source2.readyState > 2;
  }
  /** Runs the update loop when the video is ready to play. */
  _onPlayStart() {
    if (!this.isValid) {
      this._mediaReady();
    }
    this._configureAutoUpdate();
  }
  /** Stops the update loop when a pause event is triggered. */
  _onPlayStop() {
    this._configureAutoUpdate();
  }
  /** Handles behavior when the video completes seeking to the current playback position. */
  _onSeeked() {
    if (this._autoUpdate && !this._isSourcePlaying()) {
      this._msToNextUpdate = 0;
      this.updateFrame();
      this._msToNextUpdate = 0;
    }
  }
  _onCanPlay() {
    const source2 = this.resource;
    source2.removeEventListener("canplay", this._onCanPlay);
    this._mediaReady();
  }
  _onCanPlayThrough() {
    const source2 = this.resource;
    source2.removeEventListener("canplaythrough", this._onCanPlay);
    if (this._preloadTimeout) {
      clearTimeout(this._preloadTimeout);
      this._preloadTimeout = void 0;
    }
    this._mediaReady();
  }
  /** Fired when the video is loaded and ready to play. */
  _mediaReady() {
    const source2 = this.resource;
    if (this.isValid) {
      this.isReady = true;
      this.resize(source2.videoWidth, source2.videoHeight);
    }
    this._msToNextUpdate = 0;
    this.updateFrame();
    this._msToNextUpdate = 0;
    if (this._resolve) {
      this._resolve(this);
      this._resolve = null;
      this._reject = null;
    }
    if (this._isSourcePlaying()) {
      this._onPlayStart();
    } else if (this.autoPlay) {
      void this.resource.play();
    }
  }
  /** Cleans up resources and event listeners associated with this texture. */
  destroy() {
    this._configureAutoUpdate();
    const source2 = this.resource;
    if (source2) {
      source2.removeEventListener("play", this._onPlayStart);
      source2.removeEventListener("pause", this._onPlayStop);
      source2.removeEventListener("seeked", this._onSeeked);
      source2.removeEventListener("canplay", this._onCanPlay);
      source2.removeEventListener("canplaythrough", this._onCanPlayThrough);
      source2.removeEventListener("error", this._onError, true);
      source2.pause();
      source2.src = "";
      source2.load();
    }
    super.destroy();
  }
  /** Should the base texture automatically update itself, set to true by default. */
  get autoUpdate() {
    return this._autoUpdate;
  }
  set autoUpdate(value) {
    if (value !== this._autoUpdate) {
      this._autoUpdate = value;
      this._configureAutoUpdate();
    }
  }
  /**
   * How many times a second to update the texture from the video.
   * Leave at 0 to update at every render.
   * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
   */
  get updateFPS() {
    return this._updateFPS;
  }
  set updateFPS(value) {
    if (value !== this._updateFPS) {
      this._updateFPS = value;
      this._configureAutoUpdate();
    }
  }
  /**
   * Configures the updating mechanism based on the current state and settings.
   *
   * This method decides between using the browser's native video frame callback or a custom ticker
   * for updating the video frame. It ensures optimal performance and responsiveness
   * based on the video's state, playback status, and the desired frames-per-second setting.
   *
   * - If `_autoUpdate` is enabled and the video source is playing:
   *   - It will prefer the native video frame callback if available and no specific FPS is set.
   *   - Otherwise, it will use a custom ticker for manual updates.
   * - If `_autoUpdate` is disabled or the video isn't playing, any active update mechanisms are halted.
   */
  _configureAutoUpdate() {
    if (this._autoUpdate && this._isSourcePlaying()) {
      if (!this._updateFPS && this.resource.requestVideoFrameCallback) {
        if (this._isConnectedToTicker) {
          Ticker.shared.remove(this.updateFrame, this);
          this._isConnectedToTicker = false;
          this._msToNextUpdate = 0;
        }
        if (this._videoFrameRequestCallbackHandle === null) {
          this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(
            this._videoFrameRequestCallback
          );
        }
      } else {
        if (this._videoFrameRequestCallbackHandle !== null) {
          this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle);
          this._videoFrameRequestCallbackHandle = null;
        }
        if (!this._isConnectedToTicker) {
          Ticker.shared.add(this.updateFrame, this);
          this._isConnectedToTicker = true;
          this._msToNextUpdate = 0;
        }
      }
    } else {
      if (this._videoFrameRequestCallbackHandle !== null) {
        this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle);
        this._videoFrameRequestCallbackHandle = null;
      }
      if (this._isConnectedToTicker) {
        Ticker.shared.remove(this.updateFrame, this);
        this._isConnectedToTicker = false;
        this._msToNextUpdate = 0;
      }
    }
  }
  static test(resource) {
    return globalThis.HTMLVideoElement && resource instanceof HTMLVideoElement;
  }
};
_VideoSource.extension = ExtensionType.TextureSource;
_VideoSource.defaultOptions = {
  ...TextureSource.defaultOptions,
  /** If true, the video will start loading immediately. */
  autoLoad: true,
  /** If true, the video will start playing as soon as it is loaded. */
  autoPlay: true,
  /** The number of times a second to update the texture from the video. Leave at 0 to update at every render. */
  updateFPS: 0,
  /** If true, the video will be loaded with the `crossorigin` attribute. */
  crossorigin: true,
  /** If true, the video will loop when it ends. */
  loop: false,
  /** If true, the video will be muted. */
  muted: true,
  /** If true, the video will play inline. */
  playsinline: true,
  /** If true, the video will be preloaded. */
  preload: false
};
_VideoSource.MIME_TYPES = {
  ogv: "video/ogg",
  mov: "video/quicktime",
  m4v: "video/mp4"
};
let VideoSource = _VideoSource;
const convertToList = (input, transform, forceTransform = false) => {
  if (!Array.isArray(input)) {
    input = [input];
  }
  if (!transform) {
    return input;
  }
  return input.map((item) => {
    if (typeof item === "string" || forceTransform) {
      return transform(item);
    }
    return item;
  });
};
class CacheClass {
  constructor() {
    this._parsers = [];
    this._cache = /* @__PURE__ */ new Map();
    this._cacheMap = /* @__PURE__ */ new Map();
  }
  /** Clear all entries. */
  reset() {
    this._cacheMap.clear();
    this._cache.clear();
  }
  /**
   * Check if the key exists
   * @param key - The key to check
   */
  has(key) {
    return this._cache.has(key);
  }
  /**
   * Fetch entry by key
   * @param key - The key of the entry to get
   */
  get(key) {
    const result = this._cache.get(key);
    if (!result) {
      warn(`[Assets] Asset id ${key} was not found in the Cache`);
    }
    return result;
  }
  /**
   * Set a value by key or keys name
   * @param key - The key or keys to set
   * @param value - The value to store in the cache or from which cacheable assets will be derived.
   */
  set(key, value) {
    const keys = convertToList(key);
    let cacheableAssets;
    for (let i2 = 0; i2 < this.parsers.length; i2++) {
      const parser = this.parsers[i2];
      if (parser.test(value)) {
        cacheableAssets = parser.getCacheableAssets(keys, value);
        break;
      }
    }
    const cacheableMap = new Map(Object.entries(cacheableAssets || {}));
    if (!cacheableAssets) {
      keys.forEach((key2) => {
        cacheableMap.set(key2, value);
      });
    }
    const cacheKeys = [...cacheableMap.keys()];
    const cachedAssets = {
      cacheKeys,
      keys
    };
    keys.forEach((key2) => {
      this._cacheMap.set(key2, cachedAssets);
    });
    cacheKeys.forEach((key2) => {
      const val = cacheableAssets ? cacheableAssets[key2] : value;
      if (this._cache.has(key2) && this._cache.get(key2) !== val) {
        warn("[Cache] already has key:", key2);
      }
      this._cache.set(key2, cacheableMap.get(key2));
    });
  }
  /**
   * Remove entry by key
   *
   * This function will also remove any associated alias from the cache also.
   * @param key - The key of the entry to remove
   */
  remove(key) {
    if (!this._cacheMap.has(key)) {
      warn(`[Assets] Asset id ${key} was not found in the Cache`);
      return;
    }
    const cacheMap2 = this._cacheMap.get(key);
    const cacheKeys = cacheMap2.cacheKeys;
    cacheKeys.forEach((key2) => {
      this._cache.delete(key2);
    });
    cacheMap2.keys.forEach((key2) => {
      this._cacheMap.delete(key2);
    });
  }
  /** All loader parsers registered */
  get parsers() {
    return this._parsers;
  }
}
const Cache = new CacheClass();
const sources = [];
extensions.handleByList(ExtensionType.TextureSource, sources);
function textureSourceFrom(options = {}) {
  const hasResource = options && options.resource;
  const res = hasResource ? options.resource : options;
  const opts = hasResource ? options : { resource: options };
  for (let i2 = 0; i2 < sources.length; i2++) {
    const Source = sources[i2];
    if (Source.test(res)) {
      return new Source(opts);
    }
  }
  throw new Error(`Could not find a source type for resource: ${opts.resource}`);
}
function resourceToTexture(options = {}, skipCache = false) {
  const hasResource = options && options.resource;
  const resource = hasResource ? options.resource : options;
  const opts = hasResource ? options : { resource: options };
  if (!skipCache && Cache.has(resource)) {
    return Cache.get(resource);
  }
  const texture = new Texture({ source: textureSourceFrom(opts) });
  texture.on("destroy", () => {
    if (Cache.has(resource)) {
      Cache.remove(resource);
    }
  });
  if (!skipCache) {
    Cache.set(resource, texture);
  }
  return texture;
}
function textureFrom(id, skipCache = false) {
  if (typeof id === "string") {
    return Cache.get(id);
  } else if (id instanceof TextureSource) {
    return new Texture({ source: id });
  }
  return resourceToTexture(id, skipCache);
}
Texture.from = textureFrom;
TextureSource.from = textureSourceFrom;
extensions.add(AlphaMask, ColorMask, StencilMask, VideoSource, ImageSource, CanvasSource, BufferImageSource);
var LoaderParserPriority = /* @__PURE__ */ ((LoaderParserPriority2) => {
  LoaderParserPriority2[LoaderParserPriority2["Low"] = 0] = "Low";
  LoaderParserPriority2[LoaderParserPriority2["Normal"] = 1] = "Normal";
  LoaderParserPriority2[LoaderParserPriority2["High"] = 2] = "High";
  return LoaderParserPriority2;
})(LoaderParserPriority || {});
function assertPath(path2) {
  if (typeof path2 !== "string") {
    throw new TypeError(`Path must be a string. Received ${JSON.stringify(path2)}`);
  }
}
function removeUrlParams(url) {
  const re = url.split("?")[0];
  return re.split("#")[0];
}
function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function replaceAll(str, find, replace) {
  return str.replace(new RegExp(escapeRegExp(find), "g"), replace);
}
function normalizeStringPosix(path2, allowAboveRoot) {
  let res = "";
  let lastSegmentLength = 0;
  let lastSlash = -1;
  let dots = 0;
  let code = -1;
  for (let i2 = 0; i2 <= path2.length; ++i2) {
    if (i2 < path2.length) {
      code = path2.charCodeAt(i2);
    } else if (code === 47) {
      break;
    } else {
      code = 47;
    }
    if (code === 47) {
      if (lastSlash === i2 - 1 || dots === 1)
        ;
      else if (lastSlash !== i2 - 1 && dots === 2) {
        if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 || res.charCodeAt(res.length - 2) !== 46) {
          if (res.length > 2) {
            const lastSlashIndex = res.lastIndexOf("/");
            if (lastSlashIndex !== res.length - 1) {
              if (lastSlashIndex === -1) {
                res = "";
                lastSegmentLength = 0;
              } else {
                res = res.slice(0, lastSlashIndex);
                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
              }
              lastSlash = i2;
              dots = 0;
              continue;
            }
          } else if (res.length === 2 || res.length === 1) {
            res = "";
            lastSegmentLength = 0;
            lastSlash = i2;
            dots = 0;
            continue;
          }
        }
      } else {
        if (res.length > 0) {
          res += `/${path2.slice(lastSlash + 1, i2)}`;
        } else {
          res = path2.slice(lastSlash + 1, i2);
        }
        lastSegmentLength = i2 - lastSlash - 1;
      }
      lastSlash = i2;
      dots = 0;
    } else if (code === 46 && dots !== -1) {
      ++dots;
    } else {
      dots = -1;
    }
  }
  return res;
}
const path = {
  /**
   * Converts a path to posix format.
   * @param path - The path to convert to posix
   */
  toPosix(path2) {
    return replaceAll(path2, "\\", "/");
  },
  /**
   * Checks if the path is a URL e.g. http://, https://
   * @param path - The path to check
   */
  isUrl(path2) {
    return /^https?:/.test(this.toPosix(path2));
  },
  /**
   * Checks if the path is a data URL
   * @param path - The path to check
   */
  isDataUrl(path2) {
    return /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()_|~`]+)*)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s<>]*?)$/i.test(path2);
  },
  /**
   * Checks if the path is a blob URL
   * @param path - The path to check
   */
  isBlobUrl(path2) {
    return path2.startsWith("blob:");
  },
  /**
   * Checks if the path has a protocol e.g. http://, https://, file:///, data:, blob:, C:/
   * This will return true for windows file paths
   * @param path - The path to check
   */
  hasProtocol(path2) {
    return /^[^/:]+:/.test(this.toPosix(path2));
  },
  /**
   * Returns the protocol of the path e.g. http://, https://, file:///, data:, blob:, C:/
   * @param path - The path to get the protocol from
   */
  getProtocol(path2) {
    assertPath(path2);
    path2 = this.toPosix(path2);
    const matchFile = /^file:\/\/\//.exec(path2);
    if (matchFile) {
      return matchFile[0];
    }
    const matchProtocol = /^[^/:]+:\/{0,2}/.exec(path2);
    if (matchProtocol) {
      return matchProtocol[0];
    }
    return "";
  },
  /**
   * Converts URL to an absolute path.
   * When loading from a Web Worker, we must use absolute paths.
   * If the URL is already absolute we return it as is
   * If it's not, we convert it
   * @param url - The URL to test
   * @param customBaseUrl - The base URL to use
   * @param customRootUrl - The root URL to use
   */
  toAbsolute(url, customBaseUrl, customRootUrl) {
    assertPath(url);
    if (this.isDataUrl(url) || this.isBlobUrl(url))
      return url;
    const baseUrl = removeUrlParams(this.toPosix(customBaseUrl ?? DOMAdapter.get().getBaseUrl()));
    const rootUrl = removeUrlParams(this.toPosix(customRootUrl ?? this.rootname(baseUrl)));
    url = this.toPosix(url);
    if (url.startsWith("/")) {
      return path.join(rootUrl, url.slice(1));
    }
    const absolutePath = this.isAbsolute(url) ? url : this.join(baseUrl, url);
    return absolutePath;
  },
  /**
   * Normalizes the given path, resolving '..' and '.' segments
   * @param path - The path to normalize
   */
  normalize(path2) {
    assertPath(path2);
    if (path2.length === 0)
      return ".";
    if (this.isDataUrl(path2) || this.isBlobUrl(path2))
      return path2;
    path2 = this.toPosix(path2);
    let protocol = "";
    const isAbsolute = path2.startsWith("/");
    if (this.hasProtocol(path2)) {
      protocol = this.rootname(path2);
      path2 = path2.slice(protocol.length);
    }
    const trailingSeparator = path2.endsWith("/");
    path2 = normalizeStringPosix(path2);
    if (path2.length > 0 && trailingSeparator)
      path2 += "/";
    if (isAbsolute)
      return `/${path2}`;
    return protocol + path2;
  },
  /**
   * Determines if path is an absolute path.
   * Absolute paths can be urls, data urls, or paths on disk
   * @param path - The path to test
   */
  isAbsolute(path2) {
    assertPath(path2);
    path2 = this.toPosix(path2);
    if (this.hasProtocol(path2))
      return true;
    return path2.startsWith("/");
  },
  /**
   * Joins all given path segments together using the platform-specific separator as a delimiter,
   * then normalizes the resulting path
   * @param segments - The segments of the path to join
   */
  join(...segments) {
    if (segments.length === 0) {
      return ".";
    }
    let joined;
    for (let i2 = 0; i2 < segments.length; ++i2) {
      const arg = segments[i2];
      assertPath(arg);
      if (arg.length > 0) {
        if (joined === void 0)
          joined = arg;
        else {
          const prevArg = segments[i2 - 1] ?? "";
          if (this.joinExtensions.includes(this.extname(prevArg).toLowerCase())) {
            joined += `/../${arg}`;
          } else {
            joined += `/${arg}`;
          }
        }
      }
    }
    if (joined === void 0) {
      return ".";
    }
    return this.normalize(joined);
  },
  /**
   * Returns the directory name of a path
   * @param path - The path to parse
   */
  dirname(path2) {
    assertPath(path2);
    if (path2.length === 0)
      return ".";
    path2 = this.toPosix(path2);
    let code = path2.charCodeAt(0);
    const hasRoot = code === 47;
    let end = -1;
    let matchedSlash = true;
    const proto = this.getProtocol(path2);
    const origpath = path2;
    path2 = path2.slice(proto.length);
    for (let i2 = path2.length - 1; i2 >= 1; --i2) {
      code = path2.charCodeAt(i2);
      if (code === 47) {
        if (!matchedSlash) {
          end = i2;
          break;
        }
      } else {
        matchedSlash = false;
      }
    }
    if (end === -1)
      return hasRoot ? "/" : this.isUrl(origpath) ? proto + path2 : proto;
    if (hasRoot && end === 1)
      return "//";
    return proto + path2.slice(0, end);
  },
  /**
   * Returns the root of the path e.g. /, C:/, file:///, http://domain.com/
   * @param path - The path to parse
   */
  rootname(path2) {
    assertPath(path2);
    path2 = this.toPosix(path2);
    let root = "";
    if (path2.startsWith("/"))
      root = "/";
    else {
      root = this.getProtocol(path2);
    }
    if (this.isUrl(path2)) {
      const index = path2.indexOf("/", root.length);
      if (index !== -1) {
        root = path2.slice(0, index);
      } else
        root = path2;
      if (!root.endsWith("/"))
        root += "/";
    }
    return root;
  },
  /**
   * Returns the last portion of a path
   * @param path - The path to test
   * @param ext - Optional extension to remove
   */
  basename(path2, ext) {
    assertPath(path2);
    if (ext)
      assertPath(ext);
    path2 = removeUrlParams(this.toPosix(path2));
    let start = 0;
    let end = -1;
    let matchedSlash = true;
    let i2;
    if (ext !== void 0 && ext.length > 0 && ext.length <= path2.length) {
      if (ext.length === path2.length && ext === path2)
        return "";
      let extIdx = ext.length - 1;
      let firstNonSlashEnd = -1;
      for (i2 = path2.length - 1; i2 >= 0; --i2) {
        const code = path2.charCodeAt(i2);
        if (code === 47) {
          if (!matchedSlash) {
            start = i2 + 1;
            break;
          }
        } else {
          if (firstNonSlashEnd === -1) {
            matchedSlash = false;
            firstNonSlashEnd = i2 + 1;
          }
          if (extIdx >= 0) {
            if (code === ext.charCodeAt(extIdx)) {
              if (--extIdx === -1) {
                end = i2;
              }
            } else {
              extIdx = -1;
              end = firstNonSlashEnd;
            }
          }
        }
      }
      if (start === end)
        end = firstNonSlashEnd;
      else if (end === -1)
        end = path2.length;
      return path2.slice(start, end);
    }
    for (i2 = path2.length - 1; i2 >= 0; --i2) {
      if (path2.charCodeAt(i2) === 47) {
        if (!matchedSlash) {
          start = i2 + 1;
          break;
        }
      } else if (end === -1) {
        matchedSlash = false;
        end = i2 + 1;
      }
    }
    if (end === -1)
      return "";
    return path2.slice(start, end);
  },
  /**
   * Returns the extension of the path, from the last occurrence of the . (period) character to end of string in the last
   * portion of the path. If there is no . in the last portion of the path, or if there are no . characters other than
   * the first character of the basename of path, an empty string is returned.
   * @param path - The path to parse
   */
  extname(path2) {
    assertPath(path2);
    path2 = removeUrlParams(this.toPosix(path2));
    let startDot = -1;
    let startPart = 0;
    let end = -1;
    let matchedSlash = true;
    let preDotState = 0;
    for (let i2 = path2.length - 1; i2 >= 0; --i2) {
      const code = path2.charCodeAt(i2);
      if (code === 47) {
        if (!matchedSlash) {
          startPart = i2 + 1;
          break;
        }
        continue;
      }
      if (end === -1) {
        matchedSlash = false;
        end = i2 + 1;
      }
      if (code === 46) {
        if (startDot === -1)
          startDot = i2;
        else if (preDotState !== 1)
          preDotState = 1;
      } else if (startDot !== -1) {
        preDotState = -1;
      }
    }
    if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      return "";
    }
    return path2.slice(startDot, end);
  },
  /**
   * Parses a path into an object containing the 'root', `dir`, `base`, `ext`, and `name` properties.
   * @param path - The path to parse
   */
  parse(path2) {
    assertPath(path2);
    const ret = { root: "", dir: "", base: "", ext: "", name: "" };
    if (path2.length === 0)
      return ret;
    path2 = removeUrlParams(this.toPosix(path2));
    let code = path2.charCodeAt(0);
    const isAbsolute = this.isAbsolute(path2);
    let start;
    ret.root = this.rootname(path2);
    if (isAbsolute || this.hasProtocol(path2)) {
      start = 1;
    } else {
      start = 0;
    }
    let startDot = -1;
    let startPart = 0;
    let end = -1;
    let matchedSlash = true;
    let i2 = path2.length - 1;
    let preDotState = 0;
    for (; i2 >= start; --i2) {
      code = path2.charCodeAt(i2);
      if (code === 47) {
        if (!matchedSlash) {
          startPart = i2 + 1;
          break;
        }
        continue;
      }
      if (end === -1) {
        matchedSlash = false;
        end = i2 + 1;
      }
      if (code === 46) {
        if (startDot === -1)
          startDot = i2;
        else if (preDotState !== 1)
          preDotState = 1;
      } else if (startDot !== -1) {
        preDotState = -1;
      }
    }
    if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      if (end !== -1) {
        if (startPart === 0 && isAbsolute)
          ret.base = ret.name = path2.slice(1, end);
        else
          ret.base = ret.name = path2.slice(startPart, end);
      }
    } else {
      if (startPart === 0 && isAbsolute) {
        ret.name = path2.slice(1, startDot);
        ret.base = path2.slice(1, end);
      } else {
        ret.name = path2.slice(startPart, startDot);
        ret.base = path2.slice(startPart, end);
      }
      ret.ext = path2.slice(startDot, end);
    }
    ret.dir = this.dirname(path2);
    return ret;
  },
  sep: "/",
  delimiter: ":",
  joinExtensions: [".html"]
};
function processX(base, ids, depth, result, tags) {
  const id = ids[depth];
  for (let i2 = 0; i2 < id.length; i2++) {
    const value = id[i2];
    if (depth < ids.length - 1) {
      processX(base.replace(result[depth], value), ids, depth + 1, result, tags);
    } else {
      tags.push(base.replace(result[depth], value));
    }
  }
}
function createStringVariations(string) {
  const regex = /\{(.*?)\}/g;
  const result = string.match(regex);
  const tags = [];
  if (result) {
    const ids = [];
    result.forEach((vars) => {
      const split = vars.substring(1, vars.length - 1).split(",");
      ids.push(split);
    });
    processX(string, ids, 0, result, tags);
  } else {
    tags.push(string);
  }
  return tags;
}
const isSingleItem = (item) => !Array.isArray(item);
class Resolver {
  constructor() {
    this._defaultBundleIdentifierOptions = {
      connector: "-",
      createBundleAssetId: (bundleId, assetId) => `${bundleId}${this._bundleIdConnector}${assetId}`,
      extractAssetIdFromBundle: (bundleId, assetBundleId) => assetBundleId.replace(`${bundleId}${this._bundleIdConnector}`, "")
    };
    this._bundleIdConnector = this._defaultBundleIdentifierOptions.connector;
    this._createBundleAssetId = this._defaultBundleIdentifierOptions.createBundleAssetId;
    this._extractAssetIdFromBundle = this._defaultBundleIdentifierOptions.extractAssetIdFromBundle;
    this._assetMap = {};
    this._preferredOrder = [];
    this._parsers = [];
    this._resolverHash = {};
    this._bundles = {};
  }
  /**
   * Override how the resolver deals with generating bundle ids.
   * must be called before any bundles are added
   * @param bundleIdentifier - the bundle identifier options
   */
  setBundleIdentifier(bundleIdentifier) {
    this._bundleIdConnector = bundleIdentifier.connector ?? this._bundleIdConnector;
    this._createBundleAssetId = bundleIdentifier.createBundleAssetId ?? this._createBundleAssetId;
    this._extractAssetIdFromBundle = bundleIdentifier.extractAssetIdFromBundle ?? this._extractAssetIdFromBundle;
    if (this._extractAssetIdFromBundle("foo", this._createBundleAssetId("foo", "bar")) !== "bar") {
      throw new Error("[Resolver] GenerateBundleAssetId are not working correctly");
    }
  }
  /**
   * Let the resolver know which assets you prefer to use when resolving assets.
   * Multiple prefer user defined rules can be added.
   * @example
   * resolver.prefer({
   *     // first look for something with the correct format, and then then correct resolution
   *     priority: ['format', 'resolution'],
   *     params:{
   *         format:'webp', // prefer webp images
   *         resolution: 2, // prefer a resolution of 2
   *     }
   * })
   * resolver.add('foo', ['bar@2x.webp', 'bar@2x.png', 'bar.webp', 'bar.png']);
   * resolver.resolveUrl('foo') // => 'bar@2x.webp'
   * @param preferOrders - the prefer options
   */
  prefer(...preferOrders) {
    preferOrders.forEach((prefer) => {
      this._preferredOrder.push(prefer);
      if (!prefer.priority) {
        prefer.priority = Object.keys(prefer.params);
      }
    });
    this._resolverHash = {};
  }
  /**
   * Set the base path to prepend to all urls when resolving
   * @example
   * resolver.basePath = 'https://home.com/';
   * resolver.add('foo', 'bar.ong');
   * resolver.resolveUrl('foo', 'bar.png'); // => 'https://home.com/bar.png'
   * @param basePath - the base path to use
   */
  set basePath(basePath) {
    this._basePath = basePath;
  }
  get basePath() {
    return this._basePath;
  }
  /**
   * Set the root path for root-relative URLs. By default the `basePath`'s root is used. If no `basePath` is set, then the
   * default value for browsers is `window.location.origin`
   * @example
   * // Application hosted on https://home.com/some-path/index.html
   * resolver.basePath = 'https://home.com/some-path/';
   * resolver.rootPath = 'https://home.com/';
   * resolver.add('foo', '/bar.png');
   * resolver.resolveUrl('foo', '/bar.png'); // => 'https://home.com/bar.png'
   * @param rootPath - the root path to use
   */
  set rootPath(rootPath) {
    this._rootPath = rootPath;
  }
  get rootPath() {
    return this._rootPath;
  }
  /**
   * All the active URL parsers that help the parser to extract information and create
   * an asset object-based on parsing the URL itself.
   *
   * Can be added using the extensions API
   * @example
   * resolver.add('foo', [
   *     {
   *         resolution: 2,
   *         format: 'png',
   *         src: 'image@2x.png',
   *     },
   *     {
   *         resolution:1,
   *         format:'png',
   *         src: 'image.png',
   *     },
   * ]);
   *
   * // With a url parser the information such as resolution and file format could extracted from the url itself:
   * extensions.add({
   *     extension: ExtensionType.ResolveParser,
   *     test: loadTextures.test, // test if url ends in an image
   *     parse: (value: string) =>
   *     ({
   *         resolution: parseFloat(Resolver.RETINA_PREFIX.exec(value)?.[1] ?? '1'),
   *         format: value.split('.').pop(),
   *         src: value,
   *     }),
   * });
   *
   * // Now resolution and format can be extracted from the url
   * resolver.add('foo', [
   *     'image@2x.png',
   *     'image.png',
   * ]);
   */
  get parsers() {
    return this._parsers;
  }
  /** Used for testing, this resets the resolver to its initial state */
  reset() {
    this.setBundleIdentifier(this._defaultBundleIdentifierOptions);
    this._assetMap = {};
    this._preferredOrder = [];
    this._resolverHash = {};
    this._rootPath = null;
    this._basePath = null;
    this._manifest = null;
    this._bundles = {};
    this._defaultSearchParams = null;
  }
  /**
   * Sets the default URL search parameters for the URL resolver. The urls can be specified as a string or an object.
   * @param searchParams - the default url parameters to append when resolving urls
   */
  setDefaultSearchParams(searchParams) {
    if (typeof searchParams === "string") {
      this._defaultSearchParams = searchParams;
    } else {
      const queryValues = searchParams;
      this._defaultSearchParams = Object.keys(queryValues).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(queryValues[key])}`).join("&");
    }
  }
  /**
   * Returns the aliases for a given asset
   * @param asset - the asset to get the aliases for
   */
  getAlias(asset) {
    const { alias, src } = asset;
    const aliasesToUse = convertToList(
      alias || src,
      (value) => {
        if (typeof value === "string")
          return value;
        if (Array.isArray(value))
          return value.map((v2) => v2?.src ?? v2);
        if (value?.src)
          return value.src;
        return value;
      },
      true
    );
    return aliasesToUse;
  }
  /**
   * Add a manifest to the asset resolver. This is a nice way to add all the asset information in one go.
   * generally a manifest would be built using a tool.
   * @param manifest - the manifest to add to the resolver
   */
  addManifest(manifest) {
    if (this._manifest) {
      warn("[Resolver] Manifest already exists, this will be overwritten");
    }
    this._manifest = manifest;
    manifest.bundles.forEach((bundle) => {
      this.addBundle(bundle.name, bundle.assets);
    });
  }
  /**
   * This adds a bundle of assets in one go so that you can resolve them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * resolver.addBundle('animals', [
   *  { alias: 'bunny', src: 'bunny.png' },
   *  { alias: 'chicken', src: 'chicken.png' },
   *  { alias: 'thumper', src: 'thumper.png' },
   * ]);
   * // or
   * resolver.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const resolvedAssets = await resolver.resolveBundle('animals');
   * @param bundleId - The id of the bundle to add
   * @param assets - A record of the asset or assets that will be chosen from when loading via the specified key
   */
  addBundle(bundleId, assets) {
    const assetNames = [];
    let convertedAssets = assets;
    if (!Array.isArray(assets)) {
      convertedAssets = Object.entries(assets).map(([alias, src]) => {
        if (typeof src === "string" || Array.isArray(src)) {
          return { alias, src };
        }
        return { alias, ...src };
      });
    }
    convertedAssets.forEach((asset) => {
      const srcs = asset.src;
      const aliases = asset.alias;
      let ids;
      if (typeof aliases === "string") {
        const bundleAssetId = this._createBundleAssetId(bundleId, aliases);
        assetNames.push(bundleAssetId);
        ids = [aliases, bundleAssetId];
      } else {
        const bundleIds = aliases.map((name) => this._createBundleAssetId(bundleId, name));
        assetNames.push(...bundleIds);
        ids = [...aliases, ...bundleIds];
      }
      this.add({
        ...asset,
        ...{
          alias: ids,
          src: srcs
        }
      });
    });
    this._bundles[bundleId] = assetNames;
  }
  /**
   * Tells the resolver what keys are associated with witch asset.
   * The most important thing the resolver does
   * @example
   * // Single key, single asset:
   * resolver.add({alias: 'foo', src: 'bar.png');
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Multiple keys, single asset:
   * resolver.add({alias: ['foo', 'boo'], src: 'bar.png'});
   * resolver.resolveUrl('foo') // => 'bar.png'
   * resolver.resolveUrl('boo') // => 'bar.png'
   *
   * // Multiple keys, multiple assets:
   * resolver.add({alias: ['foo', 'boo'], src: ['bar.png', 'bar.webp']});
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Add custom data attached to the resolver
   * Resolver.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny{png,webp}',
   *     data: { scaleMode:SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * resolver.resolve('bunnyBooBooSmooth') // => { src: 'bunny.png', data: { scaleMode: SCALE_MODES.NEAREST } }
   * @param aliases - the UnresolvedAsset or array of UnresolvedAssets to add to the resolver
   */
  add(aliases) {
    const assets = [];
    if (Array.isArray(aliases)) {
      assets.push(...aliases);
    } else {
      assets.push(aliases);
    }
    let keyCheck;
    keyCheck = (key) => {
      if (this.hasKey(key)) {
        warn(`[Resolver] already has key: ${key} overwriting`);
      }
    };
    const assetArray = convertToList(assets);
    assetArray.forEach((asset) => {
      const { src } = asset;
      let { data, format, loadParser } = asset;
      const srcsToUse = convertToList(src).map((src2) => {
        if (typeof src2 === "string") {
          return createStringVariations(src2);
        }
        return Array.isArray(src2) ? src2 : [src2];
      });
      const aliasesToUse = this.getAlias(asset);
      Array.isArray(aliasesToUse) ? aliasesToUse.forEach(keyCheck) : keyCheck(aliasesToUse);
      const resolvedAssets = [];
      srcsToUse.forEach((srcs) => {
        srcs.forEach((src2) => {
          let formattedAsset = {};
          if (typeof src2 !== "object") {
            formattedAsset.src = src2;
            for (let i2 = 0; i2 < this._parsers.length; i2++) {
              const parser = this._parsers[i2];
              if (parser.test(src2)) {
                formattedAsset = parser.parse(src2);
                break;
              }
            }
          } else {
            data = src2.data ?? data;
            format = src2.format ?? format;
            loadParser = src2.loadParser ?? loadParser;
            formattedAsset = {
              ...formattedAsset,
              ...src2
            };
          }
          if (!aliasesToUse) {
            throw new Error(`[Resolver] alias is undefined for this asset: ${formattedAsset.src}`);
          }
          formattedAsset = this._buildResolvedAsset(formattedAsset, {
            aliases: aliasesToUse,
            data,
            format,
            loadParser
          });
          resolvedAssets.push(formattedAsset);
        });
      });
      aliasesToUse.forEach((alias) => {
        this._assetMap[alias] = resolvedAssets;
      });
    });
  }
  // TODO: this needs an overload like load did in Assets
  /**
   * If the resolver has had a manifest set via setManifest, this will return the assets urls for
   * a given bundleId or bundleIds.
   * @example
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * resolver.setManifest(manifest);
   * const resolved = resolver.resolveBundle('load-screen');
   * @param bundleIds - The bundle ids to resolve
   * @returns All the bundles assets or a hash of assets for each bundle specified
   */
  resolveBundle(bundleIds) {
    const singleAsset = isSingleItem(bundleIds);
    bundleIds = convertToList(bundleIds);
    const out2 = {};
    bundleIds.forEach((bundleId) => {
      const assetNames = this._bundles[bundleId];
      if (assetNames) {
        const results = this.resolve(assetNames);
        const assets = {};
        for (const key in results) {
          const asset = results[key];
          assets[this._extractAssetIdFromBundle(bundleId, key)] = asset;
        }
        out2[bundleId] = assets;
      }
    });
    return singleAsset ? out2[bundleIds[0]] : out2;
  }
  /**
   * Does exactly what resolve does, but returns just the URL rather than the whole asset object
   * @param key - The key or keys to resolve
   * @returns - The URLs associated with the key(s)
   */
  resolveUrl(key) {
    const result = this.resolve(key);
    if (typeof key !== "string") {
      const out2 = {};
      for (const i2 in result) {
        out2[i2] = result[i2].src;
      }
      return out2;
    }
    return result.src;
  }
  resolve(keys) {
    const singleAsset = isSingleItem(keys);
    keys = convertToList(keys);
    const result = {};
    keys.forEach((key) => {
      if (!this._resolverHash[key]) {
        if (this._assetMap[key]) {
          let assets = this._assetMap[key];
          const preferredOrder = this._getPreferredOrder(assets);
          preferredOrder?.priority.forEach((priorityKey) => {
            preferredOrder.params[priorityKey].forEach((value) => {
              const filteredAssets = assets.filter((asset) => {
                if (asset[priorityKey]) {
                  return asset[priorityKey] === value;
                }
                return false;
              });
              if (filteredAssets.length) {
                assets = filteredAssets;
              }
            });
          });
          this._resolverHash[key] = assets[0];
        } else {
          this._resolverHash[key] = this._buildResolvedAsset({
            alias: [key],
            src: key
          }, {});
        }
      }
      result[key] = this._resolverHash[key];
    });
    return singleAsset ? result[keys[0]] : result;
  }
  /**
   * Checks if an asset with a given key exists in the resolver
   * @param key - The key of the asset
   */
  hasKey(key) {
    return !!this._assetMap[key];
  }
  /**
   * Checks if a bundle with the given key exists in the resolver
   * @param key - The key of the bundle
   */
  hasBundle(key) {
    return !!this._bundles[key];
  }
  /**
   * Internal function for figuring out what prefer criteria an asset should use.
   * @param assets
   */
  _getPreferredOrder(assets) {
    for (let i2 = 0; i2 < assets.length; i2++) {
      const asset = assets[i2];
      const preferred = this._preferredOrder.find((preference) => preference.params.format.includes(asset.format));
      if (preferred) {
        return preferred;
      }
    }
    return this._preferredOrder[0];
  }
  /**
   * Appends the default url parameters to the url
   * @param url - The url to append the default parameters to
   * @returns - The url with the default parameters appended
   */
  _appendDefaultSearchParams(url) {
    if (!this._defaultSearchParams)
      return url;
    const paramConnector = /\?/.test(url) ? "&" : "?";
    return `${url}${paramConnector}${this._defaultSearchParams}`;
  }
  _buildResolvedAsset(formattedAsset, data) {
    const { aliases, data: assetData, loadParser, format } = data;
    if (this._basePath || this._rootPath) {
      formattedAsset.src = path.toAbsolute(formattedAsset.src, this._basePath, this._rootPath);
    }
    formattedAsset.alias = aliases ?? formattedAsset.alias ?? [formattedAsset.src];
    formattedAsset.src = this._appendDefaultSearchParams(formattedAsset.src);
    formattedAsset.data = { ...assetData || {}, ...formattedAsset.data };
    formattedAsset.loadParser = loadParser ?? formattedAsset.loadParser;
    formattedAsset.format = format ?? formattedAsset.format ?? getUrlExtension(formattedAsset.src);
    return formattedAsset;
  }
}
Resolver.RETINA_PREFIX = /@([0-9\.]+)x/;
function getUrlExtension(url) {
  return url.split(".").pop().split("?").shift().split("#").shift();
}
const copySearchParams = (targetUrl, sourceUrl) => {
  const searchParams = sourceUrl.split("?")[1];
  if (searchParams) {
    targetUrl += `?${searchParams}`;
  }
  return targetUrl;
};
const _Spritesheet = class _Spritesheet2 {
  /**
   * @param texture - Reference to the source BaseTexture object.
   * @param {object} data - Spritesheet image data.
   */
  constructor(texture, data) {
    this.linkedSheets = [];
    this._texture = texture instanceof Texture ? texture : null;
    this.textureSource = texture.source;
    this.textures = {};
    this.animations = {};
    this.data = data;
    const metaResolution = parseFloat(data.meta.scale);
    if (metaResolution) {
      this.resolution = metaResolution;
      texture.source.resolution = this.resolution;
    } else {
      this.resolution = texture.source._resolution;
    }
    this._frames = this.data.frames;
    this._frameKeys = Object.keys(this._frames);
    this._batchIndex = 0;
    this._callback = null;
  }
  /**
   * Parser spritesheet from loaded data. This is done asynchronously
   * to prevent creating too many Texture within a single process.
   */
  parse() {
    return new Promise((resolve) => {
      this._callback = resolve;
      this._batchIndex = 0;
      if (this._frameKeys.length <= _Spritesheet2.BATCH_SIZE) {
        this._processFrames(0);
        this._processAnimations();
        this._parseComplete();
      } else {
        this._nextBatch();
      }
    });
  }
  /**
   * Process a batch of frames
   * @param initialFrameIndex - The index of frame to start.
   */
  _processFrames(initialFrameIndex) {
    let frameIndex = initialFrameIndex;
    const maxFrames = _Spritesheet2.BATCH_SIZE;
    while (frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length) {
      const i2 = this._frameKeys[frameIndex];
      const data = this._frames[i2];
      const rect = data.frame;
      if (rect) {
        let frame = null;
        let trim = null;
        const sourceSize = data.trimmed !== false && data.sourceSize ? data.sourceSize : data.frame;
        const orig = new Rectangle(
          0,
          0,
          Math.floor(sourceSize.w) / this.resolution,
          Math.floor(sourceSize.h) / this.resolution
        );
        if (data.rotated) {
          frame = new Rectangle(
            Math.floor(rect.x) / this.resolution,
            Math.floor(rect.y) / this.resolution,
            Math.floor(rect.h) / this.resolution,
            Math.floor(rect.w) / this.resolution
          );
        } else {
          frame = new Rectangle(
            Math.floor(rect.x) / this.resolution,
            Math.floor(rect.y) / this.resolution,
            Math.floor(rect.w) / this.resolution,
            Math.floor(rect.h) / this.resolution
          );
        }
        if (data.trimmed !== false && data.spriteSourceSize) {
          trim = new Rectangle(
            Math.floor(data.spriteSourceSize.x) / this.resolution,
            Math.floor(data.spriteSourceSize.y) / this.resolution,
            Math.floor(rect.w) / this.resolution,
            Math.floor(rect.h) / this.resolution
          );
        }
        this.textures[i2] = new Texture({
          source: this.textureSource,
          frame,
          orig,
          trim,
          rotate: data.rotated ? 2 : 0,
          defaultAnchor: data.anchor,
          defaultBorders: data.borders,
          label: i2.toString()
        });
      }
      frameIndex++;
    }
  }
  /** Parse animations config. */
  _processAnimations() {
    const animations = this.data.animations || {};
    for (const animName in animations) {
      this.animations[animName] = [];
      for (let i2 = 0; i2 < animations[animName].length; i2++) {
        const frameName = animations[animName][i2];
        this.animations[animName].push(this.textures[frameName]);
      }
    }
  }
  /** The parse has completed. */
  _parseComplete() {
    const callback = this._callback;
    this._callback = null;
    this._batchIndex = 0;
    callback.call(this, this.textures);
  }
  /** Begin the next batch of textures. */
  _nextBatch() {
    this._processFrames(this._batchIndex * _Spritesheet2.BATCH_SIZE);
    this._batchIndex++;
    setTimeout(() => {
      if (this._batchIndex * _Spritesheet2.BATCH_SIZE < this._frameKeys.length) {
        this._nextBatch();
      } else {
        this._processAnimations();
        this._parseComplete();
      }
    }, 0);
  }
  /**
   * Destroy Spritesheet and don't use after this.
   * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
   */
  destroy(destroyBase = false) {
    for (const i2 in this.textures) {
      this.textures[i2].destroy();
    }
    this._frames = null;
    this._frameKeys = null;
    this.data = null;
    this.textures = null;
    if (destroyBase) {
      this._texture?.destroy();
      this.textureSource.destroy();
    }
    this._texture = null;
    this.textureSource = null;
    this.linkedSheets = [];
  }
};
_Spritesheet.BATCH_SIZE = 1e3;
let Spritesheet = _Spritesheet;
const validImages = [
  "jpg",
  "png",
  "jpeg",
  "avif",
  "webp",
  "basis",
  "etc2",
  "bc7",
  "bc6h",
  "bc5",
  "bc4",
  "bc3",
  "bc2",
  "bc1",
  "eac",
  "astc"
];
function getCacheableAssets(keys, asset, ignoreMultiPack) {
  const out2 = {};
  keys.forEach((key) => {
    out2[key] = asset;
  });
  Object.keys(asset.textures).forEach((key) => {
    out2[key] = asset.textures[key];
  });
  if (!ignoreMultiPack) {
    const basePath = path.dirname(keys[0]);
    asset.linkedSheets.forEach((item, i2) => {
      const out22 = getCacheableAssets([`${basePath}/${asset.data.meta.related_multi_packs[i2]}`], item, true);
      Object.assign(out2, out22);
    });
  }
  return out2;
}
const spritesheetAsset = {
  extension: ExtensionType.Asset,
  /** Handle the caching of the related Spritesheet Textures */
  cache: {
    test: (asset) => asset instanceof Spritesheet,
    getCacheableAssets: (keys, asset) => getCacheableAssets(keys, asset, false)
  },
  /** Resolve the resolution of the asset. */
  resolver: {
    extension: {
      type: ExtensionType.ResolveParser,
      name: "resolveSpritesheet"
    },
    test: (value) => {
      const tempURL = value.split("?")[0];
      const split = tempURL.split(".");
      const extension = split.pop();
      const format = split.pop();
      return extension === "json" && validImages.includes(format);
    },
    parse: (value) => {
      const split = value.split(".");
      return {
        resolution: parseFloat(Resolver.RETINA_PREFIX.exec(value)?.[1] ?? "1"),
        format: split[split.length - 2],
        src: value
      };
    }
  },
  /**
   * Loader plugin that parses sprite sheets!
   * once the JSON has been loaded this checks to see if the JSON is spritesheet data.
   * If it is, we load the spritesheets image and parse the data into Spritesheet
   * All textures in the sprite sheet are then added to the cache
   */
  loader: {
    name: "spritesheetLoader",
    extension: {
      type: ExtensionType.LoadParser,
      priority: LoaderParserPriority.Normal,
      name: "spritesheetLoader"
    },
    async testParse(asset, options) {
      return path.extname(options.src).toLowerCase() === ".json" && !!asset.frames;
    },
    async parse(asset, options, loader) {
      const {
        texture: imageTexture,
        // if user need to use preloaded texture
        imageFilename,
        // if user need to use custom filename (not from jsonFile.meta.image)
        textureOptions
        // if user need to set texture options on texture
      } = options?.data ?? {};
      let basePath = path.dirname(options.src);
      if (basePath && basePath.lastIndexOf("/") !== basePath.length - 1) {
        basePath += "/";
      }
      let texture;
      if (imageTexture instanceof Texture) {
        texture = imageTexture;
      } else {
        const imagePath = copySearchParams(basePath + (imageFilename ?? asset.meta.image), options.src);
        const assets = await loader.load([{ src: imagePath, data: textureOptions }]);
        texture = assets[imagePath];
      }
      const spritesheet = new Spritesheet(
        texture.source,
        asset
      );
      await spritesheet.parse();
      const multiPacks = asset?.meta?.related_multi_packs;
      if (Array.isArray(multiPacks)) {
        const promises = [];
        for (const item of multiPacks) {
          if (typeof item !== "string") {
            continue;
          }
          let itemUrl = basePath + item;
          if (options.data?.ignoreMultiPack) {
            continue;
          }
          itemUrl = copySearchParams(itemUrl, options.src);
          promises.push(loader.load({
            src: itemUrl,
            data: {
              ignoreMultiPack: true
            }
          }));
        }
        const res = await Promise.all(promises);
        spritesheet.linkedSheets = res;
        res.forEach((item) => {
          item.linkedSheets = [spritesheet].concat(spritesheet.linkedSheets.filter((sp) => sp !== item));
        });
      }
      return spritesheet;
    },
    async unload(spritesheet, _resolvedAsset, loader) {
      await loader.unload(spritesheet.textureSource._sourceOrigin);
      spritesheet.destroy(false);
    }
  }
};
extensions.add(spritesheetAsset);
const idCounts = /* @__PURE__ */ Object.create(null);
const idHash = /* @__PURE__ */ Object.create(null);
function createIdFromString(value, groupId) {
  let id = idHash[value];
  if (id === void 0) {
    if (idCounts[groupId] === void 0) {
      idCounts[groupId] = 1;
    }
    idHash[value] = id = idCounts[groupId]++;
  }
  return id;
}
let context;
function getTestContext() {
  if (!context || context?.isContextLost()) {
    const canvas = DOMAdapter.get().createCanvas();
    context = canvas.getContext("webgl", {});
  }
  return context;
}
let maxFragmentPrecision;
function getMaxFragmentPrecision() {
  if (!maxFragmentPrecision) {
    maxFragmentPrecision = "mediump";
    const gl = getTestContext();
    if (gl) {
      if (gl.getShaderPrecisionFormat) {
        const shaderFragment = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);
        maxFragmentPrecision = shaderFragment.precision ? "highp" : "mediump";
      }
    }
  }
  return maxFragmentPrecision;
}
function addProgramDefines(src, isES300, isFragment) {
  if (isES300)
    return src;
  if (isFragment) {
    src = src.replace("out vec4 finalColor;", "");
    return `
        
        #ifdef GL_ES // This checks if it is WebGL1
        #define in varying
        #define finalColor gl_FragColor
        #define texture texture2D
        #endif
        ${src}
        `;
  }
  return `
        
        #ifdef GL_ES // This checks if it is WebGL1
        #define in attribute
        #define out varying
        #endif
        ${src}
        `;
}
function ensurePrecision(src, options, isFragment) {
  const maxSupportedPrecision = isFragment ? options.maxSupportedFragmentPrecision : options.maxSupportedVertexPrecision;
  if (src.substring(0, 9) !== "precision") {
    let precision = isFragment ? options.requestedFragmentPrecision : options.requestedVertexPrecision;
    if (precision === "highp" && maxSupportedPrecision !== "highp") {
      precision = "mediump";
    }
    return `precision ${precision} float;
${src}`;
  } else if (maxSupportedPrecision !== "highp" && src.substring(0, 15) === "precision highp") {
    return src.replace("precision highp", "precision mediump");
  }
  return src;
}
function insertVersion(src, isES300) {
  if (!isES300)
    return src;
  return `#version 300 es
${src}`;
}
const fragmentNameCache = {};
const VertexNameCache = {};
function setProgramName(src, { name = `pixi-program` }, isFragment = true) {
  name = name.replace(/\s+/g, "-");
  name += isFragment ? "-fragment" : "-vertex";
  const nameCache = isFragment ? fragmentNameCache : VertexNameCache;
  if (nameCache[name]) {
    nameCache[name]++;
    name += `-${nameCache[name]}`;
  } else {
    nameCache[name] = 1;
  }
  if (src.indexOf("#define SHADER_NAME") !== -1)
    return src;
  const shaderName = `#define SHADER_NAME ${name}`;
  return `${shaderName}
${src}`;
}
function stripVersion(src, isES300) {
  if (!isES300)
    return src;
  return src.replace("#version 300 es", "");
}
const processes = {
  // strips any version headers..
  stripVersion,
  // adds precision string if not already present
  ensurePrecision,
  // add some defines if WebGL1 to make it more compatible with WebGL2 shaders
  addProgramDefines,
  // add the program name to the shader
  setProgramName,
  // add the version string to the shader header
  insertVersion
};
const programCache$1 = /* @__PURE__ */ Object.create(null);
const _GlProgram = class _GlProgram2 {
  /**
   * Creates a shiny new GlProgram. Used by WebGL renderer.
   * @param options - The options for the program.
   */
  constructor(options) {
    options = { ..._GlProgram2.defaultOptions, ...options };
    const isES300 = options.fragment.indexOf("#version 300 es") !== -1;
    const preprocessorOptions = {
      stripVersion: isES300,
      ensurePrecision: {
        requestedFragmentPrecision: options.preferredFragmentPrecision,
        requestedVertexPrecision: options.preferredVertexPrecision,
        maxSupportedVertexPrecision: "highp",
        maxSupportedFragmentPrecision: getMaxFragmentPrecision()
      },
      setProgramName: {
        name: options.name
      },
      addProgramDefines: isES300,
      insertVersion: isES300
    };
    let fragment2 = options.fragment;
    let vertex2 = options.vertex;
    Object.keys(processes).forEach((processKey) => {
      const processOptions = preprocessorOptions[processKey];
      fragment2 = processes[processKey](fragment2, processOptions, true);
      vertex2 = processes[processKey](vertex2, processOptions, false);
    });
    this.fragment = fragment2;
    this.vertex = vertex2;
    this.transformFeedbackVaryings = options.transformFeedbackVaryings;
    this._key = createIdFromString(`${this.vertex}:${this.fragment}`, "gl-program");
  }
  /** destroys the program */
  destroy() {
    this.fragment = null;
    this.vertex = null;
    this._attributeData = null;
    this._uniformData = null;
    this._uniformBlockData = null;
    this.transformFeedbackVaryings = null;
  }
  /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */
  static from(options) {
    const key = `${options.vertex}:${options.fragment}`;
    if (!programCache$1[key]) {
      programCache$1[key] = new _GlProgram2(options);
    }
    return programCache$1[key];
  }
};
_GlProgram.defaultOptions = {
  preferredVertexPrecision: "highp",
  preferredFragmentPrecision: "mediump"
};
let GlProgram = _GlProgram;
const attributeFormatData = {
  uint8x2: { size: 2, stride: 2, normalised: false },
  uint8x4: { size: 4, stride: 4, normalised: false },
  sint8x2: { size: 2, stride: 2, normalised: false },
  sint8x4: { size: 4, stride: 4, normalised: false },
  unorm8x2: { size: 2, stride: 2, normalised: true },
  unorm8x4: { size: 4, stride: 4, normalised: true },
  snorm8x2: { size: 2, stride: 2, normalised: true },
  snorm8x4: { size: 4, stride: 4, normalised: true },
  uint16x2: { size: 2, stride: 4, normalised: false },
  uint16x4: { size: 4, stride: 8, normalised: false },
  sint16x2: { size: 2, stride: 4, normalised: false },
  sint16x4: { size: 4, stride: 8, normalised: false },
  unorm16x2: { size: 2, stride: 4, normalised: true },
  unorm16x4: { size: 4, stride: 8, normalised: true },
  snorm16x2: { size: 2, stride: 4, normalised: true },
  snorm16x4: { size: 4, stride: 8, normalised: true },
  float16x2: { size: 2, stride: 4, normalised: false },
  float16x4: { size: 4, stride: 8, normalised: false },
  float32: { size: 1, stride: 4, normalised: false },
  float32x2: { size: 2, stride: 8, normalised: false },
  float32x3: { size: 3, stride: 12, normalised: false },
  float32x4: { size: 4, stride: 16, normalised: false },
  uint32: { size: 1, stride: 4, normalised: false },
  uint32x2: { size: 2, stride: 8, normalised: false },
  uint32x3: { size: 3, stride: 12, normalised: false },
  uint32x4: { size: 4, stride: 16, normalised: false },
  sint32: { size: 1, stride: 4, normalised: false },
  sint32x2: { size: 2, stride: 8, normalised: false },
  sint32x3: { size: 3, stride: 12, normalised: false },
  sint32x4: { size: 4, stride: 16, normalised: false }
};
function getAttributeInfoFromFormat(format) {
  return attributeFormatData[format] ?? attributeFormatData.float32;
}
const WGSL_TO_VERTEX_TYPES = {
  f32: "float32",
  "vec2<f32>": "float32x2",
  "vec3<f32>": "float32x3",
  "vec4<f32>": "float32x4",
  vec2f: "float32x2",
  vec3f: "float32x3",
  vec4f: "float32x4",
  i32: "sint32",
  "vec2<i32>": "sint32x2",
  "vec3<i32>": "sint32x3",
  "vec4<i32>": "sint32x4",
  u32: "uint32",
  "vec2<u32>": "uint32x2",
  "vec3<u32>": "uint32x3",
  "vec4<u32>": "uint32x4",
  bool: "uint32",
  "vec2<bool>": "uint32x2",
  "vec3<bool>": "uint32x3",
  "vec4<bool>": "uint32x4"
};
function extractAttributesFromGpuProgram({ source: source2, entryPoint }) {
  const results = {};
  const mainVertStart = source2.indexOf(`fn ${entryPoint}`);
  if (mainVertStart !== -1) {
    const arrowFunctionStart = source2.indexOf("->", mainVertStart);
    if (arrowFunctionStart !== -1) {
      const functionArgsSubstring = source2.substring(mainVertStart, arrowFunctionStart);
      const inputsRegex = /@location\((\d+)\)\s+([a-zA-Z0-9_]+)\s*:\s*([a-zA-Z0-9_<>]+)(?:,|\s|$)/g;
      let match;
      while ((match = inputsRegex.exec(functionArgsSubstring)) !== null) {
        const format = WGSL_TO_VERTEX_TYPES[match[3]] ?? "float32";
        results[match[2]] = {
          location: parseInt(match[1], 10),
          format,
          stride: getAttributeInfoFromFormat(format).stride,
          offset: 0,
          instance: false,
          start: 0
        };
      }
    }
  }
  return results;
}
function extractStructAndGroups(wgsl) {
  const linePattern = /(^|[^/])@(group|binding)\(\d+\)[^;]+;/g;
  const groupPattern = /@group\((\d+)\)/;
  const bindingPattern = /@binding\((\d+)\)/;
  const namePattern = /var(<[^>]+>)? (\w+)/;
  const typePattern = /:\s*(\w+)/;
  const structPattern = /struct\s+(\w+)\s*{([^}]+)}/g;
  const structMemberPattern = /(\w+)\s*:\s*([\w\<\>]+)/g;
  const structName = /struct\s+(\w+)/;
  const groups = wgsl.match(linePattern)?.map((item) => ({
    group: parseInt(item.match(groupPattern)[1], 10),
    binding: parseInt(item.match(bindingPattern)[1], 10),
    name: item.match(namePattern)[2],
    isUniform: item.match(namePattern)[1] === "<uniform>",
    type: item.match(typePattern)[1]
  }));
  if (!groups) {
    return {
      groups: [],
      structs: []
    };
  }
  const structs = wgsl.match(structPattern)?.map((struct) => {
    const name = struct.match(structName)[1];
    const members = struct.match(structMemberPattern).reduce((acc, member) => {
      const [name2, type] = member.split(":");
      acc[name2.trim()] = type.trim();
      return acc;
    }, {});
    if (!members) {
      return null;
    }
    return { name, members };
  }).filter(({ name }) => groups.some((group) => group.type === name)) ?? [];
  return {
    groups,
    structs
  };
}
var ShaderStage = /* @__PURE__ */ ((ShaderStage2) => {
  ShaderStage2[ShaderStage2["VERTEX"] = 1] = "VERTEX";
  ShaderStage2[ShaderStage2["FRAGMENT"] = 2] = "FRAGMENT";
  ShaderStage2[ShaderStage2["COMPUTE"] = 4] = "COMPUTE";
  return ShaderStage2;
})(ShaderStage || {});
function generateGpuLayoutGroups({ groups }) {
  const layout = [];
  for (let i2 = 0; i2 < groups.length; i2++) {
    const group = groups[i2];
    if (!layout[group.group]) {
      layout[group.group] = [];
    }
    if (group.isUniform) {
      layout[group.group].push({
        binding: group.binding,
        visibility: ShaderStage.VERTEX | ShaderStage.FRAGMENT,
        buffer: {
          type: "uniform"
        }
      });
    } else if (group.type === "sampler") {
      layout[group.group].push({
        binding: group.binding,
        visibility: ShaderStage.FRAGMENT,
        sampler: {
          type: "filtering"
        }
      });
    } else if (group.type === "texture_2d") {
      layout[group.group].push({
        binding: group.binding,
        visibility: ShaderStage.FRAGMENT,
        texture: {
          sampleType: "float",
          viewDimension: "2d",
          multisampled: false
        }
      });
    }
  }
  return layout;
}
function generateLayoutHash({ groups }) {
  const layout = [];
  for (let i2 = 0; i2 < groups.length; i2++) {
    const group = groups[i2];
    if (!layout[group.group]) {
      layout[group.group] = {};
    }
    layout[group.group][group.name] = group.binding;
  }
  return layout;
}
function removeStructAndGroupDuplicates(vertexStructsAndGroups, fragmentStructsAndGroups) {
  const structNameSet = /* @__PURE__ */ new Set();
  const dupeGroupKeySet = /* @__PURE__ */ new Set();
  const structs = [...vertexStructsAndGroups.structs, ...fragmentStructsAndGroups.structs].filter((struct) => {
    if (structNameSet.has(struct.name)) {
      return false;
    }
    structNameSet.add(struct.name);
    return true;
  });
  const groups = [...vertexStructsAndGroups.groups, ...fragmentStructsAndGroups.groups].filter((group) => {
    const key = `${group.name}-${group.binding}`;
    if (dupeGroupKeySet.has(key)) {
      return false;
    }
    dupeGroupKeySet.add(key);
    return true;
  });
  return { structs, groups };
}
const programCache = /* @__PURE__ */ Object.create(null);
class GpuProgram {
  /**
   * Create a new GpuProgram
   * @param options - The options for the gpu program
   */
  constructor(options) {
    this._layoutKey = 0;
    this._attributeLocationsKey = 0;
    const { fragment: fragment2, vertex: vertex2, layout, gpuLayout, name } = options;
    this.name = name;
    this.fragment = fragment2;
    this.vertex = vertex2;
    if (fragment2.source === vertex2.source) {
      const structsAndGroups = extractStructAndGroups(fragment2.source);
      this.structsAndGroups = structsAndGroups;
    } else {
      const vertexStructsAndGroups = extractStructAndGroups(vertex2.source);
      const fragmentStructsAndGroups = extractStructAndGroups(fragment2.source);
      this.structsAndGroups = removeStructAndGroupDuplicates(vertexStructsAndGroups, fragmentStructsAndGroups);
    }
    this.layout = layout ?? generateLayoutHash(this.structsAndGroups);
    this.gpuLayout = gpuLayout ?? generateGpuLayoutGroups(this.structsAndGroups);
    this.autoAssignGlobalUniforms = !!(this.layout[0]?.globalUniforms !== void 0);
    this.autoAssignLocalUniforms = !!(this.layout[1]?.localUniforms !== void 0);
    this._generateProgramKey();
  }
  // TODO maker this pure
  _generateProgramKey() {
    const { vertex: vertex2, fragment: fragment2 } = this;
    const bigKey = vertex2.source + fragment2.source + vertex2.entryPoint + fragment2.entryPoint;
    this._layoutKey = createIdFromString(bigKey, "program");
  }
  get attributeData() {
    this._attributeData ?? (this._attributeData = extractAttributesFromGpuProgram(this.vertex));
    return this._attributeData;
  }
  /** destroys the program */
  destroy() {
    this.gpuLayout = null;
    this.layout = null;
    this.structsAndGroups = null;
    this.fragment = null;
    this.vertex = null;
  }
  /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */
  static from(options) {
    const key = `${options.vertex.source}:${options.fragment.source}:${options.fragment.entryPoint}:${options.vertex.entryPoint}`;
    if (!programCache[key]) {
      programCache[key] = new GpuProgram(options);
    }
    return programCache[key];
  }
}
const UNIFORM_TYPES_VALUES = [
  "f32",
  "i32",
  "vec2<f32>",
  "vec3<f32>",
  "vec4<f32>",
  "mat2x2<f32>",
  "mat3x3<f32>",
  "mat4x4<f32>",
  "mat3x2<f32>",
  "mat4x2<f32>",
  "mat2x3<f32>",
  "mat4x3<f32>",
  "mat2x4<f32>",
  "mat3x4<f32>",
  "vec2<i32>",
  "vec3<i32>",
  "vec4<i32>"
];
const UNIFORM_TYPES_MAP = UNIFORM_TYPES_VALUES.reduce((acc, type) => {
  acc[type] = true;
  return acc;
}, {});
function getDefaultUniformValue(type, size) {
  switch (type) {
    case "f32":
      return 0;
    case "vec2<f32>":
      return new Float32Array(2 * size);
    case "vec3<f32>":
      return new Float32Array(3 * size);
    case "vec4<f32>":
      return new Float32Array(4 * size);
    case "mat2x2<f32>":
      return new Float32Array([
        1,
        0,
        0,
        1
      ]);
    case "mat3x3<f32>":
      return new Float32Array([
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1
      ]);
    case "mat4x4<f32>":
      return new Float32Array([
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
      ]);
  }
  return null;
}
const _UniformGroup = class _UniformGroup2 {
  /**
   * Create a new Uniform group
   * @param uniformStructures - The structures of the uniform group
   * @param options - The optional parameters of this uniform group
   */
  constructor(uniformStructures, options) {
    this._touched = 0;
    this.uid = uid("uniform");
    this._resourceType = "uniformGroup";
    this._resourceId = uid("resource");
    this.isUniformGroup = true;
    this._dirtyId = 0;
    this.destroyed = false;
    options = { ..._UniformGroup2.defaultOptions, ...options };
    this.uniformStructures = uniformStructures;
    const uniforms = {};
    for (const i2 in uniformStructures) {
      const uniformData = uniformStructures[i2];
      uniformData.name = i2;
      uniformData.size = uniformData.size ?? 1;
      if (!UNIFORM_TYPES_MAP[uniformData.type]) {
        throw new Error(`Uniform type ${uniformData.type} is not supported. Supported uniform types are: ${UNIFORM_TYPES_VALUES.join(", ")}`);
      }
      uniformData.value ?? (uniformData.value = getDefaultUniformValue(uniformData.type, uniformData.size));
      uniforms[i2] = uniformData.value;
    }
    this.uniforms = uniforms;
    this._dirtyId = 1;
    this.ubo = options.ubo;
    this.isStatic = options.isStatic;
    this._signature = createIdFromString(Object.keys(uniforms).map(
      (i2) => `${i2}-${uniformStructures[i2].type}`
    ).join("-"), "uniform-group");
  }
  /** Call this if you want the uniform groups data to be uploaded to the GPU only useful if `isStatic` is true. */
  update() {
    this._dirtyId++;
  }
};
_UniformGroup.defaultOptions = {
  /** if true the UniformGroup is handled as an Uniform buffer object. */
  ubo: false,
  /** if true, then you are responsible for when the data is uploaded to the GPU by calling `update()` */
  isStatic: false
};
let UniformGroup = _UniformGroup;
class BindGroup {
  /**
   * Create a new instance eof the Bind Group.
   * @param resources - The resources that are bound together for use by a shader.
   */
  constructor(resources) {
    this.resources = /* @__PURE__ */ Object.create(null);
    this._dirty = true;
    let index = 0;
    for (const i2 in resources) {
      const resource = resources[i2];
      this.setResource(resource, index++);
    }
    this._updateKey();
  }
  /**
   * Updates the key if its flagged as dirty. This is used internally to
   * match this bind group to a WebGPU BindGroup.
   * @internal
   * @ignore
   */
  _updateKey() {
    if (!this._dirty)
      return;
    this._dirty = false;
    const keyParts = [];
    let index = 0;
    for (const i2 in this.resources) {
      keyParts[index++] = this.resources[i2]._resourceId;
    }
    this._key = keyParts.join("|");
  }
  /**
   * Set a resource at a given index. this function will
   * ensure that listeners will be removed from the current resource
   * and added to the new resource.
   * @param resource - The resource to set.
   * @param index - The index to set the resource at.
   */
  setResource(resource, index) {
    const currentResource = this.resources[index];
    if (resource === currentResource)
      return;
    if (currentResource) {
      resource.off?.("change", this.onResourceChange, this);
    }
    resource.on?.("change", this.onResourceChange, this);
    this.resources[index] = resource;
    this._dirty = true;
  }
  /**
   * Returns the resource at the current specified index.
   * @param index - The index of the resource to get.
   * @returns - The resource at the specified index.
   */
  getResource(index) {
    return this.resources[index];
  }
  /**
   * Used internally to 'touch' each resource, to ensure that the GC
   * knows that all resources in this bind group are still being used.
   * @param tick - The current tick.
   * @internal
   * @ignore
   */
  _touch(tick2) {
    const resources = this.resources;
    for (const i2 in resources) {
      resources[i2]._touched = tick2;
    }
  }
  /** Destroys this bind group and removes all listeners. */
  destroy() {
    const resources = this.resources;
    for (const i2 in resources) {
      const resource = resources[i2];
      resource.off?.("change", this.onResourceChange, this);
    }
    this.resources = null;
  }
  onResourceChange(resource) {
    this._dirty = true;
    if (resource.destroyed) {
      const resources = this.resources;
      for (const i2 in resources) {
        if (resources[i2] === resource) {
          resources[i2] = null;
        }
      }
    } else {
      this._updateKey();
    }
  }
}
var RendererType = /* @__PURE__ */ ((RendererType2) => {
  RendererType2[RendererType2["WEBGL"] = 1] = "WEBGL";
  RendererType2[RendererType2["WEBGPU"] = 2] = "WEBGPU";
  RendererType2[RendererType2["BOTH"] = 3] = "BOTH";
  return RendererType2;
})(RendererType || {});
class Shader extends EventEmitter {
  constructor(options) {
    super();
    this.uid = uid("shader");
    this._uniformBindMap = /* @__PURE__ */ Object.create(null);
    this._ownedBindGroups = [];
    let {
      gpuProgram,
      glProgram,
      groups,
      resources,
      compatibleRenderers,
      groupMap
    } = options;
    this.gpuProgram = gpuProgram;
    this.glProgram = glProgram;
    if (compatibleRenderers === void 0) {
      compatibleRenderers = 0;
      if (gpuProgram)
        compatibleRenderers |= RendererType.WEBGPU;
      if (glProgram)
        compatibleRenderers |= RendererType.WEBGL;
    }
    this.compatibleRenderers = compatibleRenderers;
    const nameHash = {};
    if (!resources && !groups) {
      resources = {};
    }
    if (resources && groups) {
      throw new Error("[Shader] Cannot have both resources and groups");
    } else if (!gpuProgram && groups && !groupMap) {
      throw new Error("[Shader] No group map or WebGPU shader provided - consider using resources instead.");
    } else if (!gpuProgram && groups && groupMap) {
      for (const i2 in groupMap) {
        for (const j2 in groupMap[i2]) {
          const uniformName = groupMap[i2][j2];
          nameHash[uniformName] = {
            group: i2,
            binding: j2,
            name: uniformName
          };
        }
      }
    } else if (gpuProgram && groups && !groupMap) {
      const groupData = gpuProgram.structsAndGroups.groups;
      groupMap = {};
      groupData.forEach((data) => {
        groupMap[data.group] = groupMap[data.group] || {};
        groupMap[data.group][data.binding] = data.name;
        nameHash[data.name] = data;
      });
    } else if (resources) {
      groups = {};
      groupMap = {};
      if (gpuProgram) {
        const groupData = gpuProgram.structsAndGroups.groups;
        groupData.forEach((data) => {
          groupMap[data.group] = groupMap[data.group] || {};
          groupMap[data.group][data.binding] = data.name;
          nameHash[data.name] = data;
        });
      }
      let bindTick = 0;
      for (const i2 in resources) {
        if (nameHash[i2])
          continue;
        if (!groups[99]) {
          groups[99] = new BindGroup();
          this._ownedBindGroups.push(groups[99]);
        }
        nameHash[i2] = { group: 99, binding: bindTick, name: i2 };
        groupMap[99] = groupMap[99] || {};
        groupMap[99][bindTick] = i2;
        bindTick++;
      }
      for (const i2 in resources) {
        const name = i2;
        let value = resources[i2];
        if (!value.source && !value._resourceType) {
          value = new UniformGroup(value);
        }
        const data = nameHash[name];
        if (data) {
          if (!groups[data.group]) {
            groups[data.group] = new BindGroup();
            this._ownedBindGroups.push(groups[data.group]);
          }
          groups[data.group].setResource(value, data.binding);
        }
      }
    }
    this.groups = groups;
    this._uniformBindMap = groupMap;
    this.resources = this._buildResourceAccessor(groups, nameHash);
  }
  /**
   * Sometimes a resource group will be provided later (for example global uniforms)
   * In such cases, this method can be used to let the shader know about the group.
   * @param name - the name of the resource group
   * @param groupIndex - the index of the group (should match the webGPU shader group location)
   * @param bindIndex - the index of the bind point (should match the webGPU shader bind point)
   */
  addResource(name, groupIndex, bindIndex) {
    var _a, _b;
    (_a = this._uniformBindMap)[groupIndex] || (_a[groupIndex] = {});
    (_b = this._uniformBindMap[groupIndex])[bindIndex] || (_b[bindIndex] = name);
    if (!this.groups[groupIndex]) {
      this.groups[groupIndex] = new BindGroup();
      this._ownedBindGroups.push(this.groups[groupIndex]);
    }
  }
  _buildResourceAccessor(groups, nameHash) {
    const uniformsOut = {};
    for (const i2 in nameHash) {
      const data = nameHash[i2];
      Object.defineProperty(uniformsOut, data.name, {
        get() {
          return groups[data.group].getResource(data.binding);
        },
        set(value) {
          groups[data.group].setResource(value, data.binding);
        }
      });
    }
    return uniformsOut;
  }
  /**
   * Use to destroy the shader when its not longer needed.
   * It will destroy the resources and remove listeners.
   * @param destroyPrograms - if the programs should be destroyed as well.
   * Make sure its not being used by other shaders!
   */
  destroy(destroyPrograms = false) {
    this.emit("destroy", this);
    if (destroyPrograms) {
      this.gpuProgram?.destroy();
      this.glProgram?.destroy();
    }
    this.gpuProgram = null;
    this.glProgram = null;
    this.removeAllListeners();
    this._uniformBindMap = null;
    this._ownedBindGroups.forEach((bindGroup) => {
      bindGroup.destroy();
    });
    this._ownedBindGroups = null;
    this.resources = null;
    this.groups = null;
  }
  static from(options) {
    const { gpu, gl, ...rest } = options;
    let gpuProgram;
    let glProgram;
    if (gpu) {
      gpuProgram = GpuProgram.from(gpu);
    }
    if (gl) {
      glProgram = GlProgram.from(gl);
    }
    return new Shader({
      gpuProgram,
      glProgram,
      ...rest
    });
  }
}
const blendModeIds = {
  normal: 0,
  add: 1,
  multiply: 2,
  screen: 3,
  overlay: 4,
  erase: 5,
  "normal-npm": 6,
  "add-npm": 7,
  "screen-npm": 8,
  min: 9,
  max: 10
};
const BLEND = 0;
const OFFSET = 1;
const CULLING = 2;
const DEPTH_TEST = 3;
const WINDING = 4;
const DEPTH_MASK = 5;
const _State = class _State2 {
  constructor() {
    this.data = 0;
    this.blendMode = "normal";
    this.polygonOffset = 0;
    this.blend = true;
    this.depthMask = true;
  }
  /**
   * Activates blending of the computed fragment color values.
   * @default true
   */
  get blend() {
    return !!(this.data & 1 << BLEND);
  }
  set blend(value) {
    if (!!(this.data & 1 << BLEND) !== value) {
      this.data ^= 1 << BLEND;
    }
  }
  /**
   * Activates adding an offset to depth values of polygon's fragments
   * @default false
   */
  get offsets() {
    return !!(this.data & 1 << OFFSET);
  }
  set offsets(value) {
    if (!!(this.data & 1 << OFFSET) !== value) {
      this.data ^= 1 << OFFSET;
    }
  }
  /** The culling settings for this state none - No culling back - Back face culling front - Front face culling */
  set cullMode(value) {
    if (value === "none") {
      this.culling = false;
      return;
    }
    this.culling = true;
    this.clockwiseFrontFace = value === "front";
  }
  get cullMode() {
    if (!this.culling) {
      return "none";
    }
    return this.clockwiseFrontFace ? "front" : "back";
  }
  /**
   * Activates culling of polygons.
   * @default false
   */
  get culling() {
    return !!(this.data & 1 << CULLING);
  }
  set culling(value) {
    if (!!(this.data & 1 << CULLING) !== value) {
      this.data ^= 1 << CULLING;
    }
  }
  /**
   * Activates depth comparisons and updates to the depth buffer.
   * @default false
   */
  get depthTest() {
    return !!(this.data & 1 << DEPTH_TEST);
  }
  set depthTest(value) {
    if (!!(this.data & 1 << DEPTH_TEST) !== value) {
      this.data ^= 1 << DEPTH_TEST;
    }
  }
  /**
   * Enables or disables writing to the depth buffer.
   * @default true
   */
  get depthMask() {
    return !!(this.data & 1 << DEPTH_MASK);
  }
  set depthMask(value) {
    if (!!(this.data & 1 << DEPTH_MASK) !== value) {
      this.data ^= 1 << DEPTH_MASK;
    }
  }
  /**
   * Specifies whether or not front or back-facing polygons can be culled.
   * @default false
   */
  get clockwiseFrontFace() {
    return !!(this.data & 1 << WINDING);
  }
  set clockwiseFrontFace(value) {
    if (!!(this.data & 1 << WINDING) !== value) {
      this.data ^= 1 << WINDING;
    }
  }
  /**
   * The blend mode to be applied when this state is set. Apply a value of `normal` to reset the blend mode.
   * Setting this mode to anything other than NO_BLEND will automatically switch blending on.
   * @default 'normal'
   */
  get blendMode() {
    return this._blendMode;
  }
  set blendMode(value) {
    this.blend = value !== "none";
    this._blendMode = value;
    this._blendModeId = blendModeIds[value] || 0;
  }
  /**
   * The polygon offset. Setting this property to anything other than 0 will automatically enable polygon offset fill.
   * @default 0
   */
  get polygonOffset() {
    return this._polygonOffset;
  }
  set polygonOffset(value) {
    this.offsets = !!value;
    this._polygonOffset = value;
  }
  toString() {
    return `[pixi.js/core:State blendMode=${this.blendMode} clockwiseFrontFace=${this.clockwiseFrontFace} culling=${this.culling} depthMask=${this.depthMask} polygonOffset=${this.polygonOffset}]`;
  }
  /**
   * A quickly getting an instance of a State that is configured for 2d rendering.
   * @returns a new State with values set for 2d rendering
   */
  static for2d() {
    const state = new _State2();
    state.depthTest = false;
    state.blend = true;
    return state;
  }
};
_State.default2d = _State.for2d();
let State = _State;
const _Filter = class _Filter2 extends Shader {
  /**
   * @param options - The optional parameters of this filter.
   */
  constructor(options) {
    options = { ..._Filter2.defaultOptions, ...options };
    super(options);
    this.enabled = true;
    this._state = State.for2d();
    this.blendMode = options.blendMode;
    this.padding = options.padding;
    if (typeof options.antialias === "boolean") {
      this.antialias = options.antialias ? "on" : "off";
    } else {
      this.antialias = options.antialias;
    }
    this.resolution = options.resolution;
    this.blendRequired = options.blendRequired;
    this.clipToViewport = options.clipToViewport;
    this.addResource("uTexture", 0, 1);
  }
  /**
   * Applies the filter
   * @param filterManager - The renderer to retrieve the filter from
   * @param input - The input render target.
   * @param output - The target to output to.
   * @param clearMode - Should the output be cleared before rendering to it
   */
  apply(filterManager, input, output, clearMode) {
    filterManager.applyFilter(this, input, output, clearMode);
  }
  /**
   * Get the blend mode of the filter.
   * @default "normal"
   */
  get blendMode() {
    return this._state.blendMode;
  }
  /** Sets the blend mode of the filter. */
  set blendMode(value) {
    this._state.blendMode = value;
  }
  /**
   * A short hand function to create a filter based of a vertex and fragment shader src.
   * @param options
   * @returns A shiny new PixiJS filter!
   */
  static from(options) {
    const { gpu, gl, ...rest } = options;
    let gpuProgram;
    let glProgram;
    if (gpu) {
      gpuProgram = GpuProgram.from(gpu);
    }
    if (gl) {
      glProgram = GlProgram.from(gl);
    }
    return new _Filter2({
      gpuProgram,
      glProgram,
      ...rest
    });
  }
};
_Filter.defaultOptions = {
  blendMode: "normal",
  resolution: 1,
  padding: 0,
  antialias: "off",
  blendRequired: false,
  clipToViewport: true
};
let Filter = _Filter;
const environments = [];
extensions.handleByNamedList(ExtensionType.Environment, environments);
async function loadEnvironmentExtensions(skip) {
  if (skip)
    return;
  for (let i2 = 0; i2 < environments.length; i2++) {
    const env = environments[i2];
    if (env.value.test()) {
      await env.value.load();
      return;
    }
  }
}
let unsafeEval;
function unsafeEvalSupported() {
  if (typeof unsafeEval === "boolean") {
    return unsafeEval;
  }
  try {
    const func = new Function("param1", "param2", "param3", "return param1[param2] === param3;");
    unsafeEval = func({ a: "b" }, "a", "b") === true;
  } catch (_e) {
    unsafeEval = false;
  }
  return unsafeEval;
}
var earcut$2 = { exports: {} };
earcut$2.exports = earcut;
earcut$2.exports.default = earcut;
function earcut(data, holeIndices, dim) {
  dim = dim || 2;
  var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data.length, outerNode = linkedList(data, 0, outerLen, dim, true), triangles = [];
  if (!outerNode || outerNode.next === outerNode.prev)
    return triangles;
  var minX, minY, maxX, maxY, x2, y2, invSize;
  if (hasHoles)
    outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
  if (data.length > 80 * dim) {
    minX = maxX = data[0];
    minY = maxY = data[1];
    for (var i2 = dim; i2 < outerLen; i2 += dim) {
      x2 = data[i2];
      y2 = data[i2 + 1];
      if (x2 < minX)
        minX = x2;
      if (y2 < minY)
        minY = y2;
      if (x2 > maxX)
        maxX = x2;
      if (y2 > maxY)
        maxY = y2;
    }
    invSize = Math.max(maxX - minX, maxY - minY);
    invSize = invSize !== 0 ? 32767 / invSize : 0;
  }
  earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
  return triangles;
}
function linkedList(data, start, end, dim, clockwise) {
  var i2, last;
  if (clockwise === signedArea(data, start, end, dim) > 0) {
    for (i2 = start; i2 < end; i2 += dim)
      last = insertNode(i2, data[i2], data[i2 + 1], last);
  } else {
    for (i2 = end - dim; i2 >= start; i2 -= dim)
      last = insertNode(i2, data[i2], data[i2 + 1], last);
  }
  if (last && equals(last, last.next)) {
    removeNode(last);
    last = last.next;
  }
  return last;
}
function filterPoints(start, end) {
  if (!start)
    return start;
  if (!end)
    end = start;
  var p2 = start, again;
  do {
    again = false;
    if (!p2.steiner && (equals(p2, p2.next) || area(p2.prev, p2, p2.next) === 0)) {
      removeNode(p2);
      p2 = end = p2.prev;
      if (p2 === p2.next)
        break;
      again = true;
    } else {
      p2 = p2.next;
    }
  } while (again || p2 !== end);
  return end;
}
function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
  if (!ear)
    return;
  if (!pass && invSize)
    indexCurve(ear, minX, minY, invSize);
  var stop = ear, prev, next;
  while (ear.prev !== ear.next) {
    prev = ear.prev;
    next = ear.next;
    if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
      triangles.push(prev.i / dim | 0);
      triangles.push(ear.i / dim | 0);
      triangles.push(next.i / dim | 0);
      removeNode(ear);
      ear = next.next;
      stop = next.next;
      continue;
    }
    ear = next;
    if (ear === stop) {
      if (!pass) {
        earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
      } else if (pass === 1) {
        ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
        earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
      } else if (pass === 2) {
        splitEarcut(ear, triangles, dim, minX, minY, invSize);
      }
      break;
    }
  }
}
function isEar(ear) {
  var a2 = ear.prev, b2 = ear, c2 = ear.next;
  if (area(a2, b2, c2) >= 0)
    return false;
  var ax = a2.x, bx = b2.x, cx = c2.x, ay = a2.y, by = b2.y, cy = c2.y;
  var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
  var p2 = c2.next;
  while (p2 !== a2) {
    if (p2.x >= x0 && p2.x <= x1 && p2.y >= y0 && p2.y <= y1 && pointInTriangle(ax, ay, bx, by, cx, cy, p2.x, p2.y) && area(p2.prev, p2, p2.next) >= 0)
      return false;
    p2 = p2.next;
  }
  return true;
}
function isEarHashed(ear, minX, minY, invSize) {
  var a2 = ear.prev, b2 = ear, c2 = ear.next;
  if (area(a2, b2, c2) >= 0)
    return false;
  var ax = a2.x, bx = b2.x, cx = c2.x, ay = a2.y, by = b2.y, cy = c2.y;
  var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
  var minZ = zOrder(x0, y0, minX, minY, invSize), maxZ = zOrder(x1, y1, minX, minY, invSize);
  var p2 = ear.prevZ, n2 = ear.nextZ;
  while (p2 && p2.z >= minZ && n2 && n2.z <= maxZ) {
    if (p2.x >= x0 && p2.x <= x1 && p2.y >= y0 && p2.y <= y1 && p2 !== a2 && p2 !== c2 && pointInTriangle(ax, ay, bx, by, cx, cy, p2.x, p2.y) && area(p2.prev, p2, p2.next) >= 0)
      return false;
    p2 = p2.prevZ;
    if (n2.x >= x0 && n2.x <= x1 && n2.y >= y0 && n2.y <= y1 && n2 !== a2 && n2 !== c2 && pointInTriangle(ax, ay, bx, by, cx, cy, n2.x, n2.y) && area(n2.prev, n2, n2.next) >= 0)
      return false;
    n2 = n2.nextZ;
  }
  while (p2 && p2.z >= minZ) {
    if (p2.x >= x0 && p2.x <= x1 && p2.y >= y0 && p2.y <= y1 && p2 !== a2 && p2 !== c2 && pointInTriangle(ax, ay, bx, by, cx, cy, p2.x, p2.y) && area(p2.prev, p2, p2.next) >= 0)
      return false;
    p2 = p2.prevZ;
  }
  while (n2 && n2.z <= maxZ) {
    if (n2.x >= x0 && n2.x <= x1 && n2.y >= y0 && n2.y <= y1 && n2 !== a2 && n2 !== c2 && pointInTriangle(ax, ay, bx, by, cx, cy, n2.x, n2.y) && area(n2.prev, n2, n2.next) >= 0)
      return false;
    n2 = n2.nextZ;
  }
  return true;
}
function cureLocalIntersections(start, triangles, dim) {
  var p2 = start;
  do {
    var a2 = p2.prev, b2 = p2.next.next;
    if (!equals(a2, b2) && intersects(a2, p2, p2.next, b2) && locallyInside(a2, b2) && locallyInside(b2, a2)) {
      triangles.push(a2.i / dim | 0);
      triangles.push(p2.i / dim | 0);
      triangles.push(b2.i / dim | 0);
      removeNode(p2);
      removeNode(p2.next);
      p2 = start = b2;
    }
    p2 = p2.next;
  } while (p2 !== start);
  return filterPoints(p2);
}
function splitEarcut(start, triangles, dim, minX, minY, invSize) {
  var a2 = start;
  do {
    var b2 = a2.next.next;
    while (b2 !== a2.prev) {
      if (a2.i !== b2.i && isValidDiagonal(a2, b2)) {
        var c2 = splitPolygon(a2, b2);
        a2 = filterPoints(a2, a2.next);
        c2 = filterPoints(c2, c2.next);
        earcutLinked(a2, triangles, dim, minX, minY, invSize, 0);
        earcutLinked(c2, triangles, dim, minX, minY, invSize, 0);
        return;
      }
      b2 = b2.next;
    }
    a2 = a2.next;
  } while (a2 !== start);
}
function eliminateHoles(data, holeIndices, outerNode, dim) {
  var queue = [], i2, len, start, end, list;
  for (i2 = 0, len = holeIndices.length; i2 < len; i2++) {
    start = holeIndices[i2] * dim;
    end = i2 < len - 1 ? holeIndices[i2 + 1] * dim : data.length;
    list = linkedList(data, start, end, dim, false);
    if (list === list.next)
      list.steiner = true;
    queue.push(getLeftmost(list));
  }
  queue.sort(compareX);
  for (i2 = 0; i2 < queue.length; i2++) {
    outerNode = eliminateHole(queue[i2], outerNode);
  }
  return outerNode;
}
function compareX(a2, b2) {
  return a2.x - b2.x;
}
function eliminateHole(hole, outerNode) {
  var bridge = findHoleBridge(hole, outerNode);
  if (!bridge) {
    return outerNode;
  }
  var bridgeReverse = splitPolygon(bridge, hole);
  filterPoints(bridgeReverse, bridgeReverse.next);
  return filterPoints(bridge, bridge.next);
}
function findHoleBridge(hole, outerNode) {
  var p2 = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m2;
  do {
    if (hy <= p2.y && hy >= p2.next.y && p2.next.y !== p2.y) {
      var x2 = p2.x + (hy - p2.y) * (p2.next.x - p2.x) / (p2.next.y - p2.y);
      if (x2 <= hx && x2 > qx) {
        qx = x2;
        m2 = p2.x < p2.next.x ? p2 : p2.next;
        if (x2 === hx)
          return m2;
      }
    }
    p2 = p2.next;
  } while (p2 !== outerNode);
  if (!m2)
    return null;
  var stop = m2, mx = m2.x, my = m2.y, tanMin = Infinity, tan;
  p2 = m2;
  do {
    if (hx >= p2.x && p2.x >= mx && hx !== p2.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p2.x, p2.y)) {
      tan = Math.abs(hy - p2.y) / (hx - p2.x);
      if (locallyInside(p2, hole) && (tan < tanMin || tan === tanMin && (p2.x > m2.x || p2.x === m2.x && sectorContainsSector(m2, p2)))) {
        m2 = p2;
        tanMin = tan;
      }
    }
    p2 = p2.next;
  } while (p2 !== stop);
  return m2;
}
function sectorContainsSector(m2, p2) {
  return area(m2.prev, m2, p2.prev) < 0 && area(p2.next, m2, m2.next) < 0;
}
function indexCurve(start, minX, minY, invSize) {
  var p2 = start;
  do {
    if (p2.z === 0)
      p2.z = zOrder(p2.x, p2.y, minX, minY, invSize);
    p2.prevZ = p2.prev;
    p2.nextZ = p2.next;
    p2 = p2.next;
  } while (p2 !== start);
  p2.prevZ.nextZ = null;
  p2.prevZ = null;
  sortLinked(p2);
}
function sortLinked(list) {
  var i2, p2, q, e2, tail, numMerges, pSize, qSize, inSize = 1;
  do {
    p2 = list;
    list = null;
    tail = null;
    numMerges = 0;
    while (p2) {
      numMerges++;
      q = p2;
      pSize = 0;
      for (i2 = 0; i2 < inSize; i2++) {
        pSize++;
        q = q.nextZ;
        if (!q)
          break;
      }
      qSize = inSize;
      while (pSize > 0 || qSize > 0 && q) {
        if (pSize !== 0 && (qSize === 0 || !q || p2.z <= q.z)) {
          e2 = p2;
          p2 = p2.nextZ;
          pSize--;
        } else {
          e2 = q;
          q = q.nextZ;
          qSize--;
        }
        if (tail)
          tail.nextZ = e2;
        else
          list = e2;
        e2.prevZ = tail;
        tail = e2;
      }
      p2 = q;
    }
    tail.nextZ = null;
    inSize *= 2;
  } while (numMerges > 1);
  return list;
}
function zOrder(x2, y2, minX, minY, invSize) {
  x2 = (x2 - minX) * invSize | 0;
  y2 = (y2 - minY) * invSize | 0;
  x2 = (x2 | x2 << 8) & 16711935;
  x2 = (x2 | x2 << 4) & 252645135;
  x2 = (x2 | x2 << 2) & 858993459;
  x2 = (x2 | x2 << 1) & 1431655765;
  y2 = (y2 | y2 << 8) & 16711935;
  y2 = (y2 | y2 << 4) & 252645135;
  y2 = (y2 | y2 << 2) & 858993459;
  y2 = (y2 | y2 << 1) & 1431655765;
  return x2 | y2 << 1;
}
function getLeftmost(start) {
  var p2 = start, leftmost = start;
  do {
    if (p2.x < leftmost.x || p2.x === leftmost.x && p2.y < leftmost.y)
      leftmost = p2;
    p2 = p2.next;
  } while (p2 !== start);
  return leftmost;
}
function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
  return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
function isValidDiagonal(a2, b2) {
  return a2.next.i !== b2.i && a2.prev.i !== b2.i && !intersectsPolygon(a2, b2) && // dones't intersect other edges
  (locallyInside(a2, b2) && locallyInside(b2, a2) && middleInside(a2, b2) && // locally visible
  (area(a2.prev, a2, b2.prev) || area(a2, b2.prev, b2)) || // does not create opposite-facing sectors
  equals(a2, b2) && area(a2.prev, a2, a2.next) > 0 && area(b2.prev, b2, b2.next) > 0);
}
function area(p2, q, r2) {
  return (q.y - p2.y) * (r2.x - q.x) - (q.x - p2.x) * (r2.y - q.y);
}
function equals(p1, p2) {
  return p1.x === p2.x && p1.y === p2.y;
}
function intersects(p1, q1, p2, q2) {
  var o1 = sign(area(p1, q1, p2));
  var o2 = sign(area(p1, q1, q2));
  var o3 = sign(area(p2, q2, p1));
  var o4 = sign(area(p2, q2, q1));
  if (o1 !== o2 && o3 !== o4)
    return true;
  if (o1 === 0 && onSegment(p1, p2, q1))
    return true;
  if (o2 === 0 && onSegment(p1, q2, q1))
    return true;
  if (o3 === 0 && onSegment(p2, p1, q2))
    return true;
  if (o4 === 0 && onSegment(p2, q1, q2))
    return true;
  return false;
}
function onSegment(p2, q, r2) {
  return q.x <= Math.max(p2.x, r2.x) && q.x >= Math.min(p2.x, r2.x) && q.y <= Math.max(p2.y, r2.y) && q.y >= Math.min(p2.y, r2.y);
}
function sign(num) {
  return num > 0 ? 1 : num < 0 ? -1 : 0;
}
function intersectsPolygon(a2, b2) {
  var p2 = a2;
  do {
    if (p2.i !== a2.i && p2.next.i !== a2.i && p2.i !== b2.i && p2.next.i !== b2.i && intersects(p2, p2.next, a2, b2))
      return true;
    p2 = p2.next;
  } while (p2 !== a2);
  return false;
}
function locallyInside(a2, b2) {
  return area(a2.prev, a2, a2.next) < 0 ? area(a2, b2, a2.next) >= 0 && area(a2, a2.prev, b2) >= 0 : area(a2, b2, a2.prev) < 0 || area(a2, a2.next, b2) < 0;
}
function middleInside(a2, b2) {
  var p2 = a2, inside = false, px = (a2.x + b2.x) / 2, py = (a2.y + b2.y) / 2;
  do {
    if (p2.y > py !== p2.next.y > py && p2.next.y !== p2.y && px < (p2.next.x - p2.x) * (py - p2.y) / (p2.next.y - p2.y) + p2.x)
      inside = !inside;
    p2 = p2.next;
  } while (p2 !== a2);
  return inside;
}
function splitPolygon(a2, b2) {
  var a22 = new Node(a2.i, a2.x, a2.y), b22 = new Node(b2.i, b2.x, b2.y), an = a2.next, bp = b2.prev;
  a2.next = b2;
  b2.prev = a2;
  a22.next = an;
  an.prev = a22;
  b22.next = a22;
  a22.prev = b22;
  bp.next = b22;
  b22.prev = bp;
  return b22;
}
function insertNode(i2, x2, y2, last) {
  var p2 = new Node(i2, x2, y2);
  if (!last) {
    p2.prev = p2;
    p2.next = p2;
  } else {
    p2.next = last.next;
    p2.prev = last;
    last.next.prev = p2;
    last.next = p2;
  }
  return p2;
}
function removeNode(p2) {
  p2.next.prev = p2.prev;
  p2.prev.next = p2.next;
  if (p2.prevZ)
    p2.prevZ.nextZ = p2.nextZ;
  if (p2.nextZ)
    p2.nextZ.prevZ = p2.prevZ;
}
function Node(i2, x2, y2) {
  this.i = i2;
  this.x = x2;
  this.y = y2;
  this.prev = null;
  this.next = null;
  this.z = 0;
  this.prevZ = null;
  this.nextZ = null;
  this.steiner = false;
}
earcut.deviation = function(data, holeIndices, dim, triangles) {
  var hasHoles = holeIndices && holeIndices.length;
  var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
  var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
  if (hasHoles) {
    for (var i2 = 0, len = holeIndices.length; i2 < len; i2++) {
      var start = holeIndices[i2] * dim;
      var end = i2 < len - 1 ? holeIndices[i2 + 1] * dim : data.length;
      polygonArea -= Math.abs(signedArea(data, start, end, dim));
    }
  }
  var trianglesArea = 0;
  for (i2 = 0; i2 < triangles.length; i2 += 3) {
    var a2 = triangles[i2] * dim;
    var b2 = triangles[i2 + 1] * dim;
    var c2 = triangles[i2 + 2] * dim;
    trianglesArea += Math.abs(
      (data[a2] - data[c2]) * (data[b2 + 1] - data[a2 + 1]) - (data[a2] - data[b2]) * (data[c2 + 1] - data[a2 + 1])
    );
  }
  return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
};
function signedArea(data, start, end, dim) {
  var sum = 0;
  for (var i2 = start, j2 = end - dim; i2 < end; i2 += dim) {
    sum += (data[j2] - data[i2]) * (data[i2 + 1] + data[j2 + 1]);
    j2 = i2;
  }
  return sum;
}
earcut.flatten = function(data) {
  var dim = data[0][0].length, result = { vertices: [], holes: [], dimensions: dim }, holeIndex = 0;
  for (var i2 = 0; i2 < data.length; i2++) {
    for (var j2 = 0; j2 < data[i2].length; j2++) {
      for (var d2 = 0; d2 < dim; d2++)
        result.vertices.push(data[i2][j2][d2]);
    }
    if (i2 > 0) {
      holeIndex += data[i2 - 1].length;
      result.holes.push(holeIndex);
    }
  }
  return result;
};
var earcutExports = earcut$2.exports;
const earcut$1 = /* @__PURE__ */ getDefaultExportFromCjs(earcutExports);
var CLEAR = /* @__PURE__ */ ((CLEAR2) => {
  CLEAR2[CLEAR2["NONE"] = 0] = "NONE";
  CLEAR2[CLEAR2["COLOR"] = 16384] = "COLOR";
  CLEAR2[CLEAR2["STENCIL"] = 1024] = "STENCIL";
  CLEAR2[CLEAR2["DEPTH"] = 256] = "DEPTH";
  CLEAR2[CLEAR2["COLOR_DEPTH"] = 16640] = "COLOR_DEPTH";
  CLEAR2[CLEAR2["COLOR_STENCIL"] = 17408] = "COLOR_STENCIL";
  CLEAR2[CLEAR2["DEPTH_STENCIL"] = 1280] = "DEPTH_STENCIL";
  CLEAR2[CLEAR2["ALL"] = 17664] = "ALL";
  return CLEAR2;
})(CLEAR || {});
class SystemRunner {
  /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */
  constructor(name) {
    this.items = [];
    this._name = name;
  }
  /* jsdoc/check-param-names */
  /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */
  /* jsdoc/check-param-names */
  emit(a0, a1, a2, a3, a4, a5, a6, a7) {
    const { name, items } = this;
    for (let i2 = 0, len = items.length; i2 < len; i2++) {
      items[i2][name](a0, a1, a2, a3, a4, a5, a6, a7);
    }
    return this;
  }
  /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * Eg A listener passed to this Runner will require a 'complete' function.
   *
   * ```
   * import { Runner } from 'pixi.js';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */
  add(item) {
    if (item[this._name]) {
      this.remove(item);
      this.items.push(item);
    }
    return this;
  }
  /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */
  remove(item) {
    const index = this.items.indexOf(item);
    if (index !== -1) {
      this.items.splice(index, 1);
    }
    return this;
  }
  /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */
  contains(item) {
    return this.items.indexOf(item) !== -1;
  }
  /** Remove all listeners from the Runner */
  removeAll() {
    this.items.length = 0;
    return this;
  }
  /** Remove all references, don't use after this. */
  destroy() {
    this.removeAll();
    this.items = null;
    this._name = null;
  }
  /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */
  get empty() {
    return this.items.length === 0;
  }
  /**
   * The name of the runner.
   * @readonly
   */
  get name() {
    return this._name;
  }
}
const defaultRunners = [
  "init",
  "destroy",
  "contextChange",
  "resolutionChange",
  "resetState",
  "renderEnd",
  "renderStart",
  "render",
  "update",
  "postrender",
  "prerender"
];
const _AbstractRenderer = class _AbstractRenderer2 extends EventEmitter {
  /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */
  constructor(config) {
    super();
    this.runners = /* @__PURE__ */ Object.create(null);
    this.renderPipes = /* @__PURE__ */ Object.create(null);
    this._initOptions = {};
    this._systemsHash = /* @__PURE__ */ Object.create(null);
    this.type = config.type;
    this.name = config.name;
    this.config = config;
    const combinedRunners = [...defaultRunners, ...this.config.runners ?? []];
    this._addRunners(...combinedRunners);
    this._unsafeEvalCheck();
  }
  /**
   * Initialize the renderer.
   * @param options - The options to use to create the renderer.
   */
  async init(options = {}) {
    const skip = options.skipExtensionImports === true ? true : options.manageImports === false;
    await loadEnvironmentExtensions(skip);
    this._addSystems(this.config.systems);
    this._addPipes(this.config.renderPipes, this.config.renderPipeAdaptors);
    for (const systemName in this._systemsHash) {
      const system = this._systemsHash[systemName];
      const defaultSystemOptions = system.constructor.defaultOptions;
      options = { ...defaultSystemOptions, ...options };
    }
    options = { ..._AbstractRenderer2.defaultOptions, ...options };
    this._roundPixels = options.roundPixels ? 1 : 0;
    for (let i2 = 0; i2 < this.runners.init.items.length; i2++) {
      await this.runners.init.items[i2].init(options);
    }
    this._initOptions = options;
  }
  render(args, deprecated) {
    let options = args;
    if (options instanceof Container) {
      options = { container: options };
      if (deprecated) {
        deprecation(v8_0_0, "passing a second argument is deprecated, please use render options instead");
        options.target = deprecated.renderTexture;
      }
    }
    options.target || (options.target = this.view.renderTarget);
    if (options.target === this.view.renderTarget) {
      this._lastObjectRendered = options.container;
      options.clearColor ?? (options.clearColor = this.background.colorRgba);
      options.clear ?? (options.clear = this.background.clearBeforeRender);
    }
    if (options.clearColor) {
      const isRGBAArray = Array.isArray(options.clearColor) && options.clearColor.length === 4;
      options.clearColor = isRGBAArray ? options.clearColor : Color.shared.setValue(options.clearColor).toArray();
    }
    if (!options.transform) {
      options.container.updateLocalTransform();
      options.transform = options.container.localTransform;
    }
    options.container.enableRenderGroup();
    this.runners.prerender.emit(options);
    this.runners.renderStart.emit(options);
    this.runners.render.emit(options);
    this.runners.renderEnd.emit(options);
    this.runners.postrender.emit(options);
  }
  /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   * @param resolution - The resolution / device pixel ratio of the renderer.
   */
  resize(desiredScreenWidth, desiredScreenHeight, resolution) {
    const previousResolution = this.view.resolution;
    this.view.resize(desiredScreenWidth, desiredScreenHeight, resolution);
    this.emit("resize", this.view.screen.width, this.view.screen.height, this.view.resolution);
    if (resolution !== void 0 && resolution !== previousResolution) {
      this.runners.resolutionChange.emit(resolution);
    }
  }
  clear(options = {}) {
    const renderer = this;
    options.target || (options.target = renderer.renderTarget.renderTarget);
    options.clearColor || (options.clearColor = this.background.colorRgba);
    options.clear ?? (options.clear = CLEAR.ALL);
    const { clear, clearColor, target } = options;
    Color.shared.setValue(clearColor ?? this.background.colorRgba);
    renderer.renderTarget.clear(target, clear, Color.shared.toArray());
  }
  /** The resolution / device pixel ratio of the renderer. */
  get resolution() {
    return this.view.resolution;
  }
  set resolution(value) {
    this.view.resolution = value;
    this.runners.resolutionChange.emit(value);
  }
  /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @member {number}
   * @readonly
   * @default 800
   */
  get width() {
    return this.view.texture.frame.width;
  }
  /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */
  get height() {
    return this.view.texture.frame.height;
  }
  // NOTE: this was `view` in v7
  /**
   * The canvas element that everything is drawn to.
   * @type {environment.ICanvas}
   */
  get canvas() {
    return this.view.canvas;
  }
  /**
   * the last object rendered by the renderer. Useful for other plugins like interaction managers
   * @readonly
   */
  get lastObjectRendered() {
    return this._lastObjectRendered;
  }
  /**
   * Flag if we are rendering to the screen vs renderTexture
   * @readonly
   * @default true
   */
  get renderingToScreen() {
    const renderer = this;
    return renderer.renderTarget.renderingToScreen;
  }
  /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   */
  get screen() {
    return this.view.screen;
  }
  /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */
  _addRunners(...runnerIds) {
    runnerIds.forEach((runnerId) => {
      this.runners[runnerId] = new SystemRunner(runnerId);
    });
  }
  _addSystems(systems) {
    let i2;
    for (i2 in systems) {
      const val = systems[i2];
      this._addSystem(val.value, val.name);
    }
  }
  /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */
  _addSystem(ClassRef, name) {
    const system = new ClassRef(this);
    if (this[name]) {
      throw new Error(`Whoops! The name "${name}" is already in use`);
    }
    this[name] = system;
    this._systemsHash[name] = system;
    for (const i2 in this.runners) {
      this.runners[i2].add(system);
    }
    return this;
  }
  _addPipes(pipes, pipeAdaptors) {
    const adaptors = pipeAdaptors.reduce((acc, adaptor) => {
      acc[adaptor.name] = adaptor.value;
      return acc;
    }, {});
    pipes.forEach((pipe) => {
      const PipeClass = pipe.value;
      const name = pipe.name;
      const Adaptor = adaptors[name];
      this.renderPipes[name] = new PipeClass(
        this,
        Adaptor ? new Adaptor() : null
      );
    });
  }
  destroy(options = false) {
    this.runners.destroy.items.reverse();
    this.runners.destroy.emit(options);
    Object.values(this.runners).forEach((runner) => {
      runner.destroy();
    });
    this._systemsHash = null;
    this.renderPipes = null;
  }
  /**
   * Generate a texture from a container.
   * @param options - options or container target to use when generating the texture
   * @returns a texture
   */
  generateTexture(options) {
    return this.textureGenerator.generateTexture(options);
  }
  /**
   * Whether the renderer will round coordinates to whole pixels when rendering.
   * Can be overridden on a per scene item basis.
   */
  get roundPixels() {
    return !!this._roundPixels;
  }
  /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   * @ignore
   */
  _unsafeEvalCheck() {
    if (!unsafeEvalSupported()) {
      throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
    }
  }
  /**
   * Resets the rendering state of the renderer.
   * This is useful when you want to use the WebGL context directly and need to ensure PixiJS's internal state
   * stays synchronized. When modifying the WebGL context state externally, calling this method before the next Pixi
   * render will reset all internal caches and ensure it executes correctly.
   *
   * This is particularly useful when combining PixiJS with other rendering engines like Three.js:
   * ```js
   * // Reset Three.js state
   * threeRenderer.resetState();
   *
   * // Render a Three.js scene
   * threeRenderer.render(threeScene, threeCamera);
   *
   * // Reset PixiJS state since Three.js modified the WebGL context
   * pixiRenderer.resetState();
   *
   * // Now render Pixi content
   * pixiRenderer.render(pixiScene);
   * ```
   */
  resetState() {
    this.runners.resetState.emit();
  }
};
_AbstractRenderer.defaultOptions = {
  /**
   * Default resolution / device pixel ratio of the renderer.
   * @default 1
   */
  resolution: 1,
  /**
   * Should the `failIfMajorPerformanceCaveat` flag be enabled as a context option used in the `isWebGLSupported`
   * function. If set to true, a WebGL renderer can fail to be created if the browser thinks there could be
   * performance issues when using WebGL.
   *
   * In PixiJS v6 this has changed from true to false by default, to allow WebGL to work in as many
   * scenarios as possible. However, some users may have a poor experience, for example, if a user has a gpu or
   * driver version blacklisted by the
   * browser.
   *
   * If your application requires high performance rendering, you may wish to set this to false.
   * We recommend one of two options if you decide to set this flag to false:
   *
   * 1: Use the Canvas renderer as a fallback in case high performance WebGL is
   *    not supported.
   *
   * 2: Call `isWebGLSupported` (which if found in the utils package) in your code before attempting to create a
   *    PixiJS renderer, and show an error message to the user if the function returns false, explaining that their
   *    device & browser combination does not support high performance WebGL.
   *    This is a much better strategy than trying to create a PixiJS renderer and finding it then fails.
   * @default false
   */
  failIfMajorPerformanceCaveat: false,
  /**
   * Should round pixels be forced when rendering?
   * @default false
   */
  roundPixels: false
};
let AbstractRenderer = _AbstractRenderer;
let _isWebGLSupported;
function isWebGLSupported(failIfMajorPerformanceCaveat) {
  if (_isWebGLSupported !== void 0)
    return _isWebGLSupported;
  _isWebGLSupported = (() => {
    const contextOptions = {
      stencil: true,
      failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat ?? AbstractRenderer.defaultOptions.failIfMajorPerformanceCaveat
    };
    try {
      if (!DOMAdapter.get().getWebGLRenderingContext()) {
        return false;
      }
      const canvas = DOMAdapter.get().createCanvas();
      let gl = canvas.getContext("webgl", contextOptions);
      const success = !!gl?.getContextAttributes()?.stencil;
      if (gl) {
        const loseContext = gl.getExtension("WEBGL_lose_context");
        if (loseContext) {
          loseContext.loseContext();
        }
      }
      gl = null;
      return success;
    } catch (_e) {
      return false;
    }
  })();
  return _isWebGLSupported;
}
let _isWebGPUSupported;
async function isWebGPUSupported(options = {}) {
  if (_isWebGPUSupported !== void 0)
    return _isWebGPUSupported;
  _isWebGPUSupported = await (async () => {
    const gpu = DOMAdapter.get().getNavigator().gpu;
    if (!gpu) {
      return false;
    }
    try {
      const adapter = await gpu.requestAdapter(options);
      await adapter.requestDevice();
      return true;
    } catch (_e) {
      return false;
    }
  })();
  return _isWebGPUSupported;
}
const renderPriority = ["webgl", "webgpu", "canvas"];
async function autoDetectRenderer(options) {
  let preferredOrder = [];
  if (options.preference) {
    preferredOrder.push(options.preference);
    renderPriority.forEach((item) => {
      if (item !== options.preference) {
        preferredOrder.push(item);
      }
    });
  } else {
    preferredOrder = renderPriority.slice();
  }
  let RendererClass;
  let finalOptions = {};
  for (let i2 = 0; i2 < preferredOrder.length; i2++) {
    const rendererType = preferredOrder[i2];
    if (rendererType === "webgpu" && await isWebGPUSupported()) {
      const { WebGPURenderer } = await import("./WebGPURenderer.js");
      RendererClass = WebGPURenderer;
      finalOptions = { ...options, ...options.webgpu };
      break;
    } else if (rendererType === "webgl" && isWebGLSupported(
      options.failIfMajorPerformanceCaveat ?? AbstractRenderer.defaultOptions.failIfMajorPerformanceCaveat
    )) {
      const { WebGLRenderer } = await import("./WebGLRenderer.js");
      RendererClass = WebGLRenderer;
      finalOptions = { ...options, ...options.webgl };
      break;
    } else if (rendererType === "canvas") {
      finalOptions = { ...options };
      throw new Error("CanvasRenderer is not yet implemented");
    }
  }
  delete finalOptions.webgpu;
  delete finalOptions.webgl;
  if (!RendererClass) {
    throw new Error("No available renderer for the current environment");
  }
  const renderer = new RendererClass();
  await renderer.init(finalOptions);
  return renderer;
}
const VERSION = "8.7.3";
class ApplicationInitHook {
  static init() {
    globalThis.__PIXI_APP_INIT__?.(this, VERSION);
  }
  static destroy() {
  }
}
ApplicationInitHook.extension = ExtensionType.Application;
class RendererInitHook {
  constructor(renderer) {
    this._renderer = renderer;
  }
  init() {
    globalThis.__PIXI_RENDERER_INIT__?.(this._renderer, VERSION);
  }
  destroy() {
    this._renderer = null;
  }
}
RendererInitHook.extension = {
  type: [
    ExtensionType.WebGLSystem,
    ExtensionType.WebGPUSystem
  ],
  name: "initHook",
  priority: -10
};
const _Application = class _Application2 {
  /** @ignore */
  constructor(...args) {
    this.stage = new Container();
    if (args[0] !== void 0) {
      deprecation(v8_0_0, "Application constructor options are deprecated, please use Application.init() instead.");
    }
  }
  /**
   * @param options - The optional application and renderer parameters.
   */
  async init(options) {
    options = { ...options };
    this.renderer = await autoDetectRenderer(options);
    _Application2._plugins.forEach((plugin) => {
      plugin.init.call(this, options);
    });
  }
  /** Render the current stage. */
  render() {
    this.renderer.render({ container: this.stage });
  }
  /**
   * Reference to the renderer's canvas element.
   * @readonly
   * @member {HTMLCanvasElement}
   */
  get canvas() {
    return this.renderer.canvas;
  }
  /**
   * Reference to the renderer's canvas element.
   * @member {HTMLCanvasElement}
   * @deprecated since 8.0.0
   */
  get view() {
    deprecation(v8_0_0, "Application.view is deprecated, please use Application.canvas instead.");
    return this.renderer.canvas;
  }
  /**
   * Reference to the renderer's screen rectangle. Its safe to use as `filterArea` or `hitArea` for the whole screen.
   * @readonly
   */
  get screen() {
    return this.renderer.screen;
  }
  /**
   * Destroys the application and all of its resources.
   * @param {object|boolean}[rendererDestroyOptions=false] - The options for destroying the renderer.
   * @param {boolean}[rendererDestroyOptions.removeView=false] - Removes the Canvas element from the DOM.
   * @param {object|boolean} [options=false] - The options for destroying the stage.
   * @param {boolean} [options.children=false] - If set to true, all the children will have their destroy method
   * called as well. `options` will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for children with textures e.g. Sprites.
   * If options.children is set to true,
   * it should destroy the texture of the child sprite.
   * @param {boolean} [options.textureSource=false] - Only used for children with textures e.g. Sprites.
   *  If options.children is set to true,
   * it should destroy the texture source of the child sprite.
   * @param {boolean} [options.context=false] - Only used for children with graphicsContexts e.g. Graphics.
   * If options.children is set to true,
   * it should destroy the context of the child graphics.
   */
  destroy(rendererDestroyOptions = false, options = false) {
    const plugins = _Application2._plugins.slice(0);
    plugins.reverse();
    plugins.forEach((plugin) => {
      plugin.destroy.call(this);
    });
    this.stage.destroy(options);
    this.stage = null;
    this.renderer.destroy(rendererDestroyOptions);
    this.renderer = null;
  }
};
_Application._plugins = [];
let Application = _Application;
extensions.handleByList(ExtensionType.Application, Application._plugins);
extensions.add(ApplicationInitHook);
class AbstractBitmapFont extends EventEmitter {
  constructor() {
    super(...arguments);
    this.chars = /* @__PURE__ */ Object.create(null);
    this.lineHeight = 0;
    this.fontFamily = "";
    this.fontMetrics = { fontSize: 0, ascent: 0, descent: 0 };
    this.baseLineOffset = 0;
    this.distanceField = { type: "none", range: 0 };
    this.pages = [];
    this.applyFillAsTint = true;
    this.baseMeasurementFontSize = 100;
    this.baseRenderedFontSize = 100;
  }
  /**
   * The name of the font face.
   * @deprecated since 8.0.0 Use `fontFamily` instead.
   */
  get font() {
    deprecation(v8_0_0, "BitmapFont.font is deprecated, please use BitmapFont.fontFamily instead.");
    return this.fontFamily;
  }
  /**
   * The map of base page textures (i.e., sheets of glyphs).
   * @deprecated since 8.0.0 Use `pages` instead.
   */
  get pageTextures() {
    deprecation(v8_0_0, "BitmapFont.pageTextures is deprecated, please use BitmapFont.pages instead.");
    return this.pages;
  }
  /**
   * The size of the font face in pixels.
   * @deprecated since 8.0.0 Use `fontMetrics.fontSize` instead.
   */
  get size() {
    deprecation(v8_0_0, "BitmapFont.size is deprecated, please use BitmapFont.fontMetrics.fontSize instead.");
    return this.fontMetrics.fontSize;
  }
  /**
   * The kind of distance field for this font or "none".
   * @deprecated since 8.0.0 Use `distanceField.type` instead.
   */
  get distanceFieldRange() {
    deprecation(v8_0_0, "BitmapFont.distanceFieldRange is deprecated, please use BitmapFont.distanceField.range instead.");
    return this.distanceField.range;
  }
  /**
   * The range of the distance field in pixels.
   * @deprecated since 8.0.0 Use `distanceField.range` instead.
   */
  get distanceFieldType() {
    deprecation(v8_0_0, "BitmapFont.distanceFieldType is deprecated, please use BitmapFont.distanceField.type instead.");
    return this.distanceField.type;
  }
  destroy(destroyTextures = false) {
    this.emit("destroy", this);
    this.removeAllListeners();
    for (const i2 in this.chars) {
      this.chars[i2].texture?.destroy();
    }
    this.chars = null;
    if (destroyTextures) {
      this.pages.forEach((page) => page.texture.destroy(true));
      this.pages = null;
    }
  }
}
const _FillGradient = class _FillGradient2 {
  constructor(x0, y0, x1, y1) {
    this.uid = uid("fillGradient");
    this.type = "linear";
    this.gradientStops = [];
    this._styleKey = null;
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
  }
  addColorStop(offset, color) {
    this.gradientStops.push({ offset, color: Color.shared.setValue(color).toHexa() });
    this._styleKey = null;
    return this;
  }
  // TODO move to the system!
  buildLinearGradient() {
    if (this.texture)
      return;
    const defaultSize = _FillGradient2.defaultTextureSize;
    const { gradientStops } = this;
    const canvas = DOMAdapter.get().createCanvas();
    canvas.width = defaultSize;
    canvas.height = defaultSize;
    const ctx = canvas.getContext("2d");
    const gradient = ctx.createLinearGradient(0, 0, _FillGradient2.defaultTextureSize, 1);
    for (let i2 = 0; i2 < gradientStops.length; i2++) {
      const stop = gradientStops[i2];
      gradient.addColorStop(stop.offset, stop.color);
    }
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, defaultSize, defaultSize);
    this.texture = new Texture({
      source: new ImageSource({
        resource: canvas,
        addressModeU: "clamp-to-edge",
        addressModeV: "repeat"
      })
    });
    const { x0, y0, x1, y1 } = this;
    const m2 = new Matrix();
    const dx = x1 - x0;
    const dy = y1 - y0;
    const dist = Math.sqrt(dx * dx + dy * dy);
    const angle = Math.atan2(dy, dx);
    m2.translate(-x0, -y0);
    m2.scale(1 / defaultSize, 1 / defaultSize);
    m2.rotate(-angle);
    m2.scale(256 / dist, 1);
    this.transform = m2;
    this._styleKey = null;
  }
  get styleKey() {
    if (this._styleKey) {
      return this._styleKey;
    }
    const stops = this.gradientStops.map((stop) => `${stop.offset}-${stop.color}`).join("-");
    const texture = this.texture.uid;
    const transform = this.transform.toArray().join("-");
    return `fill-gradient-${this.uid}-${stops}-${texture}-${transform}-${this.x0}-${this.y0}-${this.x1}-${this.y1}`;
  }
};
_FillGradient.defaultTextureSize = 256;
let FillGradient = _FillGradient;
const repetitionMap = {
  repeat: {
    addressModeU: "repeat",
    addressModeV: "repeat"
  },
  "repeat-x": {
    addressModeU: "repeat",
    addressModeV: "clamp-to-edge"
  },
  "repeat-y": {
    addressModeU: "clamp-to-edge",
    addressModeV: "repeat"
  },
  "no-repeat": {
    addressModeU: "clamp-to-edge",
    addressModeV: "clamp-to-edge"
  }
};
class FillPattern {
  constructor(texture, repetition) {
    this.uid = uid("fillPattern");
    this.transform = new Matrix();
    this._styleKey = null;
    this.texture = texture;
    this.transform.scale(
      1 / texture.frame.width,
      1 / texture.frame.height
    );
    if (repetition) {
      texture.source.style.addressModeU = repetitionMap[repetition].addressModeU;
      texture.source.style.addressModeV = repetitionMap[repetition].addressModeV;
    }
  }
  setTransform(transform) {
    const texture = this.texture;
    this.transform.copyFrom(transform);
    this.transform.invert();
    this.transform.scale(
      1 / texture.frame.width,
      1 / texture.frame.height
    );
    this._styleKey = null;
  }
  get styleKey() {
    if (this._styleKey)
      return this._styleKey;
    this._styleKey = `fill-pattern-${this.uid}-${this.texture.uid}-${this.transform.toArray().join("-")}`;
    return this._styleKey;
  }
}
var parseSvgPath = parse;
var length = { a: 7, c: 6, h: 1, l: 2, m: 2, q: 4, s: 4, t: 2, v: 1, z: 0 };
var segment = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
function parse(path2) {
  var data = [];
  path2.replace(segment, function(_, command, args) {
    var type = command.toLowerCase();
    args = parseValues(args);
    if (type == "m" && args.length > 2) {
      data.push([command].concat(args.splice(0, 2)));
      type = "l";
      command = command == "m" ? "l" : "L";
    }
    while (true) {
      if (args.length == length[type]) {
        args.unshift(command);
        return data.push(args);
      }
      if (args.length < length[type])
        throw new Error("malformed path data");
      data.push([command].concat(args.splice(0, length[type])));
    }
  });
  return data;
}
var number = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
function parseValues(args) {
  var numbers = args.match(number);
  return numbers ? numbers.map(Number) : [];
}
const parse$1 = /* @__PURE__ */ getDefaultExportFromCjs(parseSvgPath);
function SVGToGraphicsPath(svgPath, path2) {
  const commands = parse$1(svgPath);
  const subpaths = [];
  let currentSubPath = null;
  let lastX = 0;
  let lastY = 0;
  for (let i2 = 0; i2 < commands.length; i2++) {
    const command = commands[i2];
    const type = command[0];
    const data = command;
    switch (type) {
      case "M":
        lastX = data[1];
        lastY = data[2];
        path2.moveTo(lastX, lastY);
        break;
      case "m":
        lastX += data[1];
        lastY += data[2];
        path2.moveTo(lastX, lastY);
        break;
      case "H":
        lastX = data[1];
        path2.lineTo(lastX, lastY);
        break;
      case "h":
        lastX += data[1];
        path2.lineTo(lastX, lastY);
        break;
      case "V":
        lastY = data[1];
        path2.lineTo(lastX, lastY);
        break;
      case "v":
        lastY += data[1];
        path2.lineTo(lastX, lastY);
        break;
      case "L":
        lastX = data[1];
        lastY = data[2];
        path2.lineTo(lastX, lastY);
        break;
      case "l":
        lastX += data[1];
        lastY += data[2];
        path2.lineTo(lastX, lastY);
        break;
      case "C":
        lastX = data[5];
        lastY = data[6];
        path2.bezierCurveTo(
          data[1],
          data[2],
          data[3],
          data[4],
          lastX,
          lastY
        );
        break;
      case "c":
        path2.bezierCurveTo(
          lastX + data[1],
          lastY + data[2],
          lastX + data[3],
          lastY + data[4],
          lastX + data[5],
          lastY + data[6]
        );
        lastX += data[5];
        lastY += data[6];
        break;
      case "S":
        lastX = data[3];
        lastY = data[4];
        path2.bezierCurveToShort(
          data[1],
          data[2],
          lastX,
          lastY
        );
        break;
      case "s":
        path2.bezierCurveToShort(
          lastX + data[1],
          lastY + data[2],
          lastX + data[3],
          lastY + data[4]
        );
        lastX += data[3];
        lastY += data[4];
        break;
      case "Q":
        lastX = data[3];
        lastY = data[4];
        path2.quadraticCurveTo(
          data[1],
          data[2],
          lastX,
          lastY
        );
        break;
      case "q":
        path2.quadraticCurveTo(
          lastX + data[1],
          lastY + data[2],
          lastX + data[3],
          lastY + data[4]
        );
        lastX += data[3];
        lastY += data[4];
        break;
      case "T":
        lastX = data[1];
        lastY = data[2];
        path2.quadraticCurveToShort(
          lastX,
          lastY
        );
        break;
      case "t":
        lastX += data[1];
        lastY += data[2];
        path2.quadraticCurveToShort(
          lastX,
          lastY
        );
        break;
      case "A":
        lastX = data[6];
        lastY = data[7];
        path2.arcToSvg(
          data[1],
          data[2],
          data[3],
          data[4],
          data[5],
          lastX,
          lastY
        );
        break;
      case "a":
        lastX += data[6];
        lastY += data[7];
        path2.arcToSvg(
          data[1],
          data[2],
          data[3],
          data[4],
          data[5],
          lastX,
          lastY
        );
        break;
      case "Z":
      case "z":
        path2.closePath();
        if (subpaths.length > 0) {
          currentSubPath = subpaths.pop();
          if (currentSubPath) {
            lastX = currentSubPath.startX;
            lastY = currentSubPath.startY;
          } else {
            lastX = 0;
            lastY = 0;
          }
        }
        currentSubPath = null;
        break;
      default:
        warn(`Unknown SVG path command: ${type}`);
    }
    if (type !== "Z" && type !== "z") {
      if (currentSubPath === null) {
        currentSubPath = { startX: lastX, startY: lastY };
        subpaths.push(currentSubPath);
      }
    }
  }
  return path2;
}
class Circle {
  /**
   * @param x - The X coordinate of the center of this circle
   * @param y - The Y coordinate of the center of this circle
   * @param radius - The radius of the circle
   */
  constructor(x2 = 0, y2 = 0, radius = 0) {
    this.type = "circle";
    this.x = x2;
    this.y = y2;
    this.radius = radius;
  }
  /**
   * Creates a clone of this Circle instance
   * @returns A copy of the Circle
   */
  clone() {
    return new Circle(this.x, this.y, this.radius);
  }
  /**
   * Checks whether the x and y coordinates given are contained within this circle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Circle
   */
  contains(x2, y2) {
    if (this.radius <= 0)
      return false;
    const r2 = this.radius * this.radius;
    let dx = this.x - x2;
    let dy = this.y - y2;
    dx *= dx;
    dy *= dy;
    return dx + dy <= r2;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this circle including the stroke.
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param width - The width of the line to check
   * @param alignment - The alignment of the stroke, 0.5 by default
   * @returns Whether the x/y coordinates are within this Circle
   */
  strokeContains(x2, y2, width, alignment = 0.5) {
    if (this.radius === 0)
      return false;
    const dx = this.x - x2;
    const dy = this.y - y2;
    const radius = this.radius;
    const outerWidth = (1 - alignment) * width;
    const distance = Math.sqrt(dx * dx + dy * dy);
    return distance <= radius + outerWidth && distance > radius - (width - outerWidth);
  }
  /**
   * Returns the framing rectangle of the circle as a Rectangle object
   * @param out
   * @returns The framing rectangle
   */
  getBounds(out2) {
    out2 || (out2 = new Rectangle());
    out2.x = this.x - this.radius;
    out2.y = this.y - this.radius;
    out2.width = this.radius * 2;
    out2.height = this.radius * 2;
    return out2;
  }
  /**
   * Copies another circle to this one.
   * @param circle - The circle to copy from.
   * @returns Returns itself.
   */
  copyFrom(circle) {
    this.x = circle.x;
    this.y = circle.y;
    this.radius = circle.radius;
    return this;
  }
  /**
   * Copies this circle to another one.
   * @param circle - The circle to copy to.
   * @returns Returns given parameter.
   */
  copyTo(circle) {
    circle.copyFrom(this);
    return circle;
  }
  toString() {
    return `[pixi.js/math:Circle x=${this.x} y=${this.y} radius=${this.radius}]`;
  }
}
class Ellipse {
  /**
   * @param x - The X coordinate of the center of this ellipse
   * @param y - The Y coordinate of the center of this ellipse
   * @param halfWidth - The half width of this ellipse
   * @param halfHeight - The half height of this ellipse
   */
  constructor(x2 = 0, y2 = 0, halfWidth = 0, halfHeight = 0) {
    this.type = "ellipse";
    this.x = x2;
    this.y = y2;
    this.halfWidth = halfWidth;
    this.halfHeight = halfHeight;
  }
  /**
   * Creates a clone of this Ellipse instance
   * @returns {Ellipse} A copy of the ellipse
   */
  clone() {
    return new Ellipse(this.x, this.y, this.halfWidth, this.halfHeight);
  }
  /**
   * Checks whether the x and y coordinates given are contained within this ellipse
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coords are within this ellipse
   */
  contains(x2, y2) {
    if (this.halfWidth <= 0 || this.halfHeight <= 0) {
      return false;
    }
    let normx = (x2 - this.x) / this.halfWidth;
    let normy = (y2 - this.y) / this.halfHeight;
    normx *= normx;
    normy *= normy;
    return normx + normy <= 1;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this ellipse including stroke
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke
   * @returns Whether the x/y coords are within this ellipse
   */
  strokeContains(x2, y2, strokeWidth, alignment = 0.5) {
    const { halfWidth, halfHeight } = this;
    if (halfWidth <= 0 || halfHeight <= 0) {
      return false;
    }
    const strokeOuterWidth = strokeWidth * (1 - alignment);
    const strokeInnerWidth = strokeWidth - strokeOuterWidth;
    const innerHorizontal = halfWidth - strokeInnerWidth;
    const innerVertical = halfHeight - strokeInnerWidth;
    const outerHorizontal = halfWidth + strokeOuterWidth;
    const outerVertical = halfHeight + strokeOuterWidth;
    const normalizedX = x2 - this.x;
    const normalizedY = y2 - this.y;
    const innerEllipse = normalizedX * normalizedX / (innerHorizontal * innerHorizontal) + normalizedY * normalizedY / (innerVertical * innerVertical);
    const outerEllipse = normalizedX * normalizedX / (outerHorizontal * outerHorizontal) + normalizedY * normalizedY / (outerVertical * outerVertical);
    return innerEllipse > 1 && outerEllipse <= 1;
  }
  /**
   * Returns the framing rectangle of the ellipse as a Rectangle object
   * @param out
   * @returns The framing rectangle
   */
  getBounds(out2) {
    out2 || (out2 = new Rectangle());
    out2.x = this.x - this.halfWidth;
    out2.y = this.y - this.halfHeight;
    out2.width = this.halfWidth * 2;
    out2.height = this.halfHeight * 2;
    return out2;
  }
  /**
   * Copies another ellipse to this one.
   * @param ellipse - The ellipse to copy from.
   * @returns Returns itself.
   */
  copyFrom(ellipse) {
    this.x = ellipse.x;
    this.y = ellipse.y;
    this.halfWidth = ellipse.halfWidth;
    this.halfHeight = ellipse.halfHeight;
    return this;
  }
  /**
   * Copies this ellipse to another one.
   * @param ellipse - The ellipse to copy to.
   * @returns Returns given parameter.
   */
  copyTo(ellipse) {
    ellipse.copyFrom(this);
    return ellipse;
  }
  toString() {
    return `[pixi.js/math:Ellipse x=${this.x} y=${this.y} halfWidth=${this.halfWidth} halfHeight=${this.halfHeight}]`;
  }
}
function squaredDistanceToLineSegment(x2, y2, x1, y1, x22, y22) {
  const a2 = x2 - x1;
  const b2 = y2 - y1;
  const c2 = x22 - x1;
  const d2 = y22 - y1;
  const dot = a2 * c2 + b2 * d2;
  const lenSq = c2 * c2 + d2 * d2;
  let param = -1;
  if (lenSq !== 0) {
    param = dot / lenSq;
  }
  let xx;
  let yy;
  if (param < 0) {
    xx = x1;
    yy = y1;
  } else if (param > 1) {
    xx = x22;
    yy = y22;
  } else {
    xx = x1 + param * c2;
    yy = y1 + param * d2;
  }
  const dx = x2 - xx;
  const dy = y2 - yy;
  return dx * dx + dy * dy;
}
class Polygon {
  /**
   * @param points - This can be an array of Points
   *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
   *  the arguments passed can be all the points of the polygon e.g.
   *  `new Polygon(new Point(), new Point(), ...)`, or the arguments passed can be flat
   *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
   */
  constructor(...points) {
    this.type = "polygon";
    let flat = Array.isArray(points[0]) ? points[0] : points;
    if (typeof flat[0] !== "number") {
      const p2 = [];
      for (let i2 = 0, il = flat.length; i2 < il; i2++) {
        p2.push(flat[i2].x, flat[i2].y);
      }
      flat = p2;
    }
    this.points = flat;
    this.closePath = true;
  }
  /**
   * Creates a clone of this polygon.
   * @returns - A copy of the polygon.
   */
  clone() {
    const points = this.points.slice();
    const polygon = new Polygon(points);
    polygon.closePath = this.closePath;
    return polygon;
  }
  /**
   * Checks whether the x and y coordinates passed to this function are contained within this polygon.
   * @param x - The X coordinate of the point to test.
   * @param y - The Y coordinate of the point to test.
   * @returns - Whether the x/y coordinates are within this polygon.
   */
  contains(x2, y2) {
    let inside = false;
    const length2 = this.points.length / 2;
    for (let i2 = 0, j2 = length2 - 1; i2 < length2; j2 = i2++) {
      const xi = this.points[i2 * 2];
      const yi = this.points[i2 * 2 + 1];
      const xj = this.points[j2 * 2];
      const yj = this.points[j2 * 2 + 1];
      const intersect = yi > y2 !== yj > y2 && x2 < (xj - xi) * ((y2 - yi) / (yj - yi)) + xi;
      if (intersect) {
        inside = !inside;
      }
    }
    return inside;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this polygon including the stroke.
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke, 0.5 by default
   * @returns Whether the x/y coordinates are within this polygon
   */
  strokeContains(x2, y2, strokeWidth, alignment = 0.5) {
    const strokeWidthSquared = strokeWidth * strokeWidth;
    const rightWidthSquared = strokeWidthSquared * (1 - alignment);
    const leftWidthSquared = strokeWidthSquared - rightWidthSquared;
    const { points } = this;
    const iterationLength = points.length - (this.closePath ? 0 : 2);
    for (let i2 = 0; i2 < iterationLength; i2 += 2) {
      const x1 = points[i2];
      const y1 = points[i2 + 1];
      const x22 = points[(i2 + 2) % points.length];
      const y22 = points[(i2 + 3) % points.length];
      const distanceSquared = squaredDistanceToLineSegment(x2, y2, x1, y1, x22, y22);
      const sign2 = Math.sign((x22 - x1) * (y2 - y1) - (y22 - y1) * (x2 - x1));
      if (distanceSquared <= (sign2 < 0 ? leftWidthSquared : rightWidthSquared)) {
        return true;
      }
    }
    return false;
  }
  /**
   * Returns the framing rectangle of the polygon as a Rectangle object
   * @param out - optional rectangle to store the result
   * @returns The framing rectangle
   */
  getBounds(out2) {
    out2 || (out2 = new Rectangle());
    const points = this.points;
    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;
    for (let i2 = 0, n2 = points.length; i2 < n2; i2 += 2) {
      const x2 = points[i2];
      const y2 = points[i2 + 1];
      minX = x2 < minX ? x2 : minX;
      maxX = x2 > maxX ? x2 : maxX;
      minY = y2 < minY ? y2 : minY;
      maxY = y2 > maxY ? y2 : maxY;
    }
    out2.x = minX;
    out2.width = maxX - minX;
    out2.y = minY;
    out2.height = maxY - minY;
    return out2;
  }
  /**
   * Copies another polygon to this one.
   * @param polygon - The polygon to copy from.
   * @returns Returns itself.
   */
  copyFrom(polygon) {
    this.points = polygon.points.slice();
    this.closePath = polygon.closePath;
    return this;
  }
  /**
   * Copies this polygon to another one.
   * @param polygon - The polygon to copy to.
   * @returns Returns given parameter.
   */
  copyTo(polygon) {
    polygon.copyFrom(this);
    return polygon;
  }
  toString() {
    return `[pixi.js/math:PolygoncloseStroke=${this.closePath}points=${this.points.reduce((pointsDesc, currentPoint) => `${pointsDesc}, ${currentPoint}`, "")}]`;
  }
  /**
   * Get the last X coordinate of the polygon
   * @readonly
   */
  get lastX() {
    return this.points[this.points.length - 2];
  }
  /**
   * Get the last Y coordinate of the polygon
   * @readonly
   */
  get lastY() {
    return this.points[this.points.length - 1];
  }
  /**
   * Get the first X coordinate of the polygon
   * @readonly
   */
  get x() {
    return this.points[this.points.length - 2];
  }
  /**
   * Get the first Y coordinate of the polygon
   * @readonly
   */
  get y() {
    return this.points[this.points.length - 1];
  }
}
const isCornerWithinStroke = (pX, pY, cornerX, cornerY, radius, strokeWidthInner, strokeWidthOuter) => {
  const dx = pX - cornerX;
  const dy = pY - cornerY;
  const distance = Math.sqrt(dx * dx + dy * dy);
  return distance >= radius - strokeWidthInner && distance <= radius + strokeWidthOuter;
};
class RoundedRectangle {
  /**
   * @param x - The X coordinate of the upper-left corner of the rounded rectangle
   * @param y - The Y coordinate of the upper-left corner of the rounded rectangle
   * @param width - The overall width of this rounded rectangle
   * @param height - The overall height of this rounded rectangle
   * @param radius - Controls the radius of the rounded corners
   */
  constructor(x2 = 0, y2 = 0, width = 0, height = 0, radius = 20) {
    this.type = "roundedRectangle";
    this.x = x2;
    this.y = y2;
    this.width = width;
    this.height = height;
    this.radius = radius;
  }
  /**
   * Returns the framing rectangle of the rounded rectangle as a Rectangle object
   * @param out - optional rectangle to store the result
   * @returns The framing rectangle
   */
  getBounds(out2) {
    out2 || (out2 = new Rectangle());
    out2.x = this.x;
    out2.y = this.y;
    out2.width = this.width;
    out2.height = this.height;
    return out2;
  }
  /**
   * Creates a clone of this Rounded Rectangle.
   * @returns - A copy of the rounded rectangle.
   */
  clone() {
    return new RoundedRectangle(this.x, this.y, this.width, this.height, this.radius);
  }
  /**
   * Copies another rectangle to this one.
   * @param rectangle - The rectangle to copy from.
   * @returns Returns itself.
   */
  copyFrom(rectangle) {
    this.x = rectangle.x;
    this.y = rectangle.y;
    this.width = rectangle.width;
    this.height = rectangle.height;
    return this;
  }
  /**
   * Copies this rectangle to another one.
   * @param rectangle - The rectangle to copy to.
   * @returns Returns given parameter.
   */
  copyTo(rectangle) {
    rectangle.copyFrom(this);
    return rectangle;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
   * @param x - The X coordinate of the point to test.
   * @param y - The Y coordinate of the point to test.
   * @returns - Whether the x/y coordinates are within this Rounded Rectangle.
   */
  contains(x2, y2) {
    if (this.width <= 0 || this.height <= 0) {
      return false;
    }
    if (x2 >= this.x && x2 <= this.x + this.width) {
      if (y2 >= this.y && y2 <= this.y + this.height) {
        const radius = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
        if (y2 >= this.y + radius && y2 <= this.y + this.height - radius || x2 >= this.x + radius && x2 <= this.x + this.width - radius) {
          return true;
        }
        let dx = x2 - (this.x + radius);
        let dy = y2 - (this.y + radius);
        const radius2 = radius * radius;
        if (dx * dx + dy * dy <= radius2) {
          return true;
        }
        dx = x2 - (this.x + this.width - radius);
        if (dx * dx + dy * dy <= radius2) {
          return true;
        }
        dy = y2 - (this.y + this.height - radius);
        if (dx * dx + dy * dy <= radius2) {
          return true;
        }
        dx = x2 - (this.x + radius);
        if (dx * dx + dy * dy <= radius2) {
          return true;
        }
      }
    }
    return false;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @param pX - The X coordinate of the point to test
   * @param pY - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke, 0.5 by default
   * @returns Whether the x/y coordinates are within this rectangle
   */
  strokeContains(pX, pY, strokeWidth, alignment = 0.5) {
    const { x: x2, y: y2, width, height, radius } = this;
    const strokeWidthOuter = strokeWidth * (1 - alignment);
    const strokeWidthInner = strokeWidth - strokeWidthOuter;
    const innerX = x2 + radius;
    const innerY = y2 + radius;
    const innerWidth = width - radius * 2;
    const innerHeight = height - radius * 2;
    const rightBound = x2 + width;
    const bottomBound = y2 + height;
    if ((pX >= x2 - strokeWidthOuter && pX <= x2 + strokeWidthInner || pX >= rightBound - strokeWidthInner && pX <= rightBound + strokeWidthOuter) && pY >= innerY && pY <= innerY + innerHeight) {
      return true;
    }
    if ((pY >= y2 - strokeWidthOuter && pY <= y2 + strokeWidthInner || pY >= bottomBound - strokeWidthInner && pY <= bottomBound + strokeWidthOuter) && pX >= innerX && pX <= innerX + innerWidth) {
      return true;
    }
    return (
      // Top-left
      pX < innerX && pY < innerY && isCornerWithinStroke(
        pX,
        pY,
        innerX,
        innerY,
        radius,
        strokeWidthInner,
        strokeWidthOuter
      ) || pX > rightBound - radius && pY < innerY && isCornerWithinStroke(
        pX,
        pY,
        rightBound - radius,
        innerY,
        radius,
        strokeWidthInner,
        strokeWidthOuter
      ) || pX > rightBound - radius && pY > bottomBound - radius && isCornerWithinStroke(
        pX,
        pY,
        rightBound - radius,
        bottomBound - radius,
        radius,
        strokeWidthInner,
        strokeWidthOuter
      ) || pX < innerX && pY > bottomBound - radius && isCornerWithinStroke(
        pX,
        pY,
        innerX,
        bottomBound - radius,
        radius,
        strokeWidthInner,
        strokeWidthOuter
      )
    );
  }
  toString() {
    return `[pixi.js/math:RoundedRectangle x=${this.x} y=${this.y}width=${this.width} height=${this.height} radius=${this.radius}]`;
  }
}
const fragTemplate = [
  "precision mediump float;",
  "void main(void){",
  "float test = 0.1;",
  "%forloop%",
  "gl_FragColor = vec4(0.0);",
  "}"
].join("\n");
function generateIfTestSrc(maxIfs) {
  let src = "";
  for (let i2 = 0; i2 < maxIfs; ++i2) {
    if (i2 > 0) {
      src += "\nelse ";
    }
    if (i2 < maxIfs - 1) {
      src += `if(test == ${i2}.0){}`;
    }
  }
  return src;
}
function checkMaxIfStatementsInShader(maxIfs, gl) {
  if (maxIfs === 0) {
    throw new Error("Invalid value of `0` passed to `checkMaxIfStatementsInShader`");
  }
  const shader = gl.createShader(gl.FRAGMENT_SHADER);
  try {
    while (true) {
      const fragmentSrc = fragTemplate.replace(/%forloop%/gi, generateIfTestSrc(maxIfs));
      gl.shaderSource(shader, fragmentSrc);
      gl.compileShader(shader);
      if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        maxIfs = maxIfs / 2 | 0;
      } else {
        break;
      }
    }
  } finally {
    gl.deleteShader(shader);
  }
  return maxIfs;
}
let maxTexturesPerBatchCache = null;
function getMaxTexturesPerBatch() {
  if (maxTexturesPerBatchCache)
    return maxTexturesPerBatchCache;
  const gl = getTestContext();
  maxTexturesPerBatchCache = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
  maxTexturesPerBatchCache = checkMaxIfStatementsInShader(
    maxTexturesPerBatchCache,
    gl
  );
  gl.getExtension("WEBGL_lose_context")?.loseContext();
  return maxTexturesPerBatchCache;
}
const cachedGroups = {};
function getTextureBatchBindGroup(textures, size) {
  let uid2 = 2166136261;
  for (let i2 = 0; i2 < size; i2++) {
    uid2 ^= textures[i2].uid;
    uid2 = Math.imul(uid2, 16777619);
    uid2 >>>= 0;
  }
  return cachedGroups[uid2] || generateTextureBatchBindGroup(textures, size, uid2);
}
let maxTextures = 0;
function generateTextureBatchBindGroup(textures, size, key) {
  const bindGroupResources = {};
  let bindIndex = 0;
  if (!maxTextures)
    maxTextures = getMaxTexturesPerBatch();
  for (let i2 = 0; i2 < maxTextures; i2++) {
    const texture = i2 < size ? textures[i2] : Texture.EMPTY.source;
    bindGroupResources[bindIndex++] = texture.source;
    bindGroupResources[bindIndex++] = texture.style;
  }
  const bindGroup = new BindGroup(bindGroupResources);
  cachedGroups[key] = bindGroup;
  return bindGroup;
}
class ViewableBuffer {
  constructor(sizeOrBuffer) {
    if (typeof sizeOrBuffer === "number") {
      this.rawBinaryData = new ArrayBuffer(sizeOrBuffer);
    } else if (sizeOrBuffer instanceof Uint8Array) {
      this.rawBinaryData = sizeOrBuffer.buffer;
    } else {
      this.rawBinaryData = sizeOrBuffer;
    }
    this.uint32View = new Uint32Array(this.rawBinaryData);
    this.float32View = new Float32Array(this.rawBinaryData);
    this.size = this.rawBinaryData.byteLength;
  }
  /** View on the raw binary data as a `Int8Array`. */
  get int8View() {
    if (!this._int8View) {
      this._int8View = new Int8Array(this.rawBinaryData);
    }
    return this._int8View;
  }
  /** View on the raw binary data as a `Uint8Array`. */
  get uint8View() {
    if (!this._uint8View) {
      this._uint8View = new Uint8Array(this.rawBinaryData);
    }
    return this._uint8View;
  }
  /**  View on the raw binary data as a `Int16Array`. */
  get int16View() {
    if (!this._int16View) {
      this._int16View = new Int16Array(this.rawBinaryData);
    }
    return this._int16View;
  }
  /** View on the raw binary data as a `Int32Array`. */
  get int32View() {
    if (!this._int32View) {
      this._int32View = new Int32Array(this.rawBinaryData);
    }
    return this._int32View;
  }
  /** View on the raw binary data as a `Float64Array`. */
  get float64View() {
    if (!this._float64Array) {
      this._float64Array = new Float64Array(this.rawBinaryData);
    }
    return this._float64Array;
  }
  /** View on the raw binary data as a `BigUint64Array`. */
  get bigUint64View() {
    if (!this._bigUint64Array) {
      this._bigUint64Array = new BigUint64Array(this.rawBinaryData);
    }
    return this._bigUint64Array;
  }
  /**
   * Returns the view of the given type.
   * @param type - One of `int8`, `uint8`, `int16`,
   *    `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - typed array of given type
   */
  view(type) {
    return this[`${type}View`];
  }
  /** Destroys all buffer references. Do not use after calling this. */
  destroy() {
    this.rawBinaryData = null;
    this._int8View = null;
    this._uint8View = null;
    this._int16View = null;
    this.uint16View = null;
    this._int32View = null;
    this.uint32View = null;
    this.float32View = null;
  }
  /**
   * Returns the size of the given type in bytes.
   * @param type - One of `int8`, `uint8`, `int16`,
   *   `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - size of the type in bytes
   */
  static sizeOf(type) {
    switch (type) {
      case "int8":
      case "uint8":
        return 1;
      case "int16":
      case "uint16":
        return 2;
      case "int32":
      case "uint32":
      case "float32":
        return 4;
      default:
        throw new Error(`${type} isn't a valid view type`);
    }
  }
}
function fastCopy(sourceBuffer, destinationBuffer) {
  const lengthDouble = sourceBuffer.byteLength / 8 | 0;
  const sourceFloat64View = new Float64Array(sourceBuffer, 0, lengthDouble);
  const destinationFloat64View = new Float64Array(destinationBuffer, 0, lengthDouble);
  destinationFloat64View.set(sourceFloat64View);
  const remainingBytes = sourceBuffer.byteLength - lengthDouble * 8;
  if (remainingBytes > 0) {
    const sourceUint8View = new Uint8Array(sourceBuffer, lengthDouble * 8, remainingBytes);
    const destinationUint8View = new Uint8Array(destinationBuffer, lengthDouble * 8, remainingBytes);
    destinationUint8View.set(sourceUint8View);
  }
}
const BLEND_TO_NPM = {
  normal: "normal-npm",
  add: "add-npm",
  screen: "screen-npm"
};
var STENCIL_MODES = /* @__PURE__ */ ((STENCIL_MODES2) => {
  STENCIL_MODES2[STENCIL_MODES2["DISABLED"] = 0] = "DISABLED";
  STENCIL_MODES2[STENCIL_MODES2["RENDERING_MASK_ADD"] = 1] = "RENDERING_MASK_ADD";
  STENCIL_MODES2[STENCIL_MODES2["MASK_ACTIVE"] = 2] = "MASK_ACTIVE";
  STENCIL_MODES2[STENCIL_MODES2["INVERSE_MASK_ACTIVE"] = 3] = "INVERSE_MASK_ACTIVE";
  STENCIL_MODES2[STENCIL_MODES2["RENDERING_MASK_REMOVE"] = 4] = "RENDERING_MASK_REMOVE";
  STENCIL_MODES2[STENCIL_MODES2["NONE"] = 5] = "NONE";
  return STENCIL_MODES2;
})(STENCIL_MODES || {});
function getAdjustedBlendModeBlend(blendMode, textureSource) {
  if (textureSource.alphaMode === "no-premultiply-alpha") {
    return BLEND_TO_NPM[blendMode] || blendMode;
  }
  return blendMode;
}
class BatchTextureArray {
  constructor() {
    this.ids = /* @__PURE__ */ Object.create(null);
    this.textures = [];
    this.count = 0;
  }
  /** Clear the textures and their locations. */
  clear() {
    for (let i2 = 0; i2 < this.count; i2++) {
      const t2 = this.textures[i2];
      this.textures[i2] = null;
      this.ids[t2.uid] = null;
    }
    this.count = 0;
  }
}
class Batch {
  constructor() {
    this.renderPipeId = "batch";
    this.action = "startBatch";
    this.start = 0;
    this.size = 0;
    this.textures = new BatchTextureArray();
    this.blendMode = "normal";
    this.topology = "triangle-strip";
    this.canBundle = true;
  }
  destroy() {
    this.textures = null;
    this.gpuBindGroup = null;
    this.bindGroup = null;
    this.batcher = null;
  }
}
const batchPool = [];
let batchPoolIndex = 0;
function getBatchFromPool() {
  return batchPoolIndex > 0 ? batchPool[--batchPoolIndex] : new Batch();
}
function returnBatchToPool(batch) {
  batchPool[batchPoolIndex++] = batch;
}
let BATCH_TICK = 0;
const _Batcher = class _Batcher2 {
  constructor(options = {}) {
    this.uid = uid("batcher");
    this.dirty = true;
    this.batchIndex = 0;
    this.batches = [];
    this._elements = [];
    _Batcher2.defaultOptions.maxTextures = _Batcher2.defaultOptions.maxTextures ?? getMaxTexturesPerBatch();
    options = { ..._Batcher2.defaultOptions, ...options };
    const { maxTextures: maxTextures2, attributesInitialSize, indicesInitialSize } = options;
    this.attributeBuffer = new ViewableBuffer(attributesInitialSize * 4);
    this.indexBuffer = new Uint16Array(indicesInitialSize);
    this.maxTextures = maxTextures2;
  }
  begin() {
    this.elementSize = 0;
    this.elementStart = 0;
    this.indexSize = 0;
    this.attributeSize = 0;
    for (let i2 = 0; i2 < this.batchIndex; i2++) {
      returnBatchToPool(this.batches[i2]);
    }
    this.batchIndex = 0;
    this._batchIndexStart = 0;
    this._batchIndexSize = 0;
    this.dirty = true;
  }
  add(batchableObject) {
    this._elements[this.elementSize++] = batchableObject;
    batchableObject._indexStart = this.indexSize;
    batchableObject._attributeStart = this.attributeSize;
    batchableObject._batcher = this;
    this.indexSize += batchableObject.indexSize;
    this.attributeSize += batchableObject.attributeSize * this.vertexSize;
  }
  checkAndUpdateTexture(batchableObject, texture) {
    const textureId = batchableObject._batch.textures.ids[texture._source.uid];
    if (!textureId && textureId !== 0)
      return false;
    batchableObject._textureId = textureId;
    batchableObject.texture = texture;
    return true;
  }
  updateElement(batchableObject) {
    this.dirty = true;
    const attributeBuffer = this.attributeBuffer;
    if (batchableObject.packAsQuad) {
      this.packQuadAttributes(
        batchableObject,
        attributeBuffer.float32View,
        attributeBuffer.uint32View,
        batchableObject._attributeStart,
        batchableObject._textureId
      );
    } else {
      this.packAttributes(
        batchableObject,
        attributeBuffer.float32View,
        attributeBuffer.uint32View,
        batchableObject._attributeStart,
        batchableObject._textureId
      );
    }
  }
  /**
   * breaks the batcher. This happens when a batch gets too big,
   * or we need to switch to a different type of rendering (a filter for example)
   * @param instructionSet
   */
  break(instructionSet) {
    const elements = this._elements;
    if (!elements[this.elementStart])
      return;
    let batch = getBatchFromPool();
    let textureBatch = batch.textures;
    textureBatch.clear();
    const firstElement = elements[this.elementStart];
    let blendMode = getAdjustedBlendModeBlend(firstElement.blendMode, firstElement.texture._source);
    let topology = firstElement.topology;
    if (this.attributeSize * 4 > this.attributeBuffer.size) {
      this._resizeAttributeBuffer(this.attributeSize * 4);
    }
    if (this.indexSize > this.indexBuffer.length) {
      this._resizeIndexBuffer(this.indexSize);
    }
    const f32 = this.attributeBuffer.float32View;
    const u32 = this.attributeBuffer.uint32View;
    const indexBuffer = this.indexBuffer;
    let size = this._batchIndexSize;
    let start = this._batchIndexStart;
    let action = "startBatch";
    const maxTextures2 = this.maxTextures;
    for (let i2 = this.elementStart; i2 < this.elementSize; ++i2) {
      const element = elements[i2];
      elements[i2] = null;
      const texture = element.texture;
      const source2 = texture._source;
      const adjustedBlendMode = getAdjustedBlendModeBlend(element.blendMode, source2);
      const breakRequired = blendMode !== adjustedBlendMode || topology !== element.topology;
      if (source2._batchTick === BATCH_TICK && !breakRequired) {
        element._textureId = source2._textureBindLocation;
        size += element.indexSize;
        if (element.packAsQuad) {
          this.packQuadAttributes(
            element,
            f32,
            u32,
            element._attributeStart,
            element._textureId
          );
          this.packQuadIndex(
            indexBuffer,
            element._indexStart,
            element._attributeStart / this.vertexSize
          );
        } else {
          this.packAttributes(
            element,
            f32,
            u32,
            element._attributeStart,
            element._textureId
          );
          this.packIndex(
            element,
            indexBuffer,
            element._indexStart,
            element._attributeStart / this.vertexSize
          );
        }
        element._batch = batch;
        continue;
      }
      source2._batchTick = BATCH_TICK;
      if (textureBatch.count >= maxTextures2 || breakRequired) {
        this._finishBatch(
          batch,
          start,
          size - start,
          textureBatch,
          blendMode,
          topology,
          instructionSet,
          action
        );
        action = "renderBatch";
        start = size;
        blendMode = adjustedBlendMode;
        topology = element.topology;
        batch = getBatchFromPool();
        textureBatch = batch.textures;
        textureBatch.clear();
        ++BATCH_TICK;
      }
      element._textureId = source2._textureBindLocation = textureBatch.count;
      textureBatch.ids[source2.uid] = textureBatch.count;
      textureBatch.textures[textureBatch.count++] = source2;
      element._batch = batch;
      size += element.indexSize;
      if (element.packAsQuad) {
        this.packQuadAttributes(
          element,
          f32,
          u32,
          element._attributeStart,
          element._textureId
        );
        this.packQuadIndex(
          indexBuffer,
          element._indexStart,
          element._attributeStart / this.vertexSize
        );
      } else {
        this.packAttributes(
          element,
          f32,
          u32,
          element._attributeStart,
          element._textureId
        );
        this.packIndex(
          element,
          indexBuffer,
          element._indexStart,
          element._attributeStart / this.vertexSize
        );
      }
    }
    if (textureBatch.count > 0) {
      this._finishBatch(
        batch,
        start,
        size - start,
        textureBatch,
        blendMode,
        topology,
        instructionSet,
        action
      );
      start = size;
      ++BATCH_TICK;
    }
    this.elementStart = this.elementSize;
    this._batchIndexStart = start;
    this._batchIndexSize = size;
  }
  _finishBatch(batch, indexStart, indexSize, textureBatch, blendMode, topology, instructionSet, action) {
    batch.gpuBindGroup = null;
    batch.bindGroup = null;
    batch.action = action;
    batch.batcher = this;
    batch.textures = textureBatch;
    batch.blendMode = blendMode;
    batch.topology = topology;
    batch.start = indexStart;
    batch.size = indexSize;
    ++BATCH_TICK;
    this.batches[this.batchIndex++] = batch;
    instructionSet.add(batch);
  }
  finish(instructionSet) {
    this.break(instructionSet);
  }
  /**
   * Resizes the attribute buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */
  ensureAttributeBuffer(size) {
    if (size * 4 <= this.attributeBuffer.size)
      return;
    this._resizeAttributeBuffer(size * 4);
  }
  /**
   * Resizes the index buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */
  ensureIndexBuffer(size) {
    if (size <= this.indexBuffer.length)
      return;
    this._resizeIndexBuffer(size);
  }
  _resizeAttributeBuffer(size) {
    const newSize = Math.max(size, this.attributeBuffer.size * 2);
    const newArrayBuffer = new ViewableBuffer(newSize);
    fastCopy(this.attributeBuffer.rawBinaryData, newArrayBuffer.rawBinaryData);
    this.attributeBuffer = newArrayBuffer;
  }
  _resizeIndexBuffer(size) {
    const indexBuffer = this.indexBuffer;
    let newSize = Math.max(size, indexBuffer.length * 1.5);
    newSize += newSize % 2;
    const newIndexBuffer = newSize > 65535 ? new Uint32Array(newSize) : new Uint16Array(newSize);
    if (newIndexBuffer.BYTES_PER_ELEMENT !== indexBuffer.BYTES_PER_ELEMENT) {
      for (let i2 = 0; i2 < indexBuffer.length; i2++) {
        newIndexBuffer[i2] = indexBuffer[i2];
      }
    } else {
      fastCopy(indexBuffer.buffer, newIndexBuffer.buffer);
    }
    this.indexBuffer = newIndexBuffer;
  }
  packQuadIndex(indexBuffer, index, indicesOffset) {
    indexBuffer[index] = indicesOffset + 0;
    indexBuffer[index + 1] = indicesOffset + 1;
    indexBuffer[index + 2] = indicesOffset + 2;
    indexBuffer[index + 3] = indicesOffset + 0;
    indexBuffer[index + 4] = indicesOffset + 2;
    indexBuffer[index + 5] = indicesOffset + 3;
  }
  packIndex(element, indexBuffer, index, indicesOffset) {
    const indices = element.indices;
    const size = element.indexSize;
    const indexOffset = element.indexOffset;
    const attributeOffset = element.attributeOffset;
    for (let i2 = 0; i2 < size; i2++) {
      indexBuffer[index++] = indicesOffset + indices[i2 + indexOffset] - attributeOffset;
    }
  }
  destroy() {
    for (let i2 = 0; i2 < this.batches.length; i2++) {
      returnBatchToPool(this.batches[i2]);
    }
    this.batches = null;
    for (let i2 = 0; i2 < this._elements.length; i2++) {
      this._elements[i2]._batch = null;
    }
    this._elements = null;
    this.indexBuffer = null;
    this.attributeBuffer.destroy();
    this.attributeBuffer = null;
  }
};
_Batcher.defaultOptions = {
  maxTextures: null,
  attributesInitialSize: 4,
  indicesInitialSize: 6
};
let Batcher = _Batcher;
var BufferUsage = /* @__PURE__ */ ((BufferUsage2) => {
  BufferUsage2[BufferUsage2["MAP_READ"] = 1] = "MAP_READ";
  BufferUsage2[BufferUsage2["MAP_WRITE"] = 2] = "MAP_WRITE";
  BufferUsage2[BufferUsage2["COPY_SRC"] = 4] = "COPY_SRC";
  BufferUsage2[BufferUsage2["COPY_DST"] = 8] = "COPY_DST";
  BufferUsage2[BufferUsage2["INDEX"] = 16] = "INDEX";
  BufferUsage2[BufferUsage2["VERTEX"] = 32] = "VERTEX";
  BufferUsage2[BufferUsage2["UNIFORM"] = 64] = "UNIFORM";
  BufferUsage2[BufferUsage2["STORAGE"] = 128] = "STORAGE";
  BufferUsage2[BufferUsage2["INDIRECT"] = 256] = "INDIRECT";
  BufferUsage2[BufferUsage2["QUERY_RESOLVE"] = 512] = "QUERY_RESOLVE";
  BufferUsage2[BufferUsage2["STATIC"] = 1024] = "STATIC";
  return BufferUsage2;
})(BufferUsage || {});
class Buffer extends EventEmitter {
  /**
   * Creates a new Buffer with the given options
   * @param options - the options for the buffer
   */
  constructor(options) {
    let { data, size } = options;
    const { usage, label, shrinkToFit } = options;
    super();
    this.uid = uid("buffer");
    this._resourceType = "buffer";
    this._resourceId = uid("resource");
    this._touched = 0;
    this._updateID = 1;
    this._dataInt32 = null;
    this.shrinkToFit = true;
    this.destroyed = false;
    if (data instanceof Array) {
      data = new Float32Array(data);
    }
    this._data = data;
    size ?? (size = data?.byteLength);
    const mappedAtCreation = !!data;
    this.descriptor = {
      size,
      usage,
      mappedAtCreation,
      label
    };
    this.shrinkToFit = shrinkToFit ?? true;
  }
  /** the data in the buffer */
  get data() {
    return this._data;
  }
  set data(value) {
    this.setDataWithSize(value, value.length, true);
  }
  get dataInt32() {
    if (!this._dataInt32) {
      this._dataInt32 = new Int32Array(this.data.buffer);
    }
    return this._dataInt32;
  }
  /** whether the buffer is static or not */
  get static() {
    return !!(this.descriptor.usage & BufferUsage.STATIC);
  }
  set static(value) {
    if (value) {
      this.descriptor.usage |= BufferUsage.STATIC;
    } else {
      this.descriptor.usage &= ~BufferUsage.STATIC;
    }
  }
  /**
   * Sets the data in the buffer to the given value. This will immediately update the buffer on the GPU.
   * If you only want to update a subset of the buffer, you can pass in the size of the data.
   * @param value - the data to set
   * @param size - the size of the data in bytes
   * @param syncGPU - should the buffer be updated on the GPU immediately?
   */
  setDataWithSize(value, size, syncGPU) {
    this._updateID++;
    this._updateSize = size * value.BYTES_PER_ELEMENT;
    if (this._data === value) {
      if (syncGPU)
        this.emit("update", this);
      return;
    }
    const oldData = this._data;
    this._data = value;
    this._dataInt32 = null;
    if (!oldData || oldData.length !== value.length) {
      if (!this.shrinkToFit && oldData && value.byteLength < oldData.byteLength) {
        if (syncGPU)
          this.emit("update", this);
      } else {
        this.descriptor.size = value.byteLength;
        this._resourceId = uid("resource");
        this.emit("change", this);
      }
      return;
    }
    if (syncGPU)
      this.emit("update", this);
  }
  /**
   * updates the buffer on the GPU to reflect the data in the buffer.
   * By default it will update the entire buffer. If you only want to update a subset of the buffer,
   * you can pass in the size of the buffer to update.
   * @param sizeInBytes - the new size of the buffer in bytes
   */
  update(sizeInBytes) {
    this._updateSize = sizeInBytes ?? this._updateSize;
    this._updateID++;
    this.emit("update", this);
  }
  /** Destroys the buffer */
  destroy() {
    this.destroyed = true;
    this.emit("destroy", this);
    this.emit("change", this);
    this._data = null;
    this.descriptor = null;
    this.removeAllListeners();
  }
}
function ensureIsBuffer(buffer, index) {
  if (!(buffer instanceof Buffer)) {
    let usage = index ? BufferUsage.INDEX : BufferUsage.VERTEX;
    if (buffer instanceof Array) {
      if (index) {
        buffer = new Uint32Array(buffer);
        usage = BufferUsage.INDEX | BufferUsage.COPY_DST;
      } else {
        buffer = new Float32Array(buffer);
        usage = BufferUsage.VERTEX | BufferUsage.COPY_DST;
      }
    }
    buffer = new Buffer({
      data: buffer,
      label: index ? "index-mesh-buffer" : "vertex-mesh-buffer",
      usage
    });
  }
  return buffer;
}
function getGeometryBounds(geometry, attributeId, bounds) {
  const attribute = geometry.getAttribute(attributeId);
  if (!attribute) {
    bounds.minX = 0;
    bounds.minY = 0;
    bounds.maxX = 0;
    bounds.maxY = 0;
    return bounds;
  }
  const data = attribute.buffer.data;
  let minX = Infinity;
  let minY = Infinity;
  let maxX = -Infinity;
  let maxY = -Infinity;
  const byteSize = data.BYTES_PER_ELEMENT;
  const offset = (attribute.offset || 0) / byteSize;
  const stride = (attribute.stride || 2 * 4) / byteSize;
  for (let i2 = offset; i2 < data.length; i2 += stride) {
    const x2 = data[i2];
    const y2 = data[i2 + 1];
    if (x2 > maxX)
      maxX = x2;
    if (y2 > maxY)
      maxY = y2;
    if (x2 < minX)
      minX = x2;
    if (y2 < minY)
      minY = y2;
  }
  bounds.minX = minX;
  bounds.minY = minY;
  bounds.maxX = maxX;
  bounds.maxY = maxY;
  return bounds;
}
function ensureIsAttribute(attribute) {
  if (attribute instanceof Buffer || Array.isArray(attribute) || attribute.BYTES_PER_ELEMENT) {
    attribute = {
      buffer: attribute
    };
  }
  attribute.buffer = ensureIsBuffer(attribute.buffer, false);
  return attribute;
}
class Geometry extends EventEmitter {
  /**
   * Create a new instance of a geometry
   * @param options - The options for the geometry.
   */
  constructor(options = {}) {
    super();
    this.uid = uid("geometry");
    this._layoutKey = 0;
    this.instanceCount = 1;
    this._bounds = new Bounds();
    this._boundsDirty = true;
    const { attributes, indexBuffer, topology } = options;
    this.buffers = [];
    this.attributes = {};
    if (attributes) {
      for (const i2 in attributes) {
        this.addAttribute(i2, attributes[i2]);
      }
    }
    this.instanceCount = options.instanceCount ?? 1;
    if (indexBuffer) {
      this.addIndex(indexBuffer);
    }
    this.topology = topology || "triangle-list";
  }
  onBufferUpdate() {
    this._boundsDirty = true;
    this.emit("update", this);
  }
  /**
   * Returns the requested attribute.
   * @param id - The name of the attribute required
   * @returns - The attribute requested.
   */
  getAttribute(id) {
    return this.attributes[id];
  }
  /**
   * Returns the index buffer
   * @returns - The index buffer.
   */
  getIndex() {
    return this.indexBuffer;
  }
  /**
   * Returns the requested buffer.
   * @param id - The name of the buffer required.
   * @returns - The buffer requested.
   */
  getBuffer(id) {
    return this.getAttribute(id).buffer;
  }
  /**
   * Used to figure out how many vertices there are in this geometry
   * @returns the number of vertices in the geometry
   */
  getSize() {
    for (const i2 in this.attributes) {
      const attribute = this.attributes[i2];
      const buffer = attribute.buffer;
      return buffer.data.length / (attribute.stride / 4 || attribute.size);
    }
    return 0;
  }
  /**
   * Adds an attribute to the geometry.
   * @param name - The name of the attribute to add.
   * @param attributeOption - The attribute option to add.
   */
  addAttribute(name, attributeOption) {
    const attribute = ensureIsAttribute(attributeOption);
    const bufferIndex = this.buffers.indexOf(attribute.buffer);
    if (bufferIndex === -1) {
      this.buffers.push(attribute.buffer);
      attribute.buffer.on("update", this.onBufferUpdate, this);
      attribute.buffer.on("change", this.onBufferUpdate, this);
    }
    this.attributes[name] = attribute;
  }
  /**
   * Adds an index buffer to the geometry.
   * @param indexBuffer - The index buffer to add. Can be a Buffer, TypedArray, or an array of numbers.
   */
  addIndex(indexBuffer) {
    this.indexBuffer = ensureIsBuffer(indexBuffer, true);
    this.buffers.push(this.indexBuffer);
  }
  /** Returns the bounds of the geometry. */
  get bounds() {
    if (!this._boundsDirty)
      return this._bounds;
    this._boundsDirty = false;
    return getGeometryBounds(this, "aPosition", this._bounds);
  }
  /**
   * destroys the geometry.
   * @param destroyBuffers - destroy the buffers associated with this geometry
   */
  destroy(destroyBuffers = false) {
    this.emit("destroy", this);
    this.removeAllListeners();
    if (destroyBuffers) {
      this.buffers.forEach((buffer) => buffer.destroy());
    }
    this.attributes = null;
    this.buffers = null;
    this.indexBuffer = null;
    this._bounds = null;
  }
}
const placeHolderBufferData = new Float32Array(1);
const placeHolderIndexData = new Uint32Array(1);
class BatchGeometry extends Geometry {
  constructor() {
    const vertexSize = 6;
    const attributeBuffer = new Buffer({
      data: placeHolderBufferData,
      label: "attribute-batch-buffer",
      usage: BufferUsage.VERTEX | BufferUsage.COPY_DST,
      shrinkToFit: false
    });
    const indexBuffer = new Buffer({
      data: placeHolderIndexData,
      label: "index-batch-buffer",
      usage: BufferUsage.INDEX | BufferUsage.COPY_DST,
      // | BufferUsage.STATIC,
      shrinkToFit: false
    });
    const stride = vertexSize * 4;
    super({
      attributes: {
        aPosition: {
          buffer: attributeBuffer,
          format: "float32x2",
          stride,
          offset: 0
        },
        aUV: {
          buffer: attributeBuffer,
          format: "float32x2",
          stride,
          offset: 2 * 4
        },
        aColor: {
          buffer: attributeBuffer,
          format: "unorm8x4",
          stride,
          offset: 4 * 4
        },
        aTextureIdAndRound: {
          buffer: attributeBuffer,
          format: "uint16x2",
          stride,
          offset: 5 * 4
        }
      },
      indexBuffer
    });
  }
}
function addBits(srcParts, parts, name) {
  if (srcParts) {
    for (const i2 in srcParts) {
      const id = i2.toLocaleLowerCase();
      const part = parts[id];
      if (part) {
        let sanitisedPart = srcParts[i2];
        if (i2 === "header") {
          sanitisedPart = sanitisedPart.replace(/@in\s+[^;]+;\s*/g, "").replace(/@out\s+[^;]+;\s*/g, "");
        }
        if (name) {
          part.push(`//----${name}----//`);
        }
        part.push(sanitisedPart);
      } else {
        warn(`${i2} placement hook does not exist in shader`);
      }
    }
  }
}
const findHooksRx = /\{\{(.*?)\}\}/g;
function compileHooks(programSrc) {
  const parts = {};
  const partMatches = programSrc.match(findHooksRx)?.map((hook) => hook.replace(/[{()}]/g, "")) ?? [];
  partMatches.forEach((hook) => {
    parts[hook] = [];
  });
  return parts;
}
function extractInputs(fragmentSource, out2) {
  let match;
  const regex = /@in\s+([^;]+);/g;
  while ((match = regex.exec(fragmentSource)) !== null) {
    out2.push(match[1]);
  }
}
function compileInputs(fragments, template, sort = false) {
  const results = [];
  extractInputs(template, results);
  fragments.forEach((fragment2) => {
    if (fragment2.header) {
      extractInputs(fragment2.header, results);
    }
  });
  const mainInput = results;
  if (sort) {
    mainInput.sort();
  }
  const finalString = mainInput.map((inValue, i2) => `       @location(${i2}) ${inValue},`).join("\n");
  let cleanedString = template.replace(/@in\s+[^;]+;\s*/g, "");
  cleanedString = cleanedString.replace("{{in}}", `
${finalString}
`);
  return cleanedString;
}
function extractOutputs(fragmentSource, out2) {
  let match;
  const regex = /@out\s+([^;]+);/g;
  while ((match = regex.exec(fragmentSource)) !== null) {
    out2.push(match[1]);
  }
}
function extractVariableName(value) {
  const regex = /\b(\w+)\s*:/g;
  const match = regex.exec(value);
  return match ? match[1] : "";
}
function stripVariable(value) {
  const regex = /@.*?\s+/g;
  return value.replace(regex, "");
}
function compileOutputs(fragments, template) {
  const results = [];
  extractOutputs(template, results);
  fragments.forEach((fragment2) => {
    if (fragment2.header) {
      extractOutputs(fragment2.header, results);
    }
  });
  let index = 0;
  const mainStruct = results.sort().map((inValue) => {
    if (inValue.indexOf("builtin") > -1) {
      return inValue;
    }
    return `@location(${index++}) ${inValue}`;
  }).join(",\n");
  const mainStart = results.sort().map((inValue) => `       var ${stripVariable(inValue)};`).join("\n");
  const mainEnd = `return VSOutput(
            ${results.sort().map((inValue) => ` ${extractVariableName(inValue)}`).join(",\n")});`;
  let compiledCode = template.replace(/@out\s+[^;]+;\s*/g, "");
  compiledCode = compiledCode.replace("{{struct}}", `
${mainStruct}
`);
  compiledCode = compiledCode.replace("{{start}}", `
${mainStart}
`);
  compiledCode = compiledCode.replace("{{return}}", `
${mainEnd}
`);
  return compiledCode;
}
function injectBits(templateSrc, fragmentParts) {
  let out2 = templateSrc;
  for (const i2 in fragmentParts) {
    const parts = fragmentParts[i2];
    const toInject = parts.join("\n");
    if (toInject.length) {
      out2 = out2.replace(`{{${i2}}}`, `//-----${i2} START-----//
${parts.join("\n")}
//----${i2} FINISH----//`);
    } else {
      out2 = out2.replace(`{{${i2}}}`, "");
    }
  }
  return out2;
}
const cacheMap = /* @__PURE__ */ Object.create(null);
const bitCacheMap = /* @__PURE__ */ new Map();
let CACHE_UID = 0;
function compileHighShader({
  template,
  bits
}) {
  const cacheId = generateCacheId(template, bits);
  if (cacheMap[cacheId])
    return cacheMap[cacheId];
  const { vertex: vertex2, fragment: fragment2 } = compileInputsAndOutputs(template, bits);
  cacheMap[cacheId] = compileBits(vertex2, fragment2, bits);
  return cacheMap[cacheId];
}
function compileHighShaderGl({
  template,
  bits
}) {
  const cacheId = generateCacheId(template, bits);
  if (cacheMap[cacheId])
    return cacheMap[cacheId];
  cacheMap[cacheId] = compileBits(template.vertex, template.fragment, bits);
  return cacheMap[cacheId];
}
function compileInputsAndOutputs(template, bits) {
  const vertexFragments = bits.map((shaderBit) => shaderBit.vertex).filter((v2) => !!v2);
  const fragmentFragments = bits.map((shaderBit) => shaderBit.fragment).filter((v2) => !!v2);
  let compiledVertex = compileInputs(vertexFragments, template.vertex, true);
  compiledVertex = compileOutputs(vertexFragments, compiledVertex);
  const compiledFragment = compileInputs(fragmentFragments, template.fragment, true);
  return {
    vertex: compiledVertex,
    fragment: compiledFragment
  };
}
function generateCacheId(template, bits) {
  return bits.map((highFragment) => {
    if (!bitCacheMap.has(highFragment)) {
      bitCacheMap.set(highFragment, CACHE_UID++);
    }
    return bitCacheMap.get(highFragment);
  }).sort((a2, b2) => a2 - b2).join("-") + template.vertex + template.fragment;
}
function compileBits(vertex2, fragment2, bits) {
  const vertexParts = compileHooks(vertex2);
  const fragmentParts = compileHooks(fragment2);
  bits.forEach((shaderBit) => {
    addBits(shaderBit.vertex, vertexParts, shaderBit.name);
    addBits(shaderBit.fragment, fragmentParts, shaderBit.name);
  });
  return {
    vertex: injectBits(vertex2, vertexParts),
    fragment: injectBits(fragment2, fragmentParts)
  };
}
const vertexGPUTemplate = (
  /* wgsl */
  `
    @in aPosition: vec2<f32>;
    @in aUV: vec2<f32>;

    @out @builtin(position) vPosition: vec4<f32>;
    @out vUV : vec2<f32>;
    @out vColor : vec4<f32>;

    {{header}}

    struct VSOutput {
        {{struct}}
    };

    @vertex
    fn main( {{in}} ) -> VSOutput {

        var worldTransformMatrix = globalUniforms.uWorldTransformMatrix;
        var modelMatrix = mat3x3<f32>(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        var position = aPosition;
        var uv = aUV;

        {{start}}
        
        vColor = vec4<f32>(1., 1., 1., 1.);

        {{main}}

        vUV = uv;

        var modelViewProjectionMatrix = globalUniforms.uProjectionMatrix * worldTransformMatrix * modelMatrix;

        vPosition =  vec4<f32>((modelViewProjectionMatrix *  vec3<f32>(position, 1.0)).xy, 0.0, 1.0);
       
        vColor *= globalUniforms.uWorldColorAlpha;

        {{end}}

        {{return}}
    };
`
);
const fragmentGPUTemplate = (
  /* wgsl */
  `
    @in vUV : vec2<f32>;
    @in vColor : vec4<f32>;
   
    {{header}}

    @fragment
    fn main(
        {{in}}
      ) -> @location(0) vec4<f32> {
        
        {{start}}

        var outColor:vec4<f32>;
      
        {{main}}
        
        var finalColor:vec4<f32> = outColor * vColor;

        {{end}}

        return finalColor;
      };
`
);
const vertexGlTemplate = (
  /* glsl */
  `
    in vec2 aPosition;
    in vec2 aUV;

    out vec4 vColor;
    out vec2 vUV;

    {{header}}

    void main(void){

        mat3 worldTransformMatrix = uWorldTransformMatrix;
        mat3 modelMatrix = mat3(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        vec2 position = aPosition;
        vec2 uv = aUV;
        
        {{start}}
        
        vColor = vec4(1.);
        
        {{main}}
        
        vUV = uv;
        
        mat3 modelViewProjectionMatrix = uProjectionMatrix * worldTransformMatrix * modelMatrix;

        gl_Position = vec4((modelViewProjectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);

        vColor *= uWorldColorAlpha;

        {{end}}
    }
`
);
const fragmentGlTemplate = (
  /* glsl */
  `
   
    in vec4 vColor;
    in vec2 vUV;

    out vec4 finalColor;

    {{header}}

    void main(void) {
        
        {{start}}

        vec4 outColor;
      
        {{main}}
        
        finalColor = outColor * vColor;
        
        {{end}}
    }
`
);
const globalUniformsBit = {
  name: "global-uniforms-bit",
  vertex: {
    header: (
      /* wgsl */
      `
        struct GlobalUniforms {
            uProjectionMatrix:mat3x3<f32>,
            uWorldTransformMatrix:mat3x3<f32>,
            uWorldColorAlpha: vec4<f32>,
            uResolution: vec2<f32>,
        }

        @group(0) @binding(0) var<uniform> globalUniforms : GlobalUniforms;
        `
    )
  }
};
const globalUniformsBitGl = {
  name: "global-uniforms-bit",
  vertex: {
    header: (
      /* glsl */
      `
          uniform mat3 uProjectionMatrix;
          uniform mat3 uWorldTransformMatrix;
          uniform vec4 uWorldColorAlpha;
          uniform vec2 uResolution;
        `
    )
  }
};
function compileHighShaderGpuProgram({ bits, name }) {
  const source2 = compileHighShader({
    template: {
      fragment: fragmentGPUTemplate,
      vertex: vertexGPUTemplate
    },
    bits: [
      globalUniformsBit,
      ...bits
    ]
  });
  return GpuProgram.from({
    name,
    vertex: {
      source: source2.vertex,
      entryPoint: "main"
    },
    fragment: {
      source: source2.fragment,
      entryPoint: "main"
    }
  });
}
function compileHighShaderGlProgram({ bits, name }) {
  return new GlProgram({
    name,
    ...compileHighShaderGl({
      template: {
        vertex: vertexGlTemplate,
        fragment: fragmentGlTemplate
      },
      bits: [
        globalUniformsBitGl,
        ...bits
      ]
    })
  });
}
const colorBit = {
  name: "color-bit",
  vertex: {
    header: (
      /* wgsl */
      `
            @in aColor: vec4<f32>;
        `
    ),
    main: (
      /* wgsl */
      `
            vColor *= vec4<f32>(aColor.rgb * aColor.a, aColor.a);
        `
    )
  }
};
const colorBitGl = {
  name: "color-bit",
  vertex: {
    header: (
      /* glsl */
      `
            in vec4 aColor;
        `
    ),
    main: (
      /* glsl */
      `
            vColor *= vec4(aColor.rgb * aColor.a, aColor.a);
        `
    )
  }
};
const textureBatchBitGpuCache = {};
function generateBindingSrc(maxTextures2) {
  const src = [];
  if (maxTextures2 === 1) {
    src.push("@group(1) @binding(0) var textureSource1: texture_2d<f32>;");
    src.push("@group(1) @binding(1) var textureSampler1: sampler;");
  } else {
    let bindingIndex = 0;
    for (let i2 = 0; i2 < maxTextures2; i2++) {
      src.push(`@group(1) @binding(${bindingIndex++}) var textureSource${i2 + 1}: texture_2d<f32>;`);
      src.push(`@group(1) @binding(${bindingIndex++}) var textureSampler${i2 + 1}: sampler;`);
    }
  }
  return src.join("\n");
}
function generateSampleSrc(maxTextures2) {
  const src = [];
  if (maxTextures2 === 1) {
    src.push("outColor = textureSampleGrad(textureSource1, textureSampler1, vUV, uvDx, uvDy);");
  } else {
    src.push("switch vTextureId {");
    for (let i2 = 0; i2 < maxTextures2; i2++) {
      if (i2 === maxTextures2 - 1) {
        src.push(`  default:{`);
      } else {
        src.push(`  case ${i2}:{`);
      }
      src.push(`      outColor = textureSampleGrad(textureSource${i2 + 1}, textureSampler${i2 + 1}, vUV, uvDx, uvDy);`);
      src.push(`      break;}`);
    }
    src.push(`}`);
  }
  return src.join("\n");
}
function generateTextureBatchBit(maxTextures2) {
  if (!textureBatchBitGpuCache[maxTextures2]) {
    textureBatchBitGpuCache[maxTextures2] = {
      name: "texture-batch-bit",
      vertex: {
        header: `
                @in aTextureIdAndRound: vec2<u32>;
                @out @interpolate(flat) vTextureId : u32;
            `,
        main: `
                vTextureId = aTextureIdAndRound.y;
            `,
        end: `
                if(aTextureIdAndRound.x == 1)
                {
                    vPosition = vec4<f32>(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
                }
            `
      },
      fragment: {
        header: `
                @in @interpolate(flat) vTextureId: u32;

                ${generateBindingSrc(maxTextures2)}
            `,
        main: `
                var uvDx = dpdx(vUV);
                var uvDy = dpdy(vUV);

                ${generateSampleSrc(maxTextures2)}
            `
      }
    };
  }
  return textureBatchBitGpuCache[maxTextures2];
}
const textureBatchBitGlCache = {};
function generateSampleGlSrc(maxTextures2) {
  const src = [];
  for (let i2 = 0; i2 < maxTextures2; i2++) {
    if (i2 > 0) {
      src.push("else");
    }
    if (i2 < maxTextures2 - 1) {
      src.push(`if(vTextureId < ${i2}.5)`);
    }
    src.push("{");
    src.push(`	outColor = texture(uTextures[${i2}], vUV);`);
    src.push("}");
  }
  return src.join("\n");
}
function generateTextureBatchBitGl(maxTextures2) {
  if (!textureBatchBitGlCache[maxTextures2]) {
    textureBatchBitGlCache[maxTextures2] = {
      name: "texture-batch-bit",
      vertex: {
        header: `
                in vec2 aTextureIdAndRound;
                out float vTextureId;

            `,
        main: `
                vTextureId = aTextureIdAndRound.y;
            `,
        end: `
                if(aTextureIdAndRound.x == 1.)
                {
                    gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
                }
            `
      },
      fragment: {
        header: `
                in float vTextureId;

                uniform sampler2D uTextures[${maxTextures2}];

            `,
        main: `

                ${generateSampleGlSrc(maxTextures2)}
            `
      }
    };
  }
  return textureBatchBitGlCache[maxTextures2];
}
const roundPixelsBit = {
  name: "round-pixels-bit",
  vertex: {
    header: (
      /* wgsl */
      `
            fn roundPixels(position: vec2<f32>, targetSize: vec2<f32>) -> vec2<f32> 
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    )
  }
};
const roundPixelsBitGl = {
  name: "round-pixels-bit",
  vertex: {
    header: (
      /* glsl */
      `   
            vec2 roundPixels(vec2 position, vec2 targetSize)
            {       
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    )
  }
};
const batchSamplersUniformGroupHash = {};
function getBatchSamplersUniformGroup(maxTextures2) {
  let batchSamplersUniformGroup = batchSamplersUniformGroupHash[maxTextures2];
  if (batchSamplersUniformGroup)
    return batchSamplersUniformGroup;
  const sampleValues = new Int32Array(maxTextures2);
  for (let i2 = 0; i2 < maxTextures2; i2++) {
    sampleValues[i2] = i2;
  }
  batchSamplersUniformGroup = batchSamplersUniformGroupHash[maxTextures2] = new UniformGroup({
    uTextures: { value: sampleValues, type: `i32`, size: maxTextures2 }
  }, { isStatic: true });
  return batchSamplersUniformGroup;
}
class DefaultShader extends Shader {
  constructor(maxTextures2) {
    const glProgram = compileHighShaderGlProgram({
      name: "batch",
      bits: [
        colorBitGl,
        generateTextureBatchBitGl(maxTextures2),
        roundPixelsBitGl
      ]
    });
    const gpuProgram = compileHighShaderGpuProgram({
      name: "batch",
      bits: [
        colorBit,
        generateTextureBatchBit(maxTextures2),
        roundPixelsBit
      ]
    });
    super({
      glProgram,
      gpuProgram,
      resources: {
        batchSamplers: getBatchSamplersUniformGroup(maxTextures2)
      }
    });
  }
}
let defaultShader = null;
const _DefaultBatcher = class _DefaultBatcher2 extends Batcher {
  constructor() {
    super(...arguments);
    this.geometry = new BatchGeometry();
    this.shader = defaultShader || (defaultShader = new DefaultShader(this.maxTextures));
    this.name = _DefaultBatcher2.extension.name;
    this.vertexSize = 6;
  }
  /**
   * Packs the attributes of a DefaultBatchableMeshElement into the provided views.
   * @param element - The DefaultBatchableMeshElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */
  packAttributes(element, float32View, uint32View, index, textureId) {
    const textureIdAndRound = textureId << 16 | element.roundPixels & 65535;
    const wt = element.transform;
    const a2 = wt.a;
    const b2 = wt.b;
    const c2 = wt.c;
    const d2 = wt.d;
    const tx = wt.tx;
    const ty = wt.ty;
    const { positions, uvs } = element;
    const argb = element.color;
    const offset = element.attributeOffset;
    const end = offset + element.attributeSize;
    for (let i2 = offset; i2 < end; i2++) {
      const i22 = i2 * 2;
      const x2 = positions[i22];
      const y2 = positions[i22 + 1];
      float32View[index++] = a2 * x2 + c2 * y2 + tx;
      float32View[index++] = d2 * y2 + b2 * x2 + ty;
      float32View[index++] = uvs[i22];
      float32View[index++] = uvs[i22 + 1];
      uint32View[index++] = argb;
      uint32View[index++] = textureIdAndRound;
    }
  }
  /**
   * Packs the attributes of a DefaultBatchableQuadElement into the provided views.
   * @param element - The DefaultBatchableQuadElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */
  packQuadAttributes(element, float32View, uint32View, index, textureId) {
    const texture = element.texture;
    const wt = element.transform;
    const a2 = wt.a;
    const b2 = wt.b;
    const c2 = wt.c;
    const d2 = wt.d;
    const tx = wt.tx;
    const ty = wt.ty;
    const bounds = element.bounds;
    const w0 = bounds.maxX;
    const w1 = bounds.minX;
    const h0 = bounds.maxY;
    const h1 = bounds.minY;
    const uvs = texture.uvs;
    const argb = element.color;
    const textureIdAndRound = textureId << 16 | element.roundPixels & 65535;
    float32View[index + 0] = a2 * w1 + c2 * h1 + tx;
    float32View[index + 1] = d2 * h1 + b2 * w1 + ty;
    float32View[index + 2] = uvs.x0;
    float32View[index + 3] = uvs.y0;
    uint32View[index + 4] = argb;
    uint32View[index + 5] = textureIdAndRound;
    float32View[index + 6] = a2 * w0 + c2 * h1 + tx;
    float32View[index + 7] = d2 * h1 + b2 * w0 + ty;
    float32View[index + 8] = uvs.x1;
    float32View[index + 9] = uvs.y1;
    uint32View[index + 10] = argb;
    uint32View[index + 11] = textureIdAndRound;
    float32View[index + 12] = a2 * w0 + c2 * h0 + tx;
    float32View[index + 13] = d2 * h0 + b2 * w0 + ty;
    float32View[index + 14] = uvs.x2;
    float32View[index + 15] = uvs.y2;
    uint32View[index + 16] = argb;
    uint32View[index + 17] = textureIdAndRound;
    float32View[index + 18] = a2 * w1 + c2 * h0 + tx;
    float32View[index + 19] = d2 * h0 + b2 * w1 + ty;
    float32View[index + 20] = uvs.x3;
    float32View[index + 21] = uvs.y3;
    uint32View[index + 22] = argb;
    uint32View[index + 23] = textureIdAndRound;
  }
};
_DefaultBatcher.extension = {
  type: [
    ExtensionType.Batcher
  ],
  name: "default"
};
let DefaultBatcher = _DefaultBatcher;
function buildUvs(vertices, verticesStride, verticesOffset, uvs, uvsOffset, uvsStride, size, matrix = null) {
  let index = 0;
  verticesOffset *= verticesStride;
  uvsOffset *= uvsStride;
  const a2 = matrix.a;
  const b2 = matrix.b;
  const c2 = matrix.c;
  const d2 = matrix.d;
  const tx = matrix.tx;
  const ty = matrix.ty;
  while (index < size) {
    const x2 = vertices[verticesOffset];
    const y2 = vertices[verticesOffset + 1];
    uvs[uvsOffset] = a2 * x2 + c2 * y2 + tx;
    uvs[uvsOffset + 1] = b2 * x2 + d2 * y2 + ty;
    uvsOffset += uvsStride;
    verticesOffset += verticesStride;
    index++;
  }
}
function buildSimpleUvs(uvs, uvsOffset, uvsStride, size) {
  let index = 0;
  uvsOffset *= uvsStride;
  while (index < size) {
    uvs[uvsOffset] = 0;
    uvs[uvsOffset + 1] = 0;
    uvsOffset += uvsStride;
    index++;
  }
}
function transformVertices(vertices, m2, offset, stride, size) {
  const a2 = m2.a;
  const b2 = m2.b;
  const c2 = m2.c;
  const d2 = m2.d;
  const tx = m2.tx;
  const ty = m2.ty;
  offset || (offset = 0);
  stride || (stride = 2);
  size || (size = vertices.length / stride - offset);
  let index = offset * stride;
  for (let i2 = 0; i2 < size; i2++) {
    const x2 = vertices[index];
    const y2 = vertices[index + 1];
    vertices[index] = a2 * x2 + c2 * y2 + tx;
    vertices[index + 1] = b2 * x2 + d2 * y2 + ty;
    index += stride;
  }
}
const identityMatrix = new Matrix();
class BatchableGraphics {
  constructor() {
    this.packAsQuad = false;
    this.batcherName = "default";
    this.topology = "triangle-list";
    this.applyTransform = true;
    this.roundPixels = 0;
    this._batcher = null;
    this._batch = null;
  }
  get uvs() {
    return this.geometryData.uvs;
  }
  get positions() {
    return this.geometryData.vertices;
  }
  get indices() {
    return this.geometryData.indices;
  }
  get blendMode() {
    if (this.applyTransform) {
      return this.renderable.groupBlendMode;
    }
    return "normal";
  }
  get color() {
    const rgb = this.baseColor;
    const bgr = rgb >> 16 | rgb & 65280 | (rgb & 255) << 16;
    const renderable = this.renderable;
    if (renderable) {
      return multiplyHexColors(bgr, renderable.groupColor) + (this.alpha * renderable.groupAlpha * 255 << 24);
    }
    return bgr + (this.alpha * 255 << 24);
  }
  get transform() {
    return this.renderable?.groupTransform || identityMatrix;
  }
  copyTo(gpuBuffer) {
    gpuBuffer.indexOffset = this.indexOffset;
    gpuBuffer.indexSize = this.indexSize;
    gpuBuffer.attributeOffset = this.attributeOffset;
    gpuBuffer.attributeSize = this.attributeSize;
    gpuBuffer.baseColor = this.baseColor;
    gpuBuffer.alpha = this.alpha;
    gpuBuffer.texture = this.texture;
    gpuBuffer.geometryData = this.geometryData;
    gpuBuffer.topology = this.topology;
  }
  reset() {
    this.applyTransform = true;
    this.renderable = null;
    this.topology = "triangle-list";
  }
}
const buildCircle = {
  extension: {
    type: ExtensionType.ShapeBuilder,
    name: "circle"
  },
  build(shape, points) {
    let x2;
    let y2;
    let dx;
    let dy;
    let rx;
    let ry;
    if (shape.type === "circle") {
      const circle = shape;
      x2 = circle.x;
      y2 = circle.y;
      rx = ry = circle.radius;
      dx = dy = 0;
    } else if (shape.type === "ellipse") {
      const ellipse = shape;
      x2 = ellipse.x;
      y2 = ellipse.y;
      rx = ellipse.halfWidth;
      ry = ellipse.halfHeight;
      dx = dy = 0;
    } else {
      const roundedRect = shape;
      const halfWidth = roundedRect.width / 2;
      const halfHeight = roundedRect.height / 2;
      x2 = roundedRect.x + halfWidth;
      y2 = roundedRect.y + halfHeight;
      rx = ry = Math.max(0, Math.min(roundedRect.radius, Math.min(halfWidth, halfHeight)));
      dx = halfWidth - rx;
      dy = halfHeight - ry;
    }
    if (!(rx >= 0 && ry >= 0 && dx >= 0 && dy >= 0)) {
      return points;
    }
    const n2 = Math.ceil(2.3 * Math.sqrt(rx + ry));
    const m2 = n2 * 8 + (dx ? 4 : 0) + (dy ? 4 : 0);
    if (m2 === 0) {
      return points;
    }
    if (n2 === 0) {
      points[0] = points[6] = x2 + dx;
      points[1] = points[3] = y2 + dy;
      points[2] = points[4] = x2 - dx;
      points[5] = points[7] = y2 - dy;
      return points;
    }
    let j1 = 0;
    let j2 = n2 * 4 + (dx ? 2 : 0) + 2;
    let j3 = j2;
    let j4 = m2;
    let x0 = dx + rx;
    let y0 = dy;
    let x1 = x2 + x0;
    let x22 = x2 - x0;
    let y1 = y2 + y0;
    points[j1++] = x1;
    points[j1++] = y1;
    points[--j2] = y1;
    points[--j2] = x22;
    if (dy) {
      const y222 = y2 - y0;
      points[j3++] = x22;
      points[j3++] = y222;
      points[--j4] = y222;
      points[--j4] = x1;
    }
    for (let i2 = 1; i2 < n2; i2++) {
      const a2 = Math.PI / 2 * (i2 / n2);
      const x02 = dx + Math.cos(a2) * rx;
      const y02 = dy + Math.sin(a2) * ry;
      const x12 = x2 + x02;
      const x222 = x2 - x02;
      const y12 = y2 + y02;
      const y222 = y2 - y02;
      points[j1++] = x12;
      points[j1++] = y12;
      points[--j2] = y12;
      points[--j2] = x222;
      points[j3++] = x222;
      points[j3++] = y222;
      points[--j4] = y222;
      points[--j4] = x12;
    }
    x0 = dx;
    y0 = dy + ry;
    x1 = x2 + x0;
    x22 = x2 - x0;
    y1 = y2 + y0;
    const y22 = y2 - y0;
    points[j1++] = x1;
    points[j1++] = y1;
    points[--j4] = y22;
    points[--j4] = x1;
    if (dx) {
      points[j1++] = x22;
      points[j1++] = y1;
      points[--j4] = y22;
      points[--j4] = x22;
    }
    return points;
  },
  triangulate(points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
    if (points.length === 0) {
      return;
    }
    let centerX = 0;
    let centerY = 0;
    for (let i2 = 0; i2 < points.length; i2 += 2) {
      centerX += points[i2];
      centerY += points[i2 + 1];
    }
    centerX /= points.length / 2;
    centerY /= points.length / 2;
    let count2 = verticesOffset;
    vertices[count2 * verticesStride] = centerX;
    vertices[count2 * verticesStride + 1] = centerY;
    const centerIndex = count2++;
    for (let i2 = 0; i2 < points.length; i2 += 2) {
      vertices[count2 * verticesStride] = points[i2];
      vertices[count2 * verticesStride + 1] = points[i2 + 1];
      if (i2 > 0) {
        indices[indicesOffset++] = count2;
        indices[indicesOffset++] = centerIndex;
        indices[indicesOffset++] = count2 - 1;
      }
      count2++;
    }
    indices[indicesOffset++] = centerIndex + 1;
    indices[indicesOffset++] = centerIndex;
    indices[indicesOffset++] = count2 - 1;
  }
};
const buildEllipse = { ...buildCircle, extension: { ...buildCircle.extension, name: "ellipse" } };
const buildRoundedRectangle = { ...buildCircle, extension: { ...buildCircle.extension, name: "roundedRectangle" } };
const closePointEps = 1e-4;
const curveEps = 1e-4;
function getOrientationOfPoints(points) {
  const m2 = points.length;
  if (m2 < 6) {
    return 1;
  }
  let area2 = 0;
  for (let i2 = 0, x1 = points[m2 - 2], y1 = points[m2 - 1]; i2 < m2; i2 += 2) {
    const x2 = points[i2];
    const y2 = points[i2 + 1];
    area2 += (x2 - x1) * (y2 + y1);
    x1 = x2;
    y1 = y2;
  }
  if (area2 < 0) {
    return -1;
  }
  return 1;
}
function square(x2, y2, nx, ny, innerWeight, outerWeight, clockwise, verts) {
  const ix = x2 - nx * innerWeight;
  const iy = y2 - ny * innerWeight;
  const ox = x2 + nx * outerWeight;
  const oy = y2 + ny * outerWeight;
  let exx;
  let eyy;
  if (clockwise) {
    exx = ny;
    eyy = -nx;
  } else {
    exx = -ny;
    eyy = nx;
  }
  const eix = ix + exx;
  const eiy = iy + eyy;
  const eox = ox + exx;
  const eoy = oy + eyy;
  verts.push(eix, eiy);
  verts.push(eox, eoy);
  return 2;
}
function round(cx, cy, sx, sy, ex, ey, verts, clockwise) {
  const cx2p0x = sx - cx;
  const cy2p0y = sy - cy;
  let angle0 = Math.atan2(cx2p0x, cy2p0y);
  let angle1 = Math.atan2(ex - cx, ey - cy);
  if (clockwise && angle0 < angle1) {
    angle0 += Math.PI * 2;
  } else if (!clockwise && angle0 > angle1) {
    angle1 += Math.PI * 2;
  }
  let startAngle = angle0;
  const angleDiff = angle1 - angle0;
  const absAngleDiff = Math.abs(angleDiff);
  const radius = Math.sqrt(cx2p0x * cx2p0x + cy2p0y * cy2p0y);
  const segCount = (15 * absAngleDiff * Math.sqrt(radius) / Math.PI >> 0) + 1;
  const angleInc = angleDiff / segCount;
  startAngle += angleInc;
  if (clockwise) {
    verts.push(cx, cy);
    verts.push(sx, sy);
    for (let i2 = 1, angle = startAngle; i2 < segCount; i2++, angle += angleInc) {
      verts.push(cx, cy);
      verts.push(
        cx + Math.sin(angle) * radius,
        cy + Math.cos(angle) * radius
      );
    }
    verts.push(cx, cy);
    verts.push(ex, ey);
  } else {
    verts.push(sx, sy);
    verts.push(cx, cy);
    for (let i2 = 1, angle = startAngle; i2 < segCount; i2++, angle += angleInc) {
      verts.push(
        cx + Math.sin(angle) * radius,
        cy + Math.cos(angle) * radius
      );
      verts.push(cx, cy);
    }
    verts.push(ex, ey);
    verts.push(cx, cy);
  }
  return segCount * 2;
}
function buildLine(points, lineStyle, flipAlignment, closed, vertices, indices) {
  const eps = closePointEps;
  if (points.length === 0) {
    return;
  }
  const style = lineStyle;
  let alignment = style.alignment;
  if (lineStyle.alignment !== 0.5) {
    let orientation = getOrientationOfPoints(points);
    alignment = (alignment - 0.5) * orientation + 0.5;
  }
  const firstPoint = new Point(points[0], points[1]);
  const lastPoint = new Point(points[points.length - 2], points[points.length - 1]);
  const closedShape = closed;
  const closedPath = Math.abs(firstPoint.x - lastPoint.x) < eps && Math.abs(firstPoint.y - lastPoint.y) < eps;
  if (closedShape) {
    points = points.slice();
    if (closedPath) {
      points.pop();
      points.pop();
      lastPoint.set(points[points.length - 2], points[points.length - 1]);
    }
    const midPointX = (firstPoint.x + lastPoint.x) * 0.5;
    const midPointY = (lastPoint.y + firstPoint.y) * 0.5;
    points.unshift(midPointX, midPointY);
    points.push(midPointX, midPointY);
  }
  const verts = vertices;
  const length2 = points.length / 2;
  let indexCount = points.length;
  const indexStart = verts.length / 2;
  const width = style.width / 2;
  const widthSquared = width * width;
  const miterLimitSquared = style.miterLimit * style.miterLimit;
  let x0 = points[0];
  let y0 = points[1];
  let x1 = points[2];
  let y1 = points[3];
  let x2 = 0;
  let y2 = 0;
  let perpX = -(y0 - y1);
  let perpY = x0 - x1;
  let perp1x = 0;
  let perp1y = 0;
  let dist = Math.sqrt(perpX * perpX + perpY * perpY);
  perpX /= dist;
  perpY /= dist;
  perpX *= width;
  perpY *= width;
  const ratio = alignment;
  const innerWeight = (1 - ratio) * 2;
  const outerWeight = ratio * 2;
  if (!closedShape) {
    if (style.cap === "round") {
      indexCount += round(
        x0 - perpX * (innerWeight - outerWeight) * 0.5,
        y0 - perpY * (innerWeight - outerWeight) * 0.5,
        x0 - perpX * innerWeight,
        y0 - perpY * innerWeight,
        x0 + perpX * outerWeight,
        y0 + perpY * outerWeight,
        verts,
        true
      ) + 2;
    } else if (style.cap === "square") {
      indexCount += square(x0, y0, perpX, perpY, innerWeight, outerWeight, true, verts);
    }
  }
  verts.push(
    x0 - perpX * innerWeight,
    y0 - perpY * innerWeight
  );
  verts.push(
    x0 + perpX * outerWeight,
    y0 + perpY * outerWeight
  );
  for (let i2 = 1; i2 < length2 - 1; ++i2) {
    x0 = points[(i2 - 1) * 2];
    y0 = points[(i2 - 1) * 2 + 1];
    x1 = points[i2 * 2];
    y1 = points[i2 * 2 + 1];
    x2 = points[(i2 + 1) * 2];
    y2 = points[(i2 + 1) * 2 + 1];
    perpX = -(y0 - y1);
    perpY = x0 - x1;
    dist = Math.sqrt(perpX * perpX + perpY * perpY);
    perpX /= dist;
    perpY /= dist;
    perpX *= width;
    perpY *= width;
    perp1x = -(y1 - y2);
    perp1y = x1 - x2;
    dist = Math.sqrt(perp1x * perp1x + perp1y * perp1y);
    perp1x /= dist;
    perp1y /= dist;
    perp1x *= width;
    perp1y *= width;
    const dx0 = x1 - x0;
    const dy0 = y0 - y1;
    const dx1 = x1 - x2;
    const dy1 = y2 - y1;
    const dot = dx0 * dx1 + dy0 * dy1;
    const cross = dy0 * dx1 - dy1 * dx0;
    const clockwise = cross < 0;
    if (Math.abs(cross) < 1e-3 * Math.abs(dot)) {
      verts.push(
        x1 - perpX * innerWeight,
        y1 - perpY * innerWeight
      );
      verts.push(
        x1 + perpX * outerWeight,
        y1 + perpY * outerWeight
      );
      if (dot >= 0) {
        if (style.join === "round") {
          indexCount += round(
            x1,
            y1,
            x1 - perpX * innerWeight,
            y1 - perpY * innerWeight,
            x1 - perp1x * innerWeight,
            y1 - perp1y * innerWeight,
            verts,
            false
          ) + 4;
        } else {
          indexCount += 2;
        }
        verts.push(
          x1 - perp1x * outerWeight,
          y1 - perp1y * outerWeight
        );
        verts.push(
          x1 + perp1x * innerWeight,
          y1 + perp1y * innerWeight
        );
      }
      continue;
    }
    const c1 = (-perpX + x0) * (-perpY + y1) - (-perpX + x1) * (-perpY + y0);
    const c2 = (-perp1x + x2) * (-perp1y + y1) - (-perp1x + x1) * (-perp1y + y2);
    const px = (dx0 * c2 - dx1 * c1) / cross;
    const py = (dy1 * c1 - dy0 * c2) / cross;
    const pDist = (px - x1) * (px - x1) + (py - y1) * (py - y1);
    const imx = x1 + (px - x1) * innerWeight;
    const imy = y1 + (py - y1) * innerWeight;
    const omx = x1 - (px - x1) * outerWeight;
    const omy = y1 - (py - y1) * outerWeight;
    const smallerInsideSegmentSq = Math.min(dx0 * dx0 + dy0 * dy0, dx1 * dx1 + dy1 * dy1);
    const insideWeight = clockwise ? innerWeight : outerWeight;
    const smallerInsideDiagonalSq = smallerInsideSegmentSq + insideWeight * insideWeight * widthSquared;
    const insideMiterOk = pDist <= smallerInsideDiagonalSq;
    if (insideMiterOk) {
      if (style.join === "bevel" || pDist / widthSquared > miterLimitSquared) {
        if (clockwise) {
          verts.push(imx, imy);
          verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
          verts.push(imx, imy);
          verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
        } else {
          verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
          verts.push(omx, omy);
          verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
          verts.push(omx, omy);
        }
        indexCount += 2;
      } else if (style.join === "round") {
        if (clockwise) {
          verts.push(imx, imy);
          verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
          indexCount += round(
            x1,
            y1,
            x1 + perpX * outerWeight,
            y1 + perpY * outerWeight,
            x1 + perp1x * outerWeight,
            y1 + perp1y * outerWeight,
            verts,
            true
          ) + 4;
          verts.push(imx, imy);
          verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
        } else {
          verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
          verts.push(omx, omy);
          indexCount += round(
            x1,
            y1,
            x1 - perpX * innerWeight,
            y1 - perpY * innerWeight,
            x1 - perp1x * innerWeight,
            y1 - perp1y * innerWeight,
            verts,
            false
          ) + 4;
          verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
          verts.push(omx, omy);
        }
      } else {
        verts.push(imx, imy);
        verts.push(omx, omy);
      }
    } else {
      verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
      verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
      if (style.join === "round") {
        if (clockwise) {
          indexCount += round(
            x1,
            y1,
            x1 + perpX * outerWeight,
            y1 + perpY * outerWeight,
            x1 + perp1x * outerWeight,
            y1 + perp1y * outerWeight,
            verts,
            true
          ) + 2;
        } else {
          indexCount += round(
            x1,
            y1,
            x1 - perpX * innerWeight,
            y1 - perpY * innerWeight,
            x1 - perp1x * innerWeight,
            y1 - perp1y * innerWeight,
            verts,
            false
          ) + 2;
        }
      } else if (style.join === "miter" && pDist / widthSquared <= miterLimitSquared) {
        if (clockwise) {
          verts.push(omx, omy);
          verts.push(omx, omy);
        } else {
          verts.push(imx, imy);
          verts.push(imx, imy);
        }
        indexCount += 2;
      }
      verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
      verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
      indexCount += 2;
    }
  }
  x0 = points[(length2 - 2) * 2];
  y0 = points[(length2 - 2) * 2 + 1];
  x1 = points[(length2 - 1) * 2];
  y1 = points[(length2 - 1) * 2 + 1];
  perpX = -(y0 - y1);
  perpY = x0 - x1;
  dist = Math.sqrt(perpX * perpX + perpY * perpY);
  perpX /= dist;
  perpY /= dist;
  perpX *= width;
  perpY *= width;
  verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
  verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
  if (!closedShape) {
    if (style.cap === "round") {
      indexCount += round(
        x1 - perpX * (innerWeight - outerWeight) * 0.5,
        y1 - perpY * (innerWeight - outerWeight) * 0.5,
        x1 - perpX * innerWeight,
        y1 - perpY * innerWeight,
        x1 + perpX * outerWeight,
        y1 + perpY * outerWeight,
        verts,
        false
      ) + 2;
    } else if (style.cap === "square") {
      indexCount += square(x1, y1, perpX, perpY, innerWeight, outerWeight, false, verts);
    }
  }
  const eps2 = curveEps * curveEps;
  for (let i2 = indexStart; i2 < indexCount + indexStart - 2; ++i2) {
    x0 = verts[i2 * 2];
    y0 = verts[i2 * 2 + 1];
    x1 = verts[(i2 + 1) * 2];
    y1 = verts[(i2 + 1) * 2 + 1];
    x2 = verts[(i2 + 2) * 2];
    y2 = verts[(i2 + 2) * 2 + 1];
    if (Math.abs(x0 * (y1 - y2) + x1 * (y2 - y0) + x2 * (y0 - y1)) < eps2) {
      continue;
    }
    indices.push(i2, i2 + 1, i2 + 2);
  }
}
function buildPixelLine(points, closed, vertices, indices) {
  const eps = closePointEps;
  if (points.length === 0) {
    return;
  }
  const fx = points[0];
  const fy = points[1];
  const lx = points[points.length - 2];
  const ly = points[points.length - 1];
  const closePath = closed || Math.abs(fx - lx) < eps && Math.abs(fy - ly) < eps;
  const verts = vertices;
  const length2 = points.length / 2;
  const indexStart = verts.length / 2;
  for (let i2 = 0; i2 < length2; i2++) {
    verts.push(points[i2 * 2]);
    verts.push(points[i2 * 2 + 1]);
  }
  for (let i2 = 0; i2 < length2 - 1; i2++) {
    indices.push(indexStart + i2, indexStart + i2 + 1);
  }
  if (closePath) {
    indices.push(indexStart + length2 - 1, indexStart);
  }
}
function triangulateWithHoles(points, holes, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
  const triangles = earcut$1(points, holes, 2);
  if (!triangles) {
    return;
  }
  for (let i2 = 0; i2 < triangles.length; i2 += 3) {
    indices[indicesOffset++] = triangles[i2] + verticesOffset;
    indices[indicesOffset++] = triangles[i2 + 1] + verticesOffset;
    indices[indicesOffset++] = triangles[i2 + 2] + verticesOffset;
  }
  let index = verticesOffset * verticesStride;
  for (let i2 = 0; i2 < points.length; i2 += 2) {
    vertices[index] = points[i2];
    vertices[index + 1] = points[i2 + 1];
    index += verticesStride;
  }
}
const emptyArray = [];
const buildPolygon = {
  extension: {
    type: ExtensionType.ShapeBuilder,
    name: "polygon"
  },
  build(shape, points) {
    for (let i2 = 0; i2 < shape.points.length; i2++) {
      points[i2] = shape.points[i2];
    }
    return points;
  },
  triangulate(points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
    triangulateWithHoles(points, emptyArray, vertices, verticesStride, verticesOffset, indices, indicesOffset);
  }
};
const buildRectangle = {
  extension: {
    type: ExtensionType.ShapeBuilder,
    name: "rectangle"
  },
  build(shape, points) {
    const rectData = shape;
    const x2 = rectData.x;
    const y2 = rectData.y;
    const width = rectData.width;
    const height = rectData.height;
    if (!(width >= 0 && height >= 0)) {
      return points;
    }
    points[0] = x2;
    points[1] = y2;
    points[2] = x2 + width;
    points[3] = y2;
    points[4] = x2 + width;
    points[5] = y2 + height;
    points[6] = x2;
    points[7] = y2 + height;
    return points;
  },
  triangulate(points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
    let count2 = 0;
    verticesOffset *= verticesStride;
    vertices[verticesOffset + count2] = points[0];
    vertices[verticesOffset + count2 + 1] = points[1];
    count2 += verticesStride;
    vertices[verticesOffset + count2] = points[2];
    vertices[verticesOffset + count2 + 1] = points[3];
    count2 += verticesStride;
    vertices[verticesOffset + count2] = points[6];
    vertices[verticesOffset + count2 + 1] = points[7];
    count2 += verticesStride;
    vertices[verticesOffset + count2] = points[4];
    vertices[verticesOffset + count2 + 1] = points[5];
    count2 += verticesStride;
    const verticesIndex = verticesOffset / verticesStride;
    indices[indicesOffset++] = verticesIndex;
    indices[indicesOffset++] = verticesIndex + 1;
    indices[indicesOffset++] = verticesIndex + 2;
    indices[indicesOffset++] = verticesIndex + 1;
    indices[indicesOffset++] = verticesIndex + 3;
    indices[indicesOffset++] = verticesIndex + 2;
  }
};
const buildTriangle = {
  extension: {
    type: ExtensionType.ShapeBuilder,
    name: "triangle"
  },
  build(shape, points) {
    points[0] = shape.x;
    points[1] = shape.y;
    points[2] = shape.x2;
    points[3] = shape.y2;
    points[4] = shape.x3;
    points[5] = shape.y3;
    return points;
  },
  triangulate(points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
    let count2 = 0;
    verticesOffset *= verticesStride;
    vertices[verticesOffset + count2] = points[0];
    vertices[verticesOffset + count2 + 1] = points[1];
    count2 += verticesStride;
    vertices[verticesOffset + count2] = points[2];
    vertices[verticesOffset + count2 + 1] = points[3];
    count2 += verticesStride;
    vertices[verticesOffset + count2] = points[4];
    vertices[verticesOffset + count2 + 1] = points[5];
    const verticesIndex = verticesOffset / verticesStride;
    indices[indicesOffset++] = verticesIndex;
    indices[indicesOffset++] = verticesIndex + 1;
    indices[indicesOffset++] = verticesIndex + 2;
  }
};
const shapeBuilders = {};
extensions.handleByMap(ExtensionType.ShapeBuilder, shapeBuilders);
extensions.add(buildRectangle, buildPolygon, buildTriangle, buildCircle, buildEllipse, buildRoundedRectangle);
const tempRect = new Rectangle();
function buildContextBatches(context2, gpuContext) {
  const { geometryData, batches } = gpuContext;
  batches.length = 0;
  geometryData.indices.length = 0;
  geometryData.vertices.length = 0;
  geometryData.uvs.length = 0;
  for (let i2 = 0; i2 < context2.instructions.length; i2++) {
    const instruction = context2.instructions[i2];
    if (instruction.action === "texture") {
      addTextureToGeometryData(instruction.data, batches, geometryData);
    } else if (instruction.action === "fill" || instruction.action === "stroke") {
      const isStroke = instruction.action === "stroke";
      const shapePath = instruction.data.path.shapePath;
      const style = instruction.data.style;
      const hole = instruction.data.hole;
      if (isStroke && hole) {
        addShapePathToGeometryData(hole.shapePath, style, null, true, batches, geometryData);
      }
      addShapePathToGeometryData(shapePath, style, hole, isStroke, batches, geometryData);
    }
  }
}
function addTextureToGeometryData(data, batches, geometryData) {
  const { vertices, uvs, indices } = geometryData;
  const indexOffset = indices.length;
  const vertOffset = vertices.length / 2;
  const points = [];
  const build = shapeBuilders.rectangle;
  const rect = tempRect;
  const texture = data.image;
  rect.x = data.dx;
  rect.y = data.dy;
  rect.width = data.dw;
  rect.height = data.dh;
  const matrix = data.transform;
  build.build(rect, points);
  if (matrix) {
    transformVertices(points, matrix);
  }
  build.triangulate(points, vertices, 2, vertOffset, indices, indexOffset);
  const textureUvs = texture.uvs;
  uvs.push(
    textureUvs.x0,
    textureUvs.y0,
    textureUvs.x1,
    textureUvs.y1,
    textureUvs.x3,
    textureUvs.y3,
    textureUvs.x2,
    textureUvs.y2
  );
  const graphicsBatch = BigPool.get(BatchableGraphics);
  graphicsBatch.indexOffset = indexOffset;
  graphicsBatch.indexSize = indices.length - indexOffset;
  graphicsBatch.attributeOffset = vertOffset;
  graphicsBatch.attributeSize = vertices.length / 2 - vertOffset;
  graphicsBatch.baseColor = data.style;
  graphicsBatch.alpha = data.alpha;
  graphicsBatch.texture = texture;
  graphicsBatch.geometryData = geometryData;
  batches.push(graphicsBatch);
}
function addShapePathToGeometryData(shapePath, style, hole, isStroke, batches, geometryData) {
  const { vertices, uvs, indices } = geometryData;
  const lastIndex = shapePath.shapePrimitives.length - 1;
  shapePath.shapePrimitives.forEach(({ shape, transform: matrix }, i2) => {
    const indexOffset = indices.length;
    const vertOffset = vertices.length / 2;
    const points = [];
    const build = shapeBuilders[shape.type];
    let topology = "triangle-list";
    build.build(shape, points);
    if (matrix) {
      transformVertices(points, matrix);
    }
    if (!isStroke) {
      if (hole && lastIndex === i2) {
        if (lastIndex !== 0) {
          console.warn("[Pixi Graphics] only the last shape have be cut out");
        }
        const holeIndices = [];
        const otherPoints = points.slice();
        const holeArrays = getHoleArrays(hole.shapePath);
        holeArrays.forEach((holePoints) => {
          holeIndices.push(otherPoints.length / 2);
          otherPoints.push(...holePoints);
        });
        triangulateWithHoles(otherPoints, holeIndices, vertices, 2, vertOffset, indices, indexOffset);
      } else {
        build.triangulate(points, vertices, 2, vertOffset, indices, indexOffset);
      }
    } else {
      const close = shape.closePath ?? true;
      const lineStyle = style;
      if (!lineStyle.pixelLine) {
        buildLine(points, lineStyle, false, close, vertices, indices);
      } else {
        buildPixelLine(points, close, vertices, indices);
        topology = "line-list";
      }
    }
    const uvsOffset = uvs.length / 2;
    const texture = style.texture;
    if (texture !== Texture.WHITE) {
      const textureMatrix = style.matrix;
      if (textureMatrix) {
        if (matrix) {
          textureMatrix.append(matrix.clone().invert());
        }
        buildUvs(vertices, 2, vertOffset, uvs, uvsOffset, 2, vertices.length / 2 - vertOffset, textureMatrix);
      }
    } else {
      buildSimpleUvs(uvs, uvsOffset, 2, vertices.length / 2 - vertOffset);
    }
    const graphicsBatch = BigPool.get(BatchableGraphics);
    graphicsBatch.indexOffset = indexOffset;
    graphicsBatch.indexSize = indices.length - indexOffset;
    graphicsBatch.attributeOffset = vertOffset;
    graphicsBatch.attributeSize = vertices.length / 2 - vertOffset;
    graphicsBatch.baseColor = style.color;
    graphicsBatch.alpha = style.alpha;
    graphicsBatch.texture = texture;
    graphicsBatch.geometryData = geometryData;
    graphicsBatch.topology = topology;
    batches.push(graphicsBatch);
  });
}
function getHoleArrays(shape) {
  if (!shape)
    return [];
  const holePrimitives = shape.shapePrimitives;
  const holeArrays = [];
  for (let k2 = 0; k2 < holePrimitives.length; k2++) {
    const holePrimitive = holePrimitives[k2].shape;
    const holePoints = [];
    const holeBuilder = shapeBuilders[holePrimitive.type];
    holeBuilder.build(holePrimitive, holePoints);
    holeArrays.push(holePoints);
  }
  return holeArrays;
}
class GpuGraphicsContext {
  constructor() {
    this.batches = [];
    this.geometryData = {
      vertices: [],
      uvs: [],
      indices: []
    };
  }
}
class GraphicsContextRenderData {
  constructor() {
    this.batcher = new DefaultBatcher();
    this.instructions = new InstructionSet();
  }
  init() {
    this.instructions.reset();
  }
  /**
   * @deprecated since version 8.0.0
   * Use `batcher.geometry` instead.
   * @see {Batcher#geometry}
   */
  get geometry() {
    deprecation(v8_3_4, "GraphicsContextRenderData#geometry is deprecated, please use batcher.geometry instead.");
    return this.batcher.geometry;
  }
}
const _GraphicsContextSystem = class _GraphicsContextSystem2 {
  constructor(renderer) {
    this._gpuContextHash = {};
    this._graphicsDataContextHash = /* @__PURE__ */ Object.create(null);
    renderer.renderableGC.addManagedHash(this, "_gpuContextHash");
    renderer.renderableGC.addManagedHash(this, "_graphicsDataContextHash");
  }
  /**
   * Runner init called, update the default options
   * @ignore
   */
  init(options) {
    _GraphicsContextSystem2.defaultOptions.bezierSmoothness = options?.bezierSmoothness ?? _GraphicsContextSystem2.defaultOptions.bezierSmoothness;
  }
  getContextRenderData(context2) {
    return this._graphicsDataContextHash[context2.uid] || this._initContextRenderData(context2);
  }
  // Context management functions
  updateGpuContext(context2) {
    let gpuContext = this._gpuContextHash[context2.uid] || this._initContext(context2);
    if (context2.dirty) {
      if (gpuContext) {
        this._cleanGraphicsContextData(context2);
      } else {
        gpuContext = this._initContext(context2);
      }
      buildContextBatches(context2, gpuContext);
      const batchMode = context2.batchMode;
      if (context2.customShader || batchMode === "no-batch") {
        gpuContext.isBatchable = false;
      } else if (batchMode === "auto") {
        gpuContext.isBatchable = gpuContext.geometryData.vertices.length < 400;
      }
      context2.dirty = false;
    }
    return gpuContext;
  }
  getGpuContext(context2) {
    return this._gpuContextHash[context2.uid] || this._initContext(context2);
  }
  _initContextRenderData(context2) {
    const graphicsData = BigPool.get(GraphicsContextRenderData);
    const { batches, geometryData } = this._gpuContextHash[context2.uid];
    const vertexSize = geometryData.vertices.length;
    const indexSize = geometryData.indices.length;
    for (let i2 = 0; i2 < batches.length; i2++) {
      batches[i2].applyTransform = false;
    }
    const batcher = graphicsData.batcher;
    batcher.ensureAttributeBuffer(vertexSize);
    batcher.ensureIndexBuffer(indexSize);
    batcher.begin();
    for (let i2 = 0; i2 < batches.length; i2++) {
      const batch = batches[i2];
      batcher.add(batch);
    }
    batcher.finish(graphicsData.instructions);
    const geometry = batcher.geometry;
    geometry.indexBuffer.setDataWithSize(batcher.indexBuffer, batcher.indexSize, true);
    geometry.buffers[0].setDataWithSize(batcher.attributeBuffer.float32View, batcher.attributeSize, true);
    const drawBatches = batcher.batches;
    for (let i2 = 0; i2 < drawBatches.length; i2++) {
      const batch = drawBatches[i2];
      batch.bindGroup = getTextureBatchBindGroup(batch.textures.textures, batch.textures.count);
    }
    this._graphicsDataContextHash[context2.uid] = graphicsData;
    return graphicsData;
  }
  _initContext(context2) {
    const gpuContext = new GpuGraphicsContext();
    gpuContext.context = context2;
    this._gpuContextHash[context2.uid] = gpuContext;
    context2.on("destroy", this.onGraphicsContextDestroy, this);
    return this._gpuContextHash[context2.uid];
  }
  onGraphicsContextDestroy(context2) {
    this._cleanGraphicsContextData(context2);
    context2.off("destroy", this.onGraphicsContextDestroy, this);
    this._gpuContextHash[context2.uid] = null;
  }
  _cleanGraphicsContextData(context2) {
    const gpuContext = this._gpuContextHash[context2.uid];
    if (!gpuContext.isBatchable) {
      if (this._graphicsDataContextHash[context2.uid]) {
        BigPool.return(this.getContextRenderData(context2));
        this._graphicsDataContextHash[context2.uid] = null;
      }
    }
    if (gpuContext.batches) {
      gpuContext.batches.forEach((batch) => {
        BigPool.return(batch);
      });
    }
  }
  destroy() {
    for (const i2 in this._gpuContextHash) {
      if (this._gpuContextHash[i2]) {
        this.onGraphicsContextDestroy(this._gpuContextHash[i2].context);
      }
    }
  }
};
_GraphicsContextSystem.extension = {
  type: [
    ExtensionType.WebGLSystem,
    ExtensionType.WebGPUSystem,
    ExtensionType.CanvasSystem
  ],
  name: "graphicsContext"
};
_GraphicsContextSystem.defaultOptions = {
  /**
   * A value from 0 to 1 that controls the smoothness of bezier curves (the higher the smoother)
   * @default 0.5
   */
  bezierSmoothness: 0.5
};
let GraphicsContextSystem = _GraphicsContextSystem;
const RECURSION_LIMIT$1 = 8;
const FLT_EPSILON$1 = 11920929e-14;
const PATH_DISTANCE_EPSILON$1 = 1;
function buildAdaptiveBezier(points, sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, smoothness) {
  const scale = 1;
  const smoothing = Math.min(
    0.99,
    // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, smoothness ?? GraphicsContextSystem.defaultOptions.bezierSmoothness)
  );
  let distanceTolerance = (PATH_DISTANCE_EPSILON$1 - smoothing) / scale;
  distanceTolerance *= distanceTolerance;
  begin$1(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance);
  return points;
}
function begin$1(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance) {
  recursive$1(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance, 0);
  points.push(eX, eY);
}
function recursive$1(x1, y1, x2, y2, x3, y3, x4, y4, points, distanceTolerance, level) {
  if (level > RECURSION_LIMIT$1) {
    return;
  }
  const x12 = (x1 + x2) / 2;
  const y12 = (y1 + y2) / 2;
  const x23 = (x2 + x3) / 2;
  const y23 = (y2 + y3) / 2;
  const x34 = (x3 + x4) / 2;
  const y34 = (y3 + y4) / 2;
  const x123 = (x12 + x23) / 2;
  const y123 = (y12 + y23) / 2;
  const x234 = (x23 + x34) / 2;
  const y234 = (y23 + y34) / 2;
  const x1234 = (x123 + x234) / 2;
  const y1234 = (y123 + y234) / 2;
  if (level > 0) {
    let dx = x4 - x1;
    let dy = y4 - y1;
    const d2 = Math.abs((x2 - x4) * dy - (y2 - y4) * dx);
    const d3 = Math.abs((x3 - x4) * dy - (y3 - y4) * dx);
    if (d2 > FLT_EPSILON$1 && d3 > FLT_EPSILON$1) {
      if ((d2 + d3) * (d2 + d3) <= distanceTolerance * (dx * dx + dy * dy)) {
        {
          points.push(x1234, y1234);
          return;
        }
      }
    } else if (d2 > FLT_EPSILON$1) {
      if (d2 * d2 <= distanceTolerance * (dx * dx + dy * dy)) {
        {
          points.push(x1234, y1234);
          return;
        }
      }
    } else if (d3 > FLT_EPSILON$1) {
      if (d3 * d3 <= distanceTolerance * (dx * dx + dy * dy)) {
        {
          points.push(x1234, y1234);
          return;
        }
      }
    } else {
      dx = x1234 - (x1 + x4) / 2;
      dy = y1234 - (y1 + y4) / 2;
      if (dx * dx + dy * dy <= distanceTolerance) {
        points.push(x1234, y1234);
        return;
      }
    }
  }
  recursive$1(x1, y1, x12, y12, x123, y123, x1234, y1234, points, distanceTolerance, level + 1);
  recursive$1(x1234, y1234, x234, y234, x34, y34, x4, y4, points, distanceTolerance, level + 1);
}
const RECURSION_LIMIT = 8;
const FLT_EPSILON = 11920929e-14;
const PATH_DISTANCE_EPSILON = 1;
function buildAdaptiveQuadratic(points, sX, sY, cp1x, cp1y, eX, eY, smoothness) {
  const scale = 1;
  const smoothing = Math.min(
    0.99,
    // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, smoothness ?? GraphicsContextSystem.defaultOptions.bezierSmoothness)
  );
  let distanceTolerance = (PATH_DISTANCE_EPSILON - smoothing) / scale;
  distanceTolerance *= distanceTolerance;
  begin(sX, sY, cp1x, cp1y, eX, eY, points, distanceTolerance);
  return points;
}
function begin(sX, sY, cp1x, cp1y, eX, eY, points, distanceTolerance) {
  recursive(points, sX, sY, cp1x, cp1y, eX, eY, distanceTolerance, 0);
  points.push(eX, eY);
}
function recursive(points, x1, y1, x2, y2, x3, y3, distanceTolerance, level) {
  if (level > RECURSION_LIMIT) {
    return;
  }
  const x12 = (x1 + x2) / 2;
  const y12 = (y1 + y2) / 2;
  const x23 = (x2 + x3) / 2;
  const y23 = (y2 + y3) / 2;
  const x123 = (x12 + x23) / 2;
  const y123 = (y12 + y23) / 2;
  let dx = x3 - x1;
  let dy = y3 - y1;
  const d2 = Math.abs((x2 - x3) * dy - (y2 - y3) * dx);
  if (d2 > FLT_EPSILON) {
    if (d2 * d2 <= distanceTolerance * (dx * dx + dy * dy)) {
      {
        points.push(x123, y123);
        return;
      }
    }
  } else {
    dx = x123 - (x1 + x3) / 2;
    dy = y123 - (y1 + y3) / 2;
    if (dx * dx + dy * dy <= distanceTolerance) {
      points.push(x123, y123);
      return;
    }
  }
  recursive(points, x1, y1, x12, y12, x123, y123, distanceTolerance, level + 1);
  recursive(points, x123, y123, x23, y23, x3, y3, distanceTolerance, level + 1);
}
function buildArc(points, x2, y2, radius, start, end, clockwise, steps) {
  let dist = Math.abs(start - end);
  if (!clockwise && start > end) {
    dist = 2 * Math.PI - dist;
  } else if (clockwise && end > start) {
    dist = 2 * Math.PI - dist;
  }
  steps || (steps = Math.max(6, Math.floor(6 * Math.pow(radius, 1 / 3) * (dist / Math.PI))));
  steps = Math.max(steps, 3);
  let f2 = dist / steps;
  let t2 = start;
  f2 *= clockwise ? -1 : 1;
  for (let i2 = 0; i2 < steps + 1; i2++) {
    const cs = Math.cos(t2);
    const sn = Math.sin(t2);
    const nx = x2 + cs * radius;
    const ny = y2 + sn * radius;
    points.push(nx, ny);
    t2 += f2;
  }
}
function buildArcTo(points, x1, y1, x2, y2, radius) {
  const fromX = points[points.length - 2];
  const fromY = points[points.length - 1];
  const a1 = fromY - y1;
  const b1 = fromX - x1;
  const a2 = y2 - y1;
  const b2 = x2 - x1;
  const mm = Math.abs(a1 * b2 - b1 * a2);
  if (mm < 1e-8 || radius === 0) {
    if (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) {
      points.push(x1, y1);
    }
    return;
  }
  const dd = a1 * a1 + b1 * b1;
  const cc = a2 * a2 + b2 * b2;
  const tt = a1 * a2 + b1 * b2;
  const k1 = radius * Math.sqrt(dd) / mm;
  const k2 = radius * Math.sqrt(cc) / mm;
  const j1 = k1 * tt / dd;
  const j2 = k2 * tt / cc;
  const cx = k1 * b2 + k2 * b1;
  const cy = k1 * a2 + k2 * a1;
  const px = b1 * (k2 + j1);
  const py = a1 * (k2 + j1);
  const qx = b2 * (k1 + j2);
  const qy = a2 * (k1 + j2);
  const startAngle = Math.atan2(py - cy, px - cx);
  const endAngle = Math.atan2(qy - cy, qx - cx);
  buildArc(
    points,
    cx + x1,
    cy + y1,
    radius,
    startAngle,
    endAngle,
    b1 * a2 > b2 * a1
  );
}
const TAU = Math.PI * 2;
const out = {
  centerX: 0,
  centerY: 0,
  ang1: 0,
  ang2: 0
};
const mapToEllipse = ({ x: x2, y: y2 }, rx, ry, cosPhi, sinPhi, centerX, centerY, out2) => {
  x2 *= rx;
  y2 *= ry;
  const xp = cosPhi * x2 - sinPhi * y2;
  const yp = sinPhi * x2 + cosPhi * y2;
  out2.x = xp + centerX;
  out2.y = yp + centerY;
  return out2;
};
function approxUnitArc(ang1, ang2) {
  const a1 = ang2 === -1.5707963267948966 ? -0.551915024494 : 4 / 3 * Math.tan(ang2 / 4);
  const a2 = ang2 === 1.5707963267948966 ? 0.551915024494 : a1;
  const x1 = Math.cos(ang1);
  const y1 = Math.sin(ang1);
  const x2 = Math.cos(ang1 + ang2);
  const y2 = Math.sin(ang1 + ang2);
  return [
    {
      x: x1 - y1 * a2,
      y: y1 + x1 * a2
    },
    {
      x: x2 + y2 * a2,
      y: y2 - x2 * a2
    },
    {
      x: x2,
      y: y2
    }
  ];
}
const vectorAngle = (ux2, uy2, vx2, vy2) => {
  const sign2 = ux2 * vy2 - uy2 * vx2 < 0 ? -1 : 1;
  let dot = ux2 * vx2 + uy2 * vy2;
  if (dot > 1) {
    dot = 1;
  }
  if (dot < -1) {
    dot = -1;
  }
  return sign2 * Math.acos(dot);
};
const getArcCenter = (px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinPhi, cosPhi, pxp, pyp, out2) => {
  const rxSq = Math.pow(rx, 2);
  const rySq = Math.pow(ry, 2);
  const pxpSq = Math.pow(pxp, 2);
  const pypSq = Math.pow(pyp, 2);
  let radicant = rxSq * rySq - rxSq * pypSq - rySq * pxpSq;
  if (radicant < 0) {
    radicant = 0;
  }
  radicant /= rxSq * pypSq + rySq * pxpSq;
  radicant = Math.sqrt(radicant) * (largeArcFlag === sweepFlag ? -1 : 1);
  const centerXp = radicant * rx / ry * pyp;
  const centerYp = radicant * -ry / rx * pxp;
  const centerX = cosPhi * centerXp - sinPhi * centerYp + (px + cx) / 2;
  const centerY = sinPhi * centerXp + cosPhi * centerYp + (py + cy) / 2;
  const vx1 = (pxp - centerXp) / rx;
  const vy1 = (pyp - centerYp) / ry;
  const vx2 = (-pxp - centerXp) / rx;
  const vy2 = (-pyp - centerYp) / ry;
  const ang1 = vectorAngle(1, 0, vx1, vy1);
  let ang2 = vectorAngle(vx1, vy1, vx2, vy2);
  if (sweepFlag === 0 && ang2 > 0) {
    ang2 -= TAU;
  }
  if (sweepFlag === 1 && ang2 < 0) {
    ang2 += TAU;
  }
  out2.centerX = centerX;
  out2.centerY = centerY;
  out2.ang1 = ang1;
  out2.ang2 = ang2;
};
function buildArcToSvg(points, px, py, cx, cy, rx, ry, xAxisRotation = 0, largeArcFlag = 0, sweepFlag = 0) {
  if (rx === 0 || ry === 0) {
    return;
  }
  const sinPhi = Math.sin(xAxisRotation * TAU / 360);
  const cosPhi = Math.cos(xAxisRotation * TAU / 360);
  const pxp = cosPhi * (px - cx) / 2 + sinPhi * (py - cy) / 2;
  const pyp = -sinPhi * (px - cx) / 2 + cosPhi * (py - cy) / 2;
  if (pxp === 0 && pyp === 0) {
    return;
  }
  rx = Math.abs(rx);
  ry = Math.abs(ry);
  const lambda = Math.pow(pxp, 2) / Math.pow(rx, 2) + Math.pow(pyp, 2) / Math.pow(ry, 2);
  if (lambda > 1) {
    rx *= Math.sqrt(lambda);
    ry *= Math.sqrt(lambda);
  }
  getArcCenter(
    px,
    py,
    cx,
    cy,
    rx,
    ry,
    largeArcFlag,
    sweepFlag,
    sinPhi,
    cosPhi,
    pxp,
    pyp,
    out
  );
  let { ang1, ang2 } = out;
  const { centerX, centerY } = out;
  let ratio = Math.abs(ang2) / (TAU / 4);
  if (Math.abs(1 - ratio) < 1e-7) {
    ratio = 1;
  }
  const segments = Math.max(Math.ceil(ratio), 1);
  ang2 /= segments;
  let lastX = points[points.length - 2];
  let lastY = points[points.length - 1];
  const outCurvePoint = { x: 0, y: 0 };
  for (let i2 = 0; i2 < segments; i2++) {
    const curve = approxUnitArc(ang1, ang2);
    const { x: x1, y: y1 } = mapToEllipse(curve[0], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
    const { x: x2, y: y2 } = mapToEllipse(curve[1], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
    const { x: x3, y: y3 } = mapToEllipse(curve[2], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
    buildAdaptiveBezier(
      points,
      lastX,
      lastY,
      x1,
      y1,
      x2,
      y2,
      x3,
      y3
    );
    lastX = x3;
    lastY = y3;
    ang1 += ang2;
  }
}
function roundedShapeArc(g2, points, radius) {
  const vecFrom = (p2, pp) => {
    const x2 = pp.x - p2.x;
    const y2 = pp.y - p2.y;
    const len = Math.sqrt(x2 * x2 + y2 * y2);
    const nx = x2 / len;
    const ny = y2 / len;
    return { len, nx, ny };
  };
  const sharpCorner = (i2, p2) => {
    if (i2 === 0) {
      g2.moveTo(p2.x, p2.y);
    } else {
      g2.lineTo(p2.x, p2.y);
    }
  };
  let p1 = points[points.length - 1];
  for (let i2 = 0; i2 < points.length; i2++) {
    const p2 = points[i2 % points.length];
    const pRadius = p2.radius ?? radius;
    if (pRadius <= 0) {
      sharpCorner(i2, p2);
      p1 = p2;
      continue;
    }
    const p3 = points[(i2 + 1) % points.length];
    const v1 = vecFrom(p2, p1);
    const v2 = vecFrom(p2, p3);
    if (v1.len < 1e-4 || v2.len < 1e-4) {
      sharpCorner(i2, p2);
      p1 = p2;
      continue;
    }
    let angle = Math.asin(v1.nx * v2.ny - v1.ny * v2.nx);
    let radDirection = 1;
    let drawDirection = false;
    if (v1.nx * v2.nx - v1.ny * -v2.ny < 0) {
      if (angle < 0) {
        angle = Math.PI + angle;
      } else {
        angle = Math.PI - angle;
        radDirection = -1;
        drawDirection = true;
      }
    } else if (angle > 0) {
      radDirection = -1;
      drawDirection = true;
    }
    const halfAngle = angle / 2;
    let cRadius;
    let lenOut = Math.abs(
      Math.cos(halfAngle) * pRadius / Math.sin(halfAngle)
    );
    if (lenOut > Math.min(v1.len / 2, v2.len / 2)) {
      lenOut = Math.min(v1.len / 2, v2.len / 2);
      cRadius = Math.abs(lenOut * Math.sin(halfAngle) / Math.cos(halfAngle));
    } else {
      cRadius = pRadius;
    }
    const cX = p2.x + v2.nx * lenOut + -v2.ny * cRadius * radDirection;
    const cY = p2.y + v2.ny * lenOut + v2.nx * cRadius * radDirection;
    const startAngle = Math.atan2(v1.ny, v1.nx) + Math.PI / 2 * radDirection;
    const endAngle = Math.atan2(v2.ny, v2.nx) - Math.PI / 2 * radDirection;
    if (i2 === 0) {
      g2.moveTo(
        cX + Math.cos(startAngle) * cRadius,
        cY + Math.sin(startAngle) * cRadius
      );
    }
    g2.arc(cX, cY, cRadius, startAngle, endAngle, drawDirection);
    p1 = p2;
  }
}
function roundedShapeQuadraticCurve(g2, points, radius, smoothness) {
  const distance = (p1, p2) => Math.sqrt((p1.x - p2.x) ** 2 + (p1.y - p2.y) ** 2);
  const pointLerp = (p1, p2, t2) => ({
    x: p1.x + (p2.x - p1.x) * t2,
    y: p1.y + (p2.y - p1.y) * t2
  });
  const numPoints = points.length;
  for (let i2 = 0; i2 < numPoints; i2++) {
    const thisPoint = points[(i2 + 1) % numPoints];
    const pRadius = thisPoint.radius ?? radius;
    if (pRadius <= 0) {
      if (i2 === 0) {
        g2.moveTo(thisPoint.x, thisPoint.y);
      } else {
        g2.lineTo(thisPoint.x, thisPoint.y);
      }
      continue;
    }
    const lastPoint = points[i2];
    const nextPoint = points[(i2 + 2) % numPoints];
    const lastEdgeLength = distance(lastPoint, thisPoint);
    let start;
    if (lastEdgeLength < 1e-4) {
      start = thisPoint;
    } else {
      const lastOffsetDistance = Math.min(lastEdgeLength / 2, pRadius);
      start = pointLerp(
        thisPoint,
        lastPoint,
        lastOffsetDistance / lastEdgeLength
      );
    }
    const nextEdgeLength = distance(nextPoint, thisPoint);
    let end;
    if (nextEdgeLength < 1e-4) {
      end = thisPoint;
    } else {
      const nextOffsetDistance = Math.min(nextEdgeLength / 2, pRadius);
      end = pointLerp(
        thisPoint,
        nextPoint,
        nextOffsetDistance / nextEdgeLength
      );
    }
    if (i2 === 0) {
      g2.moveTo(start.x, start.y);
    } else {
      g2.lineTo(start.x, start.y);
    }
    g2.quadraticCurveTo(thisPoint.x, thisPoint.y, end.x, end.y, smoothness);
  }
}
const tempRectangle = new Rectangle();
class ShapePath {
  constructor(graphicsPath2D) {
    this.shapePrimitives = [];
    this._currentPoly = null;
    this._bounds = new Bounds();
    this._graphicsPath2D = graphicsPath2D;
  }
  /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */
  moveTo(x2, y2) {
    this.startPoly(x2, y2);
    return this;
  }
  /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */
  lineTo(x2, y2) {
    this._ensurePoly();
    const points = this._currentPoly.points;
    const fromX = points[points.length - 2];
    const fromY = points[points.length - 1];
    if (fromX !== x2 || fromY !== y2) {
      points.push(x2, y2);
    }
    return this;
  }
  /**
   * Adds an arc to the path. The arc is centered at (x, y)
   *  position with radius `radius` starting at `startAngle` and ending at `endAngle`.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The radius of the arc.
   * @param startAngle - The starting angle of the arc, in radians.
   * @param endAngle - The ending angle of the arc, in radians.
   * @param counterclockwise - Specifies whether the arc should be drawn in the anticlockwise direction. False by default.
   * @returns The instance of the current object for chaining.
   */
  arc(x2, y2, radius, startAngle, endAngle, counterclockwise) {
    this._ensurePoly(false);
    const points = this._currentPoly.points;
    buildArc(points, x2, y2, radius, startAngle, endAngle, counterclockwise);
    return this;
  }
  /**
   * Adds an arc to the path with the arc tangent to the line joining two specified points.
   * The arc radius is specified by `radius`.
   * @param x1 - The x-coordinate of the first point.
   * @param y1 - The y-coordinate of the first point.
   * @param x2 - The x-coordinate of the second point.
   * @param y2 - The y-coordinate of the second point.
   * @param radius - The radius of the arc.
   * @returns The instance of the current object for chaining.
   */
  arcTo(x1, y1, x2, y2, radius) {
    this._ensurePoly();
    const points = this._currentPoly.points;
    buildArcTo(points, x1, y1, x2, y2, radius);
    return this;
  }
  /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */
  arcToSvg(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x2, y2) {
    const points = this._currentPoly.points;
    buildArcToSvg(
      points,
      this._currentPoly.lastX,
      this._currentPoly.lastY,
      x2,
      y2,
      rx,
      ry,
      xAxisRotation,
      largeArcFlag,
      sweepFlag
    );
    return this;
  }
  /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x2, y2, smoothness) {
    this._ensurePoly();
    const currentPoly = this._currentPoly;
    buildAdaptiveBezier(
      this._currentPoly.points,
      currentPoly.lastX,
      currentPoly.lastY,
      cp1x,
      cp1y,
      cp2x,
      cp2y,
      x2,
      y2,
      smoothness
    );
    return this;
  }
  /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the control point.
   * @param cp1y - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothing - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  quadraticCurveTo(cp1x, cp1y, x2, y2, smoothing) {
    this._ensurePoly();
    const currentPoly = this._currentPoly;
    buildAdaptiveQuadratic(
      this._currentPoly.points,
      currentPoly.lastX,
      currentPoly.lastY,
      cp1x,
      cp1y,
      x2,
      y2,
      smoothing
    );
    return this;
  }
  /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */
  closePath() {
    this.endPoly(true);
    return this;
  }
  /**
   * Adds another path to the current path. This method allows for the combination of multiple paths into one.
   * @param path - The `GraphicsPath` object representing the path to add.
   * @param transform - An optional `Matrix` object to apply a transformation to the path before adding it.
   * @returns The instance of the current object for chaining.
   */
  addPath(path2, transform) {
    this.endPoly();
    if (transform && !transform.isIdentity()) {
      path2 = path2.clone(true);
      path2.transform(transform);
    }
    for (let i2 = 0; i2 < path2.instructions.length; i2++) {
      const instruction = path2.instructions[i2];
      this[instruction.action](...instruction.data);
    }
    return this;
  }
  /**
   * Finalizes the drawing of the current path. Optionally, it can close the path.
   * @param closePath - A boolean indicating whether to close the path after finishing. False by default.
   */
  finish(closePath = false) {
    this.endPoly(closePath);
  }
  /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */
  rect(x2, y2, w2, h2, transform) {
    this.drawShape(new Rectangle(x2, y2, w2, h2), transform);
    return this;
  }
  /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */
  circle(x2, y2, radius, transform) {
    this.drawShape(new Circle(x2, y2, radius), transform);
    return this;
  }
  /**
   * Draws a polygon shape. This method allows for the creation of complex polygons by specifying a sequence of points.
   * @param points - An array of numbers, or or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */
  poly(points, close, transform) {
    const polygon = new Polygon(points);
    polygon.closePath = close;
    this.drawShape(polygon, transform);
    return this;
  }
  /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */
  regularPoly(x2, y2, radius, sides, rotation = 0, transform) {
    sides = Math.max(sides | 0, 3);
    const startAngle = -1 * Math.PI / 2 + rotation;
    const delta = Math.PI * 2 / sides;
    const polygon = [];
    for (let i2 = 0; i2 < sides; i2++) {
      const angle = startAngle - i2 * delta;
      polygon.push(
        x2 + radius * Math.cos(angle),
        y2 + radius * Math.sin(angle)
      );
    }
    this.poly(polygon, true, transform);
    return this;
  }
  /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param smoothness - Optional parameter to adjust the smoothness of the rounding.
   * @returns The instance of the current object for chaining.
   */
  roundPoly(x2, y2, radius, sides, corner, rotation = 0, smoothness) {
    sides = Math.max(sides | 0, 3);
    if (corner <= 0) {
      return this.regularPoly(x2, y2, radius, sides, rotation);
    }
    const sideLength = radius * Math.sin(Math.PI / sides) - 1e-3;
    corner = Math.min(corner, sideLength);
    const startAngle = -1 * Math.PI / 2 + rotation;
    const delta = Math.PI * 2 / sides;
    const internalAngle = (sides - 2) * Math.PI / sides / 2;
    for (let i2 = 0; i2 < sides; i2++) {
      const angle = i2 * delta + startAngle;
      const x0 = x2 + radius * Math.cos(angle);
      const y0 = y2 + radius * Math.sin(angle);
      const a1 = angle + Math.PI + internalAngle;
      const a2 = angle - Math.PI - internalAngle;
      const x1 = x0 + corner * Math.cos(a1);
      const y1 = y0 + corner * Math.sin(a1);
      const x3 = x0 + corner * Math.cos(a2);
      const y3 = y0 + corner * Math.sin(a2);
      if (i2 === 0) {
        this.moveTo(x1, y1);
      } else {
        this.lineTo(x1, y1);
      }
      this.quadraticCurveTo(x0, y0, x3, y3, smoothness);
    }
    return this.closePath();
  }
  /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */
  roundShape(points, radius, useQuadratic = false, smoothness) {
    if (points.length < 3) {
      return this;
    }
    if (useQuadratic) {
      roundedShapeQuadraticCurve(this, points, radius, smoothness);
    } else {
      roundedShapeArc(this, points, radius);
    }
    return this.closePath();
  }
  /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */
  filletRect(x2, y2, width, height, fillet) {
    if (fillet === 0) {
      return this.rect(x2, y2, width, height);
    }
    const maxFillet = Math.min(width, height) / 2;
    const inset = Math.min(maxFillet, Math.max(-maxFillet, fillet));
    const right = x2 + width;
    const bottom = y2 + height;
    const dir = inset < 0 ? -inset : 0;
    const size = Math.abs(inset);
    return this.moveTo(x2, y2 + size).arcTo(x2 + dir, y2 + dir, x2 + size, y2, size).lineTo(right - size, y2).arcTo(right - dir, y2 + dir, right, y2 + size, size).lineTo(right, bottom - size).arcTo(right - dir, bottom - dir, x2 + width - size, bottom, size).lineTo(x2 + size, bottom).arcTo(x2 + dir, bottom - dir, x2, bottom - size, size).closePath();
  }
  /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */
  chamferRect(x2, y2, width, height, chamfer, transform) {
    if (chamfer <= 0) {
      return this.rect(x2, y2, width, height);
    }
    const inset = Math.min(chamfer, Math.min(width, height) / 2);
    const right = x2 + width;
    const bottom = y2 + height;
    const points = [
      x2 + inset,
      y2,
      right - inset,
      y2,
      right,
      y2 + inset,
      right,
      bottom - inset,
      right - inset,
      bottom,
      x2 + inset,
      bottom,
      x2,
      bottom - inset,
      x2,
      y2 + inset
    ];
    for (let i2 = points.length - 1; i2 >= 2; i2 -= 2) {
      if (points[i2] === points[i2 - 2] && points[i2 - 1] === points[i2 - 3]) {
        points.splice(i2 - 1, 2);
      }
    }
    return this.poly(points, true, transform);
  }
  /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @param transform - An optional `Matrix` object to apply a transformation to the ellipse. This can include rotations.
   * @returns The instance of the current object for chaining.
   */
  ellipse(x2, y2, radiusX, radiusY, transform) {
    this.drawShape(new Ellipse(x2, y2, radiusX, radiusY), transform);
    return this;
  }
  /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */
  roundRect(x2, y2, w2, h2, radius, transform) {
    this.drawShape(new RoundedRectangle(x2, y2, w2, h2, radius), transform);
    return this;
  }
  /**
   * Draws a given shape on the canvas.
   * This is a generic method that can draw any type of shape specified by the `ShapePrimitive` parameter.
   * An optional transformation matrix can be applied to the shape, allowing for complex transformations.
   * @param shape - The shape to draw, defined as a `ShapePrimitive` object.
   * @param matrix - An optional `Matrix` for transforming the shape. This can include rotations,
   * scaling, and translations.
   * @returns The instance of the current object for chaining.
   */
  drawShape(shape, matrix) {
    this.endPoly();
    this.shapePrimitives.push({ shape, transform: matrix });
    return this;
  }
  /**
   * Starts a new polygon path from the specified starting point.
   * This method initializes a new polygon or ends the current one if it exists.
   * @param x - The x-coordinate of the starting point of the new polygon.
   * @param y - The y-coordinate of the starting point of the new polygon.
   * @returns The instance of the current object for chaining.
   */
  startPoly(x2, y2) {
    let currentPoly = this._currentPoly;
    if (currentPoly) {
      this.endPoly();
    }
    currentPoly = new Polygon();
    currentPoly.points.push(x2, y2);
    this._currentPoly = currentPoly;
    return this;
  }
  /**
   * Ends the current polygon path. If `closePath` is set to true,
   * the path is closed by connecting the last point to the first one.
   * This method finalizes the current polygon and prepares it for drawing or adding to the shape primitives.
   * @param closePath - A boolean indicating whether to close the polygon by connecting the last point
   *  back to the starting point. False by default.
   * @returns The instance of the current object for chaining.
   */
  endPoly(closePath = false) {
    const shape = this._currentPoly;
    if (shape && shape.points.length > 2) {
      shape.closePath = closePath;
      this.shapePrimitives.push({ shape });
    }
    this._currentPoly = null;
    return this;
  }
  _ensurePoly(start = true) {
    if (this._currentPoly)
      return;
    this._currentPoly = new Polygon();
    if (start) {
      const lastShape = this.shapePrimitives[this.shapePrimitives.length - 1];
      if (lastShape) {
        let lx = lastShape.shape.x;
        let ly = lastShape.shape.y;
        if (lastShape.transform && !lastShape.transform.isIdentity()) {
          const t2 = lastShape.transform;
          const tempX = lx;
          lx = t2.a * lx + t2.c * ly + t2.tx;
          ly = t2.b * tempX + t2.d * ly + t2.ty;
        }
        this._currentPoly.points.push(lx, ly);
      } else {
        this._currentPoly.points.push(0, 0);
      }
    }
  }
  /** Builds the path. */
  buildPath() {
    const path2 = this._graphicsPath2D;
    this.shapePrimitives.length = 0;
    this._currentPoly = null;
    for (let i2 = 0; i2 < path2.instructions.length; i2++) {
      const instruction = path2.instructions[i2];
      this[instruction.action](...instruction.data);
    }
    this.finish();
  }
  /** Gets the bounds of the path. */
  get bounds() {
    const bounds = this._bounds;
    bounds.clear();
    const shapePrimitives = this.shapePrimitives;
    for (let i2 = 0; i2 < shapePrimitives.length; i2++) {
      const shapePrimitive = shapePrimitives[i2];
      const boundsRect = shapePrimitive.shape.getBounds(tempRectangle);
      if (shapePrimitive.transform) {
        bounds.addRect(boundsRect, shapePrimitive.transform);
      } else {
        bounds.addRect(boundsRect);
      }
    }
    return bounds;
  }
}
class GraphicsPath {
  /**
   * Creates a `GraphicsPath` instance optionally from an SVG path string or an array of `PathInstruction`.
   * @param instructions - An SVG path string or an array of `PathInstruction` objects.
   */
  constructor(instructions) {
    this.instructions = [];
    this.uid = uid("graphicsPath");
    this._dirty = true;
    if (typeof instructions === "string") {
      SVGToGraphicsPath(instructions, this);
    } else {
      this.instructions = instructions?.slice() ?? [];
    }
  }
  /**
   * Provides access to the internal shape path, ensuring it is up-to-date with the current instructions.
   * @returns The `ShapePath` instance associated with this `GraphicsPath`.
   */
  get shapePath() {
    if (!this._shapePath) {
      this._shapePath = new ShapePath(this);
    }
    if (this._dirty) {
      this._dirty = false;
      this._shapePath.buildPath();
    }
    return this._shapePath;
  }
  /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @param transform - An optional transformation to apply to the added path.
   * @returns The instance of the current object for chaining.
   */
  addPath(path2, transform) {
    path2 = path2.clone();
    this.instructions.push({ action: "addPath", data: [path2, transform] });
    this._dirty = true;
    return this;
  }
  arc(...args) {
    this.instructions.push({ action: "arc", data: args });
    this._dirty = true;
    return this;
  }
  arcTo(...args) {
    this.instructions.push({ action: "arcTo", data: args });
    this._dirty = true;
    return this;
  }
  arcToSvg(...args) {
    this.instructions.push({ action: "arcToSvg", data: args });
    this._dirty = true;
    return this;
  }
  bezierCurveTo(...args) {
    this.instructions.push({ action: "bezierCurveTo", data: args });
    this._dirty = true;
    return this;
  }
  /**
   * Adds a cubic Bezier curve to the path.
   * It requires two points: the second control point and the end point. The first control point is assumed to be
   * The starting point is the last point in the current path.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  bezierCurveToShort(cp2x, cp2y, x2, y2, smoothness) {
    const last = this.instructions[this.instructions.length - 1];
    const lastPoint = this.getLastPoint(Point.shared);
    let cp1x = 0;
    let cp1y = 0;
    if (!last || last.action !== "bezierCurveTo") {
      cp1x = lastPoint.x;
      cp1y = lastPoint.y;
    } else {
      cp1x = last.data[2];
      cp1y = last.data[3];
      const currentX = lastPoint.x;
      const currentY = lastPoint.y;
      cp1x = currentX + (currentX - cp1x);
      cp1y = currentY + (currentY - cp1y);
    }
    this.instructions.push({ action: "bezierCurveTo", data: [cp1x, cp1y, cp2x, cp2y, x2, y2, smoothness] });
    this._dirty = true;
    return this;
  }
  /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */
  closePath() {
    this.instructions.push({ action: "closePath", data: [] });
    this._dirty = true;
    return this;
  }
  ellipse(...args) {
    this.instructions.push({ action: "ellipse", data: args });
    this._dirty = true;
    return this;
  }
  lineTo(...args) {
    this.instructions.push({ action: "lineTo", data: args });
    this._dirty = true;
    return this;
  }
  moveTo(...args) {
    this.instructions.push({ action: "moveTo", data: args });
    return this;
  }
  quadraticCurveTo(...args) {
    this.instructions.push({ action: "quadraticCurveTo", data: args });
    this._dirty = true;
    return this;
  }
  /**
   * Adds a quadratic curve to the path. It uses the previous point as the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  quadraticCurveToShort(x2, y2, smoothness) {
    const last = this.instructions[this.instructions.length - 1];
    const lastPoint = this.getLastPoint(Point.shared);
    let cpx1 = 0;
    let cpy1 = 0;
    if (!last || last.action !== "quadraticCurveTo") {
      cpx1 = lastPoint.x;
      cpy1 = lastPoint.y;
    } else {
      cpx1 = last.data[0];
      cpy1 = last.data[1];
      const currentX = lastPoint.x;
      const currentY = lastPoint.y;
      cpx1 = currentX + (currentX - cpx1);
      cpy1 = currentY + (currentY - cpy1);
    }
    this.instructions.push({ action: "quadraticCurveTo", data: [cpx1, cpy1, x2, y2, smoothness] });
    this._dirty = true;
    return this;
  }
  /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */
  rect(x2, y2, w2, h2, transform) {
    this.instructions.push({ action: "rect", data: [x2, y2, w2, h2, transform] });
    this._dirty = true;
    return this;
  }
  /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */
  circle(x2, y2, radius, transform) {
    this.instructions.push({ action: "circle", data: [x2, y2, radius, transform] });
    this._dirty = true;
    return this;
  }
  roundRect(...args) {
    this.instructions.push({ action: "roundRect", data: args });
    this._dirty = true;
    return this;
  }
  poly(...args) {
    this.instructions.push({ action: "poly", data: args });
    this._dirty = true;
    return this;
  }
  regularPoly(...args) {
    this.instructions.push({ action: "regularPoly", data: args });
    this._dirty = true;
    return this;
  }
  roundPoly(...args) {
    this.instructions.push({ action: "roundPoly", data: args });
    this._dirty = true;
    return this;
  }
  roundShape(...args) {
    this.instructions.push({ action: "roundShape", data: args });
    this._dirty = true;
    return this;
  }
  filletRect(...args) {
    this.instructions.push({ action: "filletRect", data: args });
    this._dirty = true;
    return this;
  }
  chamferRect(...args) {
    this.instructions.push({ action: "chamferRect", data: args });
    this._dirty = true;
    return this;
  }
  /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @param transform - An optional `Matrix` object to apply a transformation to the star.
   * This can include rotations, scaling, and translations.
   * @returns The instance of the current object for chaining further drawing commands.
   */
  // eslint-disable-next-line max-len
  star(x2, y2, points, radius, innerRadius, rotation, transform) {
    innerRadius || (innerRadius = radius / 2);
    const startAngle = -1 * Math.PI / 2 + rotation;
    const len = points * 2;
    const delta = Math.PI * 2 / len;
    const polygon = [];
    for (let i2 = 0; i2 < len; i2++) {
      const r2 = i2 % 2 ? innerRadius : radius;
      const angle = i2 * delta + startAngle;
      polygon.push(
        x2 + r2 * Math.cos(angle),
        y2 + r2 * Math.sin(angle)
      );
    }
    this.poly(polygon, true, transform);
    return this;
  }
  /**
   * Creates a copy of the current `GraphicsPath` instance. This method supports both shallow and deep cloning.
   * A shallow clone copies the reference of the instructions array, while a deep clone creates a new array and
   * copies each instruction individually, ensuring that modifications to the instructions of the cloned `GraphicsPath`
   * do not affect the original `GraphicsPath` and vice versa.
   * @param deep - A boolean flag indicating whether the clone should be deep.
   * @returns A new `GraphicsPath` instance that is a clone of the current instance.
   */
  clone(deep = false) {
    const newGraphicsPath2D = new GraphicsPath();
    if (!deep) {
      newGraphicsPath2D.instructions = this.instructions.slice();
    } else {
      for (let i2 = 0; i2 < this.instructions.length; i2++) {
        const instruction = this.instructions[i2];
        newGraphicsPath2D.instructions.push({ action: instruction.action, data: instruction.data.slice() });
      }
    }
    return newGraphicsPath2D;
  }
  clear() {
    this.instructions.length = 0;
    this._dirty = true;
    return this;
  }
  /**
   * Applies a transformation matrix to all drawing instructions within the `GraphicsPath`.
   * This method enables the modification of the path's geometry according to the provided
   * transformation matrix, which can include translations, rotations, scaling, and skewing.
   *
   * Each drawing instruction in the path is updated to reflect the transformation,
   * ensuring the visual representation of the path is consistent with the applied matrix.
   *
   * Note: The transformation is applied directly to the coordinates and control points of the drawing instructions,
   * not to the path as a whole. This means the transformation's effects are baked into the individual instructions,
   * allowing for fine-grained control over the path's appearance.
   * @param matrix - A `Matrix` object representing the transformation to apply.
   * @returns The instance of the current object for chaining further operations.
   */
  transform(matrix) {
    if (matrix.isIdentity())
      return this;
    const a2 = matrix.a;
    const b2 = matrix.b;
    const c2 = matrix.c;
    const d2 = matrix.d;
    const tx = matrix.tx;
    const ty = matrix.ty;
    let x2 = 0;
    let y2 = 0;
    let cpx1 = 0;
    let cpy1 = 0;
    let cpx2 = 0;
    let cpy2 = 0;
    let rx = 0;
    let ry = 0;
    for (let i2 = 0; i2 < this.instructions.length; i2++) {
      const instruction = this.instructions[i2];
      const data = instruction.data;
      switch (instruction.action) {
        case "moveTo":
        case "lineTo":
          x2 = data[0];
          y2 = data[1];
          data[0] = a2 * x2 + c2 * y2 + tx;
          data[1] = b2 * x2 + d2 * y2 + ty;
          break;
        case "bezierCurveTo":
          cpx1 = data[0];
          cpy1 = data[1];
          cpx2 = data[2];
          cpy2 = data[3];
          x2 = data[4];
          y2 = data[5];
          data[0] = a2 * cpx1 + c2 * cpy1 + tx;
          data[1] = b2 * cpx1 + d2 * cpy1 + ty;
          data[2] = a2 * cpx2 + c2 * cpy2 + tx;
          data[3] = b2 * cpx2 + d2 * cpy2 + ty;
          data[4] = a2 * x2 + c2 * y2 + tx;
          data[5] = b2 * x2 + d2 * y2 + ty;
          break;
        case "quadraticCurveTo":
          cpx1 = data[0];
          cpy1 = data[1];
          x2 = data[2];
          y2 = data[3];
          data[0] = a2 * cpx1 + c2 * cpy1 + tx;
          data[1] = b2 * cpx1 + d2 * cpy1 + ty;
          data[2] = a2 * x2 + c2 * y2 + tx;
          data[3] = b2 * x2 + d2 * y2 + ty;
          break;
        case "arcToSvg":
          x2 = data[5];
          y2 = data[6];
          rx = data[0];
          ry = data[1];
          data[0] = a2 * rx + c2 * ry;
          data[1] = b2 * rx + d2 * ry;
          data[5] = a2 * x2 + c2 * y2 + tx;
          data[6] = b2 * x2 + d2 * y2 + ty;
          break;
        case "circle":
          data[4] = adjustTransform(data[3], matrix);
          break;
        case "rect":
          data[4] = adjustTransform(data[4], matrix);
          break;
        case "ellipse":
          data[8] = adjustTransform(data[8], matrix);
          break;
        case "roundRect":
          data[5] = adjustTransform(data[5], matrix);
          break;
        case "addPath":
          data[0].transform(matrix);
          break;
        case "poly":
          data[2] = adjustTransform(data[2], matrix);
          break;
        default:
          warn("unknown transform action", instruction.action);
          break;
      }
    }
    this._dirty = true;
    return this;
  }
  get bounds() {
    return this.shapePath.bounds;
  }
  /**
   * Retrieves the last point from the current drawing instructions in the `GraphicsPath`.
   * This method is useful for operations that depend on the path's current endpoint,
   * such as connecting subsequent shapes or paths. It supports various drawing instructions,
   * ensuring the last point's position is accurately determined regardless of the path's complexity.
   *
   * If the last instruction is a `closePath`, the method iterates backward through the instructions
   *  until it finds an actionable instruction that defines a point (e.g., `moveTo`, `lineTo`,
   * `quadraticCurveTo`, etc.). For compound paths added via `addPath`, it recursively retrieves
   * the last point from the nested path.
   * @param out - A `Point` object where the last point's coordinates will be stored.
   * This object is modified directly to contain the result.
   * @returns The `Point` object containing the last point's coordinates.
   */
  getLastPoint(out2) {
    let index = this.instructions.length - 1;
    let lastInstruction = this.instructions[index];
    if (!lastInstruction) {
      out2.x = 0;
      out2.y = 0;
      return out2;
    }
    while (lastInstruction.action === "closePath") {
      index--;
      if (index < 0) {
        out2.x = 0;
        out2.y = 0;
        return out2;
      }
      lastInstruction = this.instructions[index];
    }
    switch (lastInstruction.action) {
      case "moveTo":
      case "lineTo":
        out2.x = lastInstruction.data[0];
        out2.y = lastInstruction.data[1];
        break;
      case "quadraticCurveTo":
        out2.x = lastInstruction.data[2];
        out2.y = lastInstruction.data[3];
        break;
      case "bezierCurveTo":
        out2.x = lastInstruction.data[4];
        out2.y = lastInstruction.data[5];
        break;
      case "arc":
      case "arcToSvg":
        out2.x = lastInstruction.data[5];
        out2.y = lastInstruction.data[6];
        break;
      case "addPath":
        lastInstruction.data[0].getLastPoint(out2);
        break;
    }
    return out2;
  }
}
function adjustTransform(currentMatrix, transform) {
  if (currentMatrix) {
    return currentMatrix.prepend(transform);
  }
  return transform.clone();
}
function SVGParser(svg, graphicsContext) {
  if (typeof svg === "string") {
    const div = document.createElement("div");
    div.innerHTML = svg.trim();
    svg = div.querySelector("svg");
  }
  const session = {
    context: graphicsContext,
    path: new GraphicsPath()
  };
  renderChildren(svg, session, null, null);
  return graphicsContext;
}
function renderChildren(svg, session, fillStyle, strokeStyle) {
  const children = svg.children;
  const { fillStyle: f1, strokeStyle: s1 } = parseStyle(svg);
  if (f1 && fillStyle) {
    fillStyle = { ...fillStyle, ...f1 };
  } else if (f1) {
    fillStyle = f1;
  }
  if (s1 && strokeStyle) {
    strokeStyle = { ...strokeStyle, ...s1 };
  } else if (s1) {
    strokeStyle = s1;
  }
  session.context.fillStyle = fillStyle;
  session.context.strokeStyle = strokeStyle;
  let x2;
  let y2;
  let x1;
  let y1;
  let x22;
  let y22;
  let cx;
  let cy;
  let r2;
  let rx;
  let ry;
  let points;
  let pointsString;
  let d2;
  let graphicsPath;
  let width;
  let height;
  switch (svg.nodeName.toLowerCase()) {
    case "path":
      d2 = svg.getAttribute("d");
      graphicsPath = new GraphicsPath(d2);
      session.context.path(graphicsPath);
      if (fillStyle)
        session.context.fill();
      if (strokeStyle)
        session.context.stroke();
      break;
    case "circle":
      cx = parseFloatAttribute(svg, "cx", 0);
      cy = parseFloatAttribute(svg, "cy", 0);
      r2 = parseFloatAttribute(svg, "r", 0);
      session.context.ellipse(cx, cy, r2, r2);
      if (fillStyle)
        session.context.fill();
      if (strokeStyle)
        session.context.stroke();
      break;
    case "rect":
      x2 = parseFloatAttribute(svg, "x", 0);
      y2 = parseFloatAttribute(svg, "y", 0);
      width = parseFloatAttribute(svg, "width", 0);
      height = parseFloatAttribute(svg, "height", 0);
      rx = parseFloatAttribute(svg, "rx", 0);
      ry = parseFloatAttribute(svg, "ry", 0);
      if (rx || ry) {
        session.context.roundRect(x2, y2, width, height, rx || ry);
      } else {
        session.context.rect(x2, y2, width, height);
      }
      if (fillStyle)
        session.context.fill();
      if (strokeStyle)
        session.context.stroke();
      break;
    case "ellipse":
      cx = parseFloatAttribute(svg, "cx", 0);
      cy = parseFloatAttribute(svg, "cy", 0);
      rx = parseFloatAttribute(svg, "rx", 0);
      ry = parseFloatAttribute(svg, "ry", 0);
      session.context.beginPath();
      session.context.ellipse(cx, cy, rx, ry);
      if (fillStyle)
        session.context.fill();
      if (strokeStyle)
        session.context.stroke();
      break;
    case "line":
      x1 = parseFloatAttribute(svg, "x1", 0);
      y1 = parseFloatAttribute(svg, "y1", 0);
      x22 = parseFloatAttribute(svg, "x2", 0);
      y22 = parseFloatAttribute(svg, "y2", 0);
      session.context.beginPath();
      session.context.moveTo(x1, y1);
      session.context.lineTo(x22, y22);
      if (strokeStyle)
        session.context.stroke();
      break;
    case "polygon":
      pointsString = svg.getAttribute("points");
      points = pointsString.match(/\d+/g).map((n2) => parseInt(n2, 10));
      session.context.poly(points, true);
      if (fillStyle)
        session.context.fill();
      if (strokeStyle)
        session.context.stroke();
      break;
    case "polyline":
      pointsString = svg.getAttribute("points");
      points = pointsString.match(/\d+/g).map((n2) => parseInt(n2, 10));
      session.context.poly(points, false);
      if (strokeStyle)
        session.context.stroke();
      break;
    case "g":
    case "svg":
      break;
    default: {
      console.info(`[SVG parser] <${svg.nodeName}> elements unsupported`);
      break;
    }
  }
  for (let i2 = 0; i2 < children.length; i2++) {
    renderChildren(children[i2], session, fillStyle, strokeStyle);
  }
}
function parseFloatAttribute(svg, id, defaultValue) {
  const value = svg.getAttribute(id);
  return value ? Number(value) : defaultValue;
}
function parseStyle(svg) {
  const style = svg.getAttribute("style");
  const strokeStyle = {};
  const fillStyle = {};
  let useFill = false;
  let useStroke = false;
  if (style) {
    const styleParts = style.split(";");
    for (let i2 = 0; i2 < styleParts.length; i2++) {
      const stylePart = styleParts[i2];
      const [key, value] = stylePart.split(":");
      switch (key) {
        case "stroke":
          if (value !== "none") {
            strokeStyle.color = Color.shared.setValue(value).toNumber();
            useStroke = true;
          }
          break;
        case "stroke-width":
          strokeStyle.width = Number(value);
          break;
        case "fill":
          if (value !== "none") {
            useFill = true;
            fillStyle.color = Color.shared.setValue(value).toNumber();
          }
          break;
        case "fill-opacity":
          fillStyle.alpha = Number(value);
          break;
        case "stroke-opacity":
          strokeStyle.alpha = Number(value);
          break;
        case "opacity":
          fillStyle.alpha = Number(value);
          strokeStyle.alpha = Number(value);
          break;
      }
    }
  } else {
    const stroke = svg.getAttribute("stroke");
    if (stroke && stroke !== "none") {
      useStroke = true;
      strokeStyle.color = Color.shared.setValue(stroke).toNumber();
      strokeStyle.width = parseFloatAttribute(svg, "stroke-width", 1);
    }
    const fill = svg.getAttribute("fill");
    if (fill && fill !== "none") {
      useFill = true;
      fillStyle.color = Color.shared.setValue(fill).toNumber();
    }
  }
  return {
    strokeStyle: useStroke ? strokeStyle : null,
    fillStyle: useFill ? fillStyle : null
  };
}
function isColorLike(value) {
  return Color.isColorLike(value);
}
function isFillPattern(value) {
  return value instanceof FillPattern;
}
function isFillGradient(value) {
  return value instanceof FillGradient;
}
function handleColorLike(fill, value, defaultStyle) {
  const temp = Color.shared.setValue(value ?? 0);
  fill.color = temp.toNumber();
  fill.alpha = temp.alpha === 1 ? defaultStyle.alpha : temp.alpha;
  fill.texture = Texture.WHITE;
  return { ...defaultStyle, ...fill };
}
function handleFillPattern(fill, value, defaultStyle) {
  fill.fill = value;
  fill.color = 16777215;
  fill.texture = value.texture;
  fill.matrix = value.transform;
  return { ...defaultStyle, ...fill };
}
function handleFillGradient(fill, value, defaultStyle) {
  value.buildLinearGradient();
  fill.fill = value;
  fill.color = 16777215;
  fill.texture = value.texture;
  fill.matrix = value.transform;
  return { ...defaultStyle, ...fill };
}
function handleFillObject(value, defaultStyle) {
  const style = { ...defaultStyle, ...value };
  if (style.texture) {
    if (style.texture !== Texture.WHITE) {
      const m2 = style.matrix?.clone().invert() || new Matrix();
      m2.translate(style.texture.frame.x, style.texture.frame.y);
      m2.scale(1 / style.texture.source.width, 1 / style.texture.source.height);
      style.matrix = m2;
    }
    const sourceStyle = style.texture.source.style;
    if (sourceStyle.addressMode === "clamp-to-edge") {
      sourceStyle.addressMode = "repeat";
      sourceStyle.update();
    }
  }
  const color = Color.shared.setValue(style.color);
  style.alpha *= color.alpha;
  style.color = color.toNumber();
  style.matrix = style.matrix ? style.matrix.clone() : null;
  return style;
}
function toFillStyle(value, defaultStyle) {
  if (value === void 0 || value === null) {
    return null;
  }
  const fill = {};
  const objectStyle = value;
  if (isColorLike(value)) {
    return handleColorLike(fill, value, defaultStyle);
  } else if (isFillPattern(value)) {
    return handleFillPattern(fill, value, defaultStyle);
  } else if (isFillGradient(value)) {
    return handleFillGradient(fill, value, defaultStyle);
  } else if (objectStyle.fill && isFillPattern(objectStyle.fill)) {
    return handleFillPattern(objectStyle, objectStyle.fill, defaultStyle);
  } else if (objectStyle.fill && isFillGradient(objectStyle.fill)) {
    return handleFillGradient(objectStyle, objectStyle.fill, defaultStyle);
  }
  return handleFillObject(objectStyle, defaultStyle);
}
function toStrokeStyle(value, defaultStyle) {
  const { width, alignment, miterLimit, cap, join, pixelLine, ...rest } = defaultStyle;
  const fill = toFillStyle(value, rest);
  if (!fill) {
    return null;
  }
  return {
    width,
    alignment,
    miterLimit,
    cap,
    join,
    pixelLine,
    ...fill
  };
}
const tmpPoint = new Point();
const tempMatrix = new Matrix();
const _GraphicsContext = class _GraphicsContext2 extends EventEmitter {
  constructor() {
    super(...arguments);
    this.uid = uid("graphicsContext");
    this.dirty = true;
    this.batchMode = "auto";
    this.instructions = [];
    this._activePath = new GraphicsPath();
    this._transform = new Matrix();
    this._fillStyle = { ..._GraphicsContext2.defaultFillStyle };
    this._strokeStyle = { ..._GraphicsContext2.defaultStrokeStyle };
    this._stateStack = [];
    this._tick = 0;
    this._bounds = new Bounds();
    this._boundsDirty = true;
  }
  /**
   * Creates a new GraphicsContext object that is a clone of this instance, copying all properties,
   * including the current drawing state, transformations, styles, and instructions.
   * @returns A new GraphicsContext instance with the same properties and state as this one.
   */
  clone() {
    const clone = new _GraphicsContext2();
    clone.batchMode = this.batchMode;
    clone.instructions = this.instructions.slice();
    clone._activePath = this._activePath.clone();
    clone._transform = this._transform.clone();
    clone._fillStyle = { ...this._fillStyle };
    clone._strokeStyle = { ...this._strokeStyle };
    clone._stateStack = this._stateStack.slice();
    clone._bounds = this._bounds.clone();
    clone._boundsDirty = true;
    return clone;
  }
  /**
   * The current fill style of the graphics context. This can be a color, gradient, pattern, or a more complex style defined by a FillStyle object.
   */
  get fillStyle() {
    return this._fillStyle;
  }
  set fillStyle(value) {
    this._fillStyle = toFillStyle(value, _GraphicsContext2.defaultFillStyle);
  }
  /**
   * The current stroke style of the graphics context. Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   */
  get strokeStyle() {
    return this._strokeStyle;
  }
  set strokeStyle(value) {
    this._strokeStyle = toStrokeStyle(value, _GraphicsContext2.defaultStrokeStyle);
  }
  /**
   * Sets the current fill style of the graphics context. The fill style can be a color, gradient,
   * pattern, or a more complex style defined by a FillStyle object.
   * @param style - The fill style to apply. This can be a simple color, a gradient or pattern object,
   *                or a FillStyle or ConvertedFillStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  setFillStyle(style) {
    this._fillStyle = toFillStyle(style, _GraphicsContext2.defaultFillStyle);
    return this;
  }
  /**
   * Sets the current stroke style of the graphics context. Similar to fill styles, stroke styles can
   * encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   * @param style - The stroke style to apply. Can be defined as a color, a gradient or pattern,
   *                or a StrokeStyle or ConvertedStrokeStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  setStrokeStyle(style) {
    this._strokeStyle = toFillStyle(style, _GraphicsContext2.defaultStrokeStyle);
    return this;
  }
  texture(texture, tint, dx, dy, dw, dh) {
    this.instructions.push({
      action: "texture",
      data: {
        image: texture,
        dx: dx || 0,
        dy: dy || 0,
        dw: dw || texture.frame.width,
        dh: dh || texture.frame.height,
        transform: this._transform.clone(),
        alpha: this._fillStyle.alpha,
        style: tint ? Color.shared.setValue(tint).toNumber() : 16777215
      }
    });
    this.onUpdate();
    return this;
  }
  /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  beginPath() {
    this._activePath = new GraphicsPath();
    return this;
  }
  fill(style, alpha) {
    let path2;
    const lastInstruction = this.instructions[this.instructions.length - 1];
    if (this._tick === 0 && lastInstruction && lastInstruction.action === "stroke") {
      path2 = lastInstruction.data.path;
    } else {
      path2 = this._activePath.clone();
    }
    if (!path2)
      return this;
    if (style != null) {
      if (alpha !== void 0 && typeof style === "number") {
        deprecation(v8_0_0, "GraphicsContext.fill(color, alpha) is deprecated, use GraphicsContext.fill({ color, alpha }) instead");
        style = { color: style, alpha };
      }
      this._fillStyle = toFillStyle(style, _GraphicsContext2.defaultFillStyle);
    }
    this.instructions.push({
      action: "fill",
      // TODO copy fill style!
      data: { style: this.fillStyle, path: path2 }
    });
    this.onUpdate();
    this._initNextPathLocation();
    this._tick = 0;
    return this;
  }
  _initNextPathLocation() {
    const { x: x2, y: y2 } = this._activePath.getLastPoint(Point.shared);
    this._activePath.clear();
    this._activePath.moveTo(x2, y2);
  }
  /**
   * Strokes the current path with the current stroke style. This method can take an optional
   * FillInput parameter to define the stroke's appearance, including its color, width, and other properties.
   * @param style - (Optional) The stroke style to apply. Can be defined as a simple color or a more complex style object. If omitted, uses the current stroke style.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  stroke(style) {
    let path2;
    const lastInstruction = this.instructions[this.instructions.length - 1];
    if (this._tick === 0 && lastInstruction && lastInstruction.action === "fill") {
      path2 = lastInstruction.data.path;
    } else {
      path2 = this._activePath.clone();
    }
    if (!path2)
      return this;
    if (style != null) {
      this._strokeStyle = toStrokeStyle(style, _GraphicsContext2.defaultStrokeStyle);
    }
    this.instructions.push({
      action: "stroke",
      // TODO copy fill style!
      data: { style: this.strokeStyle, path: path2 }
    });
    this.onUpdate();
    this._initNextPathLocation();
    this._tick = 0;
    return this;
  }
  /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path. If a hole is not completely in a shape, it will
   * fail to cut correctly!
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  cut() {
    for (let i2 = 0; i2 < 2; i2++) {
      const lastInstruction = this.instructions[this.instructions.length - 1 - i2];
      const holePath = this._activePath.clone();
      if (lastInstruction) {
        if (lastInstruction.action === "stroke" || lastInstruction.action === "fill") {
          if (lastInstruction.data.hole) {
            lastInstruction.data.hole.addPath(holePath);
          } else {
            lastInstruction.data.hole = holePath;
            break;
          }
        }
      }
    }
    this._initNextPathLocation();
    return this;
  }
  /**
   * Adds an arc to the current path, which is centered at (x, y) with the specified radius,
   * starting and ending angles, and direction.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The arc's radius.
   * @param startAngle - The starting angle, in radians.
   * @param endAngle - The ending angle, in radians.
   * @param counterclockwise - (Optional) Specifies whether the arc is drawn counterclockwise (true) or clockwise (false). Defaults to false.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  arc(x2, y2, radius, startAngle, endAngle, counterclockwise) {
    this._tick++;
    const t2 = this._transform;
    this._activePath.arc(
      t2.a * x2 + t2.c * y2 + t2.tx,
      t2.b * x2 + t2.d * y2 + t2.ty,
      radius,
      startAngle,
      endAngle,
      counterclockwise
    );
    return this;
  }
  /**
   * Adds an arc to the current path with the given control points and radius, connected to the previous point
   * by a straight line if necessary.
   * @param x1 - The x-coordinate of the first control point.
   * @param y1 - The y-coordinate of the first control point.
   * @param x2 - The x-coordinate of the second control point.
   * @param y2 - The y-coordinate of the second control point.
   * @param radius - The arc's radius.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  arcTo(x1, y1, x2, y2, radius) {
    this._tick++;
    const t2 = this._transform;
    this._activePath.arcTo(
      t2.a * x1 + t2.c * y1 + t2.tx,
      t2.b * x1 + t2.d * y1 + t2.ty,
      t2.a * x2 + t2.c * y2 + t2.tx,
      t2.b * x2 + t2.d * y2 + t2.ty,
      radius
    );
    return this;
  }
  /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */
  arcToSvg(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x2, y2) {
    this._tick++;
    const t2 = this._transform;
    this._activePath.arcToSvg(
      rx,
      ry,
      xAxisRotation,
      // should we rotate this with transform??
      largeArcFlag,
      sweepFlag,
      t2.a * x2 + t2.c * y2 + t2.tx,
      t2.b * x2 + t2.d * y2 + t2.ty
    );
    return this;
  }
  /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x2, y2, smoothness) {
    this._tick++;
    const t2 = this._transform;
    this._activePath.bezierCurveTo(
      t2.a * cp1x + t2.c * cp1y + t2.tx,
      t2.b * cp1x + t2.d * cp1y + t2.ty,
      t2.a * cp2x + t2.c * cp2y + t2.tx,
      t2.b * cp2x + t2.d * cp2y + t2.ty,
      t2.a * x2 + t2.c * y2 + t2.tx,
      t2.b * x2 + t2.d * y2 + t2.ty,
      smoothness
    );
    return this;
  }
  /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */
  closePath() {
    this._tick++;
    this._activePath?.closePath();
    return this;
  }
  /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @returns The instance of the current object for chaining.
   */
  ellipse(x2, y2, radiusX, radiusY) {
    this._tick++;
    this._activePath.ellipse(x2, y2, radiusX, radiusY, this._transform.clone());
    return this;
  }
  /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @returns The instance of the current object for chaining.
   */
  circle(x2, y2, radius) {
    this._tick++;
    this._activePath.circle(x2, y2, radius, this._transform.clone());
    return this;
  }
  /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @returns The instance of the current object for chaining.
   */
  path(path2) {
    this._tick++;
    this._activePath.addPath(path2, this._transform.clone());
    return this;
  }
  /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */
  lineTo(x2, y2) {
    this._tick++;
    const t2 = this._transform;
    this._activePath.lineTo(
      t2.a * x2 + t2.c * y2 + t2.tx,
      t2.b * x2 + t2.d * y2 + t2.ty
    );
    return this;
  }
  /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */
  moveTo(x2, y2) {
    this._tick++;
    const t2 = this._transform;
    const instructions = this._activePath.instructions;
    const transformedX = t2.a * x2 + t2.c * y2 + t2.tx;
    const transformedY = t2.b * x2 + t2.d * y2 + t2.ty;
    if (instructions.length === 1 && instructions[0].action === "moveTo") {
      instructions[0].data[0] = transformedX;
      instructions[0].data[1] = transformedY;
      return this;
    }
    this._activePath.moveTo(
      transformedX,
      transformedY
    );
    return this;
  }
  /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cpx - The x-coordinate of the control point.
   * @param cpy - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  quadraticCurveTo(cpx, cpy, x2, y2, smoothness) {
    this._tick++;
    const t2 = this._transform;
    this._activePath.quadraticCurveTo(
      t2.a * cpx + t2.c * cpy + t2.tx,
      t2.b * cpx + t2.d * cpy + t2.ty,
      t2.a * x2 + t2.c * y2 + t2.tx,
      t2.b * x2 + t2.d * y2 + t2.ty,
      smoothness
    );
    return this;
  }
  /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @returns The instance of the current object for chaining.
   */
  rect(x2, y2, w2, h2) {
    this._tick++;
    this._activePath.rect(x2, y2, w2, h2, this._transform.clone());
    return this;
  }
  /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @returns The instance of the current object for chaining.
   */
  roundRect(x2, y2, w2, h2, radius) {
    this._tick++;
    this._activePath.roundRect(x2, y2, w2, h2, radius, this._transform.clone());
    return this;
  }
  /**
   * Draws a polygon shape by specifying a sequence of points. This method allows for the creation of complex polygons,
   * which can be both open and closed. An optional transformation can be applied, enabling the polygon to be scaled,
   * rotated, or translated as needed.
   * @param points - An array of numbers, or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates, of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   */
  poly(points, close) {
    this._tick++;
    this._activePath.poly(points, close, this._transform.clone());
    return this;
  }
  /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */
  regularPoly(x2, y2, radius, sides, rotation = 0, transform) {
    this._tick++;
    this._activePath.regularPoly(x2, y2, radius, sides, rotation, transform);
    return this;
  }
  /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @returns The instance of the current object for chaining.
   */
  roundPoly(x2, y2, radius, sides, corner, rotation) {
    this._tick++;
    this._activePath.roundPoly(x2, y2, radius, sides, corner, rotation);
    return this;
  }
  /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */
  roundShape(points, radius, useQuadratic, smoothness) {
    this._tick++;
    this._activePath.roundShape(points, radius, useQuadratic, smoothness);
    return this;
  }
  /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */
  filletRect(x2, y2, width, height, fillet) {
    this._tick++;
    this._activePath.filletRect(x2, y2, width, height, fillet);
    return this;
  }
  /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */
  chamferRect(x2, y2, width, height, chamfer, transform) {
    this._tick++;
    this._activePath.chamferRect(x2, y2, width, height, chamfer, transform);
    return this;
  }
  /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @returns The instance of the current object for chaining further drawing commands.
   */
  star(x2, y2, points, radius, innerRadius = 0, rotation = 0) {
    this._tick++;
    this._activePath.star(x2, y2, points, radius, innerRadius, rotation, this._transform.clone());
    return this;
  }
  /**
   * Parses and renders an SVG string into the graphics context. This allows for complex shapes and paths
   * defined in SVG format to be drawn within the graphics context.
   * @param svg - The SVG string to be parsed and rendered.
   */
  svg(svg) {
    this._tick++;
    SVGParser(svg, this);
    return this;
  }
  /**
   * Restores the most recently saved graphics state by popping the top of the graphics state stack.
   * This includes transformations, fill styles, and stroke styles.
   */
  restore() {
    const state = this._stateStack.pop();
    if (state) {
      this._transform = state.transform;
      this._fillStyle = state.fillStyle;
      this._strokeStyle = state.strokeStyle;
    }
    return this;
  }
  /** Saves the current graphics state, including transformations, fill styles, and stroke styles, onto a stack. */
  save() {
    this._stateStack.push({
      transform: this._transform.clone(),
      fillStyle: { ...this._fillStyle },
      strokeStyle: { ...this._strokeStyle }
    });
    return this;
  }
  /**
   * Returns the current transformation matrix of the graphics context.
   * @returns The current transformation matrix.
   */
  getTransform() {
    return this._transform;
  }
  /**
   * Resets the current transformation matrix to the identity matrix, effectively removing any transformations (rotation, scaling, translation) previously applied.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  resetTransform() {
    this._transform.identity();
    return this;
  }
  /**
   * Applies a rotation transformation to the graphics context around the current origin.
   * @param angle - The angle of rotation in radians.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  rotate(angle) {
    this._transform.rotate(angle);
    return this;
  }
  /**
   * Applies a scaling transformation to the graphics context, scaling drawings by x horizontally and by y vertically.
   * @param x - The scale factor in the horizontal direction.
   * @param y - (Optional) The scale factor in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  scale(x2, y2 = x2) {
    this._transform.scale(x2, y2);
    return this;
  }
  setTransform(a2, b2, c2, d2, dx, dy) {
    if (a2 instanceof Matrix) {
      this._transform.set(a2.a, a2.b, a2.c, a2.d, a2.tx, a2.ty);
      return this;
    }
    this._transform.set(a2, b2, c2, d2, dx, dy);
    return this;
  }
  transform(a2, b2, c2, d2, dx, dy) {
    if (a2 instanceof Matrix) {
      this._transform.append(a2);
      return this;
    }
    tempMatrix.set(a2, b2, c2, d2, dx, dy);
    this._transform.append(tempMatrix);
    return this;
  }
  /**
   * Applies a translation transformation to the graphics context, moving the origin by the specified amounts.
   * @param x - The amount to translate in the horizontal direction.
   * @param y - (Optional) The amount to translate in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  translate(x2, y2 = x2) {
    this._transform.translate(x2, y2);
    return this;
  }
  /**
   * Clears all drawing commands from the graphics context, effectively resetting it. This includes clearing the path,
   * and optionally resetting transformations to the identity matrix.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  clear() {
    this._activePath.clear();
    this.instructions.length = 0;
    this.resetTransform();
    this.onUpdate();
    return this;
  }
  onUpdate() {
    if (this.dirty)
      return;
    this.emit("update", this, 16);
    this.dirty = true;
    this._boundsDirty = true;
  }
  /** The bounds of the graphic shape. */
  get bounds() {
    if (!this._boundsDirty)
      return this._bounds;
    const bounds = this._bounds;
    bounds.clear();
    for (let i2 = 0; i2 < this.instructions.length; i2++) {
      const instruction = this.instructions[i2];
      const action = instruction.action;
      if (action === "fill") {
        const data = instruction.data;
        bounds.addBounds(data.path.bounds);
      } else if (action === "texture") {
        const data = instruction.data;
        bounds.addFrame(data.dx, data.dy, data.dx + data.dw, data.dy + data.dh, data.transform);
      }
      if (action === "stroke") {
        const data = instruction.data;
        const alignment = data.style.alignment;
        const outerPadding = data.style.width * (1 - alignment);
        const _bounds = data.path.bounds;
        bounds.addFrame(
          _bounds.minX - outerPadding,
          _bounds.minY - outerPadding,
          _bounds.maxX + outerPadding,
          _bounds.maxY + outerPadding
        );
      }
    }
    return bounds;
  }
  /**
   * Check to see if a point is contained within this geometry.
   * @param point - Point to check if it's contained.
   * @returns {boolean} `true` if the point is contained within geometry.
   */
  containsPoint(point) {
    if (!this.bounds.containsPoint(point.x, point.y))
      return false;
    const instructions = this.instructions;
    let hasHit = false;
    for (let k2 = 0; k2 < instructions.length; k2++) {
      const instruction = instructions[k2];
      const data = instruction.data;
      const path2 = data.path;
      if (!instruction.action || !path2)
        continue;
      const style = data.style;
      const shapes = path2.shapePath.shapePrimitives;
      for (let i2 = 0; i2 < shapes.length; i2++) {
        const shape = shapes[i2].shape;
        if (!style || !shape)
          continue;
        const transform = shapes[i2].transform;
        const transformedPoint = transform ? transform.applyInverse(point, tmpPoint) : point;
        if (instruction.action === "fill") {
          hasHit = shape.contains(transformedPoint.x, transformedPoint.y);
        } else {
          const strokeStyle = style;
          hasHit = shape.strokeContains(transformedPoint.x, transformedPoint.y, strokeStyle.width, strokeStyle.alignment);
        }
        const holes = data.hole;
        if (holes) {
          const holeShapes = holes.shapePath?.shapePrimitives;
          if (holeShapes) {
            for (let j2 = 0; j2 < holeShapes.length; j2++) {
              if (holeShapes[j2].shape.contains(transformedPoint.x, transformedPoint.y)) {
                hasHit = false;
              }
            }
          }
        }
        if (hasHit) {
          return true;
        }
      }
    }
    return hasHit;
  }
  /**
   * Destroys the GraphicsData object.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the fill/stroke style?
   * @param {boolean} [options.textureSource=false] - Should it destroy the texture source of the fill/stroke style?
   */
  destroy(options = false) {
    this._stateStack.length = 0;
    this._transform = null;
    this.emit("destroy", this);
    this.removeAllListeners();
    const destroyTexture = typeof options === "boolean" ? options : options?.texture;
    if (destroyTexture) {
      const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
      if (this._fillStyle.texture) {
        this._fillStyle.texture.destroy(destroyTextureSource);
      }
      if (this._strokeStyle.texture) {
        this._strokeStyle.texture.destroy(destroyTextureSource);
      }
    }
    this._fillStyle = null;
    this._strokeStyle = null;
    this.instructions = null;
    this._activePath = null;
    this._bounds = null;
    this._stateStack = null;
    this.customShader = null;
    this._transform = null;
  }
};
_GraphicsContext.defaultFillStyle = {
  /** The color to use for the fill. */
  color: 16777215,
  /** The alpha value to use for the fill. */
  alpha: 1,
  /** The texture to use for the fill. */
  texture: Texture.WHITE,
  /** The matrix to apply. */
  matrix: null,
  /** The fill pattern to use. */
  fill: null
};
_GraphicsContext.defaultStrokeStyle = {
  /** The width of the stroke. */
  width: 1,
  /** The color to use for the stroke. */
  color: 16777215,
  /** The alpha value to use for the stroke. */
  alpha: 1,
  /** The alignment of the stroke. */
  alignment: 0.5,
  /** The miter limit to use. */
  miterLimit: 10,
  /** The line cap style to use. */
  cap: "butt",
  /** The line join style to use. */
  join: "miter",
  /** The texture to use for the fill. */
  texture: Texture.WHITE,
  /** The matrix to apply. */
  matrix: null,
  /** The fill pattern to use. */
  fill: null,
  /** If the stroke is a pixel line. */
  pixelLine: false
};
let GraphicsContext = _GraphicsContext;
const valuesToIterateForKeys = [
  "align",
  "breakWords",
  "cssOverrides",
  "fontVariant",
  "fontWeight",
  "leading",
  "letterSpacing",
  "lineHeight",
  "padding",
  "textBaseline",
  "trim",
  "whiteSpace",
  "wordWrap",
  "wordWrapWidth",
  "fontFamily",
  "fontStyle",
  "fontSize"
];
function generateTextStyleKey(style) {
  const key = [];
  let index = 0;
  for (let i2 = 0; i2 < valuesToIterateForKeys.length; i2++) {
    const prop = `_${valuesToIterateForKeys[i2]}`;
    key[index++] = style[prop];
  }
  index = addFillStyleKey(style._fill, key, index);
  index = addStokeStyleKey(style._stroke, key, index);
  index = addDropShadowKey(style.dropShadow, key, index);
  return key.join("-");
}
function addFillStyleKey(fillStyle, key, index) {
  if (!fillStyle)
    return index;
  key[index++] = fillStyle.color;
  key[index++] = fillStyle.alpha;
  key[index++] = fillStyle.fill?.styleKey;
  return index;
}
function addStokeStyleKey(strokeStyle, key, index) {
  if (!strokeStyle)
    return index;
  index = addFillStyleKey(strokeStyle, key, index);
  key[index++] = strokeStyle.width;
  key[index++] = strokeStyle.alignment;
  key[index++] = strokeStyle.cap;
  key[index++] = strokeStyle.join;
  key[index++] = strokeStyle.miterLimit;
  return index;
}
function addDropShadowKey(dropShadow, key, index) {
  if (!dropShadow)
    return index;
  key[index++] = dropShadow.alpha;
  key[index++] = dropShadow.angle;
  key[index++] = dropShadow.blur;
  key[index++] = dropShadow.distance;
  key[index++] = Color.shared.setValue(dropShadow.color).toNumber();
  return index;
}
const _TextStyle = class _TextStyle2 extends EventEmitter {
  constructor(style = {}) {
    super();
    convertV7Tov8Style(style);
    const fullStyle = { ..._TextStyle2.defaultTextStyle, ...style };
    for (const key in fullStyle) {
      const thisKey = key;
      this[thisKey] = fullStyle[key];
    }
    this.update();
  }
  /**
   * Alignment for multiline text, does not affect single line text.
   * @member {'left'|'center'|'right'|'justify'}
   */
  get align() {
    return this._align;
  }
  set align(value) {
    this._align = value;
    this.update();
  }
  /** Indicates if lines can be wrapped within words, it needs wordWrap to be set to true. */
  get breakWords() {
    return this._breakWords;
  }
  set breakWords(value) {
    this._breakWords = value;
    this.update();
  }
  /** Set a drop shadow for the text. */
  get dropShadow() {
    return this._dropShadow;
  }
  set dropShadow(value) {
    if (value !== null && typeof value === "object") {
      this._dropShadow = this._createProxy({ ..._TextStyle2.defaultDropShadow, ...value });
    } else {
      this._dropShadow = value ? this._createProxy({ ..._TextStyle2.defaultDropShadow }) : null;
    }
    this.update();
  }
  /** The font family, can be a single font name, or a list of names where the first is the preferred font. */
  get fontFamily() {
    return this._fontFamily;
  }
  set fontFamily(value) {
    this._fontFamily = value;
    this.update();
  }
  /** The font size (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em') */
  get fontSize() {
    return this._fontSize;
  }
  set fontSize(value) {
    if (typeof value === "string") {
      this._fontSize = parseInt(value, 10);
    } else {
      this._fontSize = value;
    }
    this.update();
  }
  /**
   * The font style.
   * @member {'normal'|'italic'|'oblique'}
   */
  get fontStyle() {
    return this._fontStyle;
  }
  set fontStyle(value) {
    this._fontStyle = value.toLowerCase();
    this.update();
  }
  /**
   * The font variant.
   * @member {'normal'|'small-caps'}
   */
  get fontVariant() {
    return this._fontVariant;
  }
  set fontVariant(value) {
    this._fontVariant = value;
    this.update();
  }
  /**
   * The font weight.
   * @member {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */
  get fontWeight() {
    return this._fontWeight;
  }
  set fontWeight(value) {
    this._fontWeight = value;
    this.update();
  }
  /** The space between lines. */
  get leading() {
    return this._leading;
  }
  set leading(value) {
    this._leading = value;
    this.update();
  }
  /** The amount of spacing between letters, default is 0. */
  get letterSpacing() {
    return this._letterSpacing;
  }
  set letterSpacing(value) {
    this._letterSpacing = value;
    this.update();
  }
  /** The line height, a number that represents the vertical space that a letter uses. */
  get lineHeight() {
    return this._lineHeight;
  }
  set lineHeight(value) {
    this._lineHeight = value;
    this.update();
  }
  /**
   * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
   * by adding padding to all sides of the text.
   */
  get padding() {
    return this._padding;
  }
  set padding(value) {
    this._padding = value;
    this.update();
  }
  /** Trim transparent borders. This is an expensive operation so only use this if you have to! */
  get trim() {
    return this._trim;
  }
  set trim(value) {
    this._trim = value;
    this.update();
  }
  /**
   * The baseline of the text that is rendered.
   * @member {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */
  get textBaseline() {
    return this._textBaseline;
  }
  set textBaseline(value) {
    this._textBaseline = value;
    this.update();
  }
  /**
   * How newlines and spaces should be handled.
   * Default is 'pre' (preserve, preserve).
   *
   *  value       | New lines     |   Spaces
   *  ---         | ---           |   ---
   * 'normal'     | Collapse      |   Collapse
   * 'pre'        | Preserve      |   Preserve
   * 'pre-line'   | Preserve      |   Collapse
   * @member {'normal'|'pre'|'pre-line'}
   */
  get whiteSpace() {
    return this._whiteSpace;
  }
  set whiteSpace(value) {
    this._whiteSpace = value;
    this.update();
  }
  /** Indicates if word wrap should be used. */
  get wordWrap() {
    return this._wordWrap;
  }
  set wordWrap(value) {
    this._wordWrap = value;
    this.update();
  }
  /** The width at which text will wrap, it needs wordWrap to be set to true. */
  get wordWrapWidth() {
    return this._wordWrapWidth;
  }
  set wordWrapWidth(value) {
    this._wordWrapWidth = value;
    this.update();
  }
  /** A fillstyle that will be used on the text e.g., 'red', '#00FF00'. */
  get fill() {
    return this._originalFill;
  }
  set fill(value) {
    if (value === this._originalFill)
      return;
    this._originalFill = value;
    if (this._isFillStyle(value)) {
      this._originalFill = this._createProxy({ ...GraphicsContext.defaultFillStyle, ...value }, () => {
        this._fill = toFillStyle(
          { ...this._originalFill },
          GraphicsContext.defaultFillStyle
        );
      });
    }
    this._fill = toFillStyle(
      value === 0 ? "black" : value,
      GraphicsContext.defaultFillStyle
    );
    this.update();
  }
  /** A fillstyle that will be used on the text stroke, e.g., 'blue', '#FCFF00'. */
  get stroke() {
    return this._originalStroke;
  }
  set stroke(value) {
    if (value === this._originalStroke)
      return;
    this._originalStroke = value;
    if (this._isFillStyle(value)) {
      this._originalStroke = this._createProxy({ ...GraphicsContext.defaultStrokeStyle, ...value }, () => {
        this._stroke = toStrokeStyle(
          { ...this._originalStroke },
          GraphicsContext.defaultStrokeStyle
        );
      });
    }
    this._stroke = toStrokeStyle(value, GraphicsContext.defaultStrokeStyle);
    this.update();
  }
  _generateKey() {
    this._styleKey = generateTextStyleKey(this);
    return this._styleKey;
  }
  update() {
    this._styleKey = null;
    this.emit("update", this);
  }
  /** Resets all properties to the default values */
  reset() {
    const defaultStyle = _TextStyle2.defaultTextStyle;
    for (const key in defaultStyle) {
      this[key] = defaultStyle[key];
    }
  }
  get styleKey() {
    return this._styleKey || this._generateKey();
  }
  /**
   * Creates a new TextStyle object with the same values as this one.
   * @returns New cloned TextStyle object
   */
  clone() {
    return new _TextStyle2({
      align: this.align,
      breakWords: this.breakWords,
      dropShadow: this._dropShadow ? { ...this._dropShadow } : null,
      fill: this._fill,
      fontFamily: this.fontFamily,
      fontSize: this.fontSize,
      fontStyle: this.fontStyle,
      fontVariant: this.fontVariant,
      fontWeight: this.fontWeight,
      leading: this.leading,
      letterSpacing: this.letterSpacing,
      lineHeight: this.lineHeight,
      padding: this.padding,
      stroke: this._stroke,
      textBaseline: this.textBaseline,
      whiteSpace: this.whiteSpace,
      wordWrap: this.wordWrap,
      wordWrapWidth: this.wordWrapWidth
    });
  }
  /**
   * Destroys this text style.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the texture of the this style
   * @param {boolean} [options.textureSource=false] - Should it destroy the textureSource of the this style
   */
  destroy(options = false) {
    this.removeAllListeners();
    const destroyTexture = typeof options === "boolean" ? options : options?.texture;
    if (destroyTexture) {
      const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
      if (this._fill?.texture) {
        this._fill.texture.destroy(destroyTextureSource);
      }
      if (this._originalFill?.texture) {
        this._originalFill.texture.destroy(destroyTextureSource);
      }
      if (this._stroke?.texture) {
        this._stroke.texture.destroy(destroyTextureSource);
      }
      if (this._originalStroke?.texture) {
        this._originalStroke.texture.destroy(destroyTextureSource);
      }
    }
    this._fill = null;
    this._stroke = null;
    this.dropShadow = null;
    this._originalStroke = null;
    this._originalFill = null;
  }
  _createProxy(value, cb) {
    return new Proxy(value, {
      set: (target, property, newValue) => {
        target[property] = newValue;
        cb?.(property, newValue);
        this.update();
        return true;
      }
    });
  }
  _isFillStyle(value) {
    return (value ?? null) !== null && !(Color.isColorLike(value) || value instanceof FillGradient || value instanceof FillPattern);
  }
};
_TextStyle.defaultDropShadow = {
  /** Set alpha for the drop shadow */
  alpha: 1,
  /** Set a angle of the drop shadow */
  angle: Math.PI / 6,
  /** Set a shadow blur radius */
  blur: 0,
  /** A fill style to be used on the  e.g., 'red', '#00FF00' */
  color: "black",
  /** Set a distance of the drop shadow */
  distance: 5
};
_TextStyle.defaultTextStyle = {
  /**
   * See {@link TextStyle.align}
   * @type {'left'|'center'|'right'|'justify'}
   */
  align: "left",
  /** See {@link TextStyle.breakWords} */
  breakWords: false,
  /** See {@link TextStyle.dropShadow} */
  dropShadow: null,
  /**
   * See {@link TextStyle.fill}
   * @type {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
   */
  fill: "black",
  /**
   * See {@link TextStyle.fontFamily}
   * @type {string|string[]}
   */
  fontFamily: "Arial",
  /**
   * See {@link TextStyle.fontSize}
   * @type {number|string}
   */
  fontSize: 26,
  /**
   * See {@link TextStyle.fontStyle}
   * @type {'normal'|'italic'|'oblique'}
   */
  fontStyle: "normal",
  /**
   * See {@link TextStyle.fontVariant}
   * @type {'normal'|'small-caps'}
   */
  fontVariant: "normal",
  /**
   * See {@link TextStyle.fontWeight}
   * @type {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */
  fontWeight: "normal",
  /** See {@link TextStyle.leading} */
  leading: 0,
  /** See {@link TextStyle.letterSpacing} */
  letterSpacing: 0,
  /** See {@link TextStyle.lineHeight} */
  lineHeight: 0,
  /** See {@link TextStyle.padding} */
  padding: 0,
  /**
   * See {@link TextStyle.stroke}
   * @type {string|number}
   */
  stroke: null,
  /**
   * See {@link TextStyle.textBaseline}
   * @type {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */
  textBaseline: "alphabetic",
  /** See {@link TextStyle.trim} */
  trim: false,
  /**
   * See {@link TextStyle.whiteSpace}
   * @type {'normal'|'pre'|'pre-line'}
   */
  whiteSpace: "pre",
  /** See {@link TextStyle.wordWrap} */
  wordWrap: false,
  /** See {@link TextStyle.wordWrapWidth} */
  wordWrapWidth: 100
};
let TextStyle = _TextStyle;
function convertV7Tov8Style(style) {
  const oldStyle = style;
  if (typeof oldStyle.dropShadow === "boolean" && oldStyle.dropShadow) {
    const defaults = TextStyle.defaultDropShadow;
    style.dropShadow = {
      alpha: oldStyle.dropShadowAlpha ?? defaults.alpha,
      angle: oldStyle.dropShadowAngle ?? defaults.angle,
      blur: oldStyle.dropShadowBlur ?? defaults.blur,
      color: oldStyle.dropShadowColor ?? defaults.color,
      distance: oldStyle.dropShadowDistance ?? defaults.distance
    };
  }
  if (oldStyle.strokeThickness !== void 0) {
    deprecation(v8_0_0, "strokeThickness is now a part of stroke");
    const color = oldStyle.stroke;
    let obj = {};
    if (Color.isColorLike(color)) {
      obj.color = color;
    } else if (color instanceof FillGradient || color instanceof FillPattern) {
      obj.fill = color;
    } else if (Object.hasOwnProperty.call(color, "color") || Object.hasOwnProperty.call(color, "fill")) {
      obj = color;
    } else {
      throw new Error("Invalid stroke value.");
    }
    style.stroke = {
      ...obj,
      width: oldStyle.strokeThickness
    };
  }
  if (Array.isArray(oldStyle.fillGradientStops)) {
    deprecation(v8_0_0, "gradient fill is now a fill pattern: `new FillGradient(...)`");
    let fontSize;
    if (style.fontSize == null) {
      style.fontSize = TextStyle.defaultTextStyle.fontSize;
    } else if (typeof style.fontSize === "string") {
      fontSize = parseInt(style.fontSize, 10);
    } else {
      fontSize = style.fontSize;
    }
    const gradientFill = new FillGradient(0, 0, 0, fontSize * 1.7);
    const fills = oldStyle.fillGradientStops.map((color) => Color.shared.setValue(color).toNumber());
    fills.forEach((number2, index) => {
      const ratio = index / (fills.length - 1);
      gradientFill.addColorStop(ratio, number2);
    });
    style.fill = {
      fill: gradientFill
    };
  }
}
class CanvasPoolClass {
  constructor(canvasOptions) {
    this._canvasPool = /* @__PURE__ */ Object.create(null);
    this.canvasOptions = canvasOptions || {};
    this.enableFullScreen = false;
  }
  /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */
  _createCanvasAndContext(pixelWidth, pixelHeight) {
    const canvas = DOMAdapter.get().createCanvas();
    canvas.width = pixelWidth;
    canvas.height = pixelHeight;
    const context2 = canvas.getContext("2d");
    return { canvas, context: context2 };
  }
  /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */
  getOptimalCanvasAndContext(minWidth, minHeight, resolution = 1) {
    minWidth = Math.ceil(minWidth * resolution - 1e-6);
    minHeight = Math.ceil(minHeight * resolution - 1e-6);
    minWidth = nextPow2(minWidth);
    minHeight = nextPow2(minHeight);
    const key = (minWidth << 17) + (minHeight << 1);
    if (!this._canvasPool[key]) {
      this._canvasPool[key] = [];
    }
    let canvasAndContext = this._canvasPool[key].pop();
    if (!canvasAndContext) {
      canvasAndContext = this._createCanvasAndContext(minWidth, minHeight);
    }
    return canvasAndContext;
  }
  /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */
  returnCanvasAndContext(canvasAndContext) {
    const canvas = canvasAndContext.canvas;
    const { width, height } = canvas;
    const key = (width << 17) + (height << 1);
    canvasAndContext.context.clearRect(0, 0, width, height);
    this._canvasPool[key].push(canvasAndContext);
  }
  clear() {
    this._canvasPool = {};
  }
}
const CanvasPool = new CanvasPoolClass();
const genericFontFamilies = [
  "serif",
  "sans-serif",
  "monospace",
  "cursive",
  "fantasy",
  "system-ui"
];
function fontStringFromTextStyle(style) {
  const fontSizeString = typeof style.fontSize === "number" ? `${style.fontSize}px` : style.fontSize;
  let fontFamilies = style.fontFamily;
  if (!Array.isArray(style.fontFamily)) {
    fontFamilies = style.fontFamily.split(",");
  }
  for (let i2 = fontFamilies.length - 1; i2 >= 0; i2--) {
    let fontFamily = fontFamilies[i2].trim();
    if (!/([\"\'])[^\'\"]+\1/.test(fontFamily) && !genericFontFamilies.includes(fontFamily)) {
      fontFamily = `"${fontFamily}"`;
    }
    fontFamilies[i2] = fontFamily;
  }
  return `${style.fontStyle} ${style.fontVariant} ${style.fontWeight} ${fontSizeString} ${fontFamilies.join(",")}`;
}
const contextSettings = {
  // TextMetrics requires getImageData readback for measuring fonts.
  willReadFrequently: true
};
const _CanvasTextMetrics = class _CanvasTextMetrics2 {
  /**
   * Checking that we can use modern canvas 2D API.
   *
   * Note: This is an unstable API, Chrome < 94 use `textLetterSpacing`, later versions use `letterSpacing`.
   * @see TextMetrics.experimentalLetterSpacing
   * @see https://developer.mozilla.org/en-US/docs/Web/API/ICanvasRenderingContext2D/letterSpacing
   * @see https://developer.chrome.com/origintrials/#/view_trial/3585991203293757441
   */
  static get experimentalLetterSpacingSupported() {
    let result = _CanvasTextMetrics2._experimentalLetterSpacingSupported;
    if (result !== void 0) {
      const proto = DOMAdapter.get().getCanvasRenderingContext2D().prototype;
      result = _CanvasTextMetrics2._experimentalLetterSpacingSupported = "letterSpacing" in proto || "textLetterSpacing" in proto;
    }
    return result;
  }
  /**
   * @param text - the text that was measured
   * @param style - the style that was measured
   * @param width - the measured width of the text
   * @param height - the measured height of the text
   * @param lines - an array of the lines of text broken by new lines and wrapping if specified in style
   * @param lineWidths - an array of the line widths for each line matched to `lines`
   * @param lineHeight - the measured line height for this style
   * @param maxLineWidth - the maximum line width for all measured lines
   * @param {FontMetrics} fontProperties - the font properties object from TextMetrics.measureFont
   */
  constructor(text, style, width, height, lines, lineWidths, lineHeight, maxLineWidth, fontProperties) {
    this.text = text;
    this.style = style;
    this.width = width;
    this.height = height;
    this.lines = lines;
    this.lineWidths = lineWidths;
    this.lineHeight = lineHeight;
    this.maxLineWidth = maxLineWidth;
    this.fontProperties = fontProperties;
  }
  /**
   * Measures the supplied string of text and returns a Rectangle.
   * @param text - The text to measure.
   * @param style - The text style to use for measuring
   * @param canvas - optional specification of the canvas to use for measuring.
   * @param wordWrap
   * @returns Measured width and height of the text.
   */
  static measureText(text = " ", style, canvas = _CanvasTextMetrics2._canvas, wordWrap = style.wordWrap) {
    const textKey = `${text}:${style.styleKey}`;
    if (_CanvasTextMetrics2._measurementCache[textKey])
      return _CanvasTextMetrics2._measurementCache[textKey];
    const font = fontStringFromTextStyle(style);
    const fontProperties = _CanvasTextMetrics2.measureFont(font);
    if (fontProperties.fontSize === 0) {
      fontProperties.fontSize = style.fontSize;
      fontProperties.ascent = style.fontSize;
    }
    const context2 = _CanvasTextMetrics2.__context;
    context2.font = font;
    const outputText = wordWrap ? _CanvasTextMetrics2._wordWrap(text, style, canvas) : text;
    const lines = outputText.split(/(?:\r\n|\r|\n)/);
    const lineWidths = new Array(lines.length);
    let maxLineWidth = 0;
    for (let i2 = 0; i2 < lines.length; i2++) {
      const lineWidth = _CanvasTextMetrics2._measureText(lines[i2], style.letterSpacing, context2);
      lineWidths[i2] = lineWidth;
      maxLineWidth = Math.max(maxLineWidth, lineWidth);
    }
    const strokeWidth = style._stroke?.width || 0;
    let width = maxLineWidth + strokeWidth;
    if (style.dropShadow) {
      width += style.dropShadow.distance;
    }
    const lineHeight = style.lineHeight || fontProperties.fontSize;
    let height = Math.max(lineHeight, fontProperties.fontSize + strokeWidth) + (lines.length - 1) * (lineHeight + style.leading);
    if (style.dropShadow) {
      height += style.dropShadow.distance;
    }
    const measurements = new _CanvasTextMetrics2(
      text,
      style,
      width,
      height,
      lines,
      lineWidths,
      lineHeight + style.leading,
      maxLineWidth,
      fontProperties
    );
    return measurements;
  }
  static _measureText(text, letterSpacing, context2) {
    let useExperimentalLetterSpacing = false;
    if (_CanvasTextMetrics2.experimentalLetterSpacingSupported) {
      if (_CanvasTextMetrics2.experimentalLetterSpacing) {
        context2.letterSpacing = `${letterSpacing}px`;
        context2.textLetterSpacing = `${letterSpacing}px`;
        useExperimentalLetterSpacing = true;
      } else {
        context2.letterSpacing = "0px";
        context2.textLetterSpacing = "0px";
      }
    }
    const metrics = context2.measureText(text);
    let metricWidth = metrics.width;
    const actualBoundingBoxLeft = -metrics.actualBoundingBoxLeft;
    const actualBoundingBoxRight = metrics.actualBoundingBoxRight;
    let boundsWidth = actualBoundingBoxRight - actualBoundingBoxLeft;
    if (metricWidth > 0) {
      if (useExperimentalLetterSpacing) {
        metricWidth -= letterSpacing;
        boundsWidth -= letterSpacing;
      } else {
        const val = (_CanvasTextMetrics2.graphemeSegmenter(text).length - 1) * letterSpacing;
        metricWidth += val;
        boundsWidth += val;
      }
    }
    return Math.max(metricWidth, boundsWidth);
  }
  /**
   * Applies newlines to a string to have it optimally fit into the horizontal
   * bounds set by the Text object's wordWrapWidth property.
   * @param text - String to apply word wrapping to
   * @param style - the style to use when wrapping
   * @param canvas - optional specification of the canvas to use for measuring.
   * @returns New string with new lines applied where required
   */
  static _wordWrap(text, style, canvas = _CanvasTextMetrics2._canvas) {
    const context2 = canvas.getContext("2d", contextSettings);
    let width = 0;
    let line = "";
    let lines = "";
    const cache = /* @__PURE__ */ Object.create(null);
    const { letterSpacing, whiteSpace } = style;
    const collapseSpaces = _CanvasTextMetrics2._collapseSpaces(whiteSpace);
    const collapseNewlines = _CanvasTextMetrics2._collapseNewlines(whiteSpace);
    let canPrependSpaces = !collapseSpaces;
    const wordWrapWidth = style.wordWrapWidth + letterSpacing;
    const tokens = _CanvasTextMetrics2._tokenize(text);
    for (let i2 = 0; i2 < tokens.length; i2++) {
      let token = tokens[i2];
      if (_CanvasTextMetrics2._isNewline(token)) {
        if (!collapseNewlines) {
          lines += _CanvasTextMetrics2._addLine(line);
          canPrependSpaces = !collapseSpaces;
          line = "";
          width = 0;
          continue;
        }
        token = " ";
      }
      if (collapseSpaces) {
        const currIsBreakingSpace = _CanvasTextMetrics2.isBreakingSpace(token);
        const lastIsBreakingSpace = _CanvasTextMetrics2.isBreakingSpace(line[line.length - 1]);
        if (currIsBreakingSpace && lastIsBreakingSpace) {
          continue;
        }
      }
      const tokenWidth = _CanvasTextMetrics2._getFromCache(token, letterSpacing, cache, context2);
      if (tokenWidth > wordWrapWidth) {
        if (line !== "") {
          lines += _CanvasTextMetrics2._addLine(line);
          line = "";
          width = 0;
        }
        if (_CanvasTextMetrics2.canBreakWords(token, style.breakWords)) {
          const characters = _CanvasTextMetrics2.wordWrapSplit(token);
          for (let j2 = 0; j2 < characters.length; j2++) {
            let char = characters[j2];
            let lastChar = char;
            let k2 = 1;
            while (characters[j2 + k2]) {
              const nextChar = characters[j2 + k2];
              if (!_CanvasTextMetrics2.canBreakChars(lastChar, nextChar, token, j2, style.breakWords)) {
                char += nextChar;
              } else {
                break;
              }
              lastChar = nextChar;
              k2++;
            }
            j2 += k2 - 1;
            const characterWidth = _CanvasTextMetrics2._getFromCache(char, letterSpacing, cache, context2);
            if (characterWidth + width > wordWrapWidth) {
              lines += _CanvasTextMetrics2._addLine(line);
              canPrependSpaces = false;
              line = "";
              width = 0;
            }
            line += char;
            width += characterWidth;
          }
        } else {
          if (line.length > 0) {
            lines += _CanvasTextMetrics2._addLine(line);
            line = "";
            width = 0;
          }
          const isLastToken = i2 === tokens.length - 1;
          lines += _CanvasTextMetrics2._addLine(token, !isLastToken);
          canPrependSpaces = false;
          line = "";
          width = 0;
        }
      } else {
        if (tokenWidth + width > wordWrapWidth) {
          canPrependSpaces = false;
          lines += _CanvasTextMetrics2._addLine(line);
          line = "";
          width = 0;
        }
        if (line.length > 0 || !_CanvasTextMetrics2.isBreakingSpace(token) || canPrependSpaces) {
          line += token;
          width += tokenWidth;
        }
      }
    }
    lines += _CanvasTextMetrics2._addLine(line, false);
    return lines;
  }
  /**
   * Convenience function for logging each line added during the wordWrap method.
   * @param line    - The line of text to add
   * @param newLine - Add new line character to end
   * @returns A formatted line
   */
  static _addLine(line, newLine = true) {
    line = _CanvasTextMetrics2._trimRight(line);
    line = newLine ? `${line}
` : line;
    return line;
  }
  /**
   * Gets & sets the widths of calculated characters in a cache object
   * @param key            - The key
   * @param letterSpacing  - The letter spacing
   * @param cache          - The cache
   * @param context        - The canvas context
   * @returns The from cache.
   */
  static _getFromCache(key, letterSpacing, cache, context2) {
    let width = cache[key];
    if (typeof width !== "number") {
      width = _CanvasTextMetrics2._measureText(key, letterSpacing, context2) + letterSpacing;
      cache[key] = width;
    }
    return width;
  }
  /**
   * Determines whether we should collapse breaking spaces.
   * @param whiteSpace - The TextStyle property whiteSpace
   * @returns Should collapse
   */
  static _collapseSpaces(whiteSpace) {
    return whiteSpace === "normal" || whiteSpace === "pre-line";
  }
  /**
   * Determines whether we should collapse newLine chars.
   * @param whiteSpace - The white space
   * @returns should collapse
   */
  static _collapseNewlines(whiteSpace) {
    return whiteSpace === "normal";
  }
  /**
   * Trims breaking whitespaces from string.
   * @param text - The text
   * @returns Trimmed string
   */
  static _trimRight(text) {
    if (typeof text !== "string") {
      return "";
    }
    for (let i2 = text.length - 1; i2 >= 0; i2--) {
      const char = text[i2];
      if (!_CanvasTextMetrics2.isBreakingSpace(char)) {
        break;
      }
      text = text.slice(0, -1);
    }
    return text;
  }
  /**
   * Determines if char is a newline.
   * @param char - The character
   * @returns True if newline, False otherwise.
   */
  static _isNewline(char) {
    if (typeof char !== "string") {
      return false;
    }
    return _CanvasTextMetrics2._newlines.includes(char.charCodeAt(0));
  }
  /**
   * Determines if char is a breaking whitespace.
   *
   * It allows one to determine whether char should be a breaking whitespace
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param char - The character
   * @param [_nextChar] - The next character
   * @returns True if whitespace, False otherwise.
   */
  static isBreakingSpace(char, _nextChar) {
    if (typeof char !== "string") {
      return false;
    }
    return _CanvasTextMetrics2._breakingSpaces.includes(char.charCodeAt(0));
  }
  /**
   * Splits a string into words, breaking-spaces and newLine characters
   * @param text - The text
   * @returns A tokenized array
   */
  static _tokenize(text) {
    const tokens = [];
    let token = "";
    if (typeof text !== "string") {
      return tokens;
    }
    for (let i2 = 0; i2 < text.length; i2++) {
      const char = text[i2];
      const nextChar = text[i2 + 1];
      if (_CanvasTextMetrics2.isBreakingSpace(char, nextChar) || _CanvasTextMetrics2._isNewline(char)) {
        if (token !== "") {
          tokens.push(token);
          token = "";
        }
        tokens.push(char);
        continue;
      }
      token += char;
    }
    if (token !== "") {
      tokens.push(token);
    }
    return tokens;
  }
  /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to customise which words should break
   * Examples are if the token is CJK or numbers.
   * It must return a boolean.
   * @param _token - The token
   * @param breakWords - The style attr break words
   * @returns Whether to break word or not
   */
  static canBreakWords(_token, breakWords) {
    return breakWords;
  }
  /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to determine whether a pair of characters
   * should be broken by newlines
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param _char - The character
   * @param _nextChar - The next character
   * @param _token - The token/word the characters are from
   * @param _index - The index in the token of the char
   * @param _breakWords - The style attr break words
   * @returns whether to break word or not
   */
  static canBreakChars(_char, _nextChar, _token, _index, _breakWords) {
    return true;
  }
  /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It is called when a token (usually a word) has to be split into separate pieces
   * in order to determine the point to break a word.
   * It must return an array of characters.
   * @param token - The token to split
   * @returns The characters of the token
   * @see CanvasTextMetrics.graphemeSegmenter
   */
  static wordWrapSplit(token) {
    return _CanvasTextMetrics2.graphemeSegmenter(token);
  }
  /**
   * Calculates the ascent, descent and fontSize of a given font-style
   * @param font - String representing the style of the font
   * @returns Font properties object
   */
  static measureFont(font) {
    if (_CanvasTextMetrics2._fonts[font]) {
      return _CanvasTextMetrics2._fonts[font];
    }
    const context2 = _CanvasTextMetrics2._context;
    context2.font = font;
    const metrics = context2.measureText(_CanvasTextMetrics2.METRICS_STRING + _CanvasTextMetrics2.BASELINE_SYMBOL);
    const properties = {
      ascent: metrics.actualBoundingBoxAscent,
      descent: metrics.actualBoundingBoxDescent,
      fontSize: metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent
    };
    _CanvasTextMetrics2._fonts[font] = properties;
    return properties;
  }
  /**
   * Clear font metrics in metrics cache.
   * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
   */
  static clearMetrics(font = "") {
    if (font) {
      delete _CanvasTextMetrics2._fonts[font];
    } else {
      _CanvasTextMetrics2._fonts = {};
    }
  }
  /**
   * Cached canvas element for measuring text
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */
  static get _canvas() {
    if (!_CanvasTextMetrics2.__canvas) {
      let canvas;
      try {
        const c2 = new OffscreenCanvas(0, 0);
        const context2 = c2.getContext("2d", contextSettings);
        if (context2?.measureText) {
          _CanvasTextMetrics2.__canvas = c2;
          return c2;
        }
        canvas = DOMAdapter.get().createCanvas();
      } catch (_cx) {
        canvas = DOMAdapter.get().createCanvas();
      }
      canvas.width = canvas.height = 10;
      _CanvasTextMetrics2.__canvas = canvas;
    }
    return _CanvasTextMetrics2.__canvas;
  }
  /**
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */
  static get _context() {
    if (!_CanvasTextMetrics2.__context) {
      _CanvasTextMetrics2.__context = _CanvasTextMetrics2._canvas.getContext("2d", contextSettings);
    }
    return _CanvasTextMetrics2.__context;
  }
};
_CanvasTextMetrics.METRICS_STRING = "|ÉqÅ";
_CanvasTextMetrics.BASELINE_SYMBOL = "M";
_CanvasTextMetrics.BASELINE_MULTIPLIER = 1.4;
_CanvasTextMetrics.HEIGHT_MULTIPLIER = 2;
_CanvasTextMetrics.graphemeSegmenter = (() => {
  if (typeof Intl?.Segmenter === "function") {
    const segmenter = new Intl.Segmenter();
    return (s2) => [...segmenter.segment(s2)].map((x2) => x2.segment);
  }
  return (s2) => [...s2];
})();
_CanvasTextMetrics.experimentalLetterSpacing = false;
_CanvasTextMetrics._fonts = {};
_CanvasTextMetrics._newlines = [
  10,
  // line feed
  13
  // carriage return
];
_CanvasTextMetrics._breakingSpaces = [
  9,
  // character tabulation
  32,
  // space
  8192,
  // en quad
  8193,
  // em quad
  8194,
  // en space
  8195,
  // em space
  8196,
  // three-per-em space
  8197,
  // four-per-em space
  8198,
  // six-per-em space
  8200,
  // punctuation space
  8201,
  // thin space
  8202,
  // hair space
  8287,
  // medium mathematical space
  12288
  // ideographic space
];
_CanvasTextMetrics._measurementCache = {};
let CanvasTextMetrics = _CanvasTextMetrics;
function getCanvasFillStyle(fillStyle, context2) {
  if (fillStyle.texture === Texture.WHITE && !fillStyle.fill) {
    return Color.shared.setValue(fillStyle.color).setAlpha(fillStyle.alpha ?? 1).toHexa();
  } else if (!fillStyle.fill) {
    const pattern = context2.createPattern(fillStyle.texture.source.resource, "repeat");
    const tempMatrix2 = fillStyle.matrix.copyTo(Matrix.shared);
    tempMatrix2.scale(fillStyle.texture.frame.width, fillStyle.texture.frame.height);
    pattern.setTransform(tempMatrix2);
    return pattern;
  } else if (fillStyle.fill instanceof FillPattern) {
    const fillPattern = fillStyle.fill;
    const pattern = context2.createPattern(fillPattern.texture.source.resource, "repeat");
    const tempMatrix2 = fillPattern.transform.copyTo(Matrix.shared);
    tempMatrix2.scale(
      fillPattern.texture.frame.width,
      fillPattern.texture.frame.height
    );
    pattern.setTransform(tempMatrix2);
    return pattern;
  } else if (fillStyle.fill instanceof FillGradient) {
    const fillGradient = fillStyle.fill;
    if (fillGradient.type === "linear") {
      const gradient = context2.createLinearGradient(
        fillGradient.x0,
        fillGradient.y0,
        fillGradient.x1,
        fillGradient.y1
      );
      fillGradient.gradientStops.forEach((stop) => {
        gradient.addColorStop(stop.offset, Color.shared.setValue(stop.color).toHex());
      });
      return gradient;
    }
  }
  warn("FillStyle not recognised", fillStyle);
  return "red";
}
function resolveCharacters(chars) {
  if (chars === "") {
    return [];
  }
  if (typeof chars === "string") {
    chars = [chars];
  }
  const result = [];
  for (let i2 = 0, j2 = chars.length; i2 < j2; i2++) {
    const item = chars[i2];
    if (Array.isArray(item)) {
      if (item.length !== 2) {
        throw new Error(`[BitmapFont]: Invalid character range length, expecting 2 got ${item.length}.`);
      }
      if (item[0].length === 0 || item[1].length === 0) {
        throw new Error("[BitmapFont]: Invalid character delimiter.");
      }
      const startCode = item[0].charCodeAt(0);
      const endCode = item[1].charCodeAt(0);
      if (endCode < startCode) {
        throw new Error("[BitmapFont]: Invalid character range.");
      }
      for (let i22 = startCode, j22 = endCode; i22 <= j22; i22++) {
        result.push(String.fromCharCode(i22));
      }
    } else {
      result.push(...Array.from(item));
    }
  }
  if (result.length === 0) {
    throw new Error("[BitmapFont]: Empty set when resolving characters.");
  }
  return result;
}
const _DynamicBitmapFont = class _DynamicBitmapFont2 extends AbstractBitmapFont {
  /**
   * @param options - The options for the dynamic bitmap font.
   */
  constructor(options) {
    super();
    this.resolution = 1;
    this.pages = [];
    this._padding = 0;
    this._measureCache = /* @__PURE__ */ Object.create(null);
    this._currentChars = [];
    this._currentX = 0;
    this._currentY = 0;
    this._currentPageIndex = -1;
    this._skipKerning = false;
    const dynamicOptions = { ..._DynamicBitmapFont2.defaultOptions, ...options };
    this._textureSize = dynamicOptions.textureSize;
    this._mipmap = dynamicOptions.mipmap;
    const style = dynamicOptions.style.clone();
    if (dynamicOptions.overrideFill) {
      style._fill.color = 16777215;
      style._fill.alpha = 1;
      style._fill.texture = Texture.WHITE;
      style._fill.fill = null;
    }
    this.applyFillAsTint = dynamicOptions.overrideFill;
    const requestedFontSize = style.fontSize;
    style.fontSize = this.baseMeasurementFontSize;
    const font = fontStringFromTextStyle(style);
    if (dynamicOptions.overrideSize) {
      if (style._stroke) {
        style._stroke.width *= this.baseRenderedFontSize / requestedFontSize;
      }
    } else {
      style.fontSize = this.baseRenderedFontSize = requestedFontSize;
    }
    this._style = style;
    this._skipKerning = dynamicOptions.skipKerning ?? false;
    this.resolution = dynamicOptions.resolution ?? 1;
    this._padding = dynamicOptions.padding ?? 4;
    this.fontMetrics = CanvasTextMetrics.measureFont(font);
    this.lineHeight = style.lineHeight || this.fontMetrics.fontSize || style.fontSize;
  }
  ensureCharacters(chars) {
    const charList = resolveCharacters(chars).filter((char) => !this._currentChars.includes(char)).filter((char, index, self2) => self2.indexOf(char) === index);
    if (!charList.length)
      return;
    this._currentChars = [...this._currentChars, ...charList];
    let pageData;
    if (this._currentPageIndex === -1) {
      pageData = this._nextPage();
    } else {
      pageData = this.pages[this._currentPageIndex];
    }
    let { canvas, context: context2 } = pageData.canvasAndContext;
    let textureSource = pageData.texture.source;
    const style = this._style;
    let currentX = this._currentX;
    let currentY = this._currentY;
    const fontScale = this.baseRenderedFontSize / this.baseMeasurementFontSize;
    const padding = this._padding * fontScale;
    let maxCharHeight = 0;
    let skipTexture = false;
    const maxTextureWidth = canvas.width / this.resolution;
    const maxTextureHeight = canvas.height / this.resolution;
    for (let i2 = 0; i2 < charList.length; i2++) {
      const char = charList[i2];
      const metrics = CanvasTextMetrics.measureText(char, style, canvas, false);
      metrics.lineHeight = metrics.height;
      const width = metrics.width * fontScale;
      const textureGlyphWidth = Math.ceil((style.fontStyle === "italic" ? 2 : 1) * width);
      const height = metrics.height * fontScale;
      const paddedWidth = textureGlyphWidth + padding * 2;
      const paddedHeight = height + padding * 2;
      skipTexture = false;
      if (char !== "\n" && char !== "\r" && char !== "	" && char !== " ") {
        skipTexture = true;
        maxCharHeight = Math.ceil(Math.max(paddedHeight, maxCharHeight));
      }
      if (currentX + paddedWidth > maxTextureWidth) {
        currentY += maxCharHeight;
        maxCharHeight = paddedHeight;
        currentX = 0;
        if (currentY + maxCharHeight > maxTextureHeight) {
          textureSource.update();
          const pageData2 = this._nextPage();
          canvas = pageData2.canvasAndContext.canvas;
          context2 = pageData2.canvasAndContext.context;
          textureSource = pageData2.texture.source;
          currentY = 0;
        }
      }
      const xAdvance = width / fontScale - (style.dropShadow?.distance ?? 0) - (style._stroke?.width ?? 0);
      this.chars[char] = {
        id: char.codePointAt(0),
        xOffset: -this._padding,
        yOffset: -this._padding,
        xAdvance,
        kerning: {}
      };
      if (skipTexture) {
        this._drawGlyph(
          context2,
          metrics,
          currentX + padding,
          currentY + padding,
          fontScale,
          style
        );
        const px = textureSource.width * fontScale;
        const py = textureSource.height * fontScale;
        const frame = new Rectangle(
          currentX / px * textureSource.width,
          currentY / py * textureSource.height,
          paddedWidth / px * textureSource.width,
          paddedHeight / py * textureSource.height
        );
        this.chars[char].texture = new Texture({
          source: textureSource,
          frame
        });
        currentX += Math.ceil(paddedWidth);
      }
    }
    textureSource.update();
    this._currentX = currentX;
    this._currentY = currentY;
    this._skipKerning && this._applyKerning(charList, context2);
  }
  /**
   * @deprecated since 8.0.0
   * The map of base page textures (i.e., sheets of glyphs).
   */
  get pageTextures() {
    deprecation(v8_0_0, "BitmapFont.pageTextures is deprecated, please use BitmapFont.pages instead.");
    return this.pages;
  }
  _applyKerning(newChars, context2) {
    const measureCache = this._measureCache;
    for (let i2 = 0; i2 < newChars.length; i2++) {
      const first = newChars[i2];
      for (let j2 = 0; j2 < this._currentChars.length; j2++) {
        const second = this._currentChars[j2];
        let c1 = measureCache[first];
        if (!c1)
          c1 = measureCache[first] = context2.measureText(first).width;
        let c2 = measureCache[second];
        if (!c2)
          c2 = measureCache[second] = context2.measureText(second).width;
        let total = context2.measureText(first + second).width;
        let amount = total - (c1 + c2);
        if (amount) {
          this.chars[first].kerning[second] = amount;
        }
        total = context2.measureText(first + second).width;
        amount = total - (c1 + c2);
        if (amount) {
          this.chars[second].kerning[first] = amount;
        }
      }
    }
  }
  _nextPage() {
    this._currentPageIndex++;
    const textureResolution = this.resolution;
    const canvasAndContext = CanvasPool.getOptimalCanvasAndContext(
      this._textureSize,
      this._textureSize,
      textureResolution
    );
    this._setupContext(canvasAndContext.context, this._style, textureResolution);
    const resolution = textureResolution * (this.baseRenderedFontSize / this.baseMeasurementFontSize);
    const texture = new Texture({
      source: new ImageSource({
        resource: canvasAndContext.canvas,
        resolution,
        alphaMode: "premultiply-alpha-on-upload",
        autoGenerateMipmaps: this._mipmap
      })
    });
    const pageData = {
      canvasAndContext,
      texture
    };
    this.pages[this._currentPageIndex] = pageData;
    return pageData;
  }
  // canvas style!
  _setupContext(context2, style, resolution) {
    style.fontSize = this.baseRenderedFontSize;
    context2.scale(resolution, resolution);
    context2.font = fontStringFromTextStyle(style);
    style.fontSize = this.baseMeasurementFontSize;
    context2.textBaseline = style.textBaseline;
    const stroke = style._stroke;
    const strokeThickness = stroke?.width ?? 0;
    if (stroke) {
      context2.lineWidth = strokeThickness;
      context2.lineJoin = stroke.join;
      context2.miterLimit = stroke.miterLimit;
      context2.strokeStyle = getCanvasFillStyle(stroke, context2);
    }
    if (style._fill) {
      context2.fillStyle = getCanvasFillStyle(style._fill, context2);
    }
    if (style.dropShadow) {
      const shadowOptions = style.dropShadow;
      const rgb = Color.shared.setValue(shadowOptions.color).toArray();
      const dropShadowBlur = shadowOptions.blur * resolution;
      const dropShadowDistance = shadowOptions.distance * resolution;
      context2.shadowColor = `rgba(${rgb[0] * 255},${rgb[1] * 255},${rgb[2] * 255},${shadowOptions.alpha})`;
      context2.shadowBlur = dropShadowBlur;
      context2.shadowOffsetX = Math.cos(shadowOptions.angle) * dropShadowDistance;
      context2.shadowOffsetY = Math.sin(shadowOptions.angle) * dropShadowDistance;
    } else {
      context2.shadowColor = "black";
      context2.shadowBlur = 0;
      context2.shadowOffsetX = 0;
      context2.shadowOffsetY = 0;
    }
  }
  _drawGlyph(context2, metrics, x2, y2, fontScale, style) {
    const char = metrics.text;
    const fontProperties = metrics.fontProperties;
    const stroke = style._stroke;
    const strokeThickness = (stroke?.width ?? 0) * fontScale;
    const tx = x2 + strokeThickness / 2;
    const ty = y2 - strokeThickness / 2;
    const descent = fontProperties.descent * fontScale;
    const lineHeight = metrics.lineHeight * fontScale;
    if (style.stroke && strokeThickness) {
      context2.strokeText(char, tx, ty + lineHeight - descent);
    }
    if (style._fill) {
      context2.fillText(char, tx, ty + lineHeight - descent);
    }
  }
  destroy() {
    super.destroy();
    for (let i2 = 0; i2 < this.pages.length; i2++) {
      const { canvasAndContext, texture } = this.pages[i2];
      CanvasPool.returnCanvasAndContext(canvasAndContext);
      texture.destroy(true);
    }
    this.pages = null;
  }
};
_DynamicBitmapFont.defaultOptions = {
  textureSize: 512,
  style: new TextStyle(),
  mipmap: true
};
let DynamicBitmapFont = _DynamicBitmapFont;
function getBitmapTextLayout(chars, style, font, trimEnd) {
  const layoutData = {
    width: 0,
    height: 0,
    offsetY: 0,
    scale: style.fontSize / font.baseMeasurementFontSize,
    lines: [{
      width: 0,
      charPositions: [],
      spaceWidth: 0,
      spacesIndex: [],
      chars: []
    }]
  };
  layoutData.offsetY = font.baseLineOffset;
  let currentLine = layoutData.lines[0];
  let previousChar = null;
  let firstWord = true;
  const currentWord = {
    spaceWord: false,
    width: 0,
    start: 0,
    index: 0,
    // use index to not modify the array as we use it a lot!
    positions: [],
    chars: []
  };
  const nextWord = (word) => {
    const start = currentLine.width;
    for (let j2 = 0; j2 < currentWord.index; j2++) {
      const position = word.positions[j2];
      currentLine.chars.push(word.chars[j2]);
      currentLine.charPositions.push(position + start);
    }
    currentLine.width += word.width;
    firstWord = false;
    currentWord.width = 0;
    currentWord.index = 0;
    currentWord.chars.length = 0;
  };
  const nextLine = () => {
    let index = currentLine.chars.length - 1;
    if (trimEnd) {
      let lastChar = currentLine.chars[index];
      while (lastChar === " ") {
        currentLine.width -= font.chars[lastChar].xAdvance;
        lastChar = currentLine.chars[--index];
      }
    }
    layoutData.width = Math.max(layoutData.width, currentLine.width);
    currentLine = {
      width: 0,
      charPositions: [],
      chars: [],
      spaceWidth: 0,
      spacesIndex: []
    };
    firstWord = true;
    layoutData.lines.push(currentLine);
    layoutData.height += font.lineHeight;
  };
  const scale = font.baseMeasurementFontSize / style.fontSize;
  const adjustedLetterSpacing = style.letterSpacing * scale;
  const adjustedWordWrapWidth = style.wordWrapWidth * scale;
  for (let i2 = 0; i2 < chars.length + 1; i2++) {
    let char;
    const isEnd = i2 === chars.length;
    if (!isEnd) {
      char = chars[i2];
    }
    const charData = font.chars[char] || font.chars[" "];
    const isSpace = /(?:\s)/.test(char);
    const isWordBreak = isSpace || char === "\r" || char === "\n" || isEnd;
    if (isWordBreak) {
      const addWordToNextLine = !firstWord && style.wordWrap && currentLine.width + currentWord.width - adjustedLetterSpacing > adjustedWordWrapWidth;
      if (addWordToNextLine) {
        nextLine();
        nextWord(currentWord);
        if (!isEnd) {
          currentLine.charPositions.push(0);
        }
      } else {
        currentWord.start = currentLine.width;
        nextWord(currentWord);
        if (!isEnd) {
          currentLine.charPositions.push(0);
        }
      }
      if (char === "\r" || char === "\n") {
        if (currentLine.width !== 0) {
          nextLine();
        }
      } else if (!isEnd) {
        const spaceWidth = charData.xAdvance + (charData.kerning[previousChar] || 0) + adjustedLetterSpacing;
        currentLine.width += spaceWidth;
        currentLine.spaceWidth = spaceWidth;
        currentLine.spacesIndex.push(currentLine.charPositions.length);
        currentLine.chars.push(char);
      }
    } else {
      const kerning = charData.kerning[previousChar] || 0;
      const nextCharWidth = charData.xAdvance + kerning + adjustedLetterSpacing;
      currentWord.positions[currentWord.index++] = currentWord.width + kerning;
      currentWord.chars.push(char);
      currentWord.width += nextCharWidth;
    }
    previousChar = char;
  }
  nextLine();
  if (style.align === "center") {
    alignCenter(layoutData);
  } else if (style.align === "right") {
    alignRight(layoutData);
  } else if (style.align === "justify") {
    alignJustify(layoutData);
  }
  return layoutData;
}
function alignCenter(measurementData) {
  for (let i2 = 0; i2 < measurementData.lines.length; i2++) {
    const line = measurementData.lines[i2];
    const offset = measurementData.width / 2 - line.width / 2;
    for (let j2 = 0; j2 < line.charPositions.length; j2++) {
      line.charPositions[j2] += offset;
    }
  }
}
function alignRight(measurementData) {
  for (let i2 = 0; i2 < measurementData.lines.length; i2++) {
    const line = measurementData.lines[i2];
    const offset = measurementData.width - line.width;
    for (let j2 = 0; j2 < line.charPositions.length; j2++) {
      line.charPositions[j2] += offset;
    }
  }
}
function alignJustify(measurementData) {
  const width = measurementData.width;
  for (let i2 = 0; i2 < measurementData.lines.length; i2++) {
    const line = measurementData.lines[i2];
    let indy = 0;
    let spaceIndex = line.spacesIndex[indy++];
    let offset = 0;
    const totalSpaces = line.spacesIndex.length;
    const newSpaceWidth = (width - line.width) / totalSpaces;
    const spaceWidth = newSpaceWidth;
    for (let j2 = 0; j2 < line.charPositions.length; j2++) {
      if (j2 === spaceIndex) {
        spaceIndex = line.spacesIndex[indy++];
        offset += spaceWidth;
      }
      line.charPositions[j2] += offset;
    }
  }
}
let fontCount = 0;
class BitmapFontManagerClass {
  constructor() {
    this.ALPHA = [["a", "z"], ["A", "Z"], " "];
    this.NUMERIC = [["0", "9"]];
    this.ALPHANUMERIC = [["a", "z"], ["A", "Z"], ["0", "9"], " "];
    this.ASCII = [[" ", "~"]];
    this.defaultOptions = {
      chars: this.ALPHANUMERIC,
      resolution: 1,
      padding: 4,
      skipKerning: false
    };
  }
  /**
   * Get a font for the specified text and style.
   * @param text - The text to get the font for
   * @param style - The style to use
   */
  getFont(text, style) {
    let fontFamilyKey = `${style.fontFamily}-bitmap`;
    let overrideFill = true;
    if (style._fill.fill && !style._stroke) {
      fontFamilyKey += style._fill.fill.styleKey;
      overrideFill = false;
    } else if (style._stroke || style.dropShadow) {
      let key = style.styleKey;
      key = key.substring(0, key.lastIndexOf("-"));
      fontFamilyKey = `${key}-bitmap`;
      overrideFill = false;
    }
    if (!Cache.has(fontFamilyKey)) {
      const fnt = new DynamicBitmapFont({
        style,
        overrideFill,
        overrideSize: true,
        ...this.defaultOptions
      });
      fontCount++;
      if (fontCount > 50) {
        warn("BitmapText", `You have dynamically created ${fontCount} bitmap fonts, this can be inefficient. Try pre installing your font styles using \`BitmapFont.install({name:"style1", style})\``);
      }
      fnt.once("destroy", () => {
        fontCount--;
        Cache.remove(fontFamilyKey);
      });
      Cache.set(
        fontFamilyKey,
        fnt
      );
    }
    const dynamicFont = Cache.get(fontFamilyKey);
    dynamicFont.ensureCharacters?.(text);
    return dynamicFont;
  }
  /**
   * Get the layout of a text for the specified style.
   * @param text - The text to get the layout for
   * @param style - The style to use
   * @param trimEnd - Whether to ignore whitespaces at the end of each line
   */
  getLayout(text, style, trimEnd = true) {
    const bitmapFont = this.getFont(text, style);
    return getBitmapTextLayout([...text], style, bitmapFont, trimEnd);
  }
  /**
   * Measure the text using the specified style.
   * @param text - The text to measure
   * @param style - The style to use
   * @param trimEnd - Whether to ignore whitespaces at the end of each line
   */
  measureText(text, style, trimEnd = true) {
    return this.getLayout(text, style, trimEnd);
  }
  // eslint-disable-next-line max-len
  install(...args) {
    let options = args[0];
    if (typeof options === "string") {
      options = {
        name: options,
        style: args[1],
        chars: args[2]?.chars,
        resolution: args[2]?.resolution,
        padding: args[2]?.padding,
        skipKerning: args[2]?.skipKerning
      };
      deprecation(v8_0_0, "BitmapFontManager.install(name, style, options) is deprecated, use BitmapFontManager.install({name, style, ...options})");
    }
    const name = options?.name;
    if (!name) {
      throw new Error("[BitmapFontManager] Property `name` is required.");
    }
    options = { ...this.defaultOptions, ...options };
    const textStyle = options.style;
    const style = textStyle instanceof TextStyle ? textStyle : new TextStyle(textStyle);
    const overrideFill = style._fill.fill !== null && style._fill.fill !== void 0;
    const font = new DynamicBitmapFont({
      style,
      overrideFill,
      skipKerning: options.skipKerning,
      padding: options.padding,
      resolution: options.resolution,
      overrideSize: false
    });
    const flatChars = resolveCharacters(options.chars);
    font.ensureCharacters(flatChars.join(""));
    Cache.set(`${name}-bitmap`, font);
    font.once("destroy", () => Cache.remove(`${name}-bitmap`));
    return font;
  }
  /**
   * Uninstalls a bitmap font from the cache.
   * @param {string} name - The name of the bitmap font to uninstall.
   */
  uninstall(name) {
    const cacheKey = `${name}-bitmap`;
    const font = Cache.get(cacheKey);
    if (font) {
      font.destroy();
    }
  }
}
const BitmapFontManager = new BitmapFontManagerClass();
class BitmapFont extends AbstractBitmapFont {
  constructor(options, url) {
    super();
    const { textures, data } = options;
    Object.keys(data.pages).forEach((key) => {
      const pageData = data.pages[parseInt(key, 10)];
      const texture = textures[pageData.id];
      this.pages.push({ texture });
    });
    Object.keys(data.chars).forEach((key) => {
      const charData = data.chars[key];
      const {
        frame: textureFrame,
        source: textureSource
      } = textures[charData.page];
      const frameReal = new Rectangle(
        charData.x + textureFrame.x,
        charData.y + textureFrame.y,
        charData.width,
        charData.height
      );
      const texture = new Texture({
        source: textureSource,
        frame: frameReal
      });
      this.chars[key] = {
        id: key.codePointAt(0),
        xOffset: charData.xOffset,
        yOffset: charData.yOffset,
        xAdvance: charData.xAdvance,
        kerning: charData.kerning ?? {},
        texture
      };
    });
    this.baseRenderedFontSize = data.fontSize;
    this.baseMeasurementFontSize = data.fontSize;
    this.fontMetrics = {
      ascent: 0,
      descent: 0,
      fontSize: data.fontSize
    };
    this.baseLineOffset = data.baseLineOffset;
    this.lineHeight = data.lineHeight;
    this.fontFamily = data.fontFamily;
    this.distanceField = data.distanceField ?? {
      type: "none",
      range: 0
    };
    this.url = url;
  }
  /** Destroys the BitmapFont object. */
  destroy() {
    super.destroy();
    for (let i2 = 0; i2 < this.pages.length; i2++) {
      const { texture } = this.pages[i2];
      texture.destroy(true);
    }
    this.pages = null;
  }
  /**
   * Generates a bitmap-font for the given style and character set
   * @param options - Setup options for font generation.
   * @returns Font generated by style options.
   * @example
   * import { BitmapFont, BitmapText } from 'pixi.js';
   *
   * BitmapFont.install('TitleFont', {
   *     fontFamily: 'Arial',
   *     fontSize: 12,
   *     strokeThickness: 2,
   *     fill: 'purple',
   * });
   *
   * const title = new BitmapText({ text: 'This is the title', fontFamily: 'TitleFont' });
   */
  static install(options) {
    BitmapFontManager.install(options);
  }
  /**
   * Uninstalls a bitmap font from the cache.
   * @param {string} name - The name of the bitmap font to uninstall.
   */
  static uninstall(name) {
    BitmapFontManager.uninstall(name);
  }
}
const bitmapFontTextParser = {
  test(data) {
    return typeof data === "string" && data.startsWith("info face=");
  },
  parse(txt) {
    const items = txt.match(/^[a-z]+\s+.+$/gm);
    const rawData = {
      info: [],
      common: [],
      page: [],
      char: [],
      chars: [],
      kerning: [],
      kernings: [],
      distanceField: []
    };
    for (const i2 in items) {
      const name = items[i2].match(/^[a-z]+/gm)[0];
      const attributeList = items[i2].match(/[a-zA-Z]+=([^\s"']+|"([^"]*)")/gm);
      const itemData = {};
      for (const i22 in attributeList) {
        const split = attributeList[i22].split("=");
        const key = split[0];
        const strValue = split[1].replace(/"/gm, "");
        const floatValue = parseFloat(strValue);
        const value = isNaN(floatValue) ? strValue : floatValue;
        itemData[key] = value;
      }
      rawData[name].push(itemData);
    }
    const font = {
      chars: {},
      pages: [],
      lineHeight: 0,
      fontSize: 0,
      fontFamily: "",
      distanceField: null,
      baseLineOffset: 0
    };
    const [info] = rawData.info;
    const [common] = rawData.common;
    const [distanceField] = rawData.distanceField ?? [];
    if (distanceField) {
      font.distanceField = {
        range: parseInt(distanceField.distanceRange, 10),
        type: distanceField.fieldType
      };
    }
    font.fontSize = parseInt(info.size, 10);
    font.fontFamily = info.face;
    font.lineHeight = parseInt(common.lineHeight, 10);
    const page = rawData.page;
    for (let i2 = 0; i2 < page.length; i2++) {
      font.pages.push({
        id: parseInt(page[i2].id, 10) || 0,
        file: page[i2].file
      });
    }
    const map = {};
    font.baseLineOffset = font.lineHeight - parseInt(common.base, 10);
    const char = rawData.char;
    for (let i2 = 0; i2 < char.length; i2++) {
      const charNode = char[i2];
      const id = parseInt(charNode.id, 10);
      let letter = charNode.letter ?? charNode.char ?? String.fromCharCode(id);
      if (letter === "space")
        letter = " ";
      map[id] = letter;
      font.chars[letter] = {
        id,
        // texture deets..
        page: parseInt(charNode.page, 10) || 0,
        x: parseInt(charNode.x, 10),
        y: parseInt(charNode.y, 10),
        width: parseInt(charNode.width, 10),
        height: parseInt(charNode.height, 10),
        xOffset: parseInt(charNode.xoffset, 10),
        yOffset: parseInt(charNode.yoffset, 10),
        xAdvance: parseInt(charNode.xadvance, 10),
        kerning: {}
      };
    }
    const kerning = rawData.kerning || [];
    for (let i2 = 0; i2 < kerning.length; i2++) {
      const first = parseInt(kerning[i2].first, 10);
      const second = parseInt(kerning[i2].second, 10);
      const amount = parseInt(kerning[i2].amount, 10);
      font.chars[map[second]].kerning[map[first]] = amount;
    }
    return font;
  }
};
const bitmapFontXMLParser = {
  test(data) {
    const xml = data;
    return typeof xml !== "string" && "getElementsByTagName" in xml && xml.getElementsByTagName("page").length && xml.getElementsByTagName("info")[0].getAttribute("face") !== null;
  },
  parse(xml) {
    const data = {
      chars: {},
      pages: [],
      lineHeight: 0,
      fontSize: 0,
      fontFamily: "",
      distanceField: null,
      baseLineOffset: 0
    };
    const info = xml.getElementsByTagName("info")[0];
    const common = xml.getElementsByTagName("common")[0];
    const distanceField = xml.getElementsByTagName("distanceField")[0];
    if (distanceField) {
      data.distanceField = {
        type: distanceField.getAttribute("fieldType"),
        range: parseInt(distanceField.getAttribute("distanceRange"), 10)
      };
    }
    const page = xml.getElementsByTagName("page");
    const char = xml.getElementsByTagName("char");
    const kerning = xml.getElementsByTagName("kerning");
    data.fontSize = parseInt(info.getAttribute("size"), 10);
    data.fontFamily = info.getAttribute("face");
    data.lineHeight = parseInt(common.getAttribute("lineHeight"), 10);
    for (let i2 = 0; i2 < page.length; i2++) {
      data.pages.push({
        id: parseInt(page[i2].getAttribute("id"), 10) || 0,
        file: page[i2].getAttribute("file")
      });
    }
    const map = {};
    data.baseLineOffset = data.lineHeight - parseInt(common.getAttribute("base"), 10);
    for (let i2 = 0; i2 < char.length; i2++) {
      const charNode = char[i2];
      const id = parseInt(charNode.getAttribute("id"), 10);
      let letter = charNode.getAttribute("letter") ?? charNode.getAttribute("char") ?? String.fromCharCode(id);
      if (letter === "space")
        letter = " ";
      map[id] = letter;
      data.chars[letter] = {
        id,
        // texture deets..
        page: parseInt(charNode.getAttribute("page"), 10) || 0,
        x: parseInt(charNode.getAttribute("x"), 10),
        y: parseInt(charNode.getAttribute("y"), 10),
        width: parseInt(charNode.getAttribute("width"), 10),
        height: parseInt(charNode.getAttribute("height"), 10),
        // render deets..
        xOffset: parseInt(charNode.getAttribute("xoffset"), 10),
        yOffset: parseInt(charNode.getAttribute("yoffset"), 10),
        // + baseLineOffset,
        xAdvance: parseInt(charNode.getAttribute("xadvance"), 10),
        kerning: {}
      };
    }
    for (let i2 = 0; i2 < kerning.length; i2++) {
      const first = parseInt(kerning[i2].getAttribute("first"), 10);
      const second = parseInt(kerning[i2].getAttribute("second"), 10);
      const amount = parseInt(kerning[i2].getAttribute("amount"), 10);
      data.chars[map[second]].kerning[map[first]] = amount;
    }
    return data;
  }
};
const bitmapFontXMLStringParser = {
  test(data) {
    if (typeof data === "string" && data.includes("<font>")) {
      return bitmapFontXMLParser.test(DOMAdapter.get().parseXML(data));
    }
    return false;
  },
  parse(data) {
    return bitmapFontXMLParser.parse(DOMAdapter.get().parseXML(data));
  }
};
const validExtensions = [".xml", ".fnt"];
const bitmapFontCachePlugin = {
  extension: {
    type: ExtensionType.CacheParser,
    name: "cacheBitmapFont"
  },
  test: (asset) => asset instanceof BitmapFont,
  getCacheableAssets(keys, asset) {
    const out2 = {};
    keys.forEach((key) => {
      out2[key] = asset;
      out2[`${key}-bitmap`] = asset;
    });
    out2[`${asset.fontFamily}-bitmap`] = asset;
    return out2;
  }
};
const loadBitmapFont = {
  extension: {
    type: ExtensionType.LoadParser,
    priority: LoaderParserPriority.Normal
  },
  name: "loadBitmapFont",
  test(url) {
    return validExtensions.includes(path.extname(url).toLowerCase());
  },
  async testParse(data) {
    return bitmapFontTextParser.test(data) || bitmapFontXMLStringParser.test(data);
  },
  async parse(asset, data, loader) {
    const bitmapFontData = bitmapFontTextParser.test(asset) ? bitmapFontTextParser.parse(asset) : bitmapFontXMLStringParser.parse(asset);
    const { src } = data;
    const { pages } = bitmapFontData;
    const textureUrls = [];
    const textureOptions = bitmapFontData.distanceField ? {
      scaleMode: "linear",
      alphaMode: "premultiply-alpha-on-upload",
      autoGenerateMipmaps: false,
      resolution: 1
    } : {};
    for (let i2 = 0; i2 < pages.length; ++i2) {
      const pageFile = pages[i2].file;
      let imagePath = path.join(path.dirname(src), pageFile);
      imagePath = copySearchParams(imagePath, src);
      textureUrls.push({
        src: imagePath,
        data: textureOptions
      });
    }
    const loadedTextures = await loader.load(textureUrls);
    const textures = textureUrls.map((url) => loadedTextures[url.src]);
    const bitmapFont = new BitmapFont({
      data: bitmapFontData,
      textures
    }, src);
    return bitmapFont;
  },
  async load(url, _options) {
    const response = await DOMAdapter.get().fetch(url);
    return await response.text();
  },
  async unload(bitmapFont, _resolvedAsset, loader) {
    await Promise.all(bitmapFont.pages.map((page) => loader.unload(page.texture.source._sourceOrigin)));
    bitmapFont.destroy();
  }
};
class BackgroundLoader {
  /**
   * @param loader
   * @param verbose - should the loader log to the console
   */
  constructor(loader, verbose = false) {
    this._loader = loader;
    this._assetList = [];
    this._isLoading = false;
    this._maxConcurrent = 1;
    this.verbose = verbose;
  }
  /**
   * Adds an array of assets to load.
   * @param assetUrls - assets to load
   */
  add(assetUrls) {
    assetUrls.forEach((a2) => {
      this._assetList.push(a2);
    });
    if (this.verbose) {
      console.log("[BackgroundLoader] assets: ", this._assetList);
    }
    if (this._isActive && !this._isLoading) {
      void this._next();
    }
  }
  /**
   * Loads the next set of assets. Will try to load as many assets as it can at the same time.
   *
   * The max assets it will try to load at one time will be 4.
   */
  async _next() {
    if (this._assetList.length && this._isActive) {
      this._isLoading = true;
      const toLoad = [];
      const toLoadAmount = Math.min(this._assetList.length, this._maxConcurrent);
      for (let i2 = 0; i2 < toLoadAmount; i2++) {
        toLoad.push(this._assetList.pop());
      }
      await this._loader.load(toLoad);
      this._isLoading = false;
      void this._next();
    }
  }
  /**
   * Activate/Deactivate the loading. If set to true then it will immediately continue to load the next asset.
   * @returns whether the class is active
   */
  get active() {
    return this._isActive;
  }
  set active(value) {
    if (this._isActive === value)
      return;
    this._isActive = value;
    if (value && !this._isLoading) {
      void this._next();
    }
  }
}
const cacheTextureArray = {
  extension: {
    type: ExtensionType.CacheParser,
    name: "cacheTextureArray"
  },
  test: (asset) => Array.isArray(asset) && asset.every((t2) => t2 instanceof Texture),
  getCacheableAssets: (keys, asset) => {
    const out2 = {};
    keys.forEach((key) => {
      asset.forEach((item, i2) => {
        out2[key + (i2 === 0 ? "" : i2 + 1)] = item;
      });
    });
    return out2;
  }
};
async function testImageFormat(imageData) {
  if ("Image" in globalThis) {
    return new Promise((resolve) => {
      const image = new Image();
      image.onload = () => {
        resolve(true);
      };
      image.onerror = () => {
        resolve(false);
      };
      image.src = imageData;
    });
  }
  if ("createImageBitmap" in globalThis && "fetch" in globalThis) {
    try {
      const blob = await (await fetch(imageData)).blob();
      await createImageBitmap(blob);
    } catch (_e) {
      return false;
    }
    return true;
  }
  return false;
}
const detectAvif = {
  extension: {
    type: ExtensionType.DetectionParser,
    priority: 1
  },
  test: async () => testImageFormat(
    // eslint-disable-next-line max-len
    "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A="
  ),
  add: async (formats) => [...formats, "avif"],
  remove: async (formats) => formats.filter((f2) => f2 !== "avif")
};
const imageFormats = ["png", "jpg", "jpeg"];
const detectDefaults = {
  extension: {
    type: ExtensionType.DetectionParser,
    priority: -1
  },
  test: () => Promise.resolve(true),
  add: async (formats) => [...formats, ...imageFormats],
  remove: async (formats) => formats.filter((f2) => !imageFormats.includes(f2))
};
const inWorker = "WorkerGlobalScope" in globalThis && globalThis instanceof globalThis.WorkerGlobalScope;
function testVideoFormat(mimeType) {
  if (inWorker) {
    return false;
  }
  const video = document.createElement("video");
  return video.canPlayType(mimeType) !== "";
}
const detectMp4 = {
  extension: {
    type: ExtensionType.DetectionParser,
    priority: 0
  },
  test: async () => testVideoFormat("video/mp4"),
  add: async (formats) => [...formats, "mp4", "m4v"],
  remove: async (formats) => formats.filter((f2) => f2 !== "mp4" && f2 !== "m4v")
};
const detectOgv = {
  extension: {
    type: ExtensionType.DetectionParser,
    priority: 0
  },
  test: async () => testVideoFormat("video/ogg"),
  add: async (formats) => [...formats, "ogv"],
  remove: async (formats) => formats.filter((f2) => f2 !== "ogv")
};
const detectWebm = {
  extension: {
    type: ExtensionType.DetectionParser,
    priority: 0
  },
  test: async () => testVideoFormat("video/webm"),
  add: async (formats) => [...formats, "webm"],
  remove: async (formats) => formats.filter((f2) => f2 !== "webm")
};
const detectWebp = {
  extension: {
    type: ExtensionType.DetectionParser,
    priority: 0
  },
  test: async () => testImageFormat(
    "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA="
  ),
  add: async (formats) => [...formats, "webp"],
  remove: async (formats) => formats.filter((f2) => f2 !== "webp")
};
class Loader {
  constructor() {
    this._parsers = [];
    this._parsersValidated = false;
    this.parsers = new Proxy(this._parsers, {
      set: (target, key, value) => {
        this._parsersValidated = false;
        target[key] = value;
        return true;
      }
    });
    this.promiseCache = {};
  }
  /** function used for testing */
  reset() {
    this._parsersValidated = false;
    this.promiseCache = {};
  }
  /**
   * Used internally to generate a promise for the asset to be loaded.
   * @param url - The URL to be loaded
   * @param data - any custom additional information relevant to the asset being loaded
   * @returns - a promise that will resolve to an Asset for example a Texture of a JSON object
   */
  _getLoadPromiseAndParser(url, data) {
    const result = {
      promise: null,
      parser: null
    };
    result.promise = (async () => {
      let asset = null;
      let parser = null;
      if (data.loadParser) {
        parser = this._parserHash[data.loadParser];
        if (!parser) {
          warn(`[Assets] specified load parser "${data.loadParser}" not found while loading ${url}`);
        }
      }
      if (!parser) {
        for (let i2 = 0; i2 < this.parsers.length; i2++) {
          const parserX = this.parsers[i2];
          if (parserX.load && parserX.test?.(url, data, this)) {
            parser = parserX;
            break;
          }
        }
        if (!parser) {
          warn(`[Assets] ${url} could not be loaded as we don't know how to parse it, ensure the correct parser has been added`);
          return null;
        }
      }
      asset = await parser.load(url, data, this);
      result.parser = parser;
      for (let i2 = 0; i2 < this.parsers.length; i2++) {
        const parser2 = this.parsers[i2];
        if (parser2.parse) {
          if (parser2.parse && await parser2.testParse?.(asset, data, this)) {
            asset = await parser2.parse(asset, data, this) || asset;
            result.parser = parser2;
          }
        }
      }
      return asset;
    })();
    return result;
  }
  async load(assetsToLoadIn, onProgress) {
    if (!this._parsersValidated) {
      this._validateParsers();
    }
    let count2 = 0;
    const assets = {};
    const singleAsset = isSingleItem(assetsToLoadIn);
    const assetsToLoad = convertToList(assetsToLoadIn, (item) => ({
      alias: [item],
      src: item,
      data: {}
    }));
    const total = assetsToLoad.length;
    const promises = assetsToLoad.map(async (asset) => {
      const url = path.toAbsolute(asset.src);
      if (!assets[asset.src]) {
        try {
          if (!this.promiseCache[url]) {
            this.promiseCache[url] = this._getLoadPromiseAndParser(url, asset);
          }
          assets[asset.src] = await this.promiseCache[url].promise;
          if (onProgress)
            onProgress(++count2 / total);
        } catch (e2) {
          delete this.promiseCache[url];
          delete assets[asset.src];
          throw new Error(`[Loader.load] Failed to load ${url}.
${e2}`);
        }
      }
    });
    await Promise.all(promises);
    return singleAsset ? assets[assetsToLoad[0].src] : assets;
  }
  /**
   * Unloads one or more assets. Any unloaded assets will be destroyed, freeing up memory for your app.
   * The parser that created the asset, will be the one that unloads it.
   * @example
   * // Single asset:
   * const asset = await Loader.load('cool.png');
   *
   * await Loader.unload('cool.png');
   *
   * console.log(asset.destroyed); // true
   * @param assetsToUnloadIn - urls that you want to unload, or a single one!
   */
  async unload(assetsToUnloadIn) {
    const assetsToUnload = convertToList(assetsToUnloadIn, (item) => ({
      alias: [item],
      src: item
    }));
    const promises = assetsToUnload.map(async (asset) => {
      const url = path.toAbsolute(asset.src);
      const loadPromise = this.promiseCache[url];
      if (loadPromise) {
        const loadedAsset = await loadPromise.promise;
        delete this.promiseCache[url];
        await loadPromise.parser?.unload?.(loadedAsset, asset, this);
      }
    });
    await Promise.all(promises);
  }
  /** validates our parsers, right now it only checks for name conflicts but we can add more here as required! */
  _validateParsers() {
    this._parsersValidated = true;
    this._parserHash = this._parsers.filter((parser) => parser.name).reduce((hash, parser) => {
      if (!parser.name) {
        warn(`[Assets] loadParser should have a name`);
      } else if (hash[parser.name]) {
        warn(`[Assets] loadParser name conflict "${parser.name}"`);
      }
      return { ...hash, [parser.name]: parser };
    }, {});
  }
}
function checkDataUrl(url, mimes) {
  if (Array.isArray(mimes)) {
    for (const mime of mimes) {
      if (url.startsWith(`data:${mime}`))
        return true;
    }
    return false;
  }
  return url.startsWith(`data:${mimes}`);
}
function checkExtension(url, extension) {
  const tempURL = url.split("?")[0];
  const ext = path.extname(tempURL).toLowerCase();
  if (Array.isArray(extension)) {
    return extension.includes(ext);
  }
  return ext === extension;
}
const validJSONExtension = ".json";
const validJSONMIME = "application/json";
const loadJson = {
  extension: {
    type: ExtensionType.LoadParser,
    priority: LoaderParserPriority.Low
  },
  name: "loadJson",
  test(url) {
    return checkDataUrl(url, validJSONMIME) || checkExtension(url, validJSONExtension);
  },
  async load(url) {
    const response = await DOMAdapter.get().fetch(url);
    const json = await response.json();
    return json;
  }
};
const validTXTExtension = ".txt";
const validTXTMIME = "text/plain";
const loadTxt = {
  name: "loadTxt",
  extension: {
    type: ExtensionType.LoadParser,
    priority: LoaderParserPriority.Low,
    name: "loadTxt"
  },
  test(url) {
    return checkDataUrl(url, validTXTMIME) || checkExtension(url, validTXTExtension);
  },
  async load(url) {
    const response = await DOMAdapter.get().fetch(url);
    const txt = await response.text();
    return txt;
  }
};
const validWeights = [
  "normal",
  "bold",
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900"
];
const validFontExtensions = [".ttf", ".otf", ".woff", ".woff2"];
const validFontMIMEs = [
  "font/ttf",
  "font/otf",
  "font/woff",
  "font/woff2"
];
const CSS_IDENT_TOKEN_REGEX = /^(--|-?[A-Z_])[0-9A-Z_-]*$/i;
function getFontFamilyName(url) {
  const ext = path.extname(url);
  const name = path.basename(url, ext);
  const nameWithSpaces = name.replace(/(-|_)/g, " ");
  const nameTokens = nameWithSpaces.toLowerCase().split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1));
  let valid = nameTokens.length > 0;
  for (const token of nameTokens) {
    if (!token.match(CSS_IDENT_TOKEN_REGEX)) {
      valid = false;
      break;
    }
  }
  let fontFamilyName = nameTokens.join(" ");
  if (!valid) {
    fontFamilyName = `"${fontFamilyName.replace(/[\\"]/g, "\\$&")}"`;
  }
  return fontFamilyName;
}
const validURICharactersRegex = /^[0-9A-Za-z%:/?#\[\]@!\$&'()\*\+,;=\-._~]*$/;
function encodeURIWhenNeeded(uri) {
  if (validURICharactersRegex.test(uri)) {
    return uri;
  }
  return encodeURI(uri);
}
const loadWebFont = {
  extension: {
    type: ExtensionType.LoadParser,
    priority: LoaderParserPriority.Low
  },
  name: "loadWebFont",
  test(url) {
    return checkDataUrl(url, validFontMIMEs) || checkExtension(url, validFontExtensions);
  },
  async load(url, options) {
    const fonts = DOMAdapter.get().getFontFaceSet();
    if (fonts) {
      const fontFaces = [];
      const name = options.data?.family ?? getFontFamilyName(url);
      const weights = options.data?.weights?.filter((weight) => validWeights.includes(weight)) ?? ["normal"];
      const data = options.data ?? {};
      for (let i2 = 0; i2 < weights.length; i2++) {
        const weight = weights[i2];
        const font = new FontFace(name, `url(${encodeURIWhenNeeded(url)})`, {
          ...data,
          weight
        });
        await font.load();
        fonts.add(font);
        fontFaces.push(font);
      }
      Cache.set(`${name}-and-url`, {
        url,
        fontFaces
      });
      return fontFaces.length === 1 ? fontFaces[0] : fontFaces;
    }
    warn("[loadWebFont] FontFace API is not supported. Skipping loading font");
    return null;
  },
  unload(font) {
    (Array.isArray(font) ? font : [font]).forEach((t2) => {
      Cache.remove(`${t2.family}-and-url`);
      DOMAdapter.get().getFontFaceSet().delete(t2);
    });
  }
};
function getResolutionOfUrl(url, defaultValue = 1) {
  const resolution = Resolver.RETINA_PREFIX?.exec(url);
  if (resolution) {
    return parseFloat(resolution[1]);
  }
  return defaultValue;
}
function createTexture(source2, loader, url) {
  source2.label = url;
  source2._sourceOrigin = url;
  const texture = new Texture({
    source: source2,
    label: url
  });
  const unload = () => {
    delete loader.promiseCache[url];
    if (Cache.has(url)) {
      Cache.remove(url);
    }
  };
  texture.source.once("destroy", () => {
    if (loader.promiseCache[url]) {
      warn("[Assets] A TextureSource managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the TextureSource.");
      unload();
    }
  });
  texture.once("destroy", () => {
    if (!source2.destroyed) {
      warn("[Assets] A Texture managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the Texture.");
      unload();
    }
  });
  return texture;
}
const validSVGExtension = ".svg";
const validSVGMIME = "image/svg+xml";
const loadSvg = {
  extension: {
    type: ExtensionType.LoadParser,
    priority: LoaderParserPriority.Low,
    name: "loadSVG"
  },
  name: "loadSVG",
  config: {
    crossOrigin: "anonymous",
    parseAsGraphicsContext: false
  },
  test(url) {
    return checkDataUrl(url, validSVGMIME) || checkExtension(url, validSVGExtension);
  },
  async load(url, asset, loader) {
    if (asset.data?.parseAsGraphicsContext ?? this.config.parseAsGraphicsContext) {
      return loadAsGraphics(url);
    }
    return loadAsTexture(url, asset, loader, this.config.crossOrigin);
  },
  unload(asset) {
    asset.destroy(true);
  }
};
async function loadAsTexture(url, asset, loader, crossOrigin2) {
  const response = await DOMAdapter.get().fetch(url);
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const image = new Image();
  image.src = blobUrl;
  image.crossOrigin = crossOrigin2;
  await image.decode();
  URL.revokeObjectURL(blobUrl);
  const canvas = document.createElement("canvas");
  const context2 = canvas.getContext("2d");
  const resolution = asset.data?.resolution || getResolutionOfUrl(url);
  const width = asset.data?.width ?? image.width;
  const height = asset.data?.height ?? image.height;
  canvas.width = width * resolution;
  canvas.height = height * resolution;
  context2.drawImage(image, 0, 0, width * resolution, height * resolution);
  const { parseAsGraphicsContext: _p, ...rest } = asset.data ?? {};
  const base = new ImageSource({
    resource: canvas,
    alphaMode: "premultiply-alpha-on-upload",
    resolution,
    ...rest
  });
  return createTexture(base, loader, url);
}
async function loadAsGraphics(url) {
  const response = await DOMAdapter.get().fetch(url);
  const svgSource = await response.text();
  const context2 = new GraphicsContext();
  context2.svg(svgSource);
  return context2;
}
const WORKER_CODE$1 = `(function () {
    'use strict';

    const WHITE_PNG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=";
    async function checkImageBitmap() {
      try {
        if (typeof createImageBitmap !== "function")
          return false;
        const response = await fetch(WHITE_PNG);
        const imageBlob = await response.blob();
        const imageBitmap = await createImageBitmap(imageBlob);
        return imageBitmap.width === 1 && imageBitmap.height === 1;
      } catch (_e) {
        return false;
      }
    }
    void checkImageBitmap().then((result) => {
      self.postMessage(result);
    });

})();
`;
let WORKER_URL$1 = null;
let WorkerInstance$1 = class WorkerInstance {
  constructor() {
    if (!WORKER_URL$1) {
      WORKER_URL$1 = URL.createObjectURL(new Blob([WORKER_CODE$1], { type: "application/javascript" }));
    }
    this.worker = new Worker(WORKER_URL$1);
  }
};
WorkerInstance$1.revokeObjectURL = function revokeObjectURL() {
  if (WORKER_URL$1) {
    URL.revokeObjectURL(WORKER_URL$1);
    WORKER_URL$1 = null;
  }
};
const WORKER_CODE = '(function () {\n    \'use strict\';\n\n    async function loadImageBitmap(url, alphaMode) {\n      const response = await fetch(url);\n      if (!response.ok) {\n        throw new Error(`[WorkerManager.loadImageBitmap] Failed to fetch ${url}: ${response.status} ${response.statusText}`);\n      }\n      const imageBlob = await response.blob();\n      return alphaMode === "premultiplied-alpha" ? createImageBitmap(imageBlob, { premultiplyAlpha: "none" }) : createImageBitmap(imageBlob);\n    }\n    self.onmessage = async (event) => {\n      try {\n        const imageBitmap = await loadImageBitmap(event.data.data[0], event.data.data[1]);\n        self.postMessage({\n          data: imageBitmap,\n          uuid: event.data.uuid,\n          id: event.data.id\n        }, [imageBitmap]);\n      } catch (e) {\n        self.postMessage({\n          error: e,\n          uuid: event.data.uuid,\n          id: event.data.id\n        });\n      }\n    };\n\n})();\n';
let WORKER_URL = null;
class WorkerInstance2 {
  constructor() {
    if (!WORKER_URL) {
      WORKER_URL = URL.createObjectURL(new Blob([WORKER_CODE], { type: "application/javascript" }));
    }
    this.worker = new Worker(WORKER_URL);
  }
}
WorkerInstance2.revokeObjectURL = function revokeObjectURL2() {
  if (WORKER_URL) {
    URL.revokeObjectURL(WORKER_URL);
    WORKER_URL = null;
  }
};
let UUID = 0;
let MAX_WORKERS;
class WorkerManagerClass {
  constructor() {
    this._initialized = false;
    this._createdWorkers = 0;
    this._workerPool = [];
    this._queue = [];
    this._resolveHash = {};
  }
  isImageBitmapSupported() {
    if (this._isImageBitmapSupported !== void 0)
      return this._isImageBitmapSupported;
    this._isImageBitmapSupported = new Promise((resolve) => {
      const { worker } = new WorkerInstance$1();
      worker.addEventListener("message", (event) => {
        worker.terminate();
        WorkerInstance$1.revokeObjectURL();
        resolve(event.data);
      });
    });
    return this._isImageBitmapSupported;
  }
  loadImageBitmap(src, asset) {
    return this._run("loadImageBitmap", [src, asset?.data?.alphaMode]);
  }
  async _initWorkers() {
    if (this._initialized)
      return;
    this._initialized = true;
  }
  _getWorker() {
    if (MAX_WORKERS === void 0) {
      MAX_WORKERS = navigator.hardwareConcurrency || 4;
    }
    let worker = this._workerPool.pop();
    if (!worker && this._createdWorkers < MAX_WORKERS) {
      this._createdWorkers++;
      worker = new WorkerInstance2().worker;
      worker.addEventListener("message", (event) => {
        this._complete(event.data);
        this._returnWorker(event.target);
        this._next();
      });
    }
    return worker;
  }
  _returnWorker(worker) {
    this._workerPool.push(worker);
  }
  _complete(data) {
    if (data.error !== void 0) {
      this._resolveHash[data.uuid].reject(data.error);
    } else {
      this._resolveHash[data.uuid].resolve(data.data);
    }
    this._resolveHash[data.uuid] = null;
  }
  async _run(id, args) {
    await this._initWorkers();
    const promise2 = new Promise((resolve, reject) => {
      this._queue.push({ id, arguments: args, resolve, reject });
    });
    this._next();
    return promise2;
  }
  _next() {
    if (!this._queue.length)
      return;
    const worker = this._getWorker();
    if (!worker) {
      return;
    }
    const toDo = this._queue.pop();
    const id = toDo.id;
    this._resolveHash[UUID] = { resolve: toDo.resolve, reject: toDo.reject };
    worker.postMessage({
      data: toDo.arguments,
      uuid: UUID++,
      id
    });
  }
}
const WorkerManager = new WorkerManagerClass();
const validImageExtensions = [".jpeg", ".jpg", ".png", ".webp", ".avif"];
const validImageMIMEs = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/avif"
];
async function loadImageBitmap(url, asset) {
  const response = await DOMAdapter.get().fetch(url);
  if (!response.ok) {
    throw new Error(`[loadImageBitmap] Failed to fetch ${url}: ${response.status} ${response.statusText}`);
  }
  const imageBlob = await response.blob();
  return asset?.data?.alphaMode === "premultiplied-alpha" ? createImageBitmap(imageBlob, { premultiplyAlpha: "none" }) : createImageBitmap(imageBlob);
}
const loadTextures = {
  name: "loadTextures",
  extension: {
    type: ExtensionType.LoadParser,
    priority: LoaderParserPriority.High,
    name: "loadTextures"
  },
  config: {
    preferWorkers: true,
    preferCreateImageBitmap: true,
    crossOrigin: "anonymous"
  },
  test(url) {
    return checkDataUrl(url, validImageMIMEs) || checkExtension(url, validImageExtensions);
  },
  async load(url, asset, loader) {
    let src = null;
    if (globalThis.createImageBitmap && this.config.preferCreateImageBitmap) {
      if (this.config.preferWorkers && await WorkerManager.isImageBitmapSupported()) {
        src = await WorkerManager.loadImageBitmap(url, asset);
      } else {
        src = await loadImageBitmap(url, asset);
      }
    } else {
      src = await new Promise((resolve, reject) => {
        src = new Image();
        src.crossOrigin = this.config.crossOrigin;
        src.src = url;
        if (src.complete) {
          resolve(src);
        } else {
          src.onload = () => {
            resolve(src);
          };
          src.onerror = reject;
        }
      });
    }
    const base = new ImageSource({
      resource: src,
      alphaMode: "premultiply-alpha-on-upload",
      resolution: asset.data?.resolution || getResolutionOfUrl(url),
      ...asset.data
    });
    return createTexture(base, loader, url);
  },
  unload(texture) {
    texture.destroy(true);
  }
};
const validVideoExtensions = [".mp4", ".m4v", ".webm", ".ogg", ".ogv", ".h264", ".avi", ".mov"];
const validVideoMIMEs = validVideoExtensions.map((ext) => `video/${ext.substring(1)}`);
function crossOrigin(element, url, crossorigin) {
  if (crossorigin === void 0 && !url.startsWith("data:")) {
    element.crossOrigin = determineCrossOrigin(url);
  } else if (crossorigin !== false) {
    element.crossOrigin = typeof crossorigin === "string" ? crossorigin : "anonymous";
  }
}
function preloadVideo(element) {
  return new Promise((resolve, reject) => {
    element.addEventListener("canplaythrough", loaded);
    element.addEventListener("error", error);
    element.load();
    function loaded() {
      cleanup();
      resolve();
    }
    function error(err) {
      cleanup();
      reject(err);
    }
    function cleanup() {
      element.removeEventListener("canplaythrough", loaded);
      element.removeEventListener("error", error);
    }
  });
}
function determineCrossOrigin(url, loc = globalThis.location) {
  if (url.startsWith("data:")) {
    return "";
  }
  loc || (loc = globalThis.location);
  const parsedUrl = new URL(url, document.baseURI);
  if (parsedUrl.hostname !== loc.hostname || parsedUrl.port !== loc.port || parsedUrl.protocol !== loc.protocol) {
    return "anonymous";
  }
  return "";
}
const loadVideoTextures = {
  name: "loadVideo",
  extension: {
    type: ExtensionType.LoadParser,
    name: "loadVideo"
  },
  test(url) {
    const isValidDataUrl = checkDataUrl(url, validVideoMIMEs);
    const isValidExtension = checkExtension(url, validVideoExtensions);
    return isValidDataUrl || isValidExtension;
  },
  async load(url, asset, loader) {
    const options = {
      ...VideoSource.defaultOptions,
      resolution: asset.data?.resolution || getResolutionOfUrl(url),
      alphaMode: asset.data?.alphaMode || await detectVideoAlphaMode(),
      ...asset.data
    };
    const videoElement = document.createElement("video");
    const attributeMap = {
      preload: options.autoLoad !== false ? "auto" : void 0,
      "webkit-playsinline": options.playsinline !== false ? "" : void 0,
      playsinline: options.playsinline !== false ? "" : void 0,
      muted: options.muted === true ? "" : void 0,
      loop: options.loop === true ? "" : void 0,
      autoplay: options.autoPlay !== false ? "" : void 0
    };
    Object.keys(attributeMap).forEach((key) => {
      const value = attributeMap[key];
      if (value !== void 0)
        videoElement.setAttribute(key, value);
    });
    if (options.muted === true) {
      videoElement.muted = true;
    }
    crossOrigin(videoElement, url, options.crossorigin);
    const sourceElement = document.createElement("source");
    let mime;
    if (url.startsWith("data:")) {
      mime = url.slice(5, url.indexOf(";"));
    } else if (!url.startsWith("blob:")) {
      const ext = url.split("?")[0].slice(url.lastIndexOf(".") + 1).toLowerCase();
      mime = VideoSource.MIME_TYPES[ext] || `video/${ext}`;
    }
    sourceElement.src = url;
    if (mime) {
      sourceElement.type = mime;
    }
    return new Promise((resolve) => {
      const onCanPlay = async () => {
        const base = new VideoSource({ ...options, resource: videoElement });
        videoElement.removeEventListener("canplay", onCanPlay);
        if (asset.data.preload) {
          await preloadVideo(videoElement);
        }
        resolve(createTexture(base, loader, url));
      };
      videoElement.addEventListener("canplay", onCanPlay);
      videoElement.appendChild(sourceElement);
    });
  },
  unload(texture) {
    texture.destroy(true);
  }
};
const resolveTextureUrl = {
  extension: {
    type: ExtensionType.ResolveParser,
    name: "resolveTexture"
  },
  test: loadTextures.test,
  parse: (value) => ({
    resolution: parseFloat(Resolver.RETINA_PREFIX.exec(value)?.[1] ?? "1"),
    format: value.split(".").pop(),
    src: value
  })
};
const resolveJsonUrl = {
  extension: {
    type: ExtensionType.ResolveParser,
    priority: -2,
    name: "resolveJson"
  },
  test: (value) => Resolver.RETINA_PREFIX.test(value) && value.endsWith(".json"),
  parse: resolveTextureUrl.parse
};
class AssetsClass {
  constructor() {
    this._detections = [];
    this._initialized = false;
    this.resolver = new Resolver();
    this.loader = new Loader();
    this.cache = Cache;
    this._backgroundLoader = new BackgroundLoader(this.loader);
    this._backgroundLoader.active = true;
    this.reset();
  }
  /**
   * Best practice is to call this function before any loading commences
   * Initiating is the best time to add any customization to the way things are loaded.
   *
   * you do not need to call this for the Assets class to work, only if you want to set any initial properties
   * @param options - options to initialize the Assets manager with
   */
  async init(options = {}) {
    if (this._initialized) {
      warn("[Assets]AssetManager already initialized, did you load before calling this Assets.init()?");
      return;
    }
    this._initialized = true;
    if (options.defaultSearchParams) {
      this.resolver.setDefaultSearchParams(options.defaultSearchParams);
    }
    if (options.basePath) {
      this.resolver.basePath = options.basePath;
    }
    if (options.bundleIdentifier) {
      this.resolver.setBundleIdentifier(options.bundleIdentifier);
    }
    if (options.manifest) {
      let manifest = options.manifest;
      if (typeof manifest === "string") {
        manifest = await this.load(manifest);
      }
      this.resolver.addManifest(manifest);
    }
    const resolutionPref = options.texturePreference?.resolution ?? 1;
    const resolution = typeof resolutionPref === "number" ? [resolutionPref] : resolutionPref;
    const formats = await this._detectFormats({
      preferredFormats: options.texturePreference?.format,
      skipDetections: options.skipDetections,
      detections: this._detections
    });
    this.resolver.prefer({
      params: {
        format: formats,
        resolution
      }
    });
    if (options.preferences) {
      this.setPreferences(options.preferences);
    }
  }
  /**
   * Allows you to specify how to resolve any assets load requests.
   * There are a few ways to add things here as shown below:
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Simple
   * Assets.add({alias: 'bunnyBooBoo', src: 'bunny.png'});
   * const bunny = await Assets.load('bunnyBooBoo');
   *
   * // Multiple keys:
   * Assets.add({alias: ['burger', 'chicken'], src: 'bunny.png'});
   *
   * const bunny = await Assets.load('burger');
   * const bunny2 = await Assets.load('chicken');
   *
   * // passing options to to the object
   * Assets.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny.{png,webp}',
   *     data: { scaleMode: SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * // Multiple assets
   *
   * // The following all do the same thing:
   *
   * Assets.add({alias: 'bunnyBooBoo', src: 'bunny.{png,webp}'});
   *
   * Assets.add({
   *     alias: 'bunnyBooBoo',
   *     src: [
   *         'bunny.png',
   *         'bunny.webp',
   *    ],
   * });
   *
   * const bunny = await Assets.load('bunnyBooBoo'); // Will try to load WebP if available
   * @param assets - the unresolved assets to add to the resolver
   */
  add(assets) {
    this.resolver.add(assets);
  }
  async load(urls, onProgress) {
    if (!this._initialized) {
      await this.init();
    }
    const singleAsset = isSingleItem(urls);
    const urlArray = convertToList(urls).map((url) => {
      if (typeof url !== "string") {
        const aliases = this.resolver.getAlias(url);
        if (aliases.some((alias) => !this.resolver.hasKey(alias))) {
          this.add(url);
        }
        return Array.isArray(aliases) ? aliases[0] : aliases;
      }
      if (!this.resolver.hasKey(url))
        this.add({ alias: url, src: url });
      return url;
    });
    const resolveResults = this.resolver.resolve(urlArray);
    const out2 = await this._mapLoadToResolve(resolveResults, onProgress);
    return singleAsset ? out2[urlArray[0]] : out2;
  }
  /**
   * This adds a bundle of assets in one go so that you can load them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.addBundle('animals', [
   *  { alias: 'bunny', src: 'bunny.png' },
   *  { alias: 'chicken', src: 'chicken.png' },
   *  { alias: 'thumper', src: 'thumper.png' },
   * ]);
   * // or
   * Assets.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const assets = await Assets.loadBundle('animals');
   * @param bundleId - the id of the bundle to add
   * @param assets - a record of the asset or assets that will be chosen from when loading via the specified key
   */
  addBundle(bundleId, assets) {
    this.resolver.addBundle(bundleId, assets);
  }
  /**
   * Bundles are a way to load multiple assets at once.
   * If a manifest has been provided to the init function then you can load a bundle, or bundles.
   * you can also add bundles via `addBundle`
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * await Assets.init({ manifest });
   *
   * // Load a bundle...
   * loadScreenAssets = await Assets.loadBundle('load-screen');
   * // Load another bundle...
   * gameScreenAssets = await Assets.loadBundle('game-screen');
   * @param bundleIds - the bundle id or ids to load
   * @param onProgress - Optional function that is called when progress on asset loading is made.
   * The function is passed a single parameter, `progress`, which represents the percentage (0.0 - 1.0)
   * of the assets loaded. Do not use this function to detect when assets are complete and available,
   * instead use the Promise returned by this function.
   * @returns all the bundles assets or a hash of assets for each bundle specified
   */
  async loadBundle(bundleIds, onProgress) {
    if (!this._initialized) {
      await this.init();
    }
    let singleAsset = false;
    if (typeof bundleIds === "string") {
      singleAsset = true;
      bundleIds = [bundleIds];
    }
    const resolveResults = this.resolver.resolveBundle(bundleIds);
    const out2 = {};
    const keys = Object.keys(resolveResults);
    let count2 = 0;
    let total = 0;
    const _onProgress = () => {
      onProgress?.(++count2 / total);
    };
    const promises = keys.map((bundleId) => {
      const resolveResult = resolveResults[bundleId];
      total += Object.keys(resolveResult).length;
      return this._mapLoadToResolve(resolveResult, _onProgress).then((resolveResult2) => {
        out2[bundleId] = resolveResult2;
      });
    });
    await Promise.all(promises);
    return singleAsset ? out2[bundleIds[0]] : out2;
  }
  /**
   * Initiate a background load of some assets. It will passively begin to load these assets in the background.
   * So when you actually come to loading them you will get a promise that resolves to the loaded assets immediately
   *
   * An example of this might be that you would background load game assets after your initial load.
   * then when you got to actually load your game screen assets when a player goes to the game - the loading
   * would already have stared or may even be complete, saving you having to show an interim load bar.
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.backgroundLoad('bunny.png');
   *
   * // later on in your app...
   * await Assets.loadBundle('bunny.png'); // Will resolve quicker as loading may have completed!
   * @param urls - the url / urls you want to background load
   */
  async backgroundLoad(urls) {
    if (!this._initialized) {
      await this.init();
    }
    if (typeof urls === "string") {
      urls = [urls];
    }
    const resolveResults = this.resolver.resolve(urls);
    this._backgroundLoader.add(Object.values(resolveResults));
  }
  /**
   * Initiate a background of a bundle, works exactly like backgroundLoad but for bundles.
   * this can only be used if the loader has been initiated with a manifest
   * @example
   * import { Assets } from 'pixi.js';
   *
   * await Assets.init({
   *     manifest: {
   *         bundles: [
   *             {
   *                 name: 'load-screen',
   *                 assets: [...],
   *             },
   *             ...
   *         ],
   *     },
   * });
   *
   * Assets.backgroundLoadBundle('load-screen');
   *
   * // Later on in your app...
   * await Assets.loadBundle('load-screen'); // Will resolve quicker as loading may have completed!
   * @param bundleIds - the bundleId / bundleIds you want to background load
   */
  async backgroundLoadBundle(bundleIds) {
    if (!this._initialized) {
      await this.init();
    }
    if (typeof bundleIds === "string") {
      bundleIds = [bundleIds];
    }
    const resolveResults = this.resolver.resolveBundle(bundleIds);
    Object.values(resolveResults).forEach((resolveResult) => {
      this._backgroundLoader.add(Object.values(resolveResult));
    });
  }
  /**
   * Only intended for development purposes.
   * This will wipe the resolver and caches.
   * You will need to reinitialize the Asset
   */
  reset() {
    this.resolver.reset();
    this.loader.reset();
    this.cache.reset();
    this._initialized = false;
  }
  get(keys) {
    if (typeof keys === "string") {
      return Cache.get(keys);
    }
    const assets = {};
    for (let i2 = 0; i2 < keys.length; i2++) {
      assets[i2] = Cache.get(keys[i2]);
    }
    return assets;
  }
  /**
   * helper function to map resolved assets back to loaded assets
   * @param resolveResults - the resolve results from the resolver
   * @param onProgress - the progress callback
   */
  async _mapLoadToResolve(resolveResults, onProgress) {
    const resolveArray = [...new Set(Object.values(resolveResults))];
    this._backgroundLoader.active = false;
    const loadedAssets = await this.loader.load(resolveArray, onProgress);
    this._backgroundLoader.active = true;
    const out2 = {};
    resolveArray.forEach((resolveResult) => {
      const asset = loadedAssets[resolveResult.src];
      const keys = [resolveResult.src];
      if (resolveResult.alias) {
        keys.push(...resolveResult.alias);
      }
      keys.forEach((key) => {
        out2[key] = asset;
      });
      Cache.set(keys, asset);
    });
    return out2;
  }
  /**
   * Unload an asset or assets. As the Assets class is responsible for creating the assets via the `load` function
   * this will make sure to destroy any assets and release them from memory.
   * Once unloaded, you will need to load the asset again.
   *
   * Use this to help manage assets if you find that you have a large app and you want to free up memory.
   *
   * - it's up to you as the developer to make sure that textures are not actively being used when you unload them,
   * Pixi won't break but you will end up with missing assets. Not a good look for the user!
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Load a URL:
   * const myImageTexture = await Assets.load('http://some.url.com/image.png'); // => returns a texture
   *
   * await Assets.unload('http://some.url.com/image.png')
   *
   * // myImageTexture will be destroyed now.
   *
   * // Unload multiple assets:
   * const textures = await Assets.unload(['thumper', 'chicko']);
   * @param urls - the urls to unload
   */
  async unload(urls) {
    if (!this._initialized) {
      await this.init();
    }
    const urlArray = convertToList(urls).map((url) => typeof url !== "string" ? url.src : url);
    const resolveResults = this.resolver.resolve(urlArray);
    await this._unloadFromResolved(resolveResults);
  }
  /**
   * Bundles are a way to manage multiple assets at once.
   * this will unload all files in a bundle.
   *
   * once a bundle has been unloaded, you need to load it again to have access to the assets.
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.addBundle({
   *     'thumper': 'http://some.url.com/thumper.png',
   * })
   *
   * const assets = await Assets.loadBundle('thumper');
   *
   * // Now to unload...
   *
   * await Assets.unloadBundle('thumper');
   *
   * // All assets in the assets object will now have been destroyed and purged from the cache
   * @param bundleIds - the bundle id or ids to unload
   */
  async unloadBundle(bundleIds) {
    if (!this._initialized) {
      await this.init();
    }
    bundleIds = convertToList(bundleIds);
    const resolveResults = this.resolver.resolveBundle(bundleIds);
    const promises = Object.keys(resolveResults).map((bundleId) => this._unloadFromResolved(resolveResults[bundleId]));
    await Promise.all(promises);
  }
  async _unloadFromResolved(resolveResult) {
    const resolveArray = Object.values(resolveResult);
    resolveArray.forEach((resolveResult2) => {
      Cache.remove(resolveResult2.src);
    });
    await this.loader.unload(resolveArray);
  }
  /**
   * Detects the supported formats for the browser, and returns an array of supported formats, respecting
   * the users preferred formats order.
   * @param options - the options to use when detecting formats
   * @param options.preferredFormats - the preferred formats to use
   * @param options.skipDetections - if we should skip the detections altogether
   * @param options.detections - the detections to use
   * @returns - the detected formats
   */
  async _detectFormats(options) {
    let formats = [];
    if (options.preferredFormats) {
      formats = Array.isArray(options.preferredFormats) ? options.preferredFormats : [options.preferredFormats];
    }
    for (const detection of options.detections) {
      if (options.skipDetections || await detection.test()) {
        formats = await detection.add(formats);
      } else if (!options.skipDetections) {
        formats = await detection.remove(formats);
      }
    }
    formats = formats.filter((format, index) => formats.indexOf(format) === index);
    return formats;
  }
  /** All the detection parsers currently added to the Assets class. */
  get detections() {
    return this._detections;
  }
  /**
   * General setter for preferences. This is a helper function to set preferences on all parsers.
   * @param preferences - the preferences to set
   */
  setPreferences(preferences) {
    this.loader.parsers.forEach((parser) => {
      if (!parser.config)
        return;
      Object.keys(parser.config).filter((key) => key in preferences).forEach((key) => {
        parser.config[key] = preferences[key];
      });
    });
  }
}
const Assets = new AssetsClass();
extensions.handleByList(ExtensionType.LoadParser, Assets.loader.parsers).handleByList(ExtensionType.ResolveParser, Assets.resolver.parsers).handleByList(ExtensionType.CacheParser, Assets.cache.parsers).handleByList(ExtensionType.DetectionParser, Assets.detections);
extensions.add(
  cacheTextureArray,
  detectDefaults,
  detectAvif,
  detectWebp,
  detectMp4,
  detectOgv,
  detectWebm,
  loadJson,
  loadTxt,
  loadWebFont,
  loadSvg,
  loadTextures,
  loadVideoTextures,
  loadBitmapFont,
  bitmapFontCachePlugin,
  resolveTextureUrl,
  resolveJsonUrl
);
const assetKeyMap = {
  loader: ExtensionType.LoadParser,
  resolver: ExtensionType.ResolveParser,
  cache: ExtensionType.CacheParser,
  detection: ExtensionType.DetectionParser
};
extensions.handle(ExtensionType.Asset, (extension) => {
  const ref = extension.ref;
  Object.entries(assetKeyMap).filter(([key]) => !!ref[key]).forEach(([key, type]) => extensions.add(Object.assign(
    ref[key],
    // Allow the function to optionally define it's own
    // ExtensionMetadata, the use cases here is priority for LoaderParsers
    { extension: ref[key].extension ?? type }
  )));
}, (extension) => {
  const ref = extension.ref;
  Object.keys(assetKeyMap).filter((key) => !!ref[key]).forEach((key) => extensions.remove(ref[key]));
});
class Graphics extends ViewContainer {
  /**
   * @param options - Options for the Graphics.
   */
  constructor(options) {
    if (options instanceof GraphicsContext) {
      options = { context: options };
    }
    const { context: context2, roundPixels, ...rest } = options || {};
    super({
      label: "Graphics",
      ...rest
    });
    this.renderPipeId = "graphics";
    if (!context2) {
      this._context = this._ownedContext = new GraphicsContext();
    } else {
      this._context = context2;
    }
    this._context.on("update", this.onViewUpdate, this);
    this.allowChildren = false;
    this.roundPixels = roundPixels ?? false;
  }
  set context(context2) {
    if (context2 === this._context)
      return;
    this._context.off("update", this.onViewUpdate, this);
    this._context = context2;
    this._context.on("update", this.onViewUpdate, this);
    this.onViewUpdate();
  }
  get context() {
    return this._context;
  }
  /**
   * The local bounds of the graphic.
   * @type {rendering.Bounds}
   */
  get bounds() {
    return this._context.bounds;
  }
  /**
   * Graphics objects do not need to update their bounds as the context handles this.
   * @private
   */
  updateBounds() {
  }
  /**
   * Checks if the object contains the given point.
   * @param point - The point to check
   */
  containsPoint(point) {
    return this._context.containsPoint(point);
  }
  /**
   * Destroys this graphics renderable and optionally its context.
   * @param options - Options parameter. A boolean will act as if all options
   *
   * If the context was created by this graphics and `destroy(false)` or `destroy()` is called
   * then the context will still be destroyed.
   *
   * If you want to explicitly not destroy this context that this graphics created,
   * then you should pass destroy({ context: false })
   *
   * If the context was passed in as an argument to the constructor then it will not be destroyed
   * @param {boolean} [options.texture=false] - Should destroy the texture of the graphics context
   * @param {boolean} [options.textureSource=false] - Should destroy the texture source of the graphics context
   * @param {boolean} [options.context=false] - Should destroy the context
   */
  destroy(options) {
    if (this._ownedContext && !options) {
      this._ownedContext.destroy(options);
    } else if (options === true || options?.context === true) {
      this._context.destroy(options);
    }
    this._ownedContext = null;
    this._context = null;
    super.destroy(options);
  }
  _callContextMethod(method, args) {
    this.context[method](...args);
    return this;
  }
  // --------------------------------------- GraphicsContext methods ---------------------------------------
  /**
   * Sets the current fill style of the graphics context. The fill style can be a color, gradient,
   * pattern, or a more complex style defined by a FillStyle object.
   * @param {FillInput} args - The fill style to apply. This can be a simple color, a gradient or
   * pattern object, or a FillStyle or ConvertedFillStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  setFillStyle(...args) {
    return this._callContextMethod("setFillStyle", args);
  }
  /**
   * Sets the current stroke style of the graphics context. Similar to fill styles, stroke styles can
   * encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   * @param {StrokeInput} args - The stroke style to apply. Can be defined as a color, a gradient or pattern,
   * or a StrokeStyle or ConvertedStrokeStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  setStrokeStyle(...args) {
    return this._callContextMethod("setStrokeStyle", args);
  }
  fill(...args) {
    return this._callContextMethod("fill", args);
  }
  /**
   * Strokes the current path with the current stroke style. This method can take an optional
   * FillStyle parameter to define the stroke's appearance, including its color, width, and other properties.
   * @param {FillStyle} args - (Optional) The stroke style to apply. Can be defined as a simple color or a more
   * complex style object. If omitted, uses the current stroke style.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  stroke(...args) {
    return this._callContextMethod("stroke", args);
  }
  texture(...args) {
    return this._callContextMethod("texture", args);
  }
  /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  beginPath() {
    return this._callContextMethod("beginPath", []);
  }
  /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path. If a hole is not completely in a shape, it will
   * fail to cut correctly!
   */
  cut() {
    return this._callContextMethod("cut", []);
  }
  arc(...args) {
    return this._callContextMethod("arc", args);
  }
  arcTo(...args) {
    return this._callContextMethod("arcTo", args);
  }
  arcToSvg(...args) {
    return this._callContextMethod("arcToSvg", args);
  }
  bezierCurveTo(...args) {
    return this._callContextMethod("bezierCurveTo", args);
  }
  /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */
  closePath() {
    return this._callContextMethod("closePath", []);
  }
  ellipse(...args) {
    return this._callContextMethod("ellipse", args);
  }
  circle(...args) {
    return this._callContextMethod("circle", args);
  }
  path(...args) {
    return this._callContextMethod("path", args);
  }
  lineTo(...args) {
    return this._callContextMethod("lineTo", args);
  }
  moveTo(...args) {
    return this._callContextMethod("moveTo", args);
  }
  quadraticCurveTo(...args) {
    return this._callContextMethod("quadraticCurveTo", args);
  }
  rect(...args) {
    return this._callContextMethod("rect", args);
  }
  roundRect(...args) {
    return this._callContextMethod("roundRect", args);
  }
  poly(...args) {
    return this._callContextMethod("poly", args);
  }
  regularPoly(...args) {
    return this._callContextMethod("regularPoly", args);
  }
  roundPoly(...args) {
    return this._callContextMethod("roundPoly", args);
  }
  roundShape(...args) {
    return this._callContextMethod("roundShape", args);
  }
  filletRect(...args) {
    return this._callContextMethod("filletRect", args);
  }
  chamferRect(...args) {
    return this._callContextMethod("chamferRect", args);
  }
  star(...args) {
    return this._callContextMethod("star", args);
  }
  svg(...args) {
    return this._callContextMethod("svg", args);
  }
  restore(...args) {
    return this._callContextMethod("restore", args);
  }
  /** Saves the current graphics state, including transformations, fill styles, and stroke styles, onto a stack. */
  save() {
    return this._callContextMethod("save", []);
  }
  /**
   * Returns the current transformation matrix of the graphics context.
   * @returns The current transformation matrix.
   */
  getTransform() {
    return this.context.getTransform();
  }
  /**
   * Resets the current transformation matrix to the identity matrix, effectively removing
   * any transformations (rotation, scaling, translation) previously applied.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  resetTransform() {
    return this._callContextMethod("resetTransform", []);
  }
  rotateTransform(...args) {
    return this._callContextMethod("rotate", args);
  }
  scaleTransform(...args) {
    return this._callContextMethod("scale", args);
  }
  setTransform(...args) {
    return this._callContextMethod("setTransform", args);
  }
  transform(...args) {
    return this._callContextMethod("transform", args);
  }
  translateTransform(...args) {
    return this._callContextMethod("translate", args);
  }
  /**
   * Clears all drawing commands from the graphics context, effectively resetting it. This includes clearing the path,
   * and optionally resetting transformations to the identity matrix.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  clear() {
    return this._callContextMethod("clear", []);
  }
  /**
   * The fill style to use.
   * @type {ConvertedFillStyle}
   */
  get fillStyle() {
    return this._context.fillStyle;
  }
  set fillStyle(value) {
    this._context.fillStyle = value;
  }
  /**
   * The stroke style to use.
   * @type {ConvertedStrokeStyle}
   */
  get strokeStyle() {
    return this._context.strokeStyle;
  }
  set strokeStyle(value) {
    this._context.strokeStyle = value;
  }
  /**
   * Creates a new Graphics object.
   * Note that only the context of the object is cloned, not its transform (position,scale,etc)
   * @param deep - Whether to create a deep clone of the graphics object. If false, the context
   * will be shared between the two objects (default false). If true, the context will be
   * cloned (recommended if you need to modify the context in any way).
   * @returns - A clone of the graphics object
   */
  clone(deep = false) {
    if (deep) {
      return new Graphics(this._context.clone());
    }
    this._ownedContext = null;
    const clone = new Graphics(this._context);
    return clone;
  }
  // -------- v7 deprecations ---------
  /**
   * @param width
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#setStrokeStyle} instead
   */
  lineStyle(width, color, alpha) {
    deprecation(v8_0_0, "Graphics#lineStyle is no longer needed. Use Graphics#setStrokeStyle to set the stroke style.");
    const strokeStyle = {};
    width && (strokeStyle.width = width);
    color && (strokeStyle.color = color);
    alpha && (strokeStyle.alpha = alpha);
    this.context.strokeStyle = strokeStyle;
    return this;
  }
  /**
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */
  beginFill(color, alpha) {
    deprecation(v8_0_0, "Graphics#beginFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
    const fillStyle = {};
    if (color !== void 0)
      fillStyle.color = color;
    if (alpha !== void 0)
      fillStyle.alpha = alpha;
    this.context.fillStyle = fillStyle;
    return this;
  }
  /**
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */
  endFill() {
    deprecation(v8_0_0, "Graphics#endFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
    this.context.fill();
    const strokeStyle = this.context.strokeStyle;
    if (strokeStyle.width !== GraphicsContext.defaultStrokeStyle.width || strokeStyle.color !== GraphicsContext.defaultStrokeStyle.color || strokeStyle.alpha !== GraphicsContext.defaultStrokeStyle.alpha) {
      this.context.stroke();
    }
    return this;
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#circle} instead
   */
  drawCircle(...args) {
    deprecation(v8_0_0, "Graphics#drawCircle has been renamed to Graphics#circle");
    return this._callContextMethod("circle", args);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#ellipse} instead
   */
  drawEllipse(...args) {
    deprecation(v8_0_0, "Graphics#drawEllipse has been renamed to Graphics#ellipse");
    return this._callContextMethod("ellipse", args);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#poly} instead
   */
  drawPolygon(...args) {
    deprecation(v8_0_0, "Graphics#drawPolygon has been renamed to Graphics#poly");
    return this._callContextMethod("poly", args);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#rect} instead
   */
  drawRect(...args) {
    deprecation(v8_0_0, "Graphics#drawRect has been renamed to Graphics#rect");
    return this._callContextMethod("rect", args);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#roundRect} instead
   */
  drawRoundedRect(...args) {
    deprecation(v8_0_0, "Graphics#drawRoundedRect has been renamed to Graphics#roundRect");
    return this._callContextMethod("roundRect", args);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#star} instead
   */
  drawStar(...args) {
    deprecation(v8_0_0, "Graphics#drawStar has been renamed to Graphics#star");
    return this._callContextMethod("star", args);
  }
}
class RenderTexture extends Texture {
  static create(options) {
    return new RenderTexture({
      source: new TextureSource(options)
    });
  }
  /**
   * Resizes the render texture.
   * @param width - The new width of the render texture.
   * @param height - The new height of the render texture.
   * @param resolution - The new resolution of the render texture.
   * @returns This texture.
   */
  resize(width, height, resolution) {
    this.source.resize(width, height, resolution);
    return this;
  }
}
var DEPRECATED_WRAP_MODES = /* @__PURE__ */ ((DEPRECATED_WRAP_MODES2) => {
  DEPRECATED_WRAP_MODES2["CLAMP"] = "clamp-to-edge";
  DEPRECATED_WRAP_MODES2["REPEAT"] = "repeat";
  DEPRECATED_WRAP_MODES2["MIRRORED_REPEAT"] = "mirror-repeat";
  return DEPRECATED_WRAP_MODES2;
})(DEPRECATED_WRAP_MODES || {});
new Proxy(DEPRECATED_WRAP_MODES, {
  get(target, prop) {
    deprecation(v8_0_0, `DRAW_MODES.${prop} is deprecated, use '${DEPRECATED_WRAP_MODES[prop]}' instead`);
    return target[prop];
  }
});
var DEPRECATED_SCALE_MODES = /* @__PURE__ */ ((DEPRECATED_SCALE_MODES2) => {
  DEPRECATED_SCALE_MODES2["NEAREST"] = "nearest";
  DEPRECATED_SCALE_MODES2["LINEAR"] = "linear";
  return DEPRECATED_SCALE_MODES2;
})(DEPRECATED_SCALE_MODES || {});
const SCALE_MODES = new Proxy(DEPRECATED_SCALE_MODES, {
  get(target, prop) {
    deprecation(v8_0_0, `DRAW_MODES.${prop} is deprecated, use '${DEPRECATED_SCALE_MODES[prop]}' instead`);
    return target[prop];
  }
});
extensions.add(browserExt, webworkerExt);
function get_canvas_blob(renderer, obj, bounds) {
  return new Promise((resolve) => {
    if (!obj) {
      resolve(null);
      return;
    }
    const image_bounds = obj.getLocalBounds();
    const frame = bounds ? new Rectangle(bounds.x, bounds.y, bounds.width, bounds.height) : new Rectangle(0, 0, image_bounds.width, image_bounds.height);
    const src_canvas = renderer.extract.canvas({
      target: obj,
      resolution: 1,
      frame
    });
    src_canvas.toBlob?.((blob) => {
      if (!blob) {
        resolve(null);
      }
      resolve(blob);
    });
  });
}
const css$a = {
  code: ".hue-slider.svelte-9hvvq8.svelte-9hvvq8{position:relative;width:90%;margin:0px auto 10px auto;height:12px;border-radius:2px;border:1px solid var(--block-border-color);background:linear-gradient(\n			to right,\n			hsl(0, 100%, 50%) 0%,\n			#ff0 17%,\n			lime 33%,\n			cyan 50%,\n			blue 67%,\n			magenta 83%,\n			red 100%\n		);border-top:none}.opacity-slider.svelte-9hvvq8.svelte-9hvvq8{position:relative;width:90%;margin:10px auto 5px auto;height:12px;border-radius:2px;border:1px solid var(--block-border-color);background:linear-gradient(to right, transparent, var(--color)),\n			repeating-conic-gradient(#808080 0% 25%, transparent 0% 50%) 0 0 / 10px\n				10px}.opacity-marker.svelte-9hvvq8.svelte-9hvvq8{position:absolute;width:16px;height:16px;border-radius:50%}.opacity-slider.svelte-9hvvq8>.opacity-marker.svelte-9hvvq8{box-shadow:0 0 1px #888;top:-4px;margin:auto;height:18px;width:18px;left:-9px;margin:auto;border:1px solid var(--block-border-color)}.color-gradient.svelte-9hvvq8.svelte-9hvvq8{position:relative;--hue:white;background:linear-gradient(rgba(0, 0, 0, 0), #000),\n			linear-gradient(90deg, #fff, hsl(var(--hue), 100%, 50%));width:100%;height:150px;border-top-left-radius:4px;border-top-right-radius:4px}.marker.svelte-9hvvq8.svelte-9hvvq8{position:absolute;width:14px;height:14px;border-radius:50%;border:2px solid white;top:-7px;left:-7px;box-shadow:0 1px 5px rgba(0, 0, 0, 0.1);pointer-events:none;border:1px solid var(--block-border-color)}.hue-slider.svelte-9hvvq8>.marker.svelte-9hvvq8{box-shadow:0 0 1px #888;top:-3px;margin:auto;height:18px;width:18px;left:-9px;border:1px solid var(--block-border-color)}",
  map: '{"version":3,"file":"ColorPicker.svelte","sources":["ColorPicker.svelte"],"sourcesContent":["<script lang=\\"ts\\">import { onMount, tick } from \\"svelte\\";\\nimport tinycolor from \\"tinycolor2\\";\\nimport { clamp } from \\"../utils/pixi\\";\\nexport let color = \\"rgb(255, 255, 255)\\";\\nlet sl_marker_pos = [0, 0];\\nlet sl_rect = null;\\nlet sl_moving = false;\\nlet sl = [0, 0];\\nlet hue = 0;\\nlet hue_marker_pos = 0;\\nlet hue_rect = null;\\nlet hue_moving = false;\\nlet opacity_moving = false;\\nfunction handle_hue_down(event) {\\n    hue_rect = event.currentTarget.getBoundingClientRect();\\n    hue_moving = true;\\n    update_hue_from_mouse(event.clientX);\\n}\\nfunction update_hue_from_mouse(x) {\\n    if (!hue_rect)\\n        return;\\n    const _x = clamp(x - hue_rect.left, 0, hue_rect.width);\\n    hue_marker_pos = _x;\\n    const _hue = _x / hue_rect.width * 360;\\n    hue = _hue;\\n    color = hsva_to_rgba({ h: _hue, s: sl[0], v: sl[1], a: 1 });\\n}\\nfunction hsva_to_rgba(hsva) {\\n    const saturation = hsva.s;\\n    const value = hsva.v;\\n    let chroma = saturation * value;\\n    const hue_by_60 = hsva.h / 60;\\n    let x = chroma * (1 - Math.abs(hue_by_60 % 2 - 1));\\n    const m = value - chroma;\\n    chroma = chroma + m;\\n    x = x + m;\\n    const index = Math.floor(hue_by_60) % 6;\\n    const red = [chroma, x, m, m, x, chroma][index];\\n    const green = [x, chroma, chroma, x, m, m][index];\\n    const blue = [m, m, x, chroma, chroma, x][index];\\n    return `rgba(${red * 255}, ${green * 255}, ${blue * 255}, ${hsva.a})`;\\n}\\nfunction update_color_from_mouse(x, y) {\\n    if (!sl_rect)\\n        return;\\n    const _x = clamp(x - sl_rect.left, 0, sl_rect.width);\\n    const _y = clamp(y - sl_rect.top, 0, sl_rect.height);\\n    sl_marker_pos = [_x, _y];\\n    const _hsva = {\\n        h: hue * 1,\\n        s: _x / sl_rect.width,\\n        v: 1 - _y / sl_rect.height,\\n        a: 1\\n    };\\n    sl = [_hsva.s, _hsva.v];\\n    color = hsva_to_rgba(_hsva);\\n}\\nfunction handle_sl_down(event) {\\n    sl_moving = true;\\n    sl_rect = event.currentTarget.getBoundingClientRect();\\n    update_color_from_mouse(event.clientX, event.clientY);\\n}\\nfunction handle_move(event) {\\n    if (sl_moving)\\n        update_color_from_mouse(event.clientX, event.clientY);\\n    if (hue_moving)\\n        update_hue_from_mouse(event.clientX);\\n    if (opacity_moving)\\n        update_opacity_from_mouse(event.clientX);\\n}\\nfunction handle_end() {\\n    if (sl_moving)\\n        sl_moving = false;\\n    if (hue_moving)\\n        hue_moving = false;\\n    if (opacity_moving)\\n        opacity_moving = false;\\n}\\nasync function update_mouse_from_color(color2) {\\n    if (sl_moving || hue_moving)\\n        return;\\n    await tick();\\n    if (!color2)\\n        return;\\n    if (!sl_rect) {\\n        sl_rect = sl_wrap.getBoundingClientRect();\\n    }\\n    if (!hue_rect) {\\n        hue_rect = hue_wrap.getBoundingClientRect();\\n    }\\n    const hsva = tinycolor(color2).toHsv();\\n    const _x = hsva.s * sl_rect.width;\\n    const _y = (1 - hsva.v) * sl_rect.height;\\n    sl_marker_pos = [_x, _y];\\n    sl = [hsva.s, hsva.v];\\n    hue = hsva.h;\\n    hue_marker_pos = hsva.h / 360 * hue_rect.width;\\n}\\n$: update_mouse_from_color(color);\\nlet sl_wrap;\\nlet hue_wrap;\\nexport let opacity = 1;\\nlet opacity_wrap;\\nfunction handle_opacity_down(event) {\\n    opacity_rect = event.currentTarget.getBoundingClientRect();\\n    opacity_moving = true;\\n    update_opacity_from_mouse(event.clientX);\\n}\\nlet opacity_rect = null;\\nfunction update_opacity_from_mouse(x) {\\n    if (!opacity_rect)\\n        return;\\n    const _x = clamp(x - opacity_rect.left, 0, opacity_rect.width);\\n    opacity = _x / opacity_rect.width;\\n}\\nonMount(() => {\\n    opacity_rect = opacity_wrap.getBoundingClientRect();\\n});\\n<\/script>\\n\\n<svelte:window on:mousemove={handle_move} on:mouseup={handle_end} />\\n\\n<!-- svelte-ignore a11y-no-static-element-interactions -->\\n<div\\n\\tclass=\\"color-gradient\\"\\n\\ton:mousedown={handle_sl_down}\\n\\tstyle=\\"--hue:{hue}\\"\\n\\tbind:this={sl_wrap}\\n>\\n\\t<div\\n\\t\\tclass=\\"marker\\"\\n\\t\\tstyle:transform=\\"translate({sl_marker_pos[0]}px,{sl_marker_pos[1]}px)\\"\\n\\t\\tstyle:background={color}\\n\\t/>\\n</div>\\n<!-- svelte-ignore a11y-no-static-element-interactions -->\\n<div\\n\\tclass=\\"opacity-slider\\"\\n\\ton:mousedown={handle_opacity_down}\\n\\tstyle=\\"--color:{color === \'auto\' ? \'transparent\' : color}\\"\\n\\tbind:this={opacity_wrap}\\n>\\n\\t<div\\n\\t\\tclass=\\"opacity-marker\\"\\n\\t\\tstyle:background=\\"white\\"\\n\\t\\tstyle:transform=\\"translateX({opacity * (opacity_rect?.width ?? 1)}px)\\"\\n\\t/>\\n</div>\\n<!-- svelte-ignore a11y-no-static-element-interactions -->\\n<div class=\\"hue-slider\\" on:mousedown={handle_hue_down} bind:this={hue_wrap}>\\n\\t<div\\n\\t\\tclass=\\"marker\\"\\n\\t\\tstyle:background={\\"hsl(\\" + hue + \\", 100%, 50%)\\"}\\n\\t\\tstyle:transform=\\"translateX({hue_marker_pos}px)\\"\\n\\t/>\\n</div>\\n\\n<style>\\n\\t.hue-slider {\\n\\t\\tposition: relative;\\n\\t\\twidth: 90%;\\n\\t\\tmargin: 0px auto 10px auto;\\n\\t\\theight: 12px;\\n\\t\\tborder-radius: 2px;\\n\\t\\tborder: 1px solid var(--block-border-color);\\n\\t\\tbackground: linear-gradient(\\n\\t\\t\\tto right,\\n\\t\\t\\thsl(0, 100%, 50%) 0%,\\n\\t\\t\\t#ff0 17%,\\n\\t\\t\\tlime 33%,\\n\\t\\t\\tcyan 50%,\\n\\t\\t\\tblue 67%,\\n\\t\\t\\tmagenta 83%,\\n\\t\\t\\tred 100%\\n\\t\\t);\\n\\t\\tborder-top: none;\\n\\t}\\n\\n\\t.opacity-slider {\\n\\t\\tposition: relative;\\n\\t\\twidth: 90%;\\n\\t\\tmargin: 10px auto 5px auto;\\n\\t\\theight: 12px;\\n\\t\\tborder-radius: 2px;\\n\\t\\tborder: 1px solid var(--block-border-color);\\n\\t\\t/* background: linear-gradient(45deg, #808080 25%, transparent 25%),\\n\\t\\t\\tlinear-gradient(-45deg, #808080 25%, transparent 25%),\\n\\t\\t\\tlinear-gradient(45deg, transparent 75%, #808080 75%),\\n\\t\\t\\tlinear-gradient(-45deg, transparent 75%, #808080 75%); */\\n\\t\\tbackground:\\n\\t\\t\\tlinear-gradient(to right, transparent, var(--color)),\\n\\t\\t\\trepeating-conic-gradient(#808080 0% 25%, transparent 0% 50%) 0 0 / 10px\\n\\t\\t\\t\\t10px;\\n\\t}\\n\\n\\t.opacity-marker {\\n\\t\\tposition: absolute;\\n\\t\\twidth: 16px;\\n\\t\\theight: 16px;\\n\\t\\tborder-radius: 50%;\\n\\t}\\n\\n\\t.opacity-slider > .opacity-marker {\\n\\t\\tbox-shadow: 0 0 1px #888;\\n\\t\\ttop: -4px;\\n\\t\\tmargin: auto;\\n\\t\\theight: 18px;\\n\\t\\twidth: 18px;\\n\\t\\tleft: -9px;\\n\\t\\tmargin: auto;\\n\\t\\tborder: 1px solid var(--block-border-color);\\n\\t}\\n\\n\\t.color-gradient {\\n\\t\\tposition: relative;\\n\\t\\t--hue: white;\\n\\n\\t\\tbackground: linear-gradient(rgba(0, 0, 0, 0), #000),\\n\\t\\t\\tlinear-gradient(90deg, #fff, hsl(var(--hue), 100%, 50%));\\n\\t\\twidth: 100%;\\n\\t\\theight: 150px;\\n\\t\\tborder-top-left-radius: 4px;\\n\\t\\tborder-top-right-radius: 4px;\\n\\t}\\n\\n\\t.marker {\\n\\t\\tposition: absolute;\\n\\t\\twidth: 14px;\\n\\t\\theight: 14px;\\n\\t\\tborder-radius: 50%;\\n\\t\\tborder: 2px solid white;\\n\\n\\t\\ttop: -7px;\\n\\t\\tleft: -7px;\\n\\t\\tbox-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);\\n\\t\\tpointer-events: none;\\n\\t\\tborder: 1px solid var(--block-border-color);\\n\\t}\\n\\n\\t.hue-slider > .marker {\\n\\t\\tbox-shadow: 0 0 1px #888;\\n\\t\\ttop: -3px;\\n\\t\\tmargin: auto;\\n\\t\\theight: 18px;\\n\\t\\twidth: 18px;\\n\\t\\tleft: -9px;\\n\\n\\t\\tborder: 1px solid var(--block-border-color);\\n\\t}</style>\\n"],"names":[],"mappings":"AA8JC,uCAAY,CACX,QAAQ,CAAE,QAAQ,CAClB,KAAK,CAAE,GAAG,CACV,MAAM,CAAE,GAAG,CAAC,IAAI,CAAC,IAAI,CAAC,IAAI,CAC1B,MAAM,CAAE,IAAI,CACZ,aAAa,CAAE,GAAG,CAClB,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,oBAAoB,CAAC,CAC3C,UAAU,CAAE;AACd,GAAG,EAAE,CAAC,KAAK,CAAC;AACZ,GAAG,IAAI,CAAC,CAAC,CAAC,IAAI,CAAC,CAAC,GAAG,CAAC,CAAC,EAAE,CAAC;AACxB,GAAG,IAAI,CAAC,GAAG,CAAC;AACZ,GAAG,IAAI,CAAC,GAAG,CAAC;AACZ,GAAG,IAAI,CAAC,GAAG,CAAC;AACZ,GAAG,IAAI,CAAC,GAAG,CAAC;AACZ,GAAG,OAAO,CAAC,GAAG,CAAC;AACf,GAAG,GAAG,CAAC,IAAI;AACX,GAAG,CACD,UAAU,CAAE,IACb,CAEA,2CAAgB,CACf,QAAQ,CAAE,QAAQ,CAClB,KAAK,CAAE,GAAG,CACV,MAAM,CAAE,IAAI,CAAC,IAAI,CAAC,GAAG,CAAC,IAAI,CAC1B,MAAM,CAAE,IAAI,CACZ,aAAa,CAAE,GAAG,CAClB,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,oBAAoB,CAAC,CAK3C,UAAU,CACT,gBAAgB,EAAE,CAAC,KAAK,CAAC,CAAC,WAAW,CAAC,CAAC,IAAI,OAAO,CAAC,CAAC,CAAC;AACxD,GAAG,yBAAyB,OAAO,CAAC,EAAE,CAAC,GAAG,CAAC,CAAC,WAAW,CAAC,EAAE,CAAC,GAAG,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,IAAI;AAC1E,IAAI,IACH,CAEA,2CAAgB,CACf,QAAQ,CAAE,QAAQ,CAClB,KAAK,CAAE,IAAI,CACX,MAAM,CAAE,IAAI,CACZ,aAAa,CAAE,GAChB,CAEA,6BAAe,CAAG,6BAAgB,CACjC,UAAU,CAAE,CAAC,CAAC,CAAC,CAAC,GAAG,CAAC,IAAI,CACxB,GAAG,CAAE,IAAI,CACT,MAAM,CAAE,IAAI,CACZ,MAAM,CAAE,IAAI,CACZ,KAAK,CAAE,IAAI,CACX,IAAI,CAAE,IAAI,CACV,MAAM,CAAE,IAAI,CACZ,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,oBAAoB,CAC3C,CAEA,2CAAgB,CACf,QAAQ,CAAE,QAAQ,CAClB,KAAK,CAAE,KAAK,CAEZ,UAAU,CAAE,gBAAgB,KAAK,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,IAAI,CAAC,CAAC;AACtD,GAAG,gBAAgB,KAAK,CAAC,CAAC,IAAI,CAAC,CAAC,IAAI,IAAI,KAAK,CAAC,CAAC,CAAC,IAAI,CAAC,CAAC,GAAG,CAAC,CAAC,CACzD,KAAK,CAAE,IAAI,CACX,MAAM,CAAE,KAAK,CACb,sBAAsB,CAAE,GAAG,CAC3B,uBAAuB,CAAE,GAC1B,CAEA,mCAAQ,CACP,QAAQ,CAAE,QAAQ,CAClB,KAAK,CAAE,IAAI,CACX,MAAM,CAAE,IAAI,CACZ,aAAa,CAAE,GAAG,CAClB,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,KAAK,CAEvB,GAAG,CAAE,IAAI,CACT,IAAI,CAAE,IAAI,CACV,UAAU,CAAE,CAAC,CAAC,GAAG,CAAC,GAAG,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,GAAG,CAAC,CACxC,cAAc,CAAE,IAAI,CACpB,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,oBAAoB,CAC3C,CAEA,yBAAW,CAAG,qBAAQ,CACrB,UAAU,CAAE,CAAC,CAAC,CAAC,CAAC,GAAG,CAAC,IAAI,CACxB,GAAG,CAAE,IAAI,CACT,MAAM,CAAE,IAAI,CACZ,MAAM,CAAE,IAAI,CACZ,KAAK,CAAE,IAAI,CACX,IAAI,CAAE,IAAI,CAEV,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,oBAAoB,CAC3C"}'
};
const ColorPicker = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { color = "rgb(255, 255, 255)" } = $$props;
  let sl_marker_pos = [0, 0];
  let sl_rect = null;
  let hue = 0;
  let hue_marker_pos = 0;
  let hue_rect = null;
  async function update_mouse_from_color(color2) {
    await tick();
    if (!color2)
      return;
    if (!sl_rect) {
      sl_rect = sl_wrap.getBoundingClientRect();
    }
    if (!hue_rect) {
      hue_rect = hue_wrap.getBoundingClientRect();
    }
    const hsva = tinycolor(color2).toHsv();
    const _x = hsva.s * sl_rect.width;
    const _y = (1 - hsva.v) * sl_rect.height;
    sl_marker_pos = [_x, _y];
    [hsva.s, hsva.v];
    hue = hsva.h;
    hue_marker_pos = hsva.h / 360 * hue_rect.width;
  }
  let sl_wrap;
  let hue_wrap;
  let { opacity = 1 } = $$props;
  let opacity_wrap;
  let opacity_rect = null;
  onMount(() => {
    opacity_rect = opacity_wrap.getBoundingClientRect();
  });
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.opacity === void 0 && $$bindings.opacity && opacity !== void 0)
    $$bindings.opacity(opacity);
  $$result.css.add(css$a);
  {
    update_mouse_from_color(color);
  }
  return `  <div class="color-gradient svelte-9hvvq8" style="${"--hue:" + escape(hue, true)}"${add_attribute("this", sl_wrap, 0)}><div class="marker svelte-9hvvq8"${add_styles({
    "transform": `translate(${sl_marker_pos[0]}px,${sl_marker_pos[1]}px)`,
    "background": color
  })}></div></div>  <div class="opacity-slider svelte-9hvvq8" style="${"--color:" + escape(color === "auto" ? "transparent" : color, true)}"${add_attribute("this", opacity_wrap, 0)}><div class="opacity-marker svelte-9hvvq8"${add_styles({
    "background": `white`,
    "transform": `translateX(${opacity * (opacity_rect?.width ?? 1)}px)`
  })}></div></div>  <div class="hue-slider svelte-9hvvq8"${add_attribute("this", hue_wrap, 0)}><div class="marker svelte-9hvvq8"${add_styles({
    "background": "hsl(" + hue + ", 100%, 50%)",
    "transform": `translateX(${hue_marker_pos}px)`
  })}></div> </div>`;
});
const css$9 = {
  code: '.swatch-wrap.svelte-1ngpqve{display:flex;justify-content:space-between;align-items:flex-start;width:205px}span.lg.svelte-1ngpqve{margin-top:var(--spacing-sm)}.swatch-container.svelte-1ngpqve{display:flex;flex-direction:column;gap:10px;width:100%}.swatch.svelte-1ngpqve{display:grid;grid-template-columns:repeat(auto-fill, 25px);gap:8px;justify-content:flex-start;overflow:hidden;justify-content:center}.empty.svelte-1ngpqve{border:1px solid var(--block-border-color);font-weight:var(--weight-bold);display:flex;justify-content:center;align-items:center;padding-top:4px;text-align:center;font-size:var(--scale-0);cursor:pointer}.empty.svelte-1ngpqve::after{content:"+";margin-bottom:var(--size-1)}.color.svelte-1ngpqve{width:25px;height:25px;border-radius:var(--radius-md)}.empty.selected.svelte-1ngpqve,.color.selected.svelte-1ngpqve{border:2px solid var(--color-accent)}.colorpicker.svelte-1ngpqve{border:1px solid var(--block-border-color);background:conic-gradient(\n			red,\n			#ff0 60deg,\n			lime 120deg,\n			cyan 180deg,\n			blue 240deg,\n			magenta 300deg,\n			red 360deg\n		);overflow:hidden;position:relative;color:white;cursor:pointer}.colorpicker.svelte-1ngpqve::before{content:"";position:absolute;width:100%;height:100%;background:rgba(0, 0, 0, 0.6);opacity:1;transition:0.1s;top:0;left:0}.colorpicker.svelte-1ngpqve::after{display:flex;justify-content:center;align-items:center;content:"⨯";color:white;font-size:var(--scale-5);position:absolute;width:100%;height:100%;transform:translateY(-7px);opacity:1;transition:0.1s;top:0}.colorpicker.hidden.svelte-1ngpqve::after,.colorpicker.hidden.svelte-1ngpqve::before{opacity:0}',
  map: '{"version":3,"file":"ColorSwatch.svelte","sources":["ColorSwatch.svelte"],"sourcesContent":["<script lang=\\"ts\\">import tinycolor from \\"tinycolor2\\";\\nimport { createEventDispatcher } from \\"svelte\\";\\nimport IconButton from \\"../IconButton.svelte\\";\\nimport { Plus } from \\"@gradio/icons\\";\\nexport let selected_color;\\nexport let colors;\\nexport let user_colors = [];\\nexport let show_empty = false;\\nexport let current_mode = \\"hex\\";\\nexport let color_picker = false;\\nconst dispatch = createEventDispatcher();\\n$: _colors = show_empty ? colors : colors.filter((c) => c);\\nfunction get_color(color_input) {\\n    if (Array.isArray(color_input)) {\\n        return color_input[0];\\n    }\\n    return color_input;\\n}\\nfunction get_opacity(color_input) {\\n    if (Array.isArray(color_input)) {\\n        return color_input[1];\\n    }\\n    const color = tinycolor(color_input);\\n    return color.getAlpha();\\n}\\nfunction get_formatted_color(color, mode) {\\n    const color_value = get_color(color);\\n    if (mode === \\"hex\\") {\\n        return tinycolor(color_value).toHexString();\\n    }\\n    else if (mode === \\"rgb\\") {\\n        return tinycolor(color_value).toRgbString();\\n    }\\n    return tinycolor(color_value).toHslString();\\n}\\nlet current_index = `select-${colors.findIndex((c) => get_formatted_color(c, current_mode) === get_formatted_color(selected_color, current_mode))}`;\\n$: selected_opacity = get_opacity(selected_color);\\nfunction handle_select(type, detail) {\\n    current_index = `${type}-${detail.index}`;\\n    dispatch(type, detail);\\n}\\nfunction handle_picker_click() {\\n    dispatch(\\"select\\", { index: null, color: selected_color });\\n    color_picker = !color_picker;\\n}\\n<\/script>\\n\\n{#if !color_picker}\\n\\t<span class:lg={user_colors}></span>\\n{/if}\\n\\n<div class=\\"swatch-wrap\\">\\n\\t<div class=\\"swatch-container\\">\\n\\t\\t{#if user_colors}\\n\\t\\t\\t<div class=\\"swatch\\">\\n\\t\\t\\t\\t{#if color_picker}\\n\\t\\t\\t\\t\\t<IconButton\\n\\t\\t\\t\\t\\t\\tIcon={Plus}\\n\\t\\t\\t\\t\\t\\ton:click={() => dispatch(\\"add_color\\")}\\n\\t\\t\\t\\t\\t\\troundedness=\\"very\\"\\n\\t\\t\\t\\t\\t\\tbackground={get_color(selected_color)}\\n\\t\\t\\t\\t\\t\\tcolor=\\"white\\"\\n\\t\\t\\t\\t\\t/>\\n\\t\\t\\t\\t{/if}\\n\\t\\t\\t\\t{#each user_colors as color, i}\\n\\t\\t\\t\\t\\t{@const color_string = get_color(color)}\\n\\t\\t\\t\\t\\t{@const opacity = get_opacity(color)}\\n\\t\\t\\t\\t\\t<button\\n\\t\\t\\t\\t\\t\\ton:click={() =>\\n\\t\\t\\t\\t\\t\\t\\thandle_select(\\"edit\\", {\\n\\t\\t\\t\\t\\t\\t\\t\\tindex: i,\\n\\t\\t\\t\\t\\t\\t\\t\\tcolor: color_string,\\n\\t\\t\\t\\t\\t\\t\\t\\topacity: opacity\\n\\t\\t\\t\\t\\t\\t\\t})}\\n\\t\\t\\t\\t\\t\\tclass=\\"color\\"\\n\\t\\t\\t\\t\\t\\tclass:empty={color === null}\\n\\t\\t\\t\\t\\t\\tstyle=\\"background-color: {color_string}\\"\\n\\t\\t\\t\\t\\t\\tstyle:opacity\\n\\t\\t\\t\\t\\t\\tclass:selected={`${color_string}-${opacity}` ===\\n\\t\\t\\t\\t\\t\\t\\t`${selected_color}-${selected_opacity}`}\\n\\t\\t\\t\\t\\t></button>\\n\\t\\t\\t\\t{/each}\\n\\n\\t\\t\\t\\t<button\\n\\t\\t\\t\\t\\ton:click={handle_picker_click}\\n\\t\\t\\t\\t\\tclass=\\"color colorpicker\\"\\n\\t\\t\\t\\t\\tclass:hidden={!color_picker}\\n\\t\\t\\t\\t></button>\\n\\t\\t\\t</div>\\n\\t\\t{/if}\\n\\t\\t<menu class=\\"swatch\\">\\n\\t\\t\\t{#each _colors as color_item, i}\\n\\t\\t\\t\\t{@const color_string = get_color(color_item)}\\n\\t\\t\\t\\t{@const opacity = get_opacity(color_item)}\\n\\t\\t\\t\\t<button\\n\\t\\t\\t\\t\\ton:click={() =>\\n\\t\\t\\t\\t\\t\\thandle_select(\\"select\\", {\\n\\t\\t\\t\\t\\t\\t\\tindex: i,\\n\\t\\t\\t\\t\\t\\t\\tcolor: color_string,\\n\\t\\t\\t\\t\\t\\t\\topacity: opacity\\n\\t\\t\\t\\t\\t\\t})}\\n\\t\\t\\t\\t\\tclass=\\"color\\"\\n\\t\\t\\t\\t\\tclass:empty={color_item === null}\\n\\t\\t\\t\\t\\tstyle=\\"background-color: {color_string}\\"\\n\\t\\t\\t\\t\\tstyle:opacity\\n\\t\\t\\t\\t\\tclass:selected={`${color_string}-${opacity}` ===\\n\\t\\t\\t\\t\\t\\t`${selected_color}-${selected_opacity}`}\\n\\t\\t\\t\\t></button>\\n\\t\\t\\t{/each}\\n\\t\\t</menu>\\n\\t</div>\\n</div>\\n\\n<style>\\n\\t.swatch-wrap {\\n\\t\\tdisplay: flex;\\n\\t\\tjustify-content: space-between;\\n\\t\\talign-items: flex-start;\\n\\t\\t/* max-width: 200px; */\\n\\t\\twidth: 205px;\\n\\t}\\n\\n\\tspan.lg {\\n\\t\\tmargin-top: var(--spacing-sm);\\n\\t}\\n\\t.swatch-container {\\n\\t\\tdisplay: flex;\\n\\t\\tflex-direction: column;\\n\\t\\tgap: 10px;\\n\\t\\twidth: 100%;\\n\\t}\\n\\t.swatch {\\n\\t\\tdisplay: grid;\\n\\t\\tgrid-template-columns: repeat(auto-fill, 25px);\\n\\t\\tgap: 8px;\\n\\t\\tjustify-content: flex-start;\\n\\n\\t\\toverflow: hidden;\\n\\t\\tjustify-content: center;\\n\\t}\\n\\n\\t.empty {\\n\\t\\tborder: 1px solid var(--block-border-color);\\n\\t\\tfont-weight: var(--weight-bold);\\n\\t\\tdisplay: flex;\\n\\t\\tjustify-content: center;\\n\\t\\talign-items: center;\\n\\t\\tpadding-top: 4px;\\n\\t\\ttext-align: center;\\n\\t\\tfont-size: var(--scale-0);\\n\\t\\tcursor: pointer;\\n\\t}\\n\\n\\t.empty::after {\\n\\t\\tcontent: \\"+\\";\\n\\t\\tmargin-bottom: var(--size-1);\\n\\t}\\n\\n\\t.color {\\n\\t\\twidth: 25px;\\n\\t\\theight: 25px;\\n\\t\\tborder-radius: var(--radius-md);\\n\\t}\\n\\n\\t.empty.selected,\\n\\t.color.selected {\\n\\t\\tborder: 2px solid var(--color-accent);\\n\\t}\\n\\n\\t.colorpicker {\\n\\t\\tborder: 1px solid var(--block-border-color);\\n\\n\\t\\tbackground: conic-gradient(\\n\\t\\t\\tred,\\n\\t\\t\\t#ff0 60deg,\\n\\t\\t\\tlime 120deg,\\n\\t\\t\\tcyan 180deg,\\n\\t\\t\\tblue 240deg,\\n\\t\\t\\tmagenta 300deg,\\n\\t\\t\\tred 360deg\\n\\t\\t);\\n\\t\\toverflow: hidden;\\n\\t\\tposition: relative;\\n\\t\\tcolor: white;\\n\\t\\tcursor: pointer;\\n\\t}\\n\\n\\t.colorpicker::before {\\n\\t\\tcontent: \\"\\";\\n\\t\\tposition: absolute;\\n\\t\\twidth: 100%;\\n\\t\\theight: 100%;\\n\\t\\tbackground: rgba(0, 0, 0, 0.6);\\n\\t\\topacity: 1;\\n\\t\\ttransition: 0.1s;\\n\\t\\ttop: 0;\\n\\t\\tleft: 0;\\n\\t}\\n\\n\\t.colorpicker::after {\\n\\t\\tdisplay: flex;\\n\\t\\tjustify-content: center;\\n\\t\\talign-items: center;\\n\\t\\tcontent: \\"⨯\\";\\n\\t\\tcolor: white;\\n\\t\\tfont-size: var(--scale-5);\\n\\t\\tposition: absolute;\\n\\t\\twidth: 100%;\\n\\t\\theight: 100%;\\n\\t\\ttransform: translateY(-7px);\\n\\t\\topacity: 1;\\n\\t\\ttransition: 0.1s;\\n\\t\\ttop: 0;\\n\\t}\\n\\n\\t.colorpicker.hidden::after,\\n\\t.colorpicker.hidden::before {\\n\\t\\topacity: 0;\\n\\t}</style>\\n"],"names":[],"mappings":"AAkHC,2BAAa,CACZ,OAAO,CAAE,IAAI,CACb,eAAe,CAAE,aAAa,CAC9B,WAAW,CAAE,UAAU,CAEvB,KAAK,CAAE,KACR,CAEA,IAAI,kBAAI,CACP,UAAU,CAAE,IAAI,YAAY,CAC7B,CACA,gCAAkB,CACjB,OAAO,CAAE,IAAI,CACb,cAAc,CAAE,MAAM,CACtB,GAAG,CAAE,IAAI,CACT,KAAK,CAAE,IACR,CACA,sBAAQ,CACP,OAAO,CAAE,IAAI,CACb,qBAAqB,CAAE,OAAO,SAAS,CAAC,CAAC,IAAI,CAAC,CAC9C,GAAG,CAAE,GAAG,CACR,eAAe,CAAE,UAAU,CAE3B,QAAQ,CAAE,MAAM,CAChB,eAAe,CAAE,MAClB,CAEA,qBAAO,CACN,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,oBAAoB,CAAC,CAC3C,WAAW,CAAE,IAAI,aAAa,CAAC,CAC/B,OAAO,CAAE,IAAI,CACb,eAAe,CAAE,MAAM,CACvB,WAAW,CAAE,MAAM,CACnB,WAAW,CAAE,GAAG,CAChB,UAAU,CAAE,MAAM,CAClB,SAAS,CAAE,IAAI,SAAS,CAAC,CACzB,MAAM,CAAE,OACT,CAEA,qBAAM,OAAQ,CACb,OAAO,CAAE,GAAG,CACZ,aAAa,CAAE,IAAI,QAAQ,CAC5B,CAEA,qBAAO,CACN,KAAK,CAAE,IAAI,CACX,MAAM,CAAE,IAAI,CACZ,aAAa,CAAE,IAAI,WAAW,CAC/B,CAEA,MAAM,wBAAS,CACf,MAAM,wBAAU,CACf,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,cAAc,CACrC,CAEA,2BAAa,CACZ,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,oBAAoB,CAAC,CAE3C,UAAU,CAAE;AACd,GAAG,GAAG,CAAC;AACP,GAAG,IAAI,CAAC,KAAK,CAAC;AACd,GAAG,IAAI,CAAC,MAAM,CAAC;AACf,GAAG,IAAI,CAAC,MAAM,CAAC;AACf,GAAG,IAAI,CAAC,MAAM,CAAC;AACf,GAAG,OAAO,CAAC,MAAM,CAAC;AAClB,GAAG,GAAG,CAAC,MAAM;AACb,GAAG,CACD,QAAQ,CAAE,MAAM,CAChB,QAAQ,CAAE,QAAQ,CAClB,KAAK,CAAE,KAAK,CACZ,MAAM,CAAE,OACT,CAEA,2BAAY,QAAS,CACpB,OAAO,CAAE,EAAE,CACX,QAAQ,CAAE,QAAQ,CAClB,KAAK,CAAE,IAAI,CACX,MAAM,CAAE,IAAI,CACZ,UAAU,CAAE,KAAK,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,GAAG,CAAC,CAC9B,OAAO,CAAE,CAAC,CACV,UAAU,CAAE,IAAI,CAChB,GAAG,CAAE,CAAC,CACN,IAAI,CAAE,CACP,CAEA,2BAAY,OAAQ,CACnB,OAAO,CAAE,IAAI,CACb,eAAe,CAAE,MAAM,CACvB,WAAW,CAAE,MAAM,CACnB,OAAO,CAAE,GAAG,CACZ,KAAK,CAAE,KAAK,CACZ,SAAS,CAAE,IAAI,SAAS,CAAC,CACzB,QAAQ,CAAE,QAAQ,CAClB,KAAK,CAAE,IAAI,CACX,MAAM,CAAE,IAAI,CACZ,SAAS,CAAE,WAAW,IAAI,CAAC,CAC3B,OAAO,CAAE,CAAC,CACV,UAAU,CAAE,IAAI,CAChB,GAAG,CAAE,CACN,CAEA,YAAY,sBAAO,OAAO,CAC1B,YAAY,sBAAO,QAAS,CAC3B,OAAO,CAAE,CACV"}'
};
function get_color(color_input) {
  if (Array.isArray(color_input)) {
    return color_input[0];
  }
  return color_input;
}
const ColorSwatch = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let _colors;
  let selected_opacity;
  let { selected_color } = $$props;
  let { colors } = $$props;
  let { user_colors = [] } = $$props;
  let { show_empty = false } = $$props;
  let { current_mode = "hex" } = $$props;
  let { color_picker = false } = $$props;
  createEventDispatcher();
  function get_opacity(color_input) {
    if (Array.isArray(color_input)) {
      return color_input[1];
    }
    const color = tinycolor(color_input);
    return color.getAlpha();
  }
  function get_formatted_color(color, mode) {
    const color_value = get_color(color);
    if (mode === "hex") {
      return tinycolor(color_value).toHexString();
    } else if (mode === "rgb") {
      return tinycolor(color_value).toRgbString();
    }
    return tinycolor(color_value).toHslString();
  }
  `select-${colors.findIndex((c2) => get_formatted_color(c2, current_mode) === get_formatted_color(selected_color, current_mode))}`;
  if ($$props.selected_color === void 0 && $$bindings.selected_color && selected_color !== void 0)
    $$bindings.selected_color(selected_color);
  if ($$props.colors === void 0 && $$bindings.colors && colors !== void 0)
    $$bindings.colors(colors);
  if ($$props.user_colors === void 0 && $$bindings.user_colors && user_colors !== void 0)
    $$bindings.user_colors(user_colors);
  if ($$props.show_empty === void 0 && $$bindings.show_empty && show_empty !== void 0)
    $$bindings.show_empty(show_empty);
  if ($$props.current_mode === void 0 && $$bindings.current_mode && current_mode !== void 0)
    $$bindings.current_mode(current_mode);
  if ($$props.color_picker === void 0 && $$bindings.color_picker && color_picker !== void 0)
    $$bindings.color_picker(color_picker);
  $$result.css.add(css$9);
  _colors = show_empty ? colors : colors.filter((c2) => c2);
  selected_opacity = get_opacity(selected_color);
  return `${!color_picker ? `<span class="${["svelte-1ngpqve", user_colors ? "lg" : ""].join(" ").trim()}"></span>` : ``} <div class="swatch-wrap svelte-1ngpqve"><div class="swatch-container svelte-1ngpqve">${user_colors ? `<div class="swatch svelte-1ngpqve">${color_picker ? `${validate_component(IconButton, "IconButton").$$render(
    $$result,
    {
      Icon: Plus,
      roundedness: "very",
      background: get_color(selected_color),
      color: "white"
    },
    {},
    {}
  )}` : ``} ${each(user_colors, (color, i2) => {
    let color_string = get_color(color), opacity = get_opacity(color);
    return `  <button class="${[
      "color svelte-1ngpqve",
      (color === null ? "empty" : "") + " " + (`${color_string}-${opacity}` === `${selected_color}-${selected_opacity}` ? "selected" : "")
    ].join(" ").trim()}"${add_styles(merge_ssr_styles("background-color: " + escape(color_string, true), { opacity }))}></button>`;
  })} <button class="${["color colorpicker svelte-1ngpqve", !color_picker ? "hidden" : ""].join(" ").trim()}"></button></div>` : ``} <menu class="swatch svelte-1ngpqve">${each(_colors, (color_item, i2) => {
    let color_string = get_color(color_item), opacity = get_opacity(color_item);
    return `  <button class="${[
      "color svelte-1ngpqve",
      (color_item === null ? "empty" : "") + " " + (`${color_string}-${opacity}` === `${selected_color}-${selected_opacity}` ? "selected" : "")
    ].join(" ").trim()}"${add_styles(merge_ssr_styles("background-color: " + escape(color_string, true), { opacity }))}></button>`;
  })}</menu></div> </div>`;
});
const css$8 = {
  code: ".input.svelte-w84deg.svelte-w84deg{display:flex;align-items:center;padding:0 10px 15px}.input.svelte-w84deg input.svelte-w84deg{height:30px;width:100%;flex-shrink:1;border-bottom-left-radius:0;border:1px solid var(--block-border-color);letter-spacing:-0.05rem;border-left:none;border-right:none;font-family:var(--font-mono);font-size:var(--scale-000);padding-left:15px;padding-right:0;background-color:var(--background-fill-secondary);color:var(--block-label-text-color)}.swatch.svelte-w84deg.svelte-w84deg{width:50px;height:50px;border-top-left-radius:15px;border-bottom-left-radius:15px;flex-shrink:0;border:1px solid var(--block-border-color)}.buttons.svelte-w84deg button.svelte-w84deg{display:flex;align-items:center;justify-content:center;border:1px solid var(--block-border-color);background:var(--background-fill-secondary);padding:3px 6px;font-size:var(--scale-000);cursor:pointer;border-right:none;width:100%;border-top:none}.buttons.svelte-w84deg button.svelte-w84deg:first-child{border-left:none}.buttons.svelte-w84deg button.svelte-w84deg:last-child{border-bottom-right-radius:15px;border-right:1px solid var(--block-border-color)}.buttons.svelte-w84deg button.svelte-w84deg:hover{background:var(--background-fill-secondary-hover);font-weight:var(--weight-bold)}.buttons.svelte-w84deg button.active.svelte-w84deg{background:var(--background-fill-secondary);font-weight:var(--weight-bold)}.buttons.svelte-w84deg.svelte-w84deg{height:20px;display:flex;justify-content:stretch;gap:0px}.input-wrap.svelte-w84deg.svelte-w84deg{display:flex}.eyedropper.svelte-w84deg.svelte-w84deg{display:flex;align-items:center;justify-content:center;width:25px;height:30px;border-top-right-radius:15px;border:1px solid var(--block-border-color);border-left:none;background:var(--background-fill-secondary);height:30px;padding:7px 7px 5px 0px;cursor:pointer}",
  map: '{"version":3,"file":"ColorField.svelte","sources":["ColorField.svelte"],"sourcesContent":["<script lang=\\"ts\\">import { Eyedropper, Plus } from \\"@gradio/icons\\";\\nimport { createEventDispatcher } from \\"svelte\\";\\nimport tinycolor from \\"tinycolor2\\";\\nimport IconButton from \\"../IconButton.svelte\\";\\nexport let color;\\nexport let current_mode = \\"hex\\";\\nconst dispatch = createEventDispatcher();\\nconst modes = [\\n    [\\"Hex\\", \\"hex\\"],\\n    [\\"RGB\\", \\"rgb\\"],\\n    [\\"HSL\\", \\"hsl\\"]\\n];\\nfunction format_color(color2, mode) {\\n    if (mode === \\"hex\\") {\\n        return tinycolor(color2).toHexString();\\n    }\\n    else if (mode === \\"rgb\\") {\\n        return tinycolor(color2).toRgbString();\\n    }\\n    return tinycolor(color2).toHslString();\\n}\\n$: color_string = format_color(color, current_mode);\\n$: color_string && dispatch(\\"selected\\", color_string);\\nfunction request_eyedropper() {\\n    const eyeDropper = new EyeDropper();\\n    eyeDropper.open().then((result) => {\\n        color = result.sRGBHex;\\n    });\\n}\\nconst eyedropper_supported = !!window.EyeDropper;\\nfunction handle_click() {\\n    dispatch(\\"selected\\", color_string);\\n    dispatch(\\"close\\");\\n}\\n<\/script>\\n\\n<div class=\\"input\\">\\n\\t<button class=\\"swatch\\" style:background={color} on:click={handle_click}\\n\\t></button>\\n\\t<div>\\n\\t\\t<div class=\\"input-wrap\\">\\n\\t\\t\\t<input\\n\\t\\t\\t\\ttype=\\"text\\"\\n\\t\\t\\t\\tvalue={color_string}\\n\\t\\t\\t\\ton:change={(e) => (color = e.currentTarget.value)}\\n\\t\\t\\t/>\\n\\n\\t\\t\\t<button class=\\"eyedropper\\" on:click={request_eyedropper}>\\n\\t\\t\\t\\t{#if eyedropper_supported}\\n\\t\\t\\t\\t\\t<Eyedropper />\\n\\t\\t\\t\\t{/if}\\n\\t\\t\\t</button>\\n\\t\\t</div>\\n\\t\\t<div class=\\"buttons\\">\\n\\t\\t\\t{#each modes as [label, value]}\\n\\t\\t\\t\\t<button\\n\\t\\t\\t\\t\\tclass=\\"button\\"\\n\\t\\t\\t\\t\\tclass:active={current_mode === value}\\n\\t\\t\\t\\t\\ton:click={() => (current_mode = value)}>{label}</button\\n\\t\\t\\t\\t>\\n\\t\\t\\t{/each}\\n\\t\\t</div>\\n\\t</div>\\n</div>\\n\\n<style>\\n\\t.input {\\n\\t\\tdisplay: flex;\\n\\t\\talign-items: center;\\n\\t\\tpadding: 0 10px 15px;\\n\\t}\\n\\n\\t.input input {\\n\\t\\theight: 30px;\\n\\t\\twidth: 100%;\\n\\t\\tflex-shrink: 1;\\n\\t\\tborder-bottom-left-radius: 0;\\n\\t\\tborder: 1px solid var(--block-border-color);\\n\\t\\tletter-spacing: -0.05rem;\\n\\t\\tborder-left: none;\\n\\t\\tborder-right: none;\\n\\t\\tfont-family: var(--font-mono);\\n\\t\\tfont-size: var(--scale-000);\\n\\t\\tpadding-left: 15px;\\n\\t\\tpadding-right: 0;\\n\\t\\tbackground-color: var(--background-fill-secondary);\\n\\t\\tcolor: var(--block-label-text-color);\\n\\t}\\n\\n\\t.swatch {\\n\\t\\twidth: 50px;\\n\\t\\theight: 50px;\\n\\t\\tborder-top-left-radius: 15px;\\n\\t\\tborder-bottom-left-radius: 15px;\\n\\t\\tflex-shrink: 0;\\n\\t\\tborder: 1px solid var(--block-border-color);\\n\\t}\\n\\n\\t.buttons button {\\n\\t\\tdisplay: flex;\\n\\t\\talign-items: center;\\n\\t\\tjustify-content: center;\\n\\t\\tborder: 1px solid var(--block-border-color);\\n\\t\\tbackground: var(--background-fill-secondary);\\n\\t\\tpadding: 3px 6px;\\n\\t\\tfont-size: var(--scale-000);\\n\\t\\tcursor: pointer;\\n\\t\\tborder-right: none;\\n\\t\\twidth: 100%;\\n\\t\\tborder-top: none;\\n\\t}\\n\\n\\t.buttons button:first-child {\\n\\t\\tborder-left: none;\\n\\t}\\n\\n\\t.buttons button:last-child {\\n\\t\\tborder-bottom-right-radius: 15px;\\n\\t\\tborder-right: 1px solid var(--block-border-color);\\n\\t}\\n\\n\\t.buttons button:hover {\\n\\t\\tbackground: var(--background-fill-secondary-hover);\\n\\t\\tfont-weight: var(--weight-bold);\\n\\t}\\n\\n\\t.buttons button.active {\\n\\t\\tbackground: var(--background-fill-secondary);\\n\\t\\tfont-weight: var(--weight-bold);\\n\\t}\\n\\n\\t.buttons {\\n\\t\\theight: 20px;\\n\\n\\t\\tdisplay: flex;\\n\\t\\tjustify-content: stretch;\\n\\t\\tgap: 0px;\\n\\t\\t/* padding: 0 10px; */\\n\\t}\\n\\n\\t.input-wrap {\\n\\t\\tdisplay: flex;\\n\\t}\\n\\n\\t.eyedropper {\\n\\t\\tdisplay: flex;\\n\\t\\talign-items: center;\\n\\t\\tjustify-content: center;\\n\\t\\twidth: 25px;\\n\\t\\theight: 30px;\\n\\t\\tborder-top-right-radius: 15px;\\n\\t\\tborder: 1px solid var(--block-border-color);\\n\\t\\tborder-left: none;\\n\\t\\tbackground: var(--background-fill-secondary);\\n\\t\\theight: 30px;\\n\\t\\tpadding: 7px 7px 5px 0px;\\n\\t\\tcursor: pointer;\\n\\t}</style>\\n"],"names":[],"mappings":"AAkEC,kCAAO,CACN,OAAO,CAAE,IAAI,CACb,WAAW,CAAE,MAAM,CACnB,OAAO,CAAE,CAAC,CAAC,IAAI,CAAC,IACjB,CAEA,oBAAM,CAAC,mBAAM,CACZ,MAAM,CAAE,IAAI,CACZ,KAAK,CAAE,IAAI,CACX,WAAW,CAAE,CAAC,CACd,yBAAyB,CAAE,CAAC,CAC5B,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,oBAAoB,CAAC,CAC3C,cAAc,CAAE,QAAQ,CACxB,WAAW,CAAE,IAAI,CACjB,YAAY,CAAE,IAAI,CAClB,WAAW,CAAE,IAAI,WAAW,CAAC,CAC7B,SAAS,CAAE,IAAI,WAAW,CAAC,CAC3B,YAAY,CAAE,IAAI,CAClB,aAAa,CAAE,CAAC,CAChB,gBAAgB,CAAE,IAAI,2BAA2B,CAAC,CAClD,KAAK,CAAE,IAAI,wBAAwB,CACpC,CAEA,mCAAQ,CACP,KAAK,CAAE,IAAI,CACX,MAAM,CAAE,IAAI,CACZ,sBAAsB,CAAE,IAAI,CAC5B,yBAAyB,CAAE,IAAI,CAC/B,WAAW,CAAE,CAAC,CACd,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,oBAAoB,CAC3C,CAEA,sBAAQ,CAAC,oBAAO,CACf,OAAO,CAAE,IAAI,CACb,WAAW,CAAE,MAAM,CACnB,eAAe,CAAE,MAAM,CACvB,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,oBAAoB,CAAC,CAC3C,UAAU,CAAE,IAAI,2BAA2B,CAAC,CAC5C,OAAO,CAAE,GAAG,CAAC,GAAG,CAChB,SAAS,CAAE,IAAI,WAAW,CAAC,CAC3B,MAAM,CAAE,OAAO,CACf,YAAY,CAAE,IAAI,CAClB,KAAK,CAAE,IAAI,CACX,UAAU,CAAE,IACb,CAEA,sBAAQ,CAAC,oBAAM,YAAa,CAC3B,WAAW,CAAE,IACd,CAEA,sBAAQ,CAAC,oBAAM,WAAY,CAC1B,0BAA0B,CAAE,IAAI,CAChC,YAAY,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,oBAAoB,CACjD,CAEA,sBAAQ,CAAC,oBAAM,MAAO,CACrB,UAAU,CAAE,IAAI,iCAAiC,CAAC,CAClD,WAAW,CAAE,IAAI,aAAa,CAC/B,CAEA,sBAAQ,CAAC,MAAM,qBAAQ,CACtB,UAAU,CAAE,IAAI,2BAA2B,CAAC,CAC5C,WAAW,CAAE,IAAI,aAAa,CAC/B,CAEA,oCAAS,CACR,MAAM,CAAE,IAAI,CAEZ,OAAO,CAAE,IAAI,CACb,eAAe,CAAE,OAAO,CACxB,GAAG,CAAE,GAEN,CAEA,uCAAY,CACX,OAAO,CAAE,IACV,CAEA,uCAAY,CACX,OAAO,CAAE,IAAI,CACb,WAAW,CAAE,MAAM,CACnB,eAAe,CAAE,MAAM,CACvB,KAAK,CAAE,IAAI,CACX,MAAM,CAAE,IAAI,CACZ,uBAAuB,CAAE,IAAI,CAC7B,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,oBAAoB,CAAC,CAC3C,WAAW,CAAE,IAAI,CACjB,UAAU,CAAE,IAAI,2BAA2B,CAAC,CAC5C,MAAM,CAAE,IAAI,CACZ,OAAO,CAAE,GAAG,CAAC,GAAG,CAAC,GAAG,CAAC,GAAG,CACxB,MAAM,CAAE,OACT"}'
};
const ColorField = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let color_string;
  let { color } = $$props;
  let { current_mode = "hex" } = $$props;
  const dispatch = createEventDispatcher();
  const modes = [["Hex", "hex"], ["RGB", "rgb"], ["HSL", "hsl"]];
  function format_color(color2, mode) {
    if (mode === "hex") {
      return tinycolor(color2).toHexString();
    } else if (mode === "rgb") {
      return tinycolor(color2).toRgbString();
    }
    return tinycolor(color2).toHslString();
  }
  const eyedropper_supported = !!window.EyeDropper;
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.current_mode === void 0 && $$bindings.current_mode && current_mode !== void 0)
    $$bindings.current_mode(current_mode);
  $$result.css.add(css$8);
  color_string = format_color(color, current_mode);
  color_string && dispatch("selected", color_string);
  return `<div class="input svelte-w84deg"><button class="swatch svelte-w84deg"${add_styles({ "background": color })}></button> <div><div class="input-wrap svelte-w84deg"><input type="text"${add_attribute("value", color_string, 0)} class="svelte-w84deg"> <button class="eyedropper svelte-w84deg">${eyedropper_supported ? `${validate_component(Eyedropper, "Eyedropper").$$render($$result, {}, {}, {})}` : ``}</button></div> <div class="buttons svelte-w84deg">${each(modes, ([label, value]) => {
    return `<button class="${["button svelte-w84deg", current_mode === value ? "active" : ""].join(" ").trim()}">${escape(label)}</button>`;
  })}</div></div> </div>`;
});
const css$7 = {
  code: ".wrap.svelte-1ktybyw{width:230px;display:flex;gap:var(--size-4);background:var(--background-fill-secondary);padding:0 var(--size-4);cursor:default;padding-top:var(--size-2-5)}input.svelte-1ktybyw{width:100%}span.svelte-1ktybyw{width:26px;color:var(--body-text-color)}",
  map: '{"version":3,"file":"BrushSize.svelte","sources":["BrushSize.svelte"],"sourcesContent":["<script lang=\\"ts\\">import { click_outside } from \\"../utils/events\\";\\nimport { createEventDispatcher } from \\"svelte\\";\\nimport { BrushSize } from \\"@gradio/icons\\";\\nexport let selected_size;\\nexport let min;\\nexport let max;\\nconst dispatch = createEventDispatcher();\\n<\/script>\\n\\n<div class=\\"wrap\\" use:click_outside={() => dispatch(\\"click_outside\\")}>\\n\\t<span>\\n\\t\\t<BrushSize />\\n\\t</span>\\n\\t<input type=\\"range\\" bind:value={selected_size} {min} {max} step={1} />\\n</div>\\n\\n<style>\\n\\t.wrap {\\n\\t\\twidth: 230px;\\n\\t\\tdisplay: flex;\\n\\t\\tgap: var(--size-4);\\n\\t\\tbackground: var(--background-fill-secondary);\\n\\t\\tpadding: 0 var(--size-4);\\n\\t\\tcursor: default;\\n\\t\\tpadding-top: var(--size-2-5);\\n\\t}\\n\\n\\tinput {\\n\\t\\twidth: 100%;\\n\\t}\\n\\tspan {\\n\\t\\twidth: 26px;\\n\\t\\tcolor: var(--body-text-color);\\n\\t}</style>\\n"],"names":[],"mappings":"AAiBC,oBAAM,CACL,KAAK,CAAE,KAAK,CACZ,OAAO,CAAE,IAAI,CACb,GAAG,CAAE,IAAI,QAAQ,CAAC,CAClB,UAAU,CAAE,IAAI,2BAA2B,CAAC,CAC5C,OAAO,CAAE,CAAC,CAAC,IAAI,QAAQ,CAAC,CACxB,MAAM,CAAE,OAAO,CACf,WAAW,CAAE,IAAI,UAAU,CAC5B,CAEA,oBAAM,CACL,KAAK,CAAE,IACR,CACA,mBAAK,CACJ,KAAK,CAAE,IAAI,CACX,KAAK,CAAE,IAAI,iBAAiB,CAC7B"}'
};
const BrushSize_1 = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { selected_size } = $$props;
  let { min } = $$props;
  let { max } = $$props;
  createEventDispatcher();
  if ($$props.selected_size === void 0 && $$bindings.selected_size && selected_size !== void 0)
    $$bindings.selected_size(selected_size);
  if ($$props.min === void 0 && $$bindings.min && min !== void 0)
    $$bindings.min(min);
  if ($$props.max === void 0 && $$bindings.max && max !== void 0)
    $$bindings.max(max);
  $$result.css.add(css$7);
  return `<div class="wrap svelte-1ktybyw"><span class="svelte-1ktybyw">${validate_component(BrushSize, "BrushSize").$$render($$result, {}, {}, {})}</span> <input type="range"${add_attribute("min", min, 0)}${add_attribute("max", max, 0)}${add_attribute("step", 1, 0)} class="svelte-1ktybyw"${add_attribute("value", selected_size, 0)}> </div>`;
});
const css$6 = {
  code: ".wrap.svelte-qigu2l{max-width:230px;position:absolute;display:flex;flex-direction:column;gap:5px;background:var(--background-fill-secondary);border:1px solid var(--block-border-color);border-radius:var(--radius-md);box-shadow:0px 0px 5px 0px rgba(0, 0, 0, 0.1);padding-bottom:var(--size-2);pointer-events:all;cursor:default;z-index:var(--layer-top);overflow:hidden;top:0;transform:translate(35px, -12px)}.color_picker.svelte-qigu2l{transform:translate(35px, -50%)}.size_picker.svelte-qigu2l{transform:translate(35px, 18px)}.eraser_picker.svelte-qigu2l{transform:translate(35px, -7px)}",
  map: '{"version":3,"file":"BrushOptions.svelte","sources":["BrushOptions.svelte"],"sourcesContent":["<script lang=\\"ts\\">import { createEventDispatcher, tick } from \\"svelte\\";\\nimport { click_outside } from \\"../utils/events\\";\\nimport {} from \\"./types\\";\\nimport ColorPicker from \\"./ColorPicker.svelte\\";\\nimport ColorSwatch from \\"./ColorSwatch.svelte\\";\\nimport ColorField from \\"./ColorField.svelte\\";\\nimport BrushSize from \\"./BrushSize.svelte\\";\\nexport let colors;\\nexport let selected_color;\\nexport let color_mode = void 0;\\nexport let recent_colors = [];\\nexport let selected_size;\\nexport let selected_opacity;\\nexport let show_swatch;\\nexport let show_size;\\nexport let mode = \\"brush\\";\\nlet color_picker = false;\\nlet current_mode = \\"hex\\";\\nlet editing_index = null;\\nconst dispatch = createEventDispatcher();\\nfunction handle_color_selection({ index, color, opacity }, type) {\\n    if (type === \\"user\\" && !color) {\\n        editing_index = index;\\n        color_picker = true;\\n    }\\n    if (!color)\\n        return;\\n    selected_color = color;\\n    if (opacity !== void 0) {\\n        selected_opacity = opacity;\\n    }\\n    if (type === \\"core\\") {\\n        color_picker = false;\\n    }\\n}\\nfunction handle_color_change(color) {\\n    if (editing_index === null)\\n        return;\\n    recent_colors[editing_index] = color;\\n}\\n$: handle_color_change(selected_color);\\nlet width = 0;\\nlet height = 0;\\nfunction debounce(func, delay) {\\n    let timeout;\\n    return function (...args) {\\n        clearTimeout(timeout);\\n        timeout = setTimeout(() => func(...args), delay);\\n    };\\n}\\nexport let preview = false;\\nfunction handle_preview() {\\n    if (!preview) {\\n        preview = true;\\n        debounced_close_preview();\\n    }\\n    else {\\n        debounced_close_preview();\\n    }\\n}\\nfunction handle_close_preview() {\\n    preview = false;\\n}\\nconst debounced_close_preview = debounce(handle_close_preview, 1e3);\\n$: selected_size, selected_color, handle_preview();\\nfunction handle_select(color) {\\n    selected_color = color;\\n}\\nfunction handle_add_color() {\\n    if (recent_colors.length >= 5) {\\n        recent_colors.pop();\\n    }\\n    if (recent_colors.some((color) => {\\n        if (Array.isArray(color)) {\\n            return color[0] === selected_color && color[1] === selected_opacity;\\n        }\\n        return color === selected_color;\\n    })) {\\n        return;\\n    }\\n    recent_colors.push([selected_color, selected_opacity]);\\n    recent_colors = recent_colors;\\n}\\n<\/script>\\n\\n<svelte:window bind:innerHeight={height} bind:innerWidth={width} />\\n\\n<div\\n\\tclass=\\"wrap\\"\\n\\tclass:padded={!color_picker}\\n\\tuse:click_outside={() => dispatch(\\"click_outside\\")}\\n\\tclass:color_picker\\n\\tclass:size_picker={show_size && mode === \\"brush\\"}\\n\\tclass:eraser_picker={mode === \\"eraser\\"}\\n>\\n\\t{#if color_mode === \\"defaults\\"}\\n\\t\\t{#if color_picker}\\n\\t\\t\\t<ColorPicker\\n\\t\\t\\t\\tbind:color={selected_color}\\n\\t\\t\\t\\tbind:opacity={selected_opacity}\\n\\t\\t\\t/>\\n\\t\\t\\t<ColorField\\n\\t\\t\\t\\tbind:current_mode\\n\\t\\t\\t\\tcolor={selected_color}\\n\\t\\t\\t\\ton:close={() => (color_picker = false)}\\n\\t\\t\\t\\ton:selected={({ detail }) => handle_select(detail)}\\n\\t\\t\\t/>\\n\\t\\t{/if}\\n\\t{/if}\\n\\t{#if show_swatch}\\n\\t\\t<ColorSwatch\\n\\t\\t\\tbind:color_picker\\n\\t\\t\\t{colors}\\n\\t\\t\\ton:select={({ detail }) => handle_color_selection(detail, \\"core\\")}\\n\\t\\t\\ton:edit={({ detail }) => handle_color_selection(detail, \\"user\\")}\\n\\t\\t\\tuser_colors={color_mode === \\"defaults\\" ? recent_colors : null}\\n\\t\\t\\t{selected_color}\\n\\t\\t\\t{current_mode}\\n\\t\\t\\ton:add_color={handle_add_color}\\n\\t\\t/>\\n\\t{/if}\\n\\n\\t{#if show_size}\\n\\t\\t<BrushSize max={100} min={1} bind:selected_size />\\n\\t{/if}\\n</div>\\n\\n<style>\\n\\t.wrap {\\n\\t\\tmax-width: 230px;\\n\\t\\t/* width: 90%; */\\n\\t\\tposition: absolute;\\n\\t\\tdisplay: flex;\\n\\t\\tflex-direction: column;\\n\\t\\tgap: 5px;\\n\\t\\tbackground: var(--background-fill-secondary);\\n\\t\\tborder: 1px solid var(--block-border-color);\\n\\t\\tborder-radius: var(--radius-md);\\n\\t\\tbox-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);\\n\\t\\tpadding-bottom: var(--size-2);\\n\\t\\tpointer-events: all;\\n\\t\\tcursor: default;\\n\\t\\tz-index: var(--layer-top);\\n\\t\\toverflow: hidden;\\n\\t\\ttop: 0;\\n\\n\\t\\ttransform: translate(35px, -12px);\\n\\t}\\n\\n\\t.color_picker {\\n\\t\\ttransform: translate(35px, -50%);\\n\\t}\\n\\n\\t.size_picker {\\n\\t\\ttransform: translate(35px, 18px);\\n\\t}\\n\\n\\t.eraser_picker {\\n\\t\\ttransform: translate(35px, -7px);\\n\\t}</style>\\n"],"names":[],"mappings":"AAgIC,mBAAM,CACL,SAAS,CAAE,KAAK,CAEhB,QAAQ,CAAE,QAAQ,CAClB,OAAO,CAAE,IAAI,CACb,cAAc,CAAE,MAAM,CACtB,GAAG,CAAE,GAAG,CACR,UAAU,CAAE,IAAI,2BAA2B,CAAC,CAC5C,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,oBAAoB,CAAC,CAC3C,aAAa,CAAE,IAAI,WAAW,CAAC,CAC/B,UAAU,CAAE,GAAG,CAAC,GAAG,CAAC,GAAG,CAAC,GAAG,CAAC,KAAK,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,GAAG,CAAC,CAC9C,cAAc,CAAE,IAAI,QAAQ,CAAC,CAC7B,cAAc,CAAE,GAAG,CACnB,MAAM,CAAE,OAAO,CACf,OAAO,CAAE,IAAI,WAAW,CAAC,CACzB,QAAQ,CAAE,MAAM,CAChB,GAAG,CAAE,CAAC,CAEN,SAAS,CAAE,UAAU,IAAI,CAAC,CAAC,KAAK,CACjC,CAEA,2BAAc,CACb,SAAS,CAAE,UAAU,IAAI,CAAC,CAAC,IAAI,CAChC,CAEA,0BAAa,CACZ,SAAS,CAAE,UAAU,IAAI,CAAC,CAAC,IAAI,CAChC,CAEA,4BAAe,CACd,SAAS,CAAE,UAAU,IAAI,CAAC,CAAC,IAAI,CAChC"}'
};
function debounce(func, delay) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
}
const BrushOptions = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { colors } = $$props;
  let { selected_color } = $$props;
  let { color_mode = void 0 } = $$props;
  let { recent_colors = [] } = $$props;
  let { selected_size } = $$props;
  let { selected_opacity } = $$props;
  let { show_swatch } = $$props;
  let { show_size } = $$props;
  let { mode = "brush" } = $$props;
  let color_picker = false;
  let current_mode = "hex";
  createEventDispatcher();
  let { preview = false } = $$props;
  function handle_preview() {
    if (!preview) {
      preview = true;
      debounced_close_preview();
    } else {
      debounced_close_preview();
    }
  }
  function handle_close_preview() {
    preview = false;
  }
  const debounced_close_preview = debounce(handle_close_preview, 1e3);
  if ($$props.colors === void 0 && $$bindings.colors && colors !== void 0)
    $$bindings.colors(colors);
  if ($$props.selected_color === void 0 && $$bindings.selected_color && selected_color !== void 0)
    $$bindings.selected_color(selected_color);
  if ($$props.color_mode === void 0 && $$bindings.color_mode && color_mode !== void 0)
    $$bindings.color_mode(color_mode);
  if ($$props.recent_colors === void 0 && $$bindings.recent_colors && recent_colors !== void 0)
    $$bindings.recent_colors(recent_colors);
  if ($$props.selected_size === void 0 && $$bindings.selected_size && selected_size !== void 0)
    $$bindings.selected_size(selected_size);
  if ($$props.selected_opacity === void 0 && $$bindings.selected_opacity && selected_opacity !== void 0)
    $$bindings.selected_opacity(selected_opacity);
  if ($$props.show_swatch === void 0 && $$bindings.show_swatch && show_swatch !== void 0)
    $$bindings.show_swatch(show_swatch);
  if ($$props.show_size === void 0 && $$bindings.show_size && show_size !== void 0)
    $$bindings.show_size(show_size);
  if ($$props.mode === void 0 && $$bindings.mode && mode !== void 0)
    $$bindings.mode(mode);
  if ($$props.preview === void 0 && $$bindings.preview && preview !== void 0)
    $$bindings.preview(preview);
  $$result.css.add(css$6);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    {
      handle_preview();
    }
    $$rendered = ` <div class="${[
      "wrap svelte-qigu2l",
      (!color_picker ? "padded" : "") + " " + (color_picker ? "color_picker" : "") + " " + (show_size && mode === "brush" ? "size_picker" : "") + " " + (mode === "eraser" ? "eraser_picker" : "")
    ].join(" ").trim()}">${color_mode === "defaults" ? `${color_picker ? `${validate_component(ColorPicker, "ColorPicker").$$render(
      $$result,
      {
        color: selected_color,
        opacity: selected_opacity
      },
      {
        color: ($$value) => {
          selected_color = $$value;
          $$settled = false;
        },
        opacity: ($$value) => {
          selected_opacity = $$value;
          $$settled = false;
        }
      },
      {}
    )} ${validate_component(ColorField, "ColorField").$$render(
      $$result,
      { color: selected_color, current_mode },
      {
        current_mode: ($$value) => {
          current_mode = $$value;
          $$settled = false;
        }
      },
      {}
    )}` : ``}` : ``} ${show_swatch ? `${validate_component(ColorSwatch, "ColorSwatch").$$render(
      $$result,
      {
        colors,
        user_colors: color_mode === "defaults" ? recent_colors : null,
        selected_color,
        current_mode,
        color_picker
      },
      {
        color_picker: ($$value) => {
          color_picker = $$value;
          $$settled = false;
        }
      },
      {}
    )}` : ``} ${show_size ? `${validate_component(BrushSize_1, "BrushSize").$$render(
      $$result,
      { max: 100, min: 1, selected_size },
      {
        selected_size: ($$value) => {
          selected_size = $$value;
          $$settled = false;
        }
      },
      {}
    )}` : ``} </div>`;
  } while (!$$settled);
  return $$rendered;
});
const css$5 = {
  code: ".toolbar-wrap.svelte-1m5h684{display:inline-flex;flex-direction:column;justify-content:center;align-items:center;position:absolute;left:15px;right:0;top:30%;width:30px;border:1px solid var(--block-border-color);border-radius:var(--radius-md);gap:var(--spacing-sm);z-index:1000;background-color:var(--block-background-fill)}.half-container.svelte-1m5h684{flex:1;display:flex;flex-direction:column;gap:var(--spacing-sm);position:relative}.half-container.svelte-1m5h684{width:100%;padding:var(--spacing-sm) 0}.half-container.svelte-1m5h684:last-child{border-top:1px solid var(--block-border-color)}.hide.svelte-1m5h684{display:none}",
  map: '{"version":3,"file":"Toolbar.svelte","sources":["Toolbar.svelte"],"sourcesContent":["<script lang=\\"ts\\" context=\\"module\\">\\"use strict\\";\\n<\/script>\\n\\n<script lang=\\"ts\\">import { createEventDispatcher } from \\"svelte\\";\\nimport IconButton from \\"./IconButton.svelte\\";\\nimport { Image, Brush, Erase, Crop, Upload, ImagePaste, Webcam, Circle, Resize, ColorPickerSolid } from \\"@gradio/icons\\";\\nimport BrushOptions from \\"./brush/BrushOptions.svelte\\";\\nimport {} from \\"./brush/types\\";\\nimport tinycolor from \\"tinycolor2\\";\\nexport let tool = \\"image\\";\\nexport let subtool = null;\\nexport let background = false;\\nexport let brush_options;\\nexport let selected_size = brush_options && typeof brush_options.default_size === \\"number\\" ? brush_options.default_size : 25;\\nexport let eraser_options;\\nexport let selected_eraser_size = eraser_options && typeof eraser_options.default_size === \\"number\\" ? eraser_options.default_size : 25;\\nexport let selected_color = brush_options && (() => {\\n    const default_color = brush_options.default_color;\\n    if (Array.isArray(default_color)) {\\n        return default_color[0];\\n    }\\n    return default_color;\\n})();\\nexport let selected_opacity = brush_options && (() => {\\n    const default_color = brush_options.default_color;\\n    if (Array.isArray(default_color)) {\\n        return default_color[1];\\n    }\\n    const color = tinycolor(default_color);\\n    if (color.getAlpha() < 1) {\\n        return color.getAlpha();\\n    }\\n    return 1;\\n})();\\nexport let preview = false;\\nexport let show_brush_color = false;\\nexport let show_brush_size = false;\\nexport let show_eraser_size = false;\\nexport let sources;\\nexport let transforms;\\nlet recent_colors = [];\\nlet enable_layers = true;\\nconst dispatch = createEventDispatcher();\\nfunction handle_tool_click(e, _tool) {\\n    e.stopPropagation();\\n    dispatch(\\"tool_change\\", { tool: _tool });\\n}\\nfunction handle_subtool_click(e, _subtool) {\\n    e.stopPropagation();\\n    dispatch(\\"subtool_change\\", { tool, subtool: _subtool });\\n}\\n$: show_brush_size = tool === \\"draw\\" && subtool === \\"size\\";\\n$: show_brush_color = tool === \\"draw\\" && subtool === \\"color\\";\\n$: show_eraser_size = tool === \\"erase\\" && subtool === \\"size\\";\\n$: can_crop = transforms.includes(\\"crop\\");\\n$: can_resize = transforms.includes(\\"resize\\");\\n$: can_upload = sources.includes(\\"upload\\");\\n$: can_webcam = sources.includes(\\"webcam\\");\\n$: can_paste = sources.includes(\\"clipboard\\");\\n<\/script>\\n\\n<div class=\\"toolbar-wrap\\">\\n\\t<div class=\\"half-container\\">\\n\\t\\t{#if sources.length > 0}\\n\\t\\t\\t<IconButton\\n\\t\\t\\t\\tIcon={Image}\\n\\t\\t\\t\\tlabel=\\"Image\\"\\n\\t\\t\\t\\thighlight={tool === \\"image\\"}\\n\\t\\t\\t\\ton:click={(e) => handle_tool_click(e, \\"image\\")}\\n\\t\\t\\t\\tsize=\\"medium\\"\\n\\t\\t\\t\\tpadded={false}\\n\\t\\t\\t\\ttransparent={true}\\n\\t\\t\\t/>\\n\\t\\t{/if}\\n\\t\\t{#if brush_options}\\n\\t\\t\\t<IconButton\\n\\t\\t\\t\\tIcon={Brush}\\n\\t\\t\\t\\tlabel=\\"Brush\\"\\n\\t\\t\\t\\ton:click={(e) => handle_tool_click(e, \\"draw\\")}\\n\\t\\t\\t\\thighlight={tool === \\"draw\\"}\\n\\t\\t\\t\\tsize=\\"medium\\"\\n\\t\\t\\t\\tpadded={false}\\n\\t\\t\\t\\ttransparent={true}\\n\\t\\t\\t/>\\n\\t\\t{/if}\\n\\t\\t{#if eraser_options}\\n\\t\\t\\t<IconButton\\n\\t\\t\\t\\tIcon={Erase}\\n\\t\\t\\t\\tlabel=\\"Erase\\"\\n\\t\\t\\t\\ton:click={(e) => handle_tool_click(e, \\"erase\\")}\\n\\t\\t\\t\\thighlight={tool === \\"erase\\"}\\n\\t\\t\\t\\tsize=\\"medium\\"\\n\\t\\t\\t\\tpadded={false}\\n\\t\\t\\t\\ttransparent={true}\\n\\t\\t\\t/>\\n\\t\\t{/if}\\n\\t</div>\\n\\t<div\\n\\t\\tclass=\\"half-container right\\"\\n\\t\\tclass:hide={tool === \\"pan\\" ||\\n\\t\\t\\t(tool === \\"image\\" && !background && sources.length === 0) ||\\n\\t\\t\\t(tool === \\"image\\" && background && transforms.length === 0)}\\n\\t>\\n\\t\\t{#if tool === \\"image\\"}\\n\\t\\t\\t{#if background}\\n\\t\\t\\t\\t{#if can_crop}\\n\\t\\t\\t\\t\\t<IconButton\\n\\t\\t\\t\\t\\t\\tIcon={Crop}\\n\\t\\t\\t\\t\\t\\tlabel=\\"Crop\\"\\n\\t\\t\\t\\t\\t\\ton:click={(e) => handle_subtool_click(e, \\"crop\\")}\\n\\t\\t\\t\\t\\t\\thighlight={subtool === \\"crop\\"}\\n\\t\\t\\t\\t\\t\\tsize=\\"medium\\"\\n\\t\\t\\t\\t\\t\\tpadded={false}\\n\\t\\t\\t\\t\\t\\ttransparent={true}\\n\\t\\t\\t\\t\\t\\toffset={0}\\n\\t\\t\\t\\t\\t/>\\n\\t\\t\\t\\t{/if}\\n\\t\\t\\t\\t{#if can_resize}\\n\\t\\t\\t\\t\\t<IconButton\\n\\t\\t\\t\\t\\t\\tIcon={Resize}\\n\\t\\t\\t\\t\\t\\tlabel=\\"Resize\\"\\n\\t\\t\\t\\t\\t\\ton:click={(e) => handle_subtool_click(e, \\"size\\")}\\n\\t\\t\\t\\t\\t\\thighlight={subtool === \\"size\\"}\\n\\t\\t\\t\\t\\t\\tsize=\\"medium\\"\\n\\t\\t\\t\\t\\t\\tpadded={false}\\n\\t\\t\\t\\t\\t\\ttransparent={true}\\n\\t\\t\\t\\t\\t\\toffset={0}\\n\\t\\t\\t\\t\\t/>\\n\\t\\t\\t\\t{/if}\\n\\t\\t\\t{:else}\\n\\t\\t\\t\\t{#if can_upload}\\n\\t\\t\\t\\t\\t<IconButton\\n\\t\\t\\t\\t\\t\\tIcon={Upload}\\n\\t\\t\\t\\t\\t\\tlabel=\\"Upload\\"\\n\\t\\t\\t\\t\\t\\ton:click={(e) => handle_subtool_click(e, \\"upload\\")}\\n\\t\\t\\t\\t\\t\\thighlight={subtool === \\"upload\\"}\\n\\t\\t\\t\\t\\t\\tsize=\\"medium\\"\\n\\t\\t\\t\\t\\t\\tpadded={false}\\n\\t\\t\\t\\t\\t\\ttransparent={true}\\n\\t\\t\\t\\t\\t\\toffset={0}\\n\\t\\t\\t\\t\\t/>\\n\\t\\t\\t\\t{/if}\\n\\t\\t\\t\\t{#if can_paste}\\n\\t\\t\\t\\t\\t<IconButton\\n\\t\\t\\t\\t\\t\\tIcon={ImagePaste}\\n\\t\\t\\t\\t\\t\\tlabel=\\"Paste\\"\\n\\t\\t\\t\\t\\t\\ton:click={(e) => handle_subtool_click(e, \\"paste\\")}\\n\\t\\t\\t\\t\\t\\thighlight={subtool === \\"paste\\"}\\n\\t\\t\\t\\t\\t\\tsize=\\"large\\"\\n\\t\\t\\t\\t\\t\\tpadded={false}\\n\\t\\t\\t\\t\\t\\ttransparent={true}\\n\\t\\t\\t\\t\\t\\toffset={0}\\n\\t\\t\\t\\t\\t/>\\n\\t\\t\\t\\t{/if}\\n\\t\\t\\t\\t{#if can_webcam}\\n\\t\\t\\t\\t\\t<IconButton\\n\\t\\t\\t\\t\\t\\tIcon={Webcam}\\n\\t\\t\\t\\t\\t\\tlabel=\\"Webcam\\"\\n\\t\\t\\t\\t\\t\\ton:click={(e) => handle_subtool_click(e, \\"webcam\\")}\\n\\t\\t\\t\\t\\t\\thighlight={subtool === \\"webcam\\"}\\n\\t\\t\\t\\t\\t\\tsize=\\"medium\\"\\n\\t\\t\\t\\t\\t\\tpadded={false}\\n\\t\\t\\t\\t\\t\\ttransparent={true}\\n\\t\\t\\t\\t\\t\\toffset={0}\\n\\t\\t\\t\\t\\t/>\\n\\t\\t\\t\\t{/if}\\n\\t\\t\\t{/if}\\n\\t\\t{/if}\\n\\n\\t\\t{#if tool === \\"draw\\" && brush_options}\\n\\t\\t\\t<IconButton\\n\\t\\t\\t\\tIcon={ColorPickerSolid}\\n\\t\\t\\t\\tlabel=\\"Color\\"\\n\\t\\t\\t\\tcolor={selected_color}\\n\\t\\t\\t\\ton:click={(e) => handle_subtool_click(e, \\"color\\")}\\n\\t\\t\\t\\tsize=\\"medium\\"\\n\\t\\t\\t\\tpadded={false}\\n\\t\\t\\t\\ttransparent={true}\\n\\t\\t\\t\\toffset={0}\\n\\t\\t\\t/>\\n\\t\\t\\t<IconButton\\n\\t\\t\\t\\tIcon={Circle}\\n\\t\\t\\t\\tlabel=\\"Brush Size\\"\\n\\t\\t\\t\\ton:click={(e) => handle_subtool_click(e, \\"size\\")}\\n\\t\\t\\t\\thighlight={subtool === \\"size\\"}\\n\\t\\t\\t\\tsize=\\"medium\\"\\n\\t\\t\\t\\tpadded={false}\\n\\t\\t\\t\\ttransparent={true}\\n\\t\\t\\t\\toffset={0}\\n\\t\\t\\t/>\\n\\n\\t\\t\\t{#if show_brush_color || show_brush_size}\\n\\t\\t\\t\\t<BrushOptions\\n\\t\\t\\t\\t\\tcolors={brush_options.colors}\\n\\t\\t\\t\\t\\tcolor_mode={brush_options.color_mode}\\n\\t\\t\\t\\t\\t{recent_colors}\\n\\t\\t\\t\\t\\tshow_swatch={show_brush_color}\\n\\t\\t\\t\\t\\tshow_size={show_brush_size}\\n\\t\\t\\t\\t\\tbind:selected_size\\n\\t\\t\\t\\t\\tbind:selected_color\\n\\t\\t\\t\\t\\tbind:selected_opacity\\n\\t\\t\\t\\t\\tbind:preview\\n\\t\\t\\t\\t\\ton:click_outside={(e) => {\\n\\t\\t\\t\\t\\t\\te.stopPropagation();\\n\\t\\t\\t\\t\\t\\tpreview = false;\\n\\t\\t\\t\\t\\t\\tshow_brush_color = false;\\n\\t\\t\\t\\t\\t\\tshow_brush_size = false;\\n\\t\\t\\t\\t\\t\\thandle_subtool_click(e, null);\\n\\t\\t\\t\\t\\t}}\\n\\t\\t\\t\\t\\tmode=\\"brush\\"\\n\\t\\t\\t\\t/>\\n\\t\\t\\t{/if}\\n\\t\\t{/if}\\n\\n\\t\\t{#if tool === \\"erase\\" && eraser_options}\\n\\t\\t\\t<IconButton\\n\\t\\t\\t\\tIcon={Circle}\\n\\t\\t\\t\\tlabel=\\"Eraser Size\\"\\n\\t\\t\\t\\ton:click={(e) => handle_subtool_click(e, \\"size\\")}\\n\\t\\t\\t\\thighlight={subtool === \\"size\\"}\\n\\t\\t\\t\\tsize=\\"medium\\"\\n\\t\\t\\t\\tpadded={false}\\n\\t\\t\\t\\ttransparent={true}\\n\\t\\t\\t\\toffset={0}\\n\\t\\t\\t/>\\n\\t\\t{/if}\\n\\t\\t{#if show_eraser_size}\\n\\t\\t\\t<BrushOptions\\n\\t\\t\\t\\tcolors={[]}\\n\\t\\t\\t\\tshow_swatch={false}\\n\\t\\t\\t\\tshow_size={true}\\n\\t\\t\\t\\tbind:selected_size={selected_eraser_size}\\n\\t\\t\\t\\tbind:selected_color\\n\\t\\t\\t\\tbind:selected_opacity\\n\\t\\t\\t\\tbind:preview\\n\\t\\t\\t\\ton:click_outside={(e) => {\\n\\t\\t\\t\\t\\te.stopPropagation();\\n\\t\\t\\t\\t\\tpreview = false;\\n\\t\\t\\t\\t\\tshow_eraser_size = false;\\n\\t\\t\\t\\t\\thandle_subtool_click(e, null);\\n\\t\\t\\t\\t}}\\n\\t\\t\\t\\tmode=\\"eraser\\"\\n\\t\\t\\t/>\\n\\t\\t{/if}\\n\\t</div>\\n</div>\\n\\n<style>\\n\\t.toolbar-wrap {\\n\\t\\tdisplay: inline-flex;\\n\\t\\tflex-direction: column;\\n\\t\\tjustify-content: center;\\n\\t\\talign-items: center;\\n\\t\\tposition: absolute;\\n\\t\\tleft: 15px;\\n\\t\\tright: 0;\\n\\t\\ttop: 30%;\\n\\t\\t/* transform: translateY(-50%); */\\n\\t\\twidth: 30px;\\n\\t\\tborder: 1px solid var(--block-border-color);\\n\\t\\tborder-radius: var(--radius-md);\\n\\n\\t\\tgap: var(--spacing-sm);\\n\\t\\tz-index: 1000;\\n\\t\\tbackground-color: var(--block-background-fill);\\n\\t}\\n\\n\\t.half-container {\\n\\t\\tflex: 1;\\n\\t\\tdisplay: flex;\\n\\t\\tflex-direction: column;\\n\\t\\tgap: var(--spacing-sm);\\n\\t\\tposition: relative;\\n\\t}\\n\\n\\t.half-container {\\n\\t\\twidth: 100%;\\n\\t\\tpadding: var(--spacing-sm) 0;\\n\\t}\\n\\n\\t.half-container:last-child {\\n\\t\\tborder-top: 1px solid var(--block-border-color);\\n\\t}\\n\\n\\t.hide {\\n\\t\\tdisplay: none;\\n\\t}\\n\\n\\t/* .toolbar-left,\\n\\t.toolbar-right {\\n\\t\\tdisplay: flex;\\n\\t\\tflex-direction: row;\\n\\t\\talign-items: center;\\n\\t\\tgap: var(--spacing-sm);\\n\\t\\tdisplay: flex;\\n\\t\\tz-index: 1000;\\n\\t\\tborder-radius: var(--radius-sm);\\n\\t\\tbackground-color: #fff;\\n\\t\\tpadding: var(--spacing-sm) 0.3rem;\\n\\t\\twidth: auto;\\n\\t}\\n\\n\\t.toolbar-right {\\n\\t\\tborder-left: 0;\\n\\t\\tborder-top-left-radius: 0;\\n\\t\\tborder-bottom-left-radius: 0;\\n\\t}\\n\\n\\t.toolbar-left {\\n\\t\\tborder-top-right-radius: 0;\\n\\t\\tborder-bottom-right-radius: 0;\\n\\t}\\n\\n\\t.toolbar-layers {\\n\\t\\tborder-top-left-radius: 0;\\n\\t\\tborder-bottom-left-radius: 0;\\n\\t} */</style>\\n"],"names":[],"mappings":"AAwPC,4BAAc,CACb,OAAO,CAAE,WAAW,CACpB,cAAc,CAAE,MAAM,CACtB,eAAe,CAAE,MAAM,CACvB,WAAW,CAAE,MAAM,CACnB,QAAQ,CAAE,QAAQ,CAClB,IAAI,CAAE,IAAI,CACV,KAAK,CAAE,CAAC,CACR,GAAG,CAAE,GAAG,CAER,KAAK,CAAE,IAAI,CACX,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,oBAAoB,CAAC,CAC3C,aAAa,CAAE,IAAI,WAAW,CAAC,CAE/B,GAAG,CAAE,IAAI,YAAY,CAAC,CACtB,OAAO,CAAE,IAAI,CACb,gBAAgB,CAAE,IAAI,uBAAuB,CAC9C,CAEA,8BAAgB,CACf,IAAI,CAAE,CAAC,CACP,OAAO,CAAE,IAAI,CACb,cAAc,CAAE,MAAM,CACtB,GAAG,CAAE,IAAI,YAAY,CAAC,CACtB,QAAQ,CAAE,QACX,CAEA,8BAAgB,CACf,KAAK,CAAE,IAAI,CACX,OAAO,CAAE,IAAI,YAAY,CAAC,CAAC,CAC5B,CAEA,8BAAe,WAAY,CAC1B,UAAU,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,oBAAoB,CAC/C,CAEA,oBAAM,CACL,OAAO,CAAE,IACV"}'
};
const Toolbar = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let can_crop;
  let can_resize;
  let can_upload;
  let can_webcam;
  let can_paste;
  let { tool = "image" } = $$props;
  let { subtool = null } = $$props;
  let { background = false } = $$props;
  let { brush_options } = $$props;
  let { selected_size = brush_options && typeof brush_options.default_size === "number" ? brush_options.default_size : 25 } = $$props;
  let { eraser_options } = $$props;
  let { selected_eraser_size = eraser_options && typeof eraser_options.default_size === "number" ? eraser_options.default_size : 25 } = $$props;
  let { selected_color = brush_options && (() => {
    const default_color = brush_options.default_color;
    if (Array.isArray(default_color)) {
      return default_color[0];
    }
    return default_color;
  })() } = $$props;
  let { selected_opacity = brush_options && (() => {
    const default_color = brush_options.default_color;
    if (Array.isArray(default_color)) {
      return default_color[1];
    }
    const color = tinycolor(default_color);
    if (color.getAlpha() < 1) {
      return color.getAlpha();
    }
    return 1;
  })() } = $$props;
  let { preview = false } = $$props;
  let { show_brush_color = false } = $$props;
  let { show_brush_size = false } = $$props;
  let { show_eraser_size = false } = $$props;
  let { sources: sources2 } = $$props;
  let { transforms } = $$props;
  let recent_colors = [];
  createEventDispatcher();
  if ($$props.tool === void 0 && $$bindings.tool && tool !== void 0)
    $$bindings.tool(tool);
  if ($$props.subtool === void 0 && $$bindings.subtool && subtool !== void 0)
    $$bindings.subtool(subtool);
  if ($$props.background === void 0 && $$bindings.background && background !== void 0)
    $$bindings.background(background);
  if ($$props.brush_options === void 0 && $$bindings.brush_options && brush_options !== void 0)
    $$bindings.brush_options(brush_options);
  if ($$props.selected_size === void 0 && $$bindings.selected_size && selected_size !== void 0)
    $$bindings.selected_size(selected_size);
  if ($$props.eraser_options === void 0 && $$bindings.eraser_options && eraser_options !== void 0)
    $$bindings.eraser_options(eraser_options);
  if ($$props.selected_eraser_size === void 0 && $$bindings.selected_eraser_size && selected_eraser_size !== void 0)
    $$bindings.selected_eraser_size(selected_eraser_size);
  if ($$props.selected_color === void 0 && $$bindings.selected_color && selected_color !== void 0)
    $$bindings.selected_color(selected_color);
  if ($$props.selected_opacity === void 0 && $$bindings.selected_opacity && selected_opacity !== void 0)
    $$bindings.selected_opacity(selected_opacity);
  if ($$props.preview === void 0 && $$bindings.preview && preview !== void 0)
    $$bindings.preview(preview);
  if ($$props.show_brush_color === void 0 && $$bindings.show_brush_color && show_brush_color !== void 0)
    $$bindings.show_brush_color(show_brush_color);
  if ($$props.show_brush_size === void 0 && $$bindings.show_brush_size && show_brush_size !== void 0)
    $$bindings.show_brush_size(show_brush_size);
  if ($$props.show_eraser_size === void 0 && $$bindings.show_eraser_size && show_eraser_size !== void 0)
    $$bindings.show_eraser_size(show_eraser_size);
  if ($$props.sources === void 0 && $$bindings.sources && sources2 !== void 0)
    $$bindings.sources(sources2);
  if ($$props.transforms === void 0 && $$bindings.transforms && transforms !== void 0)
    $$bindings.transforms(transforms);
  $$result.css.add(css$5);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    show_brush_size = tool === "draw" && subtool === "size";
    show_brush_color = tool === "draw" && subtool === "color";
    show_eraser_size = tool === "erase" && subtool === "size";
    can_crop = transforms.includes("crop");
    can_resize = transforms.includes("resize");
    can_upload = sources2.includes("upload");
    can_webcam = sources2.includes("webcam");
    can_paste = sources2.includes("clipboard");
    $$rendered = `<div class="toolbar-wrap svelte-1m5h684"><div class="half-container svelte-1m5h684">${sources2.length > 0 ? `${validate_component(IconButton, "IconButton").$$render(
      $$result,
      {
        Icon: Image$1,
        label: "Image",
        highlight: tool === "image",
        size: "medium",
        padded: false,
        transparent: true
      },
      {},
      {}
    )}` : ``} ${brush_options ? `${validate_component(IconButton, "IconButton").$$render(
      $$result,
      {
        Icon: Brush,
        label: "Brush",
        highlight: tool === "draw",
        size: "medium",
        padded: false,
        transparent: true
      },
      {},
      {}
    )}` : ``} ${eraser_options ? `${validate_component(IconButton, "IconButton").$$render(
      $$result,
      {
        Icon: Erase,
        label: "Erase",
        highlight: tool === "erase",
        size: "medium",
        padded: false,
        transparent: true
      },
      {},
      {}
    )}` : ``}</div> <div class="${[
      "half-container right svelte-1m5h684",
      tool === "pan" || tool === "image" && !background && sources2.length === 0 || tool === "image" && background && transforms.length === 0 ? "hide" : ""
    ].join(" ").trim()}">${tool === "image" ? `${background ? `${can_crop ? `${validate_component(IconButton, "IconButton").$$render(
      $$result,
      {
        Icon: Crop,
        label: "Crop",
        highlight: subtool === "crop",
        size: "medium",
        padded: false,
        transparent: true,
        offset: 0
      },
      {},
      {}
    )}` : ``} ${can_resize ? `${validate_component(IconButton, "IconButton").$$render(
      $$result,
      {
        Icon: Resize,
        label: "Resize",
        highlight: subtool === "size",
        size: "medium",
        padded: false,
        transparent: true,
        offset: 0
      },
      {},
      {}
    )}` : ``}` : `${can_upload ? `${validate_component(IconButton, "IconButton").$$render(
      $$result,
      {
        Icon: Upload,
        label: "Upload",
        highlight: subtool === "upload",
        size: "medium",
        padded: false,
        transparent: true,
        offset: 0
      },
      {},
      {}
    )}` : ``} ${can_paste ? `${validate_component(IconButton, "IconButton").$$render(
      $$result,
      {
        Icon: ImagePaste,
        label: "Paste",
        highlight: subtool === "paste",
        size: "large",
        padded: false,
        transparent: true,
        offset: 0
      },
      {},
      {}
    )}` : ``} ${can_webcam ? `${validate_component(IconButton, "IconButton").$$render(
      $$result,
      {
        Icon: Webcam,
        label: "Webcam",
        highlight: subtool === "webcam",
        size: "medium",
        padded: false,
        transparent: true,
        offset: 0
      },
      {},
      {}
    )}` : ``}`}` : ``} ${tool === "draw" && brush_options ? `${validate_component(IconButton, "IconButton").$$render(
      $$result,
      {
        Icon: ColorPickerSolid,
        label: "Color",
        color: selected_color,
        size: "medium",
        padded: false,
        transparent: true,
        offset: 0
      },
      {},
      {}
    )} ${validate_component(IconButton, "IconButton").$$render(
      $$result,
      {
        Icon: Circle$1,
        label: "Brush Size",
        highlight: subtool === "size",
        size: "medium",
        padded: false,
        transparent: true,
        offset: 0
      },
      {},
      {}
    )} ${show_brush_color || show_brush_size ? `${validate_component(BrushOptions, "BrushOptions").$$render(
      $$result,
      {
        colors: brush_options.colors,
        color_mode: brush_options.color_mode,
        recent_colors,
        show_swatch: show_brush_color,
        show_size: show_brush_size,
        mode: "brush",
        selected_size,
        selected_color,
        selected_opacity,
        preview
      },
      {
        selected_size: ($$value) => {
          selected_size = $$value;
          $$settled = false;
        },
        selected_color: ($$value) => {
          selected_color = $$value;
          $$settled = false;
        },
        selected_opacity: ($$value) => {
          selected_opacity = $$value;
          $$settled = false;
        },
        preview: ($$value) => {
          preview = $$value;
          $$settled = false;
        }
      },
      {}
    )}` : ``}` : ``} ${tool === "erase" && eraser_options ? `${validate_component(IconButton, "IconButton").$$render(
      $$result,
      {
        Icon: Circle$1,
        label: "Eraser Size",
        highlight: subtool === "size",
        size: "medium",
        padded: false,
        transparent: true,
        offset: 0
      },
      {},
      {}
    )}` : ``} ${show_eraser_size ? `${validate_component(BrushOptions, "BrushOptions").$$render(
      $$result,
      {
        colors: [],
        show_swatch: false,
        show_size: true,
        mode: "eraser",
        selected_size: selected_eraser_size,
        selected_color,
        selected_opacity,
        preview
      },
      {
        selected_size: ($$value) => {
          selected_eraser_size = $$value;
          $$settled = false;
        },
        selected_color: ($$value) => {
          selected_color = $$value;
          $$settled = false;
        },
        selected_opacity: ($$value) => {
          selected_opacity = $$value;
          $$settled = false;
        },
        preview: ($$value) => {
          preview = $$value;
          $$settled = false;
        }
      },
      {}
    )}` : ``}</div> </div>`;
  } while (!$$settled);
  return $$rendered;
});
var vertex = "in vec2 aPosition;\nout vec2 vTextureCoord;\n\nuniform vec4 uInputSize;\nuniform vec4 uOutputFrame;\nuniform vec4 uOutputTexture;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;\n    \n    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aPosition * (uOutputFrame.zw * uInputSize.zw);\n}\n\nvoid main(void)\n{\n    gl_Position = filterVertexPosition();\n    vTextureCoord = filterTextureCoord();\n}\n";
var wgslVertex = "struct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\nstruct VSOutput {\n    @builtin(position) position: vec4<f32>,\n    @location(0) uv : vec2<f32>\n  };\n\nfn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>\n{\n    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;\n\n    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;\n    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;\n\n    return vec4(position, 0.0, 1.0);\n}\n\nfn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);\n}\n\nfn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>\n{\n  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);  \n}\n\nfn getSize() -> vec2<f32>\n{\n  return gfu.uGlobalFrame.zw;\n}\n  \n@vertex\nfn mainVertex(\n  @location(0) aPosition : vec2<f32>, \n) -> VSOutput {\n  return VSOutput(\n   filterVertexPosition(aPosition),\n   filterTextureCoord(aPosition)\n  );\n}";
var fragment$1 = "\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec2 uOffset;\n\nvoid main(void)\n{\n    vec4 color = vec4(0.0);\n\n    // Sample top left pixel\n    color += texture(uTexture, vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y + uOffset.y));\n\n    // Sample top right pixel\n    color += texture(uTexture, vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y + uOffset.y));\n\n    // Sample bottom right pixel\n    color += texture(uTexture, vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y - uOffset.y));\n\n    // Sample bottom left pixel\n    color += texture(uTexture, vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y - uOffset.y));\n\n    // Average\n    color *= 0.25;\n\n    finalColor = color;\n}";
var source$1 = "struct KawaseBlurUniforms {\n  uOffset:vec2<f32>,\n};\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> kawaseBlurUniforms : KawaseBlurUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let uOffset = kawaseBlurUniforms.uOffset;\n  var color: vec4<f32> = vec4<f32>(0.0);\n\n  // Sample top left pixel\n  color += textureSample(uTexture, uSampler, vec2<f32>(uv.x - uOffset.x, uv.y + uOffset.y));\n  // Sample top right pixel\n  color += textureSample(uTexture, uSampler, vec2<f32>(uv.x + uOffset.x, uv.y + uOffset.y));\n  // Sample bottom right pixel\n  color += textureSample(uTexture, uSampler, vec2<f32>(uv.x + uOffset.x, uv.y - uOffset.y));\n  // Sample bottom left pixel\n  color += textureSample(uTexture, uSampler, vec2<f32>(uv.x - uOffset.x, uv.y - uOffset.y));\n  // Average\n  color *= 0.25;\n\n  return color;\n}";
var fragmentClamp = "\nprecision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform vec2 uOffset;\n\nuniform vec4 uInputClamp;\n\nvoid main(void)\n{\n    vec4 color = vec4(0.0);\n\n    // Sample top left pixel\n    color += texture(uTexture, clamp(vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y + uOffset.y), uInputClamp.xy, uInputClamp.zw));\n\n    // Sample top right pixel\n    color += texture(uTexture, clamp(vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y + uOffset.y), uInputClamp.xy, uInputClamp.zw));\n\n    // Sample bottom right pixel\n    color += texture(uTexture, clamp(vec2(vTextureCoord.x + uOffset.x, vTextureCoord.y - uOffset.y), uInputClamp.xy, uInputClamp.zw));\n\n    // Sample bottom left pixel\n    color += texture(uTexture, clamp(vec2(vTextureCoord.x - uOffset.x, vTextureCoord.y - uOffset.y), uInputClamp.xy, uInputClamp.zw));\n\n    // Average\n    color *= 0.25;\n\n    finalColor = color;\n}\n";
var sourceClamp = "struct KawaseBlurUniforms {\n  uOffset:vec2<f32>,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> kawaseBlurUniforms : KawaseBlurUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  let uOffset = kawaseBlurUniforms.uOffset;\n  var color: vec4<f32> = vec4(0.0);\n\n  // Sample top left pixel\n  color += textureSample(uTexture, uSampler, clamp(vec2<f32>(uv.x - uOffset.x, uv.y + uOffset.y), gfu.uInputClamp.xy, gfu.uInputClamp.zw));\n  // Sample top right pixel\n  color += textureSample(uTexture, uSampler, clamp(vec2<f32>(uv.x + uOffset.x, uv.y + uOffset.y), gfu.uInputClamp.xy, gfu.uInputClamp.zw));\n  // Sample bottom right pixel\n  color += textureSample(uTexture, uSampler, clamp(vec2<f32>(uv.x + uOffset.x, uv.y - uOffset.y), gfu.uInputClamp.xy, gfu.uInputClamp.zw));\n  // Sample bottom left pixel\n  color += textureSample(uTexture, uSampler, clamp(vec2<f32>(uv.x - uOffset.x, uv.y - uOffset.y), gfu.uInputClamp.xy, gfu.uInputClamp.zw));\n  // Average\n  color *= 0.25;\n    \n  return color;\n}";
var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$1 = (obj, key, value) => {
  __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const _KawaseBlurFilter = class _KawaseBlurFilter2 extends Filter {
  /** @ignore */
  constructor(...args) {
    let options = args[0] ?? {};
    if (typeof options === "number" || Array.isArray(options)) {
      deprecation("6.0.0", "KawaseBlurFilter constructor params are now options object. See params: { strength, quality, clamp, pixelSize }");
      options = { strength: options };
      if (args[1] !== void 0)
        options.quality = args[1];
      if (args[2] !== void 0)
        options.clamp = args[2];
    }
    options = { ..._KawaseBlurFilter2.DEFAULT_OPTIONS, ...options };
    const gpuProgram = GpuProgram.from({
      vertex: {
        source: wgslVertex,
        entryPoint: "mainVertex"
      },
      fragment: {
        source: options?.clamp ? sourceClamp : source$1,
        entryPoint: "mainFragment"
      }
    });
    const glProgram = GlProgram.from({
      vertex,
      fragment: options?.clamp ? fragmentClamp : fragment$1,
      name: "kawase-blur-filter"
    });
    super({
      gpuProgram,
      glProgram,
      resources: {
        kawaseBlurUniforms: {
          uOffset: { value: new Float32Array(2), type: "vec2<f32>" }
        }
      }
    });
    __publicField$1(this, "uniforms");
    __publicField$1(this, "_pixelSize", { x: 0, y: 0 });
    __publicField$1(this, "_clamp");
    __publicField$1(this, "_kernels", []);
    __publicField$1(this, "_blur");
    __publicField$1(this, "_quality");
    this.uniforms = this.resources.kawaseBlurUniforms.uniforms;
    this.pixelSize = options.pixelSize ?? { x: 1, y: 1 };
    if (Array.isArray(options.strength)) {
      this.kernels = options.strength;
    } else if (typeof options.strength === "number") {
      this._blur = options.strength;
      this.quality = options.quality ?? 3;
    }
    this._clamp = !!options.clamp;
  }
  /**
   * Override existing apply method in `Filter`
   * @override
   * @ignore
   */
  apply(filterManager, input, output, clearMode) {
    const uvX = this.pixelSizeX / input.source.width;
    const uvY = this.pixelSizeY / input.source.height;
    let offset;
    if (this._quality === 1 || this._blur === 0) {
      offset = this._kernels[0] + 0.5;
      this.uniforms.uOffset[0] = offset * uvX;
      this.uniforms.uOffset[1] = offset * uvY;
      filterManager.applyFilter(this, input, output, clearMode);
    } else {
      const renderTarget = TexturePool.getSameSizeTexture(input);
      let source2 = input;
      let target = renderTarget;
      let tmp;
      const last = this._quality - 1;
      for (let i2 = 0; i2 < last; i2++) {
        offset = this._kernels[i2] + 0.5;
        this.uniforms.uOffset[0] = offset * uvX;
        this.uniforms.uOffset[1] = offset * uvY;
        filterManager.applyFilter(this, source2, target, true);
        tmp = source2;
        source2 = target;
        target = tmp;
      }
      offset = this._kernels[last] + 0.5;
      this.uniforms.uOffset[0] = offset * uvX;
      this.uniforms.uOffset[1] = offset * uvY;
      filterManager.applyFilter(this, source2, output, clearMode);
      TexturePool.returnTexture(renderTarget);
    }
  }
  /**
    * The amount of blur, value greater than `0`.
    * @default 4
    */
  get strength() {
    return this._blur;
  }
  set strength(value) {
    this._blur = value;
    this._generateKernels();
  }
  /**
    * The quality of the filter, integer greater than `1`.
    * @default 3
    */
  get quality() {
    return this._quality;
  }
  set quality(value) {
    this._quality = Math.max(1, Math.round(value));
    this._generateKernels();
  }
  /**
    * The kernel size of the blur filter, for advanced usage
    * @default [0]
    */
  get kernels() {
    return this._kernels;
  }
  set kernels(value) {
    if (Array.isArray(value) && value.length > 0) {
      this._kernels = value;
      this._quality = value.length;
      this._blur = Math.max(...value);
    } else {
      this._kernels = [0];
      this._quality = 1;
    }
  }
  /**
    * The size of the pixels. Large size is blurrier. For advanced usage.
    * @default {x:1,y:1}
    */
  get pixelSize() {
    return this._pixelSize;
  }
  set pixelSize(value) {
    if (typeof value === "number") {
      this.pixelSizeX = this.pixelSizeY = value;
      return;
    }
    if (Array.isArray(value)) {
      this.pixelSizeX = value[0];
      this.pixelSizeY = value[1];
      return;
    }
    this._pixelSize = value;
  }
  /**
    * The size of the pixels on the `x` axis. Large size is blurrier. For advanced usage.
    * @default 1
    */
  get pixelSizeX() {
    return this.pixelSize.x;
  }
  set pixelSizeX(value) {
    this.pixelSize.x = value;
  }
  /**
    * The size of the pixels on the `y` axis. Large size is blurrier. For advanced usage.
    * @default 1
    */
  get pixelSizeY() {
    return this.pixelSize.y;
  }
  set pixelSizeY(value) {
    this.pixelSize.y = value;
  }
  /**
    * Get the if the filter is clamped
    * @default false
    */
  get clamp() {
    return this._clamp;
  }
  /** Update padding based on kernel data */
  _updatePadding() {
    this.padding = Math.ceil(this._kernels.reduce((acc, v2) => acc + v2 + 0.5, 0));
  }
  /** Auto generate kernels by blur & quality */
  _generateKernels() {
    const blur = this._blur;
    const quality = this._quality;
    const kernels = [blur];
    if (blur > 0) {
      let k2 = blur;
      const step = blur / quality;
      for (let i2 = 1; i2 < quality; i2++) {
        k2 -= step;
        kernels.push(k2);
      }
    }
    this._kernels = kernels;
    this._updatePadding();
  }
};
__publicField$1(_KawaseBlurFilter, "DEFAULT_OPTIONS", {
  strength: 4,
  quality: 3,
  clamp: false,
  pixelSize: { x: 1, y: 1 }
});
let KawaseBlurFilter = _KawaseBlurFilter;
var fragment = "precision highp float;\nin vec2 vTextureCoord;\nout vec4 finalColor;\n\nuniform sampler2D uTexture;\nuniform float uAlpha;\nuniform vec3 uColor;\nuniform vec2 uOffset;\n\nuniform vec4 uInputSize;\n\nvoid main(void){\n    vec4 sample = texture(uTexture, vTextureCoord - uOffset * uInputSize.zw);\n\n    // Premultiply alpha\n    sample.rgb = uColor.rgb * sample.a;\n\n    // alpha user alpha\n    sample *= uAlpha;\n\n    finalColor = sample;\n}";
var source = "struct DropShadowUniforms {\n  uAlpha: f32,\n  uColor: vec3<f32>,\n  uOffset: vec2<f32>,\n};\n\nstruct GlobalFilterUniforms {\n  uInputSize:vec4<f32>,\n  uInputPixel:vec4<f32>,\n  uInputClamp:vec4<f32>,\n  uOutputFrame:vec4<f32>,\n  uGlobalFrame:vec4<f32>,\n  uOutputTexture:vec4<f32>,\n};\n\n@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;\n\n@group(0) @binding(1) var uTexture: texture_2d<f32>; \n@group(0) @binding(2) var uSampler: sampler;\n@group(1) @binding(0) var<uniform> dropShadowUniforms : DropShadowUniforms;\n\n@fragment\nfn mainFragment(\n  @builtin(position) position: vec4<f32>,\n  @location(0) uv : vec2<f32>\n) -> @location(0) vec4<f32> {\n  var color: vec4<f32> = textureSample(uTexture, uSampler, uv - dropShadowUniforms.uOffset * gfu.uInputSize.zw);\n\n  // Premultiply alpha\n  color = vec4<f32>(vec3<f32>(dropShadowUniforms.uColor.rgb * color.a), color.a);\n  // alpha user alpha\n  color *= dropShadowUniforms.uAlpha;\n\n  return color;\n}";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const _DropShadowFilter = class _DropShadowFilter2 extends Filter {
  /**
   * @param options - Options for the DropShadowFilter constructor.
   */
  constructor(options) {
    options = { ..._DropShadowFilter2.DEFAULT_OPTIONS, ...options };
    const gpuProgram = GpuProgram.from({
      vertex: {
        source: wgslVertex,
        entryPoint: "mainVertex"
      },
      fragment: {
        source,
        entryPoint: "mainFragment"
      }
    });
    const glProgram = GlProgram.from({
      vertex,
      fragment,
      name: "drop-shadow-filter"
    });
    super({
      gpuProgram,
      glProgram,
      resources: {
        dropShadowUniforms: {
          uAlpha: { value: options.alpha, type: "f32" },
          uColor: { value: new Float32Array(3), type: "vec3<f32>" },
          uOffset: { value: options.offset, type: "vec2<f32>" }
        }
      },
      resolution: options.resolution
    });
    __publicField(this, "uniforms");
    __publicField(this, "shadowOnly", false);
    __publicField(this, "_color");
    __publicField(this, "_blurFilter");
    __publicField(this, "_basePass");
    this.uniforms = this.resources.dropShadowUniforms.uniforms;
    this._color = new Color();
    this.color = options.color ?? 0;
    this._blurFilter = new KawaseBlurFilter({
      strength: options.kernels ?? options.blur,
      quality: options.kernels ? void 0 : options.quality
    });
    this._basePass = new Filter({
      gpuProgram: GpuProgram.from({
        vertex: {
          source: wgslVertex,
          entryPoint: "mainVertex"
        },
        fragment: {
          source: `
                    @group(0) @binding(1) var uTexture: texture_2d<f32>; 
                    @group(0) @binding(2) var uSampler: sampler;
                    @fragment
                    fn mainFragment(
                        @builtin(position) position: vec4<f32>,
                        @location(0) uv : vec2<f32>
                    ) -> @location(0) vec4<f32> {
                        return textureSample(uTexture, uSampler, uv);
                    }
                    `,
          entryPoint: "mainFragment"
        }
      }),
      glProgram: GlProgram.from({
        vertex,
        fragment: `
                in vec2 vTextureCoord;
                out vec4 finalColor;
                uniform sampler2D uTexture;

                void main(void){
                    finalColor = texture(uTexture, vTextureCoord);
                }
                `,
        name: "drop-shadow-filter"
      }),
      resources: {}
    });
    Object.assign(this, options);
  }
  /**
   * Override existing apply method in `Filter`
   * @override
   * @ignore
   */
  apply(filterManager, input, output, clearMode) {
    const renderTarget = TexturePool.getSameSizeTexture(input);
    filterManager.applyFilter(this, input, renderTarget, true);
    this._blurFilter.apply(filterManager, renderTarget, output, clearMode);
    if (!this.shadowOnly) {
      filterManager.applyFilter(this._basePass, input, output, false);
    }
    TexturePool.returnTexture(renderTarget);
  }
  /**
   * Set the offset position of the drop-shadow relative to the original image.
   * @default [4,4]
   */
  get offset() {
    return this.uniforms.uOffset;
  }
  set offset(value) {
    this.uniforms.uOffset = value;
    this._updatePadding();
  }
  /**
   * Set the offset position of the drop-shadow relative to the original image on the `x` axis
   * @default 4
   */
  get offsetX() {
    return this.offset.x;
  }
  set offsetX(value) {
    this.offset.x = value;
    this._updatePadding();
  }
  /**
   * Set the offset position of the drop-shadow relative to the original image on the `y` axis
   * @default 4
   */
  get offsetY() {
    return this.offset.y;
  }
  set offsetY(value) {
    this.offset.y = value;
    this._updatePadding();
  }
  /**
   * The color value of shadow.
   * @example [0.0, 0.0, 0.0] = 0x000000
   * @default 0x000000
   */
  get color() {
    return this._color.value;
  }
  set color(value) {
    this._color.setValue(value);
    const [r2, g2, b2] = this._color.toArray();
    this.uniforms.uColor[0] = r2;
    this.uniforms.uColor[1] = g2;
    this.uniforms.uColor[2] = b2;
  }
  /**
   * Coefficient for alpha multiplication
   * @default 1
   */
  get alpha() {
    return this.uniforms.uAlpha;
  }
  set alpha(value) {
    this.uniforms.uAlpha = value;
  }
  /**
   * The strength of the shadow's blur.
   * @default 2
   */
  get blur() {
    return this._blurFilter.strength;
  }
  set blur(value) {
    this._blurFilter.strength = value;
    this._updatePadding();
  }
  /**
   * Sets the quality of the Blur Filter
   * @default 4
   */
  get quality() {
    return this._blurFilter.quality;
  }
  set quality(value) {
    this._blurFilter.quality = value;
    this._updatePadding();
  }
  /** Sets the kernels of the Blur Filter */
  get kernels() {
    return this._blurFilter.kernels;
  }
  set kernels(value) {
    this._blurFilter.kernels = value;
  }
  /**
   * Sets the pixelSize of the Kawase Blur filter
   * @default [1,1]
   */
  get pixelSize() {
    return this._blurFilter.pixelSize;
  }
  set pixelSize(value) {
    if (typeof value === "number") {
      value = { x: value, y: value };
    }
    if (Array.isArray(value)) {
      value = { x: value[0], y: value[1] };
    }
    this._blurFilter.pixelSize = value;
  }
  /**
   * Sets the pixelSize of the Kawase Blur filter on the `x` axis
   * @default 1
   */
  get pixelSizeX() {
    return this._blurFilter.pixelSizeX;
  }
  set pixelSizeX(value) {
    this._blurFilter.pixelSizeX = value;
  }
  /**
   * Sets the pixelSize of the Kawase Blur filter on the `y` axis
   * @default 1
   */
  get pixelSizeY() {
    return this._blurFilter.pixelSizeY;
  }
  set pixelSizeY(value) {
    this._blurFilter.pixelSizeY = value;
  }
  /**
   * Recalculate the proper padding amount.
   * @private
   */
  _updatePadding() {
    const offsetPadding = Math.max(
      Math.abs(this.offsetX),
      Math.abs(this.offsetY)
    );
    this.padding = offsetPadding + this.blur * 2 + this.quality * 4;
  }
};
__publicField(_DropShadowFilter, "DEFAULT_OPTIONS", {
  offset: { x: 4, y: 4 },
  color: 0,
  alpha: 0.5,
  shadowOnly: false,
  kernels: void 0,
  blur: 2,
  quality: 3,
  pixelSize: { x: 1, y: 1 },
  resolution: 1
});
let DropShadowFilter = _DropShadowFilter;
class ImageTool {
  name = "image";
  context;
  current_tool;
  current_subtool;
  async setup(context2, tool, subtool) {
    this.context = context2;
    this.current_tool = tool;
    this.current_subtool = subtool;
  }
  cleanup() {
  }
  async add_image({
    image,
    fixed_canvas,
    border_region = 0
  }) {
    const image_command = new AddImageCommand(
      this.context,
      image,
      fixed_canvas,
      border_region
    );
    await this.context.execute_command(image_command);
  }
  set_tool(tool, subtool) {
    this.current_tool = tool;
    this.current_subtool = subtool;
  }
}
class AddImageCommand {
  sprite = null;
  fixed_canvas;
  context;
  background;
  current_canvas_size;
  computed_dimensions;
  current_scale;
  current_position;
  border_region;
  scaled_width;
  scaled_height;
  previous_image = null;
  name;
  constructor(context2, background, fixed_canvas, border_region = 0) {
    this.name = "AddImage";
    this.context = context2;
    this.background = background;
    this.fixed_canvas = fixed_canvas;
    this.border_region = border_region;
    this.current_canvas_size = get(this.context.dimensions);
    this.current_scale = get(this.context.scale);
    this.current_position = get(this.context.position);
    this.computed_dimensions = { width: 0, height: 0 };
    if (this.context.background_image && this.context.background_image.texture) {
      const bg = this.context.background_image;
      const stored_border_region = bg.borderRegion || 0;
      this.previous_image = {
        texture: this.clone_texture(bg.texture),
        width: bg.width,
        height: bg.height,
        x: bg.position.x,
        y: bg.position.y,
        border_region: stored_border_region
      };
    }
  }
  /**
   * Creates a copy of a texture to avoid reference issues
   */
  clone_texture(texture) {
    const render_texture = RenderTexture.create({
      width: texture.width,
      height: texture.height,
      resolution: window.devicePixelRatio || 1
    });
    const sprite = new Sprite(texture);
    const container = new Container();
    container.addChild(sprite);
    this.context.app.renderer.render(container, {
      renderTexture: render_texture
    });
    container.destroy({ children: true });
    return render_texture;
  }
  async start() {
    let image_texture;
    if (this.background instanceof Texture) {
      image_texture = this.background;
    } else {
      const img = await createImageBitmap(this.background);
      image_texture = Texture.from(img);
    }
    this.sprite = new Sprite(image_texture);
    const [width, height] = this.handle_image();
    this.computed_dimensions = { width, height };
  }
  handle_image() {
    if (this.sprite === null) {
      return [0, 0];
    }
    if (this.fixed_canvas) {
      const effectiveCanvasWidth = Math.max(
        this.current_canvas_size.width - this.border_region * 2,
        10
      );
      const effectiveCanvasHeight = Math.max(
        this.current_canvas_size.height - this.border_region * 2,
        10
      );
      const { width, height, x: x2, y: y2 } = fit_image_to_canvas(
        this.sprite.width,
        this.sprite.height,
        effectiveCanvasWidth,
        effectiveCanvasHeight
      );
      this.sprite.width = width;
      this.sprite.height = height;
      this.sprite.x = x2 + this.border_region;
      this.sprite.y = y2 + this.border_region;
    } else {
      const width = this.sprite.width;
      const height = this.sprite.height;
      this.sprite.x = this.border_region;
      this.sprite.y = this.border_region;
      return [width + this.border_region * 2, height + this.border_region * 2];
    }
    return [this.current_canvas_size.width, this.current_canvas_size.height];
  }
  async execute() {
    await this.start();
    if (this.sprite === null) {
      return;
    }
    const { width, height } = this.computed_dimensions;
    await this.context.set_image_properties({
      scale: 1,
      position: {
        x: this.context.app.screen.width / 2,
        y: this.context.app.screen.height / 2
      },
      width: this.fixed_canvas ? this.current_canvas_size.width : width,
      height: this.fixed_canvas ? this.current_canvas_size.height : height
    });
    const background_layer = this.context.layer_manager.create_background_layer(
      this.fixed_canvas ? this.current_canvas_size.width : width,
      this.fixed_canvas ? this.current_canvas_size.height : height
    );
    this.sprite.zIndex = 0;
    background_layer.addChild(this.sprite);
    this.context.layer_manager.reset_layers(
      this.fixed_canvas ? this.current_canvas_size.width : width,
      this.fixed_canvas ? this.current_canvas_size.height : height,
      true
    );
    if (this.border_region > 0) {
      this.sprite.borderRegion = this.border_region;
    }
    this.context.set_background_image(this.sprite);
    this.context.reset();
  }
  async undo() {
    if (this.sprite) {
      this.sprite.destroy();
      if (this.previous_image) {
        const previous_sprite = new Sprite(this.previous_image.texture);
        previous_sprite.width = this.previous_image.width;
        previous_sprite.height = this.previous_image.height;
        previous_sprite.position.set(
          this.previous_image.x,
          this.previous_image.y
        );
        if (this.previous_image.border_region > 0) {
          previous_sprite.borderRegion = this.previous_image.border_region;
        }
        await this.context.set_image_properties({
          scale: 1,
          position: {
            x: this.context.app.screen.width / 2,
            y: this.context.app.screen.height / 2
          },
          width: this.previous_image.width,
          height: this.previous_image.height
        });
        const background_layer = this.context.layer_manager.create_background_layer(
          this.previous_image.width,
          this.previous_image.height
        );
        previous_sprite.zIndex = 0;
        background_layer.addChild(previous_sprite);
        this.context.layer_manager.reset_layers(
          this.previous_image.width,
          this.previous_image.height,
          true
        );
        this.context.set_background_image(previous_sprite);
      } else {
        await this.context.set_image_properties({
          scale: 1,
          position: {
            x: this.context.app.screen.width / 2,
            y: this.context.app.screen.height / 2
          },
          width: this.current_canvas_size.width,
          height: this.current_canvas_size.height
        });
        this.context.layer_manager.create_background_layer(
          this.current_canvas_size.width,
          this.current_canvas_size.height
        );
        this.context.layer_manager.reset_layers(
          this.current_canvas_size.width,
          this.current_canvas_size.height
        );
      }
      this.context.reset();
    }
  }
}
function fit_image_to_canvas(image_width, image_height, canvas_width, canvas_height) {
  const image_aspect_ratio = image_width / image_height;
  const canvas_aspect_ratio = canvas_width / canvas_height;
  let new_width;
  let new_height;
  if (image_aspect_ratio > canvas_aspect_ratio) {
    new_width = canvas_width;
    new_height = canvas_width / image_aspect_ratio;
  } else {
    new_height = canvas_height;
    new_width = canvas_height * image_aspect_ratio;
  }
  const x2 = Math.round((canvas_width - new_width) / 2);
  const y2 = Math.round((canvas_height - new_height) / 2);
  return {
    width: Math.round(new_width),
    height: Math.round(new_height),
    x: x2,
    y: y2
  };
}
class ZoomTool {
  name = "zoom";
  min_zoom = writable(true);
  image_editor_context;
  max_zoom = 10;
  border_padding = 30;
  pad_bottom = 0;
  is_pinching = false;
  is_dragging = false;
  is_pointer_dragging = false;
  last_touch_position = null;
  last_pinch_distance = 0;
  drag_start = new Point();
  current_tool;
  current_subtool;
  local_scale = 1;
  local_dimensions = {
    width: 0,
    height: 0
  };
  local_position = { x: 0, y: 0 };
  /**
   * Prevents default behavior for events
   * @param {FederatedWheelEvent | FederatedPointerEvent} event - The event to prevent default behavior for
   */
  prevent_default(event) {
    event.preventDefault();
    event.stopPropagation();
  }
  /**
   * Sets the current tool and subtool
   * @param {ToolbarTool} tool - The tool to set
   * @param {Subtool} subtool - The subtool to set
   */
  set_tool(tool, subtool) {
    this.current_tool = tool;
    this.current_subtool = subtool;
  }
  /**
   * Sets the zoom level to a specific percentage or fits the image to the screen
   * @param {number | 'fit'} zoom_level - The zoom level to set (0-1) or 'fit' to use min_zoom
   * @returns {void}
   */
  set_zoom(zoom_level) {
    const fit_zoom = this.calculate_min_zoom(
      this.local_dimensions.width,
      this.local_dimensions.height
    );
    let target_zoom;
    const is_fit_zoom = zoom_level === "fit";
    if (is_fit_zoom) {
      target_zoom = fit_zoom;
    } else {
      target_zoom = Math.max(0, Math.min(this.max_zoom, zoom_level));
    }
    const canvas = this.image_editor_context.app.screen;
    const canvas_width = canvas.width;
    const canvas_height = canvas.height;
    let center_point;
    center_point = {
      x: canvas_width / 2,
      y: canvas_height / 2
    };
    this.zoom_to_point(target_zoom, center_point, true, is_fit_zoom);
  }
  /**
   * Sets up the zoom tool with the given context and state
   * @param {ImageEditorContext} context - The image editor context
   * @param {ToolbarTool} tool - The current tool
   * @param {Subtool} subtool - The current subtool
   * @returns {Promise<void>}
   */
  async setup(context2, tool, subtool) {
    this.image_editor_context = context2;
    this.current_tool = tool;
    this.current_subtool = subtool;
    this.pad_bottom = context2.pad_bottom;
    const { width, height } = await this.get_container_dimensions();
    const fit_zoom = this.calculate_min_zoom(width, height);
    const min_zoom = Math.min(fit_zoom, 1);
    this.local_scale = min_zoom;
    const canvas = this.image_editor_context.app.screen;
    const center_x = canvas.width / 2;
    const center_y = canvas.height / 2;
    const scaled_width = width * min_zoom;
    const scaled_height = height * min_zoom;
    const initial_x = center_x - scaled_width / 2;
    const initial_y = center_y - scaled_height / 2;
    this.local_position = { x: initial_x, y: initial_y };
    this.setup_event_listeners();
    await this.image_editor_context.set_image_properties({
      scale: min_zoom,
      position: { x: initial_x, y: initial_y }
    });
    this.image_editor_context.dimensions.subscribe((dimensions) => {
      this.local_dimensions = dimensions;
    });
    this.image_editor_context.scale.subscribe((scale) => {
      this.local_scale = scale;
    });
    this.image_editor_context.position.subscribe((position) => {
      this.local_position = position;
    });
  }
  /**
   * Sets up event listeners for zoom and pan functionality
   * @private
   */
  setup_event_listeners() {
    const stage = this.image_editor_context.app.stage;
    const canvas = this.image_editor_context.app.canvas;
    canvas.addEventListener("wheel", this.prevent_default, { passive: false });
    stage.eventMode = "static";
    stage.hitArea = this.image_editor_context.app.screen;
    const wheel_listener = this.handle_wheel.bind(this);
    stage.addEventListener("wheel", wheel_listener, { passive: false });
    if ("ontouchstart" in window) {
      stage.addEventListener(
        "touchstart",
        this.handle_touch_start.bind(this)
      );
      stage.addEventListener(
        "touchmove",
        this.handle_touch_move.bind(this)
      );
      stage.addEventListener(
        "touchend",
        this.handle_touch_end.bind(this)
      );
    } else {
      stage.addEventListener(
        "pointerdown",
        this.handle_pointer_down.bind(this)
      );
      stage.addEventListener(
        "pointermove",
        this.handle_pointer_move.bind(this)
      );
      stage.addEventListener("pointerup", this.handle_pointer_up.bind(this));
      stage.addEventListener(
        "pointerupoutside",
        this.handle_pointer_up.bind(this)
      );
    }
  }
  /**
   * Handles wheel events for zooming
   * @param {FederatedWheelEvent} event - The wheel event
   * @private
   */
  handle_wheel(event) {
    const is_trackpad = event.deltaMode === 0 && Math.abs(event.deltaY) < 50;
    const scroll_speed = is_trackpad ? 30 : 10;
    if (event.altKey || event.metaKey) {
      const local_point = this.image_editor_context.app.stage.toLocal(
        event.global
      );
      const zoom_delta = -event.deltaY * (is_trackpad ? 1e-3 : 5e-4);
      const new_scale = this.local_scale * (1 + zoom_delta);
      this.zoom_to_point(new_scale, local_point, true);
    } else {
      const delta_x = event.deltaX;
      const delta_y = event.deltaY;
      const raw_position = {
        x: this.local_position.x - delta_x / 100 * scroll_speed,
        y: this.local_position.y - delta_y / 100 * scroll_speed
      };
      const canvas = this.image_editor_context.app.screen;
      const scaled_width = this.local_dimensions.width * this.local_scale;
      const scaled_height = this.local_dimensions.height * this.local_scale;
      const available_width = canvas.width - this.border_padding * 2;
      const available_height = canvas.height - this.border_padding * 2 - this.pad_bottom;
      let final_position = { ...raw_position };
      if (scaled_width <= available_width) {
        final_position.x = (canvas.width - scaled_width) / 2;
      } else {
        const max_offset = canvas.width / 2;
        const left_bound = max_offset;
        const right_bound = canvas.width - max_offset - scaled_width;
        final_position.x = Math.min(
          Math.max(raw_position.x, right_bound),
          left_bound
        );
      }
      if (scaled_height <= available_height) {
        final_position.y = (canvas.height - this.pad_bottom - scaled_height) / 2;
      } else {
        const max_offset = (canvas.height - this.pad_bottom) / 2;
        const top_bound = max_offset;
        const bottom_bound = canvas.height - this.pad_bottom - max_offset - scaled_height;
        final_position.y = Math.min(
          Math.max(raw_position.y, bottom_bound),
          top_bound
        );
      }
      this.image_editor_context.set_image_properties({
        scale: this.local_scale,
        position: final_position
      });
    }
  }
  /**
   * Cleans up resources and event listeners
   */
  cleanup() {
    const stage = this?.image_editor_context?.app?.stage;
    if (!stage)
      return;
    stage.removeEventListener("wheel", this.handle_wheel.bind(this));
    if ("ontouchstart" in window) {
      stage.removeEventListener(
        "touchstart",
        this.handle_touch_start.bind(this)
      );
      stage.removeEventListener(
        "touchmove",
        this.handle_touch_move.bind(this)
      );
      stage.removeEventListener(
        "touchend",
        this.handle_touch_end.bind(this)
      );
    } else {
      stage.removeEventListener(
        "pointerdown",
        this.handle_pointer_down.bind(this)
      );
      stage.removeEventListener(
        "pointermove",
        this.handle_pointer_move.bind(this)
      );
      stage.removeEventListener("pointerup", this.handle_pointer_up.bind(this));
      stage.removeEventListener(
        "pointerupoutside",
        this.handle_pointer_up.bind(this)
      );
    }
  }
  /**
   * Gets the dimensions of the container
   * @returns {Promise<{width: number, height: number}>} The container dimensions
   * @private
   */
  async get_container_dimensions() {
    const bounds = this.image_editor_context.image_container.getLocalBounds();
    return {
      width: bounds.width,
      height: bounds.height
    };
  }
  /**
   * Calculates the minimum zoom level to fit the image in the viewport
   * @param {number} container_width - The width of the container
   * @param {number} container_height - The height of the container
   * @returns {number} The minimum zoom level
   * @private
   */
  calculate_min_zoom(container_width, container_height) {
    const canvas = this.image_editor_context.app.screen;
    const viewport_width = canvas.width;
    const viewport_height = canvas.height;
    if (!container_width || !viewport_width || !container_height || !viewport_height) {
      return 1;
    }
    const available_width = viewport_width - this.border_padding * 2;
    const available_height = viewport_height - this.border_padding * 2 - this.pad_bottom;
    const width_ratio = available_width / container_width;
    const height_ratio = available_height / container_height;
    return Math.min(width_ratio, height_ratio);
  }
  /**
   * Handles touch start events
   * @param {TouchEvent} event - The touch event
   * @private
   */
  handle_touch_start(event) {
    event.preventDefault();
    const touchEvent = event;
    if (touchEvent.touches && touchEvent.touches.length === 2) {
      this.is_pinching = true;
      this.last_pinch_distance = Math.hypot(
        touchEvent.touches[0].pageX - touchEvent.touches[1].pageX,
        touchEvent.touches[0].pageY - touchEvent.touches[1].pageY
      );
    } else if (touchEvent.touches && touchEvent.touches.length === 1) {
      this.is_dragging = true;
      const rect = this.image_editor_context.app.view.getBoundingClientRect();
      this.last_touch_position = new Point(
        touchEvent.touches[0].pageX - rect.left,
        touchEvent.touches[0].pageY - rect.top
      );
    }
  }
  /**
   * Handles touch move events
   * @param {TouchEvent} event - The touch event
   * @private
   */
  handle_touch_move(event) {
    event.preventDefault();
    const touchEvent = event;
    if (this.is_pinching && touchEvent.touches && touchEvent.touches.length === 2) {
      const rect = this.image_editor_context.app.view.getBoundingClientRect();
      const current_distance = Math.hypot(
        touchEvent.touches[0].pageX - touchEvent.touches[1].pageX,
        touchEvent.touches[0].pageY - touchEvent.touches[1].pageY
      );
      const pinch_center = {
        x: (touchEvent.touches[0].pageX + touchEvent.touches[1].pageX) / 2 - rect.left,
        y: (touchEvent.touches[0].pageY + touchEvent.touches[1].pageY) / 2 - rect.top
      };
      const scale_val = current_distance / this.last_pinch_distance;
      this.last_pinch_distance = current_distance;
      this.zoom_to_point(this.local_scale * scale_val, pinch_center);
    } else if (this.is_dragging && touchEvent.touches && touchEvent.touches.length === 1 && this.last_touch_position) {
      const rect = this.image_editor_context.app.view.getBoundingClientRect();
      const current_position = new Point(
        touchEvent.touches[0].pageX - rect.left,
        touchEvent.touches[0].pageY - rect.top
      );
      const dx = current_position.x - this.last_touch_position.x;
      const dy = current_position.y - this.last_touch_position.y;
      this.image_editor_context.set_image_properties({
        position: {
          x: this.local_position.x + dx,
          y: this.local_position.y + dy
        }
      });
      this.last_touch_position = current_position;
    }
  }
  /**
   * Handles touch end events
   * @param {TouchEvent} event - The touch event
   * @private
   */
  handle_touch_end(event) {
    event.preventDefault();
    const touchEvent = event;
    if (touchEvent.touches && touchEvent.touches.length < 2) {
      this.is_pinching = false;
      if (touchEvent.touches && touchEvent.touches.length === 1) {
        const rect = this.image_editor_context.app.view.getBoundingClientRect();
        this.last_touch_position = new Point(
          touchEvent.touches[0].pageX - rect.left,
          touchEvent.touches[0].pageY - rect.top
        );
        this.is_dragging = true;
      }
    }
    if (touchEvent.touches && touchEvent.touches.length === 0) {
      this.is_dragging = false;
      this.last_touch_position = null;
      this.last_pinch_distance = 0;
    }
  }
  /**
   * Gets the bounded position to keep the image within the viewport
   * @param {Object} position - The position to bound
   * @param {number} position.x - The x coordinate
   * @param {number} position.y - The y coordinate
   * @returns {Object} The bounded position
   * @private
   */
  get_bounded_position(position) {
    const canvas = this.image_editor_context.app.screen;
    const scaled_width = this.local_dimensions.width * this.local_scale;
    const scaled_height = this.local_dimensions.height * this.local_scale;
    const center_position = {
      x: (canvas.width - scaled_width) / 2,
      y: (canvas.height - scaled_height - this.pad_bottom) / 2
    };
    if (scaled_width <= canvas.width && scaled_height <= canvas.height) {
      return center_position;
    }
    let x2 = position.x;
    let y2 = position.y;
    if (scaled_width <= canvas.width) {
      x2 = center_position.x;
    } else {
      const min_x = canvas.width - scaled_width;
      const max_x = 0;
      x2 = Math.max(min_x, Math.min(max_x, position.x));
    }
    if (scaled_height <= canvas.height - this.pad_bottom) {
      y2 = center_position.y;
    } else {
      const min_y = canvas.height - scaled_height - this.pad_bottom;
      const max_y = 0;
      y2 = Math.max(min_y, Math.min(max_y, position.y));
    }
    return { x: x2, y: y2 };
  }
  /**
   * Zooms to a specific point with a new zoom level
   * @param {number} new_zoom - The new zoom level
   * @param {Object} point - The point to zoom to
   * @param {number} point.x - The x coordinate of the point
   * @param {number} point.y - The y coordinate of the point
   * @param {boolean} hard - Whether to apply a hard zoom (no animation)
   * @param {boolean} is_fit_zoom - Whether this is a fit zoom operation
   * @private
   */
  zoom_to_point(new_zoom, point, hard, is_fit_zoom) {
    const cursor_relative_to_image = {
      x: (point.x - this.local_position.x) / this.local_scale,
      y: (point.y - this.local_position.y) / this.local_scale
    };
    const image_percentages = {
      x: cursor_relative_to_image.x / this.local_dimensions.width,
      y: cursor_relative_to_image.y / this.local_dimensions.height
    };
    const fit_zoom = this.calculate_min_zoom(
      this.local_dimensions.width,
      this.local_dimensions.height
    );
    const min_zoom = Math.min(fit_zoom, 1);
    new_zoom = Math.min(Math.max(new_zoom, min_zoom), this.max_zoom);
    const new_scaled_width = this.local_dimensions.width * new_zoom;
    const new_scaled_height = this.local_dimensions.height * new_zoom;
    let new_position = {
      x: point.x - new_scaled_width * image_percentages.x,
      y: point.y - new_scaled_height * image_percentages.y
    };
    if (new_zoom === min_zoom || is_fit_zoom) {
      const canvas_width = this.image_editor_context.app.screen.width;
      const canvas_height = this.image_editor_context.app.screen.height;
      new_position = {
        x: (canvas_width - new_scaled_width) / 2,
        y: (canvas_height - this.pad_bottom - new_scaled_height) / 2
      };
    }
    this.image_editor_context.set_image_properties({
      scale: new_zoom,
      position: new_position,
      animate: typeof hard === "boolean" ? !hard : new_zoom === min_zoom
    });
    this.min_zoom.set(new_zoom === min_zoom);
  }
  /**
   * Handles pointer down events
   * @param {FederatedPointerEvent} event - The pointer event
   * @private
   */
  handle_pointer_down(event) {
    if (event.button === 0 && this.current_tool === "pan") {
      this.is_pointer_dragging = true;
      this.drag_start.copyFrom(event.global);
      this.drag_start.x -= this.local_position.x;
      this.drag_start.y -= this.local_position.y;
    }
  }
  /**
   * Handles pointer move events
   * @param {FederatedPointerEvent} event - The pointer event
   * @private
   */
  handle_pointer_move(event) {
    if (this.is_pointer_dragging && this.current_tool === "pan") {
      const raw_position = {
        x: event.global.x - this.drag_start.x,
        y: event.global.y - this.drag_start.y
      };
      const canvas = this.image_editor_context.app.screen;
      const scaled_width = this.local_dimensions.width * this.local_scale;
      const scaled_height = this.local_dimensions.height * this.local_scale;
      const available_width = canvas.width - this.border_padding * 2;
      const available_height = canvas.height - this.border_padding * 2 - this.pad_bottom;
      let final_position = { ...raw_position };
      if (scaled_width <= available_width) {
        final_position.x = (canvas.width - scaled_width) / 2;
      } else {
        final_position.x = raw_position.x;
      }
      if (scaled_height <= available_height) {
        final_position.y = (canvas.height - this.pad_bottom - scaled_height) / 2;
      } else {
        final_position.y = raw_position.y;
      }
      this.image_editor_context.set_image_properties({
        scale: this.local_scale,
        position: final_position
      });
    }
  }
  /**
   * Handles pointer up events
   * @param {FederatedPointerEvent} event - The pointer event
   * @private
   */
  handle_pointer_up(event) {
    if (this.is_pointer_dragging && this.current_tool === "pan") {
      this.is_pointer_dragging = false;
      const raw_position = {
        x: event.global.x - this.drag_start.x,
        y: event.global.y - this.drag_start.y
      };
      const canvas = this.image_editor_context.app.screen;
      const scaled_width = this.local_dimensions.width * this.local_scale;
      const scaled_height = this.local_dimensions.height * this.local_scale;
      const available_width = canvas.width - this.border_padding * 2;
      const available_height = canvas.height - this.border_padding * 2 - this.pad_bottom;
      let final_position = { ...raw_position };
      if (scaled_width <= available_width) {
        final_position.x = (canvas.width - scaled_width) / 2;
      } else {
        const max_offset = canvas.width / 2;
        const left_bound = max_offset;
        const right_bound = canvas.width - max_offset - scaled_width;
        final_position.x = Math.min(
          Math.max(raw_position.x, right_bound),
          left_bound
        );
      }
      if (scaled_height <= available_height) {
        final_position.y = (canvas.height - this.pad_bottom - scaled_height) / 2;
      } else {
        const max_offset = (canvas.height - this.pad_bottom) / 2;
        const top_bound = max_offset;
        const bottom_bound = canvas.height - this.pad_bottom - max_offset - scaled_height;
        final_position.y = Math.min(
          Math.max(raw_position.y, bottom_bound),
          top_bound
        );
      }
      this.image_editor_context.set_image_properties({
        scale: this.local_scale,
        position: final_position,
        animate: true
      });
    }
  }
}
class LayerManager {
  layers = [];
  active_layer = null;
  active_layer_id = null;
  draw_textures = /* @__PURE__ */ new Map();
  layer_store = writable({
    active_layer: "",
    layers: []
  });
  background_layer = null;
  image_container;
  app;
  fixed_canvas;
  dark;
  border_region;
  layer_options;
  constructor(image_container, app, fixed_canvas, dark, border_region, layer_options) {
    this.image_container = image_container;
    this.app = app;
    this.fixed_canvas = fixed_canvas;
    this.dark = dark;
    this.border_region = border_region;
    this.layer_options = layer_options;
  }
  toggle_layer_visibility(id) {
    const layer = this.layers.find((l2) => l2.id === id);
    if (layer) {
      layer.container.visible = !layer.container.visible;
      layer.visible = layer.container.visible;
      this.layer_store.update((state) => ({
        active_layer: state.active_layer,
        layers: this.layers
      }));
    }
  }
  create_background_layer(width, height) {
    if (this.background_layer) {
      this.background_layer.destroy();
    }
    const layer = new Container();
    this.background_layer = layer;
    const bg_texture = RenderTexture.create({
      width,
      height,
      resolution: window.devicePixelRatio,
      antialias: true,
      scaleMode: SCALE_MODES.NEAREST
    });
    const bg_sprite = new Sprite(bg_texture);
    layer.addChild(bg_sprite);
    const clear_graphics = new Graphics();
    clear_graphics.clear();
    clear_graphics.rect(0, 0, width, height).fill({ color: this.dark ? 3355443 : 16777215, alpha: 1 });
    this.app.renderer.render({
      container: clear_graphics,
      target: bg_texture,
      clear: true
    });
    this.image_container.addChild(layer);
    layer.zIndex = -1;
    this.update_layer_order();
    return layer;
  }
  set_layer_options(layer_options, width, height) {
    this.layer_options = layer_options;
    this.reset_layers(width, height);
  }
  /**
   * Creates a background layer from an image URL
   * @param url The URL of the image to use as background
   * @param width The width of the layer (if fixed_canvas is true)
   * @param height The height of the layer (if fixed_canvas is true)
   * @param borderRegion Minimum border region to add around the image for outpainting (in pixels)
   * @returns A Promise that resolves to the background Container when the image is loaded
   */
  async create_background_layer_from_url(url, width, height) {
    const layer = this.create_background_layer(
      width || this.image_container.width,
      height || this.image_container.height
    );
    try {
      const texture = await Texture.from(url);
      const sprite = new Sprite(texture);
      const imageWidth = sprite.texture.width;
      const imageHeight = sprite.texture.height;
      const containerWidth = width || this.image_container.width;
      const containerHeight = height || this.image_container.height;
      if (this.fixed_canvas) {
        const effectiveContainerWidth = Math.max(
          containerWidth - this.border_region * 2,
          10
        );
        const effectiveContainerHeight = Math.max(
          containerHeight - this.border_region * 2,
          10
        );
        const imageAspectRatio = imageWidth / imageHeight;
        const containerAspectRatio = effectiveContainerWidth / effectiveContainerHeight;
        let finalWidth, finalHeight;
        let posX = this.border_region, posY = this.border_region;
        if (imageWidth <= effectiveContainerWidth && imageHeight <= effectiveContainerHeight) {
          finalWidth = imageWidth;
          finalHeight = imageHeight;
        } else {
          if (imageAspectRatio > containerAspectRatio) {
            finalWidth = effectiveContainerWidth;
            finalHeight = effectiveContainerWidth / imageAspectRatio;
          } else {
            finalHeight = effectiveContainerHeight;
            finalWidth = effectiveContainerHeight * imageAspectRatio;
          }
        }
        posX += Math.round((effectiveContainerWidth - finalWidth) / 2);
        posY += Math.round((effectiveContainerHeight - finalHeight) / 2);
        sprite.width = finalWidth;
        sprite.height = finalHeight;
        sprite.position.set(posX, posY);
      } else {
        sprite.position.set(this.border_region, this.border_region);
        if (this.background_layer) {
          this.background_layer.destroy();
        }
        const totalWidth = imageWidth + this.border_region * 2;
        const totalHeight = imageHeight + this.border_region * 2;
        const newLayer = this.create_background_layer(totalWidth, totalHeight);
        sprite.width = imageWidth;
        sprite.height = imageHeight;
        newLayer.addChild(sprite);
        return newLayer;
      }
      layer.addChild(sprite);
      return layer;
    } catch (error) {
      console.error("Error loading image from URL:", error);
      return layer;
    }
  }
  create_layer({
    width,
    height,
    layer_name,
    user_created,
    layer_id = void 0,
    make_active = false
  }) {
    const layer = new Container();
    const _layer_id = layer_id || Math.random().toString(36).substring(2, 15);
    const _layer_name = layer_name || `Layer ${this.layers.length + 1}`;
    this.layers.push({
      name: _layer_name,
      id: _layer_id,
      container: layer,
      user_created,
      visible: true
    });
    this.image_container.addChild(layer);
    const draw_texture = RenderTexture.create({
      width,
      height,
      resolution: window.devicePixelRatio,
      antialias: true,
      scaleMode: SCALE_MODES.NEAREST
    });
    const canvas_sprite = new Sprite(draw_texture);
    layer.addChild(canvas_sprite);
    const clear_graphics = new Graphics();
    clear_graphics.clear();
    clear_graphics.beginFill(0, 0);
    clear_graphics.drawRect(0, 0, width, height);
    clear_graphics.endFill();
    this.app.renderer.render({
      container: clear_graphics,
      target: draw_texture,
      clear: true
    });
    this.draw_textures.set(layer, draw_texture);
    this.update_layer_order();
    if (make_active) {
      this.set_active_layer(_layer_id);
    }
    this.layer_store.set({
      active_layer: this.active_layer_id || "",
      layers: this.layers
    });
    return layer;
  }
  /**
   * Creates a new layer with an image loaded from a URL
   * @param url The URL of the image to load
   * @param borderRegion Minimum border region to add around the image for outpainting (in pixels)
   * @returns A Promise that resolves to the layer ID
   */
  async add_layer_from_url(url) {
    const { width, height } = this.image_container.getLocalBounds();
    const layer = this.create_layer({
      width,
      height,
      layer_name: "Layer 1",
      user_created: true
    });
    const layerIndex = this.layers.findIndex((l2) => l2.container === layer);
    if (layerIndex === -1) {
      console.error("Could not find newly created layer");
      return "";
    }
    const layerId = this.layers[layerIndex].id;
    try {
      const texture = await Assets.load(url);
      const drawTexture = this.draw_textures.get(layer);
      if (!drawTexture) {
        console.error("No draw texture found for layer");
        return layerId;
      }
      const sprite = new Sprite(texture);
      const imageWidth = sprite.width;
      const imageHeight = sprite.height;
      let posX = this.border_region;
      let posY = this.border_region;
      const effectiveWidth = this.fixed_canvas ? width - this.border_region * 2 : width;
      const effectiveHeight = this.fixed_canvas ? height - this.border_region * 2 : height;
      if (imageWidth < effectiveWidth || imageHeight < effectiveHeight) {
        posX = Math.floor((effectiveWidth - imageWidth) / 2);
        posY = Math.floor((effectiveHeight - imageHeight) / 2);
      }
      sprite.position.set(posX, posY);
      if (imageWidth > effectiveWidth || imageHeight > effectiveHeight) {
        const imageAspectRatio = imageWidth / imageHeight;
        const areaAspectRatio = effectiveWidth / effectiveHeight;
        let finalWidth, finalHeight;
        if (imageAspectRatio > areaAspectRatio) {
          finalWidth = effectiveWidth;
          finalHeight = effectiveWidth / imageAspectRatio;
        } else {
          finalHeight = effectiveHeight;
          finalWidth = effectiveHeight * imageAspectRatio;
        }
        sprite.width = finalWidth;
        sprite.height = finalHeight;
        posX = this.border_region + Math.floor((effectiveWidth - finalWidth) / 2);
        posY = this.border_region + Math.floor((effectiveHeight - finalHeight) / 2);
        sprite.position.set(posX, posY);
      }
      this.app.renderer.render(sprite, { renderTexture: drawTexture });
      this.set_active_layer(layerId);
      return layerId;
    } catch (error) {
      console.error("Error loading image from URL:", error);
      return layerId;
    }
  }
  get_active_layer() {
    return this.active_layer;
  }
  set_active_layer(id) {
    if (this.layers.some((l2) => l2.id === id)) {
      this.active_layer = this.layers.find((l2) => l2.id === id)?.container || this.layers[0]?.container || null;
      this.active_layer_id = id;
      this.layer_store.set({
        active_layer: id,
        layers: this.layers
      });
    }
  }
  get_layers() {
    return this.layers;
  }
  get_layer_textures(id) {
    const layer = this.layers.find((l2) => l2.id === id);
    if (layer) {
      const draw = this.draw_textures.get(layer.container);
      if (draw) {
        return { draw };
      }
    }
    return null;
  }
  delete_layer(id) {
    const index = this.layers.findIndex((l2) => l2.id === id);
    if (index > -1) {
      const draw_texture = this.draw_textures.get(this.layers[index].container);
      if (draw_texture) {
        draw_texture.destroy();
        this.draw_textures.delete(this.layers[index].container);
      }
      this.layers[index].container.destroy();
      if (this.active_layer === this.layers[index].container) {
        const new_active_layer = this.layers[Math.max(0, index - 1)] || null;
        this.active_layer = new_active_layer?.container || null;
        this.active_layer_id = new_active_layer?.id || null;
      }
      this.layers = this.layers.filter((l2) => l2.id !== id);
      this.layer_store.update((_layers) => ({
        active_layer: _layers.active_layer === id ? this.layers[this.layers.length - 1]?.id : _layers.active_layer,
        layers: this.layers
      }));
      this.update_layer_order();
    }
  }
  update_layer_order() {
    if (this.background_layer) {
      this.background_layer.zIndex = -1;
    }
    this.layers.forEach((layer, index) => {
      layer.container.zIndex = index;
    });
  }
  move_layer(id, direction) {
    const index = this.layers.findIndex((l2) => l2.id === id);
    if (index > -1) {
      const new_index = direction === "up" ? index - 1 : index + 1;
      this.layers = this.layers.map((l2, i2) => {
        if (i2 === index) {
          return this.layers[new_index];
        }
        if (i2 === new_index) {
          return this.layers[index];
        }
        return l2;
      });
      this.update_layer_order();
      this.layer_store.update((_layers) => ({
        active_layer: id,
        layers: this.layers
      }));
    }
  }
  /**
   * Resizes all layers to a new width and height
   * @param newWidth The new width of the layers
   * @param newHeight The new height of the layers
   * @param scale If true, scales the layer content to fit the new dimensions. If false, keeps the content size unchanged.
   * @param anchor The anchor point to position the content relative to the new size
   */
  resize_all_layers(newWidth, newHeight, scale, anchor, oldCanvasWidth, oldCanvasHeight) {
    new Map(this.layers.map((l2) => [l2.id, l2]));
    const oldBackgroundLayer = this.background_layer;
    const calculateOffset = () => {
      let offsetX = 0;
      let offsetY = 0;
      const deltaWidth = newWidth - oldCanvasWidth;
      const deltaHeight = newHeight - oldCanvasHeight;
      if (anchor.includes("left")) {
        offsetX = 0;
      } else if (anchor.includes("right")) {
        offsetX = deltaWidth;
      } else {
        offsetX = Math.floor(deltaWidth / 2);
      }
      if (anchor.includes("top")) {
        offsetY = 0;
      } else if (anchor.includes("bottom")) {
        offsetY = deltaHeight;
      } else {
        offsetY = Math.floor(deltaHeight / 2);
      }
      return { offsetX, offsetY };
    };
    this.background_layer = this._resize_background_layer(
      oldBackgroundLayer,
      newWidth,
      newHeight,
      scale,
      calculateOffset
    );
    const processedLayers = [];
    const oldLayerData = this.layers.map((oldLayer) => ({
      id: oldLayer.id,
      name: oldLayer.name,
      user_created: oldLayer.user_created,
      texture: this.draw_textures.get(oldLayer.container),
      container: oldLayer.container
    }));
    this.layers = [];
    this.draw_textures.clear();
    for (const oldData of oldLayerData) {
      const newLayer = this._resize_single_layer(
        oldData,
        newWidth,
        newHeight,
        scale,
        calculateOffset
      );
      if (newLayer) {
        processedLayers.push(newLayer);
      }
    }
    const currentActiveId = get(this.layer_store).active_layer;
    const activeLayerExists = processedLayers.some(
      (l2) => l2.id === currentActiveId
    );
    if (!activeLayerExists && processedLayers.length > 0) {
      this.set_active_layer(processedLayers[0].id);
    } else if (processedLayers.length === 0) {
      this.layer_store.update((s2) => ({ ...s2, active_layer: "" }));
    } else {
      this.layer_store.update((s2) => ({ ...s2 }));
    }
    this.update_layer_order();
    setTimeout(() => {
      Assets.cache.reset();
      this.app.renderer.textureGC.run();
    }, 100);
  }
  /**
   * Helper method to resize the background layer.
   */
  _resize_background_layer(oldBackgroundLayer, newWidth, newHeight, scale, calculateOffset) {
    if (!oldBackgroundLayer) {
      return this.create_background_layer(newWidth, newHeight);
    }
    let backgroundImage = oldBackgroundLayer.children.find(
      (child) => child instanceof Sprite && child.texture !== oldBackgroundLayer.children[0]?.texture
    );
    const newBackgroundLayer = this.create_background_layer(
      newWidth,
      newHeight
    );
    if (backgroundImage) {
      const newBgImage = new Sprite(backgroundImage.texture);
      newBgImage.width = backgroundImage.width;
      newBgImage.height = backgroundImage.height;
      if (scale) {
        newBgImage.width = newWidth;
        newBgImage.height = newHeight;
        newBgImage.position.set(0, 0);
      } else {
        const { offsetX, offsetY } = calculateOffset();
        newBgImage.position.set(
          backgroundImage.x + offsetX,
          backgroundImage.y + offsetY
        );
      }
      newBackgroundLayer.addChild(newBgImage);
    }
    return newBackgroundLayer;
  }
  /**
   * Helper method to resize a single regular layer.
   */
  _resize_single_layer(oldData, newWidth, newHeight, scale, calculateOffset) {
    if (!oldData.texture) {
      console.warn(
        `No texture found for layer ${oldData.id}, skipping cleanup.`
      );
      if (oldData.container && !oldData.container.destroyed) {
        if (this.image_container.children.includes(oldData.container)) {
          this.image_container.removeChild(oldData.container);
        }
        oldData.container.destroy({ children: true });
      }
      return null;
    }
    const newContainer = this.create_layer({
      width: newWidth,
      height: newHeight,
      layer_name: oldData.name,
      user_created: oldData.user_created
    });
    const newLayer = this.layers[this.layers.length - 1];
    newLayer.id = oldData.id;
    const newTexture = this.draw_textures.get(newContainer);
    if (!newTexture) {
      console.error(
        `Failed to get texture for newly created layer ${newLayer.id}. Cleaning up.`
      );
      if (newContainer && !newContainer.destroyed) {
        if (this.image_container.children.includes(newContainer)) {
          this.image_container.removeChild(newContainer);
        }
        newContainer.destroy({ children: true });
        const idx = this.layers.findIndex((l2) => l2.container === newContainer);
        if (idx > -1)
          this.layers.splice(idx, 1);
        this.draw_textures.delete(newContainer);
      }
      if (oldData.texture && !oldData.texture.destroyed)
        oldData.texture.destroy(true);
      if (oldData.container && !oldData.container.destroyed)
        oldData.container.destroy({ children: true });
      return null;
    }
    this.app.renderer.clear({ target: newTexture, clearColor: [0, 0, 0, 0] });
    const sprite = new Sprite(oldData.texture);
    if (scale) {
      sprite.width = newWidth;
      sprite.height = newHeight;
      sprite.position.set(0, 0);
    } else {
      const { offsetX, offsetY } = calculateOffset();
      sprite.position.set(offsetX, offsetY);
    }
    this.app.renderer.render(sprite, { renderTexture: newTexture });
    sprite.destroy();
    if (oldData.texture && !oldData.texture.destroyed) {
      oldData.texture.destroy(true);
    }
    if (oldData.container && !oldData.container.destroyed) {
      if (this.image_container.children.includes(oldData.container)) {
        this.image_container.removeChild(oldData.container);
      }
      oldData.container.destroy({ children: true });
    }
    return newLayer;
  }
  async get_blobs(width, height) {
    const blobs = {
      background: await get_canvas_blob(
        this.app.renderer,
        this.background_layer,
        {
          width,
          height,
          x: 0,
          y: 0
        }
      ),
      layers: await Promise.all(
        this.layers.map(async (layer) => {
          const blob = await get_canvas_blob(
            this.app.renderer,
            layer.container,
            {
              width,
              height,
              x: 0,
              y: 0
            }
          );
          if (blob) {
            return blob;
          }
          return null;
        })
      ),
      composite: await get_canvas_blob(this.app.renderer, this.image_container)
    };
    return blobs;
  }
  reset_layers(width, height, persist = false) {
    const _layers_to_recreate = persist ? this.layers.map((layer) => [layer.name, layer.id]) : this.layer_options.layers.map((layer) => [layer, void 0]);
    this.layers.forEach((layer) => {
      this.delete_layer(layer.id);
    });
    for (const [layer_name, layer_id] of _layers_to_recreate) {
      this.create_layer({
        width,
        height,
        layer_name,
        user_created: this.layer_options.layers.find((l2) => l2 === layer_name) ? false : true,
        layer_id
      });
    }
    if (!persist) {
      this.active_layer = this.layers[0].container;
      this.active_layer_id = this.layers[0].id;
    } else {
      this.active_layer = this.layers.find((l2) => l2.id === this.active_layer_id)?.container || this.layers[0]?.container;
      if (!this.active_layer)
        return;
    }
    this.layer_store.update((state) => ({
      active_layer: this.active_layer_id || this.layers[0].id,
      layers: this.layers
    }));
  }
  init_layers(width, height) {
    for (const layer of this.layers) {
      this.delete_layer(layer.id);
    }
    for (const layer of this.layer_options.layers) {
      this.create_layer({
        width,
        height,
        layer_name: layer,
        user_created: false
      });
    }
    this.active_layer = this.layers[0].container;
    this.active_layer_id = this.layers[0].id;
    this.layer_store.update((_layers) => ({
      active_layer: this.layers[0].id,
      layers: this.layers
    }));
  }
}
class AddLayerCommand {
  constructor(context2, options) {
    this.context = context2;
    this.width = options.width;
    this.height = options.height;
    this.layer_name = options.layer_name || `Layer ${this.context.layer_manager.get_layers().length + 1}`;
    this.user_created = options.user_created;
    this.layer_id = options.layer_id || Math.random().toString(36).substring(2, 15);
    this.make_active = options.make_active || false;
    this.name = "AddLayer";
    const current_layers = this.context.layer_manager.get_layers();
    const current_active = current_layers.find(
      (l2) => l2.container === this.context.layer_manager.get_active_layer()
    );
    this.previous_active_layer = current_active?.id || null;
  }
  layer_id;
  layer_name;
  width;
  height;
  user_created;
  make_active;
  previous_active_layer = null;
  name;
  async execute() {
    this.context.layer_manager.create_layer({
      width: this.width,
      height: this.height,
      layer_name: this.layer_name,
      user_created: this.user_created,
      layer_id: this.layer_id,
      make_active: this.make_active
    });
  }
  async undo() {
    this.context.layer_manager.delete_layer(this.layer_id);
    if (this.previous_active_layer) {
      this.context.layer_manager.set_active_layer(this.previous_active_layer);
    }
  }
}
class RemoveLayerCommand {
  constructor(context2, layer_id) {
    this.context = context2;
    this.name = "RemoveLayer";
    const layers = this.context.layer_manager.get_layers();
    const layer_to_remove = layers.find((l2) => l2.id === layer_id);
    if (!layer_to_remove) {
      throw new Error(`Layer with ID ${layer_id} not found`);
    }
    const active_layer = this.context.layer_manager.get_active_layer();
    const was_active = layer_to_remove.container === active_layer;
    if (was_active) {
      const layer_index = layers.findIndex((l2) => l2.id === layer_id);
      const next_active = layers[Math.max(0, layer_index - 1)];
      this.previous_active_layer = next_active?.id || null;
    }
    this.layer_data = {
      id: layer_to_remove.id,
      name: layer_to_remove.name,
      user_created: layer_to_remove.user_created,
      visible: layer_to_remove.visible,
      was_active
    };
    this.captureTextureData(layer_id);
  }
  layer_data;
  previous_active_layer = null;
  texture_copy = null;
  name;
  /**
   * Create a direct copy of the layer's texture
   */
  captureTextureData(layer_id) {
    const layer_textures = this.context.layer_manager.get_layer_textures(layer_id);
    if (!layer_textures)
      return;
    try {
      const original_texture = layer_textures.draw;
      const texture_copy = RenderTexture.create({
        width: original_texture.width,
        height: original_texture.height,
        resolution: window.devicePixelRatio || 1
      });
      const sprite = new Sprite(original_texture);
      this.context.app.renderer.render(sprite, { renderTexture: texture_copy });
      this.texture_copy = texture_copy;
      sprite.destroy();
    } catch (e2) {
      console.error("Failed to copy layer texture:", e2);
      this.texture_copy = null;
    }
  }
  async execute() {
    this.context.layer_manager.delete_layer(this.layer_data.id);
  }
  async undo() {
    const dimensions = get(this.context.dimensions);
    this.context.layer_manager.create_layer({
      width: dimensions.width,
      height: dimensions.height,
      layer_name: this.layer_data.name,
      user_created: this.layer_data.user_created,
      layer_id: this.layer_data.id,
      make_active: this.layer_data.was_active
    });
    if (this.texture_copy) {
      try {
        const layer_textures = this.context.layer_manager.get_layer_textures(
          this.layer_data.id
        );
        if (layer_textures) {
          const sprite = new Sprite(this.texture_copy);
          this.context.app.renderer.render(sprite, {
            renderTexture: layer_textures.draw
          });
          sprite.destroy();
        }
      } catch (e2) {
        console.error("Failed to restore layer content:", e2);
      }
    }
    if (!this.layer_data.visible) {
      this.context.layer_manager.toggle_layer_visibility(this.layer_data.id);
    }
    if (!this.layer_data.was_active && this.previous_active_layer) {
      this.context.layer_manager.set_active_layer(this.previous_active_layer);
    }
  }
  /**
   * Clean up resources when the command is no longer needed
   * This would need to be called by a garbage collection mechanism
   */
  destroy() {
    if (this.texture_copy) {
      this.texture_copy.destroy();
      this.texture_copy = null;
    }
  }
}
class ReorderLayerCommand {
  constructor(context2, layer_id, direction) {
    this.context = context2;
    this.layer_id = layer_id;
    this.direction = direction;
    this.name = "ReorderLayer";
    const layers = this.context.layer_manager.get_layers();
    this.original_order = layers.map((l2) => l2.id);
    const index = layers.findIndex((l2) => l2.id === layer_id);
    if (index === -1) {
      throw new Error(`Layer with ID ${layer_id} not found`);
    }
    const new_index = direction === "up" ? index - 1 : index + 1;
    if (new_index < 0 || new_index >= layers.length) {
      this.new_order = [...this.original_order];
    } else {
      this.new_order = [...this.original_order];
      [this.new_order[index], this.new_order[new_index]] = [
        this.new_order[new_index],
        this.new_order[index]
      ];
    }
  }
  original_order;
  new_order;
  layer_id;
  direction;
  name;
  async execute() {
    this.context.layer_manager.move_layer(this.layer_id, this.direction);
  }
  async undo() {
    const current_layers = this.context.layer_manager.get_layers();
    if (this.original_order.join(",") === current_layers.map((l2) => l2.id).join(",")) {
      return;
    }
    const layer_index = current_layers.findIndex((l2) => l2.id === this.layer_id);
    if (layer_index === -1)
      return;
    const original_index = this.original_order.indexOf(this.layer_id);
    const move_direction = layer_index > original_index ? "up" : "down";
    this.context.layer_manager.move_layer(this.layer_id, move_direction);
  }
}
const core_tool_map = {
  image: () => new ImageTool(),
  zoom: () => new ZoomTool()
};
const spring_config = {
  stiffness: 0.45,
  damping: 0.8
};
class EditorState {
  state;
  scale;
  position;
  subscribers;
  constructor(editor) {
    if (!(editor instanceof ImageEditor)) {
      throw new Error("EditorState must be created by ImageEditor");
    }
    this.scale = 1;
    this.position = { x: 0, y: 0 };
    this.subscribers = /* @__PURE__ */ new Set();
    this.state = Object.freeze({
      get position() {
        return { ...this.position };
      },
      get scale() {
        return this.scale;
      },
      get current_tool() {
        return this.current_tool;
      },
      get current_subtool() {
        return this.current_subtool;
      },
      subscribe: this.subscribe.bind(this)
    });
  }
  _set_position(x2, y2) {
    const oldPosition = { ...this.position };
    this.position = { x: x2, y: y2 };
    this._notify_subscribers("position", oldPosition, this.position);
  }
  _set_scale(scale) {
    const oldScale = this.scale;
    this.scale = scale;
    this._notify_subscribers("scale", oldScale, scale);
  }
  _notify_subscribers(property, oldValue, newValue) {
    this.subscribers.forEach((callback) => {
      callback({
        property,
        oldValue,
        newValue,
        timestamp: Date.now()
      });
    });
  }
  subscribe(callback) {
    this.subscribers.add(callback);
    return () => this.subscribers.delete(callback);
  }
}
class ImageEditor {
  ready;
  background_image_present = writable(false);
  min_zoom = writable(true);
  app;
  ui_container;
  image_container;
  command_manager;
  layer_manager;
  tools = /* @__PURE__ */ new Map();
  current_tool;
  current_subtool;
  target_element;
  width;
  height;
  dimensions;
  scale;
  position;
  state;
  scale_value = 1;
  position_value = { x: 0, y: 0 };
  dimensions_value = {
    width: 0,
    height: 0
  };
  layers = writable({
    active_layer: "",
    layers: []
  });
  outline_container;
  outline_graphics;
  background_image;
  ready_resolve;
  event_callbacks = /* @__PURE__ */ new Map();
  fixed_canvas;
  dark;
  border_region;
  layer_options;
  overlay_container;
  overlay_graphics;
  pad_bottom;
  theme_mode;
  constructor(options) {
    this.pad_bottom = options.pad_bottom || 0;
    this.dark = options.dark || false;
    this.theme_mode = options.theme_mode || "dark";
    this.target_element = options.target_element;
    this.width = options.width;
    this.height = options.height;
    this.command_manager = new CommandManager();
    this.ready = new Promise((resolve) => {
      this.ready_resolve = resolve;
    });
    this.fixed_canvas = options.fixed_canvas || false;
    this.tools = new Map(
      options.tools.map((tool) => {
        if (typeof tool === "string") {
          return [tool, core_tool_map[tool]()];
        }
        return [tool.name, tool];
      })
    );
    for (const tool of this.tools.values()) {
      if (tool?.on) {
        tool.on("change", () => {
          this.notify("change");
        });
      }
    }
    this.dimensions = spring(
      { width: this.width, height: this.height },
      spring_config
    );
    this.scale = spring(1, spring_config);
    this.position = spring({ x: 0, y: 0 }, spring_config);
    this.state = new EditorState(this);
    this.border_region = options.border_region || 0;
    this.layer_options = options.layer_options || {
      allow_additional_layers: true,
      layers: ["Layer 1"],
      disabled: false
    };
    this.scale.subscribe((scale) => {
      this.state._set_scale(scale);
    });
    this.position.subscribe((position) => {
      this.state._set_position(position.x, position.y);
    });
    this.init();
  }
  get context() {
    const editor = this;
    return {
      app: this.app,
      ui_container: this.ui_container,
      image_container: this.image_container,
      get background_image() {
        return editor.background_image;
      },
      pad_bottom: this.pad_bottom,
      command_manager: this.command_manager,
      layer_manager: this.layer_manager,
      dimensions: { subscribe: this.dimensions.subscribe },
      scale: { subscribe: this.scale.subscribe },
      position: { subscribe: this.position.subscribe },
      set_image_properties: this.set_image_properties.bind(this),
      execute_command: this.execute_command.bind(this),
      resize_canvas: this.resize_canvas.bind(this),
      reset: this.reset.bind(this),
      set_background_image: this.set_background_image.bind(this)
    };
  }
  async init() {
    const container_box = this.target_element.getBoundingClientRect();
    new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        this.resize_canvas(
          entry.contentBoxSize[0].inlineSize,
          entry.contentBoxSize[0].blockSize
        );
      });
    }).observe(this.target_element);
    this.app = new Application();
    await this.app.init({
      width: container_box.width,
      height: container_box.height,
      backgroundAlpha: this.dark ? 0 : 1,
      backgroundColor: this.theme_mode === "dark" ? "#27272a" : "#ffffff",
      resolution: window.devicePixelRatio,
      autoDensity: true,
      antialias: true,
      powerPreference: "high-performance"
    });
    const canvas = this.app.canvas;
    canvas.style.background = "transparent";
    await this.setup_containers();
    this.layer_manager.create_background_layer(this.width, this.height);
    this.layer_manager.init_layers(this.width, this.height);
    for (const tool of this.tools.values()) {
      await tool.setup(this.context, this.current_tool, this.current_subtool);
    }
    const zoom = this.tools.get("zoom");
    if (zoom) {
      zoom.min_zoom.subscribe((is_min_zoom) => {
        this.min_zoom.set(is_min_zoom);
      });
    }
    this.target_element.appendChild(canvas);
    this.target_element.style.background = "transparent";
    this.dimensions.subscribe((dimensions) => {
      this.dimensions_value = dimensions;
      this.image_container.width = dimensions.width;
      this.image_container.height = dimensions.height;
    });
    this.scale.subscribe((scale) => {
      this.scale_value = scale;
    });
    this.position.subscribe((position) => {
      this.position_value = position;
    });
    this.app.ticker.add(() => {
      this.image_container.scale.set(this.scale_value);
      this.image_container.position.set(
        this.position_value.x,
        this.position_value.y
      );
      const effective_width = this.dimensions_value.width * this.scale_value;
      const effective_height = this.dimensions_value.height * this.scale_value;
      const local_x = Math.round(
        this.image_container.position.x - this.outline_container.position.x
      );
      const local_y = Math.round(
        this.image_container.position.y - this.outline_container.position.y
      );
      this.overlay_container.position.set(
        this.outline_container.position.x,
        this.outline_container.position.y
      );
      this.outline_graphics.clear();
      this.outline_graphics.rect(local_x, local_y, effective_width, effective_height).fill({
        color: this.dark ? 3355443 : 16777215,
        alpha: 1
      });
      if (this.border_region > 0) {
        const scaled_border = this.border_region * this.scale_value;
        const border_x = local_x + scaled_border - 1;
        const border_y = local_y + scaled_border - 1;
        const border_width = effective_width - scaled_border * 2 + 1;
        const border_height = effective_height - scaled_border * 2 + 1;
        this.overlay_graphics.clear();
        this.overlay_graphics.rect(border_x, border_y, border_width, border_height).stroke({
          color: 10066329,
          width: 1,
          alpha: 0,
          pixelLine: true
        });
        const dashLength = 5;
        const gapLength = 5;
        const totalLength = dashLength + gapLength;
        const lineColor = 10066329;
        for (let x2 = border_x; x2 < border_x + border_width; x2 += totalLength) {
          this.overlay_graphics.rect(
            x2,
            border_y,
            Math.min(dashLength, border_x + border_width - x2),
            1
          ).fill({ color: lineColor, alpha: 0.7 });
          this.overlay_graphics.rect(
            x2,
            border_y + border_height,
            Math.min(dashLength, border_x + border_width - x2),
            1
          ).fill({ color: lineColor, alpha: 0.7 });
        }
        for (let y2 = border_y; y2 < border_y + border_height; y2 += totalLength) {
          this.overlay_graphics.rect(
            border_x,
            y2,
            1,
            Math.min(dashLength, border_y + border_height - y2)
          ).fill({ color: lineColor, alpha: 0.7 });
          this.overlay_graphics.rect(
            border_x + border_width,
            y2,
            1,
            Math.min(dashLength, border_y + border_height - y2)
          ).fill({ color: lineColor, alpha: 0.7 });
        }
      } else {
        this.overlay_graphics.clear();
      }
    });
    this.ready_resolve();
  }
  async setup_containers() {
    this.image_container = new Container({
      eventMode: "static",
      sortableChildren: true
    });
    this.image_container.width = this.width;
    this.image_container.height = this.height;
    this.app.stage.sortableChildren = true;
    this.app.stage.alpha = 1;
    this.app.stage.addChild(this.image_container);
    this.image_container.scale.set(1);
    this.ui_container = new Container({
      eventMode: "static"
    });
    this.app.stage.addChild(this.ui_container);
    this.ui_container.width = this.width;
    this.ui_container.height = this.height;
    this.outline_container = new Container();
    this.outline_container.zIndex = -10;
    this.outline_graphics = new Graphics();
    this.outline_graphics.rect(0, 0, this.width, this.height).fill({
      color: this.dark ? 3355443 : 16777215,
      alpha: 0
    });
    if (!this.dark) {
      const blurFilter = new DropShadowFilter({
        alpha: 0.1,
        blur: 2,
        color: 0,
        offset: { x: 0, y: 0 },
        quality: 4,
        shadowOnly: false
      });
      this.outline_graphics.filters = [blurFilter];
    }
    this.outline_container.addChild(this.outline_graphics);
    this.app.stage.addChild(this.outline_container);
    this.overlay_container = new Container();
    this.app.stage.addChild(this.overlay_container);
    this.overlay_container.width = this.width;
    this.overlay_container.height = this.height;
    this.overlay_container.zIndex = 999;
    this.overlay_container.eventMode = "static";
    this.overlay_container.interactiveChildren = true;
    this.overlay_graphics = new Graphics();
    this.overlay_container.addChild(this.overlay_graphics);
    this.overlay_graphics.rect(0, 0, this.width, this.height).fill({
      color: 0,
      alpha: 0
    });
    const app_center_x = this.app.screen.width / 2;
    const app_center_y = this.app.screen.height / 2;
    this.image_container.position.set(app_center_x, app_center_y);
    this.outline_container.position.set(app_center_x, app_center_y);
    this.layer_manager = new LayerManager(
      this.image_container,
      this.app,
      this.fixed_canvas,
      this.dark,
      this.border_region,
      this.layer_options
    );
    this.layers = this.layer_manager.layer_store;
  }
  resize_canvas(width, height) {
    if (this.app.renderer) {
      this.app.renderer.resize(width, height);
    }
    const app_center_x = width / 2;
    const app_center_y = height / 2;
    if (this.image_container) {
      this.image_container.position.set(app_center_x, app_center_y);
    }
    if (this.outline_container) {
      this.outline_container.position.set(app_center_x, app_center_y);
    }
  }
  reset() {
    const zoom = this.tools.get("zoom");
    if (zoom) {
      zoom.cleanup();
      zoom.setup(this.context, this.current_tool, this.current_subtool);
    }
    const brush = this.tools.get("brush");
    if (brush) {
      this.set_tool("draw");
    }
  }
  async set_image_properties(properties) {
    let hard = typeof properties.animate !== "undefined" ? !properties.animate : true;
    if (properties.position) {
      const pos = this.position.set(properties.position, { hard });
      if (hard) {
        await pos;
      }
    }
    if (properties.scale) {
      const scale = this.scale.set(properties.scale, { hard });
      if (hard) {
        await scale;
      }
    }
    if (properties.width && properties.height) {
      this.width = properties.width;
      this.height = properties.height;
      const dimensions = this.dimensions.set(
        { width: properties.width, height: properties.height },
        { hard }
      );
      if (hard) {
        await dimensions;
      }
    }
  }
  async execute_command(command) {
    await this.command_manager.execute(command);
  }
  undo() {
    this.command_manager.undo();
    this.notify("change");
  }
  redo() {
    this.command_manager.redo();
    this.notify("change");
  }
  async add_image({
    image,
    resize = true
  }) {
    const image_tool = this.tools.get("image");
    await image_tool.add_image({
      image,
      fixed_canvas: this.fixed_canvas,
      border_region: this.border_region
    });
  }
  /**
   * Adds an image from a URL as the background layer
   * @param url The URL of the image to add
   */
  async add_image_from_url(url) {
    this.command_manager.reset();
    const image_tool = this.tools.get("image");
    const texture = await Assets.load(url);
    await image_tool.add_image({
      image: texture,
      fixed_canvas: this.fixed_canvas,
      border_region: this.border_region
    });
    const resize_tool = this.tools.get("resize");
    if (resize_tool && typeof resize_tool.set_border_region === "function") {
      resize_tool.set_border_region(this.border_region);
    }
  }
  set_tool(tool) {
    this.current_tool = tool;
    for (const tool2 of this.tools.values()) {
      tool2.set_tool(this.current_tool, this.current_subtool);
    }
  }
  set_subtool(subtool) {
    this.current_subtool = subtool;
    for (const tool of this.tools.values()) {
      tool.set_tool(this.current_tool, this.current_subtool);
    }
  }
  set_background_image(image) {
    this.background_image = image;
  }
  async reset_canvas() {
    this.layer_manager.reset_layers(this.width, this.height);
    this.background_image = void 0;
    this.background_image_present.set(false);
    await this.set_image_properties({
      width: this.width,
      height: this.height,
      scale: 1,
      position: { x: 0, y: 0 },
      animate: false
    });
    this.command_manager = new CommandManager();
    this.layer_manager.create_background_layer(this.width, this.height);
    for (const tool of this.tools.values()) {
      tool.cleanup();
      tool.setup(this.context, this.current_tool, this.current_subtool);
    }
    const zoom_tool = this.tools.get("zoom");
    if (zoom_tool) {
      zoom_tool.min_zoom.subscribe((is_min_zoom) => {
        this.min_zoom.set(is_min_zoom);
      });
    }
    this.notify("change");
  }
  add_layer() {
    const add_layer_command = new AddLayerCommand(this.context, {
      width: this.width,
      height: this.height,
      user_created: true,
      make_active: true
    });
    this.command_manager.execute(add_layer_command);
    this.notify("change");
  }
  /**
   * Adds a new layer with an image loaded from a URL
   * @param layer_urls The URLs of the images to load
   * @returns A Promise that resolves when all layers are added
   */
  async add_layers_from_url(layer_urls) {
    this.command_manager.reset();
    const _layers = this.layer_manager.get_layers();
    _layers.forEach((l2) => this.layer_manager.delete_layer(l2.id));
    if (layer_urls === void 0 || layer_urls.length === 0) {
      this.layer_manager.create_layer({
        width: this.width,
        height: this.height,
        layer_name: void 0,
        user_created: false
      });
      return;
    }
    for await (const url of layer_urls) {
      await this.layer_manager.add_layer_from_url(url);
    }
    this.layer_manager.set_active_layer(_layers[0].id);
    const resize_tool = this.tools.get("resize");
    if (resize_tool && typeof resize_tool.set_border_region === "function") {
      resize_tool.set_border_region(this.border_region);
    }
    this.notify("change");
    this.notify("input");
  }
  set_layer(id) {
    this.layer_manager.set_active_layer(id);
    this.notify("change");
  }
  move_layer(id, direction) {
    const reorder_layer_command = new ReorderLayerCommand(
      this.context,
      id,
      direction
    );
    this.command_manager.execute(reorder_layer_command);
    this.notify("change");
  }
  delete_layer(id) {
    const remove_layer_command = new RemoveLayerCommand(this.context, id);
    this.command_manager.execute(remove_layer_command);
    this.notify("change");
  }
  modify_canvas_size(width, height, anchor, scale) {
    const oldWidth = this.width;
    const oldHeight = this.height;
    this.layer_manager.resize_all_layers(
      width,
      height,
      scale,
      anchor,
      oldWidth,
      oldHeight
    );
    this.width = width;
    this.height = height;
    this.set_image_properties({
      width,
      height,
      scale: 1,
      position: { x: 0, y: 0 },
      animate: false
    });
    this.notify("change");
  }
  async get_blobs() {
    const blobs = await this.layer_manager.get_blobs(this.width, this.height);
    return blobs;
  }
  on(event, callback) {
    this.event_callbacks.set(event, [
      ...this.event_callbacks.get(event) || [],
      callback
    ]);
  }
  off(event, callback) {
    this.event_callbacks.set(
      event,
      this.event_callbacks.get(event)?.filter((cb) => cb !== callback) || []
    );
  }
  notify(event) {
    for (const callback of this.event_callbacks.get(event) || []) {
      callback();
    }
  }
  destroy() {
    if (!this.app)
      return;
    this.app?.destroy();
  }
  resize(width, height) {
    this.set_image_properties({
      width,
      height
    });
    this.reset();
  }
  async get_crop_bounds() {
    const crop_tool = this.tools.get("crop");
    const crop_bounds = crop_tool.get_crop_bounds();
    const image = await crop_tool.get_image();
    return {
      image,
      ...crop_bounds
    };
  }
  get background_image_sprite() {
    return this.background_image;
  }
  set_layer_options(layer_options) {
    this.layer_options = layer_options;
    this.layer_manager.set_layer_options(
      layer_options,
      this.width,
      this.height
    );
  }
  toggle_layer_visibility(id) {
    this.layer_manager.toggle_layer_visibility(id);
  }
}
class CropTool {
  name = "crop";
  image_editor_context;
  current_tool = "image";
  current_subtool = "crop";
  // Constants
  CORNER_SIZE = 25;
  LINE_THICKNESS = 5;
  HANDLE_COLOR = 0;
  HIT_AREA_SIZE = 40;
  // State
  is_dragging = false;
  selected_handle = null;
  active_corner_index = -1;
  active_edge_index = -1;
  last_pointer_position = null;
  crop_bounds = { x: 0, y: 0, width: 0, height: 0 };
  crop_ui_container = null;
  crop_mask = null;
  dimensions = {
    width: 0,
    height: 0
  };
  position = { x: 0, y: 0 };
  scale = 1;
  is_dragging_window = false;
  drag_start_position = null;
  drag_start_bounds = null;
  background_image_watcher = null;
  has_been_manually_changed = false;
  event_callbacks = /* @__PURE__ */ new Map();
  /**
   * @method setup
   * @async
   * @description Sets up the crop tool with the given context and state
   * @param {ImageEditorContext} context - The image editor context
   * @param {ToolbarTool} tool - The current tool
   * @param {Subtool} subtool - The current subtool
   * @returns {Promise<void>}
   */
  async setup(context2, tool, subtool) {
    this.image_editor_context = context2;
    this.current_tool = tool;
    this.current_subtool = subtool;
    context2.dimensions.subscribe((dimensions) => {
      this.dimensions = dimensions;
      this.crop_bounds = {
        x: 0,
        y: 0,
        width: dimensions.width,
        height: dimensions.height
      };
      if (this.crop_ui_container) {
        this.update_crop_ui();
      }
      this.set_crop_mask();
      this.update_crop_mask();
    });
    context2.position.subscribe((position) => {
      this.position = position;
    });
    context2.scale.subscribe((scale) => {
      this.scale = scale;
    });
    this.background_image_watcher = () => {
      if (this.crop_mask && this.current_tool === "image" && this.current_subtool === "crop") {
        if (this.image_editor_context.background_image) {
          this.image_editor_context.background_image.setMask(this.crop_mask);
        }
      }
    };
    this.image_editor_context.app.ticker.add(this.background_image_watcher);
    await this.init_crop_ui();
    this.setup_event_listeners();
    const isCropActive = tool === "image" && subtool === "crop";
    if (this.crop_ui_container) {
      this.crop_ui_container.visible = isCropActive;
    }
  }
  /**
   * @method cleanup
   * @description Cleans up the crop tool resources and removes event listeners
   * @returns {void}
   */
  cleanup() {
    if (this.crop_ui_container) {
      this.image_editor_context.app.stage.removeChild(this.crop_ui_container);
    }
    if (this.crop_mask) {
      if (this.crop_mask.parent) {
        this.crop_mask.parent.removeChild(this.crop_mask);
      }
      if (this.image_editor_context.background_image && this.image_editor_context.background_image.mask === this.crop_mask) {
        this.image_editor_context.background_image.mask = null;
      }
      if (this.image_editor_context.image_container.mask === this.crop_mask) {
        this.image_editor_context.image_container.mask = null;
      }
    }
    this.crop_mask = null;
    this.crop_ui_container = null;
    if (this.background_image_watcher) {
      this.image_editor_context.app.ticker.remove(
        this.background_image_watcher
      );
      this.background_image_watcher = null;
    }
    this.cleanup_event_listeners();
  }
  /**
   * @method set_tool
   * @description Sets the current tool and subtool, updating UI visibility
   * @param {ToolbarTool} tool - The tool to set
   * @param {Subtool} subtool - The subtool to set
   * @returns {void}
   */
  set_tool(tool, subtool) {
    this.current_tool = tool;
    this.current_subtool = subtool;
    const isCropActive = tool === "image" && subtool === "crop";
    if (this.crop_ui_container) {
      this.crop_ui_container.visible = isCropActive;
    }
    if (isCropActive && this.crop_mask) {
      this.update_crop_mask();
    }
  }
  /**
   * @method set_crop_mask
   * @private
   * @description Sets up the crop mask for the image
   * @returns {void}
   */
  set_crop_mask() {
    if (this.crop_mask) {
      if (this.crop_mask.parent) {
        this.crop_mask.parent.removeChild(this.crop_mask);
      }
      if (this.image_editor_context.image_container.mask === this.crop_mask) {
        this.image_editor_context.image_container.mask = null;
      }
      if (this.image_editor_context.background_image && this.image_editor_context.background_image.mask === this.crop_mask) {
        this.image_editor_context.background_image.mask = null;
      }
    }
    this.crop_mask = new Graphics();
    this.image_editor_context.image_container.addChild(this.crop_mask);
  }
  /**
   * @method init_crop_ui
   * @private
   * @async
   * @description Initializes the crop UI elements and sets up the update loop
   * @returns {Promise<void>}
   */
  async init_crop_ui() {
    this.image_editor_context.background_image?.getLocalBounds() || {
      width: false,
      height: false
    };
    this.crop_ui_container = this.make_crop_ui(
      this.dimensions.width * this.scale,
      this.dimensions.height * this.scale
    );
    this.crop_ui_container.position.set(this.position.x, this.position.y);
    this.crop_ui_container.visible = false;
    this.image_editor_context.app.stage.addChild(this.crop_ui_container);
    this.set_crop_mask();
    this.image_editor_context.app.ticker.add(this.update_crop_ui.bind(this));
    this.update_crop_mask();
  }
  /**
   * @method make_crop_ui
   * @private
   * @description Creates the crop UI with the specified dimensions
   * @param {number} width - Width of the crop area
   * @param {number} height - Height of the crop area
   * @returns {Container} The created crop UI container
   */
  make_crop_ui(width, height) {
    const crop_container = new Container();
    crop_container.eventMode = "static";
    crop_container.interactiveChildren = true;
    const crop_outline = new Graphics().rect(0, 0, width, height).stroke({ width: 1, color: 0, alignment: 0, alpha: 0.5 });
    crop_outline.eventMode = "static";
    crop_outline.cursor = "move";
    crop_outline.hitArea = new Rectangle(0, 0, width, height);
    crop_outline.on("pointerdown", this.handle_window_drag_start.bind(this));
    crop_container.addChild(crop_outline);
    this.create_corner_handles(crop_container, width, height);
    this.create_edge_handles(crop_container, width, height);
    return crop_container;
  }
  /**
   * @method create_handle
   * @private
   * @description Creates a handle for the crop UI
   * @param {boolean} [is_edge=false] - Whether the handle is an edge handle
   * @returns {Container} The created handle container
   */
  create_handle(is_edge = false) {
    const handle = new Container();
    handle.eventMode = "static";
    const handle_graphics = new Graphics();
    if (is_edge) {
      handle_graphics.rect(0, 0, this.CORNER_SIZE * 1.5, this.LINE_THICKNESS).fill(this.HANDLE_COLOR);
    } else {
      handle_graphics.rect(0, 0, this.CORNER_SIZE, this.LINE_THICKNESS).rect(0, 0, this.LINE_THICKNESS, this.CORNER_SIZE).fill(this.HANDLE_COLOR);
    }
    handle.addChild(handle_graphics);
    const hit_size = is_edge ? this.HIT_AREA_SIZE * 1.5 : this.HIT_AREA_SIZE;
    handle.hitArea = new Rectangle(
      -hit_size / 2 + this.LINE_THICKNESS,
      -hit_size / 2 + this.LINE_THICKNESS,
      hit_size,
      hit_size
    );
    return handle;
  }
  /**
   * @method create_edge_handles
   * @private
   * @description Creates edge handles for the crop UI
   * @param {Container} container - The container to add handles to
   * @param {number} width - Width of the crop area
   * @param {number} height - Height of the crop area
   * @returns {void}
   */
  create_edge_handles(container, width, height) {
    [-1, 1].forEach((i2, index) => {
      const handle = this.create_handle(true);
      handle.rotation = 0;
      handle.on("pointerdown", (event) => {
        this.handle_pointer_down(event, handle, -1, index);
      });
      handle.x = width / 2 - this.CORNER_SIZE * 3 / 2;
      handle.y = i2 < 0 ? -this.LINE_THICKNESS : height;
      handle.cursor = "ns-resize";
      container.addChild(handle);
    });
    [-1, 1].forEach((i2, index) => {
      const handle = this.create_handle(true);
      handle.rotation = Math.PI / 2;
      handle.on("pointerdown", (event) => {
        this.handle_pointer_down(event, handle, -1, index + 2);
      });
      handle.x = i2 < 0 ? -this.LINE_THICKNESS : width;
      handle.y = height / 2 - this.CORNER_SIZE * 3 / 2;
      handle.cursor = "ew-resize";
      container.addChild(handle);
    });
  }
  /**
   * @method create_corner_handles
   * @private
   * @description Creates corner handles for the crop UI
   * @param {Container} container - The container to add handles to
   * @param {number} width - Width of the crop area
   * @param {number} height - Height of the crop area
   * @returns {void}
   */
  create_corner_handles(container, width, height) {
    const corners = [
      { x: 0, y: 0, xScale: 1, yScale: 1, cursor: "nwse-resize" },
      // Top-left
      { x: width, y: 0, xScale: -1, yScale: 1, cursor: "nesw-resize" },
      // Top-right
      { x: 0, y: height, xScale: 1, yScale: -1, cursor: "nesw-resize" },
      // Bottom-left
      { x: width, y: height, xScale: -1, yScale: -1, cursor: "nwse-resize" }
      // Bottom-right
    ];
    corners.forEach(({ x: x2, y: y2, xScale, yScale, cursor }, i2) => {
      const corner = this.create_handle(false);
      corner.x = x2 - (xScale < 0 ? -this.LINE_THICKNESS : this.LINE_THICKNESS);
      corner.y = y2 - (yScale < 0 ? -this.LINE_THICKNESS : this.LINE_THICKNESS);
      corner.scale.set(xScale, yScale);
      corner.on("pointerdown", (event) => {
        this.handle_pointer_down(event, corner, i2, -1);
      });
      corner.cursor = cursor;
      container.addChild(corner);
    });
  }
  /**
   * @method handle_pointer_down
   * @private
   * @description Handles pointer down events on handles
   * @param {FederatedPointerEvent} event - The pointer event
   * @param {Container} handle - The handle that was clicked
   * @param {number} corner_index - Index of the corner (-1 if not a corner)
   * @param {number} edge_index - Index of the edge (-1 if not an edge)
   * @returns {void}
   */
  handle_pointer_down(event, handle, corner_index, edge_index) {
    if (this.current_subtool !== "crop")
      return;
    event.stopPropagation();
    this.is_dragging = true;
    this.selected_handle = handle;
    this.active_corner_index = corner_index;
    this.active_edge_index = edge_index;
    const local_pos = this.image_editor_context.image_container.toLocal(
      event.global
    );
    this.last_pointer_position = new Point(local_pos.x, local_pos.y);
  }
  /**
   * updates the crop bounds based on pointer movement
   * @param delta - the change in position
   */
  update_crop_bounds(delta) {
    this.has_been_manually_changed = true;
    const scaled_delta = new Point(delta.x, delta.y);
    const original = {
      x: this.crop_bounds.x,
      y: this.crop_bounds.y,
      width: this.crop_bounds.width,
      height: this.crop_bounds.height
    };
    if (this.active_corner_index !== -1) {
      switch (this.active_corner_index) {
        case 0:
          const newWidth0 = Math.max(20, original.width - scaled_delta.x);
          const widthDiff0 = original.width - newWidth0;
          this.crop_bounds.width = newWidth0;
          this.crop_bounds.x = original.x + widthDiff0;
          const newHeight0 = Math.max(20, original.height - scaled_delta.y);
          const heightDiff0 = original.height - newHeight0;
          this.crop_bounds.height = newHeight0;
          this.crop_bounds.y = original.y + heightDiff0;
          break;
        case 1:
          this.crop_bounds.width = Math.max(
            20,
            original.width + scaled_delta.x
          );
          const newHeight1 = Math.max(20, original.height - scaled_delta.y);
          const heightDiff1 = original.height - newHeight1;
          this.crop_bounds.height = newHeight1;
          this.crop_bounds.y = original.y + heightDiff1;
          break;
        case 2:
          const newWidth2 = Math.max(20, original.width - scaled_delta.x);
          const widthDiff2 = original.width - newWidth2;
          this.crop_bounds.width = newWidth2;
          this.crop_bounds.x = original.x + widthDiff2;
          this.crop_bounds.height = Math.max(
            20,
            original.height + scaled_delta.y
          );
          break;
        case 3:
          this.crop_bounds.width = Math.max(
            20,
            original.width + scaled_delta.x
          );
          this.crop_bounds.height = Math.max(
            20,
            original.height + scaled_delta.y
          );
          break;
      }
    } else if (this.active_edge_index !== -1) {
      switch (this.active_edge_index) {
        case 0:
          const newHeight = Math.max(20, original.height - scaled_delta.y);
          const heightDiff = original.height - newHeight;
          this.crop_bounds.height = newHeight;
          this.crop_bounds.y = original.y + heightDiff;
          break;
        case 1:
          this.crop_bounds.height = Math.max(
            20,
            original.height + scaled_delta.y
          );
          break;
        case 2:
          const newWidth = Math.max(20, original.width - scaled_delta.x);
          const widthDiff = original.width - newWidth;
          this.crop_bounds.width = newWidth;
          this.crop_bounds.x = original.x + widthDiff;
          break;
        case 3:
          this.crop_bounds.width = Math.max(
            20,
            original.width + scaled_delta.x
          );
          break;
      }
    }
    this.constrain_crop_bounds();
    this.update_crop_ui();
    this.update_crop_mask();
    if (this.crop_mask && this.image_editor_context.background_image) {
      this.image_editor_context.background_image.setMask(this.crop_mask);
    }
  }
  /**
   * constrains the crop bounds to the image dimensions
   */
  constrain_crop_bounds() {
    ({
      x: this.crop_bounds.x,
      y: this.crop_bounds.y,
      width: this.crop_bounds.width,
      height: this.crop_bounds.height
    });
    this.crop_bounds.width = Math.max(
      20,
      Math.min(this.crop_bounds.width, this.dimensions.width)
    );
    this.crop_bounds.height = Math.max(
      20,
      Math.min(this.crop_bounds.height, this.dimensions.height)
    );
    const oldX = this.crop_bounds.x;
    this.crop_bounds.x = Math.max(
      0,
      Math.min(
        this.crop_bounds.x,
        this.dimensions.width - this.crop_bounds.width
      )
    );
    if (this.crop_bounds.x !== oldX && this.active_corner_index === 0 || this.active_edge_index === 2) {
      const xDiff = this.crop_bounds.x - oldX;
      this.crop_bounds.width -= xDiff;
    }
    const oldY = this.crop_bounds.y;
    this.crop_bounds.y = Math.max(
      0,
      Math.min(
        this.crop_bounds.y,
        this.dimensions.height - this.crop_bounds.height
      )
    );
    if (this.crop_bounds.y !== oldY && (this.active_corner_index === 0 || this.active_corner_index === 1 || this.active_edge_index === 0)) {
      const yDiff = this.crop_bounds.y - oldY;
      this.crop_bounds.height -= yDiff;
    }
    this.crop_bounds.width = Math.max(
      20,
      Math.min(
        this.crop_bounds.width,
        this.dimensions.width - this.crop_bounds.x
      )
    );
    this.crop_bounds.height = Math.max(
      20,
      Math.min(
        this.crop_bounds.height,
        this.dimensions.height - this.crop_bounds.y
      )
    );
  }
  /**
   * updates the crop mask graphics
   */
  update_crop_mask() {
    if (!this.crop_mask)
      return;
    this.crop_mask.clear();
    const { width, height } = this.image_editor_context.background_image?.getLocalBounds() ?? {
      width: 0,
      height: 0
    };
    this.crop_mask.rect(0, 0, width, height).fill({ color: 0, alpha: 0.4 }).rect(
      this.crop_bounds.x,
      this.crop_bounds.y,
      this.crop_bounds.width,
      this.crop_bounds.height
    ).cut();
    if (this.image_editor_context.background_image) {
      this.image_editor_context.background_image.mask = null;
    }
    if (this.image_editor_context.image_container.mask === this.crop_mask) {
      this.image_editor_context.image_container.mask = null;
    }
  }
  /**
   * updates the crop ui position and dimensions
   */
  update_crop_ui() {
    if (!this.crop_mask || !this.crop_ui_container)
      return;
    this.crop_ui_container.position.set(
      this.position.x + this.crop_bounds.x * this.scale,
      this.position.y + this.crop_bounds.y * this.scale
    );
    const scaled_width = this.crop_bounds.width * this.scale;
    const scaled_height = this.crop_bounds.height * this.scale;
    const outline = this.crop_ui_container.getChildAt(0);
    outline.clear().rect(0, 0, scaled_width, scaled_height).stroke({ width: 1, color: 0, alignment: 0, alpha: 0.5 });
    outline.hitArea = new Rectangle(0, 0, scaled_width, scaled_height);
    this.update_handle_positions(scaled_width, scaled_height);
  }
  /**
   * updates the positions of all handles
   * @param width - width of the crop area
   * @param height - height of the crop area
   */
  update_handle_positions(width, height) {
    if (!this.crop_ui_container)
      return;
    const handles = this.crop_ui_container.children.slice(1);
    const corners = handles.slice(0, 4);
    const cornerPositions = [
      { x: 0, y: 0 },
      // Top-left
      { x: width, y: 0 },
      // Top-right
      { x: 0, y: height },
      // Bottom-left
      { x: width, y: height }
      // Bottom-right
    ];
    corners.forEach((handle, i2) => {
      const xScale = i2 % 2 === 0 ? 1 : -1;
      const yScale = i2 < 2 ? 1 : -1;
      handle.position.set(
        cornerPositions[i2].x - (xScale < 0 ? -this.LINE_THICKNESS : this.LINE_THICKNESS),
        cornerPositions[i2].y - (yScale < 0 ? -this.LINE_THICKNESS : this.LINE_THICKNESS)
      );
    });
    const edges = handles.slice(4);
    edges.forEach((handle, i2) => {
      if (i2 < 2) {
        handle.position.set(
          width / 2 - this.CORNER_SIZE * 1.5 / 2,
          // Changed from 3 to 2
          i2 === 0 ? -this.LINE_THICKNESS : height
        );
      } else {
        handle.position.set(
          i2 === 2 ? 0 : width + this.LINE_THICKNESS,
          height / 2 - this.CORNER_SIZE * 1.5 / 2
          // Changed from 3 to 2
        );
      }
    });
  }
  /**
   * sets up event listeners for the crop tool
   */
  setup_event_listeners() {
    const stage = this.image_editor_context.app.stage;
    stage.eventMode = "static";
    stage.on("pointermove", this.handle_pointer_move.bind(this));
    stage.on("pointerup", this.handle_pointer_up.bind(this));
    stage.on("pointerupoutside", this.handle_pointer_up.bind(this));
  }
  /**
   * removes event listeners for the crop tool
   */
  cleanup_event_listeners() {
    const stage = this.image_editor_context.app.stage;
    stage.off("pointermove", this.handle_pointer_move.bind(this));
    stage.off("pointerup", this.handle_pointer_up.bind(this));
    stage.off("pointerupoutside", this.handle_pointer_up.bind(this));
  }
  /**
   * handles pointer move events
   * @param event - the pointer event
   */
  handle_pointer_move(event) {
    if (this.current_subtool !== "crop")
      return;
    if (this.is_dragging_window && this.drag_start_position && this.drag_start_bounds) {
      const local_pos = this.image_editor_context.image_container.toLocal(
        event.global
      );
      const delta = new Point(
        local_pos.x - this.drag_start_position.x,
        local_pos.y - this.drag_start_position.y
      );
      this.crop_bounds = {
        x: this.drag_start_bounds.x + delta.x,
        y: this.drag_start_bounds.y + delta.y,
        width: this.drag_start_bounds.width,
        height: this.drag_start_bounds.height
      };
      this.constrain_crop_bounds();
      this.update_crop_mask();
      if (this.crop_mask && this.image_editor_context.background_image) {
        this.image_editor_context.background_image.setMask(this.crop_mask);
      }
      return;
    }
    if (this.is_dragging && this.selected_handle && this.last_pointer_position) {
      const local_pos = this.image_editor_context.image_container.toLocal(
        event.global
      );
      const current_position = new Point(local_pos.x, local_pos.y);
      const delta = new Point(
        current_position.x - this.last_pointer_position.x,
        current_position.y - this.last_pointer_position.y
      );
      this.update_crop_bounds(delta);
      this.last_pointer_position = current_position;
      this.update_crop_mask();
    }
  }
  /**
   * handles pointer up events
   */
  handle_pointer_up() {
    if (this.current_subtool !== "crop")
      return;
    this.is_dragging = false;
    this.is_dragging_window = false;
    this.selected_handle = null;
    this.last_pointer_position = null;
    this.drag_start_position = null;
    this.drag_start_bounds = null;
    this.active_corner_index = -1;
    this.active_edge_index = -1;
    this.notify("change");
  }
  /**
   * handles the start of window dragging
   * @param event - the pointer event
   */
  handle_window_drag_start(event) {
    if (this.current_subtool !== "crop")
      return;
    event.stopPropagation();
    this.is_dragging_window = true;
    this.has_been_manually_changed = true;
    const local_pos = this.image_editor_context.image_container.toLocal(
      event.global
    );
    this.drag_start_position = new Point(local_pos.x, local_pos.y);
    this.drag_start_bounds = { ...this.crop_bounds };
  }
  /**
   * @returns whether the crop has been manually changed by the user
   */
  get crop_manually_changed() {
    return this.has_been_manually_changed;
  }
  on(event, callback) {
    this.event_callbacks.set(event, [
      ...this.event_callbacks.get(event) || [],
      callback
    ]);
  }
  off(event, callback) {
    this.event_callbacks.set(
      event,
      this.event_callbacks.get(event)?.filter((cb) => cb !== callback) || []
    );
  }
  notify(event) {
    for (const callback of this.event_callbacks.get(event) || []) {
      callback();
    }
  }
  get_crop_bounds() {
    const { width, height } = this.image_editor_context.background_image?.getLocalBounds() ?? {
      width: 0,
      height: 0
    };
    return {
      x: this.crop_bounds.x,
      y: this.crop_bounds.y,
      crop_dimensions: {
        width: this.crop_bounds.width,
        height: this.crop_bounds.height
      },
      image_dimensions: {
        width,
        height
      }
    };
  }
  get_image() {
    if (!this.image_editor_context.background_image)
      return Promise.resolve(null);
    const container = new Container();
    const sprite = new Sprite(
      this.image_editor_context.background_image.texture
    );
    container.addChild(sprite);
    return get_canvas_blob(
      this.image_editor_context.app.renderer,
      container,
      this.crop_bounds
    );
  }
}
class ResizeCommand {
  constructor(context2, original_state, new_state, reset_ui) {
    this.context = context2;
    this.name = "Resize";
    this.original_width = original_state.width;
    this.original_height = original_state.height;
    this.original_x = original_state.x;
    this.original_y = original_state.y;
    this.new_width = new_state.width;
    this.new_height = new_state.height;
    this.new_x = new_state.x;
    this.new_y = new_state.y;
    this.reset_ui = reset_ui;
  }
  original_width;
  original_height;
  original_x;
  original_y;
  new_width;
  new_height;
  new_x;
  new_y;
  reset_ui;
  name;
  async execute() {
    if (!this.context.background_image)
      return;
    this.context.background_image.width = this.new_width;
    this.context.background_image.height = this.new_height;
    this.context.background_image.position.set(this.new_x, this.new_y);
    this.reset_ui();
  }
  async undo() {
    if (!this.context.background_image)
      return;
    this.context.background_image.width = this.original_width;
    this.context.background_image.height = this.original_height;
    this.context.background_image.position.set(
      this.original_x,
      this.original_y
    );
    this.reset_ui();
  }
}
class ResizeTool {
  name = "resize";
  image_editor_context;
  current_tool = "image";
  current_subtool = "size";
  current_cursor = "unset";
  CORNER_SIZE = 25;
  LINE_THICKNESS = 5;
  HANDLE_COLOR = 0;
  HIT_AREA_SIZE = 40;
  borderRegion = 0;
  is_dragging = false;
  selected_handle = null;
  active_corner_index = -1;
  active_edge_index = -1;
  last_pointer_position = null;
  resize_ui_container = null;
  dimensions = {
    width: 0,
    height: 0
  };
  position = { x: 0, y: 0 };
  scale = 1;
  is_moving = false;
  dom_mousedown_handler = null;
  dom_mousemove_handler = null;
  dom_mouseup_handler = null;
  event_callbacks = /* @__PURE__ */ new Map();
  last_scale = 1;
  original_state = null;
  /**
   * @method setup
   * @async
   * @description Sets up the resize tool with the given context and tool/subtool
   * @param {ImageEditorContext} context - The image editor context
   * @param {ToolbarTool} tool - The current tool
   * @param {Subtool} subtool - The current subtool
   * @returns {Promise<void>}
   */
  async setup(context2, tool, subtool) {
    this.image_editor_context = context2;
    this.current_tool = tool;
    this.current_subtool = subtool;
    if (context2.background_image) {
      if (context2.background_image.borderRegion !== void 0) {
        this.borderRegion = context2.background_image.borderRegion;
      } else {
        const bg = context2.background_image;
        const container = context2.image_container;
        const isHorizontallyCentered = Math.abs(bg.position.x - (container.width - bg.width) / 2) < 2;
        const isVerticallyCentered = Math.abs(bg.position.y - (container.height - bg.height) / 2) < 2;
        if (!isHorizontallyCentered || !isVerticallyCentered) {
          this.borderRegion = Math.max(bg.position.x, bg.position.y);
          context2.background_image.borderRegion = this.borderRegion;
        }
      }
    }
    context2.dimensions.subscribe((dimensions) => {
      this.dimensions = dimensions;
      if (this.resize_ui_container) {
        this.update_resize_ui();
      }
    });
    context2.position.subscribe((position) => {
      this.position = position;
      if (this.resize_ui_container && this.current_tool === "image" && this.current_subtool === "size") {
        this.update_resize_ui();
      }
    });
    context2.scale.subscribe((scale) => {
      this.scale = scale;
      if (this.resize_ui_container && this.current_tool === "image" && this.current_subtool === "size") {
        this.update_resize_ui();
      }
    });
    await this.init_resize_ui();
    this.setup_event_listeners();
    if (this.current_subtool === "size" && this.image_editor_context.background_image) {
      const bg = this.image_editor_context.background_image;
      const container = this.image_editor_context.image_container;
      const bg_width = bg.width;
      const bg_height = bg.height;
      const container_bounds = container.getLocalBounds();
      const container_width = container_bounds.width;
      const container_height = container_bounds.height;
      const min_x = -(bg_width - container_width);
      const min_y = -(bg_height - container_height);
      const max_x = 0;
      const max_y = 0;
      const x_out_of_bounds = bg_width > container_width && (bg.position.x < min_x || bg.position.x > max_x);
      const y_out_of_bounds = bg_height > container_height && (bg.position.y < min_y || bg.position.y > max_y);
      if (x_out_of_bounds || y_out_of_bounds) {
        this.apply_boundary_constraints();
      }
    }
  }
  /**
   * @method cleanup
   * @description Cleans up the resize tool resources and removes event listeners
   * @returns {void}
   */
  cleanup() {
    if (this.resize_ui_container) {
      this.image_editor_context.app.stage.removeChild(this.resize_ui_container);
    }
    this.cleanup_event_listeners();
  }
  /**
   * @method set_tool
   * @description Sets the current tool and subtool, updating UI visibility
   * @param {ToolbarTool} tool - The tool to set
   * @param {Subtool} subtool - The subtool to set
   * @returns {void}
   */
  set_tool(tool, subtool) {
    this.current_tool = tool;
    this.current_subtool = subtool;
    if (tool === "image" && subtool === "size") {
      if (this.image_editor_context.background_image) {
        const storedBorderRegion = this.image_editor_context.background_image.borderRegion;
        if (typeof storedBorderRegion === "number" && storedBorderRegion > 0) {
          this.borderRegion = storedBorderRegion;
        }
      }
      this.show_resize_ui();
      if (this.image_editor_context.background_image) {
        const bg = this.image_editor_context.background_image;
        const container = this.image_editor_context.image_container;
        const bg_width = bg.width;
        const bg_height = bg.height;
        const container_bounds = container.getLocalBounds();
        const container_width = container_bounds.width;
        const container_height = container_bounds.height;
        const effectiveWidth = container_width - this.borderRegion * 2;
        const effectiveHeight = container_height - this.borderRegion * 2;
        const min_x = bg_width > effectiveWidth ? -(bg_width - effectiveWidth) + this.borderRegion : this.borderRegion;
        const max_x = bg_width > effectiveWidth ? this.borderRegion : container_width - bg_width - this.borderRegion;
        const min_y = bg_height > effectiveHeight ? -(bg_height - effectiveHeight) + this.borderRegion : this.borderRegion;
        const max_y = bg_height > effectiveHeight ? this.borderRegion : container_height - bg_height - this.borderRegion;
        const x_out_of_bounds = bg.position.x < min_x || bg.position.x > max_x;
        const y_out_of_bounds = bg.position.y < min_y || bg.position.y > max_y;
        if (x_out_of_bounds || y_out_of_bounds) {
          this.apply_boundary_constraints();
        }
      }
    } else {
      this.hide_resize_ui();
    }
  }
  /**
   * @method init_resize_ui
   * @private
   * @async
   * @description Initializes the resize UI elements and sets up the update loop
   * @returns {Promise<void>}
   */
  async init_resize_ui() {
    this.resize_ui_container = this.make_resize_ui(
      this.dimensions.width * this.scale,
      this.dimensions.height * this.scale
    );
    this.resize_ui_container.position.set(this.position.x, this.position.y);
    this.resize_ui_container.visible = false;
    this.image_editor_context.app.stage.addChild(this.resize_ui_container);
  }
  /**
   * @method make_resize_ui
   * @private
   * @description Creates the resize UI with the specified dimensions
   * @param {number} width - Width of the resize area
   * @param {number} height - Height of the resize area
   * @returns {Container} The created resize UI container
   */
  make_resize_ui(width, height) {
    const resize_container = new Container();
    resize_container.eventMode = "static";
    resize_container.interactiveChildren = true;
    const outline = new Graphics().rect(0, 0, width, height).stroke({
      width: 1,
      color: 0,
      alignment: 0,
      alpha: 0.3
    });
    const dotted_outline = new Graphics();
    dotted_outline.rect(0, 0, width, height).stroke({
      width: 1,
      color: 0,
      alpha: 0.7,
      pixelLine: true
    });
    const dash_length = 5;
    const gap_length = 5;
    const total_length = dash_length + gap_length;
    for (let x2 = 0; x2 < width; x2 += total_length * 2) {
      dotted_outline.rect(x2, 0, Math.min(dash_length, width - x2), 1).fill(0);
      dotted_outline.rect(x2, height - 1, Math.min(dash_length, width - x2), 1).fill(0);
    }
    for (let y2 = 0; y2 < height; y2 += total_length * 2) {
      dotted_outline.rect(0, y2, 1, Math.min(dash_length, height - y2)).fill(0);
      dotted_outline.rect(width - 1, y2, 1, Math.min(dash_length, height - y2)).fill(0);
    }
    resize_container.addChild(outline);
    resize_container.addChild(dotted_outline);
    const move_area = new Graphics().rect(0, 0, width, height).fill(16777215, 0);
    move_area.eventMode = "static";
    move_area.cursor = "move";
    resize_container.addChild(move_area);
    this.create_corner_handles(resize_container, width, height);
    this.create_edge_handles(resize_container, width, height);
    return resize_container;
  }
  /**
   * @method create_handle
   * @private
   * @description Creates a handle for the resize UI
   * @param {boolean} [is_edge=false] - Whether the handle is an edge handle
   * @returns {Container} The created handle container
   */
  create_handle(is_edge = false) {
    const handle = new Container();
    handle.eventMode = "static";
    handle.cursor = "pointer";
    const handle_graphics = new Graphics();
    const handle_size = is_edge ? 8 : 10;
    handle_graphics.rect(-handle_size / 2, -handle_size / 2, handle_size, handle_size).fill(16777215).stroke({ width: 1, color: this.HANDLE_COLOR });
    handle.addChild(handle_graphics);
    const hit_size = is_edge ? this.HIT_AREA_SIZE * 1.5 : this.HIT_AREA_SIZE;
    handle.hitArea = new Rectangle(
      -hit_size / 2,
      -hit_size / 2,
      hit_size,
      hit_size
    );
    return handle;
  }
  /**
   * @method create_edge_handles
   * @private
   * @description Creates edge handles for the resize UI
   * @param {Container} container - The container to add handles to
   * @param {number} width - Width of the resize area
   * @param {number} height - Height of the resize area
   * @returns {void}
   */
  create_edge_handles(container, width, height) {
    [-1, 1].forEach((i2, index) => {
      const handle = this.create_handle(true);
      handle.rotation = 0;
      handle.on("pointerdown", (event) => {
        this.handle_pointer_down(event, handle, -1, index);
      });
      handle.x = width / 2;
      handle.y = i2 < 0 ? 0 : height;
      handle.cursor = "ns-resize";
      container.addChild(handle);
    });
    [-1, 1].forEach((i2, index) => {
      const handle = this.create_handle(true);
      handle.rotation = 0;
      handle.on("pointerdown", (event) => {
        this.handle_pointer_down(event, handle, -1, index + 2);
      });
      handle.x = i2 < 0 ? 0 : width;
      handle.y = height / 2;
      handle.cursor = "ew-resize";
      container.addChild(handle);
    });
  }
  /**
   * @method create_corner_handles
   * @private
   * @description Creates corner handles for the resize UI
   * @param {Container} container - The container to add handles to
   * @param {number} width - Width of the resize area
   * @param {number} height - Height of the resize area
   * @returns {void}
   */
  create_corner_handles(container, width, height) {
    const corners = [
      { x: 0, y: 0, cursor: "nwse-resize" },
      { x: width, y: 0, cursor: "nesw-resize" },
      { x: 0, y: height, cursor: "nesw-resize" },
      { x: width, y: height, cursor: "nwse-resize" }
    ];
    corners.forEach(({ x: x2, y: y2, cursor }, i2) => {
      const corner = this.create_handle(false);
      corner.x = x2;
      corner.y = y2;
      corner.on("pointerdown", (event) => {
        this.handle_pointer_down(event, corner, i2, -1);
      });
      corner.cursor = cursor;
      container.addChild(corner);
    });
  }
  /**
   * @method handle_pointer_down
   * @private
   * @description Handles pointer down events on handles
   * @param {FederatedPointerEvent} event - The pointer event
   * @param {Container} handle - The handle that was clicked
   * @param {number} corner_index - Index of the corner (-1 if not a corner)
   * @param {number} edge_index - Index of the edge (-1 if not an edge)
   * @returns {void}
   */
  handle_pointer_down(event, handle, corner_index, edge_index) {
    if (this.current_subtool !== "size")
      return;
    event.stopPropagation();
    this.is_dragging = true;
    this.selected_handle = handle;
    this.active_corner_index = corner_index;
    this.active_edge_index = edge_index;
    const local_pos = this.image_editor_context.image_container.toLocal(
      event.global
    );
    this.last_pointer_position = new Point(local_pos.x, local_pos.y);
    if (this.image_editor_context.background_image) {
      const bg = this.image_editor_context.background_image;
      this.original_state = {
        width: bg.width,
        height: bg.height,
        x: bg.position.x,
        y: bg.position.y
      };
    }
  }
  /**
   * Maintains aspect ratio during resizing
   * @param new_width - The new width
   * @param new_height - The new height
   * @param original_aspect_ratio - The original aspect ratio
   * @param delta - The delta to apply
   * @returns The adjusted dimensions
   */
  maintain_aspect_ratio(new_width, new_height, original_aspect_ratio, delta) {
    const abs_delta_x = Math.abs(delta.x);
    const abs_delta_y = Math.abs(delta.y);
    if (abs_delta_x > abs_delta_y * 1.2) {
      new_height = new_width / original_aspect_ratio;
    } else if (abs_delta_y > abs_delta_x * 1.2) {
      new_width = new_height * original_aspect_ratio;
    } else {
      if (new_width / original_aspect_ratio > new_height) {
        new_height = new_width / original_aspect_ratio;
      } else {
        new_width = new_height * original_aspect_ratio;
      }
    }
    return { width: new_width, height: new_height };
  }
  /**
   * Limits dimensions based on constraints
   * @param width - The width to limit
   * @param height - The height to limit
   * @param maintain_aspect_ratio - Whether to maintain aspect ratio
   * @returns The limited dimensions
   */
  limit_dimensions(width, height, maintain_aspect_ratio) {
    const max_width = this.dimensions.width;
    const max_height = this.dimensions.height;
    let new_width = width;
    let new_height = height;
    if (new_width > max_width) {
      if (maintain_aspect_ratio && this.active_corner_index !== -1) {
        new_height = max_width / new_width * new_height;
      }
      new_width = max_width;
    }
    if (new_height > max_height) {
      if (maintain_aspect_ratio && this.active_corner_index !== -1) {
        new_width = max_height / new_height * new_width;
      }
      new_height = max_height;
    }
    new_width = Math.max(20, new_width);
    new_height = Math.max(20, new_height);
    return { width: new_width, height: new_height };
  }
  /**
   * Calculates position deltas based on dimension changes
   * @param old_width - The original width
   * @param old_height - The original height
   * @param new_width - The new width
   * @param new_height - The new height
   * @returns Object containing x and y position deltas
   */
  calculate_position_deltas(old_width, old_height, new_width, new_height) {
    let delta_x = 0;
    let delta_y = 0;
    if (this.active_corner_index === 0 || this.active_edge_index === 2) {
      delta_x = old_width - new_width;
    } else if (this.active_corner_index === 2) {
      delta_x = old_width - new_width;
      delta_y = 0;
    }
    if (this.active_corner_index === 0 || this.active_corner_index === 1 || this.active_edge_index === 0) {
      delta_y = old_height - new_height;
    }
    return { x: delta_x, y: delta_y };
  }
  /**
   * Applies boundary constraints to keep the image within the container
   * @private
   */
  apply_boundary_constraints() {
    if (!this.image_editor_context.background_image)
      return;
    const bg = this.image_editor_context.background_image;
    const image_container = this.image_editor_context.image_container;
    let new_x = bg.position.x;
    let new_y = bg.position.y;
    const container_width = image_container.width;
    const container_height = image_container.height;
    const bg_width = bg.width;
    const bg_height = bg.height;
    const effectiveWidth = container_width - this.borderRegion * 2;
    const effectiveHeight = container_height - this.borderRegion * 2;
    if (bg_width > effectiveWidth) {
      const min_x = -(bg_width - effectiveWidth) + this.borderRegion;
      const max_x = this.borderRegion;
      new_x = Math.max(min_x, Math.min(max_x, new_x));
    } else {
      const min_x = this.borderRegion;
      const max_x = container_width - bg_width - this.borderRegion;
      if (new_x < min_x || new_x > max_x) {
        new_x = Math.max(min_x, Math.min(max_x, new_x));
      }
    }
    if (bg_height > effectiveHeight) {
      const min_y = -(bg_height - effectiveHeight) + this.borderRegion;
      const max_y = this.borderRegion;
      new_y = Math.max(min_y, Math.min(max_y, new_y));
    } else {
      const min_y = this.borderRegion;
      const max_y = container_height - bg_height - this.borderRegion;
      if (new_y < min_y || new_y > max_y) {
        new_y = Math.max(min_y, Math.min(max_y, new_y));
      }
    }
    bg.position.set(new_x, new_y);
    if (this.resize_ui_container) {
      const total_x = image_container.position.x + new_x * this.scale;
      const total_y = image_container.position.y + new_y * this.scale;
      this.resize_ui_container.position.set(total_x, total_y);
    }
  }
  /**
   * Updates the resize bounds based on the delta
   * @param delta - The delta to apply
   * @param maintain_aspect_ratio - Whether to maintain the aspect ratio
   */
  update_resize_bounds(delta, maintain_aspect_ratio = false) {
    const background_image = this.image_editor_context.background_image;
    if (!background_image)
      return;
    const original_width = background_image.width;
    const original_height = background_image.height;
    const original_x = background_image.position.x;
    const original_y = background_image.position.y;
    const original_aspect_ratio = original_width / original_height;
    let current_position;
    if (this.active_corner_index !== -1) {
      switch (this.active_corner_index) {
        case 0:
          current_position = new Point(
            original_x - delta.x,
            original_y - delta.y
          );
          break;
        case 1:
          current_position = new Point(
            original_x + original_width + delta.x,
            original_y - delta.y
          );
          break;
        case 2:
          current_position = new Point(
            original_x - delta.x,
            original_y + original_height + delta.y
          );
          break;
        case 3:
          current_position = new Point(
            original_x + original_width + delta.x,
            original_y + original_height + delta.y
          );
          break;
        default:
          return;
      }
      const dimensions = this.handle_direct_corner_resize(
        current_position,
        original_width,
        original_height,
        original_x,
        original_y,
        original_aspect_ratio,
        maintain_aspect_ratio
      );
      background_image.width = dimensions.width;
      background_image.height = dimensions.height;
      background_image.position.set(dimensions.x, dimensions.y);
    } else if (this.active_edge_index !== -1) {
      switch (this.active_edge_index) {
        case 0:
          current_position = new Point(
            original_x + original_width / 2,
            original_y - delta.y
          );
          break;
        case 1:
          current_position = new Point(
            original_x + original_width / 2,
            original_y + original_height + delta.y
          );
          break;
        case 2:
          current_position = new Point(
            original_x - delta.x,
            original_y + original_height / 2
          );
          break;
        case 3:
          current_position = new Point(
            original_x + original_width + delta.x,
            original_y + original_height / 2
          );
          break;
        default:
          return;
      }
      const dimensions = this.handle_direct_edge_resize(
        current_position,
        original_width,
        original_height,
        original_x,
        original_y
      );
      background_image.width = dimensions.width;
      background_image.height = dimensions.height;
      background_image.position.set(dimensions.x, dimensions.y);
    }
    this.update_resize_ui();
  }
  /**
   * updates the resize ui position and dimensions
   */
  update_resize_ui() {
    if (!this.resize_ui_container || !this.image_editor_context.background_image || !this.image_editor_context.background_image.position)
      return;
    const background_image = this.image_editor_context.background_image;
    const image_container = this.image_editor_context.image_container;
    const container_global_pos = image_container.getGlobalPosition();
    const bg_pos_x = background_image.position.x * this.scale;
    const bg_pos_y = background_image.position.y * this.scale;
    this.resize_ui_container.position.set(
      container_global_pos.x + bg_pos_x,
      container_global_pos.y + bg_pos_y
    );
    const scaled_width = background_image.width * this.scale;
    const scaled_height = background_image.height * this.scale;
    const outline = this.resize_ui_container.getChildAt(0);
    outline.clear().rect(0, 0, scaled_width, scaled_height).stroke({ width: 1, color: 0, alignment: 0, alpha: 0.3 });
    const dotted_outline = this.resize_ui_container.getChildAt(1);
    dotted_outline.clear();
    dotted_outline.rect(0, 0, scaled_width, scaled_height).stroke({
      width: 1,
      color: 0,
      alpha: 0.7,
      pixelLine: true
    });
    if (!this.is_dragging && !this.is_moving && Math.abs(this.scale - this.last_scale) < 1e-3) {
      const dash_length = 5;
      const gap_length = 5;
      const total_length = dash_length + gap_length;
      for (let x2 = 0; x2 < scaled_width; x2 += total_length * 2) {
        dotted_outline.rect(x2, 0, Math.min(dash_length, scaled_width - x2), 1).fill(0);
        dotted_outline.rect(
          x2,
          scaled_height - 1,
          Math.min(dash_length, scaled_width - x2),
          1
        ).fill(0);
      }
      for (let y2 = 0; y2 < scaled_height; y2 += total_length * 2) {
        dotted_outline.rect(0, y2, 1, Math.min(dash_length, scaled_height - y2)).fill(0);
        dotted_outline.rect(
          scaled_width - 1,
          y2,
          1,
          Math.min(dash_length, scaled_height - y2)
        ).fill(0);
      }
    }
    this.last_scale = this.scale;
    const move_area = this.resize_ui_container.getChildAt(2);
    move_area.clear().rect(0, 0, scaled_width, scaled_height).fill(16777215, 0);
    this.update_handle_positions(scaled_width, scaled_height);
  }
  /**
   * updates the positions of all handles
   * @param width - width of the resize area
   * @param height - height of the resize area
   */
  update_handle_positions(width, height) {
    if (!this.resize_ui_container)
      return;
    const handles = this.resize_ui_container.children.slice(3);
    const move_area = this.resize_ui_container.getChildAt(2);
    move_area.clear().rect(0, 0, width, height).fill(16777215, 0);
    const corners = handles.slice(0, 4);
    const cornerPositions = [
      { x: 0, y: 0 },
      { x: width, y: 0 },
      { x: 0, y: height },
      { x: width, y: height }
    ];
    corners.forEach((handle, i2) => {
      handle.position.set(cornerPositions[i2].x, cornerPositions[i2].y);
    });
    const edges = handles.slice(4);
    edges.forEach((handle, i2) => {
      if (i2 < 2) {
        handle.position.set(width / 2, i2 === 0 ? 0 : height);
      } else {
        handle.position.set(i2 === 2 ? 0 : width, height / 2);
      }
    });
  }
  /**
   * sets up event listeners for the resize tool
   */
  setup_event_listeners() {
    const stage = this.image_editor_context.app.stage;
    stage.eventMode = "static";
    stage.on("pointermove", this.handle_pointer_move.bind(this));
    stage.on("pointerup", this.handle_pointer_up.bind(this));
    stage.on("pointerupoutside", this.handle_pointer_up.bind(this));
    this.setup_dom_event_listeners();
  }
  /**
   * Sets up direct DOM event listeners for dragging the background image
   */
  setup_dom_event_listeners() {
    this.cleanup_dom_event_listeners();
    const canvas = this.image_editor_context.app.canvas;
    this.dom_mousedown_handler = (e2) => {
      if (this.current_subtool !== "size")
        return;
      if (this.is_dragging || this.selected_handle)
        return;
      if (!this.image_editor_context.background_image)
        return;
      const bg = this.image_editor_context.background_image;
      const container = this.image_editor_context.image_container;
      const containerBounds = container.getBounds();
      const rect = canvas.getBoundingClientRect();
      const x2 = e2.clientX - rect.left;
      const y2 = e2.clientY - rect.top;
      const localX = (x2 - containerBounds.x) / this.scale;
      const localY = (y2 - containerBounds.y) / this.scale;
      if (localX >= bg.position.x && localX <= bg.position.x + bg.width && localY >= bg.position.y && localY <= bg.position.y + bg.height) {
        this.is_moving = true;
        this.last_pointer_position = new Point(localX, localY);
        this.original_state = {
          width: bg.width,
          height: bg.height,
          x: bg.position.x,
          y: bg.position.y
        };
        e2.preventDefault();
        e2.stopPropagation();
      }
    };
    this.dom_mousemove_handler = (e2) => {
      if (this.current_subtool !== "size" || !this.is_moving)
        return;
      if (!this.last_pointer_position || !this.image_editor_context.background_image)
        return;
      const container = this.image_editor_context.image_container;
      const containerBounds = container.getBounds();
      const rect = canvas.getBoundingClientRect();
      const x2 = e2.clientX - rect.left;
      const y2 = e2.clientY - rect.top;
      const localX = (x2 - containerBounds.x) / this.scale;
      const localY = (y2 - containerBounds.y) / this.scale;
      const current_position = new Point(localX, localY);
      this.handle_image_dragging(current_position);
      this.last_pointer_position = current_position;
      e2.preventDefault();
      e2.stopPropagation();
    };
    this.dom_mouseup_handler = (e2) => {
      if (this.current_subtool !== "size")
        return;
      if (this.original_state && this.image_editor_context.background_image) {
        const bg = this.image_editor_context.background_image;
        const new_state = {
          width: bg.width,
          height: bg.height,
          x: bg.position.x,
          y: bg.position.y
        };
        if (this.original_state.width !== new_state.width || this.original_state.height !== new_state.height || this.original_state.x !== new_state.x || this.original_state.y !== new_state.y) {
          const resize_command = new ResizeCommand(
            this.image_editor_context,
            this.original_state,
            new_state,
            this.update_resize_ui.bind(this)
          );
          this.image_editor_context.execute_command(resize_command);
        }
        this.original_state = null;
      }
      this.is_moving = false;
      this.last_pointer_position = null;
      this.update_resize_ui();
      e2.preventDefault();
      e2.stopPropagation();
    };
    canvas.addEventListener("mousedown", this.dom_mousedown_handler);
    window.addEventListener("mousemove", this.dom_mousemove_handler);
    window.addEventListener("mouseup", this.dom_mouseup_handler);
  }
  /**
   * Cleans up DOM event listeners
   */
  cleanup_dom_event_listeners() {
    const canvas = this.image_editor_context.app.canvas;
    if (this.dom_mousedown_handler) {
      canvas.removeEventListener("mousedown", this.dom_mousedown_handler);
      this.dom_mousedown_handler = null;
    }
    if (this.dom_mousemove_handler) {
      window.removeEventListener("mousemove", this.dom_mousemove_handler);
      this.dom_mousemove_handler = null;
    }
    if (this.dom_mouseup_handler) {
      window.removeEventListener("mouseup", this.dom_mouseup_handler);
      this.dom_mouseup_handler = null;
    }
  }
  /**
   * removes event listeners for the resize tool
   */
  cleanup_event_listeners() {
    const stage = this.image_editor_context.app.stage;
    stage.off("pointermove", this.handle_pointer_move.bind(this));
    stage.off("pointerup", this.handle_pointer_up.bind(this));
    stage.off("pointerupoutside", this.handle_pointer_up.bind(this));
    this.cleanup_dom_event_listeners();
  }
  /**
   * Handles pointer move events
   */
  handle_pointer_move(event) {
    if (this.current_subtool !== "size")
      return;
    const local_pos = this.image_editor_context.image_container.toLocal(
      event.global
    );
    const current_position = new Point(local_pos.x, local_pos.y);
    if (this.is_moving && this.last_pointer_position) {
      this.handle_image_dragging(current_position);
      this.last_pointer_position = current_position;
    } else if (this.is_dragging && this.selected_handle) {
      if (!this.image_editor_context.background_image)
        return;
      const bg = this.image_editor_context.background_image;
      const maintain_aspect_ratio = this.active_corner_index !== -1 && !event.shiftKey;
      const original_width = bg.width;
      const original_height = bg.height;
      const original_x = bg.position.x;
      const original_y = bg.position.y;
      const original_aspect_ratio = original_width / original_height;
      let dimensions;
      if (this.active_corner_index !== -1) {
        dimensions = this.handle_direct_corner_resize(
          current_position,
          original_width,
          original_height,
          original_x,
          original_y,
          original_aspect_ratio,
          maintain_aspect_ratio
        );
      } else if (this.active_edge_index !== -1) {
        dimensions = this.handle_direct_edge_resize(
          current_position,
          original_width,
          original_height,
          original_x,
          original_y
        );
      } else {
        return;
      }
      dimensions = this.limit_dimensions_to_container(
        dimensions,
        original_x,
        original_y,
        original_width,
        original_height,
        maintain_aspect_ratio
      );
      bg.width = dimensions.width;
      bg.height = dimensions.height;
      bg.position.set(dimensions.x, dimensions.y);
      this.update_resize_ui();
      this.last_pointer_position = current_position;
    }
  }
  /**
   * handles pointer up events
   */
  handle_pointer_up() {
    if (this.current_subtool !== "size")
      return;
    this.is_dragging = false;
    this.is_moving = false;
    this.selected_handle = null;
    this.last_pointer_position = null;
    this.active_corner_index = -1;
    this.active_edge_index = -1;
    this.update_resize_ui();
    this.notify("change");
  }
  /**
   * Handles dragging of the background image
   * @param current_position - The current pointer position
   * @private
   */
  handle_image_dragging(current_position) {
    if (!this.last_pointer_position || !this.image_editor_context.background_image) {
      return;
    }
    const bg = this.image_editor_context.background_image;
    const image_container = this.image_editor_context.image_container.getLocalBounds();
    const dx = current_position.x - this.last_pointer_position.x;
    const dy = current_position.y - this.last_pointer_position.y;
    let new_x = bg.position.x + dx;
    let new_y = bg.position.y + dy;
    const container_width = image_container.width;
    const container_height = image_container.height;
    const bg_width = bg.width;
    const bg_height = bg.height;
    const effectiveWidth = container_width - this.borderRegion * 2;
    const effectiveHeight = container_height - this.borderRegion * 2;
    if (bg_width > effectiveWidth) {
      const min_x = -(bg_width - effectiveWidth) + this.borderRegion;
      const max_x = this.borderRegion;
      new_x = Math.max(min_x, Math.min(max_x, new_x));
    } else {
      const min_x = this.borderRegion;
      const max_x = container_width - bg_width - this.borderRegion;
      new_x = Math.max(min_x, Math.min(max_x, new_x));
    }
    if (bg_height > effectiveHeight) {
      const min_y = -(bg_height - effectiveHeight) + this.borderRegion;
      const max_y = this.borderRegion;
      new_y = Math.max(min_y, Math.min(max_y, new_y));
    } else {
      const min_y = this.borderRegion;
      const max_y = container_height - bg_height - this.borderRegion;
      new_y = Math.max(min_y, Math.min(max_y, new_y));
    }
    bg.position.set(new_x, new_y);
    this.update_resize_ui();
  }
  /**
   * Handles corner resizing
   * @param current_position - The current mouse position
   * @param original_width - The original width
   * @param original_height - The original height
   * @param original_x - The original x position
   * @param original_y - The original y position
   * @param original_aspect_ratio - The original aspect ratio
   * @param maintain_aspect_ratio - Whether to maintain aspect ratio
   * @returns The new dimensions and position
   * @private
   */
  handle_direct_corner_resize(current_position, original_width, original_height, original_x, original_y, original_aspect_ratio, maintain_aspect_ratio) {
    let raw_width = 0;
    let raw_height = 0;
    let new_x = original_x;
    let new_y = original_y;
    switch (this.active_corner_index) {
      case 0:
        raw_width = original_x + original_width - current_position.x;
        raw_height = original_y + original_height - current_position.y;
        break;
      case 1:
        raw_width = current_position.x - original_x;
        raw_height = original_y + original_height - current_position.y;
        break;
      case 2:
        raw_width = original_x + original_width - current_position.x;
        raw_height = current_position.y - original_y;
        break;
      case 3:
        raw_width = current_position.x - original_x;
        raw_height = current_position.y - original_y;
        break;
    }
    raw_width = Math.max(20, raw_width);
    raw_height = Math.max(20, raw_height);
    let new_width = raw_width;
    let new_height = raw_height;
    if (maintain_aspect_ratio) {
      const diagonal_vector = {
        x: current_position.x - (original_x + original_width / 2),
        y: current_position.y - (original_y + original_height / 2)
      };
      const angle = Math.abs(Math.atan2(diagonal_vector.y, diagonal_vector.x));
      if (angle < Math.PI / 4 || angle > 3 * Math.PI / 4) {
        new_height = new_width / original_aspect_ratio;
      } else {
        new_width = new_height * original_aspect_ratio;
      }
    }
    switch (this.active_corner_index) {
      case 0:
        new_x = original_x + original_width - new_width;
        new_y = original_y + original_height - new_height;
        break;
      case 1:
        new_y = original_y + original_height - new_height;
        break;
      case 2:
        new_x = original_x + original_width - new_width;
        break;
    }
    return { width: new_width, height: new_height, x: new_x, y: new_y };
  }
  /**
   * Handles edge resizing
   * @param current_position - The current mouse position
   * @param original_width - The original width
   * @param original_height - The original height
   * @param original_x - The original x position
   * @param original_y - The original y position
   * @returns The new dimensions and position
   * @private
   */
  handle_direct_edge_resize(current_position, original_width, original_height, original_x, original_y) {
    let new_width = original_width;
    let new_height = original_height;
    let new_x = original_x;
    let new_y = original_y;
    switch (this.active_edge_index) {
      case 0:
        new_height = Math.max(
          20,
          original_y + original_height - current_position.y
        );
        new_y = current_position.y;
        break;
      case 1:
        new_height = Math.max(20, current_position.y - original_y);
        break;
      case 2:
        new_width = Math.max(
          20,
          original_x + original_width - current_position.x
        );
        new_x = current_position.x;
        break;
      case 3:
        new_width = Math.max(20, current_position.x - original_x);
        break;
    }
    return { width: new_width, height: new_height, x: new_x, y: new_y };
  }
  /**
   * Limits dimensions to container size
   * @param dimensions - The dimensions to limit
   * @param original_x - The original x position
   * @param original_y - The original y position
   * @param original_width - The original width
   * @param original_height - The original height
   * @param maintain_aspect_ratio - Whether to maintain aspect ratio
   * @returns The limited dimensions and position
   * @private
   */
  limit_dimensions_to_container(dimensions, original_x, original_y, original_width, original_height, maintain_aspect_ratio) {
    let {
      width: new_width,
      height: new_height,
      x: new_x,
      y: new_y
    } = dimensions;
    const effective_container_width = this.dimensions.width - this.borderRegion * 2;
    const effective_container_height = this.dimensions.height - this.borderRegion * 2;
    const pre_limit_width = new_width;
    const pre_limit_height = new_height;
    const size_limited = this.apply_size_limits(
      new_width,
      new_height,
      effective_container_width,
      effective_container_height,
      maintain_aspect_ratio,
      pre_limit_width / pre_limit_height
    );
    new_width = size_limited.width;
    new_height = size_limited.height;
    const position_adjusted = this.adjust_position_for_resizing(
      new_width,
      new_height,
      original_x,
      original_y,
      original_width,
      original_height
    );
    new_x = position_adjusted.x;
    new_y = position_adjusted.y;
    const border_constrained = this.apply_border_constraints(
      new_width,
      new_height,
      new_x,
      new_y,
      maintain_aspect_ratio,
      pre_limit_width / pre_limit_height
    );
    return border_constrained;
  }
  /**
   * Apply size limits to ensure dimensions don't exceed container
   * @private
   */
  apply_size_limits(width, height, max_width, max_height, maintain_aspect_ratio, aspect_ratio) {
    let new_width = width;
    let new_height = height;
    const needs_width_limit = new_width > max_width;
    const needs_height_limit = new_height > max_height;
    if (needs_width_limit && needs_height_limit) {
      const width_scale = max_width / new_width;
      const height_scale = max_height / new_height;
      if (width_scale < height_scale) {
        new_width = max_width;
        if (maintain_aspect_ratio) {
          new_height = new_width / aspect_ratio;
        }
      } else {
        new_height = max_height;
        if (maintain_aspect_ratio) {
          new_width = new_height * aspect_ratio;
        }
      }
    } else if (needs_width_limit) {
      new_width = max_width;
      if (maintain_aspect_ratio) {
        new_height = new_width / aspect_ratio;
      }
    } else if (needs_height_limit) {
      new_height = max_height;
      if (maintain_aspect_ratio) {
        new_width = new_height * aspect_ratio;
      }
    }
    return { width: new_width, height: new_height };
  }
  /**
   * Adjust position based on which handles are being dragged
   * @private
   */
  adjust_position_for_resizing(new_width, new_height, original_x, original_y, original_width, original_height) {
    let new_x = original_x;
    let new_y = original_y;
    switch (this.active_corner_index) {
      case 0:
        new_x = original_x + original_width - new_width;
        new_y = original_y + original_height - new_height;
        break;
      case 1:
        new_y = original_y + original_height - new_height;
        break;
      case 2:
        new_x = original_x + original_width - new_width;
        break;
    }
    if (this.active_edge_index !== -1) {
      switch (this.active_edge_index) {
        case 0:
          new_y = original_y + original_height - new_height;
          break;
        case 2:
          new_x = original_x + original_width - new_width;
          break;
      }
    }
    return { x: new_x, y: new_y };
  }
  /**
   * Apply border region constraints to prevent image from intruding on border
   * @private
   */
  apply_border_constraints(width, height, x2, y2, maintain_aspect_ratio, aspect_ratio) {
    const top_left_constrained = this.apply_top_left_constraints(
      width,
      height,
      x2,
      y2,
      maintain_aspect_ratio,
      aspect_ratio
    );
    const all_constrained = this.apply_bottom_right_constraints(
      top_left_constrained.width,
      top_left_constrained.height,
      top_left_constrained.x,
      top_left_constrained.y,
      maintain_aspect_ratio,
      aspect_ratio
    );
    all_constrained.width = Math.max(20, all_constrained.width);
    all_constrained.height = Math.max(20, all_constrained.height);
    return all_constrained;
  }
  /**
   * Apply top and left border constraints
   * @private
   */
  apply_top_left_constraints(width, height, x2, y2, maintain_aspect_ratio, aspect_ratio) {
    let new_width = width;
    let new_height = height;
    let new_x = x2;
    let new_y = y2;
    if (new_x < this.borderRegion) {
      if (this.active_corner_index === 0 || this.active_corner_index === 2 || this.active_edge_index === 2) {
        new_width -= this.borderRegion - new_x;
        if (maintain_aspect_ratio) {
          new_height = new_width / aspect_ratio;
        }
      }
      new_x = this.borderRegion;
    }
    if (new_y < this.borderRegion) {
      if (this.active_corner_index === 0 || this.active_corner_index === 1 || this.active_edge_index === 0) {
        new_height -= this.borderRegion - new_y;
        if (maintain_aspect_ratio) {
          new_width = new_height * aspect_ratio;
        }
      }
      new_y = this.borderRegion;
    }
    return { width: new_width, height: new_height, x: new_x, y: new_y };
  }
  /**
   * Apply bottom and right border constraints
   * @private
   */
  apply_bottom_right_constraints(width, height, x2, y2, maintain_aspect_ratio, aspect_ratio) {
    let new_width = width;
    let new_height = height;
    let new_x = x2;
    let new_y = y2;
    if (new_x + new_width > this.dimensions.width - this.borderRegion) {
      if (this.active_corner_index === 1 || this.active_corner_index === 3 || this.active_edge_index === 3) {
        new_width = this.dimensions.width - this.borderRegion - new_x;
        if (maintain_aspect_ratio) {
          new_height = new_width / aspect_ratio;
        }
      } else {
        const right_edge = new_x + new_width;
        const excess = right_edge - (this.dimensions.width - this.borderRegion);
        new_x = Math.max(this.borderRegion, new_x - excess);
      }
    }
    if (new_y + new_height > this.dimensions.height - this.borderRegion) {
      if (this.active_corner_index === 2 || this.active_corner_index === 3 || this.active_edge_index === 1) {
        new_height = this.dimensions.height - this.borderRegion - new_y;
        if (maintain_aspect_ratio) {
          new_width = new_height * aspect_ratio;
        }
      } else {
        const bottom_edge = new_y + new_height;
        const excess = bottom_edge - (this.dimensions.height - this.borderRegion);
        new_y = Math.max(this.borderRegion, new_y - excess);
      }
    }
    return { width: new_width, height: new_height, x: new_x, y: new_y };
  }
  /**
   * Shows the resize UI
   * @private
   */
  show_resize_ui() {
    if (this.resize_ui_container) {
      this.resize_ui_container.visible = true;
      this.update_resize_ui();
    }
    if (this.image_editor_context.background_image) {
      const bg = this.image_editor_context.background_image;
      this.current_cursor = bg.cursor;
      bg.cursor = "move";
    }
    this.setup_dom_event_listeners();
  }
  /**
   * Hides the resize UI
   * @private
   */
  hide_resize_ui() {
    if (this.resize_ui_container) {
      this.resize_ui_container.visible = false;
    }
    if (this.image_editor_context.background_image) {
      const bg = this.image_editor_context.background_image;
      bg.cursor = this.current_cursor;
    }
    this.cleanup_dom_event_listeners();
  }
  on(event, callback) {
    this.event_callbacks.set(event, [
      ...this.event_callbacks.get(event) || [],
      callback
    ]);
  }
  off(event, callback) {
    this.event_callbacks.set(
      event,
      this.event_callbacks.get(event)?.filter((cb) => cb !== callback) || []
    );
  }
  notify(event) {
    for (const callback of this.event_callbacks.get(event) || []) {
      callback();
    }
  }
  /**
   * Sets the border region explicitly
   * @param borderRegion The border region size in pixels
   */
  set_border_region(borderRegion) {
    this.borderRegion = borderRegion;
    if (this.image_editor_context?.background_image) {
      this.image_editor_context.background_image.borderRegion = borderRegion;
    }
    if (this.resize_ui_container) {
      this.update_resize_ui();
    }
    if (this.current_subtool === "size" && this.image_editor_context?.background_image) {
      this.apply_boundary_constraints();
    }
  }
}
function set_cursor(child, cursor) {
  if (child instanceof Container) {
    child.cursor = cursor;
  } else if ("cursor" in child) {
    child.cursor = cursor;
  }
}
function recurse_set_cursor(children, cursor) {
  for (const child of children) {
    set_cursor(child, cursor);
    if (child instanceof Container && child.children.length > 0) {
      recurse_set_cursor(
        child.children,
        cursor
      );
    }
  }
}
function clear_timeout(timeout) {
  if (timeout !== null) {
    window.clearTimeout(timeout);
  }
  return null;
}
class BrushCursor {
  constructor(image_editor_context, state, scale) {
    this.image_editor_context = image_editor_context;
    this.state = state;
    this.scale = scale;
    this.initialize_cursor();
    this.initialize_brush_preview();
  }
  cursor_graphics = null;
  cursor_container = null;
  brush_preview_container = null;
  brush_preview_graphics = null;
  is_preview_visible = false;
  is_cursor_over_image = false;
  cursor_position_check_timeout = null;
  is_brush_or_erase_active = false;
  _bound_update_cursor = null;
  _bound_check_cursor_over_image = null;
  /**
   * Returns whether the cursor is currently over the image.
   */
  is_over_image() {
    return this.is_cursor_over_image;
  }
  /**
   * Sets up cursor-related event listeners.
   */
  setup_event_listeners() {
    this.cleanup_event_listeners();
    this._bound_update_cursor = this.update_cursor_position.bind(this);
    this._bound_check_cursor_over_image = this.check_cursor_over_image.bind(this);
    const stage = this.image_editor_context.app.stage;
    stage.on("pointermove", this._bound_update_cursor);
    stage.on("pointermove", this._bound_check_cursor_over_image);
    this.image_editor_context.image_container.on(
      "pointerenter",
      this.on_image_container_pointer_enter.bind(this)
    );
    this.image_editor_context.image_container.on(
      "pointerleave",
      this.on_image_container_pointer_leave.bind(this)
    );
  }
  /**
   * Removes all cursor-related event listeners.
   */
  cleanup_event_listeners() {
    const stage = this.image_editor_context.app.stage;
    if (this._bound_update_cursor) {
      stage.off("pointermove", this._bound_update_cursor);
      this._bound_update_cursor = null;
    }
    if (this._bound_check_cursor_over_image) {
      stage.off("pointermove", this._bound_check_cursor_over_image);
      this._bound_check_cursor_over_image = null;
    }
    this.image_editor_context.image_container.off("pointerenter");
    this.image_editor_context.image_container.off("pointerleave");
    this.cursor_position_check_timeout = clear_timeout(
      this.cursor_position_check_timeout
    );
  }
  /**
   * initializes the cursor for the brush tool.
   */
  initialize_cursor() {
    if (this.cursor_container) {
      if (this.cursor_container.parent) {
        this.cursor_container.parent.removeChild(this.cursor_container);
      }
      this.cursor_container.destroy({ children: true });
      this.cursor_container = null;
    }
    this.cursor_container = new Container();
    this.image_editor_context.ui_container.addChild(this.cursor_container);
    this.cursor_graphics = new Graphics();
    this.cursor_container.addChild(this.cursor_graphics);
    this.update_cursor_appearance();
  }
  /**
   * updates the appearance of the cursor.
   */
  update_cursor_appearance() {
    if (!this.cursor_graphics)
      return;
    this.cursor_graphics.clear();
    const cursor_color = this.state.mode === "draw" ? tinycolor(this.state.color).toString() : 16777215;
    this.cursor_graphics.circle(0, 0, this.state.brush_size * this.scale).stroke({
      width: 1.5,
      color: cursor_color,
      alpha: 0.8
    });
    this.cursor_graphics.circle(0, 0, 1).fill({
      color: cursor_color,
      alpha: 0.8
    });
  }
  /**
   * updates the position of the cursor.
   * @param {FederatedPointerEvent} event - The pointer event.
   */
  update_cursor_position(event) {
    if (!this.cursor_container)
      return;
    const local_pos = this.image_editor_context.image_container.toLocal(
      event.global
    );
    const ui_pos = this.image_editor_context.ui_container.toLocal(
      this.image_editor_context.image_container.toGlobal(local_pos)
    );
    this.cursor_container.position.set(ui_pos.x, ui_pos.y);
  }
  /**
   * checks if the cursor is over the image container.
   * @param {FederatedPointerEvent} event - The pointer event.
   */
  check_cursor_over_image(event) {
    if (this.cursor_position_check_timeout !== null) {
      window.clearTimeout(this.cursor_position_check_timeout);
      this.cursor_position_check_timeout = null;
    }
    const image_container = this.image_editor_context.image_container;
    const bounds = image_container.getBounds();
    const was_over_image = this.is_cursor_over_image;
    this.is_cursor_over_image = event.global.x >= bounds.x && event.global.x <= bounds.x + bounds.width && event.global.y >= bounds.y && event.global.y <= bounds.y + bounds.height;
    if (was_over_image !== this.is_cursor_over_image) {
      this.update_cursor_and_preview_visibility();
    }
  }
  /**
   * updates the size of the cursor.
   */
  update_cursor_size() {
    this.update_cursor_appearance();
  }
  /**
   * Updates whether brush or erase tool is active
   */
  set_active(is_active) {
    this.is_brush_or_erase_active = is_active;
    this.update_cursor_and_preview_visibility();
  }
  /**
   * updates the visibility of the cursor.
   */
  update_cursor_visibility() {
    if (this.cursor_container) {
      this.cursor_container.visible = this.is_cursor_over_image && this.is_brush_or_erase_active;
    }
  }
  /**
   * Shows or hides the brush preview.
   * @param {boolean} show - Whether to show the preview.
   */
  preview_brush(show) {
    this.is_preview_visible = show;
    if (this.brush_preview_container) {
      this.brush_preview_container.visible = show && this.is_brush_or_erase_active;
    }
    if (show) {
      this.update_brush_preview();
      this.update_brush_preview_position();
    }
  }
  /**
   * initializes the brush preview.
   */
  initialize_brush_preview() {
    if (this.brush_preview_container) {
      if (this.brush_preview_container.parent) {
        this.brush_preview_container.parent.removeChild(
          this.brush_preview_container
        );
      }
      this.brush_preview_container.destroy({ children: true });
      this.brush_preview_container = null;
    }
    this.brush_preview_container = new Container();
    this.image_editor_context.ui_container.addChild(
      this.brush_preview_container
    );
    this.brush_preview_graphics = new Graphics();
    this.brush_preview_container.addChild(this.brush_preview_graphics);
    this.brush_preview_container.visible = false;
  }
  /**
   * updates the brush preview appearance.
   */
  update_brush_preview() {
    if (!this.brush_preview_graphics)
      return;
    this.brush_preview_graphics.clear();
    const preview_size = this.state.brush_size * this.scale;
    const preview_color = this.state.mode === "draw" ? tinycolor(this.state.color).setAlpha(this.state.opacity).toString() : 16777215;
    this.brush_preview_graphics.circle(0, 0, preview_size).fill({
      color: preview_color,
      alpha: this.state.mode === "draw" ? this.state.opacity : 0.3
    });
    this.brush_preview_graphics.circle(0, 0, preview_size + 1).stroke({
      width: 1,
      color: 0,
      alpha: 0.5
    });
  }
  /**
   * updates the position of the brush preview to center of canvas.
   */
  update_brush_preview_position() {
    if (!this.brush_preview_container)
      return;
    const image_container = this.image_editor_context.image_container;
    const center_x = image_container.width / 2;
    const center_y = image_container.height / 2;
    const global_pos = image_container.toGlobal({ x: center_x, y: center_y });
    const ui_pos = this.image_editor_context.ui_container.toLocal(global_pos);
    this.brush_preview_container.position.set(ui_pos.x, ui_pos.y);
  }
  /**
   * Called when the pointer enters the image container.
   */
  on_image_container_pointer_enter() {
    this.is_cursor_over_image = true;
    this.update_cursor_and_preview_visibility();
  }
  /**
   * Called when the pointer leaves the image container.
   */
  on_image_container_pointer_leave() {
    this.is_cursor_over_image = false;
    this.update_cursor_and_preview_visibility();
  }
  /**
   * Updates both cursor and preview visibility based on cursor position.
   */
  update_cursor_and_preview_visibility() {
    this.update_cursor_visibility();
    if (this.brush_preview_container) {
      this.brush_preview_container.visible = this.is_preview_visible && this.is_brush_or_erase_active;
    }
  }
  /**
   * Cleans up all cursor resources.
   */
  cleanup() {
    this.is_brush_or_erase_active = false;
    if (this.cursor_container) {
      if (this.cursor_container.parent) {
        this.cursor_container.parent.removeChild(this.cursor_container);
      }
      this.cursor_container.destroy({ children: true });
      this.cursor_container = null;
    }
    if (this.brush_preview_container) {
      if (this.brush_preview_container.parent) {
        this.brush_preview_container.parent.removeChild(
          this.brush_preview_container
        );
      }
      this.brush_preview_container.destroy({ children: true });
      this.brush_preview_container = null;
    }
    if (this.cursor_position_check_timeout !== null) {
      window.clearTimeout(this.cursor_position_check_timeout);
      this.cursor_position_check_timeout = null;
    }
  }
  /**
   * Updates the brush state.
   */
  update_state(state, scale) {
    this.state = state;
    this.scale = scale;
    this.update_cursor_appearance();
    if (this.is_preview_visible) {
      this.update_brush_preview();
    }
  }
}
class BrushCommand {
  constructor(context2, layer_id, original_texture, final_texture) {
    this.context = context2;
    this.name = "Draw";
    this.layer_id = layer_id;
    this.original_texture = this.createTextureFrom(original_texture);
    this.final_texture = this.createTextureFrom(final_texture);
  }
  layer_id;
  original_texture;
  final_texture;
  name;
  /**
   * Creates a new texture with the same content as the source texture
   */
  createTextureFrom(source2) {
    const texture = RenderTexture.create({
      width: source2.width,
      height: source2.height,
      resolution: window.devicePixelRatio || 1
    });
    const sprite = new Sprite(source2);
    const container = new Container();
    container.addChild(sprite);
    this.context.app.renderer.render(container, {
      renderTexture: texture
    });
    container.destroy({ children: true });
    return texture;
  }
  async execute() {
    const layer_textures = this.context.layer_manager.get_layer_textures(
      this.layer_id
    );
    if (!layer_textures)
      return;
    const temp_sprite = new Sprite(this.final_texture);
    const temp_container = new Container();
    temp_container.addChild(temp_sprite);
    this.context.app.renderer.render(temp_container, {
      renderTexture: layer_textures.draw
    });
    temp_container.destroy({ children: true });
  }
  async undo() {
    const layer_textures = this.context.layer_manager.get_layer_textures(
      this.layer_id
    );
    if (!layer_textures)
      return;
    const temp_sprite = new Sprite(this.original_texture);
    const temp_container = new Container();
    temp_container.addChild(temp_sprite);
    this.context.app.renderer.render(temp_container, {
      renderTexture: layer_textures.draw
    });
    temp_container.destroy({ children: true });
  }
}
class BrushTextures {
  constructor(image_editor_context, app) {
    this.image_editor_context = image_editor_context;
    this.app = app;
    this.dimensions = {
      width: this.image_editor_context.image_container.width,
      height: this.image_editor_context.image_container.height
    };
  }
  stroke_texture = null;
  erase_texture = null;
  display_container = null;
  stroke_container = null;
  stroke_graphics = null;
  preview_sprite = null;
  erase_graphics = null;
  dimensions;
  is_new_stroke = true;
  current_opacity = 1;
  current_mode = "draw";
  original_layer_texture = null;
  active_layer_id = null;
  /**
   * Initializes textures needed for the brush tool.
   */
  initialize_textures() {
    this.cleanup_textures();
    const local_bounds = this.image_editor_context.image_container.getLocalBounds();
    this.dimensions = {
      width: local_bounds.width,
      height: local_bounds.height
    };
    this.stroke_texture = RenderTexture.create({
      width: this.dimensions.width,
      height: this.dimensions.height,
      resolution: window.devicePixelRatio || 1
    });
    this.erase_texture = RenderTexture.create({
      width: this.dimensions.width,
      height: this.dimensions.height,
      resolution: window.devicePixelRatio || 1
    });
    this.display_container = new Container();
    const active_layer = this.image_editor_context.layer_manager.get_active_layer();
    if (active_layer) {
      active_layer.addChild(this.display_container);
    } else {
      this.image_editor_context.image_container.addChild(
        this.display_container
      );
    }
    this.stroke_container = new Container();
    this.stroke_graphics = new Graphics();
    this.stroke_container.addChild(this.stroke_graphics);
    this.erase_graphics = new Graphics();
    this.preview_sprite = new Sprite(this.stroke_texture);
    this.preview_sprite.alpha = 0;
    this.display_container.addChild(this.preview_sprite);
    const clear_container = new Container();
    this.app.renderer.render(clear_container, {
      renderTexture: this.stroke_texture
    });
    this.app.renderer.render(clear_container, {
      renderTexture: this.erase_texture
    });
    clear_container.destroy();
    this.is_new_stroke = true;
    this.current_opacity = 1;
  }
  /**
   * Reinitializes textures when needed (e.g., after resizing).
   */
  reinitialize() {
    if (this.image_editor_context.image_container.width !== this.dimensions.width || this.image_editor_context.image_container.height !== this.dimensions.height) {
      this.initialize_textures();
    }
  }
  /**
   * Cleans up texture resources.
   */
  cleanup_textures() {
    if (this.stroke_texture) {
      this.stroke_texture.destroy();
      this.stroke_texture = null;
    }
    if (this.erase_texture) {
      this.erase_texture.destroy();
      this.erase_texture = null;
    }
    if (this.display_container) {
      if (this.display_container.parent) {
        this.display_container.parent.removeChild(this.display_container);
      }
      this.display_container.destroy({ children: true });
      this.display_container = null;
    }
    if (this.original_layer_texture) {
      this.original_layer_texture.destroy();
      this.original_layer_texture = null;
    }
    this.stroke_container = null;
    this.stroke_graphics = null;
    this.preview_sprite = null;
    this.erase_graphics = null;
    this.active_layer_id = null;
  }
  /**
   * Preserve the canvas state when starting a new stroke.
   */
  preserve_canvas_state() {
    const active_layer = this.image_editor_context.layer_manager.get_active_layer();
    if (!active_layer)
      return;
    const layers = this.image_editor_context.layer_manager.get_layers();
    const layer = layers.find((l2) => l2.container === active_layer);
    if (!layer)
      return;
    this.active_layer_id = layer.id;
    const layer_textures = this.image_editor_context.layer_manager.get_layer_textures(layer.id);
    if (!layer_textures)
      return;
    if (this.original_layer_texture) {
      this.original_layer_texture.destroy();
    }
    this.original_layer_texture = RenderTexture.create({
      width: this.dimensions.width,
      height: this.dimensions.height,
      resolution: window.devicePixelRatio || 1
    });
    const temp_sprite = new Sprite(layer_textures.draw);
    const temp_container = new Container();
    temp_container.addChild(temp_sprite);
    this.app.renderer.render(temp_container, {
      renderTexture: this.original_layer_texture
    });
    temp_container.destroy({ children: true });
    this.is_new_stroke = true;
  }
  /**
   * Resets the eraser mask.
   */
  reset_eraser_mask() {
    if (!this.erase_graphics || !this.erase_texture)
      return;
    this.erase_graphics.clear();
    this.erase_graphics.beginFill(16777215, 1);
    this.erase_graphics.drawRect(
      0,
      0,
      this.dimensions.width,
      this.dimensions.height
    );
    this.erase_graphics.endFill();
    this.app.renderer.render(this.erase_graphics, {
      renderTexture: this.erase_texture
    });
  }
  /**
   * Commits the current stroke to the active layer and returns a command for undo/redo.
   */
  commit_stroke() {
    if (!this.stroke_texture || !this.preview_sprite || !this.stroke_graphics || !this.original_layer_texture || !this.active_layer_id)
      return;
    this.preview_sprite.visible = false;
    const active_layer = this.image_editor_context.layer_manager.get_active_layer();
    if (!active_layer)
      return;
    const layers = this.image_editor_context.layer_manager.get_layers();
    const layer = layers.find((l2) => l2.container === active_layer);
    if (!layer)
      return;
    if (layer.id !== this.active_layer_id)
      return;
    const layer_textures = this.image_editor_context.layer_manager.get_layer_textures(layer.id);
    if (!layer_textures)
      return;
    const currentOpacity = this.current_opacity;
    if (this.current_mode === "draw") {
      const temp_container = new Container();
      const base_sprite = new Sprite(layer_textures.draw);
      temp_container.addChild(base_sprite);
      const stroke_sprite = new Sprite(this.stroke_texture);
      stroke_sprite.alpha = currentOpacity;
      temp_container.addChild(stroke_sprite);
      this.app.renderer.render(temp_container, {
        renderTexture: layer_textures.draw
      });
      temp_container.destroy({ children: true });
    } else {
      if (!this.stroke_texture)
        return;
      const erase_container = new Container();
      const content_sprite = new Sprite(layer_textures.draw);
      erase_container.addChild(content_sprite);
      const mask_sprite = new Sprite(this.stroke_texture);
      erase_container.setMask({ mask: mask_sprite, inverse: true });
      this.app.renderer.render(erase_container, {
        renderTexture: layer_textures.draw
      });
      erase_container.destroy({ children: true });
    }
    const final_texture = RenderTexture.create({
      width: this.dimensions.width,
      height: this.dimensions.height,
      resolution: window.devicePixelRatio || 1
    });
    const final_container = new Container();
    const final_sprite = new Sprite(layer_textures.draw);
    final_container.addChild(final_sprite);
    this.app.renderer.render(final_container, {
      renderTexture: final_texture
    });
    final_container.destroy({ children: true });
    const brush_command = new BrushCommand(
      this.image_editor_context,
      this.active_layer_id,
      this.original_layer_texture,
      final_texture
    );
    if (this.stroke_graphics) {
      this.stroke_graphics.clear();
    }
    const clear_container = new Container();
    this.app.renderer.render(clear_container, {
      renderTexture: this.stroke_texture
    });
    clear_container.destroy();
    this.is_new_stroke = true;
    final_texture.destroy();
    this.original_layer_texture = null;
    this.active_layer_id = null;
    this.image_editor_context.command_manager.execute(brush_command);
  }
  /**
   * Calculates the distance between two points.
   */
  calculateDistance(x1, y1, x2, y2) {
    return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
  }
  /**
   * Draws a segment for the current stroke using a simple "stamp" approach.
   */
  draw_segment(from_x, from_y, to_x, to_y, size, color, opacity, mode) {
    if (!this.stroke_graphics || !this.stroke_texture || !this.stroke_container || !this.preview_sprite)
      return;
    if (this.is_new_stroke && !this.original_layer_texture) {
      this.preserve_canvas_state();
    }
    this.current_mode = mode;
    this.current_opacity = mode === "draw" ? Math.min(Math.max(opacity, 0), 1) : 0.5;
    const scaled_size = size;
    if (this.is_new_stroke) {
      this.stroke_graphics.clear();
      const clear_container = new Container();
      this.app.renderer.render(clear_container, {
        renderTexture: this.stroke_texture
      });
      clear_container.destroy();
      this.is_new_stroke = false;
    }
    if (mode === "draw") {
      let colorValue = 16777215;
      try {
        if (color.startsWith("#")) {
          colorValue = parseInt(color.replace("#", "0x"), 16);
        }
      } catch (e2) {
        colorValue = 16777215;
      }
      this.stroke_graphics.setFillStyle({
        color: colorValue,
        alpha: 1
      });
    } else {
      this.stroke_graphics.setFillStyle({
        color: 16777215,
        alpha: 1
      });
    }
    const distance = this.calculateDistance(from_x, from_y, to_x, to_y);
    if (distance < 0.1) {
      this.stroke_graphics.circle(from_x, from_y, scaled_size).fill();
    } else {
      const spacing = Math.max(scaled_size / 3, 2);
      const steps = Math.max(Math.ceil(distance / spacing), 2);
      for (let i2 = 0; i2 < steps; i2++) {
        const t2 = i2 / (steps - 1);
        const x2 = from_x + (to_x - from_x) * t2;
        const y2 = from_y + (to_y - from_y) * t2;
        this.stroke_graphics.circle(x2, y2, scaled_size).fill();
      }
    }
    this.stroke_graphics.endFill();
    this.app.renderer.render(this.stroke_container, {
      renderTexture: this.stroke_texture
    });
    if (mode === "draw") {
      this.preview_sprite.texture = this.stroke_texture;
      this.preview_sprite.alpha = this.current_opacity;
      this.preview_sprite.tint = 16777215;
    } else {
      const active_layer = this.image_editor_context.layer_manager.get_active_layer();
      if (!active_layer)
        return;
      const layers = this.image_editor_context.layer_manager.get_layers();
      const layer = layers.find((l2) => l2.container === active_layer);
      if (!layer)
        return;
      const layer_textures = this.image_editor_context.layer_manager.get_layer_textures(layer.id);
      if (!layer_textures)
        return;
      const preview_texture = RenderTexture.create({
        width: this.dimensions.width,
        height: this.dimensions.height,
        resolution: window.devicePixelRatio || 1
      });
      const base_container = new Container();
      const content_sprite = new Sprite(layer_textures.draw);
      base_container.addChild(content_sprite);
      this.app.renderer.render(base_container, {
        renderTexture: preview_texture
      });
      base_container.destroy({ children: true });
      const preview_container = new Container();
      const mask_sprite = new Sprite(this.stroke_texture);
      const overlay = new Graphics();
      overlay.setFillStyle({ color: 16777215, alpha: 0.5 });
      overlay.rect(0, 0, this.dimensions.width, this.dimensions.height).fill();
      overlay.setMask({ mask: mask_sprite, inverse: false });
      preview_container.addChild(overlay);
      this.app.renderer.render(preview_container, {
        renderTexture: preview_texture
      });
      this.preview_sprite.texture = preview_texture;
      this.preview_sprite.alpha = 1;
      preview_container.destroy({ children: true });
      preview_texture.destroy();
    }
    this.preview_sprite.visible = true;
  }
  /**
   * Gets current dimensions of the texture.
   */
  get_dimensions() {
    return this.dimensions;
  }
  /**
   * Cleanup all resources.
   */
  cleanup() {
    this.cleanup_textures();
  }
}
class BrushTool {
  /**
   * The name of the tool.
   * @type {string}
   */
  name = "brush";
  /**
   * The context of the image editor.
   * @private
   */
  image_editor_context;
  /**
   * The current tool selected in the toolbar.
   * @private
   */
  current_tool;
  /**
   * The current subtool selected in the toolbar.
   * @private
   */
  current_subtool;
  /**
   * The state of the brush tool.
   * @private
   */
  state = {
    opacity: 1,
    brush_size: 10,
    color: "#000000",
    mode: "draw"
  };
  /**
   * Size settings for brush and eraser
   * @private
   */
  brush_size = 10;
  eraser_size = 20;
  /**
   * Drawing state
   * @private
   */
  is_drawing = false;
  last_x = 0;
  last_y = 0;
  scale = 1;
  /**
   * Event listeners
   * @private
   */
  _bound_pointer_down = null;
  _bound_pointer_move = null;
  _bound_pointer_up = null;
  event_callbacks = /* @__PURE__ */ new Map();
  /**
   * Utility modules
   * @private
   */
  brush_cursor = null;
  brush_textures = null;
  /**
   * Sets up the brush tool with the given context, tool, and subtool.
   * @param {ImageEditorContext} context - The image editor context.
   * @param {ToolbarTool} tool - The tool from the toolbar.
   * @param {Subtool} subtool - The subtool from the toolbar.
   * @returns {Promise<void>}
   */
  async setup(context2, tool, subtool) {
    this.image_editor_context = context2;
    this.current_tool = tool;
    this.current_subtool = subtool;
    this.state.mode = tool === "erase" ? "erase" : "draw";
    if (this.state.mode === "draw") {
      this.state.brush_size = this.brush_size;
    } else {
      this.state.brush_size = this.eraser_size;
    }
    context2.scale.subscribe((scale) => {
      this.scale = scale;
      if (this.brush_cursor) {
        this.brush_cursor.update_state(this.state, this.scale);
      }
    });
    this.brush_cursor = new BrushCursor(
      this.image_editor_context,
      this.state,
      this.scale
    );
    this.brush_cursor.set_active(tool === "draw" || tool === "erase");
    this.brush_textures = new BrushTextures(
      this.image_editor_context,
      context2.app
    );
    this.brush_textures.initialize_textures();
    this.setup_event_listeners();
    this.handle_cursors(tool);
  }
  /**
   * Handles cursor styles for the brush tool.
   * @param {ToolbarTool} tool - The current tool.
   * @private
   */
  handle_cursors(tool) {
    recurse_set_cursor(
      this.image_editor_context.image_container.children,
      "none"
    );
  }
  /**
   * Sets the current tool and subtool.
   * @param {ToolbarTool} tool - The current tool.
   * @param {Subtool} subtool - The current subtool.
   */
  set_tool(tool, subtool) {
    this.current_tool = tool;
    this.current_subtool = subtool;
    if (this.current_tool !== "erase" && this.current_tool !== "draw") {
      this.commit_pending_changes();
    }
    if (this.brush_cursor) {
      this.brush_cursor.set_active(tool === "draw" || tool === "erase");
    }
    const new_mode = tool === "erase" ? "erase" : "draw";
    if (tool === "erase" || tool === "draw") {
      this.brush_textures?.initialize_textures();
    }
    if (this.state.mode !== new_mode) {
      this.state.mode = new_mode;
      if (this.state.mode === "draw") {
        this.state.brush_size = this.brush_size;
      } else {
        this.state.brush_size = this.eraser_size;
      }
      if (this.brush_cursor) {
        this.brush_cursor.update_state(this.state, this.scale);
      }
    }
  }
  /**
   * Commits any pending changes to the canvas.
   * @private
   */
  commit_pending_changes() {
    if (this.is_drawing) {
      this.on_pointer_up();
    }
  }
  /**
   * Called when the user presses the mouse button.
   * @param {FederatedPointerEvent} event - The pointer event.
   * @private
   */
  on_pointer_down(event) {
    const current_layer = this.image_editor_context.layer_manager.get_active_layer();
    if (!current_layer?.visible || this.current_tool !== "erase" && this.current_tool !== "draw") {
      return;
    }
    if (this.brush_cursor && !this.brush_cursor.is_over_image())
      return;
    if (this.brush_textures) {
      this.brush_textures.preserve_canvas_state();
    }
    const local_pos = this.image_editor_context.image_container.toLocal(
      event.global
    );
    this.is_drawing = true;
    this.last_x = local_pos.x;
    this.last_y = local_pos.y;
    if (this.brush_textures) {
      this.brush_textures.draw_segment(
        local_pos.x,
        local_pos.y,
        local_pos.x,
        local_pos.y,
        this.state.brush_size,
        this.state.color,
        this.state.opacity,
        this.state.mode
      );
    }
  }
  /**
   * Called when the user moves the mouse while drawing.
   * @param {FederatedPointerEvent} event - The pointer event.
   * @private
   */
  on_pointer_move(event) {
    if (this.brush_cursor) {
      this.brush_cursor.update_cursor_position(event);
    }
    if (!this.is_drawing)
      return;
    const local_pos = this.image_editor_context.image_container.toLocal(
      event.global
    );
    if (this.brush_textures) {
      this.brush_textures.draw_segment(
        this.last_x,
        this.last_y,
        local_pos.x,
        local_pos.y,
        this.state.brush_size,
        this.state.color,
        this.state.opacity,
        this.state.mode
      );
    }
    this.last_x = local_pos.x;
    this.last_y = local_pos.y;
  }
  /**
   * Called when the user releases the mouse button.
   * @private
   */
  on_pointer_up() {
    if (!this.is_drawing)
      return;
    this.is_drawing = false;
    if (this.brush_textures) {
      this.brush_textures.commit_stroke();
    }
    this.notify("change");
  }
  /**
   * Sets up event listeners for drawing.
   * @private
   */
  setup_event_listeners() {
    this.cleanup_event_listeners();
    this._bound_pointer_down = this.on_pointer_down.bind(this);
    this._bound_pointer_move = this.on_pointer_move.bind(this);
    this._bound_pointer_up = this.on_pointer_up.bind(this);
    const image_container = this.image_editor_context.image_container;
    image_container.eventMode = "static";
    image_container.interactiveChildren = true;
    const stage = this.image_editor_context.app.stage;
    stage.eventMode = "static";
    stage.on("pointerdown", this._bound_pointer_down);
    stage.on("pointermove", this._bound_pointer_move);
    stage.on("pointerup", this._bound_pointer_up);
    stage.on("pointerupoutside", this._bound_pointer_up);
    if (this.brush_cursor) {
      this.brush_cursor.setup_event_listeners();
    }
  }
  /**
   * Cleans up event listeners.
   * @private
   */
  cleanup_event_listeners() {
    const stage = this.image_editor_context.app.stage;
    if (this._bound_pointer_down) {
      stage.off("pointerdown", this._bound_pointer_down);
      this._bound_pointer_down = null;
    }
    if (this._bound_pointer_move) {
      stage.off("pointermove", this._bound_pointer_move);
      this._bound_pointer_move = null;
    }
    if (this._bound_pointer_up) {
      stage.off("pointerup", this._bound_pointer_up);
      stage.off("pointerupoutside", this._bound_pointer_up);
      this._bound_pointer_up = null;
    }
    if (this.brush_cursor) {
      this.brush_cursor.cleanup_event_listeners();
    }
  }
  /**
   * Sets the brush size.
   * @param {number} size - The new brush size.
   */
  set_brush_size(size) {
    this.brush_size = size;
    if (this.state.mode === "draw") {
      this.state.brush_size = size;
      if (this.brush_cursor) {
        this.brush_cursor.update_state(this.state, this.scale);
      }
    }
  }
  /**
   * Sets the brush color.
   * @param {string|ColorInput} color - The new brush color.
   */
  set_brush_color(color) {
    const color_string = tinycolor(color).toHexString();
    this.state.color = color_string;
    if (this.brush_cursor) {
      this.brush_cursor.update_state(this.state, this.scale);
    }
  }
  /**
   * Sets the brush opacity.
   * @param {number} opacity - The new brush opacity.
   */
  set_brush_opacity(opacity) {
    const clamped_opacity = Math.max(0, Math.min(1, opacity));
    this.state.opacity = clamped_opacity;
    if (this.brush_cursor) {
      this.brush_cursor.update_state(this.state, this.scale);
    }
  }
  /**
   * Sets the eraser size.
   * @param {number} size - The new eraser size.
   */
  set_eraser_size(size) {
    this.eraser_size = size;
    if (this.state.mode === "erase") {
      this.state.brush_size = size;
      if (this.brush_cursor) {
        this.brush_cursor.update_state(this.state, this.scale);
      }
    }
  }
  /**
   * Gets the current size based on mode (brush or eraser).
   * @returns {number} The current size.
   */
  get_current_size() {
    return this.state.mode === "draw" ? this.brush_size : this.eraser_size;
  }
  /**
   * Shows or hides the brush preview.
   * @param {boolean} show - Whether to show the preview.
   */
  preview_brush(show) {
    if (this.brush_cursor) {
      this.brush_cursor.preview_brush(show);
    }
  }
  /**
   * Cleans up resources used by the brush tool.
   */
  cleanup() {
    this.commit_pending_changes();
    this.cleanup_event_listeners();
    if (this.brush_textures) {
      this.brush_textures.cleanup();
      this.brush_textures = null;
    }
    if (this.brush_cursor) {
      this.brush_cursor.cleanup();
      this.brush_cursor = null;
    }
  }
  on(event, callback) {
    this.event_callbacks.set(event, [
      ...this.event_callbacks.get(event) || [],
      callback
    ]);
  }
  off(event, callback) {
    this.event_callbacks.set(
      event,
      this.event_callbacks.get(event)?.filter((cb) => cb !== callback) || []
    );
  }
  notify(event) {
    for (const callback of this.event_callbacks.get(event) || []) {
      callback();
    }
  }
}
const css$4 = {
  code: ".add-layer.svelte-1peog37.svelte-1peog37.svelte-1peog37.svelte-1peog37{display:flex;justify-content:center;align-items:center;margin:var(--spacing-sm) 0 0 0}.add-layer.svelte-1peog37 button{width:100%}.icon.svelte-1peog37.svelte-1peog37.svelte-1peog37.svelte-1peog37{width:14px;color:var(--body-text-color);transition:color 0.15s ease}.layer-wrap.svelte-1peog37.svelte-1peog37.svelte-1peog37.svelte-1peog37{display:flex;justify-content:center;align-items:center;width:100%;flex-direction:column}.layer-wrap.svelte-1peog37 button.svelte-1peog37.svelte-1peog37.svelte-1peog37{justify-content:space-between;align-items:center;width:100%;display:flex;font-size:var(--text-sm);line-height:var(--line-sm);transition:all 0.15s ease;padding:var(--spacing-md) var(--spacing-lg);border-radius:var(--radius-sm)}button.layer-title-button.svelte-1peog37.svelte-1peog37.svelte-1peog37.svelte-1peog37{width:100%}.layer-wrap.svelte-1peog37 button:hover .icon.svelte-1peog37.svelte-1peog37.svelte-1peog37{color:var(--color-accent)}.selected_layer.svelte-1peog37.svelte-1peog37.svelte-1peog37.svelte-1peog37{color:var(--color-accent);font-weight:var(--weight-semibold)}ul.svelte-1peog37.svelte-1peog37.svelte-1peog37.svelte-1peog37{bottom:0;right:0;width:100%;list-style:none;z-index:var(--layer-top);padding:var(--spacing-sm);border-top:1px solid var(--border-color-primary)}li.svelte-1peog37.svelte-1peog37.svelte-1peog37.svelte-1peog37{display:flex;justify-content:space-between;align-items:center;transition:background-color 0.15s ease;border-bottom:1px solid var(--border-color-primary)}.layer-wrap.svelte-1peog37 ul.svelte-1peog37>li.svelte-1peog37>button.svelte-1peog37{padding-left:calc(var(--spacing-md))}li.svelte-1peog37.svelte-1peog37.svelte-1peog37.svelte-1peog37:hover{background-color:var(--background-fill-secondary)}li.svelte-1peog37.svelte-1peog37.svelte-1peog37.svelte-1peog37:last-child{border-bottom:none}li.svelte-1peog37.svelte-1peog37.svelte-1peog37.svelte-1peog37:last-child:hover{background-color:unset}li.svelte-1peog37 div.svelte-1peog37.svelte-1peog37.svelte-1peog37{display:flex;gap:var(--spacing-sm);padding:var(--spacing-sm)}li.svelte-1peog37>button.svelte-1peog37.svelte-1peog37.svelte-1peog37{padding:var(--spacing-sm) var(--spacing-md)}",
  map: '{"version":3,"file":"Layers.svelte","sources":["Layers.svelte"],"sourcesContent":["<script lang=\\"ts\\">import { click_outside } from \\"./utils/events\\";\\nimport { Layers, Clear, ArrowUp, ArrowDown, Plus, Visibility, VisibilityOff } from \\"@gradio/icons\\";\\nimport { IconButton } from \\"@gradio/atoms\\";\\nimport { createEventDispatcher } from \\"svelte\\";\\nconst dispatch = createEventDispatcher();\\nexport let layers;\\nexport let enable_additional_layers = true;\\nexport let enable_layers = true;\\nexport let show_layers = false;\\nfunction new_layer() {\\n    dispatch(\\"new_layer\\");\\n}\\nfunction change_layer(id) {\\n    dispatch(\\"change_layer\\", id);\\n    show_layers = false;\\n}\\nfunction move_layer(id, direction) {\\n    dispatch(\\"move_layer\\", { id, direction });\\n}\\nfunction delete_layer(id) {\\n    dispatch(\\"delete_layer\\", id);\\n}\\n<\/script>\\n\\n{#if enable_layers}\\n\\t<div\\n\\t\\tclass=\\"layer-wrap\\"\\n\\t\\tclass:closed={!show_layers}\\n\\t\\tuse:click_outside={() => (show_layers = false)}\\n\\t>\\n\\t\\t<button\\n\\t\\t\\tclass=\\"layer-title-button\\"\\n\\t\\t\\taria-label=\\"Show Layers\\"\\n\\t\\t\\ton:click|stopPropagation={() => (show_layers = !show_layers)}\\n\\t\\t>\\n\\t\\t\\t{show_layers\\n\\t\\t\\t\\t? \\"Layers\\"\\n\\t\\t\\t\\t: $layers.layers.find((l) => l.id === $layers.active_layer)?.name}\\n\\t\\t\\t<span class=\\"icon\\"><Layers /></span>\\n\\t\\t</button>\\n\\t\\t{#if show_layers}\\n\\t\\t\\t<ul>\\n\\t\\t\\t\\t{#each $layers.layers as { id, name, user_created, visible }, i (i)}\\n\\t\\t\\t\\t\\t<li>\\n\\t\\t\\t\\t\\t\\t{#if !visible}\\n\\t\\t\\t\\t\\t\\t\\t<IconButton\\n\\t\\t\\t\\t\\t\\t\\t\\tIcon={VisibilityOff}\\n\\t\\t\\t\\t\\t\\t\\t\\tsize=\\"small\\"\\n\\t\\t\\t\\t\\t\\t\\t\\ton:click={(e) => {\\n\\t\\t\\t\\t\\t\\t\\t\\t\\te.stopPropagation();\\n\\t\\t\\t\\t\\t\\t\\t\\t\\tdispatch(\\"toggle_layer_visibility\\", id);\\n\\t\\t\\t\\t\\t\\t\\t\\t}}\\n\\t\\t\\t\\t\\t\\t\\t/>\\n\\t\\t\\t\\t\\t\\t{:else}\\n\\t\\t\\t\\t\\t\\t\\t<IconButton\\n\\t\\t\\t\\t\\t\\t\\t\\tIcon={Visibility}\\n\\t\\t\\t\\t\\t\\t\\t\\tsize=\\"small\\"\\n\\t\\t\\t\\t\\t\\t\\t\\ton:click={(e) => {\\n\\t\\t\\t\\t\\t\\t\\t\\t\\te.stopPropagation();\\n\\t\\t\\t\\t\\t\\t\\t\\t\\tdispatch(\\"toggle_layer_visibility\\", id);\\n\\t\\t\\t\\t\\t\\t\\t\\t}}\\n\\t\\t\\t\\t\\t\\t\\t/>\\n\\t\\t\\t\\t\\t\\t{/if}\\n\\t\\t\\t\\t\\t\\t<button\\n\\t\\t\\t\\t\\t\\t\\tclass:selected_layer={$layers.active_layer === id}\\n\\t\\t\\t\\t\\t\\t\\taria-label={`layer-${i + 1}`}\\n\\t\\t\\t\\t\\t\\t\\ton:click|stopPropagation={() => change_layer(id)}>{name}</button\\n\\t\\t\\t\\t\\t\\t>\\n\\t\\t\\t\\t\\t\\t{#if $layers.layers.length > 1}\\n\\t\\t\\t\\t\\t\\t\\t<div>\\n\\t\\t\\t\\t\\t\\t\\t\\t{#if i > 0}\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<IconButton\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\ton:click={(e) => {\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t\\te.stopPropagation();\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tmove_layer(id, \\"up\\");\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t}}\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tIcon={ArrowUp}\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tsize=\\"x-small\\"\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t/>\\n\\t\\t\\t\\t\\t\\t\\t\\t{/if}\\n\\t\\t\\t\\t\\t\\t\\t\\t{#if i < $layers.layers.length - 1}\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<IconButton\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\ton:click={(e) => {\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t\\te.stopPropagation();\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tmove_layer(id, \\"down\\");\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t}}\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tIcon={ArrowDown}\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tsize=\\"x-small\\"\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t/>\\n\\t\\t\\t\\t\\t\\t\\t\\t{/if}\\n\\t\\t\\t\\t\\t\\t\\t\\t{#if $layers.layers.length > 1 && user_created}\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t<IconButton\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\ton:click={(e) => {\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t\\te.stopPropagation();\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tdelete_layer(id);\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\t}}\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tIcon={Clear}\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\tsize=\\"x-small\\"\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t/>\\n\\t\\t\\t\\t\\t\\t\\t\\t{/if}\\n\\t\\t\\t\\t\\t\\t\\t</div>\\n\\t\\t\\t\\t\\t\\t{/if}\\n\\t\\t\\t\\t\\t</li>\\n\\t\\t\\t\\t{/each}\\n\\t\\t\\t\\t{#if enable_additional_layers}\\n\\t\\t\\t\\t\\t<li class=\\"add-layer\\">\\n\\t\\t\\t\\t\\t\\t<IconButton\\n\\t\\t\\t\\t\\t\\t\\tIcon={Plus}\\n\\t\\t\\t\\t\\t\\t\\tlabel=\\"Add Layer\\"\\n\\t\\t\\t\\t\\t\\t\\ton:click={(e) => {\\n\\t\\t\\t\\t\\t\\t\\t\\te.stopPropagation();\\n\\t\\t\\t\\t\\t\\t\\t\\tnew_layer();\\n\\t\\t\\t\\t\\t\\t\\t}}\\n\\t\\t\\t\\t\\t\\t\\tsize=\\"x-small\\"\\n\\t\\t\\t\\t\\t\\t/>\\n\\t\\t\\t\\t\\t</li>\\n\\t\\t\\t\\t{/if}\\n\\t\\t\\t</ul>\\n\\t\\t{/if}\\n\\t</div>\\n{/if}\\n\\n<style>\\n\\t.add-layer {\\n\\t\\tdisplay: flex;\\n\\t\\tjustify-content: center;\\n\\t\\talign-items: center;\\n\\t\\tmargin: var(--spacing-sm) 0 0 0;\\n\\t}\\n\\n\\t.add-layer :global(button) {\\n\\t\\twidth: 100%;\\n\\t}\\n\\t.icon {\\n\\t\\twidth: 14px;\\n\\t\\tcolor: var(--body-text-color);\\n\\t\\ttransition: color 0.15s ease;\\n\\t}\\n\\n\\t.layer-wrap {\\n\\t\\t/* position: absolute; */\\n\\t\\tdisplay: flex;\\n\\t\\tjustify-content: center;\\n\\t\\talign-items: center;\\n\\t\\t/* border: 1px solid var(--border-color-primary); */\\n\\t\\t/* z-index: var(--layer-1); */\\n\\t\\t/* border-radius: var(--radius-sm); */\\n\\t\\t/* background-color: var(--block-background-fill); */\\n\\t\\twidth: 100%;\\n\\t\\tflex-direction: column;\\n\\t\\t/* bottom: 5px; */\\n\\t\\t/* right: 5px; */\\n\\t\\t/* border-bottom: 0;\\n\\t\\tborder-right: 0; */\\n\\t\\t/* box-shadow: var(--shadow-drop); */\\n\\t}\\n\\n\\t.layer-wrap button {\\n\\t\\tjustify-content: space-between;\\n\\t\\talign-items: center;\\n\\t\\twidth: 100%;\\n\\t\\tdisplay: flex;\\n\\t\\tfont-size: var(--text-sm);\\n\\t\\tline-height: var(--line-sm);\\n\\t\\ttransition: all 0.15s ease;\\n\\t\\tpadding: var(--spacing-md) var(--spacing-lg);\\n\\t\\t/* padding-right: var(--spacing-lg); */\\n\\t\\tborder-radius: var(--radius-sm);\\n\\t\\t/* padding-left: 30px; */\\n\\t}\\n\\n\\tbutton.layer-title-button {\\n\\t\\twidth: 100%;\\n\\t\\t/* padding-left: 30px; */\\n\\t}\\n\\n\\t.layer-wrap button:hover .icon {\\n\\t\\tcolor: var(--color-accent);\\n\\t}\\n\\n\\t.selected_layer {\\n\\t\\tcolor: var(--color-accent);\\n\\t\\tfont-weight: var(--weight-semibold);\\n\\t}\\n\\n\\tul {\\n\\t\\t/* position: absolute; */\\n\\t\\tbottom: 0;\\n\\t\\tright: 0;\\n\\t\\t/* background: var(--block-background-fill); */\\n\\t\\twidth: 100%;\\n\\t\\t/* min-width: 100%; */\\n\\t\\tlist-style: none;\\n\\t\\tz-index: var(--layer-top);\\n\\t\\t/* border: 1px solid var(--border-color-primary); */\\n\\t\\t/* border-radius: var(--radius-sm); */\\n\\t\\t/* box-shadow: var(--shadow-drop-lg); */\\n\\t\\tpadding: var(--spacing-sm);\\n\\t\\t/* transform: translate(-1px, 1px); */\\n\\t\\tborder-top: 1px solid var(--border-color-primary);\\n\\t}\\n\\n\\t/* .sep {\\n\\t\\theight: 12px;\\n\\t\\tbackground-color: var(--block-border-color);\\n\\t\\twidth: 1px;\\n\\t\\tdisplay: block;\\n\\t\\tmargin-left: var(--spacing-xl);\\n\\t} */\\n\\n\\tli {\\n\\t\\tdisplay: flex;\\n\\t\\tjustify-content: space-between;\\n\\t\\talign-items: center;\\n\\t\\t/* border-radius: var(--radius-sm); */\\n\\t\\ttransition: background-color 0.15s ease;\\n\\t\\tborder-bottom: 1px solid var(--border-color-primary);\\n\\t}\\n\\n\\t.layer-wrap ul > li > button {\\n\\t\\tpadding-left: calc(var(--spacing-md));\\n\\t}\\n\\n\\tli:hover {\\n\\t\\tbackground-color: var(--background-fill-secondary);\\n\\t}\\n\\n\\tli:last-child {\\n\\t\\tborder-bottom: none;\\n\\t}\\n\\tli:last-child:hover {\\n\\t\\tbackground-color: unset;\\n\\t}\\n\\n\\tli div {\\n\\t\\tdisplay: flex;\\n\\t\\tgap: var(--spacing-sm);\\n\\t\\tpadding: var(--spacing-sm);\\n\\t}\\n\\tli > button {\\n\\t\\tpadding: var(--spacing-sm) var(--spacing-md);\\n\\t}\\n\\n\\t/* li > div > button {\\n\\t\\topacity: 0.7;\\n\\t\\ttransition: opacity 0.15s ease;\\n\\t}\\n\\n\\tli > div > button:hover {\\n\\t\\topacity: 1;\\n\\t} */</style>\\n"],"names":[],"mappings":"AA2HC,sEAAW,CACV,OAAO,CAAE,IAAI,CACb,eAAe,CAAE,MAAM,CACvB,WAAW,CAAE,MAAM,CACnB,MAAM,CAAE,IAAI,YAAY,CAAC,CAAC,CAAC,CAAC,CAAC,CAAC,CAC/B,CAEA,yBAAU,CAAS,MAAQ,CAC1B,KAAK,CAAE,IACR,CACA,iEAAM,CACL,KAAK,CAAE,IAAI,CACX,KAAK,CAAE,IAAI,iBAAiB,CAAC,CAC7B,UAAU,CAAE,KAAK,CAAC,KAAK,CAAC,IACzB,CAEA,uEAAY,CAEX,OAAO,CAAE,IAAI,CACb,eAAe,CAAE,MAAM,CACvB,WAAW,CAAE,MAAM,CAKnB,KAAK,CAAE,IAAI,CACX,cAAc,CAAE,MAMjB,CAEA,0BAAW,CAAC,mDAAO,CAClB,eAAe,CAAE,aAAa,CAC9B,WAAW,CAAE,MAAM,CACnB,KAAK,CAAE,IAAI,CACX,OAAO,CAAE,IAAI,CACb,SAAS,CAAE,IAAI,SAAS,CAAC,CACzB,WAAW,CAAE,IAAI,SAAS,CAAC,CAC3B,UAAU,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,CAC1B,OAAO,CAAE,IAAI,YAAY,CAAC,CAAC,IAAI,YAAY,CAAC,CAE5C,aAAa,CAAE,IAAI,WAAW,CAE/B,CAEA,MAAM,+EAAoB,CACzB,KAAK,CAAE,IAER,CAEA,0BAAW,CAAC,MAAM,MAAM,CAAC,kDAAM,CAC9B,KAAK,CAAE,IAAI,cAAc,CAC1B,CAEA,2EAAgB,CACf,KAAK,CAAE,IAAI,cAAc,CAAC,CAC1B,WAAW,CAAE,IAAI,iBAAiB,CACnC,CAEA,8DAAG,CAEF,MAAM,CAAE,CAAC,CACT,KAAK,CAAE,CAAC,CAER,KAAK,CAAE,IAAI,CAEX,UAAU,CAAE,IAAI,CAChB,OAAO,CAAE,IAAI,WAAW,CAAC,CAIzB,OAAO,CAAE,IAAI,YAAY,CAAC,CAE1B,UAAU,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,sBAAsB,CACjD,CAUA,8DAAG,CACF,OAAO,CAAE,IAAI,CACb,eAAe,CAAE,aAAa,CAC9B,WAAW,CAAE,MAAM,CAEnB,UAAU,CAAE,gBAAgB,CAAC,KAAK,CAAC,IAAI,CACvC,aAAa,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,sBAAsB,CACpD,CAEA,0BAAW,CAAC,iBAAE,CAAG,iBAAE,CAAG,qBAAO,CAC5B,YAAY,CAAE,KAAK,IAAI,YAAY,CAAC,CACrC,CAEA,8DAAE,MAAO,CACR,gBAAgB,CAAE,IAAI,2BAA2B,CAClD,CAEA,8DAAE,WAAY,CACb,aAAa,CAAE,IAChB,CACA,8DAAE,WAAW,MAAO,CACnB,gBAAgB,CAAE,KACnB,CAEA,iBAAE,CAAC,gDAAI,CACN,OAAO,CAAE,IAAI,CACb,GAAG,CAAE,IAAI,YAAY,CAAC,CACtB,OAAO,CAAE,IAAI,YAAY,CAC1B,CACA,iBAAE,CAAG,mDAAO,CACX,OAAO,CAAE,IAAI,YAAY,CAAC,CAAC,IAAI,YAAY,CAC5C"}'
};
const Layers_1 = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $layers, $$unsubscribe_layers;
  createEventDispatcher();
  let { layers } = $$props;
  $$unsubscribe_layers = subscribe(layers, (value) => $layers = value);
  let { enable_additional_layers = true } = $$props;
  let { enable_layers = true } = $$props;
  let { show_layers = false } = $$props;
  if ($$props.layers === void 0 && $$bindings.layers && layers !== void 0)
    $$bindings.layers(layers);
  if ($$props.enable_additional_layers === void 0 && $$bindings.enable_additional_layers && enable_additional_layers !== void 0)
    $$bindings.enable_additional_layers(enable_additional_layers);
  if ($$props.enable_layers === void 0 && $$bindings.enable_layers && enable_layers !== void 0)
    $$bindings.enable_layers(enable_layers);
  if ($$props.show_layers === void 0 && $$bindings.show_layers && show_layers !== void 0)
    $$bindings.show_layers(show_layers);
  $$result.css.add(css$4);
  $$unsubscribe_layers();
  return `${enable_layers ? `<div class="${["layer-wrap svelte-1peog37", !show_layers ? "closed" : ""].join(" ").trim()}"><button class="layer-title-button svelte-1peog37" aria-label="Show Layers">${escape(show_layers ? "Layers" : $layers.layers.find((l2) => l2.id === $layers.active_layer)?.name)} <span class="icon svelte-1peog37">${validate_component(Layers, "Layers").$$render($$result, {}, {}, {})}</span></button> ${show_layers ? `<ul class="svelte-1peog37">${each($layers.layers, ({ id, name, user_created, visible }, i2) => {
    return `<li class="svelte-1peog37">${!visible ? `${validate_component(IconButton$1, "IconButton").$$render($$result, { Icon: VisibilityOff, size: "small" }, {}, {})}` : `${validate_component(IconButton$1, "IconButton").$$render($$result, { Icon: Visibility, size: "small" }, {}, {})}`} <button${add_attribute("aria-label", `layer-${i2 + 1}`, 0)} class="${["svelte-1peog37", $layers.active_layer === id ? "selected_layer" : ""].join(" ").trim()}">${escape(name)}</button> ${$layers.layers.length > 1 ? `<div class="svelte-1peog37">${i2 > 0 ? `${validate_component(IconButton$1, "IconButton").$$render($$result, { Icon: ArrowUp, size: "x-small" }, {}, {})}` : ``} ${i2 < $layers.layers.length - 1 ? `${validate_component(IconButton$1, "IconButton").$$render($$result, { Icon: ArrowDown, size: "x-small" }, {}, {})}` : ``} ${$layers.layers.length > 1 && user_created ? `${validate_component(IconButton$1, "IconButton").$$render($$result, { Icon: Clear, size: "x-small" }, {}, {})}` : ``} </div>` : ``} </li>`;
  })} ${enable_additional_layers ? `<li class="add-layer svelte-1peog37">${validate_component(IconButton$1, "IconButton").$$render(
    $$result,
    {
      Icon: Plus,
      label: "Add Layer",
      size: "x-small"
    },
    {},
    {}
  )}</li>` : ``}</ul>` : ``}</div>` : ``}`;
});
const css$3 = {
  code: ".toolbar-wrap-wrap.svelte-nkklfl{position:absolute;right:0;bottom:0;width:fit-content;max-height:100%;overflow-y:auto;display:flex;flex-direction:column-reverse}.toolbar-wrap.svelte-nkklfl{min-width:110px;display:flex;flex-direction:column;justify-content:center;align-items:center;position:relative;right:0;bottom:0;border:1px solid var(--block-border-color);border-radius:0;border-top-left-radius:var(--radius-md);border-right:none;border-bottom:none;z-index:1000;background-color:var(--block-background-fill)}",
  map: '{"version":3,"file":"SecondaryToolbar.svelte","sources":["SecondaryToolbar.svelte"],"sourcesContent":["<script lang=\\"ts\\">import Layers from \\"./Layers.svelte\\";\\nexport let layers;\\nexport let enable_additional_layers = true;\\nexport let enable_layers = true;\\nexport let show_layers = false;\\n<\/script>\\n\\n<div class=\\"toolbar-wrap-wrap\\">\\n\\t<div class=\\"toolbar-wrap\\">\\n\\t\\t{#if enable_layers}\\n\\t\\t\\t<Layers\\n\\t\\t\\t\\t{layers}\\n\\t\\t\\t\\t{enable_additional_layers}\\n\\t\\t\\t\\t{enable_layers}\\n\\t\\t\\t\\t{show_layers}\\n\\t\\t\\t\\ton:new_layer\\n\\t\\t\\t\\ton:change_layer\\n\\t\\t\\t\\ton:move_layer\\n\\t\\t\\t\\ton:delete_layer\\n\\t\\t\\t\\ton:toggle_layer_visibility\\n\\t\\t\\t/>\\n\\t\\t{/if}\\n\\t</div>\\n</div>\\n\\n<style>\\n\\t.toolbar-wrap-wrap {\\n\\t\\tposition: absolute;\\n\\t\\tright: 0;\\n\\t\\tbottom: 0;\\n\\t\\twidth: fit-content;\\n\\t\\tmax-height: 100%;\\n\\t\\toverflow-y: auto;\\n\\t\\tdisplay: flex;\\n\\t\\tflex-direction: column-reverse;\\n\\t}\\n\\n\\t.toolbar-wrap {\\n\\t\\tmin-width: 110px;\\n\\t\\tdisplay: flex;\\n\\t\\tflex-direction: column;\\n\\t\\tjustify-content: center;\\n\\t\\talign-items: center;\\n\\t\\tposition: relative;\\n\\t\\tright: 0;\\n\\t\\tbottom: 0;\\n\\t\\tborder: 1px solid var(--block-border-color);\\n\\t\\tborder-radius: 0;\\n\\t\\tborder-top-left-radius: var(--radius-md);\\n\\t\\tborder-right: none;\\n\\t\\tborder-bottom: none;\\n\\t\\tz-index: 1000;\\n\\t\\tbackground-color: var(--block-background-fill);\\n\\t}</style>\\n"],"names":[],"mappings":"AA0BC,gCAAmB,CAClB,QAAQ,CAAE,QAAQ,CAClB,KAAK,CAAE,CAAC,CACR,MAAM,CAAE,CAAC,CACT,KAAK,CAAE,WAAW,CAClB,UAAU,CAAE,IAAI,CAChB,UAAU,CAAE,IAAI,CAChB,OAAO,CAAE,IAAI,CACb,cAAc,CAAE,cACjB,CAEA,2BAAc,CACb,SAAS,CAAE,KAAK,CAChB,OAAO,CAAE,IAAI,CACb,cAAc,CAAE,MAAM,CACtB,eAAe,CAAE,MAAM,CACvB,WAAW,CAAE,MAAM,CACnB,QAAQ,CAAE,QAAQ,CAClB,KAAK,CAAE,CAAC,CACR,MAAM,CAAE,CAAC,CACT,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,oBAAoB,CAAC,CAC3C,aAAa,CAAE,CAAC,CAChB,sBAAsB,CAAE,IAAI,WAAW,CAAC,CACxC,YAAY,CAAE,IAAI,CAClB,aAAa,CAAE,IAAI,CACnB,OAAO,CAAE,IAAI,CACb,gBAAgB,CAAE,IAAI,uBAAuB,CAC9C"}'
};
const SecondaryToolbar = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { layers } = $$props;
  let { enable_additional_layers = true } = $$props;
  let { enable_layers = true } = $$props;
  let { show_layers = false } = $$props;
  if ($$props.layers === void 0 && $$bindings.layers && layers !== void 0)
    $$bindings.layers(layers);
  if ($$props.enable_additional_layers === void 0 && $$bindings.enable_additional_layers && enable_additional_layers !== void 0)
    $$bindings.enable_additional_layers(enable_additional_layers);
  if ($$props.enable_layers === void 0 && $$bindings.enable_layers && enable_layers !== void 0)
    $$bindings.enable_layers(enable_layers);
  if ($$props.show_layers === void 0 && $$bindings.show_layers && show_layers !== void 0)
    $$bindings.show_layers(show_layers);
  $$result.css.add(css$3);
  return `<div class="toolbar-wrap-wrap svelte-nkklfl"><div class="toolbar-wrap svelte-nkklfl">${enable_layers ? `${validate_component(Layers_1, "Layers").$$render(
    $$result,
    {
      layers,
      enable_additional_layers,
      enable_layers,
      show_layers
    },
    {},
    {}
  )}` : ``}</div> </div>`;
});
const css$2 = {
  code: ".separator.svelte-eqjom0.svelte-eqjom0{width:1px;height:10px;background-color:var(--border-color-primary)}.zoom-number.svelte-eqjom0.svelte-eqjom0{position:relative;width:30px;padding-left:4px;display:flex;align-items:center;justify-content:center}.zoom-number.svelte-eqjom0 span.svelte-eqjom0{cursor:pointer;font-size:var(--text-sm);transition:color 0.15s ease}.zoom-number.svelte-eqjom0 span.svelte-eqjom0:hover{color:var(--color-accent)}.zoom-controls.svelte-eqjom0.svelte-eqjom0{position:absolute;top:calc(100% + var(--spacing-xxs) + 3px);left:-2px;background:var(--block-background-fill);border:1px solid var(--color-gray-200);border-radius:var(--radius-sm);padding:var(--spacing-xxs);box-shadow:var(--shadow-drop);font-size:12px;z-index:var(--layer-2);width:max-content;color:var(--block-label-text-color);border:1px solid var(--block-border-color);border-top-left-radius:0;border-top-right-radius:0}.zoom-controls.svelte-eqjom0 ul.svelte-eqjom0{list-style:none;margin:0;padding:0}.zoom-controls.svelte-eqjom0 li.svelte-eqjom0{display:flex;justify-content:space-between;align-items:center;transition:background-color 0.15s ease;border-bottom:1px solid var(--border-color-primary)}.zoom-controls.svelte-eqjom0 li.svelte-eqjom0:last-child{border-bottom:none}.zoom-controls.svelte-eqjom0 li.svelte-eqjom0:hover{background-color:var(--background-fill-secondary)}.zoom-controls.svelte-eqjom0 button.svelte-eqjom0{width:100%;text-align:left;padding:var(--spacing-sm) var(--spacing-md);font-size:var(--text-sm);line-height:var(--line-sm);transition:all 0.15s ease;border-radius:var(--radius-sm)}.zoom-controls.svelte-eqjom0 button.svelte-eqjom0:hover{color:var(--color-accent)}",
  map: '{"version":3,"file":"Controls.svelte","sources":["Controls.svelte"],"sourcesContent":["<script lang=\\"ts\\">import { createEventDispatcher } from \\"svelte\\";\\nimport { IconButton, IconButtonWrapper } from \\"@gradio/atoms\\";\\nimport { Check, Trash, ZoomIn, ZoomOut, Pan, Download, Undo, Redo } from \\"@gradio/icons\\";\\nexport let can_save = false;\\nexport let changeable = false;\\nexport let current_zoom = 1;\\nexport let tool;\\nexport let min_zoom = true;\\nexport let enable_download = false;\\nexport let can_undo;\\nexport let can_redo;\\nconst dispatch = createEventDispatcher();\\nlet show_zoom_popup = false;\\nfunction handle_zoom_click(e) {\\n    e.stopPropagation();\\n    show_zoom_popup = !show_zoom_popup;\\n}\\nfunction handle_zoom_change(zoom) {\\n    dispatch(\\"set_zoom\\", zoom);\\n    show_zoom_popup = false;\\n}\\nfunction handle_zoom_keydown(e) {\\n    if (e.key === \\"Enter\\") {\\n        handle_zoom_change(current_zoom);\\n    }\\n}\\n$: formatted_zoom = Math.round(current_zoom * 100);\\n<\/script>\\n\\n<IconButtonWrapper>\\n\\t{#if enable_download}\\n\\t\\t<IconButton\\n\\t\\t\\tIcon={Download}\\n\\t\\t\\tlabel=\\"Download\\"\\n\\t\\t\\ton:click={(event) => {\\n\\t\\t\\t\\tdispatch(\\"download\\");\\n\\t\\t\\t\\tevent.stopPropagation();\\n\\t\\t\\t}}\\n\\t\\t/>\\n\\t{/if}\\n\\n\\t<IconButton\\n\\t\\tIcon={Pan}\\n\\t\\tlabel=\\"Pan\\"\\n\\t\\ton:click={(e) => {\\n\\t\\t\\te.stopPropagation();\\n\\t\\t\\tdispatch(\\"pan\\");\\n\\t\\t}}\\n\\t\\thighlight={tool === \\"pan\\"}\\n\\t\\tsize=\\"small\\"\\n\\t\\tpadded={false}\\n\\t\\ttransparent={true}\\n\\t\\tdisabled={min_zoom}\\n\\t/>\\n\\n\\t<IconButton\\n\\t\\tIcon={ZoomOut}\\n\\t\\tlabel=\\"Zoom out\\"\\n\\t\\ton:click={(event) => {\\n\\t\\t\\tdispatch(\\"zoom_out\\");\\n\\t\\t\\tevent.stopPropagation();\\n\\t\\t}}\\n\\t/>\\n\\t<IconButton\\n\\t\\tIcon={ZoomIn}\\n\\t\\tlabel=\\"Zoom in\\"\\n\\t\\ton:click={(event) => {\\n\\t\\t\\tdispatch(\\"zoom_in\\");\\n\\t\\t\\tevent.stopPropagation();\\n\\t\\t}}\\n\\t/>\\n\\n\\t<div class=\\"zoom-number\\">\\n\\t\\t<span\\n\\t\\t\\trole=\\"button\\"\\n\\t\\t\\ttabindex=\\"0\\"\\n\\t\\t\\ton:click={handle_zoom_click}\\n\\t\\t\\ton:keydown={handle_zoom_keydown}>{formatted_zoom}%</span\\n\\t\\t>\\n\\t\\t{#if show_zoom_popup}\\n\\t\\t\\t<div class=\\"zoom-controls\\">\\n\\t\\t\\t\\t<ul>\\n\\t\\t\\t\\t\\t<li>\\n\\t\\t\\t\\t\\t\\t<button on:click|stopPropagation={() => handle_zoom_change(\\"fit\\")}>\\n\\t\\t\\t\\t\\t\\t\\tFit to screen\\n\\t\\t\\t\\t\\t\\t</button>\\n\\t\\t\\t\\t\\t</li>\\n\\t\\t\\t\\t\\t{#each [0.25, 0.5, 1, 2, 4] as zoom}\\n\\t\\t\\t\\t\\t\\t<li>\\n\\t\\t\\t\\t\\t\\t\\t<button on:click|stopPropagation={() => handle_zoom_change(zoom)}>\\n\\t\\t\\t\\t\\t\\t\\t\\t{zoom * 100}%\\n\\t\\t\\t\\t\\t\\t\\t</button>\\n\\t\\t\\t\\t\\t\\t</li>\\n\\t\\t\\t\\t\\t{/each}\\n\\t\\t\\t\\t</ul>\\n\\t\\t\\t</div>\\n\\t\\t{/if}\\n\\t</div>\\n\\t<div class=\\"separator\\"></div>\\n\\n\\t<IconButton\\n\\t\\tIcon={Undo}\\n\\t\\tlabel=\\"Undo\\"\\n\\t\\ton:click={(event) => {\\n\\t\\t\\tdispatch(\\"undo\\");\\n\\t\\t\\tevent.stopPropagation();\\n\\t\\t}}\\n\\t\\tdisabled={!can_undo}\\n\\t/>\\n\\n\\t<IconButton\\n\\t\\tIcon={Redo}\\n\\t\\tlabel=\\"Redo\\"\\n\\t\\ton:click={(event) => {\\n\\t\\t\\tdispatch(\\"redo\\");\\n\\t\\t\\tevent.stopPropagation();\\n\\t\\t}}\\n\\t\\tdisabled={!can_redo}\\n\\t/>\\n\\n\\t{#if changeable}\\n\\t\\t<IconButton\\n\\t\\t\\tdisabled={!can_save}\\n\\t\\t\\tIcon={Check}\\n\\t\\t\\tlabel=\\"Save changes\\"\\n\\t\\t\\ton:click={(event) => {\\n\\t\\t\\t\\tdispatch(\\"save\\");\\n\\t\\t\\t\\tevent.stopPropagation();\\n\\t\\t\\t}}\\n\\t\\t\\tcolor=\\"var(--color-accent)\\"\\n\\t\\t/>\\n\\t{/if}\\n\\n\\t<IconButton\\n\\t\\tIcon={Trash}\\n\\t\\tlabel=\\"Clear canvas\\"\\n\\t\\ton:click={(event) => {\\n\\t\\t\\tdispatch(\\"remove_image\\");\\n\\t\\t\\tevent.stopPropagation();\\n\\t\\t}}\\n\\t/>\\n</IconButtonWrapper>\\n\\n<style>\\n\\t.separator {\\n\\t\\twidth: 1px;\\n\\t\\theight: 10px;\\n\\t\\tbackground-color: var(--border-color-primary);\\n\\t}\\n\\n\\t.zoom-number {\\n\\t\\tposition: relative;\\n\\t\\twidth: 30px;\\n\\t\\tpadding-left: 4px;\\n\\t\\tdisplay: flex;\\n\\t\\talign-items: center;\\n\\t\\tjustify-content: center;\\n\\t}\\n\\n\\t.zoom-number span {\\n\\t\\tcursor: pointer;\\n\\t\\tfont-size: var(--text-sm);\\n\\t\\ttransition: color 0.15s ease;\\n\\t}\\n\\n\\t.zoom-number span:hover {\\n\\t\\tcolor: var(--color-accent);\\n\\t}\\n\\n\\t.zoom-controls {\\n\\t\\tposition: absolute;\\n\\t\\ttop: calc(100% + var(--spacing-xxs) + 3px);\\n\\t\\tleft: -2px;\\n\\t\\tbackground: var(--block-background-fill);\\n\\t\\tborder: 1px solid var(--color-gray-200);\\n\\t\\tborder-radius: var(--radius-sm);\\n\\t\\tpadding: var(--spacing-xxs);\\n\\t\\tbox-shadow: var(--shadow-drop);\\n\\t\\tfont-size: 12px;\\n\\t\\tz-index: var(--layer-2);\\n\\t\\twidth: max-content;\\n\\t\\tcolor: var(--block-label-text-color);\\n\\t\\tborder: 1px solid var(--block-border-color);\\n\\t\\tborder-top-left-radius: 0;\\n\\t\\tborder-top-right-radius: 0;\\n\\t}\\n\\n\\t.zoom-controls ul {\\n\\t\\tlist-style: none;\\n\\t\\tmargin: 0;\\n\\t\\tpadding: 0;\\n\\t}\\n\\n\\t.zoom-controls li {\\n\\t\\tdisplay: flex;\\n\\t\\tjustify-content: space-between;\\n\\t\\talign-items: center;\\n\\t\\ttransition: background-color 0.15s ease;\\n\\t\\tborder-bottom: 1px solid var(--border-color-primary);\\n\\t}\\n\\n\\t.zoom-controls li:last-child {\\n\\t\\tborder-bottom: none;\\n\\t}\\n\\n\\t.zoom-controls li:hover {\\n\\t\\tbackground-color: var(--background-fill-secondary);\\n\\t}\\n\\n\\t.zoom-controls button {\\n\\t\\twidth: 100%;\\n\\t\\ttext-align: left;\\n\\t\\tpadding: var(--spacing-sm) var(--spacing-md);\\n\\t\\tfont-size: var(--text-sm);\\n\\t\\tline-height: var(--line-sm);\\n\\t\\ttransition: all 0.15s ease;\\n\\t\\tborder-radius: var(--radius-sm);\\n\\t}\\n\\n\\t.zoom-controls button:hover {\\n\\t\\tcolor: var(--color-accent);\\n\\t}</style>\\n"],"names":[],"mappings":"AAgJC,sCAAW,CACV,KAAK,CAAE,GAAG,CACV,MAAM,CAAE,IAAI,CACZ,gBAAgB,CAAE,IAAI,sBAAsB,CAC7C,CAEA,wCAAa,CACZ,QAAQ,CAAE,QAAQ,CAClB,KAAK,CAAE,IAAI,CACX,YAAY,CAAE,GAAG,CACjB,OAAO,CAAE,IAAI,CACb,WAAW,CAAE,MAAM,CACnB,eAAe,CAAE,MAClB,CAEA,0BAAY,CAAC,kBAAK,CACjB,MAAM,CAAE,OAAO,CACf,SAAS,CAAE,IAAI,SAAS,CAAC,CACzB,UAAU,CAAE,KAAK,CAAC,KAAK,CAAC,IACzB,CAEA,0BAAY,CAAC,kBAAI,MAAO,CACvB,KAAK,CAAE,IAAI,cAAc,CAC1B,CAEA,0CAAe,CACd,QAAQ,CAAE,QAAQ,CAClB,GAAG,CAAE,KAAK,IAAI,CAAC,CAAC,CAAC,IAAI,aAAa,CAAC,CAAC,CAAC,CAAC,GAAG,CAAC,CAC1C,IAAI,CAAE,IAAI,CACV,UAAU,CAAE,IAAI,uBAAuB,CAAC,CACxC,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,gBAAgB,CAAC,CACvC,aAAa,CAAE,IAAI,WAAW,CAAC,CAC/B,OAAO,CAAE,IAAI,aAAa,CAAC,CAC3B,UAAU,CAAE,IAAI,aAAa,CAAC,CAC9B,SAAS,CAAE,IAAI,CACf,OAAO,CAAE,IAAI,SAAS,CAAC,CACvB,KAAK,CAAE,WAAW,CAClB,KAAK,CAAE,IAAI,wBAAwB,CAAC,CACpC,MAAM,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,oBAAoB,CAAC,CAC3C,sBAAsB,CAAE,CAAC,CACzB,uBAAuB,CAAE,CAC1B,CAEA,4BAAc,CAAC,gBAAG,CACjB,UAAU,CAAE,IAAI,CAChB,MAAM,CAAE,CAAC,CACT,OAAO,CAAE,CACV,CAEA,4BAAc,CAAC,gBAAG,CACjB,OAAO,CAAE,IAAI,CACb,eAAe,CAAE,aAAa,CAC9B,WAAW,CAAE,MAAM,CACnB,UAAU,CAAE,gBAAgB,CAAC,KAAK,CAAC,IAAI,CACvC,aAAa,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,sBAAsB,CACpD,CAEA,4BAAc,CAAC,gBAAE,WAAY,CAC5B,aAAa,CAAE,IAChB,CAEA,4BAAc,CAAC,gBAAE,MAAO,CACvB,gBAAgB,CAAE,IAAI,2BAA2B,CAClD,CAEA,4BAAc,CAAC,oBAAO,CACrB,KAAK,CAAE,IAAI,CACX,UAAU,CAAE,IAAI,CAChB,OAAO,CAAE,IAAI,YAAY,CAAC,CAAC,IAAI,YAAY,CAAC,CAC5C,SAAS,CAAE,IAAI,SAAS,CAAC,CACzB,WAAW,CAAE,IAAI,SAAS,CAAC,CAC3B,UAAU,CAAE,GAAG,CAAC,KAAK,CAAC,IAAI,CAC1B,aAAa,CAAE,IAAI,WAAW,CAC/B,CAEA,4BAAc,CAAC,oBAAM,MAAO,CAC3B,KAAK,CAAE,IAAI,cAAc,CAC1B"}'
};
const Controls = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let formatted_zoom;
  let { can_save = false } = $$props;
  let { changeable = false } = $$props;
  let { current_zoom = 1 } = $$props;
  let { tool } = $$props;
  let { min_zoom = true } = $$props;
  let { enable_download = false } = $$props;
  let { can_undo } = $$props;
  let { can_redo } = $$props;
  createEventDispatcher();
  if ($$props.can_save === void 0 && $$bindings.can_save && can_save !== void 0)
    $$bindings.can_save(can_save);
  if ($$props.changeable === void 0 && $$bindings.changeable && changeable !== void 0)
    $$bindings.changeable(changeable);
  if ($$props.current_zoom === void 0 && $$bindings.current_zoom && current_zoom !== void 0)
    $$bindings.current_zoom(current_zoom);
  if ($$props.tool === void 0 && $$bindings.tool && tool !== void 0)
    $$bindings.tool(tool);
  if ($$props.min_zoom === void 0 && $$bindings.min_zoom && min_zoom !== void 0)
    $$bindings.min_zoom(min_zoom);
  if ($$props.enable_download === void 0 && $$bindings.enable_download && enable_download !== void 0)
    $$bindings.enable_download(enable_download);
  if ($$props.can_undo === void 0 && $$bindings.can_undo && can_undo !== void 0)
    $$bindings.can_undo(can_undo);
  if ($$props.can_redo === void 0 && $$bindings.can_redo && can_redo !== void 0)
    $$bindings.can_redo(can_redo);
  $$result.css.add(css$2);
  formatted_zoom = Math.round(current_zoom * 100);
  return `${validate_component(IconButtonWrapper, "IconButtonWrapper").$$render($$result, {}, {}, {
    default: () => {
      return `${enable_download ? `${validate_component(IconButton$1, "IconButton").$$render($$result, { Icon: Download, label: "Download" }, {}, {})}` : ``} ${validate_component(IconButton$1, "IconButton").$$render(
        $$result,
        {
          Icon: Pan,
          label: "Pan",
          highlight: tool === "pan",
          size: "small",
          padded: false,
          transparent: true,
          disabled: min_zoom
        },
        {},
        {}
      )} ${validate_component(IconButton$1, "IconButton").$$render($$result, { Icon: ZoomOut, label: "Zoom out" }, {}, {})} ${validate_component(IconButton$1, "IconButton").$$render($$result, { Icon: ZoomIn, label: "Zoom in" }, {}, {})} <div class="zoom-number svelte-eqjom0"><span role="button" tabindex="0" class="svelte-eqjom0">${escape(formatted_zoom)}%</span> ${``}</div> <div class="separator svelte-eqjom0"></div> ${validate_component(IconButton$1, "IconButton").$$render(
        $$result,
        {
          Icon: Undo,
          label: "Undo",
          disabled: !can_undo
        },
        {},
        {}
      )} ${validate_component(IconButton$1, "IconButton").$$render(
        $$result,
        {
          Icon: Redo,
          label: "Redo",
          disabled: !can_redo
        },
        {},
        {}
      )} ${changeable ? `${validate_component(IconButton$1, "IconButton").$$render(
        $$result,
        {
          disabled: !can_save,
          Icon: Check,
          label: "Save changes",
          color: "var(--color-accent)"
        },
        {},
        {}
      )}` : ``} ${validate_component(IconButton$1, "IconButton").$$render($$result, { Icon: Trash, label: "Clear canvas" }, {}, {})}`;
    }
  })}`;
});
const css$1 = {
  code: ".image-container.svelte-h6gdep{display:flex;height:100%;flex-direction:column;justify-content:center;align-items:center;max-height:100%;border-radius:var(--radius-sm)}.pixi-target.svelte-h6gdep{width:100%;height:100%;position:absolute;top:0;left:0;z-index:1;display:block;opacity:0;pointer-events:none;border-radius:var(--radius-sm)}.pixi-target-crop.svelte-h6gdep{width:100%;height:100%;position:absolute;top:0;left:0;z-index:2;display:block;opacity:0;pointer-events:none;border-radius:var(--radius-sm)}.visible.svelte-h6gdep{opacity:1;pointer-events:auto}.pixi-target.svelte-h6gdep{width:100%;height:100%;position:absolute;top:0;left:0;right:0;bottom:0;overflow:hidden}.modal.svelte-h6gdep{position:absolute;height:100%;width:100%;left:0;right:0;margin:auto;z-index:var(--layer-top);display:flex;align-items:center}.modal-inner.svelte-h6gdep{height:100%;width:100%;background:var(--block-background-fill)}.dark-bg.svelte-h6gdep{background:#333}.crop-confirm-button.svelte-h6gdep{position:absolute;bottom:8px;left:0;right:0;margin:auto;z-index:var(--layer-top);display:flex;align-items:center;justify-content:center}",
  map: '{"version":3,"file":"ImageEditor.svelte","sources":["ImageEditor.svelte"],"sourcesContent":["<script lang=\\"ts\\" context=\\"module\\">export const EDITOR_KEY = Symbol(\\"editor\\");\\n<\/script>\\n\\n<script lang=\\"ts\\">import { onMount, createEventDispatcher, tick } from \\"svelte\\";\\nimport Toolbar, {} from \\"./Toolbar.svelte\\";\\nimport { CropTool } from \\"./crop/crop\\";\\nimport { ResizeTool } from \\"./resize/resize\\";\\nimport { Webcam } from \\"@gradio/image\\";\\nimport tinycolor, {} from \\"tinycolor2\\";\\nimport { ZoomTool } from \\"./zoom/zoom\\";\\nimport {} from \\"./core/commands\\";\\nimport { ImageEditor } from \\"./core/editor\\";\\nimport {} from \\"./brush/types\\";\\nimport { BrushTool } from \\"./brush/brush\\";\\nimport { create_drag } from \\"@gradio/upload\\";\\nimport SecondaryToolbar from \\"./SecondaryToolbar.svelte\\";\\nimport { Check } from \\"@gradio/icons\\";\\nimport {} from \\"./types\\";\\nimport Controls from \\"./Controls.svelte\\";\\nimport IconButton from \\"./IconButton.svelte\\";\\nconst { drag, open_file_upload } = create_drag();\\nconst dispatch = createEventDispatcher();\\nexport const antialias = true;\\nexport const full_history = null;\\nexport let changeable = false;\\nexport let sources = [\\"upload\\", \\"webcam\\", \\"clipboard\\"];\\nexport let transforms = [\\"crop\\", \\"resize\\"];\\nexport let canvas_size;\\nexport let is_dragging = false;\\nexport let background_image = false;\\nexport let brush_options;\\nexport let eraser_options;\\nexport let fixed_canvas = false;\\nexport let root;\\nexport let i18n;\\nexport let upload;\\nexport let composite;\\nexport let layers;\\nexport let background;\\nexport let border_region = 0;\\nexport let layer_options;\\nexport let current_tool;\\nexport let webcam_options;\\nexport let show_download_button = false;\\nexport let theme_mode;\\nlet pixi_target;\\nlet pixi_target_crop;\\n$: if (layer_options) {\\n    if (check_if_should_init()) {\\n        editor.set_layer_options(layer_options);\\n        refresh_tools();\\n    }\\n}\\nfunction refresh_tools() {\\n    editor.set_tool(current_tool);\\n    editor.set_subtool(current_subtool);\\n}\\nfunction check_if_should_init() {\\n    return layer_options && editor && ready;\\n}\\nexport let has_drawn = false;\\nexport async function get_blobs() {\\n    if (!editor)\\n        return { background: null, layers: [], composite: null };\\n    if (!background_image && !has_drawn && !layers.length)\\n        return { background: null, layers: [], composite: null };\\n    const blobs = await editor.get_blobs();\\n    return blobs;\\n}\\nlet editor;\\nexport function add_image(image) {\\n    editor.add_image({ image });\\n}\\nlet pending_bg;\\nexport async function add_image_from_url(source) {\\n    if (!editor || !source || !check_if_should_init())\\n        return;\\n    let url;\\n    if (typeof source === \\"string\\") {\\n        url = source;\\n    }\\n    else if (source?.meta?._type === \\"gradio.FileData\\" && source?.url) {\\n        url = source.url;\\n    }\\n    else {\\n        console.warn(\\"Invalid source provided to add_image_from_url:\\", source);\\n        return;\\n    }\\n    try {\\n        pending_bg = editor.add_image_from_url(url);\\n        let pending_crop = crop.add_image_from_url(url);\\n        await Promise.all([pending_bg, pending_crop]);\\n        crop.set_tool(\\"image\\");\\n        crop.set_subtool(\\"crop\\");\\n        background_image = true;\\n        dispatch(\\"upload\\");\\n        dispatch(\\"input\\");\\n    }\\n    catch (error) {\\n        console.error(\\"Error adding image from URL:\\", error);\\n    }\\n}\\nexport async function add_layers_from_url(source) {\\n    if (!editor || !source.length || !check_if_should_init())\\n        return;\\n    if (Array.isArray(source) && source.every((item) => item?.meta?._type === \\"gradio.FileData\\")) {\\n        try {\\n            await pending_bg;\\n            await editor.add_layers_from_url(source.map((item) => item.url));\\n            dispatch(\\"change\\");\\n            dispatch(\\"input\\");\\n        }\\n        catch (error) {\\n            console.error(\\"Error adding layer from URL:\\", error);\\n        }\\n    }\\n}\\nlet brush;\\nlet zoom;\\nlet zoom_level = 1;\\nlet ready = false;\\nlet mounted = false;\\nlet min_zoom = true;\\nlet last_dimensions = { width: 0, height: 0 };\\nasync function handle_visibility_change() {\\n    if (!editor || !ready || !zoom)\\n        return;\\n    await tick();\\n    const is_visible = pixi_target.offsetParent !== null;\\n    if (is_visible) {\\n        const current_dimensions = pixi_target.getBoundingClientRect();\\n        if (current_dimensions.width !== last_dimensions.width || current_dimensions.height !== last_dimensions.height) {\\n            zoom.set_zoom(\\"fit\\");\\n            last_dimensions = {\\n                width: current_dimensions.width,\\n                height: current_dimensions.height\\n            };\\n        }\\n    }\\n}\\nonMount(() => {\\n    let intersection_observer;\\n    let resize_observer;\\n    init_image_editor().then(() => {\\n        mounted = true;\\n        intersection_observer = new IntersectionObserver(() => {\\n            handle_visibility_change();\\n        });\\n        resize_observer = new ResizeObserver(() => {\\n            handle_visibility_change();\\n        });\\n        intersection_observer.observe(pixi_target);\\n        resize_observer.observe(pixi_target);\\n    });\\n    return () => {\\n        if (intersection_observer) {\\n            intersection_observer.disconnect();\\n        }\\n        if (resize_observer) {\\n            resize_observer.disconnect();\\n        }\\n        if (editor) {\\n            editor.destroy();\\n        }\\n    };\\n});\\nlet crop;\\nlet crop_zoom;\\nexport let can_undo = false;\\nlet can_redo = false;\\nasync function init_image_editor() {\\n    brush = new BrushTool();\\n    zoom = new ZoomTool();\\n    editor = new ImageEditor({\\n        target_element: pixi_target,\\n        width: canvas_size[0],\\n        height: canvas_size[1],\\n        tools: [\\"image\\", zoom, new ResizeTool(), brush],\\n        fixed_canvas,\\n        border_region,\\n        layer_options,\\n        theme_mode\\n    });\\n    brush.on(\\"change\\", () => {\\n        has_drawn = true;\\n    });\\n    crop_zoom = new ZoomTool();\\n    crop = new ImageEditor({\\n        target_element: pixi_target_crop,\\n        width: canvas_size[0],\\n        height: canvas_size[1],\\n        tools: [\\"image\\", crop_zoom, new CropTool()],\\n        dark: true,\\n        fixed_canvas: false,\\n        border_region: 0,\\n        pad_bottom: 40\\n    });\\n    editor.scale.subscribe((_scale) => {\\n        zoom_level = _scale;\\n    });\\n    editor.min_zoom.subscribe((is_min_zoom) => {\\n        min_zoom = is_min_zoom;\\n    });\\n    editor.dimensions.subscribe((dimensions) => {\\n        last_dimensions = { ...dimensions };\\n    });\\n    await Promise.all([editor.ready, crop.ready]).then(() => {\\n        handle_tool_change({ tool: \\"image\\" });\\n        ready = true;\\n        if (sources.length > 0) {\\n            handle_tool_change({ tool: \\"image\\" });\\n        }\\n        else {\\n            handle_tool_change({ tool: \\"draw\\" });\\n        }\\n        crop.set_subtool(\\"crop\\");\\n    });\\n    editor.on(\\"change\\", () => {\\n        dispatch(\\"change\\");\\n        can_undo = editor.command_manager.history.previous !== null;\\n        can_redo = editor.command_manager.history.next !== null;\\n    });\\n    if (background || layers.length > 0) {\\n        if (background) {\\n            await add_image_from_url(background);\\n        }\\n        if (layers.length > 0) {\\n            await add_layers_from_url(layers);\\n        }\\n        handle_tool_change({ tool: \\"draw\\" });\\n    }\\n    else if (composite) {\\n        await add_image_from_url(composite);\\n        handle_tool_change({ tool: \\"draw\\" });\\n    }\\n}\\n$: if (background == null && layers.length == 0 && composite == null && editor && ready) {\\n    editor.reset_canvas();\\n    handle_tool_change({ tool: \\"image\\" });\\n    background_image = false;\\n    has_drawn = false;\\n}\\n$: current_tool === \\"image\\" && current_subtool === \\"crop\\" && crop_zoom.set_zoom(\\"fit\\");\\nasync function handle_files(files) {\\n    if (files == null)\\n        return;\\n    if (!sources.includes(\\"upload\\"))\\n        return;\\n    const _file = Array.isArray(files) ? files[0] : files;\\n    await editor.add_image({ image: _file });\\n    await crop.add_image({ image: _file });\\n    crop.reset();\\n    background_image = true;\\n    handle_tool_change({ tool: \\"draw\\" });\\n    dispatch(\\"upload\\");\\n    dispatch(\\"input\\");\\n    dispatch(\\"change\\");\\n    can_undo = editor.command_manager.history.previous !== null;\\n    can_redo = editor.command_manager.history.next !== null;\\n}\\n$: background_image = can_undo && editor.command_manager.contains(\\"AddImage\\");\\nfunction handle_tool_change({ tool }) {\\n    editor.set_tool(tool);\\n    current_tool = tool;\\n    if (tool === \\"image\\") {\\n        crop.set_tool(\\"image\\");\\n        crop.set_subtool(\\"crop\\");\\n    }\\n}\\nfunction handle_subtool_change({ tool, subtool }) {\\n    editor.set_subtool(subtool);\\n    current_subtool = subtool;\\n    if (subtool === null) {\\n        return;\\n    }\\n    if (tool === \\"draw\\") {\\n        if (subtool === \\"size\\") {\\n            brush_size_visible = true;\\n        }\\n        else if (subtool === \\"color\\") {\\n            brush_color_visible = true;\\n        }\\n    }\\n    if (tool === \\"erase\\" && subtool === \\"size\\") {\\n        eraser_size_visible = true;\\n    }\\n    if (tool === \\"image\\" && subtool === \\"paste\\") {\\n        process_clipboard();\\n    }\\n    if (tool === \\"image\\" && subtool === \\"upload\\") {\\n        tick().then(() => {\\n            disable_click = false;\\n            open_file_upload();\\n        });\\n    }\\n}\\nlet eraser_size_visible = false;\\nlet selected_color;\\nlet selected_size;\\nlet selected_opacity = 1;\\nlet selected_eraser_size;\\n$: {\\n    if (brush_options) {\\n        update_brush_options();\\n    }\\n    if (eraser_options) {\\n        update_eraser_options();\\n    }\\n}\\nfunction update_brush_options() {\\n    const default_color = brush_options.default_color === \\"auto\\" ? brush_options.colors[0] : brush_options.default_color;\\n    if (Array.isArray(default_color)) {\\n        selected_color = default_color[0];\\n        selected_opacity = default_color[1];\\n    }\\n    else {\\n        selected_color = default_color;\\n        const color = tinycolor(default_color);\\n        if (color.getAlpha() < 1) {\\n            selected_opacity = color.getAlpha();\\n        }\\n        else {\\n            selected_opacity = 1;\\n        }\\n    }\\n    selected_size = typeof brush_options.default_size === \\"number\\" ? brush_options.default_size : 25;\\n}\\nfunction update_eraser_options() {\\n    selected_eraser_size = eraser_options.default_size === \\"auto\\" ? 25 : eraser_options.default_size;\\n}\\nlet brush_size_visible = false;\\nlet brush_color_visible = false;\\n$: brush?.set_brush_color((() => {\\n    let color_value;\\n    if (selected_color === \\"auto\\") {\\n        const default_color = brush_options.colors.find((color) => Array.isArray(color) ? color[0] === brush_options.default_color : color === brush_options.default_color) || brush_options.colors[0];\\n        color_value = Array.isArray(default_color) ? default_color[0] : default_color;\\n    }\\n    else {\\n        color_value = selected_color;\\n    }\\n    return color_value;\\n})());\\n$: brush?.set_brush_size(typeof selected_size === \\"number\\" ? selected_size : 25);\\n$: brush?.set_eraser_size(typeof selected_eraser_size === \\"number\\" ? selected_eraser_size : 25);\\n$: disable_click = current_tool !== \\"image\\" || current_tool === \\"image\\" && background_image || current_tool === \\"image\\" && current_subtool === \\"webcam\\" || !sources.includes(\\"upload\\");\\nlet current_subtool = null;\\nlet preview = false;\\n$: brush?.preview_brush(preview);\\n$: brush?.set_brush_opacity(selected_opacity);\\nfunction handle_zoom_change(zoom_level2) {\\n    zoom.set_zoom(zoom_level2);\\n}\\nfunction zoom_in_out(direction) {\\n    zoom.set_zoom(direction === \\"in\\" ? zoom_level + (zoom_level < 1 ? 0.1 : zoom_level * 0.1) : zoom_level - (zoom_level < 1 ? 0.1 : zoom_level * 0.1));\\n}\\nasync function process_clipboard() {\\n    const items = await navigator.clipboard.read();\\n    for (let i = 0; i < items.length; i++) {\\n        const type = items[i].types.find((t) => t.startsWith(\\"image/\\"));\\n        if (type) {\\n            const blob = await items[i].getType(type);\\n            handle_files(blob);\\n        }\\n    }\\n}\\nfunction handle_capture(e) {\\n    if (e.detail !== null) {\\n        handle_files(e.detail);\\n    }\\n    handle_subtool_change({ tool: current_tool, subtool: null });\\n}\\nfunction handle_save() {\\n    dispatch(\\"save\\");\\n}\\n$: add_image_from_url(composite || background);\\n$: add_layers_from_url(layers);\\nasync function handle_crop_confirm() {\\n    const { image } = await crop.get_crop_bounds();\\n    if (!image)\\n        return;\\n    await editor.add_image({\\n        image,\\n        resize: false\\n    });\\n    handle_subtool_change({ tool: \\"image\\", subtool: null });\\n    dispatch(\\"change\\");\\n    dispatch(\\"input\\");\\n}\\nasync function handle_download() {\\n    const blobs = await editor.get_blobs();\\n    const blob = blobs.composite;\\n    if (!blob) {\\n        dispatch(\\"download_error\\", \\"Unable to generate image to download.\\");\\n        return;\\n    }\\n    const url = URL.createObjectURL(blob);\\n    const link = document.createElement(\\"a\\");\\n    link.href = url;\\n    link.download = \\"image.png\\";\\n    link.click();\\n    URL.revokeObjectURL(url);\\n}\\nfunction handle_undo() {\\n    editor.undo();\\n    can_undo = editor.command_manager.history.previous !== null;\\n    can_redo = editor.command_manager.history.next !== null;\\n}\\nfunction handle_redo() {\\n    editor.redo();\\n    can_undo = editor.command_manager.history.previous !== null;\\n    can_redo = editor.command_manager.history.next !== null;\\n}\\n<\/script>\\n\\n<div\\n\\tdata-testid=\\"image\\"\\n\\tclass=\\"image-container\\"\\n\\tclass:dark-bg={current_subtool === \\"crop\\"}\\n\\tuse:drag={{\\n\\t\\ton_drag_change: (dragging) => (is_dragging = dragging),\\n\\t\\ton_files: handle_files,\\n\\t\\taccepted_types: \\"image/*\\",\\n\\t\\tdisable_click: disable_click\\n\\t}}\\n\\taria-label={\\"Click to upload or drop files\\"}\\n\\taria-dropeffect=\\"copy\\"\\n>\\n\\t{#if ready}\\n\\t\\t{#if current_subtool !== \\"crop\\"}\\n\\t\\t\\t<Controls\\n\\t\\t\\t\\t{changeable}\\n\\t\\t\\t\\ton:set_zoom={(e) => handle_zoom_change(e.detail)}\\n\\t\\t\\t\\ton:zoom_in={() => zoom_in_out(\\"in\\")}\\n\\t\\t\\t\\ton:zoom_out={() => zoom_in_out(\\"out\\")}\\n\\t\\t\\t\\t{min_zoom}\\n\\t\\t\\t\\tcurrent_zoom={zoom_level}\\n\\t\\t\\t\\ton:remove_image={() => {\\n\\t\\t\\t\\t\\tdispatch(\\"clear\\");\\n\\t\\t\\t\\t\\teditor.reset_canvas();\\n\\t\\t\\t\\t\\thandle_tool_change({ tool: \\"image\\" });\\n\\t\\t\\t\\t\\tbackground_image = false;\\n\\t\\t\\t\\t\\thas_drawn = false;\\n\\t\\t\\t\\t}}\\n\\t\\t\\t\\ttool={current_tool}\\n\\t\\t\\t\\tcan_save={true}\\n\\t\\t\\t\\ton:save={handle_save}\\n\\t\\t\\t\\ton:pan={(e) => {\\n\\t\\t\\t\\t\\thandle_tool_change({ tool: \\"pan\\" });\\n\\t\\t\\t\\t}}\\n\\t\\t\\t\\tenable_download={show_download_button}\\n\\t\\t\\t\\ton:download={() => handle_download()}\\n\\t\\t\\t\\t{can_undo}\\n\\t\\t\\t\\t{can_redo}\\n\\t\\t\\t\\ton:undo={handle_undo}\\n\\t\\t\\t\\ton:redo={handle_redo}\\n\\t\\t\\t/>\\n\\t\\t{/if}\\n\\n\\t\\t{#if current_subtool !== \\"crop\\"}\\n\\t\\t\\t<Toolbar\\n\\t\\t\\t\\t{sources}\\n\\t\\t\\t\\t{transforms}\\n\\t\\t\\t\\tbackground={background_image}\\n\\t\\t\\t\\ton:tool_change={(e) => handle_tool_change(e.detail)}\\n\\t\\t\\t\\ton:subtool_change={(e) => handle_subtool_change(e.detail)}\\n\\t\\t\\t\\tshow_brush_size={brush_size_visible}\\n\\t\\t\\t\\tshow_brush_color={brush_color_visible}\\n\\t\\t\\t\\tshow_eraser_size={eraser_size_visible}\\n\\t\\t\\t\\t{brush_options}\\n\\t\\t\\t\\t{eraser_options}\\n\\t\\t\\t\\tbind:selected_color\\n\\t\\t\\t\\tbind:selected_size\\n\\t\\t\\t\\tbind:selected_eraser_size\\n\\t\\t\\t\\tbind:selected_opacity\\n\\t\\t\\t\\tbind:preview\\n\\t\\t\\t\\ttool={current_tool}\\n\\t\\t\\t\\tsubtool={current_subtool}\\n\\t\\t\\t/>\\n\\t\\t{/if}\\n\\n\\t\\t{#if current_tool === \\"image\\" && current_subtool === \\"webcam\\"}\\n\\t\\t\\t<div class=\\"modal\\">\\n\\t\\t\\t\\t<div class=\\"modal-inner\\">\\n\\t\\t\\t\\t\\t<Webcam\\n\\t\\t\\t\\t\\t\\t{upload}\\n\\t\\t\\t\\t\\t\\t{root}\\n\\t\\t\\t\\t\\t\\ton:capture={handle_capture}\\n\\t\\t\\t\\t\\t\\ton:error\\n\\t\\t\\t\\t\\t\\ton:drag\\n\\t\\t\\t\\t\\t\\tstreaming={false}\\n\\t\\t\\t\\t\\t\\tmode=\\"image\\"\\n\\t\\t\\t\\t\\t\\tinclude_audio={false}\\n\\t\\t\\t\\t\\t\\t{i18n}\\n\\t\\t\\t\\t\\t\\tmirror_webcam={webcam_options.mirror}\\n\\t\\t\\t\\t\\t\\twebcam_constraints={webcam_options.constraints}\\n\\t\\t\\t\\t\\t/>\\n\\t\\t\\t\\t</div>\\n\\t\\t\\t</div>\\n\\t\\t{/if}\\n\\n\\t\\t{#if current_subtool !== \\"crop\\" && !layer_options.disabled}\\n\\t\\t\\t<SecondaryToolbar\\n\\t\\t\\t\\tenable_additional_layers={layer_options.allow_additional_layers}\\n\\t\\t\\t\\tlayers={editor.layers}\\n\\t\\t\\t\\ton:new_layer={() => {\\n\\t\\t\\t\\t\\teditor.add_layer();\\n\\t\\t\\t\\t}}\\n\\t\\t\\t\\ton:change_layer={(e) => {\\n\\t\\t\\t\\t\\teditor.set_layer(e.detail);\\n\\t\\t\\t\\t\\tif (current_tool === \\"draw\\") {\\n\\t\\t\\t\\t\\t\\thandle_tool_change({ tool: \\"draw\\" });\\n\\t\\t\\t\\t\\t}\\n\\t\\t\\t\\t}}\\n\\t\\t\\t\\ton:move_layer={(e) => {\\n\\t\\t\\t\\t\\teditor.move_layer(e.detail.id, e.detail.direction);\\n\\t\\t\\t\\t}}\\n\\t\\t\\t\\ton:delete_layer={(e) => {\\n\\t\\t\\t\\t\\teditor.delete_layer(e.detail);\\n\\t\\t\\t\\t}}\\n\\t\\t\\t\\ton:toggle_layer_visibility={(e) => {\\n\\t\\t\\t\\t\\teditor.toggle_layer_visibility(e.detail);\\n\\t\\t\\t\\t}}\\n\\t\\t\\t/>\\n\\t\\t{/if}\\n\\t{/if}\\n\\t<div\\n\\t\\tclass=\\"pixi-target\\"\\n\\t\\tclass:visible={current_subtool !== \\"crop\\"}\\n\\t\\tbind:this={pixi_target}\\n\\t></div>\\n\\t<div\\n\\t\\tclass=\\"pixi-target-crop\\"\\n\\t\\tclass:visible={current_subtool === \\"crop\\"}\\n\\t\\tbind:this={pixi_target_crop}\\n\\t></div>\\n\\n\\t{#if current_subtool === \\"crop\\"}\\n\\t\\t<div class=\\"crop-confirm-button\\">\\n\\t\\t\\t<IconButton\\n\\t\\t\\t\\tIcon={Check}\\n\\t\\t\\t\\tlabel=\\"Confirm crop\\"\\n\\t\\t\\t\\tshow_label={true}\\n\\t\\t\\t\\tsize=\\"large\\"\\n\\t\\t\\t\\tpadded={true}\\n\\t\\t\\t\\tcolor=\\"white\\"\\n\\t\\t\\t\\tbackground=\\"var(--color-green-500)\\"\\n\\t\\t\\t\\tlabel_position=\\"right\\"\\n\\t\\t\\t\\ton:click={handle_crop_confirm}\\n\\t\\t\\t/>\\n\\t\\t</div>\\n\\t{/if}\\n\\t<slot></slot>\\n</div>\\n\\n<style>\\n\\t.image-container {\\n\\t\\tdisplay: flex;\\n\\t\\theight: 100%;\\n\\t\\tflex-direction: column;\\n\\t\\tjustify-content: center;\\n\\t\\talign-items: center;\\n\\t\\tmax-height: 100%;\\n\\t\\tborder-radius: var(--radius-sm);\\n\\t}\\n\\n\\t.pixi-target {\\n\\t\\twidth: 100%;\\n\\t\\theight: 100%;\\n\\t\\tposition: absolute;\\n\\t\\ttop: 0;\\n\\t\\tleft: 0;\\n\\t\\tz-index: 1;\\n\\t\\tdisplay: block;\\n\\t\\topacity: 0;\\n\\t\\tpointer-events: none;\\n\\t\\tborder-radius: var(--radius-sm);\\n\\t}\\n\\n\\t.pixi-target-crop {\\n\\t\\twidth: 100%;\\n\\t\\theight: 100%;\\n\\t\\tposition: absolute;\\n\\t\\ttop: 0;\\n\\t\\tleft: 0;\\n\\t\\tz-index: 2;\\n\\t\\tdisplay: block;\\n\\t\\topacity: 0;\\n\\t\\tpointer-events: none;\\n\\t\\tborder-radius: var(--radius-sm);\\n\\t}\\n\\n\\t.visible {\\n\\t\\topacity: 1;\\n\\t\\tpointer-events: auto;\\n\\t}\\n\\n\\t.pixi-target {\\n\\t\\twidth: 100%;\\n\\t\\theight: 100%;\\n\\t\\tposition: absolute;\\n\\t\\ttop: 0;\\n\\t\\tleft: 0;\\n\\t\\tright: 0;\\n\\t\\tbottom: 0;\\n\\t\\toverflow: hidden;\\n\\t}\\n\\n\\t.modal {\\n\\t\\tposition: absolute;\\n\\t\\theight: 100%;\\n\\t\\twidth: 100%;\\n\\t\\tleft: 0;\\n\\t\\tright: 0;\\n\\t\\tmargin: auto;\\n\\t\\tz-index: var(--layer-top);\\n\\t\\tdisplay: flex;\\n\\t\\talign-items: center;\\n\\t}\\n\\n\\t.modal-inner {\\n\\t\\theight: 100%;\\n\\t\\twidth: 100%;\\n\\t\\tbackground: var(--block-background-fill);\\n\\t}\\n\\n\\t.dark-bg {\\n\\t\\tbackground: #333;\\n\\t}\\n\\n\\t.crop-confirm-button {\\n\\t\\tposition: absolute;\\n\\t\\tbottom: 8px;\\n\\t\\tleft: 0;\\n\\t\\tright: 0;\\n\\t\\tmargin: auto;\\n\\t\\tz-index: var(--layer-top);\\n\\t\\tdisplay: flex;\\n\\t\\talign-items: center;\\n\\t\\tjustify-content: center;\\n\\t}</style>\\n"],"names":[],"mappings":"AA4iBC,8BAAiB,CAChB,OAAO,CAAE,IAAI,CACb,MAAM,CAAE,IAAI,CACZ,cAAc,CAAE,MAAM,CACtB,eAAe,CAAE,MAAM,CACvB,WAAW,CAAE,MAAM,CACnB,UAAU,CAAE,IAAI,CAChB,aAAa,CAAE,IAAI,WAAW,CAC/B,CAEA,0BAAa,CACZ,KAAK,CAAE,IAAI,CACX,MAAM,CAAE,IAAI,CACZ,QAAQ,CAAE,QAAQ,CAClB,GAAG,CAAE,CAAC,CACN,IAAI,CAAE,CAAC,CACP,OAAO,CAAE,CAAC,CACV,OAAO,CAAE,KAAK,CACd,OAAO,CAAE,CAAC,CACV,cAAc,CAAE,IAAI,CACpB,aAAa,CAAE,IAAI,WAAW,CAC/B,CAEA,+BAAkB,CACjB,KAAK,CAAE,IAAI,CACX,MAAM,CAAE,IAAI,CACZ,QAAQ,CAAE,QAAQ,CAClB,GAAG,CAAE,CAAC,CACN,IAAI,CAAE,CAAC,CACP,OAAO,CAAE,CAAC,CACV,OAAO,CAAE,KAAK,CACd,OAAO,CAAE,CAAC,CACV,cAAc,CAAE,IAAI,CACpB,aAAa,CAAE,IAAI,WAAW,CAC/B,CAEA,sBAAS,CACR,OAAO,CAAE,CAAC,CACV,cAAc,CAAE,IACjB,CAEA,0BAAa,CACZ,KAAK,CAAE,IAAI,CACX,MAAM,CAAE,IAAI,CACZ,QAAQ,CAAE,QAAQ,CAClB,GAAG,CAAE,CAAC,CACN,IAAI,CAAE,CAAC,CACP,KAAK,CAAE,CAAC,CACR,MAAM,CAAE,CAAC,CACT,QAAQ,CAAE,MACX,CAEA,oBAAO,CACN,QAAQ,CAAE,QAAQ,CAClB,MAAM,CAAE,IAAI,CACZ,KAAK,CAAE,IAAI,CACX,IAAI,CAAE,CAAC,CACP,KAAK,CAAE,CAAC,CACR,MAAM,CAAE,IAAI,CACZ,OAAO,CAAE,IAAI,WAAW,CAAC,CACzB,OAAO,CAAE,IAAI,CACb,WAAW,CAAE,MACd,CAEA,0BAAa,CACZ,MAAM,CAAE,IAAI,CACZ,KAAK,CAAE,IAAI,CACX,UAAU,CAAE,IAAI,uBAAuB,CACxC,CAEA,sBAAS,CACR,UAAU,CAAE,IACb,CAEA,kCAAqB,CACpB,QAAQ,CAAE,QAAQ,CAClB,MAAM,CAAE,GAAG,CACX,IAAI,CAAE,CAAC,CACP,KAAK,CAAE,CAAC,CACR,MAAM,CAAE,IAAI,CACZ,OAAO,CAAE,IAAI,WAAW,CAAC,CACzB,OAAO,CAAE,IAAI,CACb,WAAW,CAAE,MAAM,CACnB,eAAe,CAAE,MAClB"}'
};
const ImageEditor_1 = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  const dispatch = createEventDispatcher();
  const antialias = true;
  const full_history = null;
  let { changeable = false } = $$props;
  let { sources: sources2 = ["upload", "webcam", "clipboard"] } = $$props;
  let { transforms = ["crop", "resize"] } = $$props;
  let { canvas_size } = $$props;
  let { is_dragging = false } = $$props;
  let { background_image = false } = $$props;
  let { brush_options } = $$props;
  let { eraser_options } = $$props;
  let { fixed_canvas = false } = $$props;
  let { root } = $$props;
  let { i18n } = $$props;
  let { upload } = $$props;
  let { composite } = $$props;
  let { layers } = $$props;
  let { background } = $$props;
  let { border_region = 0 } = $$props;
  let { layer_options } = $$props;
  let { current_tool } = $$props;
  let { webcam_options } = $$props;
  let { show_download_button = false } = $$props;
  let { theme_mode } = $$props;
  let pixi_target;
  let pixi_target_crop;
  function refresh_tools() {
    editor.set_tool(current_tool);
    editor.set_subtool(current_subtool);
  }
  function check_if_should_init() {
    return layer_options && editor && ready;
  }
  let { has_drawn = false } = $$props;
  async function get_blobs() {
    if (!editor)
      return {
        background: null,
        layers: [],
        composite: null
      };
    if (!background_image && !has_drawn && !layers.length)
      return {
        background: null,
        layers: [],
        composite: null
      };
    const blobs = await editor.get_blobs();
    return blobs;
  }
  let editor;
  function add_image(image) {
    editor.add_image({ image });
  }
  let pending_bg;
  async function add_image_from_url(source2) {
    if (!editor || !source2 || !check_if_should_init())
      return;
    let url;
    if (typeof source2 === "string") {
      url = source2;
    } else if (source2?.meta?._type === "gradio.FileData" && source2?.url) {
      url = source2.url;
    } else {
      console.warn("Invalid source provided to add_image_from_url:", source2);
      return;
    }
    try {
      pending_bg = editor.add_image_from_url(url);
      let pending_crop = crop.add_image_from_url(url);
      await Promise.all([pending_bg, pending_crop]);
      crop.set_tool("image");
      crop.set_subtool("crop");
      background_image = true;
      dispatch("upload");
      dispatch("input");
    } catch (error) {
      console.error("Error adding image from URL:", error);
    }
  }
  async function add_layers_from_url(source2) {
    if (!editor || !source2.length || !check_if_should_init())
      return;
    if (Array.isArray(source2) && source2.every((item) => item?.meta?._type === "gradio.FileData")) {
      try {
        await pending_bg;
        await editor.add_layers_from_url(source2.map((item) => item.url));
        dispatch("change");
        dispatch("input");
      } catch (error) {
        console.error("Error adding layer from URL:", error);
      }
    }
  }
  let brush;
  let zoom;
  let zoom_level = 1;
  let ready = false;
  let min_zoom = true;
  let last_dimensions = { width: 0, height: 0 };
  async function handle_visibility_change() {
    if (!editor || !ready || !zoom)
      return;
    await tick();
    pixi_target.offsetParent !== null;
    {
      const current_dimensions = pixi_target.getBoundingClientRect();
      if (current_dimensions.width !== last_dimensions.width || current_dimensions.height !== last_dimensions.height) {
        zoom.set_zoom("fit");
        last_dimensions = {
          width: current_dimensions.width,
          height: current_dimensions.height
        };
      }
    }
  }
  onMount(() => {
    let intersection_observer;
    let resize_observer;
    init_image_editor().then(() => {
      intersection_observer = new IntersectionObserver(() => {
        handle_visibility_change();
      });
      resize_observer = new ResizeObserver(() => {
        handle_visibility_change();
      });
      intersection_observer.observe(pixi_target);
      resize_observer.observe(pixi_target);
    });
    return () => {
      if (intersection_observer) {
        intersection_observer.disconnect();
      }
      if (resize_observer) {
        resize_observer.disconnect();
      }
      if (editor) {
        editor.destroy();
      }
    };
  });
  let crop;
  let crop_zoom;
  let { can_undo = false } = $$props;
  let can_redo = false;
  async function init_image_editor() {
    brush = new BrushTool();
    zoom = new ZoomTool();
    editor = new ImageEditor({
      target_element: pixi_target,
      width: canvas_size[0],
      height: canvas_size[1],
      tools: ["image", zoom, new ResizeTool(), brush],
      fixed_canvas,
      border_region,
      layer_options,
      theme_mode
    });
    brush.on("change", () => {
      has_drawn = true;
    });
    crop_zoom = new ZoomTool();
    crop = new ImageEditor({
      target_element: pixi_target_crop,
      width: canvas_size[0],
      height: canvas_size[1],
      tools: ["image", crop_zoom, new CropTool()],
      dark: true,
      fixed_canvas: false,
      border_region: 0,
      pad_bottom: 40
    });
    editor.scale.subscribe((_scale) => {
      zoom_level = _scale;
    });
    editor.min_zoom.subscribe((is_min_zoom) => {
      min_zoom = is_min_zoom;
    });
    editor.dimensions.subscribe((dimensions) => {
      last_dimensions = { ...dimensions };
    });
    await Promise.all([editor.ready, crop.ready]).then(() => {
      handle_tool_change({ tool: "image" });
      ready = true;
      if (sources2.length > 0) {
        handle_tool_change({ tool: "image" });
      } else {
        handle_tool_change({ tool: "draw" });
      }
      crop.set_subtool("crop");
    });
    editor.on("change", () => {
      dispatch("change");
      can_undo = editor.command_manager.history.previous !== null;
      can_redo = editor.command_manager.history.next !== null;
    });
    if (background || layers.length > 0) {
      if (background) {
        await add_image_from_url(background);
      }
      if (layers.length > 0) {
        await add_layers_from_url(layers);
      }
      handle_tool_change({ tool: "draw" });
    } else if (composite) {
      await add_image_from_url(composite);
      handle_tool_change({ tool: "draw" });
    }
  }
  function handle_tool_change({ tool }) {
    editor.set_tool(tool);
    current_tool = tool;
    if (tool === "image") {
      crop.set_tool("image");
      crop.set_subtool("crop");
    }
  }
  let eraser_size_visible = false;
  let selected_color;
  let selected_size;
  let selected_opacity = 1;
  let selected_eraser_size;
  function update_brush_options() {
    const default_color = brush_options.default_color === "auto" ? brush_options.colors[0] : brush_options.default_color;
    if (Array.isArray(default_color)) {
      selected_color = default_color[0];
      selected_opacity = default_color[1];
    } else {
      selected_color = default_color;
      const color = tinycolor(default_color);
      if (color.getAlpha() < 1) {
        selected_opacity = color.getAlpha();
      } else {
        selected_opacity = 1;
      }
    }
    selected_size = typeof brush_options.default_size === "number" ? brush_options.default_size : 25;
  }
  function update_eraser_options() {
    selected_eraser_size = eraser_options.default_size === "auto" ? 25 : eraser_options.default_size;
  }
  let brush_size_visible = false;
  let brush_color_visible = false;
  let current_subtool = null;
  let preview = false;
  if ($$props.antialias === void 0 && $$bindings.antialias && antialias !== void 0)
    $$bindings.antialias(antialias);
  if ($$props.full_history === void 0 && $$bindings.full_history && full_history !== void 0)
    $$bindings.full_history(full_history);
  if ($$props.changeable === void 0 && $$bindings.changeable && changeable !== void 0)
    $$bindings.changeable(changeable);
  if ($$props.sources === void 0 && $$bindings.sources && sources2 !== void 0)
    $$bindings.sources(sources2);
  if ($$props.transforms === void 0 && $$bindings.transforms && transforms !== void 0)
    $$bindings.transforms(transforms);
  if ($$props.canvas_size === void 0 && $$bindings.canvas_size && canvas_size !== void 0)
    $$bindings.canvas_size(canvas_size);
  if ($$props.is_dragging === void 0 && $$bindings.is_dragging && is_dragging !== void 0)
    $$bindings.is_dragging(is_dragging);
  if ($$props.background_image === void 0 && $$bindings.background_image && background_image !== void 0)
    $$bindings.background_image(background_image);
  if ($$props.brush_options === void 0 && $$bindings.brush_options && brush_options !== void 0)
    $$bindings.brush_options(brush_options);
  if ($$props.eraser_options === void 0 && $$bindings.eraser_options && eraser_options !== void 0)
    $$bindings.eraser_options(eraser_options);
  if ($$props.fixed_canvas === void 0 && $$bindings.fixed_canvas && fixed_canvas !== void 0)
    $$bindings.fixed_canvas(fixed_canvas);
  if ($$props.root === void 0 && $$bindings.root && root !== void 0)
    $$bindings.root(root);
  if ($$props.i18n === void 0 && $$bindings.i18n && i18n !== void 0)
    $$bindings.i18n(i18n);
  if ($$props.upload === void 0 && $$bindings.upload && upload !== void 0)
    $$bindings.upload(upload);
  if ($$props.composite === void 0 && $$bindings.composite && composite !== void 0)
    $$bindings.composite(composite);
  if ($$props.layers === void 0 && $$bindings.layers && layers !== void 0)
    $$bindings.layers(layers);
  if ($$props.background === void 0 && $$bindings.background && background !== void 0)
    $$bindings.background(background);
  if ($$props.border_region === void 0 && $$bindings.border_region && border_region !== void 0)
    $$bindings.border_region(border_region);
  if ($$props.layer_options === void 0 && $$bindings.layer_options && layer_options !== void 0)
    $$bindings.layer_options(layer_options);
  if ($$props.current_tool === void 0 && $$bindings.current_tool && current_tool !== void 0)
    $$bindings.current_tool(current_tool);
  if ($$props.webcam_options === void 0 && $$bindings.webcam_options && webcam_options !== void 0)
    $$bindings.webcam_options(webcam_options);
  if ($$props.show_download_button === void 0 && $$bindings.show_download_button && show_download_button !== void 0)
    $$bindings.show_download_button(show_download_button);
  if ($$props.theme_mode === void 0 && $$bindings.theme_mode && theme_mode !== void 0)
    $$bindings.theme_mode(theme_mode);
  if ($$props.has_drawn === void 0 && $$bindings.has_drawn && has_drawn !== void 0)
    $$bindings.has_drawn(has_drawn);
  if ($$props.get_blobs === void 0 && $$bindings.get_blobs && get_blobs !== void 0)
    $$bindings.get_blobs(get_blobs);
  if ($$props.add_image === void 0 && $$bindings.add_image && add_image !== void 0)
    $$bindings.add_image(add_image);
  if ($$props.add_image_from_url === void 0 && $$bindings.add_image_from_url && add_image_from_url !== void 0)
    $$bindings.add_image_from_url(add_image_from_url);
  if ($$props.add_layers_from_url === void 0 && $$bindings.add_layers_from_url && add_layers_from_url !== void 0)
    $$bindings.add_layers_from_url(add_layers_from_url);
  if ($$props.can_undo === void 0 && $$bindings.can_undo && can_undo !== void 0)
    $$bindings.can_undo(can_undo);
  $$result.css.add(css$1);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    {
      if (layer_options) {
        if (check_if_should_init()) {
          editor.set_layer_options(layer_options);
          refresh_tools();
        }
      }
    }
    {
      if (background == null && layers.length == 0 && composite == null && editor && ready) {
        editor.reset_canvas();
        handle_tool_change({ tool: "image" });
        background_image = false;
        has_drawn = false;
      }
    }
    current_tool === "image" && current_subtool === "crop" && crop_zoom.set_zoom("fit");
    background_image = can_undo && editor.command_manager.contains("AddImage");
    {
      {
        if (brush_options) {
          update_brush_options();
        }
        if (eraser_options) {
          update_eraser_options();
        }
      }
    }
    {
      brush?.set_brush_color((() => {
        let color_value;
        if (selected_color === "auto") {
          const default_color = brush_options.colors.find((color) => Array.isArray(color) ? color[0] === brush_options.default_color : color === brush_options.default_color) || brush_options.colors[0];
          color_value = Array.isArray(default_color) ? default_color[0] : default_color;
        } else {
          color_value = selected_color;
        }
        return color_value;
      })());
    }
    {
      brush?.set_brush_size(typeof selected_size === "number" ? selected_size : 25);
    }
    {
      brush?.set_eraser_size(typeof selected_eraser_size === "number" ? selected_eraser_size : 25);
    }
    current_tool !== "image" || current_tool === "image" && background_image || current_tool === "image" && current_subtool === "webcam" || !sources2.includes("upload");
    {
      brush?.preview_brush(preview);
    }
    {
      brush?.set_brush_opacity(selected_opacity);
    }
    {
      add_image_from_url(composite || background);
    }
    {
      add_layers_from_url(layers);
    }
    $$rendered = `<div data-testid="image" class="${["image-container svelte-h6gdep", ""].join(" ").trim()}"${add_attribute("aria-label", "Click to upload or drop files", 0)} aria-dropeffect="copy">${ready ? `${`${validate_component(Controls, "Controls").$$render(
      $$result,
      {
        changeable,
        min_zoom,
        current_zoom: zoom_level,
        tool: current_tool,
        can_save: true,
        enable_download: show_download_button,
        can_undo,
        can_redo
      },
      {},
      {}
    )}`} ${`${validate_component(Toolbar, "Toolbar").$$render(
      $$result,
      {
        sources: sources2,
        transforms,
        background: background_image,
        show_brush_size: brush_size_visible,
        show_brush_color: brush_color_visible,
        show_eraser_size: eraser_size_visible,
        brush_options,
        eraser_options,
        tool: current_tool,
        subtool: current_subtool,
        selected_color,
        selected_size,
        selected_eraser_size,
        selected_opacity,
        preview
      },
      {
        selected_color: ($$value) => {
          selected_color = $$value;
          $$settled = false;
        },
        selected_size: ($$value) => {
          selected_size = $$value;
          $$settled = false;
        },
        selected_eraser_size: ($$value) => {
          selected_eraser_size = $$value;
          $$settled = false;
        },
        selected_opacity: ($$value) => {
          selected_opacity = $$value;
          $$settled = false;
        },
        preview: ($$value) => {
          preview = $$value;
          $$settled = false;
        }
      },
      {}
    )}`} ${current_tool === "image" && current_subtool === "webcam" ? `<div class="modal svelte-h6gdep"><div class="modal-inner svelte-h6gdep">${validate_component(Webcam$1, "Webcam").$$render(
      $$result,
      {
        upload,
        root,
        streaming: false,
        mode: "image",
        include_audio: false,
        i18n,
        mirror_webcam: webcam_options.mirror,
        webcam_constraints: webcam_options.constraints
      },
      {},
      {}
    )}</div></div>` : ``} ${!layer_options.disabled ? `${validate_component(SecondaryToolbar, "SecondaryToolbar").$$render(
      $$result,
      {
        enable_additional_layers: layer_options.allow_additional_layers,
        layers: editor.layers
      },
      {},
      {}
    )}` : ``}` : ``} <div class="${["pixi-target svelte-h6gdep", "visible"].join(" ").trim()}"${add_attribute("this", pixi_target, 0)}></div> <div class="${[
      "pixi-target-crop svelte-h6gdep",
      ""
    ].join(" ").trim()}"${add_attribute("this", pixi_target_crop, 0)}></div> ${``} ${slots.default ? slots.default({}) : ``} </div>`;
  } while (!$$settled);
  return $$rendered;
});
const RE_HEADING = /^(#\s*)(.+)$/m;
function inject(text) {
  const trimmed_text = text.trim();
  const heading_match = trimmed_text.match(RE_HEADING);
  if (!heading_match) {
    return [false, trimmed_text || false];
  }
  const [full_match, , heading_content] = heading_match;
  const _heading = heading_content.trim();
  if (trimmed_text === full_match) {
    return [_heading, false];
  }
  const heading_end_index = heading_match.index !== void 0 ? heading_match.index + full_match.length : 0;
  const remaining_text = trimmed_text.substring(heading_end_index).trim();
  const _paragraph = remaining_text || false;
  return [_heading, _paragraph];
}
const css = {
  code: "h2.svelte-a0rsm5{font-size:var(--text-xl)}p.svelte-a0rsm5,h2.svelte-a0rsm5{white-space:pre-line}.empty.svelte-a0rsm5{display:flex;flex-direction:column;justify-content:center;align-items:center;position:absolute;height:100%;width:100%;left:0;right:0;margin:auto;z-index:var(--layer-1);text-align:center;color:var(--color-grey-500) !important;cursor:pointer}.wrap.svelte-a0rsm5{display:flex;flex-direction:column;justify-content:center;align-items:center;line-height:var(--line-md);font-size:var(--text-md)}.or.svelte-a0rsm5{color:var(--body-text-color-subdued)}",
  map: '{"version":3,"file":"InteractiveImageEditor.svelte","sources":["InteractiveImageEditor.svelte"],"sourcesContent":["<script lang=\\"ts\\" context=\\"module\\">\\"use strict\\";\\n<\/script>\\n\\n<script lang=\\"ts\\">import { createEventDispatcher } from \\"svelte\\";\\nimport {} from \\"@gradio/utils\\";\\nimport { prepare_files } from \\"@gradio/client\\";\\nimport {} from \\"./shared/core/commands\\";\\nimport ImageEditor from \\"./shared/ImageEditor.svelte\\";\\nimport {} from \\"./shared/brush/types\\";\\nimport {} from \\"./shared/Toolbar.svelte\\";\\nimport { BlockLabel } from \\"@gradio/atoms\\";\\nimport { Image as ImageIcon } from \\"@gradio/icons\\";\\nimport { inject } from \\"./shared/utils/parse_placeholder\\";\\nimport {} from \\"./shared/types\\";\\nexport let brush;\\nexport let eraser;\\nexport let sources;\\nexport let i18n;\\nexport let root;\\nexport let label = void 0;\\nexport let show_label;\\nexport let changeable = false;\\nexport let theme_mode;\\nexport let layers;\\nexport let composite;\\nexport let background;\\nexport let layer_options;\\nexport let transforms;\\nexport let accept_blobs;\\nexport let canvas_size;\\nexport let fixed_canvas = false;\\nexport let realtime;\\nexport let upload;\\nexport let is_dragging;\\nexport let placeholder = void 0;\\nexport let border_region;\\nexport let full_history = null;\\nexport let webcam_options;\\nexport let show_download_button = false;\\nconst dispatch = createEventDispatcher();\\nlet editor;\\nlet has_drawn = false;\\nfunction is_not_null(o) {\\n    return !!o;\\n}\\nfunction is_file_data(o) {\\n    return !!o;\\n}\\n$: if (background_image)\\n    dispatch(\\"upload\\");\\nexport async function get_data() {\\n    let blobs;\\n    try {\\n        blobs = await editor.get_blobs();\\n    }\\n    catch (e) {\\n        return { background: null, layers: [], composite: null };\\n    }\\n    const bg = blobs.background ? upload(await prepare_files([new File([blobs.background], \\"background.png\\")]), root) : Promise.resolve(null);\\n    const layers2 = blobs.layers.filter(is_not_null).map(async (blob, i) => upload(await prepare_files([new File([blob], `layer_${i}.png`)]), root));\\n    const composite2 = blobs.composite ? upload(await prepare_files([new File([blobs.composite], \\"composite.png\\")]), root) : Promise.resolve(null);\\n    const [background2, composite_, ...layers_] = await Promise.all([\\n        bg,\\n        composite2,\\n        ...layers2\\n    ]);\\n    return {\\n        background: Array.isArray(background2) ? background2[0] : background2,\\n        layers: layers_.flatMap((layer) => Array.isArray(layer) ? layer : [layer]).filter(is_file_data),\\n        composite: Array.isArray(composite_) ? composite_[0] : composite_\\n    };\\n}\\nfunction handle_value(value) {\\n    if (!editor)\\n        return;\\n    if (value == null) {\\n        editor.handle_remove();\\n        dispatch(\\"receive_null\\");\\n    }\\n}\\n$: handle_value({ layers, composite, background });\\nlet background_image = false;\\nlet can_undo;\\nexport let image_id = null;\\nfunction nextframe() {\\n    return new Promise((resolve) => setTimeout(() => resolve(), 30));\\n}\\nlet uploading = false;\\nlet pending = false;\\nasync function handle_change(e) {\\n    if (!realtime)\\n        return;\\n    if (uploading) {\\n        pending = true;\\n        return;\\n    }\\n    uploading = true;\\n    await nextframe();\\n    const blobs = await editor.get_blobs();\\n    const images = [];\\n    let id = Math.random().toString(36).substring(2);\\n    if (blobs.background)\\n        images.push([\\n            id,\\n            \\"background\\",\\n            new File([blobs.background], \\"background.png\\"),\\n            null\\n        ]);\\n    if (blobs.composite)\\n        images.push([\\n            id,\\n            \\"composite\\",\\n            new File([blobs.composite], \\"composite.png\\"),\\n            null\\n        ]);\\n    blobs.layers.forEach((layer, i) => {\\n        if (layer)\\n            images.push([\\n                id,\\n                `layer`,\\n                new File([layer], `layer_${i}.png`),\\n                i\\n            ]);\\n    });\\n    await Promise.all(images.map(async ([image_id2, type, data, index]) => {\\n        return accept_blobs({\\n            binary: true,\\n            data: { file: data, id: image_id2, type, index }\\n        });\\n    }));\\n    image_id = id;\\n    dispatch(\\"change\\");\\n    await nextframe();\\n    uploading = false;\\n    if (pending) {\\n        pending = false;\\n        uploading = false;\\n        handle_change(e);\\n    }\\n}\\n$: [heading, paragraph] = placeholder ? inject(placeholder) : [false, false];\\nlet current_tool;\\n<\/script>\\n\\n<BlockLabel\\n\\t{show_label}\\n\\tIcon={ImageIcon}\\n\\tlabel={label || i18n(\\"image.image\\")}\\n/>\\n<ImageEditor\\n\\t{transforms}\\n\\t{composite}\\n\\t{layers}\\n\\t{background}\\n\\ton:history\\n\\t{canvas_size}\\n\\tbind:this={editor}\\n\\t{changeable}\\n\\ton:save\\n\\ton:change={handle_change}\\n\\ton:clear={() => dispatch(\\"clear\\")}\\n\\ton:download_error\\n\\t{sources}\\n\\t{full_history}\\n\\tbind:background_image\\n\\tbind:current_tool\\n\\tbrush_options={brush}\\n\\teraser_options={eraser}\\n\\t{fixed_canvas}\\n\\t{border_region}\\n\\t{layer_options}\\n\\t{i18n}\\n\\t{root}\\n\\t{upload}\\n\\tbind:is_dragging\\n\\tbind:has_drawn\\n\\t{webcam_options}\\n\\t{show_download_button}\\n\\t{theme_mode}\\n\\tbind:can_undo\\n>\\n\\t{#if current_tool === \\"image\\" && !can_undo}\\n\\t\\t<div class=\\"empty wrap\\">\\n\\t\\t\\t{#if sources && sources.length}\\n\\t\\t\\t\\t{#if heading || paragraph}\\n\\t\\t\\t\\t\\t{#if heading}\\n\\t\\t\\t\\t\\t\\t<h2>{heading}</h2>\\n\\t\\t\\t\\t\\t{/if}\\n\\t\\t\\t\\t\\t{#if paragraph}\\n\\t\\t\\t\\t\\t\\t<p>{paragraph}</p>\\n\\t\\t\\t\\t\\t{/if}\\n\\t\\t\\t\\t{:else}\\n\\t\\t\\t\\t\\t<div>Upload an image</div>\\n\\t\\t\\t\\t{/if}\\n\\t\\t\\t{/if}\\n\\n\\t\\t\\t{#if sources && sources.length && brush && !placeholder}\\n\\t\\t\\t\\t<div class=\\"or\\">or</div>\\n\\t\\t\\t{/if}\\n\\t\\t\\t{#if brush && !placeholder}\\n\\t\\t\\t\\t<div>select the draw tool to start</div>\\n\\t\\t\\t{/if}\\n\\t\\t</div>\\n\\t{/if}\\n</ImageEditor>\\n\\n<style>\\n\\th2 {\\n\\t\\tfont-size: var(--text-xl);\\n\\t}\\n\\n\\tp,\\n\\th2 {\\n\\t\\twhite-space: pre-line;\\n\\t}\\n\\n\\t.empty {\\n\\t\\tdisplay: flex;\\n\\t\\tflex-direction: column;\\n\\t\\tjustify-content: center;\\n\\t\\talign-items: center;\\n\\t\\tposition: absolute;\\n\\t\\theight: 100%;\\n\\t\\twidth: 100%;\\n\\t\\tleft: 0;\\n\\t\\tright: 0;\\n\\t\\tmargin: auto;\\n\\t\\tz-index: var(--layer-1);\\n\\t\\ttext-align: center;\\n\\t\\tcolor: var(--color-grey-500) !important;\\n\\t\\tcursor: pointer;\\n\\t}\\n\\n\\t.wrap {\\n\\t\\tdisplay: flex;\\n\\t\\tflex-direction: column;\\n\\t\\tjustify-content: center;\\n\\t\\talign-items: center;\\n\\t\\tline-height: var(--line-md);\\n\\t\\tfont-size: var(--text-md);\\n\\t}\\n\\n\\t.or {\\n\\t\\tcolor: var(--body-text-color-subdued);\\n\\t}</style>\\n"],"names":[],"mappings":"AA+MC,gBAAG,CACF,SAAS,CAAE,IAAI,SAAS,CACzB,CAEA,eAAC,CACD,gBAAG,CACF,WAAW,CAAE,QACd,CAEA,oBAAO,CACN,OAAO,CAAE,IAAI,CACb,cAAc,CAAE,MAAM,CACtB,eAAe,CAAE,MAAM,CACvB,WAAW,CAAE,MAAM,CACnB,QAAQ,CAAE,QAAQ,CAClB,MAAM,CAAE,IAAI,CACZ,KAAK,CAAE,IAAI,CACX,IAAI,CAAE,CAAC,CACP,KAAK,CAAE,CAAC,CACR,MAAM,CAAE,IAAI,CACZ,OAAO,CAAE,IAAI,SAAS,CAAC,CACvB,UAAU,CAAE,MAAM,CAClB,KAAK,CAAE,IAAI,gBAAgB,CAAC,CAAC,UAAU,CACvC,MAAM,CAAE,OACT,CAEA,mBAAM,CACL,OAAO,CAAE,IAAI,CACb,cAAc,CAAE,MAAM,CACtB,eAAe,CAAE,MAAM,CACvB,WAAW,CAAE,MAAM,CACnB,WAAW,CAAE,IAAI,SAAS,CAAC,CAC3B,SAAS,CAAE,IAAI,SAAS,CACzB,CAEA,iBAAI,CACH,KAAK,CAAE,IAAI,yBAAyB,CACrC"}'
};
function is_not_null(o2) {
  return !!o2;
}
function is_file_data(o2) {
  return !!o2;
}
const InteractiveImageEditor = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let heading;
  let paragraph;
  let { brush } = $$props;
  let { eraser } = $$props;
  let { sources: sources2 } = $$props;
  let { i18n } = $$props;
  let { root } = $$props;
  let { label = void 0 } = $$props;
  let { show_label } = $$props;
  let { changeable = false } = $$props;
  let { theme_mode } = $$props;
  let { layers } = $$props;
  let { composite } = $$props;
  let { background } = $$props;
  let { layer_options } = $$props;
  let { transforms } = $$props;
  let { accept_blobs } = $$props;
  let { canvas_size } = $$props;
  let { fixed_canvas = false } = $$props;
  let { realtime } = $$props;
  let { upload } = $$props;
  let { is_dragging } = $$props;
  let { placeholder = void 0 } = $$props;
  let { border_region } = $$props;
  let { full_history = null } = $$props;
  let { webcam_options } = $$props;
  let { show_download_button = false } = $$props;
  const dispatch = createEventDispatcher();
  let editor;
  let has_drawn = false;
  async function get_data() {
    let blobs;
    try {
      blobs = await editor.get_blobs();
    } catch (e2) {
      return {
        background: null,
        layers: [],
        composite: null
      };
    }
    const bg = blobs.background ? upload(await prepare_files([new File([blobs.background], "background.png")]), root) : Promise.resolve(null);
    const layers2 = blobs.layers.filter(is_not_null).map(async (blob, i2) => upload(await prepare_files([new File([blob], `layer_${i2}.png`)]), root));
    const composite2 = blobs.composite ? upload(await prepare_files([new File([blobs.composite], "composite.png")]), root) : Promise.resolve(null);
    const [background2, composite_, ...layers_] = await Promise.all([bg, composite2, ...layers2]);
    return {
      background: Array.isArray(background2) ? background2[0] : background2,
      layers: layers_.flatMap((layer) => Array.isArray(layer) ? layer : [layer]).filter(is_file_data),
      composite: Array.isArray(composite_) ? composite_[0] : composite_
    };
  }
  function handle_value(value) {
    if (!editor)
      return;
    if (value == null) {
      editor.handle_remove();
      dispatch("receive_null");
    }
  }
  let background_image = false;
  let can_undo;
  let { image_id = null } = $$props;
  let current_tool;
  if ($$props.brush === void 0 && $$bindings.brush && brush !== void 0)
    $$bindings.brush(brush);
  if ($$props.eraser === void 0 && $$bindings.eraser && eraser !== void 0)
    $$bindings.eraser(eraser);
  if ($$props.sources === void 0 && $$bindings.sources && sources2 !== void 0)
    $$bindings.sources(sources2);
  if ($$props.i18n === void 0 && $$bindings.i18n && i18n !== void 0)
    $$bindings.i18n(i18n);
  if ($$props.root === void 0 && $$bindings.root && root !== void 0)
    $$bindings.root(root);
  if ($$props.label === void 0 && $$bindings.label && label !== void 0)
    $$bindings.label(label);
  if ($$props.show_label === void 0 && $$bindings.show_label && show_label !== void 0)
    $$bindings.show_label(show_label);
  if ($$props.changeable === void 0 && $$bindings.changeable && changeable !== void 0)
    $$bindings.changeable(changeable);
  if ($$props.theme_mode === void 0 && $$bindings.theme_mode && theme_mode !== void 0)
    $$bindings.theme_mode(theme_mode);
  if ($$props.layers === void 0 && $$bindings.layers && layers !== void 0)
    $$bindings.layers(layers);
  if ($$props.composite === void 0 && $$bindings.composite && composite !== void 0)
    $$bindings.composite(composite);
  if ($$props.background === void 0 && $$bindings.background && background !== void 0)
    $$bindings.background(background);
  if ($$props.layer_options === void 0 && $$bindings.layer_options && layer_options !== void 0)
    $$bindings.layer_options(layer_options);
  if ($$props.transforms === void 0 && $$bindings.transforms && transforms !== void 0)
    $$bindings.transforms(transforms);
  if ($$props.accept_blobs === void 0 && $$bindings.accept_blobs && accept_blobs !== void 0)
    $$bindings.accept_blobs(accept_blobs);
  if ($$props.canvas_size === void 0 && $$bindings.canvas_size && canvas_size !== void 0)
    $$bindings.canvas_size(canvas_size);
  if ($$props.fixed_canvas === void 0 && $$bindings.fixed_canvas && fixed_canvas !== void 0)
    $$bindings.fixed_canvas(fixed_canvas);
  if ($$props.realtime === void 0 && $$bindings.realtime && realtime !== void 0)
    $$bindings.realtime(realtime);
  if ($$props.upload === void 0 && $$bindings.upload && upload !== void 0)
    $$bindings.upload(upload);
  if ($$props.is_dragging === void 0 && $$bindings.is_dragging && is_dragging !== void 0)
    $$bindings.is_dragging(is_dragging);
  if ($$props.placeholder === void 0 && $$bindings.placeholder && placeholder !== void 0)
    $$bindings.placeholder(placeholder);
  if ($$props.border_region === void 0 && $$bindings.border_region && border_region !== void 0)
    $$bindings.border_region(border_region);
  if ($$props.full_history === void 0 && $$bindings.full_history && full_history !== void 0)
    $$bindings.full_history(full_history);
  if ($$props.webcam_options === void 0 && $$bindings.webcam_options && webcam_options !== void 0)
    $$bindings.webcam_options(webcam_options);
  if ($$props.show_download_button === void 0 && $$bindings.show_download_button && show_download_button !== void 0)
    $$bindings.show_download_button(show_download_button);
  if ($$props.get_data === void 0 && $$bindings.get_data && get_data !== void 0)
    $$bindings.get_data(get_data);
  if ($$props.image_id === void 0 && $$bindings.image_id && image_id !== void 0)
    $$bindings.image_id(image_id);
  $$result.css.add(css);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    {
      if (background_image)
        dispatch("upload");
    }
    {
      handle_value({ layers, composite, background });
    }
    [heading, paragraph] = placeholder ? inject(placeholder) : [false, false];
    $$rendered = `${validate_component(BlockLabel, "BlockLabel").$$render(
      $$result,
      {
        show_label,
        Icon: Image$1,
        label: label || i18n("image.image")
      },
      {},
      {}
    )} ${validate_component(ImageEditor_1, "ImageEditor").$$render(
      $$result,
      {
        transforms,
        composite,
        layers,
        background,
        canvas_size,
        changeable,
        sources: sources2,
        full_history,
        brush_options: brush,
        eraser_options: eraser,
        fixed_canvas,
        border_region,
        layer_options,
        i18n,
        root,
        upload,
        webcam_options,
        show_download_button,
        theme_mode,
        this: editor,
        background_image,
        current_tool,
        is_dragging,
        has_drawn,
        can_undo
      },
      {
        this: ($$value) => {
          editor = $$value;
          $$settled = false;
        },
        background_image: ($$value) => {
          background_image = $$value;
          $$settled = false;
        },
        current_tool: ($$value) => {
          current_tool = $$value;
          $$settled = false;
        },
        is_dragging: ($$value) => {
          is_dragging = $$value;
          $$settled = false;
        },
        has_drawn: ($$value) => {
          has_drawn = $$value;
          $$settled = false;
        },
        can_undo: ($$value) => {
          can_undo = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `${current_tool === "image" && !can_undo ? `<div class="empty wrap svelte-a0rsm5">${sources2 && sources2.length ? `${heading || paragraph ? `${heading ? `<h2 class="svelte-a0rsm5">${escape(heading)}</h2>` : ``} ${paragraph ? `<p class="svelte-a0rsm5">${escape(paragraph)}</p>` : ``}` : `<div data-svelte-h="svelte-1av7pez">Upload an image</div>`}` : ``} ${sources2 && sources2.length && brush && !placeholder ? `<div class="or svelte-a0rsm5" data-svelte-h="svelte-tbjmnz">or</div>` : ``} ${brush && !placeholder ? `<div data-svelte-h="svelte-jwb70i">select the draw tool to start</div>` : ``}</div>` : ``}`;
        }
      }
    )}`;
  } while (!$$settled);
  return $$rendered;
});
const Index = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let has_value;
  let normalised_background;
  let normalised_composite;
  let normalised_layers;
  let { elem_id = "" } = $$props;
  let { elem_classes = [] } = $$props;
  let { visible = true } = $$props;
  let { value = {
    background: null,
    layers: [],
    composite: null
  } } = $$props;
  let { label } = $$props;
  let { show_label } = $$props;
  let { show_download_button } = $$props;
  let { root } = $$props;
  let { value_is_output = false } = $$props;
  let { height = 350 } = $$props;
  let { width } = $$props;
  let { _selectable = false } = $$props;
  let { container = true } = $$props;
  let { scale = null } = $$props;
  let { min_width = void 0 } = $$props;
  let { loading_status } = $$props;
  let { show_share_button = false } = $$props;
  let { sources: sources2 = [] } = $$props;
  let { interactive } = $$props;
  let { placeholder } = $$props;
  let { brush } = $$props;
  let { eraser } = $$props;
  let { transforms = [] } = $$props;
  let { layers } = $$props;
  let { attached_events = [] } = $$props;
  let { server } = $$props;
  let { canvas_size } = $$props;
  let { fixed_canvas = false } = $$props;
  let { show_fullscreen_button = true } = $$props;
  let { full_history = null } = $$props;
  let { gradio } = $$props;
  let { border_region = 0 } = $$props;
  let { webcam_options } = $$props;
  let { theme_mode } = $$props;
  let editor_instance;
  let image_id = null;
  async function get_value() {
    if (image_id) {
      const val = { id: image_id };
      image_id = null;
      return val;
    }
    const blobs = await editor_instance.get_data();
    return blobs;
  }
  let is_dragging;
  const is_browser = typeof window !== "undefined";
  const raf = is_browser ? window.requestAnimationFrame : (cb) => cb();
  function wait_for_next_frame() {
    return new Promise((resolve) => {
      raf(() => raf(() => resolve()));
    });
  }
  async function handle_change() {
    await wait_for_next_frame();
    if (value && (value.background || value.layers?.length || value.composite)) {
      gradio.dispatch("change");
    }
  }
  if ($$props.elem_id === void 0 && $$bindings.elem_id && elem_id !== void 0)
    $$bindings.elem_id(elem_id);
  if ($$props.elem_classes === void 0 && $$bindings.elem_classes && elem_classes !== void 0)
    $$bindings.elem_classes(elem_classes);
  if ($$props.visible === void 0 && $$bindings.visible && visible !== void 0)
    $$bindings.visible(visible);
  if ($$props.value === void 0 && $$bindings.value && value !== void 0)
    $$bindings.value(value);
  if ($$props.label === void 0 && $$bindings.label && label !== void 0)
    $$bindings.label(label);
  if ($$props.show_label === void 0 && $$bindings.show_label && show_label !== void 0)
    $$bindings.show_label(show_label);
  if ($$props.show_download_button === void 0 && $$bindings.show_download_button && show_download_button !== void 0)
    $$bindings.show_download_button(show_download_button);
  if ($$props.root === void 0 && $$bindings.root && root !== void 0)
    $$bindings.root(root);
  if ($$props.value_is_output === void 0 && $$bindings.value_is_output && value_is_output !== void 0)
    $$bindings.value_is_output(value_is_output);
  if ($$props.height === void 0 && $$bindings.height && height !== void 0)
    $$bindings.height(height);
  if ($$props.width === void 0 && $$bindings.width && width !== void 0)
    $$bindings.width(width);
  if ($$props._selectable === void 0 && $$bindings._selectable && _selectable !== void 0)
    $$bindings._selectable(_selectable);
  if ($$props.container === void 0 && $$bindings.container && container !== void 0)
    $$bindings.container(container);
  if ($$props.scale === void 0 && $$bindings.scale && scale !== void 0)
    $$bindings.scale(scale);
  if ($$props.min_width === void 0 && $$bindings.min_width && min_width !== void 0)
    $$bindings.min_width(min_width);
  if ($$props.loading_status === void 0 && $$bindings.loading_status && loading_status !== void 0)
    $$bindings.loading_status(loading_status);
  if ($$props.show_share_button === void 0 && $$bindings.show_share_button && show_share_button !== void 0)
    $$bindings.show_share_button(show_share_button);
  if ($$props.sources === void 0 && $$bindings.sources && sources2 !== void 0)
    $$bindings.sources(sources2);
  if ($$props.interactive === void 0 && $$bindings.interactive && interactive !== void 0)
    $$bindings.interactive(interactive);
  if ($$props.placeholder === void 0 && $$bindings.placeholder && placeholder !== void 0)
    $$bindings.placeholder(placeholder);
  if ($$props.brush === void 0 && $$bindings.brush && brush !== void 0)
    $$bindings.brush(brush);
  if ($$props.eraser === void 0 && $$bindings.eraser && eraser !== void 0)
    $$bindings.eraser(eraser);
  if ($$props.transforms === void 0 && $$bindings.transforms && transforms !== void 0)
    $$bindings.transforms(transforms);
  if ($$props.layers === void 0 && $$bindings.layers && layers !== void 0)
    $$bindings.layers(layers);
  if ($$props.attached_events === void 0 && $$bindings.attached_events && attached_events !== void 0)
    $$bindings.attached_events(attached_events);
  if ($$props.server === void 0 && $$bindings.server && server !== void 0)
    $$bindings.server(server);
  if ($$props.canvas_size === void 0 && $$bindings.canvas_size && canvas_size !== void 0)
    $$bindings.canvas_size(canvas_size);
  if ($$props.fixed_canvas === void 0 && $$bindings.fixed_canvas && fixed_canvas !== void 0)
    $$bindings.fixed_canvas(fixed_canvas);
  if ($$props.show_fullscreen_button === void 0 && $$bindings.show_fullscreen_button && show_fullscreen_button !== void 0)
    $$bindings.show_fullscreen_button(show_fullscreen_button);
  if ($$props.full_history === void 0 && $$bindings.full_history && full_history !== void 0)
    $$bindings.full_history(full_history);
  if ($$props.gradio === void 0 && $$bindings.gradio && gradio !== void 0)
    $$bindings.gradio(gradio);
  if ($$props.border_region === void 0 && $$bindings.border_region && border_region !== void 0)
    $$bindings.border_region(border_region);
  if ($$props.webcam_options === void 0 && $$bindings.webcam_options && webcam_options !== void 0)
    $$bindings.webcam_options(webcam_options);
  if ($$props.theme_mode === void 0 && $$bindings.theme_mode && theme_mode !== void 0)
    $$bindings.theme_mode(theme_mode);
  if ($$props.get_value === void 0 && $$bindings.get_value && get_value !== void 0)
    $$bindings.get_value(get_value);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    value && handle_change();
    has_value = value?.background || value?.layers?.length || value?.composite;
    normalised_background = value?.background ? new FileData(value.background) : null;
    normalised_composite = value?.composite ? new FileData(value.composite) : null;
    normalised_layers = value?.layers?.map((layer) => new FileData(layer)) || [];
    $$rendered = `  ${!interactive ? `${validate_component(Block, "Block").$$render(
      $$result,
      {
        visible,
        variant: "solid",
        border_mode: is_dragging ? "focus" : "base",
        padding: false,
        elem_id,
        elem_classes,
        height,
        width,
        allow_overflow: true,
        overflow_behavior: "visible",
        container,
        scale,
        min_width
      },
      {},
      {
        default: () => {
          return `${validate_component(Static, "StatusTracker").$$render($$result, Object.assign({}, { autoscroll: gradio.autoscroll }, { i18n: gradio.i18n }, loading_status), {}, {})} ${validate_component(ImagePreview, "StaticImage").$$render(
            $$result,
            {
              value: value?.composite || null,
              label,
              show_label,
              show_download_button,
              selectable: _selectable,
              show_share_button,
              i18n: gradio.i18n,
              show_fullscreen_button
            },
            {},
            {}
          )}`;
        }
      }
    )}` : `${validate_component(Block, "Block").$$render(
      $$result,
      {
        visible,
        variant: has_value ? "solid" : "dashed",
        border_mode: is_dragging ? "focus" : "base",
        padding: false,
        elem_id,
        elem_classes,
        height,
        width,
        allow_overflow: true,
        overflow_behavior: "visible",
        container,
        scale,
        min_width
      },
      {},
      {
        default: () => {
          return `${validate_component(Static, "StatusTracker").$$render($$result, Object.assign({}, { autoscroll: gradio.autoscroll }, { i18n: gradio.i18n }, loading_status), {}, {})} ${validate_component(InteractiveImageEditor, "InteractiveImageEditor").$$render(
            $$result,
            {
              border_region,
              canvas_size,
              layers: normalised_layers,
              composite: normalised_composite,
              background: normalised_background,
              root,
              sources: sources2,
              label,
              show_label,
              fixed_canvas,
              brush,
              eraser,
              changeable: attached_events.includes("apply"),
              realtime: attached_events.includes("change") || attached_events.includes("input"),
              i18n: gradio.i18n,
              transforms,
              accept_blobs: server.accept_blobs,
              layer_options: layers,
              upload: (...args) => gradio.client.upload(...args),
              placeholder,
              full_history,
              webcam_options,
              show_download_button,
              theme_mode,
              is_dragging,
              image_id,
              this: editor_instance
            },
            {
              is_dragging: ($$value) => {
                is_dragging = $$value;
                $$settled = false;
              },
              image_id: ($$value) => {
                image_id = $$value;
                $$settled = false;
              },
              this: ($$value) => {
                editor_instance = $$value;
                $$settled = false;
              }
            },
            {}
          )}`;
        }
      }
    )}`}`;
  } while (!$$settled);
  return $$rendered;
});
const Index$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Index
}, Symbol.toStringTag, { value: "Module" }));
export {
  Color as $,
  AbstractRenderer as A,
  BufferUsage as B,
  Container as C,
  DOMAdapter as D,
  ExtensionType as E,
  Filter as F,
  GpuProgram as G,
  getGlobalBounds as H,
  TexturePool as I,
  Bounds as J,
  FilterEffect as K,
  Sprite as L,
  Matrix as M,
  getAttributeInfoFromFormat as N,
  unsafeEvalSupported as O,
  Point as P,
  uid as Q,
  RendererType as R,
  State as S,
  Ticker as T,
  UPDATE_PRIORITY as U,
  Rectangle as V,
  SystemRunner as W,
  multiplyColors as X,
  UPDATE_COLOR as Y,
  UPDATE_BLEND as Z,
  UPDATE_VISIBLE as _,
  EventEmitter as a,
  getLocalBounds as a0,
  RenderTexture as a1,
  VERSION as a2,
  deprecation as a3,
  v8_0_0 as a4,
  RendererInitHook as a5,
  Geometry as a6,
  compileHighShaderGlProgram as a7,
  colorBitGl as a8,
  generateTextureBatchBitGl as a9,
  roundPixelsBitGl as aa,
  getBatchSamplersUniformGroup as ab,
  TextStyle as ac,
  generateTextStyleKey as ad,
  BatchableGraphics as ae,
  getAdjustedBlendModeBlend as af,
  ViewableBuffer as ag,
  TextureStyle as ah,
  BitmapFontManager as ai,
  getBitmapTextLayout as aj,
  Graphics as ak,
  Cache as al,
  updateQuadBounds as am,
  CanvasTextMetrics as an,
  fontStringFromTextStyle as ao,
  getCanvasFillStyle as ap,
  nextPow2 as aq,
  GraphicsContextSystem as ar,
  Index$1 as as,
  STENCIL_MODES as b,
  Buffer as c,
  BindGroup as d,
  extensions as e,
  fastCopy as f,
  getTextureBatchBindGroup as g,
  createIdFromString as h,
  CLEAR as i,
  CanvasSource as j,
  TextureSource as k,
  UniformGroup as l,
  CanvasPool as m,
  compileHighShaderGpuProgram as n,
  colorBit as o,
  generateTextureBatchBit as p,
  getMaxTexturesPerBatch as q,
  removeItems as r,
  roundPixelsBit as s,
  Shader as t,
  Texture as u,
  TextureMatrix as v,
  warn as w,
  GlProgram as x,
  DefaultBatcher as y,
  BigPool as z
};
